import { Injectable } from '@angular/core';
import { ThemeColorsService } from '../theme-colors/theme-colors.service';

@Injectable({
  providedIn: 'root'
})
export class MapIconsService {
  brandColors:any = {};

  constructor(private themeColorsService: ThemeColorsService,) {
     this.brandColors = this.themeColorsService.getBrandColors();
  }

  drawElementDinamiteOG (ctx, scale, x, y) {
         x = x / scale;
  y = y / scale;
    ctx.save();
    ctx.strokeStyle = "rgba(0,0,0,0)";
    ctx.miterLimit = 4;
    ctx.fillStyle = "rgba(0,0,0,0)";

    // Aplicar transformaciones: trasladar a la posición y escalar
    ctx.translate(x, y);
    // ctx.scale(0.8602150537634408, 0.8602150537634408);
    ctx.scale(scale, scale);

    ctx.save();
    ctx.fillStyle = "#FD9407"; // naranja

    ctx.beginPath();
    ctx.moveTo(26.6817, 21.6469);
    ctx.bezierCurveTo(27.8819, 20.3554, 25.2353, 17.3728, 25.2353, 17.3728);
    ctx.bezierCurveTo(27.6973, 19.064, 36.9295, 26.536, 49.5161, 21.6776);
    ctx.lineTo(56.4095, 16.5118);
    ctx.bezierCurveTo(56.4095, 16.5118, 58.8407, 18.3875, 70.5348, 13.1602);
    ctx.bezierCurveTo(66.5958, 18.8487, 66.0726, 22.8154, 71.5504, 27.2125);
    ctx.bezierCurveTo(77.0282, 31.6096, 90.0764, 31.1791, 90.0764, 31.1791);
    ctx.bezierCurveTo(90.0764, 31.1791, 79.7671, 33.9465, 79.9209, 39.7888);
    ctx.bezierCurveTo(79.9825, 42.5562, 81.6443, 43.8784, 83.3369, 44.5242);
    ctx.bezierCurveTo(79.367, 45.6311, 77.4282, 49.0135, 79.9825, 51.166);
    ctx.bezierCurveTo(76.9974, 51.5657, 72.6583, 54.3331, 77.8898, 64.2035);
    ctx.bezierCurveTo(72.012, 61.6821, 61.2103, 62.0204, 48.4082, 64.6955);
    ctx.bezierCurveTo(39.5145, 66.5405, 31.7287, 71.6756, 27.7896, 74.6275);
    ctx.bezierCurveTo(30.2207, 69.3079, 30.0053, 66.602, 28.5282, 65.8332);
    ctx.bezierCurveTo(27.051, 65.0645, 24.3121, 65.741, 22.6503, 66.725);
    ctx.bezierCurveTo(23.1427, 65.6795, 23.3273, 64.6955, 22.2195, 64.634);
    ctx.bezierCurveTo(21.1116, 64.5725, 18.8036, 65.0645, 15.88, 66.6942);
    ctx.bezierCurveTo(18.3112, 63.7731, 21.4809, 60.2062, 20.0653, 56.9468);
    ctx.bezierCurveTo(18.0342, 52.2729, 4.67824, 54.7943, 2.21631, 55.3786);
    ctx.bezierCurveTo(11.5101, 48.952, 20.9885, 42.3102, 19.3267, 33.5775);
    ctx.bezierCurveTo(18.742, 30.4411, 15.4184, 27.7044, 9.81751, 26.659);
    ctx.bezierCurveTo(15.2953, 25.7365, 24.7122, 23.7993, 26.6817, 21.6469);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#FFF403"; // amarillo

    ctx.beginPath();
    ctx.moveTo(33.144, 29.089);
    ctx.bezierCurveTo(33.9442, 28.228, 32.19, 26.2293, 32.19, 26.2293);
    ctx.bezierCurveTo(33.8211, 27.367, 40.0067, 32.3484, 48.4388, 29.089);
    ctx.lineTo(53.0549, 25.6451);
    ctx.bezierCurveTo(53.0549, 25.6451, 54.6859, 26.9058, 62.5025, 23.4004);
    ctx.bezierCurveTo(59.856, 27.2133, 59.5175, 29.8577, 63.1796, 32.8096);
    ctx.bezierCurveTo(66.8725, 35.7615, 75.5815, 35.454, 75.5815, 35.454);
    ctx.bezierCurveTo(75.5815, 35.454, 68.6881, 37.299, 68.7805, 41.2041);
    ctx.bezierCurveTo(68.842, 43.049, 69.9191, 43.9407, 71.0577, 44.3712);
    ctx.bezierCurveTo(68.4112, 45.1092, 67.0879, 47.3846, 68.8112, 48.8298);
    ctx.bezierCurveTo(66.8109, 49.1066, 63.9182, 50.9515, 67.3956, 57.5626);
    ctx.bezierCurveTo(63.4565, 55.8714, 56.2246, 56.1174, 47.6694, 57.9008);
    ctx.bezierCurveTo(41.73, 59.1308, 36.4984, 62.5747, 33.8826, 64.5426);
    ctx.bezierCurveTo(35.5137, 60.9757, 35.3598, 59.1615, 34.375, 58.6695);
    ctx.bezierCurveTo(33.3902, 58.1468, 31.5438, 58.608, 30.4359, 59.2538);
    ctx.bezierCurveTo(30.7744, 58.5465, 30.8975, 57.9008, 30.159, 57.8393);
    ctx.bezierCurveTo(29.4204, 57.7778, 27.8509, 58.116, 25.9121, 59.1923);
    ctx.bezierCurveTo(27.5432, 57.2243, 29.6666, 54.8566, 28.7126, 52.6735);
    ctx.bezierCurveTo(27.3585, 49.5678, 18.434, 51.2283, 16.7722, 51.628);
    ctx.bezierCurveTo(22.9886, 47.3231, 29.3281, 42.8953, 28.2202, 37.0222);
    ctx.bezierCurveTo(27.8201, 34.9313, 25.6044, 33.0863, 21.8499, 32.4099);
    ctx.bezierCurveTo(25.5428, 31.8256, 31.8208, 30.5342, 33.144, 29.089);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B"; //negro

    ctx.beginPath();
    ctx.moveTo(26.4965, 21.4319);
    ctx.bezierCurveTo(26.6812, 21.2166, 26.7427, 20.9092, 26.7119, 20.5402);
    ctx.bezierCurveTo(26.6504, 20.2019, 26.5273, 19.8329, 26.3426, 19.4947);
    ctx.bezierCurveTo(26.1888, 19.1565, 25.9733, 18.8182, 25.7579, 18.5107);
    ctx.bezierCurveTo(25.5425, 18.2032, 25.2963, 17.865, 25.0501, 17.5883);
    ctx.lineTo(23.5114, 15.8048);
    ctx.lineTo(25.4194, 17.1578);
    ctx.bezierCurveTo(26.3119, 17.8035, 27.2043, 18.4185, 28.0968, 19.0027);
    ctx.bezierCurveTo(29.02, 19.5869, 29.9432, 20.1097, 30.928, 20.5709);
    ctx.bezierCurveTo(32.8668, 21.5241, 34.8978, 22.2006, 36.9597, 22.6311);
    ctx.bezierCurveTo(39.0523, 23.0308, 41.1758, 23.1538, 43.2684, 22.9386);
    ctx.bezierCurveTo(45.361, 22.7234, 47.4537, 22.2006, 49.4232, 21.4626);
    ctx.lineTo(49.3617, 21.4934);
    ctx.lineTo(56.2551, 16.3276);
    ctx.lineTo(56.5628, 16.3276);
    ctx.bezierCurveTo(56.5628, 16.3276, 56.5628, 16.3276, 56.5936, 16.3276);
    ctx.bezierCurveTo(56.5936, 16.3276, 56.6244, 16.3276, 56.6244, 16.3583);
    ctx.bezierCurveTo(56.6551, 16.3583, 56.6859, 16.3891, 56.7167, 16.3891);
    ctx.bezierCurveTo(56.7782, 16.4198, 56.8398, 16.4198, 56.9013, 16.4505);
    ctx.bezierCurveTo(57.0244, 16.4813, 57.1783, 16.512, 57.3322, 16.5428);
    ctx.bezierCurveTo(57.6091, 16.5735, 57.9169, 16.6043, 58.2246, 16.6043);
    ctx.bezierCurveTo(58.8093, 16.6043, 59.4248, 16.5428, 60.0095, 16.4505);
    ctx.bezierCurveTo(60.5942, 16.3583, 61.2097, 16.2353, 61.7944, 16.0816);
    ctx.bezierCurveTo(62.3791, 15.9278, 62.9638, 15.7741, 63.5485, 15.5896);
    ctx.bezierCurveTo(65.8874, 14.8823, 68.1647, 13.9599, 70.4112, 12.9452);
    ctx.lineTo(71.2728, 12.5762);
    ctx.lineTo(70.7189, 13.3756);
    ctx.bezierCurveTo(69.888, 14.6056, 69.0879, 15.8356, 68.5032, 17.2193);
    ctx.bezierCurveTo(68.2262, 17.8958, 67.98, 18.603, 67.8569, 19.3102);
    ctx.bezierCurveTo(67.7338, 19.9559, 67.703, 20.6939, 67.8261, 21.4319);
    ctx.bezierCurveTo(67.9492, 22.1391, 68.1954, 22.8463, 68.5339, 23.4921);
    ctx.bezierCurveTo(68.8725, 24.1378, 69.3341, 24.722, 69.7957, 25.2755);
    ctx.bezierCurveTo(70.2881, 25.829, 70.8112, 26.321, 71.3959, 26.7822);
    ctx.bezierCurveTo(71.6729, 27.0282, 71.9499, 27.2435, 72.2576, 27.4587);
    ctx.bezierCurveTo(72.5654, 27.6739, 72.8731, 27.8584, 73.1808, 28.0122);
    ctx.bezierCurveTo(74.4426, 28.7194, 75.8274, 29.1806, 77.2122, 29.5804);
    ctx.bezierCurveTo(78.5971, 29.9494, 80.0127, 30.2261, 81.4591, 30.4414);
    ctx.bezierCurveTo(82.8747, 30.6566, 84.3211, 30.7796, 85.7675, 30.8718);
    ctx.bezierCurveTo(87.2138, 30.9641, 88.6602, 30.9948, 90.0758, 30.9641);
    ctx.lineTo(92.1685, 30.9026);
    ctx.lineTo(90.1681, 31.4868);
    ctx.bezierCurveTo(89.368, 31.7021, 88.5987, 31.9788, 87.8293, 32.2863);
    ctx.bezierCurveTo(87.06, 32.5938, 86.2906, 32.932, 85.5828, 33.3318);
    ctx.bezierCurveTo(84.8442, 33.7315, 84.1364, 34.1312, 83.4594, 34.6232);
    ctx.bezierCurveTo(82.7824, 35.1152, 82.1669, 35.6379, 81.6129, 36.2837);
    ctx.bezierCurveTo(81.0898, 36.8987, 80.6282, 37.6366, 80.4128, 38.4054);
    ctx.bezierCurveTo(80.2897, 38.8051, 80.2281, 39.2048, 80.2281, 39.6046);
    ctx.bezierCurveTo(80.2281, 40.0043, 80.2589, 40.4348, 80.3512, 40.8345);
    ctx.bezierCurveTo(80.5051, 41.634, 80.8744, 42.4027, 81.4591, 42.987);
    ctx.bezierCurveTo(82.013, 43.5712, 82.7208, 43.9709, 83.4902, 44.2784);
    ctx.lineTo(84.3211, 44.5859);
    ctx.lineTo(83.4902, 44.8319);
    ctx.bezierCurveTo(82.7824, 45.0471, 82.1053, 45.3239, 81.4591, 45.6929);
    ctx.bezierCurveTo(80.8436, 46.0619, 80.2589, 46.5538, 79.828, 47.1381);
    ctx.bezierCurveTo(79.3972, 47.7223, 79.1202, 48.4295, 79.1818, 49.1368);
    ctx.bezierCurveTo(79.2126, 49.475, 79.3357, 49.8132, 79.5203, 50.1207);
    ctx.bezierCurveTo(79.7049, 50.4282, 79.9511, 50.705, 80.2281, 50.9202);
    ctx.lineTo(80.7205, 51.3507);
    ctx.lineTo(80.0127, 51.4737);
    ctx.bezierCurveTo(78.8125, 51.6582, 77.6431, 52.1809, 76.843, 53.1341);
    ctx.bezierCurveTo(76.4429, 53.5954, 76.1659, 54.1489, 76.0121, 54.7638);
    ctx.bezierCurveTo(75.8274, 55.3481, 75.7966, 55.9938, 75.7966, 56.6395);
    ctx.bezierCurveTo(75.8274, 57.931, 76.1659, 59.1917, 76.6275, 60.4217);
    ctx.bezierCurveTo(77.0891, 61.6516, 77.6431, 62.8508, 78.2586, 63.9885);
    ctx.lineTo(78.8433, 65.1263);
    ctx.lineTo(77.7046, 64.6343);
    ctx.bezierCurveTo(75.7043, 63.8041, 73.5501, 63.4043, 71.3959, 63.1891);
    ctx.bezierCurveTo(69.2418, 62.9738, 67.0568, 62.9431, 64.8718, 63.0046);
    ctx.bezierCurveTo(60.5019, 63.1583, 56.1628, 63.7426, 51.8544, 64.5113);
    ctx.bezierCurveTo(50.7773, 64.6958, 49.7002, 64.911, 48.6231, 65.1263);
    ctx.bezierCurveTo(47.546, 65.3415, 46.4997, 65.6182, 45.4534, 65.9257);
    ctx.bezierCurveTo(43.3607, 66.5407, 41.3296, 67.3402, 39.3293, 68.2319);
    ctx.bezierCurveTo(37.329, 69.1544, 35.3902, 70.1691, 33.513, 71.3068);
    ctx.bezierCurveTo(31.6358, 72.4445, 29.7893, 73.6745, 28.0352, 74.9967);
    ctx.lineTo(26.5273, 76.0729);
    ctx.lineTo(27.3274, 74.3817);
    ctx.bezierCurveTo(27.8813, 73.2133, 28.3737, 72.014, 28.743, 70.7841);
    ctx.bezierCurveTo(28.9277, 70.1691, 29.0815, 69.5541, 29.1431, 68.9084);
    ctx.bezierCurveTo(29.2046, 68.2934, 29.2354, 67.6477, 29.0508, 67.0942);
    ctx.bezierCurveTo(29.02, 66.9712, 28.9584, 66.8175, 28.8969, 66.7252);
    ctx.bezierCurveTo(28.8353, 66.6022, 28.743, 66.51, 28.6507, 66.4177);
    ctx.bezierCurveTo(28.5584, 66.3255, 28.4661, 66.2332, 28.343, 66.1717);
    ctx.bezierCurveTo(28.2199, 66.1102, 28.0968, 66.0487, 27.9737, 66.018);
    ctx.bezierCurveTo(27.4505, 65.8335, 26.835, 65.8335, 26.2195, 65.8642);
    ctx.bezierCurveTo(25.6041, 65.9257, 25.0194, 66.0487, 24.4346, 66.2332);
    ctx.bezierCurveTo(23.8499, 66.4177, 23.2652, 66.6637, 22.7421, 66.9712);
    ctx.lineTo(21.9727, 67.4324);
    ctx.lineTo(22.3728, 66.6022);
    ctx.bezierCurveTo(22.5266, 66.264, 22.6805, 65.895, 22.7421, 65.5567);
    ctx.bezierCurveTo(22.7728, 65.403, 22.7421, 65.2493, 22.7113, 65.157);
    ctx.bezierCurveTo(22.6497, 65.0648, 22.5574, 65.0033, 22.4036, 64.9725);
    ctx.bezierCurveTo(22.2497, 64.9418, 22.065, 64.9418, 21.8804, 64.9418);
    ctx.bezierCurveTo(21.7881, 64.9418, 21.6957, 64.9418, 21.6034, 64.9418);
    ctx.bezierCurveTo(21.5111, 64.9418, 21.4188, 64.9725, 21.3265, 64.9725);
    ctx.bezierCurveTo(20.9572, 65.034, 20.5879, 65.0955, 20.2186, 65.1878);
    ctx.bezierCurveTo(19.48, 65.3723, 18.7722, 65.6182, 18.0644, 65.9257);
    ctx.bezierCurveTo(17.3566, 66.2332, 16.6796, 66.5715, 16.0025, 66.9405);
    ctx.lineTo(14.6793, 67.6784);
    ctx.lineTo(15.6332, 66.51);
    ctx.bezierCurveTo(16.4334, 65.526, 17.2335, 64.5728, 17.9721, 63.5581);
    ctx.bezierCurveTo(18.3414, 63.0661, 18.6799, 62.5433, 18.9876, 61.9899);
    ctx.bezierCurveTo(19.2954, 61.4671, 19.5723, 60.8829, 19.757, 60.2987);
    ctx.bezierCurveTo(19.9416, 59.7144, 20.0647, 59.1302, 20.0339, 58.5152);
    ctx.bezierCurveTo(20.0339, 58.2077, 19.9724, 57.931, 19.9108, 57.6542);
    ctx.bezierCurveTo(19.8493, 57.3775, 19.7262, 57.1008, 19.6031, 56.8548);
    ctx.bezierCurveTo(19.3261, 56.3628, 18.8953, 55.9938, 18.3721, 55.6863);
    ctx.bezierCurveTo(17.8798, 55.4096, 17.2951, 55.1943, 16.7411, 55.0406);
    ctx.bezierCurveTo(15.5717, 54.7331, 14.3715, 54.6408, 13.1713, 54.5793);
    ctx.bezierCurveTo(11.9711, 54.5486, 10.7402, 54.6101, 9.5092, 54.7023);
    ctx.bezierCurveTo(8.30901, 54.7946, 7.07805, 54.9483, 5.87786, 55.1328);
    ctx.bezierCurveTo(4.67766, 55.3173, 3.47747, 55.5326, 2.27728, 55.8093);
    ctx.lineTo(0, 56.332);
    ctx.lineTo(1.96954, 55.0098);
    ctx.bezierCurveTo(4.80076, 53.0726, 7.63198, 51.1355, 10.3401, 49.0138);
    ctx.bezierCurveTo(11.6634, 47.9376, 12.9867, 46.8306, 14.1869, 45.6006);
    ctx.bezierCurveTo(15.3871, 44.3707, 16.4949, 43.0485, 17.3874, 41.6033);
    ctx.bezierCurveTo(17.849, 40.8653, 18.2183, 40.0966, 18.526, 39.2971);
    ctx.bezierCurveTo(18.8338, 38.4976, 19.0492, 37.6674, 19.1415, 36.8064);
    ctx.bezierCurveTo(19.2338, 35.9454, 19.2338, 35.0845, 19.1107, 34.2235);
    ctx.bezierCurveTo(19.1107, 34.1312, 19.0799, 34.0082, 19.0492, 33.916);
    ctx.bezierCurveTo(19.0184, 33.8237, 19.0184, 33.7008, 18.9876, 33.6085);
    ctx.bezierCurveTo(18.9569, 33.5163, 18.9569, 33.3933, 18.9261, 33.301);
    ctx.bezierCurveTo(18.8953, 33.2088, 18.8645, 33.0858, 18.8338, 32.9935);
    ctx.bezierCurveTo(18.7107, 32.5938, 18.526, 32.2248, 18.3106, 31.8558);
    ctx.bezierCurveTo(17.8798, 31.0563, 17.3258, 30.4414, 16.6796, 29.8879);
    ctx.bezierCurveTo(16.0333, 29.3651, 15.2947, 28.9039, 14.5562, 28.5349);
    ctx.bezierCurveTo(13.0482, 27.7662, 11.4172, 27.305, 9.75539, 26.9975);
    ctx.lineTo(8.03204, 26.69);
    ctx.lineTo(9.75539, 26.4132);
    ctx.bezierCurveTo(12.6789, 25.8598, 15.5717, 25.3063, 18.4337, 24.599);
    ctx.bezierCurveTo(19.8493, 24.2301, 21.2957, 23.8611, 22.6805, 23.3691);
    ctx.bezierCurveTo(23.3883, 23.1231, 24.0654, 22.8771, 24.7116, 22.5696);
    ctx.bezierCurveTo(25.0501, 22.4159, 25.3579, 22.2621, 25.6656, 22.0776);
    ctx.bezierCurveTo(25.9734, 21.8931, 26.2503, 21.6779, 26.4965, 21.4319);
    ctx.closePath();
    ctx.moveTo(26.8966, 21.8624);
    ctx.bezierCurveTo(26.6196, 22.1699, 26.2811, 22.3851, 25.9426, 22.6004);
    ctx.bezierCurveTo(25.6041, 22.7848, 25.2655, 22.9693, 24.927, 23.1231);
    ctx.bezierCurveTo(24.25, 23.4306, 23.5422, 23.7073, 22.8344, 23.9533);
    ctx.bezierCurveTo(21.4188, 24.4145, 20.0032, 24.8143, 18.5568, 25.1833);
    ctx.bezierCurveTo(15.6948, 25.8905, 12.7713, 26.4747, 9.84772, 26.9667);
    ctx.lineTo(9.84772, 26.3517);
    ctx.bezierCurveTo(11.5403, 26.6592, 13.2329, 27.1512, 14.8023, 27.9507);
    ctx.bezierCurveTo(15.5717, 28.3504, 16.3411, 28.8117, 17.0181, 29.3959);
    ctx.bezierCurveTo(17.6951, 29.9801, 18.3414, 30.6566, 18.803, 31.4561);
    ctx.bezierCurveTo(19.0492, 31.8558, 19.2338, 32.2863, 19.3877, 32.7168);
    ctx.bezierCurveTo(19.4185, 32.8398, 19.4492, 32.932, 19.48, 33.055);
    ctx.bezierCurveTo(19.5108, 33.178, 19.5416, 33.2703, 19.5723, 33.3933);
    ctx.bezierCurveTo(19.6031, 33.5163, 19.6031, 33.6085, 19.6339, 33.7315);
    ctx.bezierCurveTo(19.6647, 33.8545, 19.6647, 33.9467, 19.6954, 34.0697);
    ctx.bezierCurveTo(19.8185, 34.9922, 19.8185, 35.9147, 19.7262, 36.8372);
    ctx.bezierCurveTo(19.6339, 37.7596, 19.3877, 38.6513, 19.0799, 39.4816);
    ctx.bezierCurveTo(18.7722, 40.3425, 18.3721, 41.142, 17.9105, 41.9107);
    ctx.bezierCurveTo(16.9873, 43.4482, 15.8487, 44.8012, 14.6485, 46.0619);
    ctx.bezierCurveTo(13.4175, 47.3226, 12.125, 48.4603, 10.7709, 49.5673);
    ctx.bezierCurveTo(8.09359, 51.7504, 5.26237, 53.7491, 2.43115, 55.7171);
    ctx.lineTo(2.09264, 54.8868);
    ctx.bezierCurveTo(3.3236, 54.6101, 4.52379, 54.4256, 5.75476, 54.2411);
    ctx.bezierCurveTo(6.98572, 54.0566, 8.21669, 53.9336, 9.44765, 53.8414);
    ctx.bezierCurveTo(10.6786, 53.7491, 11.9404, 53.7184, 13.1713, 53.7491);
    ctx.bezierCurveTo(14.4331, 53.8106, 15.664, 53.9336, 16.895, 54.2719);
    ctx.bezierCurveTo(17.5105, 54.4563, 18.126, 54.6716, 18.7107, 55.0098);
    ctx.bezierCurveTo(19.2954, 55.3481, 19.8185, 55.8093, 20.1878, 56.455);
    ctx.bezierCurveTo(20.3725, 56.7625, 20.4956, 57.1008, 20.5571, 57.439);
    ctx.bezierCurveTo(20.6494, 57.7772, 20.6802, 58.1155, 20.711, 58.4845);
    ctx.bezierCurveTo(20.7418, 59.1917, 20.5879, 59.8682, 20.3725, 60.5139);
    ctx.bezierCurveTo(20.157, 61.1596, 19.8493, 61.7439, 19.5416, 62.2973);
    ctx.bezierCurveTo(19.203, 62.8508, 18.8338, 63.4043, 18.4645, 63.8963);
    ctx.bezierCurveTo(17.6951, 64.911, 16.8642, 65.895, 16.0641, 66.8482);
    ctx.lineTo(15.7563, 66.4177);
    ctx.bezierCurveTo(16.4334, 66.018, 17.1412, 65.6797, 17.8798, 65.3723);
    ctx.bezierCurveTo(18.6183, 65.0648, 19.3569, 64.788, 20.1263, 64.6035);
    ctx.bezierCurveTo(20.4956, 64.5113, 20.8956, 64.419, 21.2957, 64.3883);
    ctx.bezierCurveTo(21.388, 64.3883, 21.4803, 64.3575, 21.6034, 64.3575);
    ctx.bezierCurveTo(21.6957, 64.3575, 21.8188, 64.3575, 21.9112, 64.3268);
    ctx.bezierCurveTo(22.0035, 64.3268, 22.1266, 64.3268, 22.2189, 64.3268);
    ctx.bezierCurveTo(22.3112, 64.3268, 22.4343, 64.3575, 22.5574, 64.3883);
    ctx.bezierCurveTo(22.6805, 64.419, 22.8036, 64.4498, 22.8959, 64.542);
    ctx.bezierCurveTo(23.019, 64.6035, 23.1114, 64.7265, 23.2037, 64.8495);
    ctx.bezierCurveTo(23.3576, 65.1263, 23.3576, 65.403, 23.3268, 65.6182);
    ctx.bezierCurveTo(23.2652, 66.0795, 23.0806, 66.4792, 22.9267, 66.8482);
    ctx.lineTo(22.5267, 66.4485);
    ctx.bezierCurveTo(23.0806, 66.1102, 23.6961, 65.8335, 24.3115, 65.6182);
    ctx.bezierCurveTo(24.927, 65.403, 25.5733, 65.2493, 26.2195, 65.157);
    ctx.bezierCurveTo(26.8658, 65.0955, 27.5428, 65.0648, 28.2506, 65.28);
    ctx.bezierCurveTo(28.4353, 65.3415, 28.5892, 65.403, 28.743, 65.4952);
    ctx.bezierCurveTo(28.9277, 65.5875, 29.0815, 65.7105, 29.2046, 65.8335);
    ctx.bezierCurveTo(29.3585, 65.9565, 29.4816, 66.141, 29.5739, 66.2947);
    ctx.bezierCurveTo(29.6662, 66.4485, 29.7586, 66.633, 29.8201, 66.8175);
    ctx.bezierCurveTo(30.0663, 67.5554, 30.0663, 68.2627, 30.0048, 68.9699);
    ctx.bezierCurveTo(29.9432, 69.6771, 29.7893, 70.3536, 29.6047, 70.9993);
    ctx.bezierCurveTo(29.2354, 72.3215, 28.743, 73.5515, 28.2199, 74.7815);
    ctx.lineTo(27.5121, 74.1665);
    ctx.bezierCurveTo(29.297, 72.8135, 31.1742, 71.5836, 33.0822, 70.4151);
    ctx.bezierCurveTo(34.9902, 69.2774, 36.9597, 68.2012, 38.9908, 67.2787);
    ctx.bezierCurveTo(41.0219, 66.3562, 43.0838, 65.5567, 45.2379, 64.911);
    ctx.bezierCurveTo(46.315, 64.6035, 47.3921, 64.3268, 48.4692, 64.1115);
    ctx.bezierCurveTo(49.5463, 63.8963, 50.6234, 63.6811, 51.7313, 63.4966);
    ctx.bezierCurveTo(56.0704, 62.7278, 60.4404, 62.1436, 64.8718, 61.9899);
    ctx.bezierCurveTo(67.0876, 61.9284, 69.3033, 61.9591, 71.519, 62.1744);
    ctx.bezierCurveTo(73.7348, 62.4203, 75.9505, 62.8201, 78.0739, 63.7118);
    ctx.lineTo(77.52, 64.3575);
    ctx.bezierCurveTo(76.9045, 63.1583, 76.3506, 61.9284, 75.889, 60.6061);
    ctx.bezierCurveTo(75.4581, 59.3147, 75.1196, 57.9617, 75.0888, 56.5473);
    ctx.bezierCurveTo(75.0888, 55.8401, 75.1504, 55.1328, 75.3658, 54.4563);
    ctx.bezierCurveTo(75.5812, 53.7799, 75.9197, 53.1341, 76.3813, 52.6114);
    ctx.bezierCurveTo(76.843, 52.0887, 77.4277, 51.6582, 78.0124, 51.3814);
    ctx.bezierCurveTo(78.6279, 51.1047, 79.2741, 50.9202, 79.9511, 50.828);
    ctx.lineTo(79.828, 51.3507);
    ctx.bezierCurveTo(79.5203, 51.074, 79.2126, 50.7665, 78.9971, 50.3975);
    ctx.bezierCurveTo(78.7817, 50.0285, 78.6279, 49.598, 78.5663, 49.1368);
    ctx.bezierCurveTo(78.5355, 48.7063, 78.5971, 48.245, 78.7202, 47.8453);
    ctx.bezierCurveTo(78.8433, 47.4456, 79.0587, 47.0766, 79.3049, 46.7383);
    ctx.bezierCurveTo(79.7973, 46.0619, 80.4128, 45.5391, 81.0898, 45.1394);
    ctx.bezierCurveTo(81.7668, 44.7397, 82.5054, 44.4322, 83.244, 44.2169);
    ctx.lineTo(83.244, 44.7704);
    ctx.bezierCurveTo(82.4438, 44.4629, 81.6437, 44.0324, 80.9975, 43.3559);
    ctx.bezierCurveTo(80.3512, 42.7102, 79.9511, 41.8185, 79.7665, 40.9268);
    ctx.bezierCurveTo(79.6742, 40.4655, 79.6434, 40.0351, 79.6434, 39.5431);
    ctx.bezierCurveTo(79.6434, 39.0818, 79.7357, 38.6206, 79.8588, 38.1901);
    ctx.bezierCurveTo(80.1358, 37.2984, 80.5974, 36.5297, 81.1821, 35.8532);
    ctx.bezierCurveTo(81.7668, 35.1767, 82.4131, 34.6232, 83.1209, 34.1005);
    ctx.bezierCurveTo(83.8287, 33.6085, 84.5365, 33.1473, 85.3058, 32.7783);
    ctx.bezierCurveTo(86.0444, 32.3785, 86.8445, 32.0403, 87.6139, 31.7328);
    ctx.bezierCurveTo(88.414, 31.4253, 89.1834, 31.1486, 90.0143, 30.9026);
    ctx.lineTo(90.0758, 31.4253);
    ctx.bezierCurveTo(88.6294, 31.4561, 87.1523, 31.4253, 85.7059, 31.3331);
    ctx.bezierCurveTo(84.2595, 31.2408, 82.8131, 31.1178, 81.3668, 30.9026);
    ctx.bezierCurveTo(79.9204, 30.6873, 78.474, 30.4106, 77.0584, 30.0416);
    ctx.bezierCurveTo(75.6428, 29.6419, 74.2579, 29.1499, 72.9346, 28.4427);
    ctx.bezierCurveTo(72.5961, 28.2582, 72.2884, 28.0737, 71.9806, 27.8584);
    ctx.bezierCurveTo(71.6729, 27.6432, 71.3652, 27.3972, 71.0882, 27.182);
    ctx.bezierCurveTo(70.5035, 26.69, 69.9496, 26.198, 69.4572, 25.6138);
    ctx.bezierCurveTo(68.934, 25.0603, 68.4724, 24.4145, 68.1031, 23.7381);
    ctx.bezierCurveTo(67.703, 23.0616, 67.4261, 22.2929, 67.303, 21.4934);
    ctx.bezierCurveTo(67.1799, 20.6939, 67.2107, 19.8944, 67.3645, 19.1257);
    ctx.bezierCurveTo(67.5184, 18.357, 67.7646, 17.619, 68.0416, 16.9118);
    ctx.bezierCurveTo(68.657, 15.4973, 69.4572, 14.2059, 70.2881, 12.9759);
    ctx.lineTo(70.5958, 13.3756);
    ctx.bezierCurveTo(68.3185, 14.3904, 66.0412, 15.3128, 63.6716, 16.0508);
    ctx.bezierCurveTo(63.0869, 16.2353, 62.4714, 16.3891, 61.8867, 16.5428);
    ctx.bezierCurveTo(61.2713, 16.6965, 60.6865, 16.8195, 60.0711, 16.9118);
    ctx.bezierCurveTo(59.4556, 17.004, 58.8401, 17.0655, 58.1938, 17.0655);
    ctx.bezierCurveTo(57.8861, 17.0655, 57.5476, 17.0655, 57.2398, 17.004);
    ctx.bezierCurveTo(57.086, 16.9733, 56.9321, 16.9425, 56.7475, 16.9118);
    ctx.bezierCurveTo(56.6551, 16.881, 56.5936, 16.8503, 56.5013, 16.8195);
    ctx.bezierCurveTo(56.4705, 16.7888, 56.4089, 16.7888, 56.3782, 16.758);
    ctx.bezierCurveTo(56.3474, 16.758, 56.3474, 16.7273, 56.3166, 16.7273);
    ctx.bezierCurveTo(56.2858, 16.7273, 56.2859, 16.6965, 56.2243, 16.6658);
    ctx.lineTo(56.532, 16.6658);
    ctx.lineTo(49.6386, 21.8316);
    ctx.lineTo(49.6079, 21.8624);
    ctx.lineTo(49.5771, 21.8624);
    ctx.bezierCurveTo(47.546, 22.6311, 45.4534, 23.1846, 43.2992, 23.3998);
    ctx.bezierCurveTo(41.145, 23.6151, 38.96, 23.5228, 36.8366, 23.0923);
    ctx.bezierCurveTo(34.7132, 22.6926, 32.6206, 21.9546, 30.651, 21.0014);
    ctx.bezierCurveTo(29.697, 20.6017, 28.743, 20.0482, 27.8198, 19.464);
    ctx.bezierCurveTo(26.8966, 18.8797, 26.0041, 18.234, 25.1117, 17.619);
    ctx.lineTo(25.4502, 17.1885);
    ctx.bezierCurveTo(25.7272, 17.496, 25.9734, 17.8343, 26.2195, 18.1725);
    ctx.bezierCurveTo(26.4657, 18.5107, 26.6812, 18.8797, 26.8658, 19.2487);
    ctx.bezierCurveTo(27.0504, 19.6177, 27.2043, 20.0482, 27.2659, 20.4787);
    ctx.bezierCurveTo(27.2966, 20.6939, 27.2966, 20.9399, 27.2351, 21.1859);
    ctx.bezierCurveTo(27.1735, 21.4319, 27.0504, 21.6779, 26.8966, 21.8624);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#FFF403"; //amarillo

    ctx.beginPath();
    ctx.moveTo(59.2712, 9.5015);
    ctx.bezierCurveTo(60.4099, 5.13514, 61.8563, 1.04552, 68.2265, 0.307539);
    ctx.bezierCurveTo(74.5967,-0.430438,77.5818,3.41319,77.828,5.62712);
    ctx.bezierCurveTo(78.105, 8.21004, 76.2278, 14.7596, 70.5038, 16.912);
    ctx.lineTo(69.6113, 16.297);
    ctx.bezierCurveTo(69.6113, 16.297, 73.6735, 14.5136, 75.52, 10.67);
    ctx.bezierCurveTo(76.5355, 8.60978, 76.8125, 7.10307, 76.7202, 5.78087);
    ctx.bezierCurveTo(76.6278, 4.21267, 74.3506, 0.738025, 68.0419, 1.44525);
    ctx.bezierCurveTo(65.7646, 1.69125, 61.5793, 2.64447, 60.4714, 9.83974);
    ctx.lineTo(59.2712, 9.5015);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(58.9939, 9.68536);
    ctx.lineTo(59.0554, 9.47012);
    ctx.bezierCurveTo(60.2864, 4.76551, 61.8251, 0.829639, 68.1954, 0.0916624);
    ctx.bezierCurveTo(71.9806,-0.338824,74.381,0.829639,75.7042,1.87511);
    ctx.bezierCurveTo(77.2429, 3.10507, 77.92, 4.61177, 78.0431, 5.62649);
    ctx.bezierCurveTo(78.32, 8.08641, 76.5659, 14.8819, 70.565, 17.1574);
    ctx.lineTo(70.4419, 17.2189);
    ctx.lineTo(69.1494, 16.2657);
    ctx.lineTo(69.5186, 16.1119);
    ctx.bezierCurveTo(69.5494, 16.0812, 73.5193, 14.2977, 75.3349, 10.6078);
    ctx.bezierCurveTo(76.2582, 8.73214, 76.6275, 7.25619, 76.5351, 5.84173);
    ctx.bezierCurveTo(76.5044, 5.22675, 76.0735, 4.18128, 74.9657, 3.25881);
    ctx.bezierCurveTo(73.8578, 2.33634, 71.7652, 1.29087, 68.103, 1.72136);
    ctx.bezierCurveTo(65.4257, 2.02885, 61.7636, 3.19731, 60.748, 9.93135);
    ctx.lineTo(60.7172, 10.1773);
    ctx.lineTo(58.9939, 9.68536);
    ctx.closePath();
    ctx.moveTo(75.0272, 1.96735);
    ctx.bezierCurveTo(73.7039, 1.04488, 71.5497, 0.18391, 68.2261, 0.552898);
    ctx.bezierCurveTo(62.256, 1.22938, 60.7172, 4.91926, 59.5171, 9.34712);
    ctx.lineTo(60.2864, 9.56236);
    ctx.bezierCurveTo(61.5481, 1.9366, 66.4105, 1.41387, 68.0107, 1.22938);
    ctx.bezierCurveTo(71.8267, 0.79889, 74.0424, 1.90586, 75.2119, 2.88982);
    ctx.bezierCurveTo(76.412, 3.90454, 76.8737, 5.07301, 76.9352, 5.78023);
    ctx.bezierCurveTo(77.0275, 7.28694, 76.6582, 8.82439, 75.7042, 10.7616);
    ctx.bezierCurveTo(74.1348, 13.9902, 71.0573, 15.7737, 70.011, 16.3271);
    ctx.lineTo(70.5034, 16.6961);
    ctx.bezierCurveTo(76.1659, 14.4822, 77.8277, 8.02491, 77.5507, 5.68799);
    ctx.bezierCurveTo(77.4584, 4.76552, 76.8121, 3.38181, 75.3965, 2.24409);
    ctx.bezierCurveTo(75.3042, 2.15185, 75.1811, 2.0596, 75.0272, 1.96735);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(61.3329, 6.58111);
    ctx.bezierCurveTo(60.7482, 6.39661, 60.1327, 6.8271, 59.7634, 7.71882);
    ctx.bezierCurveTo(59.3941, 8.61054, 59.2402, 9.53301, 59.2402, 9.53301);
    ctx.lineTo(60.4712, 9.87125);
    ctx.bezierCurveTo(60.502, 9.8405, 60.902, 7.28834, 61.3329, 6.58111);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(70.9651, 15.5578);
    ctx.bezierCurveTo(71.5806, 15.1274, 72.2577, 15.0659, 72.5346, 15.3118);
    ctx.bezierCurveTo(72.75, 15.5271, 72.1653, 16.1113, 71.3652, 16.5726);
    ctx.bezierCurveTo(70.5651, 17.0338, 70.5035, 16.9415, 70.5035, 16.9415);
    ctx.lineTo(69.6111, 16.2958);
    ctx.lineTo(70.9651, 15.5578);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(76.6889, 7.1642);
    ctx.bezierCurveTo(76.8427, 6.57997, 77.5505, 6.48772, 77.7352, 7.41019);
    ctx.bezierCurveTo(77.9506, 8.30191, 76.3503, 11.5921, 76.3503, 11.5921);
    ctx.bezierCurveTo(76.3503, 11.5921, 75.7656, 10.8848, 75.1501, 11.4076);
    ctx.bezierCurveTo(75.1501, 11.4076, 76.1657, 9.53188, 76.4119, 8.54791);
    ctx.bezierCurveTo(76.6273, 7.53319, 76.6889, 7.1642, 76.6889, 7.1642);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(77.4274, 16.3899);
    ctx.bezierCurveTo(76.9966, 16.4206, 76.5965, 16.4206, 76.258, 16.4821);
    ctx.bezierCurveTo(74.9039, 16.6359, 74.2884, 17.0971, 74.7193, 19.311);
    ctx.lineTo(73.5499, 19.1265);
    ctx.bezierCurveTo(73.5499, 19.1265, 73.119, 16.5744, 74.5038, 15.8671);
    ctx.bezierCurveTo(74.7193, 15.7441, 74.9655, 15.6519, 75.2117, 15.5904);
    ctx.bezierCurveTo(76.8119, 15.1292, 78.7815, 15.3444, 79.6431, 13.9914);
    ctx.bezierCurveTo(80.1663, 13.1612, 80.474, 11.6853, 77.9813, 10.3323);
    ctx.bezierCurveTo(75.4886, 8.97935, 72.1958, 8.48736, 69.1184, 8.45661);
    ctx.bezierCurveTo(65.8871, 8.39511, 62.3789, 10.978, 62.3789, 10.978);
    ctx.lineTo(61.3018, 10.3016);
    ctx.bezierCurveTo(61.3018, 10.3016, 64.133, 8.51811, 65.7332, 7.90313);
    ctx.bezierCurveTo(67.3027, 7.28815, 71.5495, 6.33493, 78.6584, 9.37908);
    ctx.bezierCurveTo(81.1818, 10.4553, 81.6742, 12.454, 81.1203, 13.9299);
    ctx.bezierCurveTo(80.5971, 15.3444, 79.12, 16.2976, 77.4274, 16.3899);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(73.3659, 19.3412);
    ctx.lineTo(73.3351, 19.1874);
    ctx.bezierCurveTo(73.3043, 19.0644, 72.8735, 16.4507, 74.4122, 15.682);
    ctx.bezierCurveTo(74.6276, 15.559, 74.8738, 15.4668, 75.1508, 15.4053);
    ctx.bezierCurveTo(75.6431, 15.2515, 76.1971, 15.19, 76.6895, 15.0978);
    ctx.bezierCurveTo(77.8281, 14.9133, 78.9052, 14.7596, 79.4591, 13.8986);
    ctx.bezierCurveTo(79.6745, 13.5603, 79.89, 13.0376, 79.7361, 12.4534);
    ctx.bezierCurveTo(79.5515, 11.7769, 78.936, 11.1312, 77.8896, 10.5777);
    ctx.bezierCurveTo(75.1815, 9.13248, 71.6425, 8.76349, 69.1498, 8.70199);
    ctx.bezierCurveTo(66.0416, 8.64049, 62.5641, 11.1619, 62.5334, 11.1927);
    ctx.lineTo(62.4103, 11.2849);
    ctx.lineTo(60.9023, 10.3317);
    ctx.lineTo(61.2101, 10.1472);
    ctx.bezierCurveTo(61.3332, 10.0857, 64.0721, 8.36375, 65.6723, 7.71802);
    ctx.bezierCurveTo(67.1803, 7.13379, 71.4579, 6.05758, 78.7821, 9.19398);
    ctx.bezierCurveTo(81.3979, 10.3009, 81.9826, 12.4226, 81.3671, 14.0216);
    ctx.bezierCurveTo(80.8132, 15.4975, 79.2745, 16.5122, 77.4588, 16.6045);
    ctx.lineTo(77.3973, 16.6045);
    ctx.bezierCurveTo(76.9972, 16.6352, 76.6279, 16.6352, 76.2894, 16.6967);
    ctx.bezierCurveTo(75.6124, 16.789, 75.2431, 16.912, 75.0277, 17.2195);
    ctx.bezierCurveTo(74.7507, 17.5885, 74.7199, 18.2342, 74.9353, 19.2797);
    ctx.lineTo(74.9969, 19.5871);
    ctx.lineTo(73.3659, 19.3412);
    ctx.closePath();
    ctx.moveTo(78.8129, 10.5777);
    ctx.bezierCurveTo(79.5822, 11.1004, 80.0438, 11.6846, 80.1977, 12.3304);
    ctx.bezierCurveTo(80.3824, 13.0991, 80.1362, 13.7141, 79.8592, 14.1446);
    ctx.bezierCurveTo(79.2129, 15.1593, 77.982, 15.3438, 76.7818, 15.5283);
    ctx.bezierCurveTo(76.2894, 15.5898, 75.7662, 15.682, 75.3046, 15.805);
    ctx.bezierCurveTo(75.0584, 15.8665, 74.8122, 15.9588, 74.6276, 16.051);
    ctx.bezierCurveTo(73.5813, 16.5737, 73.7044, 18.3572, 73.7659, 18.9107);
    ctx.lineTo(74.443, 19.0029);
    ctx.bezierCurveTo(74.2891, 17.9882, 74.3506, 17.3425, 74.6584, 16.912);
    ctx.bezierCurveTo(75.0277, 16.42, 75.6431, 16.297, 76.2278, 16.2048);
    ctx.bezierCurveTo(76.5664, 16.174, 76.9357, 16.1433, 77.3357, 16.1125);
    ctx.lineTo(77.3973, 16.1125);
    ctx.bezierCurveTo(79.0283, 16.0203, 80.4131, 15.1285, 80.9055, 13.8371);
    ctx.bezierCurveTo(81.3979, 12.5456, 81.0594, 10.6392, 78.5667, 9.56296);
    ctx.bezierCurveTo(71.3963, 6.48806, 67.2726, 7.50278, 65.8262, 8.08701);
    ctx.bezierCurveTo(64.5952, 8.579, 62.5334, 9.80896, 61.764, 10.2702);
    ctx.lineTo(62.4103, 10.6699);
    ctx.bezierCurveTo(63.0873, 10.2087, 66.1955, 8.14851, 69.1806, 8.17926);
    ctx.bezierCurveTo(71.7348, 8.24076, 75.3662, 8.60975, 78.1358, 10.0857);
    ctx.bezierCurveTo(78.3513, 10.3009, 78.5975, 10.4547, 78.8129, 10.5777);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(62.533, 9.59404);
    ctx.bezierCurveTo(63.0869, 9.28654, 64.2255, 8.91756, 64.4717, 9.22505);
    ctx.bezierCurveTo(64.6871, 9.56329, 63.1484, 10.4858, 63.1484, 10.4858);
    ctx.lineTo(62.3483, 11.0085);
    ctx.lineTo(61.3328, 10.2705);
    ctx.lineTo(62.533, 9.59404);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(74.7194, 19.3105);
    ctx.lineTo(73.55, 19.126);
    ctx.bezierCurveTo(73.55, 19.126, 73.1191, 16.5738, 74.504, 15.8666);
    ctx.bezierCurveTo(74.7194, 15.7436, 74.9656, 15.6513, 75.2118, 15.5898);
    ctx.bezierCurveTo(75.6734, 15.7436, 76.1042, 16.0511, 76.2581, 16.4508);
    ctx.bezierCurveTo(74.904, 16.6353, 74.2885, 17.0965, 74.7194, 19.3105);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(79.4585, 9.80788);
    ctx.bezierCurveTo(78.7507, 9.62339, 78.0429, 10.1769, 78.2583, 10.5151);
    ctx.bezierCurveTo(78.2583, 10.5151, 76.8427, 9.53114, 74.627, 9.1314);
    ctx.lineTo(73.3037, 8.91616);
    ctx.lineTo(74.9347, 8.08594);
    ctx.bezierCurveTo(74.9347, 8.08594, 77.5813, 8.57792, 79.4585, 9.80788);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#0093F1";

    ctx.beginPath();
    ctx.moveTo(67.0879, 13.3139);
    ctx.bezierCurveTo(69.6114, 9.96226, 72.9965, 7.84058, 76.9048, 7.68683);
    ctx.bezierCurveTo(80.8131, 7.53309, 83.3366, 9.34728, 84.2291, 11.6842);
    ctx.bezierCurveTo(85.1523, 14.0211, 83.9829, 16.9423, 82.3519, 18.0185);
    ctx.bezierCurveTo(80.3823, 19.31, 78.2897, 18.5412, 77.2434, 21.2164);
    ctx.lineTo(76.1663, 20.7244);
    ctx.bezierCurveTo(76.1663, 20.7244, 76.6586, 19.2485, 77.8281, 18.695);
    ctx.bezierCurveTo(78.9975, 18.1415, 80.8131, 17.8033, 81.6748, 17.2805);
    ctx.bezierCurveTo(82.5365, 16.7578, 83.9213, 14.6976, 83.1212, 12.2992);
    ctx.bezierCurveTo(82.3211, 9.90076, 79.7361, 8.6708, 76.6586, 8.85529);
    ctx.bezierCurveTo(73.5812, 9.03979, 69.796, 11.0077, 67.7649, 14.6054);
    ctx.lineTo(67.0879, 13.3139);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(75.9199, 20.8167);
    ctx.lineTo(75.9815, 20.6322);
    ctx.bezierCurveTo(76.0123, 20.5707, 76.5354, 19.064, 77.7664, 18.4798);
    ctx.bezierCurveTo(78.3203, 18.2338, 78.9973, 18.0185, 79.6436, 17.8033);
    ctx.bezierCurveTo(80.4129, 17.5573, 81.1515, 17.342, 81.5824, 17.0653);
    ctx.bezierCurveTo(82.3825, 16.5733, 83.675, 14.6054, 82.9364, 12.3607);
    ctx.bezierCurveTo(82.1979, 10.1468, 79.7975, 8.88606, 76.6893, 9.07056);
    ctx.bezierCurveTo(73.8273, 9.25505, 70.0421, 11.0385, 67.9802, 14.6976);
    ctx.lineTo(67.7648, 15.0666);
    ctx.lineTo(66.8108, 13.3447);
    ctx.lineTo(66.9031, 13.2217);
    ctx.bezierCurveTo(69.6112, 9.62404, 73.0579, 7.6561, 76.8739, 7.50236);
    ctx.bezierCurveTo(80.4745, 7.34861, 83.398, 8.94756, 84.4444, 11.6535);
    ctx.bezierCurveTo(85.3676, 14.0826, 84.1982, 17.1268, 82.5056, 18.2338);
    ctx.bezierCurveTo(81.767, 18.7258, 81.0284, 18.941, 80.3206, 19.1255);
    ctx.bezierCurveTo(79.1512, 19.4637, 78.1357, 19.7405, 77.5202, 21.3087);
    ctx.lineTo(77.4279, 21.5239);
    ctx.lineTo(75.9199, 20.8167);
    ctx.closePath();
    ctx.moveTo(81.49, 9.74704);
    ctx.bezierCurveTo(82.3825, 10.362, 82.998, 11.1922, 83.3365, 12.207);
    ctx.bezierCurveTo(84.1674, 14.7284, 82.7518, 16.8501, 81.7978, 17.465);
    ctx.bezierCurveTo(81.3054, 17.7725, 80.536, 18.0185, 79.7667, 18.2645);
    ctx.bezierCurveTo(79.1204, 18.449, 78.4742, 18.6643, 77.951, 18.9102);
    ctx.bezierCurveTo(77.1201, 19.31, 76.6585, 20.2017, 76.4739, 20.6014);
    ctx.lineTo(77.1509, 20.9089);
    ctx.bezierCurveTo(77.8587, 19.31, 78.9666, 19.0025, 80.1668, 18.6643);
    ctx.bezierCurveTo(80.8746, 18.449, 81.5516, 18.2645, 82.2594, 17.8033);
    ctx.bezierCurveTo(83.7981, 16.7886, 84.906, 13.9597, 84.0443, 11.7457);
    ctx.bezierCurveTo(83.0595, 9.19355, 80.3822, 7.74835, 76.9355, 7.90209);
    ctx.bezierCurveTo(73.3041, 8.05584, 70.0113, 9.93153, 67.3955, 13.3447);
    ctx.lineTo(67.8263, 14.1134);
    ctx.bezierCurveTo(70.0113, 10.5465, 73.8273, 8.76307, 76.6893, 8.57857);
    ctx.bezierCurveTo(78.5973, 8.45558, 80.2591, 8.88606, 81.49, 9.74704);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(76.9356, 19.4032);
    ctx.bezierCurveTo(77.5203, 18.8498, 78.4743, 18.6653, 78.7513, 18.8805);
    ctx.bezierCurveTo(79.0282, 19.1265, 78.2281, 19.434, 77.8896, 20.1105);
    ctx.bezierCurveTo(77.5203, 20.8177, 77.3049, 21.1559, 77.3049, 21.1559);
    ctx.lineTo(76.2278, 20.6639);
    ctx.lineTo(76.9356, 19.4032);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(27.5435, 83.3922);
    ctx.lineTo(27.5127, 83.4229);
    ctx.bezierCurveTo(27.3896, 83.5459, 27.2665, 83.6382, 27.1434, 83.7612);
    ctx.lineTo(27.1126, 83.7919);
    ctx.bezierCurveTo(27.0818, 83.8227, 27.0818, 83.8227, 27.0818, 83.8227);
    ctx.bezierCurveTo(25.1431, 85.3294, 22.0964, 85.5139, 17.9112, 82.1622);
    ctx.bezierCurveTo(12.5257, 77.8573, 13.5412, 72.2303, 16.2494, 68.5096);
    ctx.bezierCurveTo(17.6342, 66.6032, 19.4806, 65.158, 21.1424, 64.666);
    ctx.lineTo(22.558, 65.1887);
    ctx.bezierCurveTo(22.558, 65.1887, 19.7884, 66.2957, 17.9727, 68.1099);
    ctx.bezierCurveTo(17.4803, 68.6019, 17.0803, 69.1246, 16.8033, 69.7089);
    ctx.bezierCurveTo(15.5108, 72.4455, 13.7874, 77.0271, 18.7728, 81.3012);
    ctx.bezierCurveTo(19.8192, 82.193, 20.8347, 82.8079, 21.7579, 83.1462);
    ctx.bezierCurveTo(24.5584, 84.1916, 26.7741, 83.0232, 27.8204, 80.9322);
    ctx.bezierCurveTo(28.1282, 80.2865, 28.3436, 79.5793, 28.4359, 78.8106);
    ctx.bezierCurveTo(28.4667, 78.4723, 28.4975, 78.1033, 28.4975, 77.7344);
    ctx.bezierCurveTo(28.4975, 77.3961, 28.4975, 77.0579, 28.4975, 76.7504);
    ctx.lineTo(28.4975, 76.3199);
    ctx.bezierCurveTo(28.4975, 75.9202, 28.5282, 75.5512, 28.559, 75.1822);
    ctx.bezierCurveTo(28.7436, 72.3225, 29.3284, 70.2316, 29.6361, 69.2476);
    ctx.bezierCurveTo(30.0054, 69.5244, 30.4054, 69.8011, 30.8055, 70.0471);
    ctx.bezierCurveTo(30.5593, 71.1233, 30.1593, 72.876, 29.9131, 74.7824);
    ctx.bezierCurveTo(29.8515, 75.3359, 29.79, 75.9202, 29.7592, 76.5044);
    ctx.bezierCurveTo(29.7284, 77.0271, 29.6976, 77.5806, 29.7284, 78.1033);
    ctx.bezierCurveTo(29.7284, 78.7798, 29.6361, 79.5178, 29.4207, 80.2865);
    ctx.bezierCurveTo(29.2668, 80.84, 29.0206, 81.4242, 28.7129, 81.947);
    ctx.bezierCurveTo(28.3744, 82.439, 27.9743, 82.9617, 27.5435, 83.3922);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(18.7416, 83.0846);
    ctx.bezierCurveTo(18.4031, 82.8693, 18.0953, 82.6233, 17.7568, 82.3466);
    ctx.bezierCurveTo(15.2641, 80.3479, 13.9101, 77.8572, 13.8177, 75.1513);
    ctx.bezierCurveTo(13.7254, 72.9067, 14.5255, 70.4775, 16.0642, 68.3865);
    ctx.bezierCurveTo(17.4799, 66.4494, 19.3571, 64.9734, 21.0804, 64.4507);
    ctx.lineTo(21.142, 64.4199);
    ctx.lineTo(23.1731, 65.1579);
    ctx.lineTo(22.6191, 65.3731);
    ctx.bezierCurveTo(22.5884, 65.3731, 19.8802, 66.4801, 18.1261, 68.2636);
    ctx.bezierCurveTo(17.6337, 68.7863, 17.2337, 69.2783, 16.9875, 69.801);
    ctx.bezierCurveTo(15.4795, 73.0296, 14.3101, 77.2115, 18.8955, 81.1166);
    ctx.bezierCurveTo(19.8802, 81.9469, 20.865, 82.5618, 21.819, 82.9308);
    ctx.bezierCurveTo(24.2809, 83.8533, 26.4967, 83.0538, 27.6045, 80.8092);
    ctx.bezierCurveTo(27.9123, 80.1942, 28.1277, 79.5177, 28.1892, 78.749);
    ctx.bezierCurveTo(28.22, 78.4107, 28.2508, 78.0725, 28.2508, 77.7035);
    ctx.bezierCurveTo(28.2508, 77.396, 28.2508, 77.0578, 28.2508, 76.6888);
    ctx.lineTo(28.2508, 76.2583);
    ctx.bezierCurveTo(28.2508, 75.8586, 28.2816, 75.4896, 28.3123, 75.1206);
    ctx.bezierCurveTo(28.497, 72.2302, 29.0817, 70.1392, 29.4202, 69.1245);
    ctx.lineTo(29.5125, 68.817);
    ctx.lineTo(29.7587, 69.0323);
    ctx.bezierCurveTo(30.0972, 69.309, 30.4665, 69.555, 30.8974, 69.801);
    ctx.lineTo(31.0512, 69.8932);
    ctx.lineTo(31.0205, 70.047);
    ctx.bezierCurveTo(30.7435, 71.1847, 30.3742, 72.9066, 30.1588, 74.7516);
    ctx.bezierCurveTo(30.0972, 75.3666, 30.0357, 75.9201, 30.0049, 76.4428);
    ctx.bezierCurveTo(29.9741, 76.9963, 29.9434, 77.519, 29.9741, 78.011);
    ctx.bezierCurveTo(29.9741, 78.7182, 29.8818, 79.4869, 29.6356, 80.2557);
    ctx.bezierCurveTo(29.451, 80.8399, 29.2048, 81.4241, 28.9278, 81.9469);
    ctx.bezierCurveTo(28.5893, 82.5311, 28.1892, 83.0538, 27.7584, 83.4843);
    ctx.bezierCurveTo(27.7584, 83.4843, 27.7584, 83.4843, 27.7276, 83.5151);
    ctx.bezierCurveTo(27.6045, 83.6381, 27.4814, 83.7611, 27.3276, 83.8533);
    ctx.lineTo(27.266, 83.9148);
    ctx.bezierCurveTo(25.8812, 84.991, 23.1115, 86.1287, 18.7416, 83.0846);
    ctx.closePath();
    ctx.moveTo(21.1112, 64.8812);
    ctx.bezierCurveTo(19.4802, 65.3731, 17.726, 66.7876, 16.4028, 68.6325);
    ctx.bezierCurveTo(13.7254, 72.3224, 12.7406, 77.765, 18.0338, 81.9776);
    ctx.bezierCurveTo(22.5268, 85.5445, 25.358, 84.8373, 26.9275, 83.6381);
    ctx.lineTo(26.9891, 83.5766);
    ctx.bezierCurveTo(27.1121, 83.4843, 27.2352, 83.3613, 27.3583, 83.2691);
    ctx.bezierCurveTo(27.3891, 83.2383, 27.3891, 83.2383, 27.3891, 83.2383);
    ctx.bezierCurveTo(27.82, 82.8386, 28.1892, 82.3466, 28.497, 81.7931);
    ctx.bezierCurveTo(28.774, 81.3011, 29.0201, 80.7477, 29.174, 80.1942);
    ctx.bezierCurveTo(29.3894, 79.4869, 29.4818, 78.749, 29.4818, 78.1032);
    ctx.bezierCurveTo(29.4818, 77.5805, 29.4818, 77.0578, 29.5125, 76.5043);
    ctx.bezierCurveTo(29.5433, 75.9816, 29.6049, 75.3973, 29.6664, 74.7823);
    ctx.bezierCurveTo(29.8818, 72.9989, 30.2511, 71.3077, 30.4973, 70.17);
    ctx.bezierCurveTo(30.2203, 69.9855, 29.9434, 69.8317, 29.6972, 69.6473);
    ctx.bezierCurveTo(29.3587, 70.7235, 28.8663, 72.6607, 28.7124, 75.2128);
    ctx.bezierCurveTo(28.6816, 75.5818, 28.6816, 75.9508, 28.6509, 76.3505);
    ctx.lineTo(28.6509, 76.781);
    ctx.bezierCurveTo(28.6509, 77.1193, 28.6509, 77.4575, 28.6509, 77.765);
    ctx.bezierCurveTo(28.6509, 78.134, 28.6509, 78.503, 28.5893, 78.872);
    ctx.bezierCurveTo(28.497, 79.6714, 28.2816, 80.4094, 27.943, 81.0551);
    ctx.bezierCurveTo(26.7121, 83.5151, 24.2809, 84.4068, 21.5728, 83.3921);
    ctx.bezierCurveTo(20.5573, 83.0231, 19.5417, 82.3774, 18.5262, 81.5164);
    ctx.bezierCurveTo(13.7254, 77.396, 14.9256, 73.0296, 16.4951, 69.6473);
    ctx.bezierCurveTo(16.772, 69.0938, 17.1721, 68.5403, 17.726, 67.9868);
    ctx.bezierCurveTo(19.0801, 66.6339, 20.9573, 65.6499, 21.8498, 65.2501);
    ctx.lineTo(21.1112, 64.8812);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(29.359, 80.2562);
    ctx.bezierCurveTo(29.5437, 79.4567, 28.405, 78.811, 28.405, 78.811);
    ctx.lineTo(28.4358, 76.7508);
    ctx.lineTo(28.4358, 76.3203);
    ctx.lineTo(29.6975, 76.5048);
    ctx.bezierCurveTo(29.6668, 77.0275, 29.636, 77.581, 29.6668, 78.1038);
    ctx.bezierCurveTo(29.6975, 78.7495, 29.6052, 79.4875, 29.359, 80.2562);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(27.5429, 83.3916);
    ctx.lineTo(27.5121, 83.4223);
    ctx.bezierCurveTo(27.3275, 83.6068, 27.1736, 83.7298, 27.1121, 83.7606);
    ctx.bezierCurveTo(27.0813, 83.7913, 27.0813, 83.7913, 27.0813, 83.7913);
    ctx.lineTo(26.3427, 83.3301);
    ctx.bezierCurveTo(24.4347, 84.437, 22.9268, 83.8221, 21.6035, 83.3301);
    ctx.lineTo(21.7574, 83.1456);
    ctx.bezierCurveTo(24.5578, 84.191, 26.7736, 83.0226, 27.8199, 80.9316);
    ctx.bezierCurveTo(27.943, 80.9624, 28.8662, 81.2391, 28.7123, 81.9156);
    ctx.bezierCurveTo(28.7123, 81.9464, 28.6816, 81.9771, 28.6816, 82.0079);
    ctx.bezierCurveTo(28.4661, 82.4691, 27.943, 83.0226, 27.5429, 83.3916);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#FFF403";

    ctx.beginPath();
    ctx.moveTo(38.3143, 74.5354);
    ctx.bezierCurveTo(37.0217, 75.2119, 35.3599, 75.9499, 33.575, 76.5341);
    ctx.bezierCurveTo(29.8206, 77.7641, 25.4199, 78.379, 22.1886, 76.4111);
    ctx.bezierCurveTo(18.9266, 74.4739, 19.1728, 70.9378, 20.1575, 68.0166);
    ctx.bezierCurveTo(20.6191, 66.6022, 21.2654, 65.3414, 21.7578, 64.4805);
    ctx.lineTo(23.0811, 64.5112);
    ctx.bezierCurveTo(22.5579, 65.4337, 22.0348, 66.4792, 21.6039, 67.5861);
    ctx.bezierCurveTo(20.4345, 70.5995, 20.0344, 73.8589, 22.8349, 75.3349);
    ctx.bezierCurveTo(26.0354, 77.0261, 29.9745, 76.3496, 32.8672, 75.3964);
    ctx.bezierCurveTo(35.2676, 74.5969, 36.9602, 73.6129, 36.9602, 73.6129);
    ctx.lineTo(38.3143, 74.5354);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(21.6649, 76.3807);
    ctx.bezierCurveTo(19.2338, 74.6895, 18.6183, 71.7991, 19.9108, 67.9555);
    ctx.bezierCurveTo(20.4032, 66.4796, 21.0802, 65.1881, 21.5418, 64.3886);
    ctx.lineTo(21.6034, 64.2656);
    ctx.lineTo(23.4191, 64.3271);
    ctx.lineTo(23.2344, 64.6654);
    ctx.bezierCurveTo(22.6497, 65.7108, 22.1573, 66.7563, 21.788, 67.7095);
    ctx.bezierCurveTo(20.3109, 71.4916, 20.6802, 73.9823, 22.8959, 75.1508);
    ctx.bezierCurveTo(26.0656, 76.8112, 30.0047, 76.104, 32.7436, 75.1815);
    ctx.bezierCurveTo(35.0824, 74.4128, 36.775, 73.4288, 36.8058, 73.4288);
    ctx.lineTo(36.9289, 73.3673);
    ctx.lineTo(38.7138, 74.6281);
    ctx.lineTo(38.3753, 74.8125);
    ctx.bezierCurveTo(37.2982, 75.366, 35.5748, 76.1655, 33.6053, 76.8112);
    ctx.bezierCurveTo(30.2509, 77.9182, 25.5425, 78.7792, 22.0034, 76.6882);
    ctx.bezierCurveTo(21.9111, 76.5345, 21.788, 76.4422, 21.6649, 76.3807);
    ctx.closePath();
    ctx.moveTo(21.8803, 64.7269);
    ctx.bezierCurveTo(21.4187, 65.5263, 20.8033, 66.7563, 20.3416, 68.1093);
    ctx.bezierCurveTo(19.4492, 70.7537, 19.0799, 74.3206, 22.2804, 76.227);
    ctx.bezierCurveTo(25.6348, 78.2564, 30.2509, 77.3955, 33.4822, 76.3192);
    ctx.bezierCurveTo(35.2363, 75.735, 36.775, 75.0278, 37.8521, 74.5051);
    ctx.lineTo(36.9289, 73.8593);
    ctx.bezierCurveTo(36.498, 74.1053, 34.9286, 74.9048, 32.8975, 75.5813);
    ctx.bezierCurveTo(30.0663, 76.5037, 26.0041, 77.2725, 22.6805, 75.5198);
    ctx.bezierCurveTo(20.2493, 74.2283, 19.7877, 71.4609, 21.3572, 67.4943);
    ctx.bezierCurveTo(21.6957, 66.6333, 22.1265, 65.6801, 22.6497, 64.7269);
    ctx.lineTo(21.8803, 64.7269);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(22.404, 75.0898);
    ctx.bezierCurveTo(21.6962, 74.8131, 21.1423, 75.7355, 21.8501, 76.2275);
    ctx.bezierCurveTo(22.5579, 76.7195, 23.8196, 77.2422, 25.0198, 77.519);
    ctx.lineTo(24.6813, 76.043);
    ctx.bezierCurveTo(24.7121, 76.043, 23.9427, 76.0123, 22.404, 75.0898);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(38.314, 74.5352);
    ctx.bezierCurveTo(37.0214, 75.2117, 35.3596, 75.9497, 33.5747, 76.5339);
    ctx.bezierCurveTo(33.5132, 76.1957, 33.2978, 75.673, 32.8669, 75.3655);
    ctx.bezierCurveTo(35.2673, 74.566, 36.9599, 73.582, 36.9599, 73.582);
    ctx.lineTo(38.314, 74.5352);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(21.5728, 67.5861);
    ctx.bezierCurveTo(20.9574, 67.5554, 20.5573, 67.6784, 20.1265, 68.0166);
    ctx.bezierCurveTo(20.5881, 66.6022, 21.2343, 65.3414, 21.7267, 64.4805);
    ctx.lineTo(23.05, 64.5112);
    ctx.bezierCurveTo(22.5268, 65.4337, 22.0037, 66.5099, 21.5728, 67.5861);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#0093F1";

    ctx.beginPath();
    ctx.moveTo(34.2209, 84.4367);
    ctx.bezierCurveTo(33.79, 84.8364, 32.2513, 85.0824, 29.5124, 83.1759);
    ctx.bezierCurveTo(26.8043, 81.2695, 24.9579, 79.0556, 24.0962, 76.6264);
    ctx.bezierCurveTo(23.573, 75.1505, 24.0347, 73.736, 25.1733, 72.0448);
    ctx.bezierCurveTo(25.9119, 70.9378, 26.9274, 69.6771, 28.0968, 68.2319);
    ctx.lineTo(28.1892, 68.2012);
    ctx.bezierCurveTo(28.4661, 68.4779, 28.7739, 68.7547, 29.1124, 69.0006);
    ctx.bezierCurveTo(28.343, 69.8924, 27.5121, 70.9071, 26.8043, 71.9833);
    ctx.bezierCurveTo(25.7272, 73.613, 24.9579, 75.2734, 25.2656, 76.4112);
    ctx.bezierCurveTo(26.035, 79.2401, 30.2818, 82.7147, 32.6206, 83.5142);
    ctx.bezierCurveTo(32.8976, 83.6064, 33.1746, 83.4219, 33.2053, 83.1452);
    ctx.bezierCurveTo(33.2977, 82.4072, 33.5131, 80.9005, 34.0978, 79.3631);
    ctx.bezierCurveTo(34.1286, 79.2708, 34.1901, 79.1478, 34.2209, 79.0556);
    ctx.bezierCurveTo(35.1441, 76.7801, 37.8215, 72.2908, 37.8215, 72.2908);
    ctx.lineTo(39.114, 72.6905);
    ctx.bezierCurveTo(39.114, 72.6905, 38.16, 73.5822, 36.0673, 77.8256);
    ctx.bezierCurveTo(35.7904, 78.3483, 35.5749, 78.8403, 35.3903, 79.3016);
    ctx.bezierCurveTo(34.0978, 82.4687, 34.5902, 84.0984, 34.2209, 84.4367);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(29.4818, 83.4223);
    ctx.bezierCurveTo(29.451, 83.3915, 29.4203, 83.3915, 29.3895, 83.3608);
    ctx.bezierCurveTo(26.589, 81.3929, 24.7426, 79.1482, 23.8809, 76.6883);
    ctx.bezierCurveTo(23.3885, 75.2738, 23.6963, 73.8286, 24.958, 71.8914);
    ctx.bezierCurveTo(25.6658, 70.7844, 26.6506, 69.616, 27.9123, 68.0478);
    ctx.lineTo(27.9431, 68.017);
    ctx.lineTo(28.2201, 67.8633);
    ctx.lineTo(28.3432, 67.9863);
    ctx.bezierCurveTo(28.6201, 68.263, 28.9279, 68.509, 29.2356, 68.755);
    ctx.lineTo(29.4203, 68.9087);
    ctx.lineTo(29.2664, 69.0932);
    ctx.bezierCurveTo(28.3432, 70.1387, 27.6046, 71.1227, 26.9891, 72.0452);
    ctx.bezierCurveTo(25.7581, 73.8901, 25.235, 75.366, 25.4812, 76.2885);
    ctx.bezierCurveTo(26.2198, 79.0252, 30.3743, 82.4691, 32.6823, 83.2378);
    ctx.bezierCurveTo(32.7746, 83.2685, 32.8362, 83.2378, 32.867, 83.207);
    ctx.bezierCurveTo(32.9285, 83.1763, 32.9593, 83.1148, 32.9593, 83.0533);
    ctx.bezierCurveTo(33.0516, 82.2846, 33.2978, 80.7779, 33.8517, 79.2404);
    ctx.lineTo(33.8517, 79.2097);
    ctx.bezierCurveTo(33.8825, 79.1174, 33.9133, 79.0252, 33.9748, 78.9329);
    ctx.bezierCurveTo(34.8981, 76.6883, 37.4831, 72.3219, 37.6062, 72.1374);
    ctx.lineTo(37.6985, 71.9837);
    ctx.lineTo(39.5449, 72.5371);
    ctx.lineTo(39.268, 72.8139);
    ctx.bezierCurveTo(39.268, 72.8139, 38.314, 73.7671, 36.2521, 77.8875);
    ctx.bezierCurveTo(36.0059, 78.3795, 35.7905, 78.8714, 35.6059, 79.3634);
    ctx.bezierCurveTo(34.8057, 81.3929, 34.7134, 82.7766, 34.6519, 83.576);
    ctx.bezierCurveTo(34.6211, 84.0988, 34.5903, 84.437, 34.4057, 84.6215);
    ctx.bezierCurveTo(33.9133, 85.052, 32.2823, 85.3902, 29.4818, 83.4223);
    ctx.closePath();
    ctx.moveTo(28.1893, 68.4783);
    ctx.bezierCurveTo(26.9583, 69.9542, 26.0659, 71.0919, 25.3581, 72.1374);
    ctx.bezierCurveTo(24.1887, 73.9208, 23.8809, 75.243, 24.3118, 76.5345);
    ctx.bezierCurveTo(25.1427, 78.9022, 26.9276, 81.0546, 29.6357, 82.9918);
    ctx.bezierCurveTo(29.6665, 83.0226, 29.6972, 83.0226, 29.728, 83.0533);
    ctx.bezierCurveTo(32.3746, 84.8982, 33.7594, 84.56, 34.0671, 84.2833);
    ctx.bezierCurveTo(34.1287, 84.2218, 34.1595, 83.8835, 34.1902, 83.5453);
    ctx.bezierCurveTo(34.2518, 82.6843, 34.3441, 81.2699, 35.175, 79.1789);
    ctx.bezierCurveTo(35.3597, 78.6869, 35.6059, 78.195, 35.852, 77.6722);
    ctx.bezierCurveTo(37.3908, 74.6281, 38.314, 73.2751, 38.714, 72.7524);
    ctx.lineTo(37.9139, 72.5064);
    ctx.bezierCurveTo(37.4523, 73.3059, 35.2366, 77.1187, 34.4057, 79.0867);
    ctx.bezierCurveTo(34.3749, 79.1789, 34.3133, 79.2712, 34.2826, 79.3942);
    ctx.lineTo(34.2826, 79.4249);
    ctx.bezierCurveTo(33.7286, 80.9009, 33.4824, 82.3768, 33.4209, 83.1148);
    ctx.bezierCurveTo(33.3901, 83.2993, 33.2978, 83.4838, 33.1132, 83.6068);
    ctx.bezierCurveTo(32.9285, 83.699, 32.7439, 83.7298, 32.5592, 83.6683);
    ctx.bezierCurveTo(30.1588, 82.8688, 25.8505, 79.3634, 25.0503, 76.4115);
    ctx.bezierCurveTo(24.7734, 75.366, 25.2965, 73.7978, 26.6198, 71.7992);
    ctx.bezierCurveTo(27.2045, 70.9382, 27.9123, 69.985, 28.774, 69.001);
    ctx.bezierCurveTo(28.5586, 68.8473, 28.3739, 68.6628, 28.1893, 68.4783);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(35.3902, 79.2398);
    ctx.bezierCurveTo(35.3902, 79.2398, 34.4977, 78.7786, 34.0977, 79.332);
    ctx.bezierCurveTo(34.1284, 79.2398, 34.19, 79.1168, 34.2208, 79.0246);
    ctx.bezierCurveTo(35.144, 76.7491, 37.8213, 72.2598, 37.8213, 72.2598);
    ctx.lineTo(39.1138, 72.6595);
    ctx.bezierCurveTo(39.1138, 72.6595, 38.1598, 73.5512, 36.0672, 77.7946);
    ctx.bezierCurveTo(35.7902, 78.2866, 35.5748, 78.7786, 35.3902, 79.2398);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(26.8041, 71.9526);
    ctx.bezierCurveTo(26.4656, 71.7681, 25.8194, 71.3683, 25.1731, 72.0448);
    ctx.bezierCurveTo(25.9117, 70.9378, 26.9272, 69.6771, 28.0966, 68.2319);
    ctx.lineTo(28.189, 68.2012);
    ctx.bezierCurveTo(28.4659, 68.4779, 28.7737, 68.7547, 29.1122, 69.0006);
    ctx.bezierCurveTo(28.3428, 69.8616, 27.5119, 70.8763, 26.8041, 71.9526);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(22.4959, 65.1575);
    ctx.bezierCurveTo(22.4959, 65.1575, 19.7263, 66.2645, 17.9106, 68.0787);
    ctx.bezierCurveTo(17.4182, 67.8019, 17.0182, 67.7712, 16.1873, 68.4784);
    ctx.bezierCurveTo(17.5721, 66.572, 19.4185, 65.1268, 21.0803, 64.6348);
    ctx.lineTo(22.4959, 65.1575);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(29.8821, 74.7829);
    ctx.bezierCurveTo(29.4205, 74.8136, 28.8974, 74.9059, 28.4973, 75.1826);
    ctx.bezierCurveTo(28.682, 72.323, 29.2667, 70.232, 29.5744, 69.248);
    ctx.bezierCurveTo(29.9437, 69.5248, 30.3438, 69.8015, 30.7438, 70.0475);
    ctx.bezierCurveTo(30.4976, 71.093, 30.1283, 72.8764, 29.8821, 74.7829);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(48.5614, 29.8269);
    ctx.bezierCurveTo(50.1309, 29.1197, 51.1464, 27.5207, 49.6077, 25.7373);
    ctx.bezierCurveTo(48.069, 23.9846, 47.7305, 22.6317, 46.4688, 22.3857);
    ctx.bezierCurveTo(46.4688, 22.3857, 49.6693, 22.2934, 50.9002, 23.9846);
    ctx.bezierCurveTo(52.1312, 25.6758, 51.0233, 28.6585, 51.0233, 28.6585);
    ctx.lineTo(50.2232, 30.4419);
    ctx.lineTo(48.5614, 29.8269);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(64.6563, 12.1135);
    ctx.lineTo(26.1579, 67.3695);
    ctx.bezierCurveTo(22.0342, 66.0473, 19.6953, 63.5874, 18.8337, 62.5112);
    ctx.bezierCurveTo(18.5567, 62.1729, 18.4336, 61.9884, 18.4336, 61.9884);
    ctx.lineTo(56.932, 6.73242);
    ctx.bezierCurveTo(57.609, 6.97841, 58.2245, 7.25516, 58.84, 7.5319);
    ctx.bezierCurveTo(62.4714, 9.37684, 64.6563, 12.1135, 64.6563, 12.1135);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(21.542, 65.5561);
    ctx.bezierCurveTo(20.0033, 64.4799, 19.0185, 63.4037, 18.5261, 62.8195);
    ctx.bezierCurveTo(18.2491, 62.4812, 18.126, 62.266, 18.0953, 62.266);
    ctx.lineTo(17.9722, 62.0507);
    ctx.lineTo(56.7783, 6.30273);
    ctx.lineTo(57.0553, 6.39498);
    ctx.bezierCurveTo(57.7015, 6.61022, 58.3478, 6.88697, 58.9941, 7.22521);
    ctx.bezierCurveTo(62.6562, 9.07015, 64.8411, 11.7761, 64.9335, 11.8683);
    ctx.lineTo(65.1181, 12.0836);
    ctx.lineTo(26.2812, 67.8315);
    ctx.lineTo(26.0042, 67.7393);
    ctx.bezierCurveTo(24.1885, 67.1551, 22.7114, 66.3556, 21.542, 65.5561);
    ctx.closePath();
    ctx.moveTo(18.8646, 62.02);
    ctx.bezierCurveTo(18.9262, 62.1122, 18.9877, 62.2045, 19.08, 62.2967);
    ctx.bezierCurveTo(19.8494, 63.2499, 22.0651, 65.5869, 25.9734, 66.9398);
    ctx.lineTo(64.1641, 12.1451);
    ctx.bezierCurveTo(63.5794, 11.4686, 61.5791, 9.37764, 58.6555, 7.90168);
    ctx.bezierCurveTo(58.1324, 7.62494, 57.6092, 7.4097, 57.0553, 7.19446);
    ctx.lineTo(18.8646, 62.02);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(35.3281, 41.7871);
    ctx.lineTo(29.2349, 50.5506);
    ctx.bezierCurveTo(29.6657, 50.8581, 30.0965, 51.1656, 30.5274, 51.4731);
    ctx.lineTo(35.8821, 43.7858);
    ctx.bezierCurveTo(35.6667, 43.1401, 35.5128, 42.4636, 35.3281, 41.7871);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(49.6077, 21.4007);
    ctx.bezierCurveTo(50.0693, 21.5852, 50.5002, 21.8312, 50.931, 22.0772);
    ctx.lineTo(52.7467, 19.4635);
    ctx.bezierCurveTo(52.7159, 19.3712, 52.6544, 19.279, 52.4697, 19.156);
    ctx.bezierCurveTo(52.162, 18.91, 51.7927, 18.7255, 51.4234, 18.541);
    ctx.lineTo(49.4539, 21.3392);
    ctx.bezierCurveTo(49.5154, 21.3699, 49.577, 21.4007, 49.6077, 21.4007);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(56.1319, 14.6054);
    ctx.lineTo(58.84, 10.7003);
    ctx.bezierCurveTo(58.6554, 10.116, 58.163, 9.80854, 57.5783, 9.68555);
    ctx.lineTo(54.8086, 13.6829);
    ctx.bezierCurveTo(55.3625, 13.8982, 55.7934, 14.2057, 56.1319, 14.6054);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(22.1575, 62.4191);
    ctx.lineTo(26.8044, 56.5153);
    ctx.bezierCurveTo(26.3428, 56.2385, 25.8812, 55.9618, 25.4503, 55.6543);
    ctx.lineTo(20.8342, 61.5274);
    ctx.bezierCurveTo(21.2651, 61.8349, 21.6959, 62.1423, 22.1575, 62.4191);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(64.6559, 12.1445);
    ctx.lineTo(26.1267, 67.4005);
    ctx.bezierCurveTo(26.1267, 67.4005, 28.4655, 71.0289, 33.851, 72.7816);
    ctx.lineTo(72.3494, 17.4949);
    ctx.bezierCurveTo(72.3494, 17.4949, 69.3951, 13.805, 64.6559, 12.1445);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(29.2353, 70.9062);
    ctx.bezierCurveTo(26.958, 69.3073, 25.8809, 67.7083, 25.8194, 67.5853);
    ctx.lineTo(25.6963, 67.3701);
    ctx.lineTo(64.5024, 11.6836);
    ctx.lineTo(64.7794, 11.7758);
    ctx.bezierCurveTo(69.5802, 13.467, 72.5345, 17.1262, 72.6576, 17.2799);
    ctx.lineTo(72.8422, 17.4952);
    ctx.lineTo(34.0053, 73.2124);
    ctx.lineTo(33.7283, 73.1202);
    ctx.bezierCurveTo(31.8819, 72.5359, 30.4047, 71.7365, 29.2353, 70.9062);
    ctx.closePath();
    ctx.moveTo(26.5887, 67.4008);
    ctx.bezierCurveTo(27.1427, 68.1696, 29.42, 70.8755, 33.6976, 72.3207);
    ctx.lineTo(71.8882, 17.5259);
    ctx.bezierCurveTo(71.1804, 16.7572, 68.5954, 14.0205, 64.7794, 12.5753);
    ctx.lineTo(26.5887, 67.4008);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(63.6714, 19.1553);
    ctx.lineTo(66.3487, 15.3424);
    ctx.lineTo(65.0254, 14.4199);
    ctx.lineTo(62.4404, 18.1406);
    ctx.bezierCurveTo(62.8713, 18.448, 63.2406, 18.817, 63.6714, 19.1553);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(55.6696, 30.6247);
    ctx.lineTo(59.9164, 24.5364);
    ctx.bezierCurveTo(59.4856, 24.1674, 58.9624, 24.0137, 58.3469, 24.0137);
    ctx.lineTo(54.1001, 30.0712);
    ctx.bezierCurveTo(54.654, 30.1942, 55.208, 30.348, 55.6696, 30.6247);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(37.729, 56.3936);
    ctx.lineTo(41.1449, 51.4738);
    ctx.bezierCurveTo(41.0219, 51.2893, 40.7757, 50.8588, 39.8217, 50.7051);
    ctx.bezierCurveTo(39.7909, 50.7051, 39.7601, 50.7051, 39.7293, 50.7051);
    ctx.lineTo(36.4673, 55.4097);
    ctx.bezierCurveTo(36.8981, 55.7172, 37.2982, 56.0554, 37.729, 56.3936);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(29.6661, 67.9536);
    ctx.lineTo(33.9129, 61.8345);
    ctx.bezierCurveTo(33.6667, 61.6808, 33.4205, 61.4963, 33.1743, 61.281);
    ctx.bezierCurveTo(32.9897, 61.1273, 32.8358, 60.9736, 32.6819, 60.7891);
    ctx.lineTo(28.312, 67.0619);
    ctx.bezierCurveTo(28.8044, 67.3386, 29.2352, 67.6461, 29.6661, 67.9536);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(80.0433, 22.8445);
    ctx.lineTo(41.5449, 78.1312);
    ctx.bezierCurveTo(40.8063, 77.8852, 40.1292, 77.6085, 39.483, 77.3318);
    ctx.bezierCurveTo(35.5439, 75.4868, 33.8206, 72.7809, 33.8206, 72.7809);
    ctx.lineTo(72.3497, 17.4941);
    ctx.bezierCurveTo(75.0886, 18.4474, 77.2121, 20.0771, 78.5353, 21.307);
    ctx.bezierCurveTo(79.5201, 22.168, 80.0433, 22.8445, 80.0433, 22.8445);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(36.9289, 76.2558);
    ctx.bezierCurveTo(34.6209, 74.6569, 33.5745, 73.0272, 33.513, 72.9657);
    ctx.lineTo(33.3899, 72.7504);
    ctx.lineTo(72.196, 17.0332);
    ctx.lineTo(72.473, 17.1255);
    ctx.bezierCurveTo(75.2735, 18.1094, 77.4584, 19.7699, 78.7817, 20.9998);
    ctx.bezierCurveTo(79.7665, 21.9223, 80.3204, 22.5988, 80.3512, 22.5988);
    ctx.lineTo(80.5358, 22.814);
    ctx.lineTo(41.6989, 78.562);
    ctx.lineTo(41.4219, 78.4698);
    ctx.bezierCurveTo(40.6834, 78.2238, 39.9755, 77.947, 39.3293, 77.6395);
    ctx.bezierCurveTo(38.4061, 77.209, 37.6059, 76.7478, 36.9289, 76.2558);
    ctx.closePath();
    ctx.moveTo(34.2823, 72.7504);
    ctx.bezierCurveTo(34.7747, 73.3962, 36.4981, 75.4871, 39.637, 76.9631);
    ctx.bezierCurveTo(40.191, 77.2398, 40.7757, 77.455, 41.3912, 77.6703);
    ctx.lineTo(79.5818, 22.8755);
    ctx.bezierCurveTo(79.3664, 22.5988, 78.9048, 22.1375, 78.2893, 21.5533);
    ctx.bezierCurveTo(77.0276, 20.4156, 75.0273, 18.8781, 72.5038, 17.9249);
    ctx.lineTo(34.2823, 72.7504);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(60.8713, 39.2962);
    ctx.lineTo(67.3954, 30.01);
    ctx.bezierCurveTo(66.903, 29.764, 66.4106, 29.518, 65.9182, 29.3027);
    ctx.lineTo(60.4712, 37.0515);
    ctx.bezierCurveTo(60.7789, 37.7587, 60.9328, 38.5274, 60.8713, 39.2962);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(40.7755, 66.5082);
    ctx.bezierCurveTo(40.7447, 66.4774, 40.437, 66.2929, 40.3754, 66.2622);
    ctx.bezierCurveTo(40.3139, 66.2314, 40.2523, 66.2007, 40.1908, 66.1699);
    ctx.lineTo(35.667, 72.6272);
    ctx.lineTo(36.9903, 73.5497);
    ctx.lineTo(41.5448, 67.0309);
    ctx.bezierCurveTo(41.2987, 66.8771, 41.0217, 66.6927, 40.7755, 66.5082);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(44.1304, 60.6657);
    ctx.bezierCurveTo(44.5612, 60.9732, 44.9921, 61.2499, 45.3921, 61.4959);
    ctx.lineTo(49.8236, 55.1309);
    ctx.bezierCurveTo(49.1158, 55.4383, 48.4696, 55.4076, 47.7002, 55.3461);
    ctx.lineTo(44.0381, 60.6042);
    ctx.bezierCurveTo(44.0996, 60.6349, 44.1304, 60.6349, 44.1304, 60.6657);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(71.242, 24.4131);
    ctx.lineTo(73.8886, 20.6002);
    ctx.lineTo(72.5653, 19.6777);
    ctx.lineTo(69.8572, 23.5521);
    ctx.bezierCurveTo(70.3496, 23.8289, 70.8112, 24.1363, 71.242, 24.4131);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(48.4691, 19.832);
    ctx.lineTo(50.1925, 19.709);
    ctx.bezierCurveTo(54.9317, 13.0365, 58.84, 7.56315, 58.84, 7.56315);
    ctx.bezierCurveTo(58.2553, 7.25566, 57.6091, 6.97892, 56.932, 6.76367);
    ctx.lineTo(18.4028, 62.0197);
    ctx.bezierCurveTo(18.4028, 62.0197, 18.5259, 62.2042, 18.8029, 62.5424);
    ctx.bezierCurveTo(19.9723, 61.4354, 26.958, 52.1492, 30.9587, 46.6759);
    ctx.bezierCurveTo(30.4355, 46.6144, 29.7893, 46.4607, 29.7893, 46.4607);
    ctx.bezierCurveTo(29.7893, 46.4607, 29.8508, 46.4607, 30.0047, 46.3992);
    ctx.bezierCurveTo(30.1585, 46.3377, 31.1741, 46.3684, 31.1741, 46.3684);
    ctx.bezierCurveTo(32.1589, 45.0155, 32.9282, 43.9392, 33.3591, 43.3243);
    ctx.bezierCurveTo(34.6208, 41.5101, 43.1452, 29.5487, 49.9771, 19.9243);
    ctx.lineTo(48.4691, 19.832);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(46.3459, 71.2138);
    ctx.lineTo(80.0435, 22.8455);
    ctx.bezierCurveTo(80.0435, 22.8455, 79.6435, 22.2306, 78.5048, 21.2773);
    ctx.lineTo(72.7808, 29.5181);
    ctx.bezierCurveTo(72.7808, 29.5181, 72.4423, 30.6558, 66.1644, 39.6345);
    ctx.bezierCurveTo(59.8865, 48.6132, 47.4537, 65.8327, 39.8525, 76.7486);
    ctx.lineTo(41.5451, 78.1015);
    ctx.lineTo(45.2996, 72.7205);
    ctx.lineTo(42.9915, 75.5494);
    ctx.lineTo(43.7301, 73.9812);
    ctx.lineTo(45.8843, 70.8755);
    ctx.lineTo(46.3459, 71.2138);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(74.9658, 28.3187);
    ctx.bezierCurveTo(75.1812, 27.9804, 75.4274, 27.6422, 75.6428, 27.304);
    ctx.bezierCurveTo(75.889, 26.9657, 76.1045, 26.6275, 76.3507, 26.32);
    ctx.bezierCurveTo(76.843, 25.6743, 77.3354, 25.0285, 77.8894, 24.3828);
    ctx.bezierCurveTo(77.4893, 25.09, 77.0585, 25.7973, 76.6276, 26.4737);
    ctx.bezierCurveTo(76.4122, 26.812, 76.166, 27.1502, 75.9506, 27.4885);
    ctx.bezierCurveTo(75.7044, 27.8267, 75.489, 28.1649, 75.2428, 28.4724);
    ctx.lineTo(74.9658, 28.3187);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(40.7139, 77.5168);
    ctx.lineTo(40.7446, 77.4553);
    ctx.lineTo(40.837, 77.363);
    ctx.lineTo(40.9601, 77.2093);
    ctx.lineTo(41.2063, 76.8711);
    ctx.lineTo(41.6986, 76.1638);
    ctx.lineTo(42.6834, 74.8109);
    ctx.lineTo(44.6837, 72.0742);
    ctx.lineTo(42.8065, 74.9031);
    ctx.lineTo(41.8833, 76.3176);
    ctx.lineTo(41.4217, 77.0248);
    ctx.lineTo(41.1755, 77.363);
    ctx.lineTo(41.0524, 77.5475);
    ctx.lineTo(40.9908, 77.609);
    ctx.lineTo(40.9293, 77.732);
    ctx.lineTo(40.7139, 77.5168);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(74.2884, 18.3863);
    ctx.lineTo(73.5498, 17.8943);
    ctx.lineTo(73.5498, 17.9251);
    ctx.bezierCurveTo(72.7805, 17.4638, 72.3496, 17.4946, 72.3496, 17.4946);
    ctx.lineTo(68.0105, 23.6751);
    ctx.lineTo(68.9029, 24.2901);
    ctx.lineTo(72.1958, 20.139);
    ctx.lineTo(70.2878, 23.3984);
    ctx.lineTo(74.2884, 18.3863);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(72.996, 17.8939);
    ctx.bezierCurveTo(73.0268, 17.9247, 73.0883, 17.9247, 73.1191, 17.8939);
    ctx.bezierCurveTo(73.1499, 17.8939, 73.1499, 17.8632, 73.1499, 17.8632);
    ctx.lineTo(73.1191, 17.9247);
    ctx.lineTo(73.0576, 18.0169);
    ctx.lineTo(72.9037, 18.2014);
    ctx.lineTo(72.596, 18.5704);
    ctx.lineTo(71.9805, 19.3084);
    ctx.lineTo(70.7495, 20.8151);
    ctx.lineTo(71.8574, 19.2161);
    ctx.lineTo(72.3805, 18.4474);
    ctx.lineTo(72.6575, 18.0477);
    ctx.lineTo(72.8114, 17.8632);
    ctx.lineTo(72.8729, 17.7709);
    ctx.lineTo(72.9037, 17.7094);
    ctx.bezierCurveTo(72.9037, 17.7094, 72.9345, 17.6787, 72.9652, 17.6479);
    ctx.bezierCurveTo(73.0268, 17.6172, 73.0883, 17.6172, 73.1191, 17.6172);
    ctx.lineTo(72.996, 17.8939);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(58.1939, 7.31631);
    ctx.bezierCurveTo(57.6092, 8.23878, 56.9938, 9.09975, 56.3475, 9.96072);
    ctx.bezierCurveTo(55.7012, 10.8217, 55.0242, 11.6827, 54.3164, 12.4821);
    ctx.bezierCurveTo(54.8396, 11.5289, 55.3935, 10.6065, 55.9782, 9.71473);
    ctx.bezierCurveTo(56.5629, 8.82301, 57.1476, 7.90054, 57.8247, 7.07031);
    ctx.lineTo(58.1939, 7.31631);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(65.3025, 47.752);
    ctx.bezierCurveTo(65.7949, 47.8442, 66.2257, 48.0287, 66.6566, 48.2439);
    ctx.bezierCurveTo(67.0874, 48.4592, 67.4875, 48.7359, 67.8875, 49.0127);
    ctx.bezierCurveTo(68.2876, 49.2894, 68.6569, 49.5969, 69.0262, 49.9044);
    ctx.bezierCurveTo(69.3955, 50.2119, 69.734, 50.5501, 70.0417, 50.9499);
    ctx.bezierCurveTo(69.6416, 50.6731, 69.2724, 50.3964, 68.8723, 50.0889);
    ctx.bezierCurveTo(68.4722, 49.8121, 68.1029, 49.5047, 67.7029, 49.2587);
    ctx.bezierCurveTo(67.3028, 48.9819, 66.9335, 48.7052, 66.5335, 48.4592);
    ctx.bezierCurveTo(66.1334, 48.2132, 65.7333, 47.9672, 65.3025, 47.752);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(65.7329, 51.2578);
    ctx.bezierCurveTo(66.0099, 51.5038, 66.2253, 51.842, 66.3792, 52.1803);
    ctx.bezierCurveTo(66.533, 52.5185, 66.6561, 52.8568, 66.7792, 53.2257);
    ctx.bezierCurveTo(66.8716, 53.5947, 66.9639, 53.933, 67.0254, 54.302);
    ctx.bezierCurveTo(67.087, 54.671, 67.1177, 55.0399, 67.087, 55.4089);
    ctx.bezierCurveTo(66.9946, 55.0399, 66.9023, 54.7017, 66.81, 54.3327);
    ctx.bezierCurveTo(66.7177, 53.9945, 66.6254, 53.6255, 66.5023, 53.2872);
    ctx.bezierCurveTo(66.4099, 52.949, 66.2868, 52.58, 66.1945, 52.2418);
    ctx.bezierCurveTo(66.0407, 51.9035, 65.9176, 51.5653, 65.7329, 51.2578);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(66.0105, 49.3496);
    ctx.bezierCurveTo(66.5029, 49.5956, 66.9645, 49.9031, 67.3953, 50.2721);
    ctx.bezierCurveTo(67.8262, 50.6411, 68.2262, 51.0101, 68.5955, 51.4405);
    ctx.bezierCurveTo(68.9648, 51.871, 69.3033, 52.3323, 69.5803, 52.7935);
    ctx.bezierCurveTo(69.8573, 53.2855, 70.1035, 53.8082, 70.1958, 54.331);
    ctx.bezierCurveTo(69.9188, 53.839, 69.6111, 53.4085, 69.2726, 52.978);
    ctx.bezierCurveTo(68.934, 52.5475, 68.5955, 52.117, 68.257, 51.7173);
    ctx.bezierCurveTo(67.9185, 51.3175, 67.5492, 50.9178, 67.1799, 50.5181);
    ctx.bezierCurveTo(66.7798, 50.1183, 66.4106, 49.7186, 66.0105, 49.3496);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(29.8511, 46.491);
    ctx.bezierCurveTo(30.2819, 46.2757, 30.7743, 46.245, 31.2359, 46.2757);
    ctx.bezierCurveTo(31.6975, 46.3065, 32.1591, 46.3987, 32.6207, 46.5217);
    ctx.bezierCurveTo(33.0516, 46.6447, 33.5132, 46.7985, 33.9133, 46.983);
    ctx.bezierCurveTo(34.3441, 47.1674, 34.7442, 47.3519, 35.1442, 47.5979);
    ctx.bezierCurveTo(34.7134, 47.4749, 34.2518, 47.3519, 33.8209, 47.1982);
    ctx.bezierCurveTo(33.3901, 47.0752, 32.9593, 46.9215, 32.5284, 46.8292);
    ctx.bezierCurveTo(32.0976, 46.7062, 31.6667, 46.614, 31.2051, 46.5525);
    ctx.bezierCurveTo(30.7743, 46.4295, 30.3127, 46.3987, 29.8511, 46.491);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(35.2671, 56.6082);
    ctx.bezierCurveTo(35.6364, 56.4544, 36.0057, 56.3314, 36.375, 56.2392);
    ctx.bezierCurveTo(36.7442, 56.1469, 37.1135, 56.1162, 37.4828, 56.0854);
    ctx.bezierCurveTo(37.8521, 56.0547, 38.2214, 56.0547, 38.5907, 56.0547);
    ctx.bezierCurveTo(38.96, 56.0547, 39.3293, 56.0854, 39.6986, 56.1469);
    ctx.bezierCurveTo(39.3293, 56.1469, 38.96, 56.2084, 38.6215, 56.2392);
    ctx.bezierCurveTo(38.2522, 56.3007, 37.9137, 56.3622, 37.5444, 56.4237);
    ctx.bezierCurveTo(37.2059, 56.5159, 36.8673, 56.6082, 36.5288, 56.7312);
    ctx.bezierCurveTo(36.2211, 56.8542, 35.9133, 57.0079, 35.6364, 57.2232);
    ctx.lineTo(35.2671, 56.6082);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(37.1445, 54.8863);
    ctx.bezierCurveTo(37.4215, 54.7633, 37.7292, 54.7018, 38.0062, 54.7018);
    ctx.bezierCurveTo(38.3139, 54.6711, 38.5909, 54.6711, 38.8987, 54.7326);
    ctx.bezierCurveTo(39.2064, 54.7633, 39.4834, 54.8556, 39.7603, 54.9478);
    ctx.bezierCurveTo(40.0373, 55.0401, 40.3143, 55.1631, 40.5605, 55.3476);
    ctx.lineTo(39.6988, 55.1938);
    ctx.bezierCurveTo(39.4218, 55.1323, 39.1448, 55.1016, 38.8371, 55.0708);
    ctx.bezierCurveTo(38.5601, 55.0401, 38.2832, 55.0093, 37.9754, 54.9786);
    ctx.bezierCurveTo(37.7292, 54.8863, 37.4215, 54.9171, 37.1445, 54.8863);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(39.0522, 52.6719);
    ctx.bezierCurveTo(39.6985, 52.6719, 40.314, 52.9179, 40.8679, 53.2561);
    ctx.bezierCurveTo(41.4219, 53.5943, 41.9142, 53.9941, 42.3143, 54.4861);
    ctx.bezierCurveTo(41.8219, 54.0863, 41.3295, 53.7173, 40.8064, 53.3791);
    ctx.bezierCurveTo(40.5294, 53.2254, 40.2524, 53.0716, 39.9755, 52.9486);
    ctx.bezierCurveTo(39.6677, 52.8564, 39.36, 52.7334, 39.0522, 52.6719);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(76.0242, 28.6293);
    ctx.lineTo(52.8894, 12.5352);
    ctx.lineTo(50.2166, 16.371);
    ctx.lineTo(73.3514, 32.4651);
    ctx.lineTo(76.0242, 28.6293);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(36.3748, 38.0352);
    ctx.bezierCurveTo(36.1286, 38.4349, 35.8824, 38.8346, 35.6362, 39.2036);
    ctx.bezierCurveTo(35.39, 39.6034, 35.1131, 39.9723, 34.8669, 40.3413);
    ctx.bezierCurveTo(34.5899, 40.7103, 34.3437, 41.1101, 34.0667, 41.479);
    ctx.lineTo(33.6667, 42.0325);
    ctx.bezierCurveTo(33.5128, 42.217, 33.3897, 42.4015, 33.2358, 42.586);
    ctx.bezierCurveTo(33.3589, 42.4015, 33.482, 42.1863, 33.6051, 42.0018);
    ctx.lineTo(33.9744, 41.4176);
    ctx.bezierCurveTo(34.2206, 41.0178, 34.4976, 40.6488, 34.7438, 40.2798);
    ctx.bezierCurveTo(35.0207, 39.9108, 35.2669, 39.5111, 35.5439, 39.1421);
    ctx.bezierCurveTo(35.8209, 38.7731, 36.0978, 38.4041, 36.3748, 38.0352);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(59.64, 7.99449);
    ctx.bezierCurveTo(59.2707, 8.30198, 58.9322, 8.67097, 58.5937, 9.03996);
    ctx.bezierCurveTo(58.2552, 9.40894, 57.9474, 9.80868, 57.6089, 10.1777);
    ctx.bezierCurveTo(56.9626, 10.9464, 56.3472, 11.7459, 55.7625, 12.5761);
    ctx.bezierCurveTo(56.3164, 11.7151, 56.8703, 10.8849, 57.455, 10.0547);
    ctx.bezierCurveTo(57.732, 9.62419, 58.0397, 9.22445, 58.3475, 8.82471);
    ctx.bezierCurveTo(58.6552, 8.42498, 58.963, 8.02524, 59.363, 7.65625);
    ctx.lineTo(59.64, 7.99449);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(30.2815, 47.2601);
    ctx.bezierCurveTo(30.9278, 47.1371, 31.574, 47.2294, 32.1895, 47.3831);
    ctx.bezierCurveTo(32.4972, 47.4754, 32.805, 47.5676, 33.0819, 47.6906);
    ctx.bezierCurveTo(33.3589, 47.8136, 33.6666, 47.9673, 33.9128, 48.1518);
    ctx.bezierCurveTo(33.6051, 48.0903, 33.2974, 47.9673, 32.9896, 47.8751);
    ctx.bezierCurveTo(32.6819, 47.7829, 32.4049, 47.6599, 32.0972, 47.5676);
    ctx.bezierCurveTo(31.5432, 47.4139, 30.9278, 47.2909, 30.2815, 47.2601);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(59.3323, 9.53125);
    ctx.bezierCurveTo(59.6092, 9.6235, 59.8862, 9.83874, 60.0709, 10.1155);
    ctx.bezierCurveTo(60.2555, 10.3922, 60.3478, 10.6997, 60.3786, 11.0072);
    ctx.bezierCurveTo(60.4094, 11.3147, 60.4094, 11.6222, 60.3478, 11.9297);
    ctx.bezierCurveTo(60.317, 12.2372, 60.2247, 12.5139, 60.1324, 12.8214);
    ctx.bezierCurveTo(60.1016, 12.5139, 60.1016, 12.2064, 60.1016, 11.9297);
    ctx.bezierCurveTo(60.1016, 11.6222, 60.1016, 11.3454, 60.0709, 11.0687);
    ctx.bezierCurveTo(60.0401, 10.792, 59.9785, 10.5152, 59.8554, 10.2385);
    ctx.bezierCurveTo(59.7631, 9.96174, 59.5785, 9.74649, 59.3323, 9.53125);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(62.0099, 9.31641);
    ctx.bezierCurveTo(61.9791, 9.59315, 61.9176, 9.80839, 61.856, 10.0544);
    ctx.bezierCurveTo(61.7945, 10.3004, 61.7329, 10.5464, 61.6714, 10.7616);
    ctx.bezierCurveTo(61.5175, 11.2228, 61.3329, 11.6841, 61.1174, 12.1146);
    ctx.bezierCurveTo(61.2098, 11.6533, 61.2713, 11.1613, 61.3021, 10.7001);
    ctx.bezierCurveTo(61.3021, 10.4541, 61.3021, 10.2389, 61.3021, 9.99289);
    ctx.bezierCurveTo(61.3021, 9.77764, 61.2713, 9.53165, 61.2405, 9.31641);
    ctx.lineTo(62.0099, 9.31641);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(69.9185, 14.9731);
    ctx.bezierCurveTo(69.7954, 15.2805, 69.6723, 15.5573, 69.5184, 15.834);
    ctx.bezierCurveTo(69.3645, 16.1108, 69.2414, 16.3875, 69.0876, 16.6335);
    ctx.bezierCurveTo(68.7798, 17.1562, 68.4413, 17.679, 68.1028, 18.171);
    ctx.bezierCurveTo(68.349, 17.6175, 68.5644, 17.064, 68.749, 16.4798);
    ctx.bezierCurveTo(68.8414, 16.203, 68.9337, 15.8955, 68.9952, 15.6188);
    ctx.bezierCurveTo(69.0568, 15.342, 69.1491, 15.0346, 69.1799, 14.7578);
    ctx.lineTo(69.9185, 14.9731);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(76.012, 19.2475);
    ctx.bezierCurveTo(75.9197, 19.6165, 75.7966, 19.9548, 75.6735, 20.293);
    ctx.bezierCurveTo(75.5504, 20.6313, 75.3966, 20.9695, 75.2119, 21.277);
    ctx.bezierCurveTo(75.335, 20.9387, 75.4581, 20.6005, 75.5197, 20.2623);
    ctx.bezierCurveTo(75.612, 19.924, 75.6735, 19.555, 75.7043, 19.2168);
    ctx.lineTo(76.012, 19.2475);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(66.6872, 12.9756);
    ctx.lineTo(65.7332, 15.8352);
    ctx.lineTo(66.4102, 12.9141);
    ctx.lineTo(66.6872, 12.9756);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(58.5018, 20.9701);
    ctx.lineTo(58.0094, 20.6012);
    ctx.lineTo(56.5322, 19.6172);
    ctx.lineTo(56.286, 20.5704);
    ctx.lineTo(56.5938, 22.2309);
    ctx.lineTo(52.8086, 27.6427);
    ctx.lineTo(50.7159, 28.5652);
    ctx.lineTo(48.6541, 30.5023);
    ctx.lineTo(51.116, 31.5786);
    ctx.lineTo(52.5624, 30.5946);
    ctx.lineTo(58.1325, 22.8151);
    ctx.lineTo(59.7943, 23.0303);
    ctx.lineTo(60.5021, 22.3846);
    ctx.lineTo(58.5018, 20.9701);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(70.7491, 15.834);
    ctx.lineTo(70.7799, 18.2017);
    ctx.lineTo(66.8408, 23.8595);
    ctx.lineTo(67.5486, 24.3515);
    ctx.lineTo(72.3494, 17.4637);
    ctx.bezierCurveTo(72.3494, 17.4944, 71.2723, 16.2952, 70.7491, 15.834);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(64.6559, 12.1442);
    ctx.bezierCurveTo(64.6559, 12.1442, 63.4865, 10.7297, 62.5633, 10.084);
    ctx.bezierCurveTo(62.6556, 10.1762, 62.5017, 10.5145, 62.5633, 10.576);
    ctx.bezierCurveTo(63.4557, 11.4677, 63.3634, 12.2057, 63.1172, 12.5439);
    ctx.lineTo(59.4243, 17.8635);
    ctx.lineTo(60.2552, 18.4477);
    ctx.lineTo(60.1629, 18.5707);
    ctx.lineTo(60.9322, 19.0934);
    ctx.lineTo(65.5176, 12.5132);
    ctx.lineTo(64.6559, 12.1442);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(78.2279, 21.0311);
    ctx.bezierCurveTo(77.3662, 22.4456, 76.5045, 23.86, 75.6121, 25.2745);
    ctx.bezierCurveTo(75.1505, 25.9817, 74.7196, 26.6889, 74.258, 27.3654);
    ctx.bezierCurveTo(74.0426, 27.7036, 73.7964, 28.0726, 73.581, 28.4109);
    ctx.lineTo(72.8732, 29.4256);
    ctx.bezierCurveTo(71.95, 30.8093, 70.996, 32.1622, 70.042, 33.5152);
    ctx.bezierCurveTo(69.088, 34.8682, 68.134, 36.2519, 67.18, 37.5741);
    ctx.bezierCurveTo(65.272, 40.28, 63.3332, 42.9859, 61.3944, 45.6918);
    ctx.bezierCurveTo(59.4557, 48.3977, 57.5785, 51.1037, 55.5474, 53.7481);
    ctx.bezierCurveTo(57.3015, 50.9192, 59.1787, 48.1825, 60.9944, 45.4151);
    ctx.bezierCurveTo(62.8408, 42.6477, 64.6565, 39.8803, 66.503, 37.1128);
    ctx.bezierCurveTo(67.4262, 35.7291, 68.3494, 34.3454, 69.2726, 32.9925);
    ctx.bezierCurveTo(70.1958, 31.6088, 71.1191, 30.2558, 72.0731, 28.8721);
    ctx.bezierCurveTo(72.5347, 28.1956, 73.0271, 27.5191, 73.4887, 26.8119);
    ctx.bezierCurveTo(73.9503, 26.1354, 74.4119, 25.4282, 74.8735, 24.7517);
    ctx.bezierCurveTo(75.7967, 23.368, 76.7507, 22.0151, 77.7355, 20.6621);
    ctx.lineTo(78.2279, 21.0311);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(18.4028, 62.0198);
    ctx.bezierCurveTo(18.4028, 62.0198, 19.603, 61.9583, 22.3419, 63.8647);
    ctx.bezierCurveTo(25.1116, 65.7711, 26.1271, 67.3701, 26.1271, 67.3701);
    ctx.bezierCurveTo(26.1271, 67.3701, 21.3879, 66.1401, 18.4028, 62.0198);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(26.0964, 67.3694);
    ctx.bezierCurveTo(26.0964, 67.3694, 27.2966, 67.3079, 30.0355, 69.2143);
    ctx.bezierCurveTo(32.8052, 71.1207, 33.8207, 72.7197, 33.8207, 72.7197);
    ctx.bezierCurveTo(33.8207, 72.7197, 29.0815, 71.4897, 26.0964, 67.3694);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(33.821, 72.7502);
    ctx.bezierCurveTo(33.821, 72.7502, 35.0212, 72.6887, 37.7601, 74.5952);
    ctx.bezierCurveTo(40.5298, 76.5016, 41.5453, 78.1006, 41.5453, 78.1006);
    ctx.bezierCurveTo(41.5453, 78.1006, 36.8061, 76.8706, 33.821, 72.7502);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(20.28, 62.9116);
    ctx.bezierCurveTo(20.7109, 62.7271, 21.1109, 62.6964, 21.511, 62.6656);
    ctx.bezierCurveTo(21.9111, 62.6349, 22.3111, 62.6349, 22.6804, 62.6656);
    ctx.bezierCurveTo(23.0805, 62.6964, 23.4498, 62.7271, 23.8498, 62.7886);
    ctx.bezierCurveTo(24.2191, 62.8501, 24.6192, 62.9116, 24.9885, 62.9731);
    ctx.bezierCurveTo(24.6192, 62.9424, 24.2191, 62.9424, 23.8498, 62.9731);
    ctx.bezierCurveTo(23.4805, 62.9731, 23.0805, 63.0039, 22.7112, 63.0346);
    ctx.bezierCurveTo(22.3419, 63.0654, 21.9726, 63.1269, 21.6033, 63.2191);
    ctx.bezierCurveTo(21.234, 63.3114, 20.8955, 63.4036, 20.6185, 63.5881);
    ctx.lineTo(20.28, 62.9116);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(21.696, 61.3746);
    ctx.bezierCurveTo(22.0961, 61.2208, 22.5269, 61.1286, 22.9886, 61.0671);
    ctx.bezierCurveTo(23.4194, 61.0363, 23.881, 61.0363, 24.3118, 61.0978);
    ctx.bezierCurveTo(24.7427, 61.1593, 25.1735, 61.2516, 25.6044, 61.3746);
    ctx.bezierCurveTo(26.0352, 61.4976, 26.4353, 61.6513, 26.8353, 61.8358);
    ctx.bezierCurveTo(26.4045, 61.7743, 25.9736, 61.6821, 25.5428, 61.5898);
    ctx.bezierCurveTo(25.112, 61.4976, 24.7119, 61.4361, 24.2811, 61.3746);
    ctx.bezierCurveTo(23.8502, 61.3131, 23.4502, 61.2823, 23.0193, 61.2823);
    ctx.bezierCurveTo(22.5577, 61.3131, 22.1269, 61.3438, 21.696, 61.3746);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(26.804, 67.8625);
    ctx.bezierCurveTo(27.0501, 67.4627, 27.2963, 67.0937, 27.5733, 66.7247);
    ctx.bezierCurveTo(27.8503, 66.3558, 28.1272, 65.9868, 28.4042, 65.6485);
    ctx.bezierCurveTo(28.6812, 65.2795, 28.9581, 64.9106, 29.2659, 64.5723);
    ctx.bezierCurveTo(29.5429, 64.2033, 29.8506, 63.8651, 30.1276, 63.4961);
    ctx.bezierCurveTo(29.8814, 63.8958, 29.6659, 64.2956, 29.4198, 64.6646);
    ctx.bezierCurveTo(29.1736, 65.0643, 28.9274, 65.4333, 28.7119, 65.833);
    ctx.bezierCurveTo(28.4658, 66.2328, 28.2196, 66.6017, 27.9734, 67.0015);
    ctx.bezierCurveTo(27.7272, 67.3705, 27.4502, 67.7702, 27.1732, 68.1392);
    ctx.lineTo(26.804, 67.8625);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(30.0354, 66.7857);
    ctx.bezierCurveTo(30.3124, 66.5705, 30.6509, 66.386, 30.9894, 66.2322);
    ctx.bezierCurveTo(31.3279, 66.0785, 31.6664, 65.9862, 32.0049, 65.894);
    ctx.bezierCurveTo(32.3435, 65.8017, 32.7127, 65.7403, 33.082, 65.7095);
    ctx.bezierCurveTo(33.4513, 65.6788, 33.7898, 65.648, 34.1591, 65.6788);
    ctx.bezierCurveTo(33.8206, 65.771, 33.4513, 65.8632, 33.1128, 65.9555);
    ctx.lineTo(32.0665, 66.2015);
    ctx.bezierCurveTo(31.728, 66.2937, 31.3895, 66.386, 31.0509, 66.4782);
    ctx.bezierCurveTo(30.7432, 66.5705, 30.4047, 66.6627, 30.0354, 66.7857);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(28.6194, 68.8145);
    ctx.bezierCurveTo(29.3272, 68.4148, 30.0658, 68.015, 30.7736, 67.646);
    ctx.bezierCurveTo(31.5122, 67.277, 32.22, 66.9081, 32.9585, 66.5391);
    ctx.bezierCurveTo(32.2815, 66.9695, 31.6045, 67.4308, 30.9274, 67.892);
    ctx.bezierCurveTo(30.2504, 68.3533, 29.6042, 68.8145, 28.9579, 69.3065);
    ctx.lineTo(28.6194, 68.8145);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(38.1292, 70.1058);
    ctx.bezierCurveTo(38.3138, 70.0443, 38.4984, 70.0136, 38.6831, 69.9521);
    ctx.bezierCurveTo(38.8677, 69.9213, 39.0524, 69.8906, 39.2678, 69.8598);
    ctx.bezierCurveTo(39.6679, 69.7983, 40.0371, 69.7676, 40.4372, 69.7676);
    ctx.bezierCurveTo(40.8373, 69.7676, 41.2066, 69.7983, 41.6066, 69.8598);
    ctx.bezierCurveTo(41.7913, 69.8906, 42.0067, 69.9213, 42.1913, 69.9521);
    ctx.bezierCurveTo(42.376, 69.9828, 42.5606, 70.0443, 42.7453, 70.1058);
    ctx.bezierCurveTo(42.376, 70.0443, 41.9759, 69.9828, 41.6066, 69.9828);
    ctx.bezierCurveTo(41.2066, 69.9521, 40.8373, 69.9213, 40.4372, 69.9521);
    ctx.bezierCurveTo(40.0371, 69.9521, 39.6679, 69.9521, 39.2678, 69.9828);
    ctx.bezierCurveTo(38.8985, 70.0136, 38.5292, 70.0751, 38.1292, 70.1058);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(36.7444, 71.7665);
    ctx.bezierCurveTo(37.1752, 71.5512, 37.6368, 71.4282, 38.0984, 71.3052);
    ctx.bezierCurveTo(38.5601, 71.213, 39.0524, 71.1515, 39.5141, 71.1207);
    ctx.bezierCurveTo(39.9757, 71.09, 40.4681, 71.09, 40.9297, 71.1207);
    ctx.bezierCurveTo(41.3913, 71.1515, 41.8837, 71.213, 42.3453, 71.3052);
    ctx.bezierCurveTo(41.8837, 71.336, 41.3913, 71.336, 40.9297, 71.3667);
    ctx.bezierCurveTo(40.6835, 71.3667, 40.4681, 71.3667, 40.2219, 71.3975);
    ctx.bezierCurveTo(39.9757, 71.3975, 39.7602, 71.4282, 39.5141, 71.4282);
    ctx.bezierCurveTo(39.2679, 71.4282, 39.0524, 71.459, 38.8063, 71.459);
    ctx.bezierCurveTo(38.6832, 71.459, 38.5601, 71.459, 38.4677, 71.4897);
    ctx.bezierCurveTo(38.3446, 71.4897, 38.2215, 71.5205, 38.1292, 71.5205);
    ctx.bezierCurveTo(37.6984, 71.6127, 37.2368, 71.6742, 36.7444, 71.7665);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(35.6365, 73.7663);
    ctx.bezierCurveTo(35.9442, 73.4588, 36.3135, 73.2128, 36.7136, 73.0283);
    ctx.bezierCurveTo(37.0829, 72.8438, 37.4829, 72.6901, 37.883, 72.5364);
    ctx.bezierCurveTo(38.283, 72.3826, 38.6831, 72.2904, 39.0832, 72.1674);
    ctx.bezierCurveTo(39.4832, 72.0751, 39.8833, 71.9829, 40.3141, 71.8906);
    ctx.bezierCurveTo(39.9141, 72.0136, 39.5448, 72.1674, 39.1447, 72.3211);
    ctx.bezierCurveTo(38.7754, 72.4749, 38.3754, 72.6286, 38.0061, 72.8131);
    ctx.bezierCurveTo(37.6368, 72.9976, 37.2675, 73.1821, 36.929, 73.3973);
    ctx.bezierCurveTo(36.5905, 73.6126, 36.252, 73.8278, 35.9442, 74.0738);
    ctx.lineTo(35.6365, 73.7663);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(40.1913, 63.6192);
    ctx.lineTo(39.3912, 63.0657);
    ctx.lineTo(36.8985, 61.3438);
    ctx.lineTo(36.1907, 62.3277);
    ctx.bezierCurveTo(37.1447, 62.9734, 37.8217, 64.3264, 37.9448, 64.9414);
    ctx.lineTo(33.975, 70.7222);
    ctx.lineTo(32.467, 71.6139);
    ctx.lineTo(33.8519, 72.7516);
    ctx.lineTo(38.8373, 65.5871);
    ctx.lineTo(38.8373, 65.6179);
    ctx.bezierCurveTo(39.145, 65.1874, 40.5914, 65.3719, 41.9147, 66.2943);
    ctx.lineTo(42.6225, 65.3104);
    ctx.lineTo(40.1913, 63.6192);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(33.4823, 60.4502);
    ctx.bezierCurveTo(32.836, 59.989, 31.5127, 59.6507, 31.0511, 60.358);
    ctx.lineTo(26.1273, 67.3995);
    ctx.lineTo(24.7732, 66.4463);
    ctx.lineTo(26.1888, 65.616);
    ctx.lineTo(30.1279, 59.9582);
    ctx.bezierCurveTo(30.1279, 59.9582, 30.4972, 58.759, 29.3893, 57.5905);
    ctx.bezierCurveTo(28.3122, 56.4221, 30.651, 56.7603, 30.651, 56.7603);
    ctx.lineTo(33.9131, 59.497);
    ctx.lineTo(33.4823, 60.4502);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(64.2568, 33.7613);
    ctx.bezierCurveTo(64.4415, 33.6691, 64.6261, 33.6076, 64.8108, 33.5153);
    ctx.bezierCurveTo(64.9954, 33.4538, 65.1801, 33.3616, 65.3647, 33.3001);
    ctx.bezierCurveTo(65.734, 33.1771, 66.1341, 33.0541, 66.5034, 32.9618);
    ctx.bezierCurveTo(66.9034, 32.8696, 67.2727, 32.8081, 67.6728, 32.7773);
    ctx.bezierCurveTo(67.8882, 32.7773, 68.0728, 32.7466, 68.2882, 32.7773);
    ctx.bezierCurveTo(68.4729, 32.8081, 68.6883, 32.8388, 68.873, 32.9618);
    ctx.bezierCurveTo(68.6883, 32.8696, 68.5037, 32.8696, 68.2882, 32.8696);
    ctx.bezierCurveTo(68.1036, 32.8696, 67.8882, 32.8696, 67.7035, 32.9003);
    ctx.bezierCurveTo(67.3035, 32.9618, 66.9342, 33.0233, 66.5341, 33.1156);
    ctx.bezierCurveTo(66.1648, 33.2078, 65.7648, 33.3001, 65.3955, 33.4231);
    ctx.lineTo(64.2568, 33.7613);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(66.041, 34.9292);
    ctx.bezierCurveTo(66.4103, 34.8984, 66.7796, 34.8984, 67.1489, 34.8984);
    ctx.bezierCurveTo(67.5182, 34.8984, 67.8875, 34.9292, 68.2568, 34.9292);
    ctx.bezierCurveTo(68.626, 34.9599, 68.9953, 34.9907, 69.3646, 35.0522);
    ctx.bezierCurveTo(69.7339, 35.1137, 70.1032, 35.1752, 70.4725, 35.3289);
    ctx.bezierCurveTo(70.1032, 35.3597, 69.7339, 35.3904, 69.3646, 35.3904);
    ctx.bezierCurveTo(68.9953, 35.3904, 68.626, 35.3904, 68.2568, 35.3597);
    ctx.bezierCurveTo(67.8875, 35.3289, 67.5182, 35.2982, 67.1489, 35.2059);
    ctx.bezierCurveTo(66.7488, 35.2059, 66.4103, 35.0829, 66.041, 34.9292);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(65.9792, 34.8383);
    ctx.bezierCurveTo(66.3485, 34.7768, 66.7486, 34.7461, 67.1179, 34.7461);
    ctx.bezierCurveTo(67.4872, 34.7461, 67.8872, 34.7461, 68.2565, 34.7768);
    ctx.bezierCurveTo(68.6258, 34.8076, 69.0259, 34.8691, 69.3952, 34.9613);
    ctx.bezierCurveTo(69.7645, 35.0536, 70.1338, 35.1766, 70.4723, 35.3611);
    ctx.bezierCurveTo(70.103, 35.2996, 69.7337, 35.2381, 69.3644, 35.1766);
    ctx.bezierCurveTo(68.9951, 35.1458, 68.6258, 35.0843, 68.2565, 35.0536);
    ctx.lineTo(67.1179, 34.9306);
    ctx.bezierCurveTo(66.7486, 34.9306, 66.3485, 34.8998, 65.9792, 34.8383);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(66.1639, 41.2324);
    ctx.bezierCurveTo(65.7639, 41.8474, 65.3638, 42.4624, 64.933, 43.0774);
    ctx.bezierCurveTo(64.5329, 43.6923, 64.1021, 44.3073, 63.6712, 44.8916);
    ctx.bezierCurveTo(63.2404, 45.5065, 62.8095, 46.0908, 62.3787, 46.7057);
    ctx.lineTo(61.7324, 47.5975);
    ctx.bezierCurveTo(61.517, 47.905, 61.3016, 48.1817, 61.0554, 48.4892);
    ctx.bezierCurveTo(61.2401, 48.1817, 61.4555, 47.8742, 61.6709, 47.5667);
    ctx.lineTo(62.2864, 46.6443);
    ctx.bezierCurveTo(62.6864, 46.0293, 63.1173, 45.4143, 63.5481, 44.8301);
    ctx.bezierCurveTo(63.979, 44.2151, 64.4098, 43.6308, 64.8406, 43.0159);
    ctx.bezierCurveTo(65.2715, 42.4009, 65.7023, 41.8167, 66.1639, 41.2324);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(74.1963, 28.2871);
    ctx.lineTo(74.6887, 29.3326);
    ctx.lineTo(72.9961, 31.9155);
    ctx.lineTo(74.1963, 28.2871);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(73.6421, 29.0566);
    ctx.bezierCurveTo(73.4882, 29.4871, 73.3036, 29.8561, 73.0882, 30.2559);
    ctx.bezierCurveTo(72.8727, 30.6556, 72.6573, 31.0246, 72.4111, 31.3936);
    ctx.bezierCurveTo(72.565, 30.9631, 72.7496, 30.5941, 72.9651, 30.1944);
    ctx.bezierCurveTo(73.1497, 29.8254, 73.3651, 29.4256, 73.6421, 29.0566);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(65.8572, 27.9815);
    ctx.lineTo(59.2642, 36.7246);
    ctx.lineTo(59.51, 36.9097);
    ctx.lineTo(66.103, 28.1666);
    ctx.lineTo(65.8572, 27.9815);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(66.441, 25.9514);
    ctx.lineTo(62.1634, 22.9688);
    ctx.lineTo(61.9479, 24.537);
    ctx.bezierCurveTo(63.4251, 25.5517, 64.1021, 27.3044, 63.9483, 27.8578);
    ctx.lineTo(40.8677, 60.9746);
    ctx.lineTo(41.637, 61.4973);
    ctx.lineTo(64.7484, 28.3191);
    ctx.lineTo(67.0257, 28.5036);
    ctx.lineTo(70.9955, 31.271);
    ctx.lineTo(71.7957, 30.1333);
    ctx.lineTo(66.441, 25.9514);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(45.761, 54.9472);
    ctx.bezierCurveTo(47.115, 53.6865, 49.0846, 53.4713, 51.1156, 53.0716);
    ctx.bezierCurveTo(53.1467, 52.6718, 56.5011, 50.2734, 58.4707, 47.5367);
    ctx.bezierCurveTo(60.4402, 44.8001, 60.5633, 41.3562, 60.4094, 39.9725);
    ctx.lineTo(60.1017, 41.6022);
    ctx.bezierCurveTo(60.1017, 41.6022, 59.9478, 44.5541, 58.4399, 46.6143);
    ctx.bezierCurveTo(56.932, 48.7052, 54.0084, 51.7186, 49.6693, 51.7801);
    ctx.bezierCurveTo(45.3301, 51.8416, 43.0528, 50.0274, 43.0528, 50.0274);
    ctx.bezierCurveTo(43.0528, 50.0274, 33.9745, 44.0313, 40.0062, 34.4069);
    ctx.lineTo(38.8676, 33.6074);
    ctx.lineTo(36.221, 39.0807);
    ctx.bezierCurveTo(36.221, 39.0807, 38.2213, 46.1223, 38.3752, 48.1517);
    ctx.lineTo(33.1128, 55.716);
    ctx.lineTo(33.8514, 56.3002);
    ctx.lineTo(38.5598, 49.5354);
    ctx.bezierCurveTo(38.5598, 49.5354, 40.3139, 48.7974, 42.8066, 50.7346);
    ctx.bezierCurveTo(45.2993, 52.6718, 45.761, 54.9472, 45.761, 54.9472);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(51.7923, 16.4794);
    ctx.bezierCurveTo(50.9922, 17.6786, 50.1613, 18.8471, 49.3612, 20.0156);
    ctx.bezierCurveTo(48.5611, 21.184, 47.6994, 22.3525, 46.8992, 23.5209);
    ctx.bezierCurveTo(46.0683, 24.6894, 45.2374, 25.8579, 44.4065, 27.0263);
    ctx.bezierCurveTo(43.5756, 28.1948, 42.714, 29.3325, 41.8523, 30.501);
    ctx.bezierCurveTo(42.6216, 29.3018, 43.4218, 28.1025, 44.2219, 26.9033);
    ctx.bezierCurveTo(45.022, 25.7041, 45.8222, 24.5357, 46.6531, 23.3364);
    ctx.bezierCurveTo(47.4532, 22.168, 48.2841, 20.9688, 49.115, 19.8003);
    ctx.bezierCurveTo(49.9459, 18.6318, 50.746, 17.4634, 51.6077, 16.2949);
    ctx.lineTo(51.7923, 16.4794);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(49.8848, 19.4316);
    ctx.lineTo(51.8543, 19.5854);
    ctx.lineTo(49.854, 19.7391);
    ctx.lineTo(49.8848, 19.4316);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(52.8696, 12.9433);
    ctx.lineTo(51.7925, 12.6973);
    ctx.lineTo(49.2998, 16.3257);
    ctx.lineTo(49.3306, 17.4941);
    ctx.lineTo(49.6999, 17.7401);
    ctx.lineTo(52.8696, 12.9433);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(26.9274, 49.8115);
    ctx.lineTo(25.8503, 49.75);
    ctx.lineTo(22.896, 53.9626);
    ctx.lineTo(22.896, 55.5923);
    ctx.lineTo(24.0654, 53.9011);
    ctx.lineTo(47.2075, 69.9829);
    ctx.lineTo(50.0695, 65.8932);
    ctx.lineTo(26.9274, 49.8115);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(25.8194, 50.4878);
    ctx.lineTo(26.8042, 50.457);
    ctx.lineTo(24.4961, 53.0707);
    ctx.lineTo(25.8194, 50.4878);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(31.7284, 37.6678);
    ctx.lineTo(29.8512, 36.5608);
    ctx.bezierCurveTo(29.5435, 36.3763, 29.2357, 36.1918, 28.928, 36.0073);
    ctx.bezierCurveTo(28.6202, 35.8229, 28.3125, 35.6384, 27.974, 35.4846);
    ctx.lineTo(27.5124, 35.2386);
    ctx.lineTo(27.02, 34.9926);
    ctx.lineTo(26.5584, 34.7466);
    ctx.bezierCurveTo(26.4045, 34.6544, 26.2506, 34.5929, 26.066, 34.5006);
    ctx.bezierCurveTo(25.4197, 34.1932, 24.7735, 33.8857, 24.0657, 33.7012);
    ctx.bezierCurveTo(24.8043, 33.7319, 25.5121, 33.9164, 26.2199, 34.1932);
    ctx.bezierCurveTo(26.4045, 34.2547, 26.5584, 34.3162, 26.743, 34.4084);
    ctx.lineTo(27.2354, 34.6236);
    ctx.bezierCurveTo(27.5739, 34.7774, 27.8817, 34.9619, 28.2202, 35.1156);
    ctx.bezierCurveTo(28.5279, 35.3001, 28.8664, 35.4846, 29.1742, 35.6691);
    ctx.bezierCurveTo(29.328, 35.7614, 29.4819, 35.8536, 29.6358, 35.9766);
    ctx.bezierCurveTo(29.7897, 36.0688, 29.9435, 36.1918, 30.0974, 36.2841);
    ctx.bezierCurveTo(30.6513, 36.7146, 31.2053, 37.1758, 31.7284, 37.6678);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(22.3115, 35.3928);
    ctx.bezierCurveTo(22.927, 35.362, 23.5425, 35.4235, 24.1272, 35.5158);
    ctx.bezierCurveTo(24.7119, 35.608, 25.3274, 35.7618, 25.8813, 35.9462);
    ctx.bezierCurveTo(26.466, 36.1307, 27.02, 36.346, 27.5739, 36.592);
    ctx.bezierCurveTo(28.1278, 36.838, 28.6818, 37.1147, 29.1741, 37.4529);
    ctx.bezierCurveTo(28.6202, 37.2377, 28.0355, 37.0225, 27.4816, 36.8072);
    ctx.bezierCurveTo(26.9276, 36.592, 26.3429, 36.4075, 25.789, 36.223);
    ctx.bezierCurveTo(25.2043, 36.0385, 24.6504, 35.8847, 24.0656, 35.731);
    ctx.bezierCurveTo(23.4809, 35.608, 22.8962, 35.485, 22.3115, 35.3928);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(26.6816, 29.9193);
    ctx.bezierCurveTo(27.0509, 29.8271, 27.4818, 29.8271, 27.8511, 29.8886);
    ctx.bezierCurveTo(28.2511, 29.9501, 28.6204, 30.1038, 28.9589, 30.2576);
    ctx.bezierCurveTo(29.2974, 30.442, 29.636, 30.6265, 29.9437, 30.8725);
    ctx.bezierCurveTo(30.2514, 31.1185, 30.5592, 31.3645, 30.8054, 31.6413);
    ctx.bezierCurveTo(30.4669, 31.4568, 30.1283, 31.2415, 29.8206, 31.057);
    ctx.bezierCurveTo(29.4821, 30.8725, 29.1743, 30.688, 28.8358, 30.5343);
    ctx.bezierCurveTo(28.4973, 30.3805, 28.1588, 30.2268, 27.7895, 30.1346);
    ctx.bezierCurveTo(27.451, 30.0116, 27.0817, 29.9501, 26.6816, 29.9193);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#0093F1";

    ctx.beginPath();
    ctx.moveTo(51.0853, 30.2874);
    ctx.bezierCurveTo(52.1009, 27.643, 52.3471, 25.2138, 51.3931, 23.8609);
    ctx.bezierCurveTo(50.4699, 22.5079, 47.0539, 20.294, 42.0993, 22.7539);
    ctx.bezierCurveTo(37.1139, 25.2138, 34.8982, 28.75, 34.3442, 31.0869);
    ctx.bezierCurveTo(33.6364, 34.1618, 36.1599, 38.9894, 38.8988, 43.1098);
    ctx.lineTo(39.2681, 41.2033);
    ctx.bezierCurveTo(39.2681, 41.2033, 34.6827, 34.5615, 35.606, 31.3944);
    ctx.bezierCurveTo(36.5907, 28.0427, 39.3912, 25.4906, 42.3763, 23.8916);
    ctx.bezierCurveTo(45.1152, 22.4157, 49.0542, 22.5386, 50.4083, 24.5373);
    ctx.bezierCurveTo(51.7624, 26.536, 49.6697, 30.5641, 49.6697, 30.5641);
    ctx.lineTo(51.0853, 30.2874);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(39.0219, 43.6939);
    ctx.lineTo(38.7141, 43.2327);
    ctx.bezierCurveTo(35.052, 37.7286, 33.5133, 33.639, 34.1288, 31.0253);
    ctx.bezierCurveTo(34.7135, 28.5039, 37.1139, 24.937, 42.007, 22.5386);
    ctx.bezierCurveTo(46.777, 20.2017, 50.4083, 22.0158, 51.6085, 23.7378);
    ctx.bezierCurveTo(52.5317, 25.0907, 52.4394, 27.4584, 51.3008, 30.3796);
    ctx.lineTo(51.2392, 30.5026);
    ctx.lineTo(49.2697, 30.8408);
    ctx.lineTo(49.4851, 30.4411);
    ctx.bezierCurveTo(49.5159, 30.4103, 51.4854, 26.5052, 50.2237, 24.6603);
    ctx.bezierCurveTo(48.9927, 22.8461, 45.2998, 22.6001, 42.4994, 24.1068);
    ctx.bezierCurveTo(40.499, 25.183, 36.9908, 27.5507, 35.8214, 31.4865);
    ctx.bezierCurveTo(34.9289, 34.5, 39.3912, 41.0187, 39.4527, 41.0802);
    ctx.lineTo(39.5143, 41.1725);
    ctx.lineTo(39.0219, 43.6939);
    ctx.closePath();
    ctx.moveTo(50.1621, 23.0306);
    ctx.bezierCurveTo(48.7157, 22.0158, 45.9461, 21.1241, 42.1916, 22.9691);
    ctx.bezierCurveTo(37.4216, 25.306, 35.1443, 28.7191, 34.5596, 31.1483);
    ctx.bezierCurveTo(34.0057, 33.5467, 35.4213, 37.3596, 38.7757, 42.5254);
    ctx.lineTo(39.0219, 41.2647);
    ctx.bezierCurveTo(38.468, 40.4653, 34.4981, 34.4077, 35.3905, 31.3635);
    ctx.bezierCurveTo(36.5907, 27.2739, 40.2221, 24.814, 42.2839, 23.707);
    ctx.bezierCurveTo(44.9921, 22.2618, 49.1466, 22.2618, 50.6237, 24.4143);
    ctx.bezierCurveTo(51.7931, 26.1362, 50.593, 29.1804, 50.1006, 30.2566);
    ctx.lineTo(50.9315, 30.1336);
    ctx.bezierCurveTo(51.947, 27.4584, 52.0393, 25.2137, 51.2392, 24.0453);
    ctx.bezierCurveTo(51.0238, 23.7378, 50.6853, 23.3688, 50.1621, 23.0306);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(58.1324, 47.0764);
    ctx.bezierCurveTo(54.6242, 52.0885, 47.7308, 53.3184, 42.7146, 49.8438);
    ctx.bezierCurveTo(37.6984, 46.3384, 36.4675, 39.4506, 39.9449, 34.4385);
    ctx.bezierCurveTo(43.4532, 29.4264, 50.3466, 28.1965, 55.3628, 31.6711);
    ctx.bezierCurveTo(60.379, 35.1458, 61.6099, 42.0643, 58.1324, 47.0764);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(42.53, 50.0903);
    ctx.bezierCurveTo(37.3908, 46.5234, 36.0982, 39.4204, 39.6988, 34.2546);
    ctx.bezierCurveTo(43.2686, 29.1195, 50.3774, 27.828, 55.5475, 31.4257);
    ctx.bezierCurveTo(60.6868, 34.9925, 61.9793, 42.0956, 58.3787, 47.2614);
    ctx.bezierCurveTo(54.7781, 52.3965, 47.6693, 53.6572, 42.53, 50.0903);
    ctx.closePath();
    ctx.moveTo(55.1782, 31.9176);
    ctx.bezierCurveTo(50.3159, 28.5353, 43.5764, 29.7345, 40.1912, 34.5928);
    ctx.bezierCurveTo(36.806, 39.4512, 38.0062, 46.1852, 42.8685, 49.5676);
    ctx.bezierCurveTo(47.7309, 52.95, 54.4704, 51.7508, 57.8555, 46.8924);
    ctx.bezierCurveTo(61.2715, 42.0341, 60.0713, 35.3, 55.1782, 31.9176);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(43.6686, 48.429);
    ctx.bezierCurveTo(39.4218, 45.4771, 38.3755, 39.6348, 41.3298, 35.3914);
    ctx.bezierCurveTo(44.2841, 31.1481, 50.1312, 30.1026, 54.378, 33.0545);
    ctx.bezierCurveTo(58.6249, 36.0064, 59.6712, 41.8487, 56.7169, 46.0921);
    ctx.bezierCurveTo(53.7625, 50.3355, 47.9155, 51.3809, 43.6686, 48.429);
    ctx.closePath();
    ctx.moveTo(54.1318, 33.4235);
    ctx.bezierCurveTo(50.1004, 30.6253, 44.5303, 31.6093, 41.7299, 35.6374);
    ctx.bezierCurveTo(38.9294, 39.6655, 39.9142, 45.2311, 43.9456, 48.0293);
    ctx.bezierCurveTo(47.977, 50.8274, 53.5471, 49.8435, 56.3476, 45.8154);
    ctx.bezierCurveTo(59.148, 41.818, 58.1632, 36.2524, 54.1318, 33.4235);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(48.377, 41.6651);
    ctx.bezierCurveTo(47.8539, 41.2961, 47.7308, 40.6196, 48.1001, 40.0969);
    ctx.bezierCurveTo(48.4694, 39.5741, 49.1464, 39.4511, 49.6696, 39.8201);
    ctx.bezierCurveTo(50.1927, 40.1891, 50.3158, 40.8656, 49.9465, 41.3883);
    ctx.bezierCurveTo(49.608, 41.9111, 48.9002, 42.034, 48.377, 41.6651);
    ctx.closePath();
    ctx.moveTo(49.3003, 40.3429);
    ctx.bezierCurveTo(49.0848, 40.1891, 48.7771, 40.2506, 48.6232, 40.4658);
    ctx.bezierCurveTo(48.4694, 40.6811, 48.5309, 40.9886, 48.7463, 41.1423);
    ctx.bezierCurveTo(48.9618, 41.2961, 49.2695, 41.2346, 49.4234, 41.0193);
    ctx.bezierCurveTo(49.5772, 40.8041, 49.5465, 40.4966, 49.3003, 40.3429);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(48.2661, 41.195);
    ctx.lineTo(45.5938, 45.0312);
    ctx.lineTo(46.2252, 45.4704);
    ctx.lineTo(48.8976, 41.6341);
    ctx.lineTo(48.2661, 41.195);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(56.6752, 40.0869);
    ctx.lineTo(49.8174, 40.3516);
    ctx.lineTo(49.8411, 40.9661);
    ctx.lineTo(56.699, 40.7014);
    ctx.lineTo(56.6752, 40.0869);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(45.3303, 47.1388);
    ctx.bezierCurveTo(45.1457, 47.4155, 44.7456, 47.477, 44.4994, 47.2926);
    ctx.bezierCurveTo(44.2224, 47.1081, 44.1609, 46.7083, 44.3455, 46.4623);
    ctx.bezierCurveTo(44.5302, 46.1856, 44.9302, 46.1241, 45.1764, 46.3086);
    ctx.bezierCurveTo(45.4534, 46.4931, 45.515, 46.8621, 45.3303, 47.1388);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(43.4834, 36.8673);
    ctx.bezierCurveTo(43.2987, 37.1441, 42.8987, 37.2056, 42.6525, 37.0211);
    ctx.bezierCurveTo(42.3755, 36.8366, 42.314, 36.4368, 42.4986, 36.1908);
    ctx.bezierCurveTo(42.6833, 35.9141, 43.0833, 35.8526, 43.3295, 36.0371);
    ctx.bezierCurveTo(43.6065, 36.2216, 43.668, 36.5906, 43.4834, 36.8673);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(55.5471, 45.2619);
    ctx.bezierCurveTo(55.3625, 45.5386, 54.9624, 45.6001, 54.7162, 45.4156);
    ctx.bezierCurveTo(54.4392, 45.2311, 54.3777, 44.8314, 54.5623, 44.5854);
    ctx.bezierCurveTo(54.747, 44.3086, 55.147, 44.2471, 55.3932, 44.4316);
    ctx.bezierCurveTo(55.6702, 44.6161, 55.7625, 45.0159, 55.5471, 45.2619);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(53.793, 34.9611);
    ctx.bezierCurveTo(53.6083, 35.2378, 53.2082, 35.2993, 52.9621, 35.1148);
    ctx.bezierCurveTo(52.6851, 34.9303, 52.6235, 34.5306, 52.8082, 34.2846);
    ctx.bezierCurveTo(52.9928, 34.0079, 53.3929, 33.9464, 53.6391, 34.1309);
    ctx.bezierCurveTo(53.9161, 34.3153, 53.9776, 34.6843, 53.793, 34.9611);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(43.8222, 34.5305);
    ctx.bezierCurveTo(43.6375, 34.4998, 43.4529, 34.469, 43.2682, 34.4383);
    ctx.lineTo(42.7451, 34.3461);
    ctx.bezierCurveTo(42.5604, 34.3153, 42.3758, 34.2846, 42.2219, 34.2538);
    ctx.bezierCurveTo(42.0373, 34.2231, 41.8526, 34.1616, 41.668, 34.1308);
    ctx.bezierCurveTo(41.8526, 34.0386, 42.0373, 34.0386, 42.2219, 34.0078);
    ctx.bezierCurveTo(42.4065, 34.0078, 42.5912, 34.0078, 42.8066, 34.0386);
    ctx.bezierCurveTo(42.9913, 34.0693, 43.1759, 34.1308, 43.3605, 34.1923);
    ctx.bezierCurveTo(43.5144, 34.3153, 43.6991, 34.4075, 43.8222, 34.5305);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(57.086, 38.6826);
    ctx.lineTo(56.9321, 38.8979);
    ctx.lineTo(56.132, 37.1452);
    ctx.lineTo(56.132, 37.0837);
    ctx.bezierCurveTo(56.132, 37.0529, 56.4089, 35.3002, 55.9473, 34.2855);
    ctx.lineTo(55.7935, 33.9473);
    ctx.lineTo(56.132, 34.101);
    ctx.bezierCurveTo(56.2243, 34.1318, 58.2246, 34.962, 58.04, 36.2842);
    ctx.bezierCurveTo(57.8861, 37.5142, 57.1167, 38.6519, 57.086, 38.6826);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(56.2239, 34.3164);
    ctx.bezierCurveTo(56.3777, 34.5009, 56.5008, 34.7469, 56.5932, 34.9929);
    ctx.bezierCurveTo(56.6855, 35.2389, 56.7163, 35.4849, 56.747, 35.7309);
    ctx.bezierCurveTo(56.7778, 35.9769, 56.7778, 36.2228, 56.747, 36.4688);
    ctx.bezierCurveTo(56.7163, 36.7148, 56.6855, 36.9608, 56.5932, 37.2068);
    ctx.bezierCurveTo(56.5316, 36.7148, 56.5008, 36.2228, 56.4393, 35.7616);
    ctx.bezierCurveTo(56.4085, 35.5156, 56.4085, 35.3004, 56.3777, 35.0544);
    ctx.bezierCurveTo(56.3162, 34.7776, 56.2547, 34.5624, 56.2239, 34.3164);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(57.2707, 35.5762);
    ctx.bezierCurveTo(57.3631, 35.7914, 57.3938, 36.0067, 57.3938, 36.2219);
    ctx.bezierCurveTo(57.3938, 36.4371, 57.3631, 36.6524, 57.3015, 36.8676);
    ctx.bezierCurveTo(57.24, 37.0829, 57.1784, 37.2981, 57.0553, 37.4826);
    ctx.bezierCurveTo(56.963, 37.6671, 56.8399, 37.8516, 56.686, 38.0361);
    ctx.bezierCurveTo(56.7168, 37.8209, 56.7784, 37.6056, 56.8399, 37.4211);
    ctx.lineTo(56.9938, 36.8061);
    ctx.bezierCurveTo(57.0553, 36.5909, 57.0861, 36.4064, 57.1476, 36.1912);
    ctx.bezierCurveTo(57.1784, 36.0067, 57.2092, 35.7914, 57.2707, 35.5762);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#17162B";

    ctx.beginPath();
    ctx.moveTo(44.1295, 34.347);
    ctx.bezierCurveTo(43.9449, 34.3162, 43.7602, 34.2855, 43.5756, 34.2547);
    ctx.lineTo(43.0524, 34.1625);
    ctx.bezierCurveTo(42.8678, 34.1317, 42.6831, 34.101, 42.5293, 34.0702);
    ctx.bezierCurveTo(42.3446, 34.0395, 42.16, 33.978, 41.9753, 33.9472);
    ctx.bezierCurveTo(42.16, 33.855, 42.3446, 33.855, 42.5293, 33.8242);
    ctx.bezierCurveTo(42.7139, 33.8242, 42.8986, 33.8242, 43.114, 33.855);
    ctx.bezierCurveTo(43.2986, 33.8857, 43.4833, 33.9472, 43.6679, 34.0087);
    ctx.bezierCurveTo(43.8218, 34.101, 44.0064, 34.224, 44.1295, 34.347);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.restore();


  }

  drawElementThunderOG(ctx,scale,  x, y) {
         x = x / scale;
  y = y / scale;

ctx.save();
ctx.strokeStyle="rgba(0,0,0,0)";
ctx.miterLimit=4;

ctx.fillStyle="rgba(0,0,0,0)";

// ctx.scale(0.8,0.8);
 ctx.scale(scale, scale);
ctx.save();
ctx.fillStyle="#020202";

ctx.beginPath();
ctx.moveTo(x + 74.5305, y + 3.49355);
ctx.bezierCurveTo(x + 74.9971, y + 4.55017, x + 74.9507, y + 5.80777, x + 74.3104, y + 6.85814);
ctx.lineTo(x + 57.7624, y + 33.9785);
ctx.lineTo(x + 66.5434, y + 32.5112);
ctx.bezierCurveTo(x + 68.0374, y + 32.2615, x + 69.5285, y + 32.9694, x + 70.2845, y + 34.2861);
ctx.bezierCurveTo(x + 70.3476, y + 34.397, x + 70.4055, y + 34.5108, x + 70.4574, y + 34.6264);
ctx.bezierCurveTo(x + 71.0094, y + 35.8765, x + 70.8162, y + 37.3467, x + 69.9311, y + 38.4151);
ctx.lineTo(x + 30.8363, y + 85.5101);
ctx.bezierCurveTo(x + 29.6365, y + 86.9555, x + 27.5326, y + 87.2437, x + 25.9874, y + 86.1729);
ctx.bezierCurveTo(x + 25.4205, y + 85.7797, x + 24.9978, y + 85.25, x + 24.7351, y + 84.658);
ctx.bezierCurveTo(x + 24.2842, y + 83.6374, x + 24.3104, y + 82.4282, x + 24.8959, y + 81.3942);
ctx.lineTo(x + 41.4751, y + 52.158);
ctx.lineTo(x + 32.1485, y + 54.5908);
ctx.bezierCurveTo(x + 30.6113, y + 54.9926, x + 28.9917, y + 54.3442, x + 28.1533, y + 52.9905);
ctx.bezierCurveTo(x + 28.0631, y + 52.8451, x + 27.9847, y + 52.6963, x + 27.9183, y + 52.544);
ctx.bezierCurveTo(x + 27.356, y + 51.2704, x + 27.566, y + 49.7695, x + 28.4952, y + 48.6962);
ctx.lineTo(x + 68.4812, y + 2.58161);
ctx.bezierCurveTo(x + 69.716, y + 1.15753, x + 71.8374, y + 0.91993, x + 73.3578, y + 2.03468);
ctx.bezierCurveTo(x + 73.8855, y + 2.42306, x + 74.2811, y + 2.93032, x + 74.5305, y + 3.49355);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#ED1B24";

ctx.beginPath();
ctx.moveTo(x + 25.304, y + 83.9604);
ctx.lineTo(x + 64.4009, y + 36.8659);
ctx.lineTo(x + 47.789, y + 39.6395);
ctx.lineTo(x + 68.4768, y + 5.73488);
ctx.lineTo(x + 28.4907, y + 51.8494);
ctx.lineTo(x + 46.1235, y + 47.2503);
ctx.lineTo(x + 25.304, y + 83.9604);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.restore();

  }

  drawElementWarningOG(ctx,scale, x, y) {
    x = x / scale;
    y = y / scale;

    ctx.save();
    ctx.strokeStyle="rgba(0,0,0,0)";
    ctx.miterLimit=4;

    ctx.fillStyle="rgba(0,0,0,0)";

    ctx.scale(scale, scale);
// ctx.scale(0.5095541401273885,0.5095541401273885);
ctx.save();
ctx.fillStyle="#ED1B24";

ctx.beginPath();
ctx.moveTo(x + 135.438, y + 104.785);
ctx.lineTo(x + 96.5283, y + 89.4015);
ctx.lineTo(x + 128.136, y + 116.816);
ctx.lineTo(x + 93.6252, y + 93.1592);
ctx.lineTo(x + 118.341, y + 126.92);
ctx.lineTo(x + 89.9582, y + 96.1772);
ctx.lineTo(x + 106.542, y + 134.592);
ctx.lineTo(x + 85.7119, y + 98.3049);
ctx.lineTo(x + 93.3323, y + 139.446);
ctx.lineTo(x + 81.0999, y + 99.4324);
ctx.lineTo(x + 79.3738, y + 141.239);
ctx.lineTo(x + 76.351, y + 99.5069);
ctx.lineTo(x + 65.3658, y + 139.879);
ctx.lineTo(x + 71.7051, y + 98.5224);
ctx.lineTo(x + 52.0127, y + 135.438);
ctx.lineTo(x + 67.3958, y + 96.5276);
ctx.lineTo(x + 39.9811, y + 128.137);
ctx.lineTo(x + 63.6377, y + 93.6254);
ctx.lineTo(x + 29.876, y + 118.341);
ctx.lineTo(x + 60.6185, y + 89.9584);
ctx.lineTo(x + 22.2049, y + 106.542);
ctx.lineTo(x + 58.4914, y + 85.7123);
ctx.lineTo(x + 17.3511, y + 93.3326);
ctx.lineTo(x + 57.3645, y + 81.1003);
ctx.lineTo(x + 15.5587, y + 79.3744);
ctx.lineTo(x + 57.2901, y + 76.3513);
ctx.lineTo(x + 16.9162, y + 65.366);
ctx.lineTo(x + 58.275, y + 71.7065);
ctx.lineTo(x + 21.3592, y + 52.0124);
ctx.lineTo(x + 60.269, y + 67.3958);
ctx.lineTo(x + 28.6608, y + 39.981);
ctx.lineTo(x + 63.1716, y + 63.6365);
ctx.lineTo(x + 38.4563, y + 29.8775);
ctx.lineTo(x + 66.8386, y + 60.6184);
ctx.lineTo(x + 50.2551, y + 22.2055);
ctx.lineTo(x + 71.0853, y + 58.4924);
ctx.lineTo(x + 63.465, y + 17.351);
ctx.lineTo(x + 75.6969, y + 57.3633);
ctx.lineTo(x + 77.4234, y + 15.5585);
ctx.lineTo(x + 80.4463, y + 57.2904);
ctx.lineTo(x + 91.4309, y + 16.9166);
ctx.lineTo(x + 85.0922, y + 58.2749);
ctx.lineTo(x + 104.785, y + 21.3593);
ctx.lineTo(x + 89.401, y + 60.268);
ctx.lineTo(x + 116.816, y + 28.6605);
ctx.lineTo(x + 93.1596, y + 63.1719);
ctx.lineTo(x + 126.921, y + 38.4558);
ctx.lineTo(x + 96.1782, y + 66.8373);
ctx.lineTo(x + 134.592, y + 50.2551);
ctx.lineTo(x + 98.3054, y + 71.0834);
ctx.lineTo(x + 139.446, y + 63.4647);
ctx.lineTo(x + 99.4328, y + 75.697);
ctx.lineTo(x + 141.239, y + 77.4229);
ctx.lineTo(x + 99.5071, y + 80.446);
ctx.lineTo(x + 139.881, y + 91.4296);
ctx.lineTo(x + 98.5222, y + 85.0908);
ctx.lineTo(x + 135.438, y + 104.785);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="black";

ctx.beginPath();
ctx.moveTo(x + 96.8946, y + 69.4082);
ctx.bezierCurveTo(x + 97.6102, y + 66.2763, x + 98.9824, y + 63.1468, x + 100.098, y + 60.7686);
ctx.lineTo(x + 103.199, y + 54.1605);
ctx.lineTo(x + 89.9556, y + 52.7719);
ctx.lineTo(x + 90.6507, y + 51.2913);
ctx.lineTo(x + 77.4065, y + 49.901);
ctx.lineTo(x + 78.0999, y + 48.421);
ctx.lineTo(x + 60.2722, y + 46.5504);
ctx.lineTo(x + 58.5681, y + 49.3861);
ctx.bezierCurveTo(x + 56.8303, y + 52.2801, x + 55.7658, y + 56.3301, x + 55.0338, y + 59.5362);
ctx.bezierCurveTo(x + 54.1812, y + 63.2638, x + 53.6715, y + 66.5046, x + 53.1307, y + 69.9341);
ctx.bezierCurveTo(x + 52.9148, y + 71.3083, x + 52.6916, y + 72.7166, x + 52.4409, y + 74.1973);
ctx.lineTo(x + 52.1357, y + 75.9982);
ctx.bezierCurveTo(x + 50.9488, y + 77.1329, x + 50.0791, y + 78.589, x + 49.6946, y + 80.2705);
ctx.bezierCurveTo(x + 48.6131, y + 85.0001, x + 51.8378, y + 89.7875, x + 56.882, y + 90.9407);
ctx.bezierCurveTo(x + 59.3251, y + 91.4999, x + 61.7464, y + 91.1324, x + 63.7488, y + 90.095);
ctx.bezierCurveTo(x + 65.0567, y + 91.8883, x + 67.0352, y + 93.261, x + 69.4323, y + 93.8095);
ctx.bezierCurveTo(x + 71.8748, y + 94.3671, x + 74.2967, y + 94.0011, x + 76.2991, y + 92.9637);
ctx.bezierCurveTo(x + 77.6071, y + 94.7571, x + 79.5855, y + 96.1298, x + 81.9826, y + 96.6782);
ctx.bezierCurveTo(x + 87.1856, y + 97.8679, x + 92.3171, y + 94.9021, x + 93.4227, y + 90.0658);
ctx.bezierCurveTo(x + 93.7718, y + 88.5354, x + 93.6693, y + 86.9981, x + 93.198, y + 85.5795);
ctx.lineTo(x + 96.8946, y + 69.4082);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#FFFF00";

ctx.beginPath();
ctx.moveTo(x + 58.4002, y + 79.4687);
ctx.bezierCurveTo(x + 58.8893, y + 77.3292, x + 61.3871, y + 76.2496, x + 63.5736, y + 76.7491);
ctx.bezierCurveTo(x + 65.7126, y + 77.2385, x + 67.3838, y + 79.1208, x + 66.9045, y + 81.2112);
ctx.bezierCurveTo(x + 66.4257, y + 83.3032, x + 63.9177, y + 84.4303, x + 61.683, y + 83.9188);
ctx.bezierCurveTo(x + 59.5921, y + 83.4414, x + 57.923, y + 81.5602, x + 58.4002, y + 79.4687);
ctx.closePath();
ctx.moveTo(x + 61.2057, y + 73.1076);
ctx.bezierCurveTo(x + 62.0727, y + 68.0038, x + 62.5909, y + 63.772, x + 63.7427, y + 58.7333);
ctx.bezierCurveTo(x + 64.34, y + 56.1187, x + 65.2943, y + 52.3865, x + 66.6676, y + 50.0996);
ctx.lineTo(x + 73.9452, y + 50.8631);
ctx.bezierCurveTo(x + 72.482, y + 53.9798, x + 71.1414, y + 57.2238, x + 70.3791, y + 60.551);
ctx.lineTo(x + 67.1946, y + 74.4781);
ctx.lineTo(x + 61.2057, y + 73.1076);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#FFFF00";

ctx.beginPath();
ctx.moveTo(x + 70.9507, y + 82.3374);
ctx.bezierCurveTo(x + 71.4398, y + 80.1979, x + 73.9375, y + 79.1183, x + 76.1241, y + 79.6178);
ctx.bezierCurveTo(x + 78.2631, y + 80.1072, x + 79.9343, y + 81.9895, x + 79.4555, y + 84.0815);
ctx.bezierCurveTo(x + 78.9783, y + 86.173, x + 76.4687, y + 87.3006, x + 74.2356, y + 86.7887);
ctx.bezierCurveTo(x + 72.1426, y + 86.3101, x + 70.4719, y + 84.4294, x + 70.9507, y + 82.3374);
ctx.closePath();
ctx.moveTo(x + 73.7545, y + 75.9768);
ctx.bezierCurveTo(x + 74.6216, y + 70.873, x + 75.1397, y + 66.6412, x + 76.2916, y + 61.6025);
ctx.bezierCurveTo(x + 76.8889, y + 58.9879, x + 77.8431, y + 55.2557, x + 79.2164, y + 52.9688);
ctx.lineTo(x + 86.494, y + 53.7323);
ctx.bezierCurveTo(x + 85.0308, y + 56.849, x + 83.6903, y + 60.093, x + 82.928, y + 63.4202);
ctx.lineTo(x + 79.7435, y + 77.3473);
ctx.lineTo(x + 73.7545, y + 75.9768);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#FFFF00";

ctx.beginPath();
ctx.moveTo(x + 83.4988, y + 85.2065);
ctx.bezierCurveTo(x + 83.9879, y + 83.067, x + 86.4857, y + 81.9874, x + 88.6722, y + 82.4869);
ctx.bezierCurveTo(x + 90.8112, y + 82.9763, x + 92.4808, y + 84.8591, x + 92.0036, y + 86.9506);
ctx.bezierCurveTo(x + 91.5264, y + 89.0421, x + 89.0163, y + 90.1681, x + 86.7838, y + 89.6578);
ctx.bezierCurveTo(x + 84.6907, y + 89.1792, x + 83.0216, y + 87.298, x + 83.4988, y + 85.2065);
ctx.closePath();
ctx.moveTo(x + 86.3043, y + 78.8454);
ctx.bezierCurveTo(x + 87.1713, y + 73.7416, x + 87.689, y + 69.5082, x + 88.8413, y + 64.4711);
ctx.bezierCurveTo(x + 89.4386, y + 61.8565, x + 90.3929, y + 58.1243, x + 91.7662, y + 55.8374);
ctx.lineTo(x + 99.0438, y + 56.601);
ctx.bezierCurveTo(x + 97.5806, y + 59.7176, x + 96.24, y + 62.9616, x + 95.4777, y + 66.2888);
ctx.lineTo(x + 92.2932, y + 80.2159);
ctx.lineTo(x + 86.3043, y + 78.8454);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.restore();

  }

  drawElementThelephoneOG(ctx, scale, x, y) {
    x = x / scale;
    y = y / scale;
ctx.save();
ctx.strokeStyle="rgba(0,0,0,0)";
ctx.miterLimit=4;
ctx.fillStyle="rgba(0,0,0,0)";
ctx.scale(scale, scale);
// ctx.scale(0.6106870229007634,0.6106870229007634);
ctx.save();
ctx.fillStyle="rgba(0,0,0,0)";

ctx.beginPath();
ctx.moveTo(x + 0, y + 0);
ctx.lineTo(x + 131, y + 0);
ctx.bezierCurveTo(x + 131, y + 0, x + 131, y + 0, x + 131, y + 0);
ctx.lineTo(x + 131, y + 120);
ctx.bezierCurveTo(x + 131, y + 120, x + 131, y + 120, x + 131, y + 120);
ctx.lineTo(x + 0, y + 120);
ctx.bezierCurveTo(x + 0, y + 120, x + 0, y + 120, x + 0, y + 120);
ctx.lineTo(x + 0, y + 0);
ctx.bezierCurveTo(x + 0, y + 0, x + 0, y + 0, x + 0, y + 0);
ctx.closePath();
ctx.clip();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 73.8044, y + 83.5448);
ctx.bezierCurveTo(x + 74.2425, y + 82.6586, x + 74.3222, y + 82.578, x + 74.9993, y + 82.1752);
ctx.bezierCurveTo(x + 74.123, y + 81.7321, x + 73.6451, y + 81.0473, x + 73.884, y + 80.0402);
ctx.bezierCurveTo(x + 74.0434, y + 79.3554, x + 74.601, y + 78.8721, x + 75.2781, y + 78.7915);
ctx.bezierCurveTo(x + 76.0747, y + 78.6706, x + 76.6323, y + 79.0332, x + 77.1899, y + 80.0402);
ctx.bezierCurveTo(x + 77.5086, y + 79.0735, x + 78.1458, y + 78.5901, x + 79.1416, y + 78.6707);
ctx.bezierCurveTo(x + 79.7789, y + 78.7512, x + 80.3763, y + 79.3152, x + 80.5356, y + 79.9597);
ctx.bezierCurveTo(x + 80.7348, y + 80.725, x + 80.456, y + 81.4098, x + 79.6594, y + 82.0141);
ctx.bezierCurveTo(x + 79.8585, y + 82.1752, x + 80.0975, y + 82.296, x + 80.2568, y + 82.4572);
ctx.bezierCurveTo(x + 80.456, y + 82.6183, x + 80.5754, y + 82.86, x + 80.6949, y + 83.0211);
ctx.bezierCurveTo(x + 81.0534, y + 82.6586, x + 81.4119, y + 82.296, x + 81.7703, y + 81.9738);
ctx.bezierCurveTo(x + 80.7746, y + 81.3293, x + 80.456, y + 80.725, x + 80.6949, y + 79.8388);
ctx.bezierCurveTo(x + 80.8941, y + 79.1138, x + 81.5314, y + 78.5901, x + 82.2881, y + 78.5901);
ctx.bezierCurveTo(x + 83.0449, y + 78.5901, x + 83.6822, y + 79.1138, x + 83.9211, y + 79.8791);
ctx.bezierCurveTo(x + 84.1601, y + 80.6847, x + 83.8017, y + 81.3695, x + 82.9254, y + 81.9738);
ctx.bezierCurveTo(x + 83.1644, y + 82.1349, x + 83.4432, y + 82.2557, x + 83.6423, y + 82.4572);
ctx.bezierCurveTo(x + 83.8415, y + 82.6586, x + 84.0008, y + 82.9405, x + 84.1999, y + 83.1822);
ctx.bezierCurveTo(x + 84.6381, y + 82.2557, x + 85.3152, y + 81.7321, x + 86.3906, y + 82.0946);
ctx.bezierCurveTo(x + 87.0677, y + 82.296, x + 87.5456, y + 83.0211, x + 87.5058, y + 83.7462);
ctx.bezierCurveTo(x + 87.5058, y + 84.5115, x + 86.988, y + 85.156, x + 86.3109, y + 85.3575);
ctx.bezierCurveTo(x + 85.5143, y + 85.5992, x + 84.9169, y + 85.3172, x + 84.2796, y + 84.3907);
ctx.bezierCurveTo(x + 83.961, y + 84.7935, x + 83.6423, y + 85.1963, x + 83.2839, y + 85.5991);
ctx.bezierCurveTo(x + 83.4432, y + 85.72, x + 83.6423, y + 85.8408, x + 83.8415, y + 86.002);
ctx.bezierCurveTo(x + 84.0406, y + 86.1631, x + 84.1601, y + 86.4048, x + 84.3194, y + 86.6465);
ctx.bezierCurveTo(x + 84.7974, y + 85.7603, x + 85.5143, y + 85.3172, x + 86.5101, y + 85.6394);
ctx.bezierCurveTo(x + 87.1474, y + 85.8408, x + 87.5855, y + 86.4854, x + 87.6253, y + 87.1701);
ctx.bezierCurveTo(x + 87.6651, y + 88.0966, x + 87.1872, y + 88.6606, x + 86.3906, y + 88.9426);
ctx.bezierCurveTo(x + 86.7092, y + 89.1842, x + 87.1075, y + 89.3454, x + 87.3067, y + 89.6676);
ctx.bezierCurveTo(x + 87.466, y + 89.8288, x + 87.6253, y + 90.3121, x + 87.6253, y + 90.6747);
ctx.bezierCurveTo(x + 87.6253, y + 91.44, x + 87.0677, y + 92.0443, x + 86.3508, y + 92.2054);
ctx.bezierCurveTo(x + 85.5542, y + 92.4068, x + 84.9567, y + 92.0845, x + 84.3593, y + 91.0775);
ctx.bezierCurveTo(x + 84.1601, y + 91.8026, x + 83.6822, y + 92.2457, x + 83.0847, y + 92.4471);
ctx.bezierCurveTo(x + 83.4034, y + 92.6888, x + 83.8017, y + 92.9305, x + 84.0805, y + 93.2527);
ctx.bezierCurveTo(x + 84.3991, y + 93.6153, x + 84.4389, y + 94.0584, x + 84.3593, y + 94.5417);
ctx.bezierCurveTo(x + 84.2, y + 95.3474, x + 83.5228, y + 95.9516, x + 82.7661, y + 95.9113);
ctx.bezierCurveTo(x + 81.9297, y + 95.9113, x + 81.2526, y + 95.3071, x + 81.0932, y + 94.4209);
ctx.bezierCurveTo(x + 80.9737, y + 93.6153, x + 81.4517, y + 92.8902, x + 82.4474, y + 92.4874);
ctx.bezierCurveTo(x + 81.7703, y + 92.3262, x + 81.2924, y + 92.004, x + 81.0136, y + 91.3595);
ctx.bezierCurveTo(x + 80.8144, y + 91.6012, x + 80.6949, y + 91.8831, x + 80.4958, y + 92.0845);
ctx.bezierCurveTo(x + 80.2966, y + 92.286, x + 80.0178, y + 92.4471, x + 79.8187, y + 92.6082);
ctx.bezierCurveTo(x + 80.7348, y + 93.0916, x + 81.1331, y + 93.7361, x + 81.0136, y + 94.5417);
ctx.bezierCurveTo(x + 80.8941, y + 95.2668, x + 80.3365, y + 95.8711, x + 79.6594, y + 95.9919);
ctx.bezierCurveTo(x + 78.8229, y + 96.153, x + 78.2255, y + 95.7905, x + 77.7077, y + 94.7834);
ctx.bezierCurveTo(x + 77.4687, y + 95.1057, x + 77.2696, y + 95.4682, x + 76.9509, y + 95.7502);
ctx.bezierCurveTo(x + 76.6323, y + 96.0725, x + 76.1942, y + 96.153, x + 75.756, y + 96.0725);
ctx.bezierCurveTo(x + 74.9595, y + 95.9516, x + 74.4018, y + 95.3474, x + 74.3222, y + 94.5417);
ctx.bezierCurveTo(x + 74.2425, y + 93.7361, x + 74.6806, y + 93.0916, x + 75.5171, y + 92.7291);
ctx.bezierCurveTo(x + 75.2383, y + 92.5679, x + 74.9196, y + 92.4068, x + 74.6806, y + 92.2054);
ctx.bezierCurveTo(x + 74.4417, y + 91.9637, x + 74.2823, y + 91.6414, x + 74.123, y + 91.44);
ctx.bezierCurveTo(x + 73.9239, y + 91.722, x + 73.7247, y + 92.1248, x + 73.4061, y + 92.3262);
ctx.bezierCurveTo(x + 73.0875, y + 92.5276, x + 72.6493, y + 92.6888, x + 72.251, y + 92.6485);
ctx.bezierCurveTo(x + 71.4943, y + 92.6082, x + 70.857, y + 91.9637, x + 70.7773, y + 91.1581);
ctx.bezierCurveTo(x + 70.6578, y + 90.3524, x + 71.096, y + 89.6676, x + 71.9722, y + 89.2648);
ctx.bezierCurveTo(x + 70.857, y + 88.6203, x + 70.4985, y + 88.0966, x + 70.6578, y + 87.2104);
ctx.bezierCurveTo(x + 70.7773, y + 86.5256, x + 71.2951, y + 85.9214, x + 71.9324, y + 85.8006);
ctx.bezierCurveTo(x + 72.729, y + 85.6394, x + 73.3663, y + 85.9617, x + 73.9239, y + 86.8479);
ctx.bezierCurveTo(x + 74.0832, y + 86.6062, x + 74.2027, y + 86.3645, x + 74.362, y + 86.1631);
ctx.bezierCurveTo(x + 74.5213, y + 85.9617, x + 74.7603, y + 85.8006, x + 74.8798, y + 85.6797);
ctx.bezierCurveTo(x + 74.5213, y + 85.2769, x + 74.1629, y + 84.8741, x + 73.884, y + 84.5115);
ctx.bezierCurveTo(x + 73.6849, y + 84.7532, x + 73.4459, y + 85.1561, x + 73.1273, y + 85.3977);
ctx.bezierCurveTo(x + 72.8086, y + 85.6797, x + 72.3705, y + 85.7603, x + 71.9324, y + 85.6394);
ctx.bezierCurveTo(x + 71.1358, y + 85.438, x + 70.5782, y + 84.7935, x + 70.5782, y + 83.9879);
ctx.bezierCurveTo(x + 70.5383, y + 83.1822, x + 71.096, y + 82.4572, x + 71.8926, y + 82.2557);
ctx.bezierCurveTo(x + 72.5697, y + 82.1349, x + 73.2866, y + 82.578, x + 73.8044, y + 83.5448);
ctx.closePath();
ctx.moveTo(x + 76.3535, y + 92.7693);
ctx.bezierCurveTo(x + 76.9509, y + 92.8902, x + 77.3492, y + 93.3333, x + 77.628, y + 94.0986);
ctx.bezierCurveTo(x + 77.7874, y + 93.3736, x + 78.1857, y + 92.9305, x + 78.6636, y + 92.6888);
ctx.bezierCurveTo(x + 78.2653, y + 92.3665, x + 77.867, y + 92.004, x + 77.5484, y + 91.722);
ctx.bezierCurveTo(x + 77.1501, y + 92.0845, x + 76.7518, y + 92.4471, x + 76.3535, y + 92.7693);
ctx.closePath();
ctx.moveTo(x + 74.8798, y + 89.2648);
ctx.bezierCurveTo(x + 74.5612, y + 88.9426, x + 74.2425, y + 88.5397, x + 73.884, y + 88.1772);
ctx.bezierCurveTo(x + 73.6849, y + 88.7009, x + 73.2866, y + 89.1037, x + 72.6493, y + 89.3051);
ctx.bezierCurveTo(x + 73.4061, y + 89.5065, x + 73.8044, y + 89.9093, x + 74.0035, y + 90.4733);
ctx.bezierCurveTo(x + 74.2823, y + 90.0704, x + 74.601, y + 89.6273, x + 74.8798, y + 89.2648);
ctx.closePath();
ctx.moveTo(x + 84.3991, y + 90.0705);
ctx.bezierCurveTo(x + 84.5584, y + 89.5065, x + 84.9965, y + 89.1037, x + 85.7533, y + 88.862);
ctx.bezierCurveTo(x + 85.0364, y + 88.7411, x + 84.6381, y + 88.3786, x + 84.3593, y + 87.8952);
ctx.bezierCurveTo(x + 84.0008, y + 88.298, x + 83.6822, y + 88.6606, x + 83.4034, y + 88.9828);
ctx.bezierCurveTo(x + 83.6822, y + 89.3051, x + 84.0406, y + 89.7079, x + 84.3991, y + 90.0705);
ctx.closePath();
ctx.moveTo(x + 76.234, y + 82.1349);
ctx.bezierCurveTo(x + 76.5128, y + 82.3766, x + 76.8713, y + 82.6988, x + 77.1899, y + 82.9405);
ctx.bezierCurveTo(x + 77.4687, y + 82.6183, x + 77.7874, y + 82.296, x + 78.106, y + 81.9738);
ctx.bezierCurveTo(x + 77.9467, y + 81.8529, x + 77.7077, y + 81.6918, x + 77.5484, y + 81.4904);
ctx.bezierCurveTo(x + 77.3891, y + 81.289, x + 77.2696, y + 81.0473, x + 77.1899, y + 80.9264);
ctx.bezierCurveTo(x + 76.8713, y + 81.3695, x + 76.5526, y + 81.7724, x + 76.234, y + 82.1349);
ctx.closePath();
ctx.moveTo(x + 81.7305, y + 85.438);
ctx.bezierCurveTo(x + 81.6907, y + 85.5186, x + 81.611, y + 85.5992, x + 81.5314, y + 85.6797);
ctx.bezierCurveTo(x + 81.2127, y + 85.3172, x + 80.8941, y + 84.9949, x + 80.6153, y + 84.6727);
ctx.bezierCurveTo(x + 80.456, y + 84.8741, x + 80.217, y + 85.1963, x + 80.0178, y + 85.3977);
ctx.bezierCurveTo(x + 80.3365, y + 85.6394, x + 80.6153, y + 85.9214, x + 80.8941, y + 86.1631);
ctx.bezierCurveTo(x + 81.1331, y + 86.002, x + 81.4517, y + 85.72, x + 81.7305, y + 85.438);
ctx.closePath();
ctx.moveTo(x + 80.9339, y + 88.298);
ctx.bezierCurveTo(x + 80.6949, y + 88.58, x + 80.456, y + 88.862, x + 80.217, y + 89.144);
ctx.bezierCurveTo(x + 80.456, y + 89.4259, x + 80.7348, y + 89.7482, x + 80.9737, y + 90.0302);
ctx.bezierCurveTo(x + 80.8941, y + 89.9496, x + 80.8144, y + 89.9093, x + 80.7348, y + 89.8288);
ctx.bezierCurveTo(x + 81.0534, y + 89.5065, x + 81.4119, y + 89.2245, x + 81.6907, y + 88.9426);
ctx.bezierCurveTo(x + 81.4915, y + 88.7814, x + 81.2127, y + 88.5397, x + 80.9339, y + 88.298);
ctx.closePath();
ctx.moveTo(x + 77.3492, y + 84.8338);
ctx.bezierCurveTo(x + 77.0704, y + 85.1158, x + 76.7916, y + 85.438, x + 76.5526, y + 85.72);
ctx.bezierCurveTo(x + 76.712, y + 85.8408, x + 77.0306, y + 86.0825, x + 77.2696, y + 86.3242);
ctx.bezierCurveTo(x + 77.5086, y + 86.0423, x + 77.7874, y + 85.8006, x + 78.0263, y + 85.5589);
ctx.bezierCurveTo(x + 77.7874, y + 85.2769, x + 77.5086, y + 84.9949, x + 77.3492, y + 84.8338);
ctx.closePath();
ctx.moveTo(x + 76.6721, y + 89.1037);
ctx.bezierCurveTo(x + 76.9509, y + 89.3454, x + 77.2696, y + 89.6273, x + 77.5882, y + 89.9093);
ctx.bezierCurveTo(x + 77.5484, y + 89.9496, x + 77.4687, y + 89.9899, x + 77.4289, y + 90.0302);
ctx.bezierCurveTo(x + 77.6679, y + 89.7482, x + 77.867, y + 89.4662, x + 78.0662, y + 89.2245);
ctx.bezierCurveTo(x + 77.8272, y + 88.9828, x + 77.5882, y + 88.7009, x + 77.3492, y + 88.4592);
ctx.bezierCurveTo(x + 77.1103, y + 88.7411, x + 76.8314, y + 88.9828, x + 76.6721, y + 89.1037);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 73.6449, y + 80.5236);
ctx.bezierCurveTo(x + 73.6847, y + 81.4501, x + 73.0076, y + 82.2155, x + 72.0915, y + 82.2557);
ctx.bezierCurveTo(x + 71.1754, y + 82.296, x + 70.4585, y + 81.5709, x + 70.4187, y + 80.6445);
ctx.bezierCurveTo(x + 70.3788, y + 79.718, x + 71.0559, y + 78.9929, x + 71.972, y + 78.9526);
ctx.bezierCurveTo(x + 72.8881, y + 78.9123, x + 73.6449, y + 79.5971, x + 73.6449, y + 80.5236);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 85.6341, y + 78.5095);
ctx.bezierCurveTo(x + 86.5104, y + 78.5095, x + 87.2273, y + 79.1943, x + 87.2671, y + 80.1208);
ctx.bezierCurveTo(x + 87.307, y + 81.0473, x + 86.59, y + 81.7724, x + 85.674, y + 81.8126);
ctx.bezierCurveTo(x + 84.7977, y + 81.8126, x + 84.0808, y + 81.0876, x + 84.0808, y + 80.1611);
ctx.bezierCurveTo(x + 84.0409, y + 79.2346, x + 84.718, y + 78.5095, x + 85.6341, y + 78.5095);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 72.4905, y + 92.9304);
ctx.bezierCurveTo(x + 73.3667, y + 92.9304, x + 74.0837, y + 93.6152, x + 74.1235, y + 94.5417);
ctx.bezierCurveTo(x + 74.1633, y + 95.4682, x + 73.4464, y + 96.2335, x + 72.5303, y + 96.2335);
ctx.bezierCurveTo(x + 71.6541, y + 96.2335, x + 70.9371, y + 95.5085, x + 70.9371, y + 94.6223);
ctx.bezierCurveTo(x + 70.8973, y + 93.6555, x + 71.6142, y + 92.9304, x + 72.4905, y + 92.9304);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 68.9851, y + 89.3452);
ctx.bezierCurveTo(x + 68.1088, y + 89.3855, x + 67.352, y + 88.6605, x + 67.3122, y + 87.7743);
ctx.bezierCurveTo(x + 67.2724, y + 86.8881, x + 67.9495, y + 86.1227, x + 68.8258, y + 86.0824);
ctx.bezierCurveTo(x + 69.702, y + 86.0421, x + 70.4588, y + 86.7672, x + 70.4986, y + 87.6534);
ctx.bezierCurveTo(x + 70.5783, y + 88.4993, x + 69.8613, y + 89.305, x + 68.9851, y + 89.3452);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 78.7034, y + 75.2064);
ctx.bezierCurveTo(x + 79.5796, y + 75.1661, x + 80.3364, y + 75.9314, x + 80.3364, y + 76.8176);
ctx.bezierCurveTo(x + 80.3364, y + 77.7038, x + 79.6195, y + 78.4692, x + 78.783, y + 78.4692);
ctx.bezierCurveTo(x + 77.9068, y + 78.4692, x + 77.1899, y + 77.7844, x + 77.15, y + 76.8982);
ctx.bezierCurveTo(x + 77.1102, y + 76.012, x + 77.8271, y + 75.2064, x + 78.7034, y + 75.2064);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 87.7049, y + 94.0582);
ctx.bezierCurveTo(x + 87.7448, y + 94.9444, x + 87.0278, y + 95.7098, x + 86.1516, y + 95.75);
ctx.bezierCurveTo(x + 85.2753, y + 95.75, x + 84.5186, y + 95.025, x + 84.5186, y + 94.1388);
ctx.bezierCurveTo(x + 84.5186, y + 93.2526, x + 85.1957, y + 92.5275, x + 86.0719, y + 92.4872);
ctx.bezierCurveTo(x + 86.9083, y + 92.4469, x + 87.6651, y + 93.172, x + 87.7049, y + 94.0582);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 79.4608, y + 99.4158);
ctx.bezierCurveTo(x + 78.5845, y + 99.4561, x + 77.8676, y + 98.731, x + 77.8278, y + 97.8448);
ctx.bezierCurveTo(x + 77.7879, y + 96.9586, x + 78.5049, y + 96.1933, x + 79.3413, y + 96.153);
ctx.bezierCurveTo(x + 80.1777, y + 96.1127, x + 80.9345, y + 96.8378, x + 80.9743, y + 97.724);
ctx.bezierCurveTo(x + 81.0141, y + 98.6102, x + 80.337, y + 99.3755, x + 79.4608, y + 99.4158);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 70.3797, y + 84.1087);
ctx.bezierCurveTo(x + 70.4195, y + 84.9949, x + 69.7026, y + 85.7603, x + 68.8661, y + 85.8006);
ctx.bezierCurveTo(x + 68.0297, y + 85.8409, x + 67.2729, y + 85.1158, x + 67.2331, y + 84.2296);
ctx.bezierCurveTo(x + 67.1933, y + 83.3434, x + 67.8704, y + 82.578, x + 68.7467, y + 82.5377);
ctx.bezierCurveTo(x + 69.6229, y + 82.4975, x + 70.3398, y + 83.2225, x + 70.3797, y + 84.1087);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 83.7624, y + 76.6565);
ctx.bezierCurveTo(x + 83.8022, y + 77.5427, x + 83.0853, y + 78.308, x + 82.2489, y + 78.308);
ctx.bezierCurveTo(x + 81.3726, y + 78.3483, x + 80.6557, y + 77.6232, x + 80.6158, y + 76.737);
ctx.bezierCurveTo(x + 80.576, y + 75.8508, x + 81.293, y + 75.0854, x + 82.1294, y + 75.0854);
ctx.bezierCurveTo(x + 82.9658, y + 75.0854, x + 83.7226, y + 75.8105, x + 83.7624, y + 76.6565);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 89.259, y + 88.6203);
ctx.bezierCurveTo(x + 88.3827, y + 88.6203, x + 87.6658, y + 87.8952, x + 87.626, y + 87.0493);
ctx.bezierCurveTo(x + 87.626, y + 86.1631, x + 88.3031, y + 85.3977, x + 89.1793, y + 85.3977);
ctx.bezierCurveTo(x + 90.0556, y + 85.3977, x + 90.7725, y + 86.1228, x + 90.8124, y + 86.9687);
ctx.bezierCurveTo(x + 90.8124, y + 87.8549, x + 90.1352, y + 88.6203, x + 89.259, y + 88.6203);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 75.4373, y + 78.5901);
ctx.bezierCurveTo(x + 74.5611, y + 78.6304, x + 73.8441, y + 77.9053, x + 73.8043, y + 77.0191);
ctx.bezierCurveTo(x + 73.7645, y + 76.1329, x + 74.4814, y + 75.3676, x + 75.3178, y + 75.3273);
ctx.bezierCurveTo(x + 76.1941, y + 75.287, x + 76.911, y + 76.0121, x + 76.9509, y + 76.8983);
ctx.bezierCurveTo(x + 76.9907, y + 77.7845, x + 76.2738, y + 78.5498, x + 75.4373, y + 78.5901);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 68.9848, y + 89.5065);
ctx.bezierCurveTo(x + 69.8611, y + 89.4662, x + 70.578, y + 90.1913, x + 70.6179, y + 91.0775);
ctx.bezierCurveTo(x + 70.6577, y + 91.9637, x + 69.9408, y + 92.729, x + 69.1043, y + 92.729);
ctx.bezierCurveTo(x + 68.2281, y + 92.7693, x + 67.5111, y + 92.0442, x + 67.4713, y + 91.158);
ctx.bezierCurveTo(x + 67.4315, y + 90.3121, x + 68.1484, y + 89.5468, x + 68.9848, y + 89.5065);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 90.6925, y + 83.4641);
ctx.bezierCurveTo(x + 90.6925, y + 84.3503, x + 89.9755, y + 85.0753, x + 89.0993, y + 85.0753);
ctx.bezierCurveTo(x + 88.223, y + 85.0351, x + 87.5459, y + 84.3503, x + 87.5459, y + 83.4641);
ctx.bezierCurveTo(x + 87.5459, y + 82.5779, x + 88.2628, y + 81.8528, x + 89.1391, y + 81.8528);
ctx.bezierCurveTo(x + 89.9755, y + 81.8931, x + 90.6925, y + 82.6181, x + 90.6925, y + 83.4641);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 77.6279, y + 97.8046);
ctx.bezierCurveTo(x + 77.6678, y + 98.6908, x + 76.9907, y + 99.4562, x + 76.1144, y + 99.4965);
ctx.bezierCurveTo(x + 75.278, y + 99.5368, x + 74.561, y + 98.852, x + 74.5212, y + 97.9658);
ctx.bezierCurveTo(x + 74.4814, y + 97.0796, x + 75.1585, y + 96.3142, x + 76.0347, y + 96.2739);
ctx.bezierCurveTo(x + 76.8712, y + 96.2739, x + 77.5881, y + 96.9587, x + 77.6279, y + 97.8046);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 90.8916, y + 90.3928);
ctx.bezierCurveTo(x + 90.9314, y + 91.279, x + 90.2941, y + 92.004, x + 89.4179, y + 92.0443);
ctx.bezierCurveTo(x + 88.5416, y + 92.0846, x + 87.8247, y + 91.3998, x + 87.7849, y + 90.5136);
ctx.bezierCurveTo(x + 87.745, y + 89.6274, x + 88.4221, y + 88.9023, x + 89.2984, y + 88.862);
ctx.bezierCurveTo(x + 90.1348, y + 88.8218, x + 90.8518, y + 89.5066, x + 90.8916, y + 90.3928);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 82.9259, y + 99.2548);
ctx.bezierCurveTo(x + 82.0497, y + 99.295, x + 81.3726, y + 98.6103, x + 81.3327, y + 97.7241);
ctx.bezierCurveTo(x + 81.2929, y + 96.8378, x + 81.97, y + 96.0725, x + 82.8463, y + 96.0725);
ctx.bezierCurveTo(x + 83.7225, y + 96.0322, x + 84.3996, y + 96.717, x + 84.4394, y + 97.6032);
ctx.bezierCurveTo(x + 84.4394, y + 98.4894, x + 83.7623, y + 99.2145, x + 82.9259, y + 99.2548);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 70.2202, y + 80.6445);
ctx.bezierCurveTo(x + 70.26, y + 81.5307, x + 69.5829, y + 82.2155, x + 68.7465, y + 82.2558);
ctx.bezierCurveTo(x + 67.8703, y + 82.296, x + 67.1932, y + 81.6113, x + 67.1533, y + 80.7251);
ctx.bezierCurveTo(x + 67.1533, y + 79.8791, x + 67.7906, y + 79.1541, x + 68.627, y + 79.1138);
ctx.bezierCurveTo(x + 69.5033, y + 79.1138, x + 70.1804, y + 79.7986, x + 70.2202, y + 80.6445);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 72.0119, y + 78.6303);
ctx.bezierCurveTo(x + 71.1755, y + 78.6705, x + 70.4586, y + 77.9857, x + 70.4188, y + 77.1398);
ctx.bezierCurveTo(x + 70.3789, y + 76.2536, x + 71.0162, y + 75.5285, x + 71.8925, y + 75.5285);
ctx.bezierCurveTo(x + 72.7289, y + 75.4883, x + 73.4458, y + 76.1731, x + 73.4857, y + 77.019);
ctx.bezierCurveTo(x + 73.4857, y + 77.8649, x + 72.8484, y + 78.59, x + 72.0119, y + 78.6303);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 74.1235, y + 97.9658);
ctx.bezierCurveTo(x + 74.1633, y + 98.8117, x + 73.4862, y + 99.5367, x + 72.6498, y + 99.577);
ctx.bezierCurveTo(x + 71.8133, y + 99.6173, x + 71.0964, y + 98.9325, x + 71.0964, y + 98.0463);
ctx.bezierCurveTo(x + 71.0566, y + 97.2004, x + 71.7337, y + 96.4753, x + 72.5303, y + 96.435);
ctx.bezierCurveTo(x + 73.4065, y + 96.3948, x + 74.1235, y + 97.0795, x + 74.1235, y + 97.9658);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 86.1515, y + 95.9919);
ctx.bezierCurveTo(x + 86.948, y + 95.9516, x + 87.665, y + 96.6364, x + 87.7447, y + 97.4824);
ctx.bezierCurveTo(x + 87.7845, y + 98.3283, x + 87.1074, y + 99.0936, x + 86.2709, y + 99.1339);
ctx.bezierCurveTo(x + 85.4345, y + 99.1742, x + 84.7574, y + 98.4894, x + 84.7176, y + 97.6435);
ctx.bezierCurveTo(x + 84.6778, y + 96.7573, x + 85.315, y + 96.0322, x + 86.1515, y + 95.9919);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 69.1046, y + 93.0915);
ctx.bezierCurveTo(x + 69.941, y + 93.0513, x + 70.6579, y + 93.736, x + 70.6579, y + 94.6222);
ctx.bezierCurveTo(x + 70.6978, y + 95.4682, x + 70.0206, y + 96.1932, x + 69.1842, y + 96.2335);
ctx.bezierCurveTo(x + 68.3478, y + 96.2738, x + 67.6309, y + 95.589, x + 67.6309, y + 94.7028);
ctx.bezierCurveTo(x + 67.6309, y + 93.8569, x + 68.2681, y + 93.1318, x + 69.1046, y + 93.0915);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 89.378, y + 92.447);
ctx.bezierCurveTo(x + 90.2144, y + 92.4067, x + 90.8915, y + 93.0915, x + 90.9314, y + 93.9374);
ctx.bezierCurveTo(x + 90.9712, y + 94.7834, x + 90.2941, y + 95.5487, x + 89.4577, y + 95.5487);
ctx.bezierCurveTo(x + 88.6212, y + 95.5487, x + 87.9441, y + 94.9042, x + 87.9043, y + 94.0583);
ctx.bezierCurveTo(x + 87.9043, y + 93.2124, x + 88.5814, y + 92.4873, x + 89.378, y + 92.447);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 85.4744, y + 75.0451);
ctx.bezierCurveTo(x + 86.3108, y + 75.0049, x + 87.0278, y + 75.6897, x + 87.0676, y + 76.5356);
ctx.bezierCurveTo(x + 87.1074, y + 77.3815, x + 86.4303, y + 78.1066, x + 85.5939, y + 78.1469);
ctx.bezierCurveTo(x + 84.7575, y + 78.1871, x + 84.0804, y + 77.5024, x + 84.0406, y + 76.6564);
ctx.bezierCurveTo(x + 83.9609, y + 75.8508, x + 84.638, y + 75.0854, x + 85.4744, y + 75.0451);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 90.5329, y + 79.9998);
ctx.bezierCurveTo(x + 90.5728, y + 80.8457, x + 89.8956, y + 81.5708, x + 89.0592, y + 81.6111);
ctx.bezierCurveTo(x + 88.2228, y + 81.6111, x + 87.5059, y + 80.9263, x + 87.5059, y + 80.0804);
ctx.bezierCurveTo(x + 87.5059, y + 79.2344, x + 88.1431, y + 78.5094, x + 88.9796, y + 78.5094);
ctx.bezierCurveTo(x + 89.7762, y + 78.4288, x + 90.4931, y + 79.1136, x + 90.5329, y + 79.9998);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 65.5201, y + 89.3051);
ctx.bezierCurveTo(x + 64.6837, y + 89.3454, x + 64.0464, y + 88.7009, x + 64.0066, y + 87.8549);
ctx.bezierCurveTo(x + 63.9667, y + 87.009, x + 64.6438, y + 86.2839, x + 65.4404, y + 86.2839);
ctx.bezierCurveTo(x + 66.237, y + 86.2839, x + 66.9141, y + 86.9285, x + 66.954, y + 87.7744);
ctx.bezierCurveTo(x + 66.9938, y + 88.6203, x + 66.3565, y + 89.3051, x + 65.5201, y + 89.3051);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 80.0978, y + 73.3535);
ctx.bezierCurveTo(x + 80.0978, y + 74.1994, x + 79.5003, y + 74.8842, x + 78.6639, y + 74.8842);
ctx.bezierCurveTo(x + 77.8275, y + 74.9245, x + 77.1504, y + 74.2397, x + 77.1504, y + 73.3937);
ctx.bezierCurveTo(x + 77.1504, y + 72.5478, x + 77.7877, y + 71.863, x + 78.5843, y + 71.863);
ctx.bezierCurveTo(x + 79.4207, y + 71.863, x + 80.058, y + 72.5075, x + 80.0978, y + 73.3535);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 66.8343, y + 84.2295);
ctx.bezierCurveTo(x + 66.8343, y + 85.0755, x + 66.2369, y + 85.7603, x + 65.4005, y + 85.7603);
ctx.bezierCurveTo(x + 64.564, y + 85.7603, x + 63.9268, y + 85.1157, x + 63.9268, y + 84.2698);
ctx.bezierCurveTo(x + 63.9268, y + 83.4642, x + 64.5242, y + 82.7794, x + 65.3606, y + 82.7794);
ctx.bezierCurveTo(x + 66.1572, y + 82.7391, x + 66.8343, y + 83.3836, x + 66.8343, y + 84.2295);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 75.2384, y + 71.9839);
ctx.bezierCurveTo(x + 76.0748, y + 71.9839, x + 76.7121, y + 72.6284, x + 76.7121, y + 73.4743);
ctx.bezierCurveTo(x + 76.7121, y + 74.3202, x + 76.0748, y + 74.9648, x + 75.2782, y + 75.005);
ctx.bezierCurveTo(x + 74.4816, y + 75.005, x + 73.8443, y + 74.3605, x + 73.8045, y + 73.5549);
ctx.bezierCurveTo(x + 73.7647, y + 72.709, x + 74.4019, y + 72.0242, x + 75.2384, y + 71.9839);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 79.5799, y + 102.719);
ctx.bezierCurveTo(x + 78.7435, y + 102.759, x + 78.1062, y + 102.115, x + 78.0664, y + 101.269);
ctx.bezierCurveTo(x + 78.0664, y + 100.423, x + 78.6639, y + 99.7784, x + 79.4604, y + 99.7381);
ctx.bezierCurveTo(x + 80.2969, y + 99.6978, x + 80.9341, y + 100.342, x + 80.974, y + 101.188);
ctx.bezierCurveTo(x + 81.0138, y + 102.034, x + 80.3765, y + 102.679, x + 79.5799, y + 102.719);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 94.1173, y + 86.8479);
ctx.bezierCurveTo(x + 94.1572, y + 87.6938, x + 93.5199, y + 88.3786, x + 92.6835, y + 88.3786);
ctx.bezierCurveTo(x + 91.8869, y + 88.3786, x + 91.2098, y + 87.7743, x + 91.2098, y + 86.9284);
ctx.bezierCurveTo(x + 91.1699, y + 86.0825, x + 91.8072, y + 85.3977, x + 92.6437, y + 85.3977);
ctx.bezierCurveTo(x + 93.4402, y + 85.3977, x + 94.0775, y + 86.0019, x + 94.1173, y + 86.8479);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 65.6795, y + 92.729);
ctx.bezierCurveTo(x + 64.843, y + 92.7693, x + 64.1659, y + 92.1248, x + 64.1659, y + 91.2788);
ctx.bezierCurveTo(x + 64.1261, y + 90.4329, x + 64.7236, y + 89.7884, x + 65.56, y + 89.7481);
ctx.bezierCurveTo(x + 66.3964, y + 89.7078, x + 67.0735, y + 90.3524, x + 67.0735, y + 91.1983);
ctx.bezierCurveTo(x + 67.0735, y + 92.0442, x + 66.4761, y + 92.6887, x + 65.6795, y + 92.729);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 83.5226, y + 73.2325);
ctx.bezierCurveTo(x + 83.5624, y + 74.0784, x + 82.9252, y + 74.7632, x + 82.0888, y + 74.7632);
ctx.bezierCurveTo(x + 81.2922, y + 74.7632, x + 80.6549, y + 74.1589, x + 80.6151, y + 73.313);
ctx.bezierCurveTo(x + 80.5752, y + 72.4671, x + 81.2125, y + 71.7823, x + 82.0489, y + 71.7823);
ctx.bezierCurveTo(x + 82.8455, y + 71.742, x + 83.4828, y + 72.3865, x + 83.5226, y + 73.2325);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 92.5247, y + 81.8931);
ctx.bezierCurveTo(x + 93.3213, y + 81.8931, x + 93.9586, y + 82.4973, x + 93.9984, y + 83.3432);
ctx.bezierCurveTo(x + 94.0382, y + 84.1891, x + 93.4009, y + 84.8739, x + 92.5645, y + 84.8739);
ctx.bezierCurveTo(x + 91.7679, y + 84.8739, x + 91.1307, y + 84.2294, x + 91.0908, y + 83.4238);
ctx.bezierCurveTo(x + 91.0908, y + 82.5779, x + 91.7281, y + 81.8931, x + 92.5247, y + 81.8931);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 76.1942, y + 102.84);
ctx.bezierCurveTo(x + 75.3976, y + 102.84, x + 74.7603, y + 102.236, x + 74.7205, y + 101.39);
ctx.bezierCurveTo(x + 74.6807, y + 100.544, x + 75.318, y + 99.8589, x + 76.1544, y + 99.8589);
ctx.bezierCurveTo(x + 76.951, y + 99.8589, x + 77.5883, y + 100.503, x + 77.5883, y + 101.349);
ctx.bezierCurveTo(x + 77.6281, y + 102.155, x + 76.9908, y + 102.799, x + 76.1942, y + 102.84);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 70.0211, y + 77.1398);
ctx.bezierCurveTo(x + 70.0211, y + 77.9455, x + 69.4236, y + 78.6303, x + 68.627, y + 78.6706);
ctx.bezierCurveTo(x + 67.7906, y + 78.7108, x + 67.1533, y + 78.026, x + 67.1533, y + 77.1801);
ctx.bezierCurveTo(x + 67.1533, y + 76.3745, x + 67.7906, y + 75.6897, x + 68.5872, y + 75.6897);
ctx.bezierCurveTo(x + 69.3838, y + 75.6897, x + 70.0211, y + 76.3342, x + 70.0211, y + 77.1398);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 82.8862, y + 99.6173);
ctx.bezierCurveTo(x + 83.6828, y + 99.577, x + 84.3599, y + 100.222, x + 84.3998, y + 101.027);
ctx.bezierCurveTo(x + 84.4396, y + 101.873, x + 83.8023, y + 102.558, x + 83.0057, y + 102.558);
ctx.bezierCurveTo(x + 82.2091, y + 102.598, x + 81.532, y + 101.954, x + 81.4922, y + 101.148);
ctx.bezierCurveTo(x + 81.4922, y + 100.342, x + 82.0896, y + 99.6576, x + 82.8862, y + 99.6173);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 92.7239, y + 88.8619);
ctx.bezierCurveTo(x + 93.5205, y + 88.8216, x + 94.1976, y + 89.4661, x + 94.2375, y + 90.2718);
ctx.bezierCurveTo(x + 94.2773, y + 91.1177, x + 93.64, y + 91.7622, x + 92.8434, y + 91.8025);
ctx.bezierCurveTo(x + 92.0468, y + 91.8428, x + 91.3697, y + 91.1983, x + 91.3299, y + 90.3926);
ctx.bezierCurveTo(x + 91.2901, y + 89.587, x + 91.9273, y + 88.9022, x + 92.7239, y + 88.8619);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 69.264, y + 96.6362);
ctx.bezierCurveTo(x + 70.0606, y + 96.6362, x + 70.6979, y + 97.2807, x + 70.7377, y + 98.1267);
ctx.bezierCurveTo(x + 70.7377, y + 98.9323, x + 70.1005, y + 99.6171, x + 69.3039, y + 99.6171);
ctx.bezierCurveTo(x + 68.5073, y + 99.6171, x + 67.87, y + 98.9726, x + 67.87, y + 98.1669);
ctx.bezierCurveTo(x + 67.7904, y + 97.321, x + 68.4276, y + 96.6362, x + 69.264, y + 96.6362);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 89.5374, y + 95.9516);
ctx.bezierCurveTo(x + 90.334, y + 95.9114, x + 91.0111, y + 96.5962, x + 91.0111, y + 97.4018);
ctx.bezierCurveTo(x + 91.0111, y + 98.2074, x + 90.4137, y + 98.8922, x + 89.6171, y + 98.8922);
ctx.bezierCurveTo(x + 88.8205, y + 98.9325, x + 88.1434, y + 98.2477, x + 88.1434, y + 97.4421);
ctx.bezierCurveTo(x + 88.1035, y + 96.6767, x + 88.7408, y + 95.9919, x + 89.5374, y + 95.9516);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 88.9395, y + 77.9857);
ctx.bezierCurveTo(x + 88.1429, y + 78.026, x + 87.4658, y + 77.3815, x + 87.4658, y + 76.5356);
ctx.bezierCurveTo(x + 87.4658, y + 75.73, x + 88.0633, y + 75.0452, x + 88.8997, y + 75.0049);
ctx.bezierCurveTo(x + 89.6963, y + 75.0049, x + 90.3336, y + 75.6091, x + 90.3734, y + 76.455);
ctx.bezierCurveTo(x + 90.3336, y + 77.2607, x + 89.7361, y + 77.9455, x + 88.9395, y + 77.9857);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 73.2466, y + 73.5549);
ctx.bezierCurveTo(x + 73.2865, y + 74.3605, x + 72.6492, y + 75.0453, x + 71.8526, y + 75.0453);
ctx.bezierCurveTo(x + 71.056, y + 75.0856, x + 70.3789, y + 74.4008, x + 70.3789, y + 73.5952);
ctx.bezierCurveTo(x + 70.3789, y + 72.7895, x + 71.0162, y + 72.1047, x + 71.7729, y + 72.1047);
ctx.bezierCurveTo(x + 72.5695, y + 72.145, x + 73.2466, y + 72.7895, x + 73.2466, y + 73.5549);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 66.6754, y + 80.8056);
ctx.bezierCurveTo(x + 66.6754, y + 81.6113, x + 66.0779, y + 82.2961, x + 65.2813, y + 82.2961);
ctx.bezierCurveTo(x + 64.4847, y + 82.3363, x + 63.8076, y + 81.6515, x + 63.8076, y + 80.8459);
ctx.bezierCurveTo(x + 63.8076, y + 80.0403, x + 64.4449, y + 79.3555, x + 65.2017, y + 79.3555);
ctx.bezierCurveTo(x + 66.0381, y + 79.3555, x + 66.6754, y + 80, x + 66.6754, y + 80.8056);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 67.1531, y + 94.7431);
ctx.bezierCurveTo(x + 67.1929, y + 95.5487, x + 66.5557, y + 96.2335, x + 65.7989, y + 96.2738);
ctx.bezierCurveTo(x + 65.0421, y + 96.3141, x + 64.365, y + 95.6293, x + 64.3252, y + 94.8639);
ctx.bezierCurveTo(x + 64.3252, y + 94.0986, x + 64.9226, y + 93.4138, x + 65.6794, y + 93.3735);
ctx.bezierCurveTo(x + 66.4362, y + 93.2929, x + 67.1133, y + 93.9375, x + 67.1531, y + 94.7431);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 85.355, y + 71.7019);
ctx.bezierCurveTo(x + 86.1117, y + 71.6616, x + 86.7888, y + 72.3464, x + 86.8287, y + 73.1118);
ctx.bezierCurveTo(x + 86.8685, y + 73.9174, x + 86.2312, y + 74.6022, x + 85.4346, y + 74.6022);
ctx.bezierCurveTo(x + 84.6779, y + 74.6425, x + 84.0008, y + 73.9577, x + 83.9609, y + 73.1923);
ctx.bezierCurveTo(x + 83.9609, y + 72.427, x + 84.5982, y + 71.7019, x + 85.355, y + 71.7019);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 72.8085, y + 102.92);
ctx.bezierCurveTo(x + 72.0517, y + 102.961, x + 71.3746, y + 102.316, x + 71.3348, y + 101.51);
ctx.bezierCurveTo(x + 71.2949, y + 100.705, x + 71.9322, y + 100.02, x + 72.7288, y + 100.02);
ctx.bezierCurveTo(x + 73.4856, y + 100.02, x + 74.1229, y + 100.624, x + 74.1627, y + 101.43);
ctx.bezierCurveTo(x + 74.2025, y + 102.195, x + 73.5652, y + 102.88, x + 72.8085, y + 102.92);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 87.7449, y + 100.987);
ctx.bezierCurveTo(x + 87.7449, y + 101.792, x + 87.1076, y + 102.477, x + 86.3509, y + 102.477);
ctx.bezierCurveTo(x + 85.5941, y + 102.477, x + 84.9568, y + 101.833, x + 84.917, y + 101.067);
ctx.bezierCurveTo(x + 84.917, y + 100.262, x + 85.5543, y + 99.577, x + 86.311, y + 99.577);
ctx.bezierCurveTo(x + 87.0678, y + 99.5367, x + 87.7051, y + 100.181, x + 87.7449, y + 100.987);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 92.4844, y + 81.3695);
ctx.bezierCurveTo(x + 91.7277, y + 81.3695, x + 91.0506, y + 80.725, x + 91.0107, y + 79.9194);
ctx.bezierCurveTo(x + 91.0107, y + 79.1138, x + 91.648, y + 78.429, x + 92.4048, y + 78.429);
ctx.bezierCurveTo(x + 93.1615, y + 78.429, x + 93.7988, y + 79.0735, x + 93.8386, y + 79.8388);
ctx.bezierCurveTo(x + 93.8785, y + 80.6445, x + 93.2412, y + 81.3695, x + 92.4844, y + 81.3695);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 92.9629, y + 95.3071);
ctx.bezierCurveTo(x + 92.2061, y + 95.3474, x + 91.529, y + 94.7432, x + 91.4892, y + 93.9375);
ctx.bezierCurveTo(x + 91.4494, y + 93.1319, x + 92.0468, y + 92.4471, x + 92.8434, y + 92.4068);
ctx.bezierCurveTo(x + 93.6002, y + 92.3665, x + 94.2773, y + 93.0111, x + 94.2773, y + 93.7764);
ctx.bezierCurveTo(x + 94.3171, y + 94.6223, x + 93.7197, y + 95.2668, x + 92.9629, y + 95.3071);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 66.516, y + 77.2608);
ctx.bezierCurveTo(x + 66.5559, y + 78.0262, x + 65.9584, y + 78.6707, x + 65.2017, y + 78.711);
ctx.bezierCurveTo(x + 64.4449, y + 78.7513, x + 63.8076, y + 78.1068, x + 63.8076, y + 77.3414);
ctx.bezierCurveTo(x + 63.8076, y + 76.576, x + 64.3652, y + 75.9315, x + 65.122, y + 75.9315);
ctx.bezierCurveTo(x + 65.8389, y + 75.851, x + 66.4762, y + 76.4552, x + 66.516, y + 77.2608);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 67.1133, y + 73.7563);
ctx.bezierCurveTo(x + 67.1133, y + 72.9909, x + 67.7107, y + 72.3464, x + 68.4675, y + 72.3464);
ctx.bezierCurveTo(x + 69.2243, y + 72.3464, x + 69.8217, y + 72.9507, x + 69.8615, y + 73.7563);
ctx.bezierCurveTo(x + 69.8615, y + 74.5217, x + 69.2641, y + 75.1259, x + 68.5471, y + 75.1662);
ctx.bezierCurveTo(x + 67.7506, y + 75.1259, x + 67.1133, y + 74.5217, x + 67.1133, y + 73.7563);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 63.4887, y + 87.8952);
ctx.bezierCurveTo(x + 63.4887, y + 88.6606, x + 62.8912, y + 89.3051, x + 62.1345, y + 89.3051);
ctx.bezierCurveTo(x + 61.3777, y + 89.3051, x + 60.7803, y + 88.7009, x + 60.7803, y + 87.9355);
ctx.bezierCurveTo(x + 60.7803, y + 87.1701, x + 61.3777, y + 86.5256, x + 62.1345, y + 86.5256);
ctx.bezierCurveTo(x + 62.8912, y + 86.5256, x + 63.4887, y + 87.1299, x + 63.4887, y + 87.8952);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 78.4647, y + 68.5195);
ctx.bezierCurveTo(x + 79.2215, y + 68.4792, x + 79.8587, y + 69.0834, x + 79.8587, y + 69.8891);
ctx.bezierCurveTo(x + 79.8986, y + 70.6544, x + 79.3011, y + 71.2989, x + 78.5444, y + 71.3392);
ctx.bezierCurveTo(x + 77.7876, y + 71.3392, x + 77.1901, y + 70.7753, x + 77.1503, y + 70.0099);
ctx.bezierCurveTo(x + 77.1105, y + 69.2043, x + 77.7079, y + 68.5598, x + 78.4647, y + 68.5195);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 69.4233, y + 102.961);
ctx.bezierCurveTo(x + 68.6666, y + 103.001, x + 68.0293, y + 102.356, x + 68.0293, y + 101.591);
ctx.bezierCurveTo(x + 68.0293, y + 100.826, x + 68.5869, y + 100.181, x + 69.3437, y + 100.181);
ctx.bezierCurveTo(x + 70.1004, y + 100.141, x + 70.7377, y + 100.785, x + 70.7377, y + 101.551);
ctx.bezierCurveTo(x + 70.7377, y + 102.316, x + 70.1801, y + 102.92, x + 69.4233, y + 102.961);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 82.01, y + 71.2184);
ctx.bezierCurveTo(x + 81.293, y + 71.2587, x + 80.6558, y + 70.6544, x + 80.5761, y + 69.8891);
ctx.bezierCurveTo(x + 80.5363, y + 69.1237, x + 81.1337, y + 68.4389, x + 81.8905, y + 68.4389);
ctx.bezierCurveTo(x + 82.6074, y + 68.3986, x + 83.2447, y + 69.0029, x + 83.2845, y + 69.7682);
ctx.bezierCurveTo(x + 83.3244, y + 70.5336, x + 82.7269, y + 71.1781, x + 82.01, y + 71.2184);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 63.3696, y + 84.31);
ctx.bezierCurveTo(x + 63.4094, y + 85.0754, x + 62.8119, y + 85.7199, x + 62.095, y + 85.7602);
ctx.bezierCurveTo(x + 61.3382, y + 85.8005, x + 60.701, y + 85.1559, x + 60.6611, y + 84.3906);
ctx.bezierCurveTo(x + 60.6611, y + 83.6252, x + 61.2188, y + 82.9807, x + 61.9755, y + 82.9807);
ctx.bezierCurveTo(x + 62.6925, y + 82.9807, x + 63.3297, y + 83.5849, x + 63.3696, y + 84.31);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 65.7987, y + 96.8377);
ctx.bezierCurveTo(x + 66.5554, y + 96.7974, x + 67.1927, y + 97.442, x + 67.1927, y + 98.2073);
ctx.bezierCurveTo(x + 67.1927, y + 98.9727, x + 66.6351, y + 99.6172, x + 65.8783, y + 99.6172);
ctx.bezierCurveTo(x + 65.1216, y + 99.6575, x + 64.4843, y + 99.0129, x + 64.4843, y + 98.2476);
ctx.bezierCurveTo(x + 64.4445, y + 97.5225, x + 65.0419, y + 96.878, x + 65.7987, y + 96.8377);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 62.2137, y + 89.9899);
ctx.bezierCurveTo(x + 62.9307, y + 89.9497, x + 63.5679, y + 90.5539, x + 63.6078, y + 91.3192);
ctx.bezierCurveTo(x + 63.6476, y + 92.0846, x + 63.0103, y + 92.7694, x + 62.2934, y + 92.7694);
ctx.bezierCurveTo(x + 61.5764, y + 92.7694, x + 60.9392, y + 92.1652, x + 60.8993, y + 91.3998);
ctx.bezierCurveTo(x + 60.8595, y + 90.6345, x + 61.457, y + 89.9899, x + 62.2137, y + 89.9899);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 76.5131, y + 70.01);
ctx.bezierCurveTo(x + 76.5131, y + 70.7753, x + 75.9157, y + 71.4198, x + 75.1589, y + 71.4198);
ctx.bezierCurveTo(x + 74.442, y + 71.4198, x + 73.8047, y + 70.8156, x + 73.8047, y + 70.0502);
ctx.bezierCurveTo(x + 73.8047, y + 69.2849, x + 74.4021, y + 68.6404, x + 75.1589, y + 68.6404);
ctx.bezierCurveTo(x + 75.8758, y + 68.6404, x + 76.4733, y + 69.2849, x + 76.5131, y + 70.01);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 90.135, y + 72.9909);
ctx.bezierCurveTo(x + 90.1748, y + 73.7563, x + 89.5375, y + 74.4008, x + 88.8206, y + 74.4411);
ctx.bezierCurveTo(x + 88.1037, y + 74.4411, x + 87.4664, y + 73.8368, x + 87.4266, y + 73.0715);
ctx.bezierCurveTo(x + 87.3867, y + 72.3061, x + 88.024, y + 71.6616, x + 88.741, y + 71.6213);
ctx.bezierCurveTo(x + 89.4977, y + 71.6213, x + 90.0952, y + 72.2659, x + 90.135, y + 72.9909);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 93.6801, y + 76.3342);
ctx.bezierCurveTo(x + 93.7199, y + 77.0995, x + 93.1225, y + 77.7441, x + 92.3657, y + 77.7441);
ctx.bezierCurveTo(x + 91.609, y + 77.7843, x + 90.9717, y + 77.1398, x + 90.9717, y + 76.3745);
ctx.bezierCurveTo(x + 90.9717, y + 75.6091, x + 91.5691, y + 74.9646, x + 92.2861, y + 74.9646);
ctx.bezierCurveTo(x + 93.0428, y + 74.9646, x + 93.6403, y + 75.6091, x + 93.6801, y + 76.3342);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 95.9501, y + 85.3977);
ctx.bezierCurveTo(x + 96.6671, y + 85.3574, x + 97.3043, y + 85.9616, x + 97.3442, y + 86.727);
ctx.bezierCurveTo(x + 97.384, y + 87.4923, x + 96.7865, y + 88.1368, x + 96.0298, y + 88.1771);
ctx.bezierCurveTo(x + 95.3128, y + 88.2174, x + 94.6756, y + 87.6132, x + 94.6357, y + 86.8478);
ctx.bezierCurveTo(x + 94.6357, y + 86.0824, x + 95.2332, y + 85.4379, x + 95.9501, y + 85.3977);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 80.974, y + 104.733);
ctx.bezierCurveTo(x + 81.0138, y + 105.498, x + 80.4164, y + 106.143, x + 79.6596, y + 106.183);
ctx.bezierCurveTo(x + 78.9427, y + 106.223, x + 78.3054, y + 105.579, x + 78.2656, y + 104.854);
ctx.bezierCurveTo(x + 78.2257, y + 104.089, x + 78.8232, y + 103.444, x + 79.5799, y + 103.404);
ctx.bezierCurveTo(x + 80.3367, y + 103.363, x + 80.974, y + 103.968, x + 80.974, y + 104.733);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 89.7367, y + 102.276);
ctx.bezierCurveTo(x + 89.0198, y + 102.316, x + 88.3825, y + 101.712, x + 88.3427, y + 100.946);
ctx.bezierCurveTo(x + 88.3029, y + 100.181, x + 88.9003, y + 99.5366, x + 89.6173, y + 99.4963);
ctx.bezierCurveTo(x + 90.3342, y + 99.456, x + 90.9715, y + 100.06, x + 91.0113, y + 100.826);
ctx.bezierCurveTo(x + 91.0511, y + 101.591, x + 90.4537, y + 102.235, x + 89.7367, y + 102.276);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 83.1247, y + 106.022);
ctx.bezierCurveTo(x + 82.4078, y + 106.022, x + 81.7705, y + 105.418, x + 81.7705, y + 104.653);
ctx.bezierCurveTo(x + 81.7705, y + 103.927, x + 82.368, y + 103.283, x + 83.0849, y + 103.283);
ctx.bezierCurveTo(x + 83.8018, y + 103.283, x + 84.4391, y + 103.887, x + 84.4391, y + 104.653);
ctx.bezierCurveTo(x + 84.3993, y + 105.378, x + 83.8417, y + 106.022, x + 83.1247, y + 106.022);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 95.87, y + 81.8931);
ctx.bezierCurveTo(x + 96.587, y + 81.8931, x + 97.2243, y + 82.5376, x + 97.2243, y + 83.2627);
ctx.bezierCurveTo(x + 97.2243, y + 83.9877, x + 96.6268, y + 84.6322, x + 95.9099, y + 84.6322);
ctx.bezierCurveTo(x + 95.1929, y + 84.6322, x + 94.5557, y + 83.9877, x + 94.5557, y + 83.2627);
ctx.bezierCurveTo(x + 94.5557, y + 82.4973, x + 95.1531, y + 81.8931, x + 95.87, y + 81.8931);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 94.357, y + 97.2809);
ctx.bezierCurveTo(x + 94.3968, y + 98.0462, x + 93.7994, y + 98.6907, x + 93.0824, y + 98.731);
ctx.bezierCurveTo(x + 92.3655, y + 98.7713, x + 91.6884, y + 98.1268, x + 91.6884, y + 97.4017);
ctx.bezierCurveTo(x + 91.6486, y + 96.6766, x + 92.246, y + 96.0321, x + 92.963, y + 95.9918);
ctx.bezierCurveTo(x + 93.6401, y + 95.9113, x + 94.3172, y + 96.5155, x + 94.357, y + 97.2809);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 96.189, y + 91.6011);
ctx.bezierCurveTo(x + 95.472, y + 91.6414, x + 94.7949, y + 90.9968, x + 94.7949, y + 90.2718);
ctx.bezierCurveTo(x + 94.7949, y + 89.5467, x + 95.3525, y + 88.9022, x + 96.0695, y + 88.8619);
ctx.bezierCurveTo(x + 96.7864, y + 88.8216, x + 97.4635, y + 89.4661, x + 97.4635, y + 90.1912);
ctx.bezierCurveTo(x + 97.5033, y + 90.9566, x + 96.9059, y + 91.6011, x + 96.189, y + 91.6011);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 76.2344, y + 103.484);
ctx.bezierCurveTo(x + 76.9514, y + 103.444, x + 77.6285, y + 104.088, x + 77.6285, y + 104.814);
ctx.bezierCurveTo(x + 77.6285, y + 105.539, x + 77.0709, y + 106.183, x + 76.3539, y + 106.223);
ctx.bezierCurveTo(x + 75.637, y + 106.264, x + 74.9599, y + 105.619, x + 74.9599, y + 104.894);
ctx.bezierCurveTo(x + 74.9201, y + 104.169, x + 75.5175, y + 103.524, x + 76.2344, y + 103.484);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 61.8954, y + 82.2961);
ctx.bezierCurveTo(x + 61.1387, y + 82.2961, x + 60.5811, y + 81.6918, x + 60.5811, y + 80.9265);
ctx.bezierCurveTo(x + 60.5811, y + 80.1611, x + 61.1785, y + 79.5972, x + 61.9353, y + 79.5972);
ctx.bezierCurveTo(x + 62.6522, y + 79.5972, x + 63.2098, y + 80.2014, x + 63.2098, y + 80.9668);
ctx.bezierCurveTo(x + 63.2098, y + 81.6918, x + 62.6522, y + 82.2961, x + 61.8954, y + 82.2961);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 73.048, y + 70.1711);
ctx.bezierCurveTo(x + 73.048, y + 70.9365, x + 72.4505, y + 71.5004, x + 71.7336, y + 71.5004);
ctx.bezierCurveTo(x + 70.9768, y + 71.5004, x + 70.4192, y + 70.8962, x + 70.459, y + 70.1308);
ctx.bezierCurveTo(x + 70.459, y + 69.4057, x + 71.0565, y + 68.8015, x + 71.7734, y + 68.8015);
ctx.bezierCurveTo(x + 72.4505, y + 68.8015, x + 73.048, y + 69.4057, x + 73.048, y + 70.1711);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 63.6483, y + 94.864);
ctx.bezierCurveTo(x + 63.6881, y + 95.6293, x + 63.1305, y + 96.2336, x + 62.3737, y + 96.2336);
ctx.bezierCurveTo(x + 61.6568, y + 96.2336, x + 61.0594, y + 95.6696, x + 61.0195, y + 94.9043);
ctx.bezierCurveTo(x + 61.0195, y + 94.1792, x + 61.5373, y + 93.5749, x + 62.2941, y + 93.5347);
ctx.bezierCurveTo(x + 63.0509, y + 93.5347, x + 63.6483, y + 94.0986, x + 63.6483, y + 94.864);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 95.7504, y + 78.4691);
ctx.bezierCurveTo(x + 96.5072, y + 78.4288, x + 97.0648, y + 78.9927, x + 97.1046, y + 79.7581);
ctx.bezierCurveTo(x + 97.1046, y + 80.4832, x + 96.5868, y + 81.0874, x + 95.8699, y + 81.1277);
ctx.bezierCurveTo(x + 95.1131, y + 81.168, x + 94.5555, y + 80.604, x + 94.5157, y + 79.8387);
ctx.bezierCurveTo(x + 94.4759, y + 79.0733, x + 95.0335, y + 78.5094, x + 95.7504, y + 78.4691);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 86.5897, y + 69.6474);
ctx.bezierCurveTo(x + 86.6295, y + 70.4128, x + 86.0719, y + 71.017, x + 85.3151, y + 71.017);
ctx.bezierCurveTo(x + 84.5584, y + 71.0573, x + 84.0008, y + 70.4531, x + 83.9609, y + 69.6877);
ctx.bezierCurveTo(x + 83.9609, y + 68.9626, x + 84.4787, y + 68.3584, x + 85.1957, y + 68.3181);
ctx.bezierCurveTo(x + 85.9923, y + 68.3584, x + 86.5897, y + 68.9224, x + 86.5897, y + 69.6474);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 74.1632, y + 104.975);
ctx.bezierCurveTo(x + 74.203, y + 105.7, x + 73.6454, y + 106.304, x + 72.9284, y + 106.344);
ctx.bezierCurveTo(x + 72.1717, y + 106.385, x + 71.614, y + 105.78, x + 71.5742, y + 105.015);
ctx.bezierCurveTo(x + 71.5742, y + 104.29, x + 72.1318, y + 103.686, x + 72.8488, y + 103.686);
ctx.bezierCurveTo(x + 73.5657, y + 103.645, x + 74.1233, y + 104.209, x + 74.1632, y + 104.975);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 94.9541, y + 93.7763);
ctx.bezierCurveTo(x + 94.9541, y + 93.0513, x + 95.5117, y + 92.447, x + 96.2287, y + 92.447);
ctx.bezierCurveTo(x + 96.9456, y + 92.447, x + 97.5032, y + 93.011, x + 97.543, y + 93.7763);
ctx.bezierCurveTo(x + 97.543, y + 94.5014, x + 96.9854, y + 95.1056, x + 96.2685, y + 95.1056);
ctx.bezierCurveTo(x + 95.5515, y + 95.1056, x + 94.9541, y + 94.5417, x + 94.9541, y + 93.7763);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 87.7052, y + 104.491);
ctx.bezierCurveTo(x + 87.745, y + 105.216, x + 87.1874, y + 105.821, x + 86.4705, y + 105.861);
ctx.bezierCurveTo(x + 85.7535, y + 105.901, x + 85.1561, y + 105.337, x + 85.1163, y + 104.572);
ctx.bezierCurveTo(x + 85.0764, y + 103.807, x + 85.6341, y + 103.243, x + 86.351, y + 103.202);
ctx.bezierCurveTo(x + 87.1078, y + 103.202, x + 87.7052, y + 103.726, x + 87.7052, y + 104.491);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 65.0024, y + 72.5075);
ctx.bezierCurveTo(x + 65.7193, y + 72.4672, x + 66.3167, y + 73.0715, x + 66.3167, y + 73.7965);
ctx.bezierCurveTo(x + 66.3167, y + 74.5216, x + 65.7989, y + 75.1258, x + 65.082, y + 75.1258);
ctx.bezierCurveTo(x + 64.3651, y + 75.1661, x + 63.7676, y + 74.5619, x + 63.7676, y + 73.8368);
ctx.bezierCurveTo(x + 63.7278, y + 73.152, x + 64.2854, y + 72.5478, x + 65.0024, y + 72.5075);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 92.2062, y + 74.2396);
ctx.bezierCurveTo(x + 91.5291, y + 74.2396, x + 90.9316, y + 73.6354, x + 90.9316, y + 72.9103);
ctx.bezierCurveTo(x + 90.9316, y + 72.1852, x + 91.5291, y + 71.581, x + 92.246, y + 71.6213);
ctx.bezierCurveTo(x + 92.9231, y + 71.6616, x + 93.5206, y + 72.2658, x + 93.4807, y + 72.9506);
ctx.bezierCurveTo(x + 93.4807, y + 73.6757, x + 92.8833, y + 74.2396, x + 92.2062, y + 74.2396);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 67.2327, y + 101.672);
ctx.bezierCurveTo(x + 67.2327, y + 102.397, x + 66.6751, y + 103.001, x + 65.998, y + 103.001);
ctx.bezierCurveTo(x + 65.281, y + 103.041, x + 64.6836, y + 102.437, x + 64.6836, y + 101.712);
ctx.bezierCurveTo(x + 64.6836, y + 100.987, x + 65.2412, y + 100.383, x + 65.9581, y + 100.383);
ctx.bezierCurveTo(x + 66.6352, y + 100.383, x + 67.1929, y + 100.947, x + 67.2327, y + 101.672);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 89.9358, y + 69.5669);
ctx.bezierCurveTo(x + 89.9358, y + 70.2919, x + 89.3782, y + 70.8962, x + 88.6613, y + 70.8962);
ctx.bezierCurveTo(x + 87.9842, y + 70.8962, x + 87.3867, y + 70.2919, x + 87.3867, y + 69.6071);
ctx.bezierCurveTo(x + 87.3867, y + 68.8821, x + 87.9443, y + 68.2778, x + 88.6613, y + 68.2778);
ctx.bezierCurveTo(x + 89.3384, y + 68.3181, x + 89.896, y + 68.8821, x + 89.9358, y + 69.5669);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 63.051, y + 77.3413);
ctx.bezierCurveTo(x + 63.0908, y + 78.0664, x + 62.4934, y + 78.6706, x + 61.8163, y + 78.6706);
ctx.bezierCurveTo(x + 61.1392, y + 78.7109, x + 60.5417, y + 78.1066, x + 60.5019, y + 77.4218);
ctx.bezierCurveTo(x + 60.4621, y + 76.6968, x + 61.0595, y + 76.0925, x + 61.7366, y + 76.0925);
ctx.bezierCurveTo(x + 62.4535, y + 76.0925, x + 63.051, y + 76.6565, x + 63.051, y + 77.3413);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 69.6223, y + 70.2517);
ctx.bezierCurveTo(x + 69.6223, y + 70.9767, x + 69.0647, y + 71.581, x + 68.3876, y + 71.581);
ctx.bezierCurveTo(x + 67.7105, y + 71.581, x + 67.1131, y + 71.017, x + 67.0732, y + 70.292);
ctx.bezierCurveTo(x + 67.0732, y + 69.5669, x + 67.6309, y + 68.9626, x + 68.308, y + 68.9626);
ctx.bezierCurveTo(x + 69.0249, y + 68.9626, x + 69.6223, y + 69.5266, x + 69.6223, y + 70.2517);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 63.7279, y + 98.2878);
ctx.bezierCurveTo(x + 63.7677, y + 98.9726, x + 63.2101, y + 99.6171, x + 62.4931, y + 99.6574);
ctx.bezierCurveTo(x + 61.816, y + 99.6977, x + 61.2186, y + 99.1337, x + 61.1788, y + 98.4087);
ctx.bezierCurveTo(x + 61.1389, y + 97.7239, x + 61.6966, y + 97.0793, x + 62.4135, y + 97.0391);
ctx.bezierCurveTo(x + 63.0906, y + 97.0391, x + 63.688, y + 97.603, x + 63.7279, y + 98.2878);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 94.3969, y + 100.785);
ctx.bezierCurveTo(x + 94.3969, y + 101.51, x + 93.7995, y + 102.074, x + 93.1223, y + 102.074);
ctx.bezierCurveTo(x + 92.4452, y + 102.034, x + 91.8478, y + 101.43, x + 91.8876, y + 100.745);
ctx.bezierCurveTo(x + 91.9275, y + 100.06, x + 92.4851, y + 99.456, x + 93.1622, y + 99.4963);
ctx.bezierCurveTo(x + 93.7995, y + 99.4963, x + 94.3969, y + 100.101, x + 94.3969, y + 100.785);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 95.1133, y + 97.2407);
ctx.bezierCurveTo(x + 95.1133, y + 96.5559, x + 95.6709, y + 95.9517, x + 96.348, y + 95.9517);
ctx.bezierCurveTo(x + 97.0251, y + 95.9517, x + 97.6226, y + 96.5156, x + 97.6226, y + 97.2407);
ctx.bezierCurveTo(x + 97.6226, y + 97.9255, x + 97.0649, y + 98.5297, x + 96.3878, y + 98.5297);
ctx.bezierCurveTo(x + 95.6709, y + 98.4894, x + 95.1133, y + 97.9255, x + 95.1133, y + 97.2407);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 95.7109, y + 77.5426);
ctx.bezierCurveTo(x + 95.0338, y + 77.5829, x + 94.4364, y + 77.019, x + 94.3965, y + 76.3342);
ctx.bezierCurveTo(x + 94.3567, y + 75.6494, x + 94.9143, y + 75.0049, x + 95.6313, y + 74.9646);
ctx.bezierCurveTo(x + 96.3084, y + 74.9646, x + 96.9058, y + 75.5285, x + 96.9058, y + 76.2133);
ctx.bezierCurveTo(x + 96.9456, y + 76.9384, x + 96.388, y + 77.5426, x + 95.7109, y + 77.5426);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 89.7369, y + 103.162);
ctx.bezierCurveTo(x + 90.414, y + 103.122, x + 91.0114, y + 103.686, x + 91.0114, y + 104.411);
ctx.bezierCurveTo(x + 91.0513, y + 105.095, x + 90.4936, y + 105.7, x + 89.8165, y + 105.74);
ctx.bezierCurveTo(x + 89.1394, y + 105.78, x + 88.542, y + 105.216, x + 88.542, y + 104.491);
ctx.bezierCurveTo(x + 88.542, y + 103.766, x + 89.0598, y + 103.162, x + 89.7369, y + 103.162);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 60.024, y + 87.9756);
ctx.bezierCurveTo(x + 60.0638, y + 88.6604, x + 59.5062, y + 89.2646, x + 58.8291, y + 89.3049);
ctx.bezierCurveTo(x + 58.152, y + 89.3452, x + 57.5545, y + 88.7813, x + 57.5147, y + 88.0965);
ctx.bezierCurveTo(x + 57.4749, y + 87.4117, x + 58.0325, y + 86.8075, x + 58.7096, y + 86.7672);
ctx.bezierCurveTo(x + 59.3867, y + 86.7269, x + 59.9841, y + 87.2908, x + 60.024, y + 87.9756);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 70.7378, y + 105.055);
ctx.bezierCurveTo(x + 70.7776, y + 105.74, x + 70.22, y + 106.344, x + 69.5429, y + 106.385);
ctx.bezierCurveTo(x + 68.8658, y + 106.425, x + 68.2285, y + 105.821, x + 68.2285, y + 105.136);
ctx.bezierCurveTo(x + 68.2285, y + 104.451, x + 68.7861, y + 103.847, x + 69.4632, y + 103.807);
ctx.bezierCurveTo(x + 70.1403, y + 103.807, x + 70.7378, y + 104.371, x + 70.7378, y + 105.055);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 78.3453, y + 65.1358);
ctx.bezierCurveTo(x + 79.0224, y + 65.0955, x + 79.6199, y + 65.6595, x + 79.6199, y + 66.3846);
ctx.bezierCurveTo(x + 79.6199, y + 67.1096, x + 79.1021, y + 67.6736, x + 78.425, y + 67.6736);
ctx.bezierCurveTo(x + 77.7479, y + 67.6736, x + 77.1903, y + 67.1499, x + 77.1504, y + 66.4651);
ctx.bezierCurveTo(x + 77.1106, y + 65.74, x + 77.6682, y + 65.1761, x + 78.3453, y + 65.1358);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 80.9736, y + 108.157);
ctx.bezierCurveTo(x + 81.0134, y + 108.842, x + 80.4956, y + 109.446, x + 79.8185, y + 109.446);
ctx.bezierCurveTo(x + 79.1016, y + 109.486, x + 78.5439, y + 108.922, x + 78.5439, y + 108.238);
ctx.bezierCurveTo(x + 78.5439, y + 107.553, x + 79.0219, y + 106.989, x + 79.7388, y + 106.948);
ctx.bezierCurveTo(x + 80.4159, y + 106.948, x + 80.9337, y + 107.472, x + 80.9736, y + 108.157);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 100.65, y + 86.6464);
ctx.bezierCurveTo(x + 100.65, y + 87.3312, x + 100.172, y + 87.8952, x + 99.4554, y + 87.9355);
ctx.bezierCurveTo(x + 98.7783, y + 87.9355, x + 98.2207, y + 87.4118, x + 98.2207, y + 86.727);
ctx.bezierCurveTo(x + 98.2207, y + 86.0422, x + 98.6987, y + 85.4782, x + 99.4156, y + 85.438);
ctx.bezierCurveTo(x + 100.093, y + 85.3977, x + 100.65, y + 85.9214, x + 100.65, y + 86.6464);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 81.7705, y + 65.0554);
ctx.bezierCurveTo(x + 82.4476, y + 65.0151, x + 83.0052, y + 65.5388, x + 83.045, y + 66.2639);
ctx.bezierCurveTo(x + 83.0849, y + 66.9889, x + 82.5671, y + 67.5529, x + 81.8502, y + 67.5932);
ctx.bezierCurveTo(x + 81.173, y + 67.5932, x + 80.6154, y + 67.0695, x + 80.6154, y + 66.3847);
ctx.bezierCurveTo(x + 80.5756, y + 65.6193, x + 81.0934, y + 65.0554, x + 81.7705, y + 65.0554);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 77.6279, y + 108.318);
ctx.bezierCurveTo(x + 77.6279, y + 109.003, x + 77.1101, y + 109.567, x + 76.433, y + 109.567);
ctx.bezierCurveTo(x + 75.7559, y + 109.567, x + 75.1982, y + 109.043, x + 75.1982, y + 108.358);
ctx.bezierCurveTo(x + 75.1982, y + 107.674, x + 75.716, y + 107.11, x + 76.3931, y + 107.11);
ctx.bezierCurveTo(x + 77.0702, y + 107.069, x + 77.588, y + 107.593, x + 77.6279, y + 108.318);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 84.3998, y + 108.076);
ctx.bezierCurveTo(x + 84.4396, y + 108.761, x + 83.9218, y + 109.325, x + 83.2447, y + 109.365);
ctx.bezierCurveTo(x + 82.5676, y + 109.365, x + 82.01, y + 108.842, x + 82.01, y + 108.157);
ctx.bezierCurveTo(x + 81.9701, y + 107.472, x + 82.4879, y + 106.908, x + 83.165, y + 106.868);
ctx.bezierCurveTo(x + 83.8421, y + 106.828, x + 84.3998, y + 107.351, x + 84.3998, y + 108.076);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 59.9042, y + 84.4309);
ctx.bezierCurveTo(x + 59.944, y + 85.1559, x + 59.4263, y + 85.7199, x + 58.7093, y + 85.7602);
ctx.bezierCurveTo(x + 58.0322, y + 85.8005, x + 57.4746, y + 85.2768, x + 57.4348, y + 84.5517);
ctx.bezierCurveTo(x + 57.3949, y + 83.8266, x + 57.9127, y + 83.2627, x + 58.6297, y + 83.2224);
ctx.bezierCurveTo(x + 59.3068, y + 83.2224, x + 59.8644, y + 83.7461, x + 59.9042, y + 84.4309);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 100.53, y + 83.1015);
ctx.bezierCurveTo(x + 100.53, y + 83.7863, x + 100.012, y + 84.3503, x + 99.3353, y + 84.3503);
ctx.bezierCurveTo(x + 98.6582, y + 84.3503, x + 98.1006, y + 83.8266, x + 98.1006, y + 83.1418);
ctx.bezierCurveTo(x + 98.1006, y + 82.457, x + 98.6184, y + 81.8931, x + 99.2955, y + 81.8931);
ctx.bezierCurveTo(x + 100.012, y + 81.8931, x + 100.53, y + 82.4167, x + 100.53, y + 83.1015);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 58.8291, y + 90.2315);
ctx.bezierCurveTo(x + 59.5062, y + 90.1912, x + 60.1036, y + 90.7552, x + 60.1036, y + 91.44);
ctx.bezierCurveTo(x + 60.1435, y + 92.1248, x + 59.6257, y + 92.6887, x + 58.9486, y + 92.729);
ctx.bezierCurveTo(x + 58.2715, y + 92.7693, x + 57.674, y + 92.2053, x + 57.674, y + 91.5205);
ctx.bezierCurveTo(x + 57.6342, y + 90.7955, x + 58.152, y + 90.2315, x + 58.8291, y + 90.2315);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 76.2741, y + 66.5053);
ctx.bezierCurveTo(x + 76.2741, y + 67.2304, x + 75.7563, y + 67.7944, x + 75.0394, y + 67.7944);
ctx.bezierCurveTo(x + 74.3623, y + 67.7944, x + 73.8047, y + 67.2707, x + 73.8047, y + 66.5456);
ctx.bezierCurveTo(x + 73.8047, y + 65.8205, x + 74.3225, y + 65.2566, x + 75.0394, y + 65.2566);
ctx.bezierCurveTo(x + 75.7165, y + 65.2566, x + 76.2343, y + 65.7803, x + 76.2741, y + 66.5053);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 100.769, y + 90.1106);
ctx.bezierCurveTo(x + 100.769, y + 90.7954, x + 100.252, y + 91.3593, x + 99.5746, y + 91.3593);
ctx.bezierCurveTo(x + 98.8975, y + 91.3593, x + 98.3797, y + 90.8356, x + 98.3398, y + 90.1106);
ctx.bezierCurveTo(x + 98.3398, y + 89.4258, x + 98.8576, y + 88.9021, x + 99.5347, y + 88.8618);
ctx.bezierCurveTo(x + 100.212, y + 88.8618, x + 100.769, y + 89.3855, x + 100.769, y + 90.1106);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 60.1828, y + 94.9446);
ctx.bezierCurveTo(x + 60.2226, y + 95.6294, x + 59.7048, y + 96.1934, x + 59.0675, y + 96.2336);
ctx.bezierCurveTo(x + 58.3904, y + 96.2739, x + 57.8328, y + 95.71, x + 57.793, y + 95.0252);
ctx.bezierCurveTo(x + 57.793, y + 94.3404, x + 58.3108, y + 93.7764, x + 58.948, y + 93.7764);
ctx.bezierCurveTo(x + 59.6251, y + 93.7362, x + 60.1828, y + 94.3001, x + 60.1828, y + 94.9446);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 85.1561, y + 64.9343);
ctx.bezierCurveTo(x + 85.7934, y + 64.9343, x + 86.351, y + 65.458, x + 86.3908, y + 66.1428);
ctx.bezierCurveTo(x + 86.3908, y + 66.8276, x + 85.873, y + 67.3915, x + 85.1959, y + 67.3915);
ctx.bezierCurveTo(x + 84.5586, y + 67.3915, x + 84.001, y + 66.8276, x + 84.001, y + 66.1831);
ctx.bezierCurveTo(x + 83.9612, y + 65.5386, x + 84.5188, y + 64.9746, x + 85.1561, y + 64.9343);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 64.9625, y + 71.6213);
ctx.bezierCurveTo(x + 64.3252, y + 71.6616, x + 63.7277, y + 71.138, x + 63.7277, y + 70.4532);
ctx.bezierCurveTo(x + 63.6879, y + 69.7684, x + 64.2057, y + 69.1641, x + 64.8828, y + 69.1641);
ctx.bezierCurveTo(x + 65.5201, y + 69.1239, x + 66.0777, y + 69.6878, x + 66.1175, y + 70.3323);
ctx.bezierCurveTo(x + 66.1574, y + 71.0171, x + 65.6396, y + 71.5811, x + 64.9625, y + 71.6213);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 59.7443, y + 81.007);
ctx.bezierCurveTo(x + 59.7443, y + 81.6918, x + 59.2265, y + 82.2558, x + 58.5494, y + 82.2558);
ctx.bezierCurveTo(x + 57.9121, y + 82.2558, x + 57.3545, y + 81.7321, x + 57.3545, y + 81.0473);
ctx.bezierCurveTo(x + 57.3545, y + 80.3625, x + 57.8723, y + 79.7986, x + 58.5494, y + 79.7986);
ctx.bezierCurveTo(x + 59.1867, y + 79.7986, x + 59.7443, y + 80.3625, x + 59.7443, y + 81.007);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 62.8917, y + 73.9174);
ctx.bezierCurveTo(x + 62.9316, y + 74.6022, x + 62.4138, y + 75.1662, x + 61.7367, y + 75.2064);
ctx.bezierCurveTo(x + 61.0596, y + 75.2467, x + 60.502, y + 74.6828, x + 60.502, y + 73.998);
ctx.bezierCurveTo(x + 60.502, y + 73.3132, x + 61.0197, y + 72.7492, x + 61.657, y + 72.7492);
ctx.bezierCurveTo(x + 62.2943, y + 72.709, x + 62.8519, y + 73.2326, x + 62.8917, y + 73.9174);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 72.8089, y + 66.5859);
ctx.bezierCurveTo(x + 72.8488, y + 67.2707, x + 72.331, y + 67.8346, x + 71.6539, y + 67.8749);
ctx.bezierCurveTo(x + 70.9768, y + 67.8749, x + 70.459, y + 67.3512, x + 70.4191, y + 66.7067);
ctx.bezierCurveTo(x + 70.3793, y + 66.0219, x + 70.8971, y + 65.458, x + 71.5742, y + 65.4177);
ctx.bezierCurveTo(x + 72.2513, y + 65.3774, x + 72.7691, y + 65.9011, x + 72.8089, y + 66.5859);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 92.1664, y + 70.6947);
ctx.bezierCurveTo(x + 91.5291, y + 70.735, x + 90.9317, y + 70.1711, x + 90.9317, y + 69.5266);
ctx.bezierCurveTo(x + 90.8919, y + 68.8418, x + 91.4495, y + 68.2778, x + 92.0868, y + 68.2375);
ctx.bezierCurveTo(x + 92.724, y + 68.2375, x + 93.2817, y + 68.7612, x + 93.3215, y + 69.4057);
ctx.bezierCurveTo(x + 93.3215, y + 70.0905, x + 92.8037, y + 70.6545, x + 92.1664, y + 70.6947);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 66.0379, y + 104.008);
ctx.bezierCurveTo(x + 66.6751, y + 104.008, x + 67.2328, y + 104.572, x + 67.2328, y + 105.217);
ctx.bezierCurveTo(x + 67.2328, y + 105.861, x + 66.715, y + 106.425, x + 66.0777, y + 106.425);
ctx.bezierCurveTo(x + 65.4404, y + 106.425, x + 64.8828, y + 105.861, x + 64.8828, y + 105.217);
ctx.bezierCurveTo(x + 64.8828, y + 104.572, x + 65.4006, y + 104.008, x + 66.0379, y + 104.008);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 95.5513, y + 71.5811);
ctx.bezierCurveTo(x + 96.1886, y + 71.5811, x + 96.7462, y + 72.145, x + 96.7462, y + 72.7895);
ctx.bezierCurveTo(x + 96.7462, y + 73.4743, x + 96.1886, y + 74.0383, x + 95.5513, y + 73.998);
ctx.bezierCurveTo(x + 94.9141, y + 73.998, x + 94.3963, y + 73.434, x + 94.3564, y + 72.7895);
ctx.bezierCurveTo(x + 94.3564, y + 72.1853, x + 94.9141, y + 71.5811, x + 95.5513, y + 71.5811);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 63.7677, y + 101.752);
ctx.bezierCurveTo(x + 63.7677, y + 102.437, x + 63.2499, y + 103.001, x + 62.6127, y + 103.001);
ctx.bezierCurveTo(x + 61.9754, y + 103.001, x + 61.4178, y + 102.437, x + 61.3779, y + 101.792);
ctx.bezierCurveTo(x + 61.3779, y + 101.148, x + 61.8957, y + 100.584, x + 62.533, y + 100.544);
ctx.bezierCurveTo(x + 63.1703, y + 100.544, x + 63.7677, y + 101.108, x + 63.7677, y + 101.752);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 73.0082, y + 109.647);
ctx.bezierCurveTo(x + 72.3709, y + 109.688, x + 71.7735, y + 109.124, x + 71.7735, y + 108.479);
ctx.bezierCurveTo(x + 71.7337, y + 107.835, x + 72.2913, y + 107.23, x + 72.9286, y + 107.19);
ctx.bezierCurveTo(x + 73.5658, y + 107.15, x + 74.1235, y + 107.674, x + 74.1633, y + 108.358);
ctx.bezierCurveTo(x + 74.2031, y + 109.043, x + 73.6853, y + 109.607, x + 73.0082, y + 109.647);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 85.3555, y + 107.956);
ctx.bezierCurveTo(x + 85.3555, y + 107.271, x + 85.9131, y + 106.747, x + 86.5902, y + 106.747);
ctx.bezierCurveTo(x + 87.2275, y + 106.787, x + 87.7851, y + 107.351, x + 87.7453, y + 107.996);
ctx.bezierCurveTo(x + 87.7054, y + 108.64, x + 87.1876, y + 109.204, x + 86.5504, y + 109.164);
ctx.bezierCurveTo(x + 85.8733, y + 109.204, x + 85.3555, y + 108.64, x + 85.3555, y + 107.956);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 98.0215, y + 79.6777);
ctx.bezierCurveTo(x + 98.0215, y + 78.9929, x + 98.5791, y + 78.429, x + 99.2164, y + 78.429);
ctx.bezierCurveTo(x + 99.8536, y + 78.429, x + 100.411, y + 78.9929, x + 100.411, y + 79.6777);
ctx.bezierCurveTo(x + 100.411, y + 80.3222, x + 99.8537, y + 80.8862, x + 99.2562, y + 80.8862);
ctx.bezierCurveTo(x + 98.5791, y + 80.9264, x + 98.0215, y + 80.3625, x + 98.0215, y + 79.6777);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 99.6541, y + 92.447);
ctx.bezierCurveTo(x + 100.291, y + 92.447, x + 100.849, y + 93.011, x + 100.889, y + 93.6555);
ctx.bezierCurveTo(x + 100.889, y + 94.3, x + 100.371, y + 94.8639, x + 99.7338, y + 94.8639);
ctx.bezierCurveTo(x + 99.0965, y + 94.8639, x + 98.5389, y + 94.3, x + 98.499, y + 93.6555);
ctx.bezierCurveTo(x + 98.499, y + 93.011, x + 99.0168, y + 92.447, x + 99.6541, y + 92.447);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 94.3968, y + 104.29);
ctx.bezierCurveTo(x + 94.3968, y + 104.934, x + 93.879, y + 105.498, x + 93.2816, y + 105.539);
ctx.bezierCurveTo(x + 92.6443, y + 105.579, x + 92.0469, y + 105.015, x + 92.0469, y + 104.33);
ctx.bezierCurveTo(x + 92.0469, y + 103.686, x + 92.5647, y + 103.122, x + 93.2019, y + 103.122);
ctx.bezierCurveTo(x + 93.8392, y + 103.081, x + 94.3968, y + 103.645, x + 94.3968, y + 104.29);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 95.3125, y + 100.705);
ctx.bezierCurveTo(x + 95.3125, y + 100.06, x + 95.8303, y + 99.4964, x + 96.4277, y + 99.4561);
ctx.bezierCurveTo(x + 97.065, y + 99.4159, x + 97.6625, y + 99.9798, x + 97.6625, y + 100.665);
ctx.bezierCurveTo(x + 97.6625, y + 101.309, x + 97.1447, y + 101.873, x + 96.5074, y + 101.873);
ctx.bezierCurveTo(x + 95.8701, y + 101.873, x + 95.3125, y + 101.349, x + 95.3125, y + 100.705);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 59.5853, y + 77.5024);
ctx.bezierCurveTo(x + 59.5853, y + 78.1469, x + 59.0675, y + 78.7108, x + 58.4302, y + 78.7108);
ctx.bezierCurveTo(x + 57.793, y + 78.7108, x + 57.2354, y + 78.1872, x + 57.2354, y + 77.5427);
ctx.bezierCurveTo(x + 57.2354, y + 76.8982, x + 57.7133, y + 76.3745, x + 58.3506, y + 76.3342);
ctx.bezierCurveTo(x + 59.0277, y + 76.2939, x + 59.5853, y + 76.8176, x + 59.5853, y + 77.5024);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 89.6971, y + 66.0222);
ctx.bezierCurveTo(x + 89.7369, y + 66.6667, x + 89.2589, y + 67.2306, x + 88.6216, y + 67.2306);
ctx.bezierCurveTo(x + 87.9445, y + 67.2709, x + 87.4268, y + 66.7472, x + 87.4268, y + 66.1027);
ctx.bezierCurveTo(x + 87.4268, y + 65.4582, x + 87.9047, y + 64.9346, x + 88.542, y + 64.8943);
ctx.bezierCurveTo(x + 89.1394, y + 64.854, x + 89.6572, y + 65.3776, x + 89.6971, y + 66.0222);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 59.068, y + 97.2809);
ctx.bezierCurveTo(x + 59.7052, y + 97.2406, x + 60.223, y + 97.724, x + 60.2628, y + 98.4088);
ctx.bezierCurveTo(x + 60.3027, y + 99.0936, x + 59.7849, y + 99.6173, x + 59.1476, y + 99.6173);
ctx.bezierCurveTo(x + 58.5103, y + 99.6173, x + 57.9926, y + 99.1339, x + 57.9926, y + 98.4894);
ctx.bezierCurveTo(x + 57.9527, y + 97.8449, x + 58.4307, y + 97.3212, x + 59.068, y + 97.2809);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 67.1133, y + 66.747);
ctx.bezierCurveTo(x + 67.1133, y + 66.0622, x + 67.6311, y + 65.5386, x + 68.2683, y + 65.5788);
ctx.bezierCurveTo(x + 68.9056, y + 65.5788, x + 69.3836, y + 66.1025, x + 69.3836, y + 66.747);
ctx.bezierCurveTo(x + 69.3836, y + 67.4318, x + 68.8658, y + 67.9555, x + 68.2285, y + 67.9152);
ctx.bezierCurveTo(x + 67.5912, y + 67.9152, x + 67.1133, y + 67.3915, x + 67.1133, y + 66.747);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 99.0961, y + 75.0049);
ctx.bezierCurveTo(x + 99.7333, y + 75.0049, x + 100.251, y + 75.4883, x + 100.251, y + 76.1328);
ctx.bezierCurveTo(x + 100.291, y + 76.7773, x + 99.813, y + 77.301, x + 99.1359, y + 77.3412);
ctx.bezierCurveTo(x + 98.4986, y + 77.3815, x + 97.9808, y + 76.8579, x + 97.9808, y + 76.2133);
ctx.bezierCurveTo(x + 97.941, y + 75.5285, x + 98.419, y + 75.0049, x + 99.0961, y + 75.0049);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 70.7381, y + 108.519);
ctx.bezierCurveTo(x + 70.7381, y + 109.164, x + 70.2601, y + 109.688, x + 69.6228, y + 109.688);
ctx.bezierCurveTo(x + 68.9856, y + 109.688, x + 68.4678, y + 109.204, x + 68.4678, y + 108.56);
ctx.bezierCurveTo(x + 68.4678, y + 107.915, x + 68.9457, y + 107.392, x + 69.583, y + 107.392);
ctx.bezierCurveTo(x + 70.2203, y + 107.392, x + 70.7381, y + 107.875, x + 70.7381, y + 108.519);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 91.0506, y + 107.875);
ctx.bezierCurveTo(x + 91.0506, y + 108.52, x + 90.5726, y + 109.043, x + 89.8955, y + 109.043);
ctx.bezierCurveTo(x + 89.2582, y + 109.043, x + 88.7803, y + 108.52, x + 88.7803, y + 107.875);
ctx.bezierCurveTo(x + 88.7803, y + 107.231, x + 89.2582, y + 106.747, x + 89.8955, y + 106.747);
ctx.bezierCurveTo(x + 90.5328, y + 106.707, x + 91.0107, y + 107.19, x + 91.0506, y + 107.875);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 100.929, y + 97.0796);
ctx.bezierCurveTo(x + 100.929, y + 97.7241, x + 100.451, y + 98.2477, x + 99.8135, y + 98.2477);
ctx.bezierCurveTo(x + 99.216, y + 98.2477, x + 98.6982, y + 97.7644, x + 98.6982, y + 97.1198);
ctx.bezierCurveTo(x + 98.6982, y + 96.4753, x + 99.1762, y + 95.9517, x + 99.8135, y + 95.9517);
ctx.bezierCurveTo(x + 100.411, y + 95.9517, x + 100.889, y + 96.435, x + 100.929, y + 97.0796);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 61.4973, y + 69.3655);
ctx.bezierCurveTo(x + 62.0947, y + 69.3252, x + 62.6523, y + 69.8488, x + 62.6523, y + 70.4531);
ctx.bezierCurveTo(x + 62.6922, y + 71.0976, x + 62.2142, y + 71.6213, x + 61.5769, y + 71.6615);
ctx.bezierCurveTo(x + 60.9795, y + 71.7018, x + 60.4219, y + 71.1782, x + 60.4219, y + 70.5739);
ctx.bezierCurveTo(x + 60.4219, y + 69.9697, x + 60.8998, y + 69.3655, x + 61.4973, y + 69.3655);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 78.2656, y + 61.7925);
ctx.bezierCurveTo(x + 78.8631, y + 61.7925, x + 79.3809, y + 62.2759, x + 79.4207, y + 62.9204);
ctx.bezierCurveTo(x + 79.4207, y + 63.5649, x + 78.9427, y + 64.0886, x + 78.3054, y + 64.0886);
ctx.bezierCurveTo(x + 77.708, y + 64.0886, x + 77.1902, y + 63.6052, x + 77.1504, y + 62.9607);
ctx.bezierCurveTo(x + 77.1504, y + 62.3564, x + 77.6682, y + 61.8328, x + 78.2656, y + 61.7925);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 55.3232, y + 87.009);
ctx.bezierCurveTo(x + 55.9207, y + 87.009, x + 56.4385, y + 87.4924, x + 56.4783, y + 88.1369);
ctx.bezierCurveTo(x + 56.4783, y + 88.7814, x + 56.0003, y + 89.3051, x + 55.3631, y + 89.3051);
ctx.bezierCurveTo(x + 54.7656, y + 89.3051, x + 54.2478, y + 88.8217, x + 54.208, y + 88.1772);
ctx.bezierCurveTo(x + 54.208, y + 87.5327, x + 54.7258, y + 87.009, x + 55.3232, y + 87.009);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 102.84, y + 87.6938);
ctx.bezierCurveTo(x + 102.243, y + 87.6938, x + 101.725, y + 87.2104, x + 101.725, y + 86.6062);
ctx.bezierCurveTo(x + 101.685, y + 86.0019, x + 102.203, y + 85.438, x + 102.8, y + 85.438);
ctx.bezierCurveTo(x + 103.398, y + 85.438, x + 103.915, y + 85.9617, x + 103.915, y + 86.5659);
ctx.bezierCurveTo(x + 103.915, y + 87.1298, x + 103.437, y + 87.6938, x + 102.84, y + 87.6938);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 55.4436, y + 90.4329);
ctx.bezierCurveTo(x + 56.041, y + 90.4329, x + 56.5588, y + 90.9565, x + 56.5588, y + 91.5608);
ctx.bezierCurveTo(x + 56.5588, y + 92.165, x + 56.041, y + 92.6886, x + 55.4834, y + 92.6886);
ctx.bezierCurveTo(x + 54.886, y + 92.6886, x + 54.3682, y + 92.165, x + 54.3682, y + 91.5608);
ctx.bezierCurveTo(x + 54.3682, y + 90.9565, x + 54.8461, y + 90.4731, x + 55.4436, y + 90.4329);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 62.7324, y + 106.465);
ctx.bezierCurveTo(x + 62.135, y + 106.506, x + 61.6172, y + 105.982, x + 61.5774, y + 105.378);
ctx.bezierCurveTo(x + 61.5375, y + 104.773, x + 62.0553, y + 104.209, x + 62.6528, y + 104.209);
ctx.bezierCurveTo(x + 63.2502, y + 104.209, x + 63.768, y + 104.693, x + 63.768, y + 105.297);
ctx.bezierCurveTo(x + 63.8078, y + 105.901, x + 63.3299, y + 106.425, x + 62.7324, y + 106.465);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 80.9738, y + 111.702);
ctx.bezierCurveTo(x + 81.0137, y + 112.306, x + 80.5357, y + 112.83, x + 79.9383, y + 112.87);
ctx.bezierCurveTo(x + 79.3408, y + 112.91, x + 78.7832, y + 112.387, x + 78.7832, y + 111.782);
ctx.bezierCurveTo(x + 78.7832, y + 111.178, x + 79.2612, y + 110.655, x + 79.8586, y + 110.614);
ctx.bezierCurveTo(x + 80.4162, y + 110.574, x + 80.934, y + 111.098, x + 80.9738, y + 111.702);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 58.311, y + 72.9102);
ctx.bezierCurveTo(x + 58.9084, y + 72.9102, x + 59.4262, y + 73.3935, x + 59.4262, y + 73.9978);
ctx.bezierCurveTo(x + 59.466, y + 74.602, x + 58.9482, y + 75.1659, x + 58.3508, y + 75.1659);
ctx.bezierCurveTo(x + 57.7533, y + 75.1659, x + 57.2356, y + 74.6423, x + 57.2356, y + 74.038);
ctx.bezierCurveTo(x + 57.1957, y + 73.4741, x + 57.7135, y + 72.9504, x + 58.311, y + 72.9102);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 56.3193, y + 84.5517);
ctx.bezierCurveTo(x + 56.3592, y + 85.1962, x + 55.8414, y + 85.7199, x + 55.2439, y + 85.7199);
ctx.bezierCurveTo(x + 54.6465, y + 85.7199, x + 54.1287, y + 85.2365, x + 54.0889, y + 84.592);
ctx.bezierCurveTo(x + 54.0889, y + 83.9878, x + 54.5668, y + 83.4641, x + 55.1643, y + 83.4238);
ctx.bezierCurveTo(x + 55.8015, y + 83.4238, x + 56.3193, y + 83.9475, x + 56.3193, y + 84.5517);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 95.432, y + 68.2375);
ctx.bezierCurveTo(x + 96.0295, y + 68.1972, x + 96.5871, y + 68.7209, x + 96.5871, y + 69.3654);
ctx.bezierCurveTo(x + 96.5871, y + 69.9696, x + 96.1092, y + 70.4933, x + 95.5117, y + 70.5336);
ctx.bezierCurveTo(x + 94.9143, y + 70.5336, x + 94.3566, y + 70.0502, x + 94.3566, y + 69.4057);
ctx.bezierCurveTo(x + 94.3168, y + 68.7612, x + 94.8346, y + 68.2375, x + 95.432, y + 68.2375);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 76.0354, y + 63.0412);
ctx.bezierCurveTo(x + 76.0354, y + 63.6857, x + 75.5574, y + 64.2094, x + 74.96, y + 64.2094);
ctx.bezierCurveTo(x + 74.3625, y + 64.2094, x + 73.8447, y + 63.6857, x + 73.8447, y + 63.0815);
ctx.bezierCurveTo(x + 73.8447, y + 62.4773, x + 74.3227, y + 61.9536, x + 74.9201, y + 61.9133);
ctx.bezierCurveTo(x + 75.4777, y + 61.9133, x + 76.0354, y + 62.3967, x + 76.0354, y + 63.0412);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 81.7303, y + 63.9677);
ctx.bezierCurveTo(x + 81.1328, y + 63.9677, x + 80.615, y + 63.444, x + 80.5752, y + 62.8398);
ctx.bezierCurveTo(x + 80.5752, y + 62.1953, x + 81.093, y + 61.6716, x + 81.6904, y + 61.6716);
ctx.bezierCurveTo(x + 82.2879, y + 61.6716, x + 82.8057, y + 62.155, x + 82.8057, y + 62.7995);
ctx.bezierCurveTo(x + 82.8455, y + 63.444, x + 82.3675, y + 63.9677, x + 81.7303, y + 63.9677);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 65.9182, y + 66.8679);
ctx.bezierCurveTo(x + 65.9182, y + 67.4721, x + 65.4004, y + 67.9958, x + 64.8428, y + 67.9958);
ctx.bezierCurveTo(x + 64.2453, y + 67.9958, x + 63.7275, y + 67.4721, x + 63.7275, y + 66.8679);
ctx.bezierCurveTo(x + 63.7275, y + 66.2637, x + 64.2453, y + 65.74, x + 64.8029, y + 65.74);
ctx.bezierCurveTo(x + 65.4004, y + 65.74, x + 65.9182, y + 66.2637, x + 65.9182, y + 66.8679);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 83.2438, y + 110.493);
ctx.bezierCurveTo(x + 83.8412, y + 110.453, x + 84.359, y + 110.977, x + 84.3989, y + 111.581);
ctx.bezierCurveTo(x + 84.4387, y + 112.185, x + 83.9607, y + 112.709, x + 83.3633, y + 112.749);
ctx.bezierCurveTo(x + 82.7658, y + 112.789, x + 82.248, y + 112.266, x + 82.2082, y + 111.662);
ctx.bezierCurveTo(x + 82.1684, y + 111.057, x + 82.6862, y + 110.534, x + 83.2438, y + 110.493);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 103.796, y + 82.9807);
ctx.bezierCurveTo(x + 103.836, y + 83.5849, x + 103.358, y + 84.1086, x + 102.761, y + 84.1489);
ctx.bezierCurveTo(x + 102.163, y + 84.1891, x + 101.646, y + 83.6655, x + 101.606, y + 83.0612);
ctx.bezierCurveTo(x + 101.566, y + 82.457, x + 102.044, y + 81.9333, x + 102.641, y + 81.8931);
ctx.bezierCurveTo(x + 103.239, y + 81.8931, x + 103.757, y + 82.3765, x + 103.796, y + 82.9807);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 104.035, y + 89.9899);
ctx.bezierCurveTo(x + 104.035, y + 90.5942, x + 103.557, y + 91.1178, x + 102.96, y + 91.1581);
ctx.bezierCurveTo(x + 102.363, y + 91.1581, x + 101.845, y + 90.6747, x + 101.845, y + 90.0705);
ctx.bezierCurveTo(x + 101.845, y + 89.4663, x + 102.323, y + 88.9426, x + 102.92, y + 88.9023);
ctx.bezierCurveTo(x + 103.478, y + 88.862, x + 103.996, y + 89.3857, x + 104.035, y + 89.9899);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 77.6281, y + 111.823);
ctx.bezierCurveTo(x + 77.6281, y + 112.427, x + 77.1502, y + 112.951, x + 76.5527, y + 112.991);
ctx.bezierCurveTo(x + 75.9553, y + 112.991, x + 75.4375, y + 112.508, x + 75.4375, y + 111.903);
ctx.bezierCurveTo(x + 75.4375, y + 111.299, x + 75.9155, y + 110.775, x + 76.5129, y + 110.735);
ctx.bezierCurveTo(x + 77.0705, y + 110.735, x + 77.5883, y + 111.218, x + 77.6281, y + 111.823);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 72.5695, y + 63.2024);
ctx.bezierCurveTo(x + 72.5695, y + 63.8066, x + 72.0518, y + 64.3303, x + 71.4543, y + 64.29);
ctx.bezierCurveTo(x + 70.8569, y + 64.2497, x + 70.3789, y + 63.7663, x + 70.3789, y + 63.1218);
ctx.bezierCurveTo(x + 70.4187, y + 62.5176, x + 70.8967, y + 62.0342, x + 71.4543, y + 62.0342);
ctx.bezierCurveTo(x + 72.0916, y + 62.0745, x + 72.5695, y + 62.5981, x + 72.5695, y + 63.2024);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 96.627, y + 105.297);
ctx.bezierCurveTo(x + 96.0295, y + 105.337, x + 95.5117, y + 104.814, x + 95.5117, y + 104.209);
ctx.bezierCurveTo(x + 95.5117, y + 103.605, x + 95.9897, y + 103.082, x + 96.5871, y + 103.082);
ctx.bezierCurveTo(x + 97.1846, y + 103.082, x + 97.6625, y + 103.565, x + 97.7024, y + 104.129);
ctx.bezierCurveTo(x + 97.7024, y + 104.773, x + 97.2244, y + 105.297, x + 96.627, y + 105.297);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 59.1867, y + 100.785);
ctx.bezierCurveTo(x + 59.7842, y + 100.785, x + 60.302, y + 101.269, x + 60.302, y + 101.873);
ctx.bezierCurveTo(x + 60.302, y + 102.477, x + 59.824, y + 103.001, x + 59.2266, y + 103.001);
ctx.bezierCurveTo(x + 58.6291, y + 103.001, x + 58.1512, y + 102.518, x + 58.1113, y + 101.913);
ctx.bezierCurveTo(x + 58.1113, y + 101.349, x + 58.5893, y + 100.826, x + 59.1867, y + 100.785);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 55.124, y + 82.2558);
ctx.bezierCurveTo(x + 54.5266, y + 82.2558, x + 54.0088, y + 81.7724, x + 54.0088, y + 81.1682);
ctx.bezierCurveTo(x + 54.0088, y + 80.5639, x + 54.4867, y + 80.0403, x + 55.0842, y + 80.0403);
ctx.bezierCurveTo(x + 55.6816, y + 80.0403, x + 56.1596, y + 80.5237, x + 56.1596, y + 81.1279);
ctx.bezierCurveTo(x + 56.1994, y + 81.7321, x + 55.7215, y + 82.2558, x + 55.124, y + 82.2558);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 93.0825, y + 65.9012);
ctx.bezierCurveTo(x + 93.1223, y + 66.5055, x + 92.6045, y + 67.0291, x + 92.0469, y + 67.0694);
ctx.bezierCurveTo(x + 91.4494, y + 67.0694, x + 90.9316, y + 66.586, x + 90.9316, y + 65.9818);
ctx.bezierCurveTo(x + 90.9316, y + 65.3776, x + 91.3698, y + 64.8942, x + 91.9672, y + 64.8539);
ctx.bezierCurveTo(x + 92.5248, y + 64.8136, x + 93.0426, y + 65.297, x + 93.0825, y + 65.9012);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 85.0366, y + 61.6313);
ctx.bezierCurveTo(x + 85.634, y + 61.6313, x + 86.1518, y + 62.1147, x + 86.1518, y + 62.719);
ctx.bezierCurveTo(x + 86.1518, y + 63.3232, x + 85.7137, y + 63.8066, x + 85.1162, y + 63.8469);
ctx.bezierCurveTo(x + 84.5188, y + 63.8469, x + 84.001, y + 63.3635, x + 84.001, y + 62.7592);
ctx.bezierCurveTo(x + 84.001, y + 62.1147, x + 84.4391, y + 61.6313, x + 85.0366, y + 61.6313);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 100.093, y + 72.6686);
ctx.bezierCurveTo(x + 100.132, y + 73.2728, x + 99.6544, y + 73.7965, x + 99.0968, y + 73.7965);
ctx.bezierCurveTo(x + 98.4994, y + 73.8367, x + 97.9816, y + 73.3534, x + 97.9418, y + 72.7491);
ctx.bezierCurveTo(x + 97.9019, y + 72.1449, x + 98.3799, y + 71.6212, x + 98.9773, y + 71.6212);
ctx.bezierCurveTo(x + 99.5748, y + 71.581, x + 100.053, y + 72.0643, x + 100.093, y + 72.6686);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 55.5623, y + 94.0181);
ctx.bezierCurveTo(x + 56.1598, y + 94.0181, x + 56.6775, y + 94.5015, x + 56.6775, y + 95.1057);
ctx.bezierCurveTo(x + 56.6775, y + 95.7099, x + 56.1996, y + 96.1933, x + 55.642, y + 96.1933);
ctx.bezierCurveTo(x + 55.0445, y + 96.1933, x + 54.5666, y + 95.7099, x + 54.5267, y + 95.1057);
ctx.bezierCurveTo(x + 54.4869, y + 94.5015, x + 54.9649, y + 94.0181, x + 55.5623, y + 94.0181);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 66.1176, y + 107.553);
ctx.bezierCurveTo(x + 66.7151, y + 107.513, x + 67.193, y + 107.996, x + 67.2328, y + 108.6);
ctx.bezierCurveTo(x + 67.2727, y + 109.204, x + 66.8345, y + 109.728, x + 66.1973, y + 109.768);
ctx.bezierCurveTo(x + 65.5998, y + 109.809, x + 65.082, y + 109.325, x + 65.082, y + 108.681);
ctx.bezierCurveTo(x + 65.082, y + 108.077, x + 65.5202, y + 107.593, x + 66.1176, y + 107.553);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 93.3607, y + 108.842);
ctx.bezierCurveTo(x + 92.7633, y + 108.842, x + 92.2853, y + 108.399, x + 92.2455, y + 107.794);
ctx.bezierCurveTo(x + 92.2057, y + 107.15, x + 92.6836, y + 106.667, x + 93.2811, y + 106.667);
ctx.bezierCurveTo(x + 93.8785, y + 106.667, x + 94.3565, y + 107.11, x + 94.3565, y + 107.754);
ctx.bezierCurveTo(x + 94.4361, y + 108.358, x + 93.9582, y + 108.842, x + 93.3607, y + 108.842);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 73.0881, y + 113.071);
ctx.bezierCurveTo(x + 72.4907, y + 113.071, x + 72.0127, y + 112.628, x + 72.0127, y + 111.984);
ctx.bezierCurveTo(x + 72.0127, y + 111.38, x + 72.4508, y + 110.896, x + 73.0483, y + 110.896);
ctx.bezierCurveTo(x + 73.6457, y + 110.896, x + 74.1237, y + 111.339, x + 74.1237, y + 111.984);
ctx.bezierCurveTo(x + 74.1635, y + 112.548, x + 73.6855, y + 113.031, x + 73.0881, y + 113.071);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 86.7092, y + 112.588);
ctx.bezierCurveTo(x + 86.1117, y + 112.588, x + 85.6338, y + 112.145, x + 85.6338, y + 111.541);
ctx.bezierCurveTo(x + 85.6338, y + 110.937, x + 86.0719, y + 110.453, x + 86.6694, y + 110.413);
ctx.bezierCurveTo(x + 87.2668, y + 110.413, x + 87.7448, y + 110.856, x + 87.7448, y + 111.46);
ctx.bezierCurveTo(x + 87.7448, y + 112.105, x + 87.3066, y + 112.588, x + 86.7092, y + 112.588);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 103.637, y + 79.5568);
ctx.bezierCurveTo(x + 103.637, y + 80.161, x + 103.199, y + 80.6444, x + 102.602, y + 80.6847);
ctx.bezierCurveTo(x + 102.004, y + 80.6847, x + 101.526, y + 80.2416, x + 101.526, y + 79.6373);
ctx.bezierCurveTo(x + 101.526, y + 79.0331, x + 101.964, y + 78.5497, x + 102.562, y + 78.5094);
ctx.bezierCurveTo(x + 103.159, y + 78.4691, x + 103.637, y + 78.9525, x + 103.637, y + 79.5568);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 104.115, y + 93.4943);
ctx.bezierCurveTo(x + 104.115, y + 94.0986, x + 103.677, y + 94.582, x + 103.079, y + 94.6222);
ctx.bezierCurveTo(x + 102.482, y + 94.6222, x + 102.004, y + 94.1791, x + 102.004, y + 93.5749);
ctx.bezierCurveTo(x + 102.004, y + 92.9707, x + 102.442, y + 92.4873, x + 103.039, y + 92.447);
ctx.bezierCurveTo(x + 103.597, y + 92.447, x + 104.075, y + 92.8901, x + 104.115, y + 93.4943);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 100.968, y + 100.544);
ctx.bezierCurveTo(x + 100.968, y + 101.148, x + 100.53, y + 101.631, x + 99.9326, y + 101.672);
ctx.bezierCurveTo(x + 99.3352, y + 101.672, x + 98.8572, y + 101.229, x + 98.8174, y + 100.584);
ctx.bezierCurveTo(x + 98.8174, y + 99.9798, x + 99.2555, y + 99.4964, x + 99.853, y + 99.4964);
ctx.bezierCurveTo(x + 100.49, y + 99.4562, x + 100.968, y + 99.8992, x + 100.968, y + 100.544);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 56.0409, y + 77.6233);
ctx.bezierCurveTo(x + 56.0409, y + 78.2275, x + 55.6027, y + 78.7109, x + 55.0451, y + 78.7109);
ctx.bezierCurveTo(x + 54.4477, y + 78.7109, x + 53.9697, y + 78.2678, x + 53.9697, y + 77.6233);
ctx.bezierCurveTo(x + 53.9697, y + 77.019, x + 54.4079, y + 76.5759, x + 55.0053, y + 76.5356);
ctx.bezierCurveTo(x + 55.5629, y + 76.5356, x + 56.0409, y + 77.019, x + 56.0409, y + 77.6233);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 69.1842, y + 63.2425);
ctx.bezierCurveTo(x + 69.2241, y + 63.8467, x + 68.7859, y + 64.3301, x + 68.1885, y + 64.3704);
ctx.bezierCurveTo(x + 67.591, y + 64.4107, x + 67.1131, y + 63.9273, x + 67.0732, y + 63.3231);
ctx.bezierCurveTo(x + 67.0732, y + 62.7188, x + 67.5114, y + 62.2355, x + 68.069, y + 62.2355);
ctx.bezierCurveTo(x + 68.6664, y + 62.1952, x + 69.1444, y + 62.6383, x + 69.1842, y + 63.2425);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 56.7176, y + 98.5295);
ctx.bezierCurveTo(x + 56.7176, y + 99.1337, x + 56.2795, y + 99.6171, x + 55.7219, y + 99.6171);
ctx.bezierCurveTo(x + 55.1643, y + 99.6171, x + 54.6863, y + 99.174, x + 54.6465, y + 98.5698);
ctx.bezierCurveTo(x + 54.6465, y + 97.9656, x + 55.0846, y + 97.4822, x + 55.6422, y + 97.4822);
ctx.bezierCurveTo(x + 56.2397, y + 97.4822, x + 56.7176, y + 97.9656, x + 56.7176, y + 98.5295);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 88.4615, y + 61.5508);
ctx.bezierCurveTo(x + 89.0191, y + 61.5508, x + 89.4971, y + 62.0744, x + 89.4573, y + 62.6384);
ctx.bezierCurveTo(x + 89.4573, y + 63.2426, x + 88.9793, y + 63.6857, x + 88.3819, y + 63.6857);
ctx.bezierCurveTo(x + 87.8242, y + 63.6857, x + 87.3463, y + 63.1621, x + 87.3861, y + 62.5981);
ctx.bezierCurveTo(x + 87.3861, y + 61.9939, x + 87.9039, y + 61.5508, x + 88.4615, y + 61.5508);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 59.2274, y + 70.6141);
ctx.bezierCurveTo(x + 59.2274, y + 71.1781, x + 58.7893, y + 71.6615, x + 58.2317, y + 71.7017);
ctx.bezierCurveTo(x + 57.674, y + 71.7017, x + 57.1562, y + 71.2184, x + 57.1562, y + 70.6544);
ctx.bezierCurveTo(x + 57.1562, y + 70.0905, x + 57.6342, y + 69.6071, x + 58.1918, y + 69.6071);
ctx.bezierCurveTo(x + 58.7494, y + 69.5668, x + 59.2274, y + 70.0502, x + 59.2274, y + 70.6141);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 103.478, y + 76.0119);
ctx.bezierCurveTo(x + 103.478, y + 76.5759, x + 103.04, y + 77.0593, x + 102.482, y + 77.0995);
ctx.bezierCurveTo(x + 101.924, y + 77.0995, x + 101.407, y + 76.6162, x + 101.446, y + 76.0522);
ctx.bezierCurveTo(x + 101.446, y + 75.4883, x + 101.924, y + 75.0049, x + 102.482, y + 75.0049);
ctx.bezierCurveTo(x + 103, y + 75.0049, x + 103.478, y + 75.4883, x + 103.478, y + 76.0119);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 69.7818, y + 113.152);
ctx.bezierCurveTo(x + 69.2242, y + 113.192, x + 68.7463, y + 112.709, x + 68.7064, y + 112.145);
ctx.bezierCurveTo(x + 68.6666, y + 111.581, x + 69.1446, y + 111.057, x + 69.7022, y + 111.017);
ctx.bezierCurveTo(x + 70.2598, y + 111.017, x + 70.7377, y + 111.46, x + 70.7776, y + 112.024);
ctx.bezierCurveTo(x + 70.7776, y + 112.588, x + 70.3394, y + 113.112, x + 69.7818, y + 113.152);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 60.3419, y + 105.418);
ctx.bezierCurveTo(x + 60.3817, y + 105.982, x + 59.9037, y + 106.465, x + 59.3461, y + 106.505);
ctx.bezierCurveTo(x + 58.7885, y + 106.505, x + 58.3105, y + 106.062, x + 58.3105, y + 105.498);
ctx.bezierCurveTo(x + 58.3105, y + 104.934, x + 58.7487, y + 104.451, x + 59.2665, y + 104.451);
ctx.bezierCurveTo(x + 59.8241, y + 104.37, x + 60.3419, y + 104.854, x + 60.3419, y + 105.418);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 103.16, y + 98.0463);
ctx.bezierCurveTo(x + 102.602, y + 98.0463, x + 102.124, y + 97.5629, x + 102.124, y + 96.999);
ctx.bezierCurveTo(x + 102.124, y + 96.435, x + 102.602, y + 95.9517, x + 103.12, y + 95.9517);
ctx.bezierCurveTo(x + 103.677, y + 95.9517, x + 104.155, y + 96.435, x + 104.155, y + 96.999);
ctx.bezierCurveTo(x + 104.195, y + 97.5227, x + 103.717, y + 98.0463, x + 103.16, y + 98.0463);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 91.0508, y + 111.38);
ctx.bezierCurveTo(x + 91.0508, y + 111.944, x + 90.5729, y + 112.427, x + 90.0551, y + 112.427);
ctx.bezierCurveTo(x + 89.4975, y + 112.427, x + 89.0195, y + 111.944, x + 89.0195, y + 111.38);
ctx.bezierCurveTo(x + 89.0195, y + 110.816, x + 89.4975, y + 110.332, x + 90.0153, y + 110.332);
ctx.bezierCurveTo(x + 90.5729, y + 110.332, x + 91.0508, y + 110.816, x + 91.0508, y + 111.38);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 61.4176, y + 65.9011);
ctx.bezierCurveTo(x + 61.9752, y + 65.9011, x + 62.4532, y + 66.3442, x + 62.4532, y + 66.9082);
ctx.bezierCurveTo(x + 62.4532, y + 67.4721, x + 62.0151, y + 67.9555, x + 61.4574, y + 67.9958);
ctx.bezierCurveTo(x + 60.8998, y + 67.9958, x + 60.4219, y + 67.5527, x + 60.4219, y + 66.9887);
ctx.bezierCurveTo(x + 60.4219, y + 66.4248, x + 60.86, y + 65.9414, x + 61.4176, y + 65.9011);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 96.3487, y + 65.8207);
ctx.bezierCurveTo(x + 96.3487, y + 66.3846, x + 95.9106, y + 66.868, x + 95.353, y + 66.9083);
ctx.bezierCurveTo(x + 94.7953, y + 66.9083, x + 94.3174, y + 66.4249, x + 94.3174, y + 65.861);
ctx.bezierCurveTo(x + 94.3174, y + 65.297, x + 94.7555, y + 64.8539, x + 95.2733, y + 64.8136);
ctx.bezierCurveTo(x + 95.8309, y + 64.7733, x + 96.3487, y + 65.2567, x + 96.3487, y + 65.8207);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 62.851, y + 109.809);
ctx.bezierCurveTo(x + 62.2934, y + 109.849, x + 61.8154, y + 109.406, x + 61.8154, y + 108.802);
ctx.bezierCurveTo(x + 61.8154, y + 108.238, x + 62.2137, y + 107.754, x + 62.7713, y + 107.754);
ctx.bezierCurveTo(x + 63.329, y + 107.714, x + 63.8069, y + 108.157, x + 63.8069, y + 108.761);
ctx.bezierCurveTo(x + 63.8467, y + 109.285, x + 63.4086, y + 109.768, x + 62.851, y + 109.809);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 98.8971, y + 68.2375);
ctx.bezierCurveTo(x + 99.4547, y + 68.2375, x + 99.8929, y + 68.7209, x + 99.8929, y + 69.2849);
ctx.bezierCurveTo(x + 99.8929, y + 69.8488, x + 99.4547, y + 70.2919, x + 98.8971, y + 70.2919);
ctx.bezierCurveTo(x + 98.3395, y + 70.2919, x + 97.9014, y + 69.8085, x + 97.9014, y + 69.2446);
ctx.bezierCurveTo(x + 97.9014, y + 68.6807, x + 98.3395, y + 68.2375, x + 98.8971, y + 68.2375);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 52.018, y + 89.2648);
ctx.bezierCurveTo(x + 51.4604, y + 89.3051, x + 51.0223, y + 88.862, x + 50.9824, y + 88.2981);
ctx.bezierCurveTo(x + 50.9824, y + 87.7341, x + 51.3807, y + 87.291, x + 51.9383, y + 87.2507);
ctx.bezierCurveTo(x + 52.496, y + 87.2507, x + 52.8942, y + 87.6536, x + 52.9341, y + 88.2175);
ctx.bezierCurveTo(x + 52.9739, y + 88.7814, x + 52.5756, y + 89.2245, x + 52.018, y + 89.2648);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 96.6669, y + 106.626);
ctx.bezierCurveTo(x + 97.2245, y + 106.586, x + 97.6626, y + 107.029, x + 97.7024, y + 107.593);
ctx.bezierCurveTo(x + 97.7423, y + 108.157, x + 97.3041, y + 108.64, x + 96.7465, y + 108.64);
ctx.bezierCurveTo(x + 96.1889, y + 108.64, x + 95.7508, y + 108.238, x + 95.7508, y + 107.633);
ctx.bezierCurveTo(x + 95.711, y + 107.11, x + 96.1093, y + 106.667, x + 96.6669, y + 106.626);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 78.1461, y + 60.4228);
ctx.bezierCurveTo(x + 77.5885, y + 60.4228, x + 77.1504, y + 59.9797, x + 77.1504, y + 59.4157);
ctx.bezierCurveTo(x + 77.1504, y + 58.8518, x + 77.5885, y + 58.4087, x + 78.1461, y + 58.4087);
ctx.bezierCurveTo(x + 78.7038, y + 58.4087, x + 79.102, y + 58.8518, x + 79.102, y + 59.4157);
ctx.bezierCurveTo(x + 79.1419, y + 59.9797, x + 78.7436, y + 60.4228, x + 78.1461, y + 60.4228);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 100.052, y + 105.096);
ctx.bezierCurveTo(x + 99.4948, y + 105.096, x + 99.0566, y + 104.693, x + 99.0566, y + 104.129);
ctx.bezierCurveTo(x + 99.0566, y + 103.565, x + 99.4549, y + 103.122, x + 100.013, y + 103.082);
ctx.bezierCurveTo(x + 100.57, y + 103.082, x + 100.968, y + 103.484, x + 101.008, y + 104.048);
ctx.bezierCurveTo(x + 101.008, y + 104.612, x + 100.61, y + 105.055, x + 100.052, y + 105.096);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 64.7233, y + 64.4108);
ctx.bezierCurveTo(x + 64.1657, y + 64.4108, x + 63.7275, y + 64.008, x + 63.7275, y + 63.4441);
ctx.bezierCurveTo(x + 63.7275, y + 62.8801, x + 64.1258, y + 62.437, x + 64.6835, y + 62.3967);
ctx.bezierCurveTo(x + 65.2411, y + 62.3967, x + 65.6394, y + 62.7995, x + 65.6792, y + 63.3635);
ctx.bezierCurveTo(x + 65.6792, y + 63.9274, x + 65.2809, y + 64.4108, x + 64.7233, y + 64.4108);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 55.8813, y + 74.1589);
ctx.bezierCurveTo(x + 55.8813, y + 74.7229, x + 55.483, y + 75.166, x + 54.9254, y + 75.166);
ctx.bezierCurveTo(x + 54.3678, y + 75.166, x + 53.9297, y + 74.7229, x + 53.9297, y + 74.1589);
ctx.bezierCurveTo(x + 53.9297, y + 73.595, x + 54.328, y + 73.1921, x + 54.8856, y + 73.1519);
ctx.bezierCurveTo(x + 55.4034, y + 73.1519, x + 55.8415, y + 73.595, x + 55.8813, y + 74.1589);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 53.0532, y + 91.6817);
ctx.bezierCurveTo(x + 53.0532, y + 92.2457, x + 52.6549, y + 92.6888, x + 52.0973, y + 92.729);
ctx.bezierCurveTo(x + 51.5397, y + 92.729, x + 51.1414, y + 92.3262, x + 51.1016, y + 91.7623);
ctx.bezierCurveTo(x + 51.1016, y + 91.1983, x + 51.4999, y + 90.7552, x + 52.0575, y + 90.7149);
ctx.bezierCurveTo(x + 52.6151, y + 90.6747, x + 53.0532, y + 91.1178, x + 53.0532, y + 91.6817);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 91.8078, y + 61.5104);
ctx.bezierCurveTo(x + 92.3655, y + 61.4701, x + 92.8036, y + 61.9132, x + 92.8036, y + 62.4368);
ctx.bezierCurveTo(x + 92.8434, y + 63.0008, x + 92.4053, y + 63.4842, x + 91.8477, y + 63.4842);
ctx.bezierCurveTo(x + 91.2901, y + 63.4842, x + 90.8918, y + 63.0814, x + 90.8519, y + 62.5174);
ctx.bezierCurveTo(x + 90.8121, y + 61.9535, x + 91.2901, y + 61.5506, x + 91.8078, y + 61.5104);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 74.7606, y + 58.5295);
ctx.bezierCurveTo(x + 75.3182, y + 58.5295, x + 75.7563, y + 58.9324, x + 75.7563, y + 59.5366);
ctx.bezierCurveTo(x + 75.7563, y + 60.1005, x + 75.358, y + 60.5436, x + 74.8004, y + 60.5436);
ctx.bezierCurveTo(x + 74.2428, y + 60.5436, x + 73.8047, y + 60.1408, x + 73.8047, y + 59.5366);
ctx.bezierCurveTo(x + 73.8445, y + 58.9726, x + 74.2428, y + 58.5698, x + 74.7606, y + 58.5295);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 56.7573, y + 101.994);
ctx.bezierCurveTo(x + 56.7972, y + 102.558, x + 56.3989, y + 103.001, x + 55.8412, y + 103.041);
ctx.bezierCurveTo(x + 55.2836, y + 103.082, x + 54.8455, y + 102.638, x + 54.8057, y + 102.075);
ctx.bezierCurveTo(x + 54.8057, y + 101.511, x + 55.204, y + 101.067, x + 55.7217, y + 101.067);
ctx.bezierCurveTo(x + 56.2794, y + 101.027, x + 56.7175, y + 101.43, x + 56.7573, y + 101.994);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 51.8583, y + 83.7058);
ctx.bezierCurveTo(x + 52.4159, y + 83.7058, x + 52.854, y + 84.1086, x + 52.854, y + 84.7129);
ctx.bezierCurveTo(x + 52.854, y + 85.2768, x + 52.4557, y + 85.7199, x + 51.8981, y + 85.7199);
ctx.bezierCurveTo(x + 51.3405, y + 85.7199, x + 50.9023, y + 85.3171, x + 50.9023, y + 84.7129);
ctx.bezierCurveTo(x + 50.9023, y + 84.1892, x + 51.3006, y + 83.7461, x + 51.8583, y + 83.7058);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 79.9383, y + 114.199);
ctx.bezierCurveTo(x + 80.496, y + 114.199, x + 80.9341, y + 114.602, x + 80.9341, y + 115.166);
ctx.bezierCurveTo(x + 80.9739, y + 115.73, x + 80.5358, y + 116.213, x + 79.9782, y + 116.213);
ctx.bezierCurveTo(x + 79.4205, y + 116.213, x + 79.0223, y + 115.81, x + 78.9824, y + 115.247);
ctx.bezierCurveTo(x + 79.0223, y + 114.683, x + 79.4205, y + 114.24, x + 79.9383, y + 114.199);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 82.5671, y + 59.295);
ctx.bezierCurveTo(x + 82.5671, y + 59.8589, x + 82.1688, y + 60.302, x + 81.6112, y + 60.302);
ctx.bezierCurveTo(x + 81.0536, y + 60.302, x + 80.6553, y + 59.8992, x + 80.6553, y + 59.3353);
ctx.bezierCurveTo(x + 80.6553, y + 58.7713, x + 81.0536, y + 58.3282, x + 81.6112, y + 58.3282);
ctx.bezierCurveTo(x + 82.129, y + 58.2879, x + 82.5671, y + 58.7311, x + 82.5671, y + 59.295);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 106.266, y + 87.4118);
ctx.bezierCurveTo(x + 105.748, y + 87.4118, x + 105.271, y + 87.009, x + 105.271, y + 86.445);
ctx.bezierCurveTo(x + 105.271, y + 85.8811, x + 105.669, y + 85.438, x + 106.187, y + 85.438);
ctx.bezierCurveTo(x + 106.704, y + 85.438, x + 107.182, y + 85.8408, x + 107.182, y + 86.4048);
ctx.bezierCurveTo(x + 107.222, y + 86.9687, x + 106.824, y + 87.4118, x + 106.266, y + 87.4118);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 77.5882, y + 115.247);
ctx.bezierCurveTo(x + 77.628, y + 115.811, x + 77.1899, y + 116.254, x + 76.6721, y + 116.294);
ctx.bezierCurveTo(x + 76.1543, y + 116.334, x + 75.6763, y + 115.891, x + 75.6763, y + 115.368);
ctx.bezierCurveTo(x + 75.6365, y + 114.804, x + 76.0746, y + 114.36, x + 76.5924, y + 114.32);
ctx.bezierCurveTo(x + 77.1102, y + 114.28, x + 77.5483, y + 114.723, x + 77.5882, y + 115.247);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 66.3166, y + 113.192);
ctx.bezierCurveTo(x + 65.7988, y + 113.232, x + 65.3209, y + 112.789, x + 65.3209, y + 112.266);
ctx.bezierCurveTo(x + 65.281, y + 111.702, x + 65.7192, y + 111.259, x + 66.237, y + 111.218);
ctx.bezierCurveTo(x + 66.7547, y + 111.178, x + 67.2327, y + 111.621, x + 67.2327, y + 112.145);
ctx.bezierCurveTo(x + 67.2725, y + 112.709, x + 66.8742, y + 113.152, x + 66.3166, y + 113.192);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 103.319, y + 72.6284);
ctx.bezierCurveTo(x + 103.319, y + 73.1923, x + 102.881, y + 73.5952, x + 102.323, y + 73.5952);
ctx.bezierCurveTo(x + 101.805, y + 73.5952, x + 101.367, y + 73.1118, x + 101.367, y + 72.5881);
ctx.bezierCurveTo(x + 101.367, y + 72.0242, x + 101.805, y + 71.6213, x + 102.363, y + 71.6213);
ctx.bezierCurveTo(x + 102.921, y + 71.6213, x + 103.319, y + 72.0644, x + 103.319, y + 72.6284);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 72.3313, y + 59.6575);
ctx.bezierCurveTo(x + 72.3313, y + 60.1812, x + 71.8534, y + 60.6243, x + 71.3356, y + 60.6243);
ctx.bezierCurveTo(x + 70.8178, y + 60.584, x + 70.3797, y + 60.1409, x + 70.4195, y + 59.577);
ctx.bezierCurveTo(x + 70.4593, y + 59.0533, x + 70.8975, y + 58.6102, x + 71.3754, y + 58.6505);
ctx.bezierCurveTo(x + 71.933, y + 58.6908, x + 72.3313, y + 59.1339, x + 72.3313, y + 59.6575);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 103.279, y + 101.43);
ctx.bezierCurveTo(x + 102.761, y + 101.43, x + 102.323, y + 100.987, x + 102.283, y + 100.463);
ctx.bezierCurveTo(x + 102.283, y + 99.9394, x + 102.721, y + 99.4561, x + 103.239, y + 99.4561);
ctx.bezierCurveTo(x + 103.757, y + 99.4561, x + 104.195, y + 99.8992, x + 104.195, y + 100.423);
ctx.bezierCurveTo(x + 104.235, y + 100.946, x + 103.797, y + 101.43, x + 103.279, y + 101.43);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 106.385, y + 90.8759);
ctx.bezierCurveTo(x + 105.868, y + 90.9162, x + 105.39, y + 90.4731, x + 105.39, y + 89.9091);
ctx.bezierCurveTo(x + 105.39, y + 89.3855, x + 105.788, y + 88.9021, x + 106.346, y + 88.9021);
ctx.bezierCurveTo(x + 106.863, y + 88.9021, x + 107.301, y + 89.3049, x + 107.341, y + 89.8286);
ctx.bezierCurveTo(x + 107.341, y + 90.3925, x + 106.943, y + 90.8356, x + 106.385, y + 90.8759);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 52.695, y + 81.2487);
ctx.bezierCurveTo(x + 52.695, y + 81.7724, x + 52.2967, y + 82.2558, x + 51.7391, y + 82.2558);
ctx.bezierCurveTo(x + 51.2213, y + 82.2558, x + 50.7832, y + 81.8127, x + 50.7832, y + 81.289);
ctx.bezierCurveTo(x + 50.7832, y + 80.7654, x + 51.1815, y + 80.3223, x + 51.6993, y + 80.282);
ctx.bezierCurveTo(x + 52.2569, y + 80.282, x + 52.695, y + 80.7251, x + 52.695, y + 81.2487);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 52.2164, y + 96.2336);
ctx.bezierCurveTo(x + 51.6987, y + 96.2336, x + 51.2605, y + 95.7905, x + 51.2207, y + 95.2668);
ctx.bezierCurveTo(x + 51.2207, y + 94.7431, x + 51.6588, y + 94.2598, x + 52.1766, y + 94.2598);
ctx.bezierCurveTo(x + 52.6944, y + 94.2598, x + 53.1325, y + 94.7029, x + 53.1325, y + 95.2265);
ctx.bezierCurveTo(x + 53.1724, y + 95.7502, x + 52.7741, y + 96.1933, x + 52.2164, y + 96.2336);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 84.9569, y + 58.2073);
ctx.bezierCurveTo(x + 85.4747, y + 58.2073, x + 85.9128, y + 58.6504, x + 85.9128, y + 59.174);
ctx.bezierCurveTo(x + 85.9128, y + 59.6977, x + 85.4747, y + 60.1408, x + 84.9569, y + 60.1408);
ctx.bezierCurveTo(x + 84.4391, y + 60.1408, x + 84.001, y + 59.6977, x + 84.001, y + 59.174);
ctx.bezierCurveTo(x + 84.001, y + 58.6504, x + 84.4391, y + 58.2073, x + 84.9569, y + 58.2073);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 84.3591, y + 115.045);
ctx.bezierCurveTo(x + 84.3591, y + 115.569, x + 83.921, y + 116.052, x + 83.4032, y + 116.052);
ctx.bezierCurveTo(x + 82.8854, y + 116.052, x + 82.4473, y + 115.609, x + 82.4473, y + 115.045);
ctx.bezierCurveTo(x + 82.4473, y + 114.521, x + 82.8854, y + 114.078, x + 83.3633, y + 114.078);
ctx.bezierCurveTo(x + 83.921, y + 114.078, x + 84.3591, y + 114.521, x + 84.3591, y + 115.045);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 94.3962, y + 111.259);
ctx.bezierCurveTo(x + 94.3962, y + 111.782, x + 93.9979, y + 112.266, x + 93.4801, y + 112.266);
ctx.bezierCurveTo(x + 92.9623, y + 112.266, x + 92.5242, y + 111.823, x + 92.4844, y + 111.299);
ctx.bezierCurveTo(x + 92.4844, y + 110.775, x + 92.8827, y + 110.332, x + 93.4005, y + 110.292);
ctx.bezierCurveTo(x + 93.9581, y + 110.292, x + 94.3962, y + 110.735, x + 94.3962, y + 111.259);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 107.102, y + 82.9001);
ctx.bezierCurveTo(x + 107.102, y + 83.4237, x + 106.704, y + 83.9071, x + 106.146, y + 83.9071);
ctx.bezierCurveTo(x + 105.589, y + 83.9071, x + 105.19, y + 83.464, x + 105.19, y + 82.9404);
ctx.bezierCurveTo(x + 105.19, y + 82.4167, x + 105.589, y + 81.9736, x + 106.107, y + 81.9736);
ctx.bezierCurveTo(x + 106.624, y + 81.893, x + 107.062, y + 82.3361, x + 107.102, y + 82.9001);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 74.1234, y + 115.408);
ctx.bezierCurveTo(x + 74.1234, y + 115.931, x + 73.725, y + 116.375, x + 73.2073, y + 116.415);
ctx.bezierCurveTo(x + 72.6895, y + 116.415, x + 72.2115, y + 115.972, x + 72.2513, y + 115.448);
ctx.bezierCurveTo(x + 72.2513, y + 114.924, x + 72.6895, y + 114.481, x + 73.2073, y + 114.481);
ctx.bezierCurveTo(x + 73.6852, y + 114.441, x + 74.1234, y + 114.884, x + 74.1234, y + 115.408);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 59.0275, y + 67.0693);
ctx.bezierCurveTo(x + 59.0275, y + 67.593, x + 58.5894, y + 68.0361, x + 58.1114, y + 68.0361);
ctx.bezierCurveTo(x + 57.5936, y + 68.0361, x + 57.1953, y + 67.593, x + 57.1953, y + 67.1096);
ctx.bezierCurveTo(x + 57.1953, y + 66.5859, x + 57.6334, y + 66.1428, x + 58.1114, y + 66.1428);
ctx.bezierCurveTo(x + 58.5894, y + 66.1428, x + 59.0275, y + 66.5456, x + 59.0275, y + 67.0693);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 106.505, y + 94.3806);
ctx.bezierCurveTo(x + 105.987, y + 94.3806, x + 105.549, y + 93.9777, x + 105.549, y + 93.4541);
ctx.bezierCurveTo(x + 105.549, y + 92.9304, x + 105.947, y + 92.4873, x + 106.465, y + 92.447);
ctx.bezierCurveTo(x + 106.983, y + 92.447, x + 107.421, y + 92.8498, x + 107.421, y + 93.3735);
ctx.bezierCurveTo(x + 107.421, y + 93.9375, x + 107.023, y + 94.3806, x + 106.505, y + 94.3806);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 106.067, y + 80.4429);
ctx.bezierCurveTo(x + 105.549, y + 80.4832, x + 105.111, y + 80.0401, x + 105.071, y + 79.5164);
ctx.bezierCurveTo(x + 105.031, y + 78.9928, x + 105.469, y + 78.5497, x + 105.947, y + 78.5094);
ctx.bezierCurveTo(x + 106.465, y + 78.4691, x + 106.903, y + 78.9122, x + 106.943, y + 79.4359);
ctx.bezierCurveTo(x + 106.983, y + 79.9193, x + 106.584, y + 80.4026, x + 106.067, y + 80.4429);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 87.7056, y + 114.924);
ctx.bezierCurveTo(x + 87.7454, y + 115.448, x + 87.3073, y + 115.891, x + 86.8293, y + 115.931);
ctx.bezierCurveTo(x + 86.3115, y + 115.972, x + 85.8734, y + 115.529, x + 85.8336, y + 115.005);
ctx.bezierCurveTo(x + 85.7937, y + 114.481, x + 86.2319, y + 114.038, x + 86.7098, y + 113.998);
ctx.bezierCurveTo(x + 87.2276, y + 113.958, x + 87.7056, y + 114.401, x + 87.7056, y + 114.924);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 51.659, y + 76.8177);
ctx.bezierCurveTo(x + 52.1768, y + 76.8177, x + 52.5751, y + 77.2608, x + 52.5353, y + 77.7845);
ctx.bezierCurveTo(x + 52.5353, y + 78.3081, x + 52.0972, y + 78.7513, x + 51.5794, y + 78.711);
ctx.bezierCurveTo(x + 51.0616, y + 78.6707, x + 50.7031, y + 78.2679, x + 50.7031, y + 77.7442);
ctx.bezierCurveTo(x + 50.743, y + 77.1803, x + 51.1413, y + 76.7774, x + 51.659, y + 76.8177);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 60.382, y + 108.922);
ctx.bezierCurveTo(x + 60.382, y + 109.446, x + 59.9438, y + 109.849, x + 59.4659, y + 109.849);
ctx.bezierCurveTo(x + 58.9481, y + 109.849, x + 58.5498, y + 109.406, x + 58.5498, y + 108.842);
ctx.bezierCurveTo(x + 58.5896, y + 108.318, x + 58.9879, y + 107.915, x + 59.5057, y + 107.956);
ctx.bezierCurveTo(x + 59.9837, y + 107.956, x + 60.382, y + 108.399, x + 60.382, y + 108.922);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 68.9454, y + 59.738);
ctx.bezierCurveTo(x + 68.9853, y + 60.2617, x + 68.587, y + 60.7048, x + 68.0692, y + 60.7048);
ctx.bezierCurveTo(x + 67.5514, y + 60.7451, x + 67.1133, y + 60.302, x + 67.1133, y + 59.7783);
ctx.bezierCurveTo(x + 67.1133, y + 59.2546, x + 67.5116, y + 58.8518, x + 67.9895, y + 58.8115);
ctx.bezierCurveTo(x + 68.5073, y + 58.8115, x + 68.9056, y + 59.2143, x + 68.9454, y + 59.738);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 55.682, y + 70.6946);
ctx.bezierCurveTo(x + 55.682, y + 71.2183, x + 55.3235, y + 71.6211, x + 54.8057, y + 71.6614);
ctx.bezierCurveTo(x + 54.2879, y + 71.6614, x + 53.8896, y + 71.2586, x + 53.8896, y + 70.7349);
ctx.bezierCurveTo(x + 53.8896, y + 70.2113, x + 54.2481, y + 69.8084, x + 54.7659, y + 69.8084);
ctx.bezierCurveTo(x + 55.2439, y + 69.7682, x + 55.682, y + 70.171, x + 55.682, y + 70.6946);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 88.3428, y + 60.02);
ctx.bezierCurveTo(x + 87.8251, y + 60.02, x + 87.4268, y + 59.6574, x + 87.4268, y + 59.0935);
ctx.bezierCurveTo(x + 87.4268, y + 58.5698, x + 87.7852, y + 58.167, x + 88.303, y + 58.1267);
ctx.bezierCurveTo(x + 88.8208, y + 58.1267, x + 89.1793, y + 58.4892, x + 89.2191, y + 59.0129);
ctx.bezierCurveTo(x + 89.2589, y + 59.5769, x + 88.8606, y + 59.9797, x + 88.3428, y + 60.02);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 99.6937, y + 65.6998);
ctx.bezierCurveTo(x + 99.6937, y + 66.2234, x + 99.3352, y + 66.6263, x + 98.8174, y + 66.6665);
ctx.bezierCurveTo(x + 98.2997, y + 66.6665, x + 97.9014, y + 66.2637, x + 97.9014, y + 65.7401);
ctx.bezierCurveTo(x + 97.9014, y + 65.2164, x + 98.2598, y + 64.8136, x + 98.7776, y + 64.8136);
ctx.bezierCurveTo(x + 99.2556, y + 64.7733, x + 99.6539, y + 65.1761, x + 99.6937, y + 65.6998);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 62.254, y + 63.4842);
ctx.bezierCurveTo(x + 62.2939, y + 64.0079, x + 61.8956, y + 64.451, x + 61.3778, y + 64.451);
ctx.bezierCurveTo(x + 60.86, y + 64.4912, x + 60.4617, y + 64.0884, x + 60.4219, y + 63.5648);
ctx.bezierCurveTo(x + 60.4219, y + 63.0411, x + 60.7803, y + 62.6383, x + 61.2583, y + 62.598);
ctx.bezierCurveTo(x + 61.7761, y + 62.5577, x + 62.2142, y + 62.9605, x + 62.254, y + 63.4842);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 53.213, y + 98.6505);
ctx.bezierCurveTo(x + 53.213, y + 99.1741, x + 52.8147, y + 99.5769, x + 52.2969, y + 99.6172);
ctx.bezierCurveTo(x + 51.7792, y + 99.6172, x + 51.3809, y + 99.2144, x + 51.3809, y + 98.6907);
ctx.bezierCurveTo(x + 51.3809, y + 98.1671, x + 51.7393, y + 97.7643, x + 52.2571, y + 97.7643);
ctx.bezierCurveTo(x + 52.8147, y + 97.724, x + 53.213, y + 98.1268, x + 53.213, y + 98.6505);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 91.0113, y + 114.803);
ctx.bezierCurveTo(x + 91.0113, y + 115.327, x + 90.6528, y + 115.73, x + 90.1749, y + 115.73);
ctx.bezierCurveTo(x + 89.6571, y + 115.77, x + 89.2588, y + 115.367, x + 89.2588, y + 114.844);
ctx.bezierCurveTo(x + 89.2588, y + 114.32, x + 89.6173, y + 113.917, x + 90.135, y + 113.917);
ctx.bezierCurveTo(x + 90.613, y + 113.917, x + 91.0113, y + 114.32, x + 91.0113, y + 114.803);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 103.358, y + 103.082);
ctx.bezierCurveTo(x + 103.836, y + 103.082, x + 104.274, y + 103.444, x + 104.274, y + 103.968);
ctx.bezierCurveTo(x + 104.274, y + 104.491, x + 103.916, y + 104.894, x + 103.438, y + 104.894);
ctx.bezierCurveTo(x + 102.96, y + 104.894, x + 102.522, y + 104.532, x + 102.522, y + 104.008);
ctx.bezierCurveTo(x + 102.482, y + 103.484, x + 102.84, y + 103.082, x + 103.358, y + 103.082);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 56.797, y + 105.499);
ctx.bezierCurveTo(x + 56.8369, y + 106.022, x + 56.4386, y + 106.465, x + 55.9208, y + 106.465);
ctx.bezierCurveTo(x + 55.403, y + 106.465, x + 55.0445, y + 106.103, x + 55.0047, y + 105.579);
ctx.bezierCurveTo(x + 54.9649, y + 105.055, x + 55.3632, y + 104.612, x + 55.881, y + 104.612);
ctx.bezierCurveTo(x + 56.3987, y + 104.612, x + 56.797, y + 105.015, x + 56.797, y + 105.499);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 97.7025, y + 111.178);
ctx.bezierCurveTo(x + 97.7025, y + 111.702, x + 97.344, y + 112.105, x + 96.8262, y + 112.105);
ctx.bezierCurveTo(x + 96.3483, y + 112.105, x + 95.95, y + 111.702, x + 95.9102, y + 111.218);
ctx.bezierCurveTo(x + 95.9102, y + 110.695, x + 96.2686, y + 110.292, x + 96.7864, y + 110.292);
ctx.bezierCurveTo(x + 97.3042, y + 110.252, x + 97.7025, y + 110.654, x + 97.7025, y + 111.178);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 103.12, y + 69.1237);
ctx.bezierCurveTo(x + 103.12, y + 69.6474, x + 102.761, y + 70.0502, x + 102.283, y + 70.0502);
ctx.bezierCurveTo(x + 101.765, y + 70.0905, x + 101.367, y + 69.6877, x + 101.367, y + 69.164);
ctx.bezierCurveTo(x + 101.367, y + 68.6404, x + 101.726, y + 68.2375, x + 102.243, y + 68.2375);
ctx.bezierCurveTo(x + 102.721, y + 68.2375, x + 103.12, y + 68.6001, x + 103.12, y + 69.1237);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 96.1089, y + 62.3564);
ctx.bezierCurveTo(x + 96.1089, y + 62.8801, x + 95.7505, y + 63.2829, x + 95.2327, y + 63.2829);
ctx.bezierCurveTo(x + 94.7547, y + 63.2829, x + 94.3564, y + 62.8801, x + 94.3564, y + 62.3967);
ctx.bezierCurveTo(x + 94.3564, y + 61.873, x + 94.7149, y + 61.4702, x + 95.2327, y + 61.4702);
ctx.bezierCurveTo(x + 95.7107, y + 61.4702, x + 96.1089, y + 61.873, x + 96.1089, y + 62.3564);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 105.867, y + 76.8579);
ctx.bezierCurveTo(x + 105.39, y + 76.8579, x + 104.991, y + 76.4551, x + 104.991, y + 75.9315);
ctx.bezierCurveTo(x + 104.991, y + 75.4078, x + 105.39, y + 75.005, x + 105.947, y + 75.0453);
ctx.bezierCurveTo(x + 106.425, y + 75.0453, x + 106.784, y + 75.4884, x + 106.784, y + 76.012);
ctx.bezierCurveTo(x + 106.784, y + 76.4551, x + 106.385, y + 76.8579, x + 105.867, y + 76.8579);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 101.048, y + 107.512);
ctx.bezierCurveTo(x + 101.048, y + 108.036, x + 100.65, y + 108.439, x + 100.132, y + 108.439);
ctx.bezierCurveTo(x + 99.6542, y + 108.439, x + 99.2559, y + 108.036, x + 99.2559, y + 107.512);
ctx.bezierCurveTo(x + 99.2559, y + 106.989, x + 99.6542, y + 106.586, x + 100.172, y + 106.586);
ctx.bezierCurveTo(x + 100.65, y + 106.626, x + 101.008, y + 106.989, x + 101.048, y + 107.512);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 62.8909, y + 111.38);
ctx.bezierCurveTo(x + 63.3689, y + 111.38, x + 63.7672, y + 111.742, x + 63.807, y + 112.266);
ctx.bezierCurveTo(x + 63.8468, y + 112.79, x + 63.4485, y + 113.192, x + 62.9308, y + 113.233);
ctx.bezierCurveTo(x + 62.4528, y + 113.233, x + 62.0545, y + 112.83, x + 62.0545, y + 112.346);
ctx.bezierCurveTo(x + 62.0147, y + 111.823, x + 62.413, y + 111.42, x + 62.8909, y + 111.38);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 107.461, y + 96.8379);
ctx.bezierCurveTo(x + 107.461, y + 97.3615, x + 107.102, y + 97.7644, x + 106.624, y + 97.7644);
ctx.bezierCurveTo(x + 106.106, y + 97.8046, x + 105.708, y + 97.4018, x + 105.708, y + 96.8781);
ctx.bezierCurveTo(x + 105.708, y + 96.3545, x + 106.066, y + 95.9517, x + 106.584, y + 95.9517);
ctx.bezierCurveTo(x + 107.062, y + 95.9517, x + 107.461, y + 96.3545, x + 107.461, y + 96.8379);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 70.7375, y + 115.488);
ctx.bezierCurveTo(x + 70.7773, y + 116.012, x + 70.379, y + 116.455, x + 69.8612, y + 116.455);
ctx.bezierCurveTo(x + 69.3434, y + 116.455, x + 68.985, y + 116.092, x + 68.9451, y + 115.569);
ctx.bezierCurveTo(x + 68.9053, y + 115.045, x + 69.3036, y + 114.602, x + 69.8214, y + 114.602);
ctx.bezierCurveTo(x + 70.2993, y + 114.602, x + 70.6976, y + 114.965, x + 70.7375, y + 115.488);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 52.3764, y + 74.2395);
ctx.bezierCurveTo(x + 52.4162, y + 74.7229, x + 52.0179, y + 75.166, x + 51.5399, y + 75.166);
ctx.bezierCurveTo(x + 51.062, y + 75.2062, x + 50.6637, y + 74.8034, x + 50.6238, y + 74.32);
ctx.bezierCurveTo(x + 50.584, y + 73.8367, x + 50.9823, y + 73.3936, x + 51.4603, y + 73.3936);
ctx.bezierCurveTo(x + 51.9382, y + 73.3936, x + 52.3764, y + 73.7561, x + 52.3764, y + 74.2395);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 65.4402, y + 59.8589);
ctx.bezierCurveTo(x + 65.4402, y + 60.3422, x + 65.0419, y + 60.7451, x + 64.6038, y + 60.7853);
ctx.bezierCurveTo(x + 64.1258, y + 60.7853, x + 63.7275, y + 60.3825, x + 63.7275, y + 59.8991);
ctx.bezierCurveTo(x + 63.7275, y + 59.4158, x + 64.1258, y + 59.0129, x + 64.564, y + 58.9727);
ctx.bezierCurveTo(x + 65.0419, y + 58.9727, x + 65.4402, y + 59.3755, x + 65.4402, y + 59.8589);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 92.6043, y + 58.9324);
ctx.bezierCurveTo(x + 92.6043, y + 59.4158, x + 92.206, y + 59.8186, x + 91.7679, y + 59.8589);
ctx.bezierCurveTo(x + 91.2899, y + 59.8589, x + 90.8916, y + 59.4561, x + 90.8916, y + 58.9727);
ctx.bezierCurveTo(x + 90.8916, y + 58.5296, x + 91.2501, y + 58.0865, x + 91.728, y + 58.0865);
ctx.bezierCurveTo(x + 92.1662, y + 58.0462, x + 92.6043, y + 58.4491, x + 92.6043, y + 58.9324);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 53.2928, y + 102.115);
ctx.bezierCurveTo(x + 53.2928, y + 102.598, x + 52.9343, y + 103.001, x + 52.4563, y + 103.041);
ctx.bezierCurveTo(x + 51.9784, y + 103.041, x + 51.5801, y + 102.638, x + 51.5801, y + 102.155);
ctx.bezierCurveTo(x + 51.5801, y + 101.712, x + 51.9385, y + 101.269, x + 52.4165, y + 101.269);
ctx.bezierCurveTo(x + 52.8546, y + 101.229, x + 53.2928, y + 101.631, x + 53.2928, y + 102.115);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 48.5132, y + 87.4924);
ctx.bezierCurveTo(x + 48.9911, y + 87.4924, x + 49.3894, y + 87.8953, x + 49.3894, y + 88.3786);
ctx.bezierCurveTo(x + 49.3894, y + 88.862, x + 48.9911, y + 89.2648, x + 48.553, y + 89.2648);
ctx.bezierCurveTo(x + 48.1149, y + 89.2648, x + 47.7166, y + 88.862, x + 47.6768, y + 88.4189);
ctx.bezierCurveTo(x + 47.6768, y + 87.9355, x + 48.0751, y + 87.4924, x + 48.5132, y + 87.4924);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 78.9031, y + 55.9515);
ctx.bezierCurveTo(x + 78.9429, y + 56.4349, x + 78.5446, y + 56.8377, x + 78.0667, y + 56.878);
ctx.bezierCurveTo(x + 77.5887, y + 56.878, x + 77.1904, y + 56.4751, x + 77.1904, y + 55.9918);
ctx.bezierCurveTo(x + 77.1904, y + 55.5487, x + 77.5489, y + 55.1056, x + 77.987, y + 55.1056);
ctx.bezierCurveTo(x + 78.465, y + 55.0653, x + 78.9031, y + 55.4681, x + 78.9031, y + 55.9515);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 48.6324, y + 90.9565);
ctx.bezierCurveTo(x + 49.0705, y + 90.9565, x + 49.4688, y + 91.3191, x + 49.5086, y + 91.8025);
ctx.bezierCurveTo(x + 49.5086, y + 92.2859, x + 49.1103, y + 92.6887, x + 48.6722, y + 92.6887);
ctx.bezierCurveTo(x + 48.2341, y + 92.6887, x + 47.8358, y + 92.2859, x + 47.8358, y + 91.8025);
ctx.bezierCurveTo(x + 47.7959, y + 91.3594, x + 48.1942, y + 90.9565, x + 48.6324, y + 90.9565);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 49.2695, y + 84.7934);
ctx.bezierCurveTo(x + 49.2695, y + 85.2768, x + 48.9111, y + 85.6796, x + 48.4729, y + 85.6796);
ctx.bezierCurveTo(x + 47.995, y + 85.7199, x + 47.5967, y + 85.2768, x + 47.5967, y + 84.8337);
ctx.bezierCurveTo(x + 47.5967, y + 84.3503, x + 47.995, y + 83.9475, x + 48.4331, y + 83.9475);
ctx.bezierCurveTo(x + 48.8712, y + 83.9475, x + 49.2695, y + 84.3503, x + 49.2695, y + 84.7934);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 75.5566, y + 56.0725);
ctx.bezierCurveTo(x + 75.5566, y + 56.5559, x + 75.1982, y + 56.9587, x + 74.76, y + 56.9587);
ctx.bezierCurveTo(x + 74.2821, y + 56.999, x + 73.8838, y + 56.5559, x + 73.8838, y + 56.0725);
ctx.bezierCurveTo(x + 73.8838, y + 55.5891, x + 74.2821, y + 55.1863, x + 74.7202, y + 55.1863);
ctx.bezierCurveTo(x + 75.1185, y + 55.1863, x + 75.5168, y + 55.5891, x + 75.5566, y + 56.0725);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 82.3279, y + 55.8308);
ctx.bezierCurveTo(x + 82.3279, y + 56.3142, x + 81.9694, y + 56.717, x + 81.4915, y + 56.717);
ctx.bezierCurveTo(x + 81.0135, y + 56.717, x + 80.6152, y + 56.3142, x + 80.6152, y + 55.8308);
ctx.bezierCurveTo(x + 80.6152, y + 55.3474, x + 81.0135, y + 54.9849, x + 81.4517, y + 54.9849);
ctx.bezierCurveTo(x + 81.9296, y + 54.9849, x + 82.3279, y + 55.3877, x + 82.3279, y + 55.8308);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 66.396, y + 114.763);
ctx.bezierCurveTo(x + 66.8341, y + 114.763, x + 67.2324, y + 115.166, x + 67.2723, y + 115.609);
ctx.bezierCurveTo(x + 67.2723, y + 116.092, x + 66.874, y + 116.495, x + 66.396, y + 116.495);
ctx.bezierCurveTo(x + 65.918, y + 116.495, x + 65.5596, y + 116.092, x + 65.5596, y + 115.609);
ctx.bezierCurveTo(x + 65.5596, y + 115.166, x + 65.918, y + 114.763, x + 66.396, y + 114.763);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 105.827, y + 73.3535);
ctx.bezierCurveTo(x + 105.389, y + 73.3535, x + 104.991, y + 72.9909, x + 104.951, y + 72.5075);
ctx.bezierCurveTo(x + 104.911, y + 72.0242, x + 105.309, y + 71.5811, x + 105.787, y + 71.5811);
ctx.bezierCurveTo(x + 106.226, y + 71.5811, x + 106.624, y + 71.9839, x + 106.624, y + 72.427);
ctx.bezierCurveTo(x + 106.664, y + 72.9506, x + 106.265, y + 73.3535, x + 105.827, y + 73.3535);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 55.4827, y + 67.1499);
ctx.bezierCurveTo(x + 55.5226, y + 67.6333, x + 55.1641, y + 68.0361, x + 54.6861, y + 68.0361);
ctx.bezierCurveTo(x + 54.248, y + 68.0361, x + 53.8497, y + 67.7138, x + 53.8497, y + 67.2304);
ctx.bezierCurveTo(x + 53.8099, y + 66.7471, x + 54.1683, y + 66.3442, x + 54.6463, y + 66.3442);
ctx.bezierCurveTo(x + 55.0844, y + 66.3442, x + 55.4429, y + 66.7068, x + 55.4827, y + 67.1499);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 49.5881, y + 95.3071);
ctx.bezierCurveTo(x + 49.5881, y + 95.7905, x + 49.2695, y + 96.153, x + 48.8313, y + 96.1933);
ctx.bezierCurveTo(x + 48.3534, y + 96.2336, x + 47.9949, y + 95.871, x + 47.9551, y + 95.3876);
ctx.bezierCurveTo(x + 47.9551, y + 94.9043, x + 48.2737, y + 94.5417, x + 48.7517, y + 94.5417);
ctx.bezierCurveTo(x + 49.1898, y + 94.5014, x + 49.5483, y + 94.8237, x + 49.5881, y + 95.3071);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 94.3966, y + 114.723);
ctx.bezierCurveTo(x + 94.3966, y + 115.206, x + 94.0779, y + 115.609, x + 93.6, y + 115.609);
ctx.bezierCurveTo(x + 93.122, y + 115.609, x + 92.7636, y + 115.247, x + 92.7237, y + 114.804);
ctx.bezierCurveTo(x + 92.6839, y + 114.36, x + 93.0424, y + 113.917, x + 93.5203, y + 113.917);
ctx.bezierCurveTo(x + 93.9983, y + 113.877, x + 94.3966, y + 114.24, x + 94.3966, y + 114.723);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 58.7893, y + 63.6052);
ctx.bezierCurveTo(x + 58.7893, y + 64.0886, x + 58.4706, y + 64.4511, x + 57.9927, y + 64.4914);
ctx.bezierCurveTo(x + 57.5545, y + 64.4914, x + 57.1961, y + 64.1289, x + 57.1562, y + 63.6858);
ctx.bezierCurveTo(x + 57.1562, y + 63.2024, x + 57.4749, y + 62.8398, x + 57.9528, y + 62.7996);
ctx.bezierCurveTo(x + 58.4308, y + 62.7996, x + 58.7893, y + 63.1218, x + 58.7893, y + 63.6052);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 98.6182, y + 61.4298);
ctx.bezierCurveTo(x + 99.0563, y + 61.3895, x + 99.4546, y + 61.7521, x + 99.4546, y + 62.2355);
ctx.bezierCurveTo(x + 99.4944, y + 62.7188, x + 99.136, y + 63.0814, x + 98.6979, y + 63.1217);
ctx.bezierCurveTo(x + 98.2597, y + 63.1619, x + 97.8614, y + 62.7994, x + 97.8614, y + 62.316);
ctx.bezierCurveTo(x + 97.8216, y + 61.8326, x + 98.1801, y + 61.4701, x + 98.6182, y + 61.4298);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 60.382, y + 112.387);
ctx.bezierCurveTo(x + 60.382, y + 112.87, x + 60.0634, y + 113.233, x + 59.5854, y + 113.233);
ctx.bezierCurveTo(x + 59.1473, y + 113.233, x + 58.7889, y + 112.87, x + 58.749, y + 112.427);
ctx.bezierCurveTo(x + 58.749, y + 111.944, x + 59.0677, y + 111.581, x + 59.5456, y + 111.581);
ctx.bezierCurveTo(x + 60.0236, y + 111.581, x + 60.382, y + 111.944, x + 60.382, y + 112.387);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 71.2952, y + 57.0391);
ctx.bezierCurveTo(x + 70.8172, y + 57.0794, x + 70.4588, y + 56.7169, x + 70.4189, y + 56.2335);
ctx.bezierCurveTo(x + 70.4189, y + 55.7501, x + 70.7376, y + 55.3876, x + 71.2155, y + 55.3876);
ctx.bezierCurveTo(x + 71.6935, y + 55.3473, x + 72.052, y + 55.7098, x + 72.0918, y + 56.1932);
ctx.bezierCurveTo(x + 72.0918, y + 56.6363, x + 71.7732, y + 57.0391, x + 71.2952, y + 57.0391);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 109.771, y + 90.6344);
ctx.bezierCurveTo(x + 109.293, y + 90.6746, x + 108.934, y + 90.3121, x + 108.895, y + 89.8287);
ctx.bezierCurveTo(x + 108.895, y + 89.3453, x + 109.213, y + 88.9828, x + 109.691, y + 88.9828);
ctx.bezierCurveTo(x + 110.169, y + 88.9425, x + 110.528, y + 89.3051, x + 110.567, y + 89.7884);
ctx.bezierCurveTo(x + 110.567, y + 90.2315, x + 110.209, y + 90.5941, x + 109.771, y + 90.6344);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 85.674, y + 55.7099);
ctx.bezierCurveTo(x + 85.674, y + 56.1933, x + 85.3554, y + 56.5559, x + 84.8774, y + 56.5559);
ctx.bezierCurveTo(x + 84.3995, y + 56.5961, x + 84.041, y + 56.2336, x + 84.041, y + 55.7099);
ctx.bezierCurveTo(x + 84.041, y + 55.2266, x + 84.3596, y + 54.864, x + 84.8376, y + 54.864);
ctx.bezierCurveTo(x + 85.2757, y + 54.9043, x + 85.6342, y + 55.2668, x + 85.674, y + 55.7099);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 48.3531, y + 82.2153);
ctx.bezierCurveTo(x + 47.8752, y + 82.2153, x + 47.5167, y + 81.893, x + 47.5167, y + 81.4096);
ctx.bezierCurveTo(x + 47.4769, y + 80.9263, x + 47.8353, y + 80.5234, x + 48.3133, y + 80.5234);
ctx.bezierCurveTo(x + 48.7514, y + 80.5234, x + 49.1099, y + 80.8457, x + 49.1497, y + 81.3291);
ctx.bezierCurveTo(x + 49.1497, y + 81.8527, x + 48.8311, y + 82.2153, x + 48.3531, y + 82.2153);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 108.775, y + 86.3242);
ctx.bezierCurveTo(x + 108.775, y + 85.8408, x + 109.134, y + 85.4783, x + 109.612, y + 85.4783);
ctx.bezierCurveTo(x + 110.09, y + 85.4783, x + 110.448, y + 85.8811, x + 110.448, y + 86.3242);
ctx.bezierCurveTo(x + 110.448, y + 86.8076, x + 110.09, y + 87.1701, x + 109.612, y + 87.1701);
ctx.bezierCurveTo(x + 109.134, y + 87.1701, x + 108.775, y + 86.8076, x + 108.775, y + 86.3242);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 107.54, y + 100.302);
ctx.bezierCurveTo(x + 107.54, y + 100.785, x + 107.221, y + 101.188, x + 106.743, y + 101.188);
ctx.bezierCurveTo(x + 106.265, y + 101.188, x + 105.907, y + 100.826, x + 105.867, y + 100.383);
ctx.bezierCurveTo(x + 105.867, y + 99.8993, x + 106.186, y + 99.4965, x + 106.664, y + 99.4965);
ctx.bezierCurveTo(x + 107.142, y + 99.4562, x + 107.5, y + 99.8187, x + 107.54, y + 100.302);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 102.92, y + 65.6192);
ctx.bezierCurveTo(x + 102.92, y + 66.1026, x + 102.601, y + 66.4652, x + 102.124, y + 66.4652);
ctx.bezierCurveTo(x + 101.685, y + 66.4652, x + 101.327, y + 66.1026, x + 101.287, y + 65.6595);
ctx.bezierCurveTo(x + 101.287, y + 65.1761, x + 101.606, y + 64.8136, x + 102.084, y + 64.8136);
ctx.bezierCurveTo(x + 102.562, y + 64.7733, x + 102.92, y + 65.1359, x + 102.92, y + 65.6192);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 109.532, y + 83.6253);
ctx.bezierCurveTo(x + 109.054, y + 83.6656, x + 108.695, y + 83.3031, x + 108.655, y + 82.8197);
ctx.bezierCurveTo(x + 108.655, y + 82.3363, x + 108.974, y + 81.9738, x + 109.452, y + 81.9738);
ctx.bezierCurveTo(x + 109.93, y + 81.9335, x + 110.288, y + 82.296, x + 110.328, y + 82.7794);
ctx.bezierCurveTo(x + 110.328, y + 83.2628, x + 109.97, y + 83.6253, x + 109.532, y + 83.6253);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 56.0007, y + 108.157);
ctx.bezierCurveTo(x + 56.4388, y + 108.157, x + 56.7973, y + 108.479, x + 56.8371, y + 108.963);
ctx.bezierCurveTo(x + 56.8371, y + 109.446, x + 56.5185, y + 109.809, x + 56.0405, y + 109.809);
ctx.bezierCurveTo(x + 55.6024, y + 109.809, x + 55.2439, y + 109.486, x + 55.2041, y + 109.003);
ctx.bezierCurveTo(x + 55.2041, y + 108.56, x + 55.5227, y + 108.197, x + 56.0007, y + 108.157);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 77.5482, y + 118.791);
ctx.bezierCurveTo(x + 77.588, y + 119.275, x + 77.2295, y + 119.678, x + 76.7516, y + 119.678);
ctx.bezierCurveTo(x + 76.2736, y + 119.678, x + 75.9151, y + 119.355, x + 75.9151, y + 118.872);
ctx.bezierCurveTo(x + 75.8753, y + 118.389, x + 76.2338, y + 117.986, x + 76.7117, y + 117.986);
ctx.bezierCurveTo(x + 77.1897, y + 117.986, x + 77.5482, y + 118.308, x + 77.5482, y + 118.791);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 80.0583, y + 117.865);
ctx.bezierCurveTo(x + 80.5363, y + 117.865, x + 80.8947, y + 118.228, x + 80.8947, y + 118.711);
ctx.bezierCurveTo(x + 80.8947, y + 119.194, x + 80.5761, y + 119.557, x + 80.0981, y + 119.557);
ctx.bezierCurveTo(x + 79.6202, y + 119.557, x + 79.2617, y + 119.194, x + 79.2617, y + 118.711);
ctx.bezierCurveTo(x + 79.2617, y + 118.268, x + 79.6202, y + 117.905, x + 80.0583, y + 117.865);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 83.5631, y + 119.436);
ctx.bezierCurveTo(x + 83.0851, y + 119.476, x + 82.7267, y + 119.114, x + 82.7267, y + 118.671);
ctx.bezierCurveTo(x + 82.6868, y + 118.187, x + 83.0453, y + 117.784, x + 83.5232, y + 117.784);
ctx.bezierCurveTo(x + 84.0012, y + 117.784, x + 84.3198, y + 118.107, x + 84.3597, y + 118.59);
ctx.bezierCurveTo(x + 84.3597, y + 119.033, x + 84.041, y + 119.436, x + 83.5631, y + 119.436);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 100.212, y + 110.252);
ctx.bezierCurveTo(x + 100.65, y + 110.252, x + 101.008, y + 110.574, x + 101.048, y + 111.017);
ctx.bezierCurveTo(x + 101.088, y + 111.46, x + 100.69, y + 111.863, x + 100.252, y + 111.863);
ctx.bezierCurveTo(x + 99.8135, y + 111.863, x + 99.4551, y + 111.5, x + 99.4551, y + 111.057);
ctx.bezierCurveTo(x + 99.4551, y + 110.655, x + 99.7737, y + 110.252, x + 100.212, y + 110.252);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 73.3667, y + 119.758);
ctx.bezierCurveTo(x + 72.9286, y + 119.799, x + 72.5303, y + 119.436, x + 72.5303, y + 118.953);
ctx.bezierCurveTo(x + 72.5303, y + 118.51, x + 72.8489, y + 118.107, x + 73.3269, y + 118.107);
ctx.bezierCurveTo(x + 73.765, y + 118.107, x + 74.1235, y + 118.429, x + 74.1633, y + 118.872);
ctx.bezierCurveTo(x + 74.1235, y + 119.355, x + 73.8048, y + 119.758, x + 73.3667, y + 119.758);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 52.2172, y + 70.8157);
ctx.bezierCurveTo(x + 52.2172, y + 71.2588, x + 51.8986, y + 71.6616, x + 51.4206, y + 71.6616);
ctx.bezierCurveTo(x + 50.9825, y + 71.6616, x + 50.624, y + 71.299, x + 50.624, y + 70.8559);
ctx.bezierCurveTo(x + 50.624, y + 70.4128, x + 50.9427, y + 70.0503, x + 51.3808, y + 70.01);
ctx.bezierCurveTo(x + 51.8189, y + 70.01, x + 52.2172, y + 70.3726, x + 52.2172, y + 70.8157);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 110.647, y + 93.2929);
ctx.bezierCurveTo(x + 110.647, y + 93.736, x + 110.328, y + 94.1389, x + 109.85, y + 94.1389);
ctx.bezierCurveTo(x + 109.412, y + 94.1389, x + 109.054, y + 93.7763, x + 109.014, y + 93.3332);
ctx.bezierCurveTo(x + 109.014, y + 92.8901, x + 109.332, y + 92.5276, x + 109.77, y + 92.4873);
ctx.bezierCurveTo(x + 110.248, y + 92.4873, x + 110.607, y + 92.8096, x + 110.647, y + 93.2929);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 109.413, y + 80.1611);
ctx.bezierCurveTo(x + 108.974, y + 80.2014, x + 108.576, y + 79.8388, x + 108.576, y + 79.3554);
ctx.bezierCurveTo(x + 108.576, y + 78.9123, x + 108.895, y + 78.5095, x + 109.373, y + 78.5095);
ctx.bezierCurveTo(x + 109.811, y + 78.5095, x + 110.169, y + 78.8318, x + 110.209, y + 79.2749);
ctx.bezierCurveTo(x + 110.209, y + 79.7583, x + 109.851, y + 80.1611, x + 109.413, y + 80.1611);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 61.2185, y + 59.1741);
ctx.bezierCurveTo(x + 61.6566, y + 59.1741, x + 62.0151, y + 59.5366, x + 62.0151, y + 59.9797);
ctx.bezierCurveTo(x + 62.0151, y + 60.4228, x + 61.6566, y + 60.8256, x + 61.2185, y + 60.8256);
ctx.bezierCurveTo(x + 60.7803, y + 60.8256, x + 60.4219, y + 60.4228, x + 60.4219, y + 60.02);
ctx.bezierCurveTo(x + 60.4219, y + 59.5366, x + 60.7803, y + 59.1741, x + 61.2185, y + 59.1741);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 103.478, y + 106.586);
ctx.bezierCurveTo(x + 103.916, y + 106.586, x + 104.314, y + 106.908, x + 104.314, y + 107.392);
ctx.bezierCurveTo(x + 104.314, y + 107.835, x + 103.956, y + 108.238, x + 103.518, y + 108.238);
ctx.bezierCurveTo(x + 103.08, y + 108.238, x + 102.721, y + 107.915, x + 102.721, y + 107.472);
ctx.bezierCurveTo(x + 102.681, y + 106.989, x + 103, y + 106.626, x + 103.478, y + 106.586);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 68.7065, y + 56.3141);
ctx.bezierCurveTo(x + 68.7065, y + 56.7572, x + 68.348, y + 57.1197, x + 67.9497, y + 57.16);
ctx.bezierCurveTo(x + 67.5116, y + 57.16, x + 67.1133, y + 56.7975, x + 67.1133, y + 56.3544);
ctx.bezierCurveTo(x + 67.1133, y + 55.9113, x + 67.4717, y + 55.5487, x + 67.9099, y + 55.5487);
ctx.bezierCurveTo(x + 68.348, y + 55.5084, x + 68.7065, y + 55.871, x + 68.7065, y + 56.3141);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 87.7055, y + 118.469);
ctx.bezierCurveTo(x + 87.7453, y + 118.912, x + 87.3869, y + 119.315, x + 86.9487, y + 119.315);
ctx.bezierCurveTo(x + 86.5106, y + 119.315, x + 86.1123, y + 118.993, x + 86.1123, y + 118.509);
ctx.bezierCurveTo(x + 86.1123, y + 118.066, x + 86.4309, y + 117.704, x + 86.8691, y + 117.664);
ctx.bezierCurveTo(x + 87.3072, y + 117.664, x + 87.6657, y + 117.986, x + 87.7055, y + 118.469);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 52.5757, y + 106.465);
ctx.bezierCurveTo(x + 52.1376, y + 106.465, x + 51.7791, y + 106.102, x + 51.7393, y + 105.7);
ctx.bezierCurveTo(x + 51.7393, y + 105.257, x + 52.0579, y + 104.894, x + 52.496, y + 104.854);
ctx.bezierCurveTo(x + 52.9342, y + 104.854, x + 53.2926, y + 105.216, x + 53.3324, y + 105.619);
ctx.bezierCurveTo(x + 53.3723, y + 106.062, x + 53.0138, y + 106.465, x + 52.5757, y + 106.465);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 63.0107, y + 114.965);
ctx.bezierCurveTo(x + 63.4488, y + 114.965, x + 63.8073, y + 115.327, x + 63.8073, y + 115.73);
ctx.bezierCurveTo(x + 63.8073, y + 116.173, x + 63.4488, y + 116.536, x + 63.0505, y + 116.576);
ctx.bezierCurveTo(x + 62.6124, y + 116.576, x + 62.2539, y + 116.213, x + 62.2539, y + 115.811);
ctx.bezierCurveTo(x + 62.2539, y + 115.367, x + 62.6124, y + 114.965, x + 63.0107, y + 114.965);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 88.98, y + 55.589);
ctx.bezierCurveTo(x + 89.0198, y + 56.0321, x + 88.6614, y + 56.4349, x + 88.2232, y + 56.4349);
ctx.bezierCurveTo(x + 87.7851, y + 56.4752, x + 87.4266, y + 56.1126, x + 87.3868, y + 55.6695);
ctx.bezierCurveTo(x + 87.347, y + 55.2264, x + 87.7054, y + 54.8236, x + 88.1436, y + 54.8236);
ctx.bezierCurveTo(x + 88.5817, y + 54.7833, x + 88.98, y + 55.1459, x + 88.98, y + 55.589);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 48.9109, y + 99.6171);
ctx.bezierCurveTo(x + 48.4727, y + 99.6171, x + 48.1143, y + 99.2546, x + 48.1143, y + 98.8115);
ctx.bezierCurveTo(x + 48.1143, y + 98.3684, x + 48.4727, y + 98.0059, x + 48.9109, y + 98.0059);
ctx.bezierCurveTo(x + 49.349, y + 98.0059, x + 49.7074, y + 98.3684, x + 49.7074, y + 98.8115);
ctx.bezierCurveTo(x + 49.6676, y + 99.2143, x + 49.3091, y + 99.6171, x + 48.9109, y + 99.6171);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 95.153, y + 59.6574);
ctx.bezierCurveTo(x + 94.7149, y + 59.6574, x + 94.3564, y + 59.2949, x + 94.3564, y + 58.8518);
ctx.bezierCurveTo(x + 94.3564, y + 58.4087, x + 94.7149, y + 58.0461, x + 95.1132, y + 58.0059);
ctx.bezierCurveTo(x + 95.5513, y + 58.0059, x + 95.9098, y + 58.3684, x + 95.9098, y + 58.7712);
ctx.bezierCurveTo(x + 95.9098, y + 59.2546, x + 95.5513, y + 59.6574, x + 95.153, y + 59.6574);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 48.2341, y + 78.6706);
ctx.bezierCurveTo(x + 47.796, y + 78.6706, x + 47.4375, y + 78.3081, x + 47.4375, y + 77.865);
ctx.bezierCurveTo(x + 47.4375, y + 77.4219, x + 47.796, y + 77.0593, x + 48.1943, y + 77.019);
ctx.bezierCurveTo(x + 48.6324, y + 77.019, x + 48.9909, y + 77.3816, x + 48.9909, y + 77.8247);
ctx.bezierCurveTo(x + 48.9909, y + 78.2678, x + 48.6324, y + 78.6706, x + 48.2341, y + 78.6706);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 106.465, y + 69.0029);
ctx.bezierCurveTo(x + 106.465, y + 69.446, x + 106.107, y + 69.8085, x + 105.669, y + 69.8085);
ctx.bezierCurveTo(x + 105.271, y + 69.8085, x + 104.912, y + 69.446, x + 104.912, y + 69.0029);
ctx.bezierCurveTo(x + 104.912, y + 68.5598, x + 105.271, y + 68.1973, x + 105.709, y + 68.1973);
ctx.bezierCurveTo(x + 106.107, y + 68.2375, x + 106.465, y + 68.6001, x + 106.465, y + 69.0029);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 97.702, y + 114.602);
ctx.bezierCurveTo(x + 97.7418, y + 115.005, x + 97.3834, y + 115.408, x + 96.9851, y + 115.448);
ctx.bezierCurveTo(x + 96.5469, y + 115.488, x + 96.1885, y + 115.126, x + 96.1885, y + 114.683);
ctx.bezierCurveTo(x + 96.1885, y + 114.239, x + 96.5071, y + 113.877, x + 96.9452, y + 113.877);
ctx.bezierCurveTo(x + 97.3037, y + 113.837, x + 97.6622, y + 114.159, x + 97.702, y + 114.602);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 110.01, y + 75.7702);
ctx.bezierCurveTo(x + 110.049, y + 76.2133, x + 109.691, y + 76.5759, x + 109.293, y + 76.5759);
ctx.bezierCurveTo(x + 108.855, y + 76.6162, x + 108.496, y + 76.2536, x + 108.496, y + 75.8105);
ctx.bezierCurveTo(x + 108.496, y + 75.3674, x + 108.815, y + 75.0049, x + 109.253, y + 75.0049);
ctx.bezierCurveTo(x + 109.651, y + 75.0049, x + 110.01, y + 75.3674, x + 110.01, y + 75.7702);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 69.941, y + 118.268);
ctx.bezierCurveTo(x + 70.3393, y + 118.268, x + 70.6978, y + 118.59, x + 70.7376, y + 119.033);
ctx.bezierCurveTo(x + 70.7774, y + 119.476, x + 70.419, y + 119.839, x + 69.9808, y + 119.879);
ctx.bezierCurveTo(x + 69.5825, y + 119.879, x + 69.2241, y + 119.517, x + 69.2241, y + 119.114);
ctx.bezierCurveTo(x + 69.1842, y + 118.671, x + 69.5029, y + 118.308, x + 69.941, y + 118.268);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 109.93, y + 95.9918);
ctx.bezierCurveTo(x + 110.329, y + 95.9918, x + 110.687, y + 96.3544, x + 110.687, y + 96.7572);
ctx.bezierCurveTo(x + 110.687, y + 97.2003, x + 110.329, y + 97.5628, x + 109.891, y + 97.5628);
ctx.bezierCurveTo(x + 109.492, y + 97.5628, x + 109.134, y + 97.2003, x + 109.134, y + 96.7572);
ctx.bezierCurveTo(x + 109.174, y + 96.3141, x + 109.532, y + 95.9516, x + 109.93, y + 95.9918);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 107.581, y + 103.847);
ctx.bezierCurveTo(x + 107.581, y + 104.29, x + 107.262, y + 104.653, x + 106.824, y + 104.653);
ctx.bezierCurveTo(x + 106.386, y + 104.653, x + 106.027, y + 104.29, x + 106.027, y + 103.847);
ctx.bezierCurveTo(x + 106.027, y + 103.404, x + 106.386, y + 103.082, x + 106.784, y + 103.082);
ctx.bezierCurveTo(x + 107.222, y + 103.082, x + 107.581, y + 103.444, x + 107.581, y + 103.847);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 91.0106, y + 118.348);
ctx.bezierCurveTo(x + 91.0106, y + 118.791, x + 90.692, y + 119.154, x + 90.2937, y + 119.154);
ctx.bezierCurveTo(x + 89.8555, y + 119.194, x + 89.4971, y + 118.832, x + 89.4971, y + 118.389);
ctx.bezierCurveTo(x + 89.4971, y + 117.946, x + 89.8157, y + 117.583, x + 90.2538, y + 117.583);
ctx.bezierCurveTo(x + 90.6521, y + 117.583, x + 91.0106, y + 117.946, x + 91.0106, y + 118.348);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 64.4843, y + 57.1601);
ctx.bezierCurveTo(x + 64.086, y + 57.1601, x + 63.7275, y + 56.8781, x + 63.7275, y + 56.435);
ctx.bezierCurveTo(x + 63.7275, y + 55.9919, x + 64.0063, y + 55.6697, x + 64.4445, y + 55.6697);
ctx.bezierCurveTo(x + 64.8428, y + 55.6697, x + 65.2012, y + 55.9517, x + 65.2012, y + 56.3948);
ctx.bezierCurveTo(x + 65.2012, y + 56.8379, x + 64.9224, y + 57.1601, x + 64.4843, y + 57.1601);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 48.8313, y + 74.3603);
ctx.bezierCurveTo(x + 48.8712, y + 74.8034, x + 48.5525, y + 75.1257, x + 48.1542, y + 75.166);
ctx.bezierCurveTo(x + 47.7559, y + 75.166, x + 47.3975, y + 74.884, x + 47.3975, y + 74.4409);
ctx.bezierCurveTo(x + 47.3975, y + 73.9978, x + 47.6763, y + 73.6755, x + 48.0746, y + 73.6353);
ctx.bezierCurveTo(x + 48.4729, y + 73.6353, x + 48.7915, y + 73.9575, x + 48.8313, y + 74.3603);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 75.2778, y + 52.5277);
ctx.bezierCurveTo(x + 75.2778, y + 52.9305, x + 74.9592, y + 53.2528, x + 74.6007, y + 53.2931);
ctx.bezierCurveTo(x + 74.2024, y + 53.2931, x + 73.8838, y + 52.9708, x + 73.8838, y + 52.568);
ctx.bezierCurveTo(x + 73.8838, y + 52.1652, x + 74.2024, y + 51.8429, x + 74.5609, y + 51.8429);
ctx.bezierCurveTo(x + 74.9592, y + 51.8026, x + 75.2778, y + 52.1652, x + 75.2778, y + 52.5277);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 110.01, y + 99.4963);
ctx.bezierCurveTo(x + 110.408, y + 99.4963, x + 110.727, y + 99.8186, x + 110.767, y + 100.181);
ctx.bezierCurveTo(x + 110.767, y + 100.584, x + 110.488, y + 100.906, x + 110.09, y + 100.946);
ctx.bezierCurveTo(x + 109.691, y + 100.946, x + 109.373, y + 100.624, x + 109.333, y + 100.262);
ctx.bezierCurveTo(x + 109.333, y + 99.8589, x + 109.652, y + 99.4963, x + 110.01, y + 99.4963);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 45.8841, y + 88.4592);
ctx.bezierCurveTo(x + 45.8841, y + 88.862, x + 45.5654, y + 89.1843, x + 45.207, y + 89.2245);
ctx.bezierCurveTo(x + 44.8087, y + 89.2245, x + 44.49, y + 88.9023, x + 44.4502, y + 88.5398);
ctx.bezierCurveTo(x + 44.4502, y + 88.1369, x + 44.7688, y + 87.8147, x + 45.1273, y + 87.7744);
ctx.bezierCurveTo(x + 45.5256, y + 87.7341, x + 45.8841, y + 88.0564, x + 45.8841, y + 88.4592);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 91.6484, y + 56.2739);
ctx.bezierCurveTo(x + 91.2501, y + 56.2739, x + 90.8916, y + 55.9516, x + 90.8916, y + 55.5488);
ctx.bezierCurveTo(x + 90.8916, y + 55.146, x + 91.2102, y + 54.7834, x + 91.6085, y + 54.7834);
ctx.bezierCurveTo(x + 92.0068, y + 54.7834, x + 92.3255, y + 55.1057, x + 92.3255, y + 55.5085);
ctx.bezierCurveTo(x + 92.3653, y + 55.9113, x + 92.0865, y + 56.2336, x + 91.6484, y + 56.2739);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 109.174, y + 73.1118);
ctx.bezierCurveTo(x + 108.776, y + 73.1118, x + 108.457, y + 72.8298, x + 108.417, y + 72.427);
ctx.bezierCurveTo(x + 108.377, y + 72.0242, x + 108.736, y + 71.6616, x + 109.134, y + 71.6616);
ctx.bezierCurveTo(x + 109.532, y + 71.6616, x + 109.851, y + 71.9839, x + 109.851, y + 72.3867);
ctx.bezierCurveTo(x + 109.891, y + 72.7492, x + 109.572, y + 73.0715, x + 109.174, y + 73.1118);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 49.7073, y + 102.236);
ctx.bezierCurveTo(x + 49.7073, y + 102.638, x + 49.3887, y + 103.001, x + 48.9904, y + 103.001);
ctx.bezierCurveTo(x + 48.5921, y + 103.001, x + 48.2734, y + 102.679, x + 48.2734, y + 102.236);
ctx.bezierCurveTo(x + 48.2734, y + 101.833, x + 48.5921, y + 101.51, x + 48.9904, y + 101.51);
ctx.bezierCurveTo(x + 49.3887, y + 101.51, x + 49.7073, y + 101.833, x + 49.7073, y + 102.236);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 53.3723, y + 109.124);
ctx.bezierCurveTo(x + 53.3723, y + 109.527, x + 53.0139, y + 109.849, x + 52.6554, y + 109.849);
ctx.bezierCurveTo(x + 52.2571, y + 109.849, x + 51.9385, y + 109.486, x + 51.9385, y + 109.124);
ctx.bezierCurveTo(x + 51.9385, y + 108.721, x + 52.2969, y + 108.399, x + 52.6554, y + 108.399);
ctx.bezierCurveTo(x + 53.0537, y + 108.399, x + 53.3723, y + 108.721, x + 53.3723, y + 109.124);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 46.0032, y + 91.883);
ctx.bezierCurveTo(x + 46.0032, y + 92.2859, x + 45.6846, y + 92.6081, x + 45.3261, y + 92.6484);
ctx.bezierCurveTo(x + 44.9278, y + 92.6484, x + 44.6092, y + 92.3261, x + 44.5693, y + 91.9636);
ctx.bezierCurveTo(x + 44.5693, y + 91.5608, x + 44.888, y + 91.2385, x + 45.2464, y + 91.1982);
ctx.bezierCurveTo(x + 45.6447, y + 91.1982, x + 46.0032, y + 91.5205, x + 46.0032, y + 91.883);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 57.9121, y + 60.8256);
ctx.bezierCurveTo(x + 57.5138, y + 60.8256, x + 57.1952, y + 60.5437, x + 57.1554, y + 60.1408);
ctx.bezierCurveTo(x + 57.1155, y + 59.738, x + 57.474, y + 59.3755, x + 57.8723, y + 59.3755);
ctx.bezierCurveTo(x + 58.2706, y + 59.3755, x + 58.5892, y + 59.6977, x + 58.5892, y + 60.1006);
ctx.bezierCurveTo(x + 58.5892, y + 60.4631, x + 58.2706, y + 60.8256, x + 57.9121, y + 60.8256);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 54.5275, y + 64.4914);
ctx.bezierCurveTo(x + 54.1292, y + 64.4914, x + 53.8105, y + 64.1289, x + 53.8105, y + 63.726);
ctx.bezierCurveTo(x + 53.8105, y + 63.3232, x + 54.169, y + 63.001, x + 54.5673, y + 63.001);
ctx.bezierCurveTo(x + 54.9656, y + 63.001, x + 55.2444, y + 63.3232, x + 55.2444, y + 63.726);
ctx.bezierCurveTo(x + 55.2842, y + 64.1692, x + 54.9656, y + 64.4914, x + 54.5275, y + 64.4914);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 101.964, y + 61.4299);
ctx.bezierCurveTo(x + 102.363, y + 61.4299, x + 102.681, y + 61.7119, x + 102.721, y + 62.1147);
ctx.bezierCurveTo(x + 102.761, y + 62.5175, x + 102.442, y + 62.8801, x + 102.004, y + 62.8801);
ctx.bezierCurveTo(x + 101.606, y + 62.8801, x + 101.287, y + 62.5578, x + 101.287, y + 62.155);
ctx.bezierCurveTo(x + 101.287, y + 61.7925, x + 101.606, y + 61.4299, x + 101.964, y + 61.4299);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 78.6636, y + 52.4067);
ctx.bezierCurveTo(x + 78.6636, y + 52.8095, x + 78.3449, y + 53.1318, x + 77.9865, y + 53.1318);
ctx.bezierCurveTo(x + 77.5882, y + 53.1318, x + 77.2695, y + 52.8095, x + 77.2695, y + 52.4067);
ctx.bezierCurveTo(x + 77.2695, y + 52.0039, x + 77.5882, y + 51.6816, x + 77.9466, y + 51.6816);
ctx.bezierCurveTo(x + 78.3051, y + 51.7219, x + 78.6237, y + 52.0442, x + 78.6636, y + 52.4067);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 51.3009, y + 66.5859);
ctx.bezierCurveTo(x + 51.6992, y + 66.5859, x + 52.0179, y + 66.9082, x + 52.0179, y + 67.311);
ctx.bezierCurveTo(x + 52.0179, y + 67.7138, x + 51.6992, y + 68.0764, x + 51.3009, y + 68.0764);
ctx.bezierCurveTo(x + 50.9026, y + 68.0764, x + 50.584, y + 67.7138, x + 50.584, y + 67.3513);
ctx.bezierCurveTo(x + 50.584, y + 66.9082, x + 50.9026, y + 66.5859, x + 51.3009, y + 66.5859);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 56.8372, y + 112.508);
ctx.bezierCurveTo(x + 56.8372, y + 112.91, x + 56.5186, y + 113.233, x + 56.1601, y + 113.273);
ctx.bezierCurveTo(x + 55.7618, y + 113.273, x + 55.4033, y + 112.951, x + 55.4033, y + 112.548);
ctx.bezierCurveTo(x + 55.4033, y + 112.145, x + 55.722, y + 111.823, x + 56.1203, y + 111.823);
ctx.bezierCurveTo(x + 56.5186, y + 111.782, x + 56.8372, y + 112.105, x + 56.8372, y + 112.508);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 45.804, y + 84.9143);
ctx.bezierCurveTo(x + 45.804, y + 85.3171, x + 45.4853, y + 85.6394, x + 45.1269, y + 85.6796);
ctx.bezierCurveTo(x + 44.7286, y + 85.6796, x + 44.4099, y + 85.3574, x + 44.3701, y + 84.9948);
ctx.bezierCurveTo(x + 44.3701, y + 84.592, x + 44.6888, y + 84.2698, x + 45.0472, y + 84.2295);
ctx.bezierCurveTo(x + 45.4455, y + 84.1892, x + 45.7642, y + 84.5115, x + 45.804, y + 84.9143);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 67.2327, y + 119.154);
ctx.bezierCurveTo(x + 67.2725, y + 119.557, x + 66.9539, y + 119.919, x + 66.5556, y + 119.919);
ctx.bezierCurveTo(x + 66.1573, y + 119.96, x + 65.7988, y + 119.597, x + 65.7988, y + 119.194);
ctx.bezierCurveTo(x + 65.7988, y + 118.791, x + 66.1175, y + 118.469, x + 66.4759, y + 118.429);
ctx.bezierCurveTo(x + 66.8742, y + 118.429, x + 67.1929, y + 118.751, x + 67.2327, y + 119.154);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 94.3962, y + 118.228);
ctx.bezierCurveTo(x + 94.4361, y + 118.63, x + 94.1174, y + 118.993, x + 93.7191, y + 118.993);
ctx.bezierCurveTo(x + 93.3208, y + 119.033, x + 93.0022, y + 118.711, x + 92.9624, y + 118.308);
ctx.bezierCurveTo(x + 92.9225, y + 117.905, x + 93.2412, y + 117.543, x + 93.6395, y + 117.543);
ctx.bezierCurveTo(x + 94.0378, y + 117.502, x + 94.3564, y + 117.825, x + 94.3962, y + 118.228);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 104.314, y + 110.937);
ctx.bezierCurveTo(x + 104.314, y + 111.339, x + 103.995, y + 111.662, x + 103.597, y + 111.662);
ctx.bezierCurveTo(x + 103.238, y + 111.662, x + 102.92, y + 111.339, x + 102.88, y + 110.937);
ctx.bezierCurveTo(x + 102.88, y + 110.534, x + 103.199, y + 110.211, x + 103.597, y + 110.211);
ctx.bezierCurveTo(x + 103.995, y + 110.252, x + 104.314, y + 110.574, x + 104.314, y + 110.937);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 60.3823, y + 115.851);
ctx.bezierCurveTo(x + 60.3823, y + 116.254, x + 60.0637, y + 116.616, x + 59.7052, y + 116.616);
ctx.bezierCurveTo(x + 59.3467, y + 116.616, x + 59.0281, y + 116.294, x + 58.9883, y + 115.931);
ctx.bezierCurveTo(x + 58.9883, y + 115.529, x + 59.3069, y + 115.166, x + 59.6654, y + 115.166);
ctx.bezierCurveTo(x + 60.0239, y + 115.166, x + 60.3823, y + 115.448, x + 60.3823, y + 115.851);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 82.0895, y + 52.2859);
ctx.bezierCurveTo(x + 82.1293, y + 52.6887, x + 81.7708, y + 53.0512, x + 81.4124, y + 53.0512);
ctx.bezierCurveTo(x + 81.0539, y + 53.0512, x + 80.6954, y + 52.729, x + 80.6954, y + 52.3664);
ctx.bezierCurveTo(x + 80.6556, y + 51.9636, x + 81.0141, y + 51.6011, x + 81.3725, y + 51.6011);
ctx.bezierCurveTo(x + 81.731, y + 51.6011, x + 82.0496, y + 51.9233, x + 82.0895, y + 52.2859);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 99.2555, y + 58.6907);
ctx.bezierCurveTo(x + 99.2953, y + 59.0935, x + 98.9368, y + 59.456, x + 98.5784, y + 59.456);
ctx.bezierCurveTo(x + 98.2199, y + 59.456, x + 97.8614, y + 59.1338, x + 97.8614, y + 58.7712);
ctx.bezierCurveTo(x + 97.8216, y + 58.3684, x + 98.1801, y + 58.0059, x + 98.5385, y + 58.0059);
ctx.bezierCurveTo(x + 98.897, y + 58.0059, x + 99.2157, y + 58.3281, x + 99.2555, y + 58.6907);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 104.872, y + 65.4983);
ctx.bezierCurveTo(x + 104.872, y + 65.0955, x + 105.231, y + 64.7732, x + 105.589, y + 64.7732);
ctx.bezierCurveTo(x + 105.947, y + 64.7732, x + 106.266, y + 65.1357, x + 106.266, y + 65.4983);
ctx.bezierCurveTo(x + 106.266, y + 65.9011, x + 105.908, y + 66.2233, x + 105.549, y + 66.2233);
ctx.bezierCurveTo(x + 105.151, y + 66.1831, x + 104.872, y + 65.8608, x + 104.872, y + 65.4983);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 107.62, y + 107.271);
ctx.bezierCurveTo(x + 107.62, y + 107.633, x + 107.341, y + 107.996, x + 106.983, y + 107.996);
ctx.bezierCurveTo(x + 106.624, y + 107.996, x + 106.266, y + 107.714, x + 106.266, y + 107.311);
ctx.bezierCurveTo(x + 106.266, y + 106.948, x + 106.544, y + 106.586, x + 106.903, y + 106.586);
ctx.bezierCurveTo(x + 107.261, y + 106.586, x + 107.58, y + 106.908, x + 107.62, y + 107.271);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 113.554, y + 82.6584);
ctx.bezierCurveTo(x + 113.554, y + 83.0612, x + 113.236, y + 83.3835, x + 112.877, y + 83.3835);
ctx.bezierCurveTo(x + 112.519, y + 83.3835, x + 112.2, y + 83.0612, x + 112.16, y + 82.6987);
ctx.bezierCurveTo(x + 112.16, y + 82.2959, x + 112.479, y + 81.9736, x + 112.837, y + 81.9736);
ctx.bezierCurveTo(x + 113.196, y + 81.9736, x + 113.514, y + 82.2959, x + 113.554, y + 82.6584);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 99.6943, y + 114.521);
ctx.bezierCurveTo(x + 99.6943, y + 114.119, x + 100.013, y + 113.796, x + 100.371, y + 113.796);
ctx.bezierCurveTo(x + 100.73, y + 113.796, x + 101.049, y + 114.119, x + 101.088, y + 114.481);
ctx.bezierCurveTo(x + 101.088, y + 114.884, x + 100.77, y + 115.206, x + 100.411, y + 115.206);
ctx.bezierCurveTo(x + 100.013, y + 115.247, x + 99.6943, y + 114.924, x + 99.6943, y + 114.521);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 71.853, y + 52.6484);
ctx.bezierCurveTo(x + 71.853, y + 53.0512, x + 71.5344, y + 53.3735, x + 71.1759, y + 53.3735);
ctx.bezierCurveTo(x + 70.8175, y + 53.3735, x + 70.4988, y + 53.0512, x + 70.459, y + 52.6887);
ctx.bezierCurveTo(x + 70.459, y + 52.2859, x + 70.7776, y + 51.9636, x + 71.1361, y + 51.9636);
ctx.bezierCurveTo(x + 71.4946, y + 51.9636, x + 71.8132, y + 52.2859, x + 71.853, y + 52.6484);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 113.634, y + 86.2033);
ctx.bezierCurveTo(x + 113.634, y + 86.5659, x + 113.356, y + 86.9284, x + 112.997, y + 86.9284);
ctx.bezierCurveTo(x + 112.639, y + 86.9284, x + 112.28, y + 86.6464, x + 112.28, y + 86.2436);
ctx.bezierCurveTo(x + 112.28, y + 85.8811, x + 112.559, y + 85.5185, x + 112.918, y + 85.5185);
ctx.bezierCurveTo(x + 113.316, y + 85.4783, x + 113.634, y + 85.8005, x + 113.634, y + 86.2033);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 113.077, y + 88.9424);
ctx.bezierCurveTo(x + 113.435, y + 88.9424, x + 113.754, y + 89.2646, x + 113.794, y + 89.6272);
ctx.bezierCurveTo(x + 113.794, y + 90.03, x + 113.475, y + 90.3523, x + 113.117, y + 90.3523);
ctx.bezierCurveTo(x + 112.758, y + 90.3523, x + 112.44, y + 90.03, x + 112.4, y + 89.6675);
ctx.bezierCurveTo(x + 112.36, y + 89.3049, x + 112.679, y + 88.9827, x + 113.077, y + 88.9424);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 44.9679, y + 82.2153);
ctx.bezierCurveTo(x + 44.6094, y + 82.2153, x + 44.2908, y + 81.893, x + 44.251, y + 81.5305);
ctx.bezierCurveTo(x + 44.251, y + 81.1277, x + 44.5696, y + 80.8054, x + 44.9281, y + 80.8054);
ctx.bezierCurveTo(x + 45.2866, y + 80.8054, x + 45.6052, y + 81.1277, x + 45.645, y + 81.4902);
ctx.bezierCurveTo(x + 45.645, y + 81.8528, x + 45.3662, y + 82.2153, x + 44.9679, y + 82.2153);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 95.6708, y + 55.3877);
ctx.bezierCurveTo(x + 95.6708, y + 55.7502, x + 95.4318, y + 56.0725, x + 95.0336, y + 56.0725);
ctx.bezierCurveTo(x + 94.6353, y + 56.0725, x + 94.3564, y + 55.7905, x + 94.3564, y + 55.3877);
ctx.bezierCurveTo(x + 94.3564, y + 55.0251, x + 94.6353, y + 54.7029, x + 94.9937, y + 54.7029);
ctx.bezierCurveTo(x + 95.3522, y + 54.7432, x + 95.631, y + 55.0251, x + 95.6708, y + 55.3877);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 47.9945, y + 71.6616);
ctx.bezierCurveTo(x + 47.5962, y + 71.6616, x + 47.3174, y + 71.3796, x + 47.3174, y + 70.9768);
ctx.bezierCurveTo(x + 47.3174, y + 70.6142, x + 47.5962, y + 70.292, x + 47.9547, y + 70.292);
ctx.bezierCurveTo(x + 48.353, y + 70.292, x + 48.6318, y + 70.574, x + 48.6318, y + 70.9768);
ctx.bezierCurveTo(x + 48.6318, y + 71.3393, x + 48.353, y + 71.6213, x + 47.9945, y + 71.6616);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 61.139, y + 57.2407);
ctx.bezierCurveTo(x + 60.7407, y + 57.2407, x + 60.4619, y + 56.9587, x + 60.4619, y + 56.5559);
ctx.bezierCurveTo(x + 60.4619, y + 56.1933, x + 60.7407, y + 55.8711, x + 61.0992, y + 55.8711);
ctx.bezierCurveTo(x + 61.4975, y + 55.8711, x + 61.7763, y + 56.1531, x + 61.7763, y + 56.5559);
ctx.bezierCurveTo(x + 61.7763, y + 56.9184, x + 61.4975, y + 57.2004, x + 61.139, y + 57.2407);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 112.718, y + 78.5498);
ctx.bezierCurveTo(x + 113.077, y + 78.5498, x + 113.356, y + 78.8318, x + 113.395, y + 79.1943);
ctx.bezierCurveTo(x + 113.395, y + 79.5971, x + 113.117, y + 79.8791, x + 112.718, y + 79.8791);
ctx.bezierCurveTo(x + 112.36, y + 79.8791, x + 112.081, y + 79.5971, x + 112.081, y + 79.1943);
ctx.bezierCurveTo(x + 112.081, y + 78.8721, x + 112.36, y + 78.5498, x + 112.718, y + 78.5498);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 85.3952, y + 52.2053);
ctx.bezierCurveTo(x + 85.3952, y + 52.6081, x + 85.1164, y + 52.9304, x + 84.7181, y + 52.9304);
ctx.bezierCurveTo(x + 84.3597, y + 52.9304, x + 84.041, y + 52.6484, x + 84.041, y + 52.2456);
ctx.bezierCurveTo(x + 84.041, y + 51.8428, x + 84.3198, y + 51.5205, x + 84.7181, y + 51.5205);
ctx.bezierCurveTo(x + 85.0766, y + 51.5205, x + 85.3952, y + 51.8025, x + 85.3952, y + 52.2053);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 45.4457, y + 96.153);
ctx.bezierCurveTo(x + 45.0474, y + 96.153, x + 44.7686, y + 95.8711, x + 44.7686, y + 95.4682);
ctx.bezierCurveTo(x + 44.7686, y + 95.1057, x + 45.0474, y + 94.7834, x + 45.4058, y + 94.7834);
ctx.bezierCurveTo(x + 45.8041, y + 94.7834, x + 46.0829, y + 95.0654, x + 46.0829, y + 95.4682);
ctx.bezierCurveTo(x + 46.0829, y + 95.8308, x + 45.8041, y + 96.153, x + 45.4457, y + 96.153);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 67.8303, y + 53.4541);
ctx.bezierCurveTo(x + 67.4718, y + 53.4541, x + 67.193, y + 53.2124, x + 67.1532, y + 52.8498);
ctx.bezierCurveTo(x + 67.1134, y + 52.4873, x + 67.3922, y + 52.165, x + 67.7507, y + 52.1248);
ctx.bezierCurveTo(x + 68.1091, y + 52.1248, x + 68.4278, y + 52.4067, x + 68.4278, y + 52.7693);
ctx.bezierCurveTo(x + 68.4278, y + 53.1318, x + 68.149, y + 53.4138, x + 67.8303, y + 53.4541);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 113.834, y + 93.1721);
ctx.bezierCurveTo(x + 113.834, y + 93.5749, x + 113.595, y + 93.8569, x + 113.197, y + 93.8569);
ctx.bezierCurveTo(x + 112.838, y + 93.8569, x + 112.52, y + 93.5749, x + 112.52, y + 93.2124);
ctx.bezierCurveTo(x + 112.52, y + 92.8498, x + 112.759, y + 92.5679, x + 113.117, y + 92.5276);
ctx.bezierCurveTo(x + 113.515, y + 92.5276, x + 113.834, y + 92.7693, x + 113.834, y + 93.1721);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 109.691, y + 68.8821);
ctx.bezierCurveTo(x + 109.691, y + 69.2849, x + 109.452, y + 69.5669, x + 109.054, y + 69.5669);
ctx.bezierCurveTo(x + 108.656, y + 69.5669, x + 108.377, y + 69.2849, x + 108.377, y + 68.9223);
ctx.bezierCurveTo(x + 108.377, y + 68.5598, x + 108.616, y + 68.2778, x + 108.974, y + 68.2375);
ctx.bezierCurveTo(x + 109.373, y + 68.2375, x + 109.652, y + 68.5195, x + 109.691, y + 68.8821);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 45.4855, y + 77.9455);
ctx.bezierCurveTo(x + 45.4855, y + 78.3081, x + 45.2067, y + 78.6303, x + 44.8482, y + 78.6303);
ctx.bezierCurveTo(x + 44.4897, y + 78.6303, x + 44.2109, y + 78.3484, x + 44.2109, y + 77.9858);
ctx.bezierCurveTo(x + 44.2109, y + 77.6233, x + 44.4897, y + 77.301, x + 44.8482, y + 77.301);
ctx.bezierCurveTo(x + 45.2067, y + 77.301, x + 45.4855, y + 77.583, x + 45.4855, y + 77.9455);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 46.1632, y + 98.8921);
ctx.bezierCurveTo(x + 46.1632, y + 99.2546, x + 45.8844, y + 99.5769, x + 45.5259, y + 99.5769);
ctx.bezierCurveTo(x + 45.1675, y + 99.5769, x + 44.8887, y + 99.2949, x + 44.8887, y + 98.9324);
ctx.bezierCurveTo(x + 44.8887, y + 98.5698, x + 45.1675, y + 98.2476, x + 45.5259, y + 98.2476);
ctx.bezierCurveTo(x + 45.8844, y + 98.2476, x + 46.1632, y + 98.5295, x + 46.1632, y + 98.8921);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 63.1305, y + 118.63);
ctx.bezierCurveTo(x + 63.489, y + 118.63, x + 63.8076, y + 118.912, x + 63.8076, y + 119.275);
ctx.bezierCurveTo(x + 63.8076, y + 119.637, x + 63.5288, y + 119.96, x + 63.1704, y + 119.96);
ctx.bezierCurveTo(x + 62.8119, y + 119.96, x + 62.5331, y + 119.678, x + 62.5331, y + 119.315);
ctx.bezierCurveTo(x + 62.4933, y + 118.953, x + 62.7721, y + 118.63, x + 63.1305, y + 118.63);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 97.6622, y + 118.147);
ctx.bezierCurveTo(x + 97.6622, y + 118.509, x + 97.4233, y + 118.791, x + 97.0648, y + 118.832);
ctx.bezierCurveTo(x + 96.7063, y + 118.872, x + 96.3877, y + 118.59, x + 96.3877, y + 118.227);
ctx.bezierCurveTo(x + 96.3877, y + 117.865, x + 96.6665, y + 117.543, x + 97.025, y + 117.543);
ctx.bezierCurveTo(x + 97.3834, y + 117.502, x + 97.6622, y + 117.784, x + 97.6622, y + 118.147);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 109.532, y + 103.766);
ctx.bezierCurveTo(x + 109.532, y + 103.404, x + 109.771, y + 103.122, x + 110.13, y + 103.081);
ctx.bezierCurveTo(x + 110.488, y + 103.041, x + 110.807, y + 103.323, x + 110.807, y + 103.686);
ctx.bezierCurveTo(x + 110.807, y + 104.048, x + 110.528, y + 104.37, x + 110.17, y + 104.37);
ctx.bezierCurveTo(x + 109.851, y + 104.411, x + 109.532, y + 104.129, x + 109.532, y + 103.766);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 88.741, y + 52.0442);
ctx.bezierCurveTo(x + 88.7808, y + 52.4067, x + 88.502, y + 52.729, x + 88.1037, y + 52.729);
ctx.bezierCurveTo(x + 87.7453, y + 52.729, x + 87.4665, y + 52.4873, x + 87.4266, y + 52.1247);
ctx.bezierCurveTo(x + 87.3868, y + 51.7622, x + 87.6656, y + 51.4399, x + 88.0639, y + 51.4399);
ctx.bezierCurveTo(x + 88.4224, y + 51.4399, x + 88.7012, y + 51.7219, x + 88.741, y + 52.0442);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 112.598, y + 75.0452);
ctx.bezierCurveTo(x + 112.957, y + 75.0452, x + 113.236, y + 75.3271, x + 113.236, y + 75.6897);
ctx.bezierCurveTo(x + 113.236, y + 76.0522, x + 112.957, y + 76.3342, x + 112.638, y + 76.3745);
ctx.bezierCurveTo(x + 112.28, y + 76.3745, x + 112.001, y + 76.0925, x + 112.001, y + 75.73);
ctx.bezierCurveTo(x + 111.961, y + 75.3674, x + 112.24, y + 75.0854, x + 112.598, y + 75.0452);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 49.7472, y + 105.78);
ctx.bezierCurveTo(x + 49.7472, y + 106.143, x + 49.4684, y + 106.465, x + 49.1099, y + 106.465);
ctx.bezierCurveTo(x + 48.7515, y + 106.465, x + 48.4727, y + 106.183, x + 48.4727, y + 105.78);
ctx.bezierCurveTo(x + 48.4727, y + 105.418, x + 48.7515, y + 105.136, x + 49.1099, y + 105.136);
ctx.bezierCurveTo(x + 49.4684, y + 105.096, x + 49.7472, y + 105.378, x + 49.7472, y + 105.78);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 113.913, y + 96.6365);
ctx.bezierCurveTo(x + 113.913, y + 96.999, x + 113.634, y + 97.3213, x + 113.276, y + 97.281);
ctx.bezierCurveTo(x + 112.957, y + 97.281, x + 112.679, y + 96.999, x + 112.639, y + 96.6767);
ctx.bezierCurveTo(x + 112.639, y + 96.3142, x + 112.917, y + 95.9919, x + 113.276, y + 96.0322);
ctx.bezierCurveTo(x + 113.634, y + 95.9919, x + 113.913, y + 96.3142, x + 113.913, y + 96.6365);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 55.0453, y + 60.2214);
ctx.bezierCurveTo(x + 55.0453, y + 60.584, x + 54.7266, y + 60.8659, x + 54.408, y + 60.8659);
ctx.bezierCurveTo(x + 54.0894, y + 60.8659, x + 53.8105, y + 60.5437, x + 53.8105, y + 60.2214);
ctx.bezierCurveTo(x + 53.8105, y + 59.8589, x + 54.1292, y + 59.5769, x + 54.4478, y + 59.5769);
ctx.bezierCurveTo(x + 54.7665, y + 59.5769, x + 55.0453, y + 59.8992, x + 55.0453, y + 60.2214);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 51.8182, y + 63.8066);
ctx.bezierCurveTo(x + 51.858, y + 64.1692, x + 51.5394, y + 64.4914, x + 51.2207, y + 64.4914);
ctx.bezierCurveTo(x + 50.9021, y + 64.4914, x + 50.5835, y + 64.2094, x + 50.5835, y + 63.8872);
ctx.bezierCurveTo(x + 50.5436, y + 63.5246, x + 50.8623, y + 63.2024, x + 51.1809, y + 63.2024);
ctx.bezierCurveTo(x + 51.4995, y + 63.2024, x + 51.7784, y + 63.4844, x + 51.8182, y + 63.8066);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 56.2799, y + 116.616);
ctx.bezierCurveTo(x + 55.9612, y + 116.616, x + 55.6426, y + 116.374, x + 55.6426, y + 116.012);
ctx.bezierCurveTo(x + 55.6426, y + 115.69, x + 55.8816, y + 115.367, x + 56.24, y + 115.367);
ctx.bezierCurveTo(x + 56.5587, y + 115.367, x + 56.8773, y + 115.609, x + 56.8773, y + 115.972);
ctx.bezierCurveTo(x + 56.8773, y + 116.294, x + 56.5985, y + 116.616, x + 56.2799, y + 116.616);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 101.924, y + 59.2546);
ctx.bezierCurveTo(x + 101.606, y + 59.2546, x + 101.287, y + 59.0129, x + 101.287, y + 58.6504);
ctx.bezierCurveTo(x + 101.287, y + 58.3281, x + 101.526, y + 58.0059, x + 101.885, y + 58.0059);
ctx.bezierCurveTo(x + 102.203, y + 58.0059, x + 102.522, y + 58.2476, x + 102.522, y + 58.6101);
ctx.bezierCurveTo(x + 102.522, y + 58.9323, x + 102.243, y + 59.2546, x + 101.924, y + 59.2546);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 52.7351, y + 112.024);
ctx.bezierCurveTo(x + 53.0538, y + 112.024, x + 53.3724, y + 112.306, x + 53.3724, y + 112.628);
ctx.bezierCurveTo(x + 53.3724, y + 112.951, x + 53.1334, y + 113.273, x + 52.775, y + 113.273);
ctx.bezierCurveTo(x + 52.4563, y + 113.273, x + 52.1377, y + 112.991, x + 52.1377, y + 112.669);
ctx.bezierCurveTo(x + 52.1377, y + 112.346, x + 52.4165, y + 112.024, x + 52.7351, y + 112.024);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 105.429, y + 61.4299);
ctx.bezierCurveTo(x + 105.748, y + 61.4299, x + 106.067, y + 61.7119, x + 106.067, y + 62.0342);
ctx.bezierCurveTo(x + 106.067, y + 62.3564, x + 105.788, y + 62.6787, x + 105.469, y + 62.6787);
ctx.bezierCurveTo(x + 105.151, y + 62.6787, x + 104.872, y + 62.3967, x + 104.832, y + 62.0744);
ctx.bezierCurveTo(x + 104.832, y + 61.7119, x + 105.111, y + 61.4299, x + 105.429, y + 61.4299);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 58.3511, y + 56.6365);
ctx.bezierCurveTo(x + 58.3511, y + 56.999, x + 58.1122, y + 57.281, x + 57.7537, y + 57.281);
ctx.bezierCurveTo(x + 57.4351, y + 57.281, x + 57.1562, y + 57.0393, x + 57.1562, y + 56.6767);
ctx.bezierCurveTo(x + 57.1562, y + 56.3142, x + 57.3952, y + 56.0322, x + 57.7537, y + 56.0322);
ctx.bezierCurveTo(x + 58.0723, y + 56.0322, x + 58.3511, y + 56.3142, x + 58.3511, y + 56.6365);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 64.9625, y + 52.8901);
ctx.bezierCurveTo(x + 64.9625, y + 53.2124, x + 64.7235, y + 53.4943, x + 64.4049, y + 53.5346);
ctx.bezierCurveTo(x + 64.0464, y + 53.5749, x + 63.7676, y + 53.2929, x + 63.7676, y + 52.9304);
ctx.bezierCurveTo(x + 63.7676, y + 52.5679, x + 64.0066, y + 52.2859, x + 64.365, y + 52.2859);
ctx.bezierCurveTo(x + 64.6837, y + 52.2859, x + 64.9226, y + 52.5276, x + 64.9625, y + 52.8901);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 44.7289, y + 73.9172);
ctx.bezierCurveTo(x + 45.0476, y + 73.9172, x + 45.3264, y + 74.1589, x + 45.3264, y + 74.4812);
ctx.bezierCurveTo(x + 45.3662, y + 74.8437, x + 45.0874, y + 75.1257, x + 44.7688, y + 75.1257);
ctx.bezierCurveTo(x + 44.4103, y + 75.1257, x + 44.1713, y + 74.884, x + 44.1713, y + 74.5215);
ctx.bezierCurveTo(x + 44.1315, y + 74.1992, x + 44.3705, y + 73.9172, x + 44.7289, y + 73.9172);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 59.824, y + 120);
ctx.bezierCurveTo(x + 59.5054, y + 120, x + 59.2266, y + 119.758, x + 59.2266, y + 119.396);
ctx.bezierCurveTo(x + 59.2266, y + 119.073, x + 59.4655, y + 118.832, x + 59.7842, y + 118.832);
ctx.bezierCurveTo(x + 60.1028, y + 118.832, x + 60.3816, y + 119.073, x + 60.3816, y + 119.396);
ctx.bezierCurveTo(x + 60.3816, y + 119.718, x + 60.1426, y + 119.96, x + 59.824, y + 120);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 112.559, y + 72.8298);
ctx.bezierCurveTo(x + 112.241, y + 72.8298, x + 111.962, y + 72.5881, x + 111.962, y + 72.2658);
ctx.bezierCurveTo(x + 111.962, y + 71.9436, x + 112.201, y + 71.7019, x + 112.48, y + 71.6616);
ctx.bezierCurveTo(x + 112.798, y + 71.6616, x + 113.077, y + 71.9033, x + 113.077, y + 72.2256);
ctx.bezierCurveTo(x + 113.077, y + 72.5478, x + 112.838, y + 72.8298, x + 112.559, y + 72.8298);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 107.62, y + 110.816);
ctx.bezierCurveTo(x + 107.62, y + 111.138, x + 107.381, y + 111.42, x + 107.062, y + 111.42);
ctx.bezierCurveTo(x + 106.744, y + 111.42, x + 106.465, y + 111.178, x + 106.465, y + 110.816);
ctx.bezierCurveTo(x + 106.465, y + 110.493, x + 106.704, y + 110.211, x + 107.022, y + 110.211);
ctx.bezierCurveTo(x + 107.381, y + 110.252, x + 107.62, y + 110.493, x + 107.62, y + 110.816);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 45.6453, y + 101.752);
ctx.bezierCurveTo(x + 45.9639, y + 101.752, x + 46.2029, y + 102.034, x + 46.2029, y + 102.356);
ctx.bezierCurveTo(x + 46.2029, y + 102.679, x + 45.9639, y + 102.961, x + 45.6055, y + 102.92);
ctx.bezierCurveTo(x + 45.2868, y + 102.92, x + 45.0479, y + 102.638, x + 45.0479, y + 102.316);
ctx.bezierCurveTo(x + 45.0877, y + 101.994, x + 45.3267, y + 101.752, x + 45.6453, y + 101.752);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 113.993, y + 100.101);
ctx.bezierCurveTo(x + 113.993, y + 100.423, x + 113.754, y + 100.705, x + 113.436, y + 100.705);
ctx.bezierCurveTo(x + 113.117, y + 100.705, x + 112.878, y + 100.463, x + 112.878, y + 100.141);
ctx.bezierCurveTo(x + 112.878, y + 99.8186, x + 113.117, y + 99.5366, x + 113.436, y + 99.5366);
ctx.bezierCurveTo(x + 113.714, y + 99.5366, x + 113.993, y + 99.7783, x + 113.993, y + 100.101);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 98.3799, y + 54.7029);
ctx.bezierCurveTo(x + 98.6985, y + 54.7029, x + 98.9773, y + 54.9043, x + 98.9773, y + 55.2668);
ctx.bezierCurveTo(x + 98.9773, y + 55.6294, x + 98.7782, y + 55.8711, x + 98.4197, y + 55.9113);
ctx.bezierCurveTo(x + 98.1011, y + 55.9113, x + 97.8223, y + 55.7099, x + 97.8223, y + 55.3474);
ctx.bezierCurveTo(x + 97.8223, y + 54.9849, x + 98.0612, y + 54.7029, x + 98.3799, y + 54.7029);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 104.314, y + 114.36);
ctx.bezierCurveTo(x + 104.314, y + 114.723, x + 104.075, y + 114.965, x + 103.757, y + 114.965);
ctx.bezierCurveTo(x + 103.438, y + 114.965, x + 103.159, y + 114.723, x + 103.159, y + 114.401);
ctx.bezierCurveTo(x + 103.159, y + 114.038, x + 103.398, y + 113.796, x + 103.717, y + 113.796);
ctx.bezierCurveTo(x + 104.035, y + 113.796, x + 104.274, y + 114.038, x + 104.314, y + 114.36);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 92.0867, y + 51.9636);
ctx.bezierCurveTo(x + 92.0867, y + 52.3261, x + 91.8876, y + 52.5678, x + 91.5291, y + 52.5678);
ctx.bezierCurveTo(x + 91.2104, y + 52.5678, x + 90.9316, y + 52.3664, x + 90.9316, y + 52.0039);
ctx.bezierCurveTo(x + 90.9316, y + 51.6413, x + 91.1308, y + 51.3996, x + 91.4893, y + 51.3996);
ctx.bezierCurveTo(x + 91.8079, y + 51.3594, x + 92.0867, y + 51.601, x + 92.0867, y + 51.9636);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 109.492, y + 65.3774);
ctx.bezierCurveTo(x + 109.492, y + 65.6997, x + 109.253, y + 65.9816, x + 108.895, y + 65.9816);
ctx.bezierCurveTo(x + 108.576, y + 65.9816, x + 108.337, y + 65.74, x + 108.337, y + 65.4177);
ctx.bezierCurveTo(x + 108.337, y + 65.0954, x + 108.576, y + 64.8135, x + 108.934, y + 64.8135);
ctx.bezierCurveTo(x + 109.253, y + 64.8135, x + 109.492, y + 65.0552, x + 109.492, y + 65.3774);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 48.4334, y + 67.3916);
ctx.bezierCurveTo(x + 48.4334, y + 67.7138, x + 48.1944, y + 67.9958, x + 47.8758, y + 67.9958);
ctx.bezierCurveTo(x + 47.5571, y + 67.9958, x + 47.2783, y + 67.7541, x + 47.2783, y + 67.4319);
ctx.bezierCurveTo(x + 47.2783, y + 67.0693, x + 47.5173, y + 66.8276, x + 47.8359, y + 66.8276);
ctx.bezierCurveTo(x + 48.1944, y + 66.8276, x + 48.4334, y + 67.0693, x + 48.4334, y + 67.3916);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 49.7869, y + 109.204);
ctx.bezierCurveTo(x + 49.7869, y + 109.527, x + 49.5479, y + 109.809, x + 49.2293, y + 109.809);
ctx.bezierCurveTo(x + 48.9106, y + 109.809, x + 48.6318, y + 109.567, x + 48.6318, y + 109.245);
ctx.bezierCurveTo(x + 48.6318, y + 108.922, x + 48.8708, y + 108.64, x + 49.1895, y + 108.64);
ctx.bezierCurveTo(x + 49.5479, y + 108.64, x + 49.7869, y + 108.882, x + 49.7869, y + 109.204);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 110.249, y + 106.626);
ctx.bezierCurveTo(x + 110.568, y + 106.626, x + 110.807, y + 106.868, x + 110.847, y + 107.19);
ctx.bezierCurveTo(x + 110.847, y + 107.512, x + 110.608, y + 107.794, x + 110.329, y + 107.794);
ctx.bezierCurveTo(x + 110.01, y + 107.794, x + 109.771, y + 107.553, x + 109.731, y + 107.23);
ctx.bezierCurveTo(x + 109.731, y + 106.908, x + 109.97, y + 106.626, x + 110.249, y + 106.626);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 42.2988, y + 88.5801);
ctx.bezierCurveTo(x + 42.2988, y + 88.9023, x + 42.0598, y + 89.144, x + 41.7412, y + 89.1843);
ctx.bezierCurveTo(x + 41.4226, y + 89.1843, x + 41.1836, y + 88.9426, x + 41.1836, y + 88.6203);
ctx.bezierCurveTo(x + 41.1836, y + 88.2981, x + 41.4226, y + 88.0564, x + 41.7412, y + 88.0161);
ctx.bezierCurveTo(x + 42.0598, y + 88.0161, x + 42.2988, y + 88.2578, x + 42.2988, y + 88.5801);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 101.048, y + 118.026);
ctx.bezierCurveTo(x + 101.048, y + 118.348, x + 100.809, y + 118.59, x + 100.49, y + 118.59);
ctx.bezierCurveTo(x + 100.172, y + 118.59, x + 99.9326, y + 118.348, x + 99.9326, y + 118.026);
ctx.bezierCurveTo(x + 99.9326, y + 117.704, x + 100.172, y + 117.462, x + 100.49, y + 117.462);
ctx.bezierCurveTo(x + 100.769, y + 117.462, x + 101.048, y + 117.744, x + 101.048, y + 118.026);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 77.8272, y + 48.4189);
ctx.bezierCurveTo(x + 78.1458, y + 48.4189, x + 78.3848, y + 48.6606, x + 78.3848, y + 48.9829);
ctx.bezierCurveTo(x + 78.3848, y + 49.3051, x + 78.1458, y + 49.5468, x + 77.8272, y + 49.5468);
ctx.bezierCurveTo(x + 77.5085, y + 49.5468, x + 77.2695, y + 49.3051, x + 77.2695, y + 48.9829);
ctx.bezierCurveTo(x + 77.2695, y + 48.7009, x + 77.5085, y + 48.4189, x + 77.8272, y + 48.4189);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 116.303, y + 83.1418);
ctx.bezierCurveTo(x + 116.024, y + 83.1418, x + 115.745, y + 82.9001, x + 115.745, y + 82.6181);
ctx.bezierCurveTo(x + 115.745, y + 82.3362, x + 115.984, y + 82.0542, x + 116.263, y + 82.0542);
ctx.bezierCurveTo(x + 116.542, y + 82.0542, x + 116.821, y + 82.2959, x + 116.821, y + 82.5779);
ctx.bezierCurveTo(x + 116.821, y + 82.8196, x + 116.582, y + 83.1015, x + 116.303, y + 83.1418);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 85.1565, y + 48.7411);
ctx.bezierCurveTo(x + 85.1565, y + 49.0231, x + 84.9175, y + 49.3051, x + 84.6387, y + 49.3051);
ctx.bezierCurveTo(x + 84.3599, y + 49.3051, x + 84.0811, y + 49.0634, x + 84.0811, y + 48.7814);
ctx.bezierCurveTo(x + 84.0811, y + 48.4995, x + 84.32, y + 48.2175, x + 84.5988, y + 48.2175);
ctx.bezierCurveTo(x + 84.8776, y + 48.1772, x + 85.1565, y + 48.4592, x + 85.1565, y + 48.7411);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 116.941, y + 86.0825);
ctx.bezierCurveTo(x + 116.941, y + 86.3645, x + 116.702, y + 86.6465, x + 116.423, y + 86.6465);
ctx.bezierCurveTo(x + 116.144, y + 86.6465, x + 115.865, y + 86.4048, x + 115.865, y + 86.0825);
ctx.bezierCurveTo(x + 115.865, y + 85.8005, x + 116.104, y + 85.5186, x + 116.383, y + 85.5186);
ctx.bezierCurveTo(x + 116.662, y + 85.5588, x + 116.941, y + 85.8005, x + 116.941, y + 86.0825);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 74.4415, y + 48.5398);
ctx.bezierCurveTo(x + 74.7203, y + 48.5398, x + 74.9991, y + 48.7815, x + 75.039, y + 49.1037);
ctx.bezierCurveTo(x + 75.039, y + 49.426, x + 74.8, y + 49.708, x + 74.4814, y + 49.6677);
ctx.bezierCurveTo(x + 74.1627, y + 49.6677, x + 73.9636, y + 49.4663, x + 73.9237, y + 49.144);
ctx.bezierCurveTo(x + 73.8839, y + 48.862, x + 74.1627, y + 48.5398, x + 74.4415, y + 48.5398);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 81.8108, y + 48.862);
ctx.bezierCurveTo(x + 81.8108, y + 49.1843, x + 81.5718, y + 49.426, x + 81.293, y + 49.4663);
ctx.bezierCurveTo(x + 81.0142, y + 49.4663, x + 80.7354, y + 49.2246, x + 80.7354, y + 48.9023);
ctx.bezierCurveTo(x + 80.7354, y + 48.5801, x + 80.9345, y + 48.3787, x + 81.2531, y + 48.3384);
ctx.bezierCurveTo(x + 81.5319, y + 48.2981, x + 81.8108, y + 48.5398, x + 81.8108, y + 48.862);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 71.5744, y + 49.2246);
ctx.bezierCurveTo(x + 71.5744, y + 49.5066, x + 71.3354, y + 49.7885, x + 71.0566, y + 49.7885);
ctx.bezierCurveTo(x + 70.7778, y + 49.7885, x + 70.499, y + 49.5468, x + 70.499, y + 49.2246);
ctx.bezierCurveTo(x + 70.499, y + 48.9426, x + 70.738, y + 48.6606, x + 71.0168, y + 48.6606);
ctx.bezierCurveTo(x + 71.2956, y + 48.6606, x + 71.5744, y + 48.9023, x + 71.5744, y + 49.2246);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 41.9014, y + 92.6081);
ctx.bezierCurveTo(x + 41.6226, y + 92.6081, x + 41.3438, y + 92.3664, x + 41.3438, y + 92.0441);
ctx.bezierCurveTo(x + 41.3438, y + 91.7219, x + 41.6226, y + 91.4399, x + 41.9014, y + 91.4802);
ctx.bezierCurveTo(x + 42.22, y + 91.4802, x + 42.4192, y + 91.6816, x + 42.459, y + 92.0038);
ctx.bezierCurveTo(x + 42.459, y + 92.3261, x + 42.1802, y + 92.6081, x + 41.9014, y + 92.6081);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 41.6621, y + 85.6393);
ctx.bezierCurveTo(x + 41.3833, y + 85.6393, x + 41.1045, y + 85.3976, x + 41.1045, y + 85.0754);
ctx.bezierCurveTo(x + 41.1045, y + 84.7531, x + 41.3833, y + 84.4711, x + 41.6621, y + 84.5114);
ctx.bezierCurveTo(x + 41.9807, y + 84.5517, x + 42.1799, y + 84.7128, x + 42.2197, y + 85.0351);
ctx.bezierCurveTo(x + 42.2197, y + 85.3171, x + 41.9409, y + 85.599, x + 41.6621, y + 85.6393);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 44.6494, y + 71.6213);
ctx.bezierCurveTo(x + 44.3706, y + 71.6213, x + 44.0918, y + 71.3796, x + 44.0918, y + 71.0976);
ctx.bezierCurveTo(x + 44.0918, y + 70.8157, x + 44.3308, y + 70.5337, x + 44.6096, y + 70.5337);
ctx.bezierCurveTo(x + 44.8884, y + 70.5337, x + 45.1672, y + 70.7754, x + 45.1672, y + 71.0574);
ctx.bezierCurveTo(x + 45.1672, y + 71.3393, x + 44.9282, y + 71.6213, x + 44.6494, y + 71.6213);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 61.5373, y + 53.0109);
ctx.bezierCurveTo(x + 61.5373, y + 53.2929, x + 61.2585, y + 53.5749, x + 60.9797, y + 53.5346);
ctx.bezierCurveTo(x + 60.7009, y + 53.5346, x + 60.4619, y + 53.2526, x + 60.4619, y + 52.9706);
ctx.bezierCurveTo(x + 60.4619, y + 52.6887, x + 60.7407, y + 52.4067, x + 61.0195, y + 52.447);
ctx.bezierCurveTo(x + 61.2983, y + 52.447, x + 61.5373, y + 52.7289, x + 61.5373, y + 53.0109);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 42.0608, y + 81.5708);
ctx.bezierCurveTo(x + 42.0608, y + 81.8528, x + 41.8218, y + 82.1347, x + 41.543, y + 82.1347);
ctx.bezierCurveTo(x + 41.2642, y + 82.1347, x + 40.9854, y + 81.893, x + 40.9854, y + 81.6111);
ctx.bezierCurveTo(x + 40.9854, y + 81.3291, x + 41.2243, y + 81.0471, x + 41.5031, y + 81.0471);
ctx.bezierCurveTo(x + 41.7819, y + 81.0471, x + 42.0608, y + 81.2888, x + 42.0608, y + 81.5708);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 116.502, y + 89.0229);
ctx.bezierCurveTo(x + 116.781, y + 89.0229, x + 116.98, y + 89.1841, x + 117.02, y + 89.5063);
ctx.bezierCurveTo(x + 117.06, y + 89.8286, x + 116.821, y + 90.0703, x + 116.542, y + 90.0703);
ctx.bezierCurveTo(x + 116.263, y + 90.0703, x + 115.984, y + 89.8689, x + 115.984, y + 89.5466);
ctx.bezierCurveTo(x + 115.984, y + 89.2646, x + 116.184, y + 89.0229, x + 116.502, y + 89.0229);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 42.4989, y + 95.5488);
ctx.bezierCurveTo(x + 42.5387, y + 95.8711, x + 42.2998, y + 96.1128, x + 41.9811, y + 96.1128);
ctx.bezierCurveTo(x + 41.6625, y + 96.1128, x + 41.5032, y + 95.9516, x + 41.4633, y + 95.6294);
ctx.bezierCurveTo(x + 41.4235, y + 95.3071, x + 41.6625, y + 95.0654, x + 41.9413, y + 95.0654);
ctx.bezierCurveTo(x + 42.2599, y + 95.0252, x + 42.4591, y + 95.2668, x + 42.4989, y + 95.5488);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 112.36, y + 68.2778);
ctx.bezierCurveTo(x + 112.639, y + 68.2778, x + 112.917, y + 68.5195, x + 112.878, y + 68.8015);
ctx.bezierCurveTo(x + 112.878, y + 69.1238, x + 112.678, y + 69.2849, x + 112.4, y + 69.3252);
ctx.bezierCurveTo(x + 112.121, y + 69.3654, x + 111.882, y + 69.0835, x + 111.882, y + 68.8015);
ctx.bezierCurveTo(x + 111.882, y + 68.5195, x + 112.081, y + 68.2778, x + 112.36, y + 68.2778);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 46.2826, y + 105.861);
ctx.bezierCurveTo(x + 46.2826, y + 106.183, x + 46.0437, y + 106.425, x + 45.7649, y + 106.425);
ctx.bezierCurveTo(x + 45.4462, y + 106.384, x + 45.2869, y + 106.223, x + 45.2471, y + 105.901);
ctx.bezierCurveTo(x + 45.2471, y + 105.579, x + 45.486, y + 105.337, x + 45.7649, y + 105.377);
ctx.bezierCurveTo(x + 46.0835, y + 105.377, x + 46.2428, y + 105.579, x + 46.2826, y + 105.861);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 51.0617, y + 59.7783);
ctx.bezierCurveTo(x + 51.3804, y + 59.7783, x + 51.6193, y + 60.02, x + 51.5795, y + 60.3423);
ctx.bezierCurveTo(x + 51.5397, y + 60.6645, x + 51.3804, y + 60.8256, x + 51.0617, y + 60.8659);
ctx.bezierCurveTo(x + 50.7829, y + 60.8659, x + 50.5439, y + 60.6242, x + 50.5439, y + 60.302);
ctx.bezierCurveTo(x + 50.5838, y + 59.9797, x + 50.7829, y + 59.8186, x + 51.0617, y + 59.7783);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 94.8741, y + 52.4067);
ctx.bezierCurveTo(x + 94.5953, y + 52.4067, x + 94.3165, y + 52.165, x + 94.3564, y + 51.883);
ctx.bezierCurveTo(x + 94.3564, y + 51.5608, x + 94.5555, y + 51.3997, x + 94.8741, y + 51.3594);
ctx.bezierCurveTo(x + 95.1529, y + 51.3594, x + 95.3919, y + 51.6011, x + 95.3919, y + 51.883);
ctx.bezierCurveTo(x + 95.3919, y + 52.165, x + 95.1529, y + 52.4067, x + 94.8741, y + 52.4067);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 42.5778, y + 99.0129);
ctx.bezierCurveTo(x + 42.5778, y + 99.3352, x + 42.4185, y + 99.4963, x + 42.0998, y + 99.5366);
ctx.bezierCurveTo(x + 41.821, y + 99.5769, x + 41.582, y + 99.3352, x + 41.582, y + 99.0532);
ctx.bezierCurveTo(x + 41.582, y + 98.7309, x + 41.7414, y + 98.5698, x + 42.06, y + 98.5698);
ctx.bezierCurveTo(x + 42.3786, y + 98.5295, x + 42.5379, y + 98.6907, x + 42.5778, y + 99.0129);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 105.828, y + 58.4893);
ctx.bezierCurveTo(x + 105.828, y + 58.7712, x + 105.668, y + 58.9726, x + 105.35, y + 59.0129);
ctx.bezierCurveTo(x + 105.071, y + 59.0532, x + 104.832, y + 58.8115, x + 104.832, y + 58.5295);
ctx.bezierCurveTo(x + 104.832, y + 58.2073, x + 104.991, y + 58.0461, x + 105.31, y + 58.0461);
ctx.bezierCurveTo(x + 105.629, y + 58.0059, x + 105.788, y + 58.2073, x + 105.828, y + 58.4893);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 68.1491, y + 49.3855);
ctx.bezierCurveTo(x + 68.1092, y + 49.6272, x + 67.9897, y + 49.8286, x + 67.6711, y + 49.8286);
ctx.bezierCurveTo(x + 67.3923, y + 49.8286, x + 67.1533, y + 49.6272, x + 67.1533, y + 49.3049);
ctx.bezierCurveTo(x + 67.1533, y + 48.9827, x + 67.3525, y + 48.8215, x + 67.6313, y + 48.8215);
ctx.bezierCurveTo(x + 67.9499, y + 48.8215, x + 68.1491, y + 49.0229, x + 68.1491, y + 49.3855);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 116.662, y + 79.154);
ctx.bezierCurveTo(x + 116.662, y + 79.436, x + 116.423, y + 79.6777, x + 116.144, y + 79.6374);
ctx.bezierCurveTo(x + 115.865, y + 79.6374, x + 115.666, y + 79.3957, x + 115.666, y + 79.0735);
ctx.bezierCurveTo(x + 115.706, y + 78.7512, x + 115.865, y + 78.5901, x + 116.184, y + 78.5901);
ctx.bezierCurveTo(x + 116.463, y + 78.5901, x + 116.662, y + 78.8318, x + 116.662, y + 79.154);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 54.8063, y + 56.7976);
ctx.bezierCurveTo(x + 54.8063, y + 57.0393, x + 54.647, y + 57.2407, x + 54.3283, y + 57.2407);
ctx.bezierCurveTo(x + 54.0495, y + 57.281, x + 53.8105, y + 57.0393, x + 53.8105, y + 56.717);
ctx.bezierCurveTo(x + 53.8105, y + 56.3948, x + 54.0097, y + 56.2336, x + 54.2885, y + 56.2336);
ctx.bezierCurveTo(x + 54.5673, y + 56.2739, x + 54.8063, y + 56.4753, x + 54.8063, y + 56.7976);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 41.901, y + 78.0664);
ctx.bezierCurveTo(x + 41.8612, y + 78.3484, x + 41.7417, y + 78.5498, x + 41.4231, y + 78.5901);
ctx.bezierCurveTo(x + 41.1442, y + 78.6303, x + 40.9053, y + 78.3886, x + 40.9053, y + 78.1067);
ctx.bezierCurveTo(x + 40.9053, y + 77.7844, x + 41.1044, y + 77.6233, x + 41.3832, y + 77.6233);
ctx.bezierCurveTo(x + 41.7019, y + 77.583, x + 41.8612, y + 77.7844, x + 41.901, y + 78.0664);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 114.033, y + 103.605);
ctx.bezierCurveTo(x + 114.033, y + 103.887, x + 113.834, y + 104.129, x + 113.555, y + 104.169);
ctx.bezierCurveTo(x + 113.276, y + 104.169, x + 113.037, y + 103.968, x + 113.037, y + 103.686);
ctx.bezierCurveTo(x + 113.037, y + 103.363, x + 113.196, y + 103.202, x + 113.475, y + 103.162);
ctx.bezierCurveTo(x + 113.754, y + 103.081, x + 113.993, y + 103.323, x + 114.033, y + 103.605);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 88.4616, y + 48.6204);
ctx.bezierCurveTo(x + 88.4616, y + 48.9426, x + 88.3022, y + 49.1037, x + 87.9836, y + 49.144);
ctx.bezierCurveTo(x + 87.7048, y + 49.1843, x + 87.4658, y + 48.9426, x + 87.4658, y + 48.6606);
ctx.bezierCurveTo(x + 87.4658, y + 48.3384, x + 87.6251, y + 48.1773, x + 87.9438, y + 48.1773);
ctx.bezierCurveTo(x + 88.2624, y + 48.137, x + 88.4217, y + 48.3384, x + 88.4616, y + 48.6204);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 102.283, y + 55.2266);
ctx.bezierCurveTo(x + 102.283, y + 55.4683, x + 102.124, y + 55.6697, x + 101.845, y + 55.71);
ctx.bezierCurveTo(x + 101.566, y + 55.7503, x + 101.327, y + 55.5086, x + 101.327, y + 55.2266);
ctx.bezierCurveTo(x + 101.327, y + 54.9043, x + 101.486, y + 54.7432, x + 101.805, y + 54.7432);
ctx.bezierCurveTo(x + 102.044, y + 54.6627, x + 102.243, y + 54.8641, x + 102.283, y + 55.2266);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 117.139, y + 93.0513);
ctx.bezierCurveTo(x + 117.139, y + 93.3332, x + 116.94, y + 93.5749, x + 116.661, y + 93.5749);
ctx.bezierCurveTo(x + 116.383, y + 93.5749, x + 116.144, y + 93.3735, x + 116.144, y + 93.0915);
ctx.bezierCurveTo(x + 116.144, y + 92.7693, x + 116.303, y + 92.6082, x + 116.582, y + 92.5679);
ctx.bezierCurveTo(x + 116.86, y + 92.5679, x + 117.099, y + 92.7693, x + 117.139, y + 93.0513);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 52.894, y + 116.616);
ctx.bezierCurveTo(x + 52.6152, y + 116.576, x + 52.416, y + 116.455, x + 52.416, y + 116.133);
ctx.bezierCurveTo(x + 52.416, y + 115.851, x + 52.6152, y + 115.609, x + 52.894, y + 115.609);
ctx.bezierCurveTo(x + 53.1728, y + 115.609, x + 53.3719, y + 115.811, x + 53.3719, y + 116.093);
ctx.bezierCurveTo(x + 53.3719, y + 116.415, x + 53.2126, y + 116.576, x + 52.894, y + 116.616);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 48.2342, y + 63.9275);
ctx.bezierCurveTo(x + 48.2342, y + 64.2497, x + 48.0749, y + 64.4109, x + 47.7961, y + 64.4511);
ctx.bezierCurveTo(x + 47.5173, y + 64.4914, x + 47.2783, y + 64.2497, x + 47.2783, y + 63.9678);
ctx.bezierCurveTo(x + 47.2783, y + 63.6455, x + 47.4376, y + 63.4844, x + 47.7563, y + 63.4844);
ctx.bezierCurveTo(x + 48.0351, y + 63.4844, x + 48.1944, y + 63.6455, x + 48.2342, y + 63.9275);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 116.542, y + 75.5688);
ctx.bezierCurveTo(x + 116.502, y + 75.8508, x + 116.383, y + 76.0522, x + 116.064, y + 76.0925);
ctx.bezierCurveTo(x + 115.785, y + 76.0925, x + 115.586, y + 75.9314, x + 115.586, y + 75.6091);
ctx.bezierCurveTo(x + 115.586, y + 75.3272, x + 115.745, y + 75.1257, x + 116.024, y + 75.1257);
ctx.bezierCurveTo(x + 116.303, y + 75.0855, x + 116.462, y + 75.2869, x + 116.542, y + 75.5688);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 58.191, y + 53.2124);
ctx.bezierCurveTo(x + 58.0317, y + 53.3332, x + 57.8723, y + 53.5346, x + 57.6732, y + 53.5749);
ctx.bezierCurveTo(x + 57.4342, y + 53.6555, x + 57.1554, y + 53.3735, x + 57.1952, y + 53.0915);
ctx.bezierCurveTo(x + 57.2351, y + 52.8096, x + 57.3944, y + 52.6082, x + 57.6732, y + 52.6484);
ctx.bezierCurveTo(x + 57.8723, y + 52.6887, x + 58.0317, y + 52.8901, x + 58.191, y + 53.011);
ctx.bezierCurveTo(x + 58.1511, y + 53.0915, x + 58.1511, y + 53.1318, x + 58.191, y + 53.2124);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 49.3491, y + 113.273);
ctx.bezierCurveTo(x + 49.0702, y + 113.233, x + 48.8711, y + 113.072, x + 48.8711, y + 112.749);
ctx.bezierCurveTo(x + 48.8711, y + 112.427, x + 49.0702, y + 112.266, x + 49.3491, y + 112.266);
ctx.bezierCurveTo(x + 49.6279, y + 112.266, x + 49.7872, y + 112.467, x + 49.7872, y + 112.749);
ctx.bezierCurveTo(x + 49.827, y + 113.072, x + 49.6279, y + 113.233, x + 49.3491, y + 113.273);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 108.815, y + 62.437);
ctx.bezierCurveTo(x + 108.536, y + 62.3967, x + 108.337, y + 62.2356, x + 108.337, y + 61.9536);
ctx.bezierCurveTo(x + 108.337, y + 61.6313, x + 108.536, y + 61.4702, x + 108.815, y + 61.4702);
ctx.bezierCurveTo(x + 109.094, y + 61.4702, x + 109.253, y + 61.6313, x + 109.293, y + 61.9536);
ctx.bezierCurveTo(x + 109.293, y + 62.2356, x + 109.094, y + 62.3967, x + 108.815, y + 62.437);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 107.66, y + 114.239);
ctx.bezierCurveTo(x + 107.62, y + 114.562, x + 107.501, y + 114.763, x + 107.182, y + 114.763);
ctx.bezierCurveTo(x + 106.903, y + 114.763, x + 106.704, y + 114.602, x + 106.704, y + 114.28);
ctx.bezierCurveTo(x + 106.704, y + 113.998, x + 106.863, y + 113.796, x + 107.142, y + 113.796);
ctx.bezierCurveTo(x + 107.421, y + 113.796, x + 107.58, y + 113.998, x + 107.66, y + 114.239);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 110.926, y + 110.816);
ctx.bezierCurveTo(x + 110.767, y + 110.937, x + 110.608, y + 111.138, x + 110.409, y + 111.218);
ctx.bezierCurveTo(x + 110.17, y + 111.299, x + 109.891, y + 111.017, x + 109.931, y + 110.735);
ctx.bezierCurveTo(x + 109.97, y + 110.453, x + 110.13, y + 110.252, x + 110.369, y + 110.292);
ctx.bezierCurveTo(x + 110.568, y + 110.332, x + 110.727, y + 110.534, x + 110.886, y + 110.655);
ctx.bezierCurveTo(x + 110.926, y + 110.695, x + 110.926, y + 110.735, x + 110.926, y + 110.816);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 56.8368, y + 119.476);
ctx.bezierCurveTo(x + 56.7969, y + 119.799, x + 56.6376, y + 120, x + 56.3588, y + 120);
ctx.bezierCurveTo(x + 56.08, y + 120, x + 55.8809, y + 119.799, x + 55.8809, y + 119.517);
ctx.bezierCurveTo(x + 55.8809, y + 119.235, x + 56.0402, y + 119.073, x + 56.319, y + 119.033);
ctx.bezierCurveTo(x + 56.6376, y + 119.033, x + 56.7969, y + 119.235, x + 56.8368, y + 119.476);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 44.4505, y + 68.0763);
ctx.bezierCurveTo(x + 44.331, y + 67.9152, x + 44.1318, y + 67.7541, x + 44.092, y + 67.5527);
ctx.bezierCurveTo(x + 44.0123, y + 67.311, x + 44.2912, y + 67.029, x + 44.5301, y + 67.0693);
ctx.bezierCurveTo(x + 44.8089, y + 67.1096, x + 45.0081, y + 67.2707, x + 44.9683, y + 67.5527);
ctx.bezierCurveTo(x + 44.9284, y + 67.7541, x + 44.7293, y + 67.9152, x + 44.6098, y + 68.1166);
ctx.bezierCurveTo(x + 44.57, y + 68.0763, x + 44.4903, y + 68.0763, x + 44.4505, y + 68.0763);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 103.796, y + 118.469);
ctx.bezierCurveTo(x + 103.676, y + 118.308, x + 103.477, y + 118.147, x + 103.398, y + 117.946);
ctx.bezierCurveTo(x + 103.318, y + 117.704, x + 103.597, y + 117.422, x + 103.836, y + 117.422);
ctx.bezierCurveTo(x + 104.115, y + 117.422, x + 104.314, y + 117.583, x + 104.314, y + 117.865);
ctx.bezierCurveTo(x + 104.314, y + 118.066, x + 104.115, y + 118.228, x + 103.995, y + 118.429);
ctx.bezierCurveTo(x + 103.915, y + 118.469, x + 103.836, y + 118.469, x + 103.796, y + 118.469);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 117.258, y + 96.6365);
ctx.bezierCurveTo(x + 117.099, y + 96.7573, x + 116.94, y + 96.9587, x + 116.741, y + 96.999);
ctx.bezierCurveTo(x + 116.502, y + 97.0796, x + 116.263, y + 96.7573, x + 116.263, y + 96.5156);
ctx.bezierCurveTo(x + 116.303, y + 96.2336, x + 116.462, y + 96.0322, x + 116.741, y + 96.0725);
ctx.bezierCurveTo(x + 116.94, y + 96.1128, x + 117.099, y + 96.3142, x + 117.258, y + 96.4351);
ctx.bezierCurveTo(x + 117.258, y + 96.5156, x + 117.258, y + 96.5559, x + 117.258, y + 96.6365);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 41.8211, y + 74.6826);
ctx.bezierCurveTo(x + 41.6618, y + 74.8035, x + 41.4627, y + 75.0451, x + 41.3034, y + 75.0451);
ctx.bezierCurveTo(x + 41.144, y + 75.0451, x + 40.9051, y + 74.8035, x + 40.8652, y + 74.6423);
ctx.bezierCurveTo(x + 40.7856, y + 74.3604, x + 41.0246, y + 74.1589, x + 41.2635, y + 74.1992);
ctx.bezierCurveTo(x + 41.4627, y + 74.2395, x + 41.622, y + 74.4006, x + 41.7813, y + 74.5215);
ctx.bezierCurveTo(x + 41.8211, y + 74.5618, x + 41.8211, y + 74.6423, x + 41.8211, y + 74.6826);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 91.927, y + 48.6606);
ctx.bezierCurveTo(x + 91.7677, y + 48.7815, x + 91.5686, y + 48.9829, x + 91.4092, y + 48.9829);
ctx.bezierCurveTo(x + 91.2499, y + 48.9829, x + 91.0508, y + 48.7412, x + 91.0109, y + 48.5398);
ctx.bezierCurveTo(x + 90.9711, y + 48.2578, x + 91.1702, y + 48.0564, x + 91.4491, y + 48.0967);
ctx.bezierCurveTo(x + 91.6084, y + 48.137, x + 91.7677, y + 48.3384, x + 91.927, y + 48.4592);
ctx.bezierCurveTo(x + 91.927, y + 48.4995, x + 91.927, y + 48.5801, x + 91.927, y + 48.6606);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 98.8172, y + 51.8428);
ctx.bezierCurveTo(x + 98.6579, y + 51.9636, x + 98.4986, y + 52.2053, x + 98.2995, y + 52.2053);
ctx.bezierCurveTo(x + 98.1401, y + 52.2053, x + 97.9012, y + 51.9636, x + 97.8613, y + 51.8025);
ctx.bezierCurveTo(x + 97.7817, y + 51.5205, x + 98.0206, y + 51.3191, x + 98.2596, y + 51.3191);
ctx.bezierCurveTo(x + 98.4588, y + 51.3594, x + 98.6181, y + 51.5205, x + 98.7774, y + 51.6413);
ctx.bezierCurveTo(x + 98.8172, y + 51.6816, x + 98.8172, y + 51.7622, x + 98.8172, y + 51.8428);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 46.3616, y + 109.446);
ctx.bezierCurveTo(x + 46.2023, y + 109.567, x + 46.0031, y + 109.768, x + 45.8438, y + 109.768);
ctx.bezierCurveTo(x + 45.6845, y + 109.768, x + 45.4853, y + 109.527, x + 45.4455, y + 109.325);
ctx.bezierCurveTo(x + 45.4057, y + 109.043, x + 45.6048, y + 108.842, x + 45.8836, y + 108.882);
ctx.bezierCurveTo(x + 46.043, y + 108.922, x + 46.2023, y + 109.124, x + 46.3616, y + 109.245);
ctx.bezierCurveTo(x + 46.3616, y + 109.325, x + 46.3616, y + 109.365, x + 46.3616, y + 109.446);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 64.1263, y + 49.9494);
ctx.bezierCurveTo(x + 64.0068, y + 49.748, x + 63.8076, y + 49.5869, x + 63.8076, y + 49.3855);
ctx.bezierCurveTo(x + 63.8076, y + 49.2244, x + 64.0466, y + 48.9827, x + 64.2457, y + 48.9827);
ctx.bezierCurveTo(x + 64.5245, y + 48.9424, x + 64.7237, y + 49.1438, x + 64.6839, y + 49.4258);
ctx.bezierCurveTo(x + 64.644, y + 49.6272, x + 64.4449, y + 49.748, x + 64.3254, y + 49.9092);
ctx.bezierCurveTo(x + 64.2457, y + 49.9494, x + 64.2059, y + 49.9494, x + 64.1263, y + 49.9494);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 116.024, y + 71.6213);
ctx.bezierCurveTo(x + 116.143, y + 71.7825, x + 116.303, y + 71.9436, x + 116.342, y + 72.145);
ctx.bezierCurveTo(x + 116.382, y + 72.427, x + 116.183, y + 72.6284, x + 115.944, y + 72.5478);
ctx.bezierCurveTo(x + 115.785, y + 72.5075, x + 115.586, y + 72.3061, x + 115.546, y + 72.145);
ctx.bezierCurveTo(x + 115.546, y + 71.9839, x + 115.745, y + 71.8227, x + 115.825, y + 71.6213);
ctx.bezierCurveTo(x + 115.904, y + 71.6616, x + 115.944, y + 71.6616, x + 116.024, y + 71.6213);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 112.4, y + 64.7732);
ctx.bezierCurveTo(x + 112.519, y + 64.9343, x + 112.679, y + 65.0954, x + 112.718, y + 65.2969);
ctx.bezierCurveTo(x + 112.758, y + 65.5788, x + 112.559, y + 65.74, x + 112.28, y + 65.6997);
ctx.bezierCurveTo(x + 112.121, y + 65.6594, x + 111.922, y + 65.458, x + 111.922, y + 65.2969);
ctx.bezierCurveTo(x + 111.922, y + 65.1357, x + 112.121, y + 64.9746, x + 112.201, y + 64.7732);
ctx.bezierCurveTo(x + 112.241, y + 64.7732, x + 112.32, y + 64.7732, x + 112.4, y + 64.7732);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 114.113, y + 107.15);
ctx.bezierCurveTo(x + 113.953, y + 107.271, x + 113.794, y + 107.472, x + 113.635, y + 107.512);
ctx.bezierCurveTo(x + 113.356, y + 107.553, x + 113.157, y + 107.351, x + 113.236, y + 107.11);
ctx.bezierCurveTo(x + 113.276, y + 106.948, x + 113.475, y + 106.707, x + 113.595, y + 106.707);
ctx.bezierCurveTo(x + 113.754, y + 106.707, x + 113.953, y + 106.868, x + 114.113, y + 106.989);
ctx.bezierCurveTo(x + 114.113, y + 107.029, x + 114.113, y + 107.069, x + 114.113, y + 107.15);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 117.338, y + 100.101);
ctx.bezierCurveTo(x + 117.179, y + 100.221, x + 117.02, y + 100.423, x + 116.9, y + 100.383);
ctx.bezierCurveTo(x + 116.741, y + 100.383, x + 116.542, y + 100.181, x + 116.502, y + 100.02);
ctx.bezierCurveTo(x + 116.422, y + 99.7381, x + 116.622, y + 99.5769, x + 116.9, y + 99.6172);
ctx.bezierCurveTo(x + 117.06, y + 99.6575, x + 117.219, y + 99.8186, x + 117.378, y + 99.9395);
ctx.bezierCurveTo(x + 117.338, y + 99.9395, x + 117.338, y + 100.02, x + 117.338, y + 100.101);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 42.2992, y + 101.994);
ctx.bezierCurveTo(x + 42.4187, y + 102.155, x + 42.5781, y + 102.316, x + 42.6179, y + 102.518);
ctx.bezierCurveTo(x + 42.6577, y + 102.8, x + 42.4586, y + 102.961, x + 42.1798, y + 102.92);
ctx.bezierCurveTo(x + 42.0204, y + 102.88, x + 41.8213, y + 102.679, x + 41.8213, y + 102.518);
ctx.bezierCurveTo(x + 41.8213, y + 102.356, x + 42.0204, y + 102.195, x + 42.1001, y + 101.994);
ctx.bezierCurveTo(x + 42.1798, y + 101.994, x + 42.2594, y + 101.994, x + 42.2992, y + 101.994);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 38.7544, y + 85.2364);
ctx.bezierCurveTo(x + 38.5951, y + 85.3573, x + 38.4358, y + 85.5587, x + 38.3163, y + 85.5587);
ctx.bezierCurveTo(x + 38.1968, y + 85.5587, x + 38.0375, y + 85.317, x + 37.918, y + 85.1961);
ctx.bezierCurveTo(x + 38.0375, y + 85.035, x + 38.1569, y + 84.8336, x + 38.3163, y + 84.7933);
ctx.bezierCurveTo(x + 38.4358, y + 84.753, x + 38.5951, y + 84.9545, x + 38.7544, y + 85.0753);
ctx.bezierCurveTo(x + 38.7146, y + 85.1156, x + 38.7544, y + 85.1961, x + 38.7544, y + 85.2364);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 38.3162, y + 89.1843);
ctx.bezierCurveTo(x + 38.1967, y + 89.0232, x + 37.9976, y + 88.862, x + 38.0374, y + 88.7009);
ctx.bezierCurveTo(x + 38.0374, y + 88.5801, x + 38.2764, y + 88.2981, x + 38.3959, y + 88.3384);
ctx.bezierCurveTo(x + 38.5552, y + 88.3787, x + 38.7543, y + 88.5801, x + 38.7942, y + 88.7412);
ctx.bezierCurveTo(x + 38.834, y + 88.862, x + 38.6349, y + 89.0232, x + 38.5154, y + 89.1843);
ctx.bezierCurveTo(x + 38.4357, y + 89.1843, x + 38.3959, y + 89.1843, x + 38.3162, y + 89.1843);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 74.8003, y + 45.7198);
ctx.bezierCurveTo(x + 74.641, y + 45.8407, x + 74.4817, y + 46.0421, x + 74.3622, y + 46.0421);
ctx.bezierCurveTo(x + 74.2427, y + 46.0421, x + 74.0834, y + 45.8004, x + 73.9639, y + 45.6795);
ctx.bezierCurveTo(x + 74.0834, y + 45.5184, x + 74.2028, y + 45.317, x + 74.3622, y + 45.2767);
ctx.bezierCurveTo(x + 74.4817, y + 45.2364, x + 74.641, y + 45.4379, x + 74.8003, y + 45.5587);
ctx.bezierCurveTo(x + 74.8003, y + 45.599, x + 74.8003, y + 45.6393, x + 74.8003, y + 45.7198);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 77.6284, y + 46.0019);
ctx.bezierCurveTo(x + 77.5488, y + 45.8408, x + 77.3496, y + 45.6797, x + 77.3496, y + 45.5185);
ctx.bezierCurveTo(x + 77.3496, y + 45.3977, x + 77.6284, y + 45.156, x + 77.7081, y + 45.156);
ctx.bezierCurveTo(x + 77.8674, y + 45.1963, x + 78.0665, y + 45.3977, x + 78.0665, y + 45.5588);
ctx.bezierCurveTo(x + 78.0665, y + 45.6797, x + 77.8674, y + 45.8408, x + 77.7479, y + 46.0019);
ctx.bezierCurveTo(x + 77.7081, y + 46.0019, x + 77.6682, y + 46.0019, x + 77.6284, y + 46.0019);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 81.2129, y + 44.9546);
ctx.bezierCurveTo(x + 81.3324, y + 45.1157, x + 81.4917, y + 45.2768, x + 81.4917, y + 45.438);
ctx.bezierCurveTo(x + 81.4917, y + 45.5588, x + 81.2527, y + 45.8408, x + 81.1332, y + 45.8005);
ctx.bezierCurveTo(x + 80.9739, y + 45.7602, x + 80.7747, y + 45.5588, x + 80.7349, y + 45.3977);
ctx.bezierCurveTo(x + 80.6951, y + 45.2768, x + 80.9341, y + 45.1157, x + 81.0137, y + 44.9546);
ctx.bezierCurveTo(x + 81.1332, y + 44.9546, x + 81.173, y + 44.9546, x + 81.2129, y + 44.9546);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 50.9026, y + 57.3615);
ctx.bezierCurveTo(x + 50.7831, y + 57.2004, x + 50.584, y + 57.0393, x + 50.584, y + 56.8782);
ctx.bezierCurveTo(x + 50.584, y + 56.7573, x + 50.7831, y + 56.5962, x + 50.9425, y + 56.4753);
ctx.bezierCurveTo(x + 51.1018, y + 56.5962, x + 51.3009, y + 56.717, x + 51.3408, y + 56.8782);
ctx.bezierCurveTo(x + 51.3806, y + 56.999, x + 51.1814, y + 57.2004, x + 51.0619, y + 57.3213);
ctx.bezierCurveTo(x + 51.0221, y + 57.3213, x + 50.9425, y + 57.3615, x + 50.9026, y + 57.3615);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 48.1147, y + 60.5438);
ctx.bezierCurveTo(x + 47.9554, y + 60.6646, x + 47.7961, y + 60.866, x + 47.6368, y + 60.8258);
ctx.bezierCurveTo(x + 47.5173, y + 60.8258, x + 47.2783, y + 60.5438, x + 47.2783, y + 60.4632);
ctx.bezierCurveTo(x + 47.3182, y + 60.3021, x + 47.5173, y + 60.1007, x + 47.6766, y + 60.0604);
ctx.bezierCurveTo(x + 47.7961, y + 60.0201, x + 47.9554, y + 60.2618, x + 48.1147, y + 60.3424);
ctx.bezierCurveTo(x + 48.0749, y + 60.4229, x + 48.0749, y + 60.4632, x + 48.1147, y + 60.5438);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 49.9069, y + 116.294);
ctx.bezierCurveTo(x + 49.7476, y + 116.415, x + 49.5883, y + 116.576, x + 49.4688, y + 116.576);
ctx.bezierCurveTo(x + 49.3095, y + 116.536, x + 49.1502, y + 116.334, x + 49.1104, y + 116.173);
ctx.bezierCurveTo(x + 49.1104, y + 116.052, x + 49.3095, y + 115.851, x + 49.4688, y + 115.851);
ctx.bezierCurveTo(x + 49.6281, y + 115.851, x + 49.7476, y + 116.012, x + 49.9069, y + 116.133);
ctx.bezierCurveTo(x + 49.9069, y + 116.173, x + 49.9069, y + 116.254, x + 49.9069, y + 116.294);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 120.206, y + 86.0825);
ctx.bezierCurveTo(x + 120.046, y + 86.1631, x + 119.887, y + 86.3645, x + 119.768, y + 86.3645);
ctx.bezierCurveTo(x + 119.648, y + 86.3242, x + 119.449, y + 86.1228, x + 119.409, y + 85.9617);
ctx.bezierCurveTo(x + 119.409, y + 85.8408, x + 119.648, y + 85.6394, x + 119.768, y + 85.6394);
ctx.bezierCurveTo(x + 119.927, y + 85.6394, x + 120.046, y + 85.8408, x + 120.206, y + 85.9214);
ctx.bezierCurveTo(x + 120.206, y + 85.9617, x + 120.206, y + 86.0422, x + 120.206, y + 86.0825);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 71.0166, y + 45.3171);
ctx.bezierCurveTo(x + 71.136, y + 45.4783, x + 71.2954, y + 45.6394, x + 71.2954, y + 45.7602);
ctx.bezierCurveTo(x + 71.2954, y + 45.8811, x + 71.0564, y + 46.1228, x + 70.9767, y + 46.1228);
ctx.bezierCurveTo(x + 70.8174, y + 46.0825, x + 70.6183, y + 45.9214, x + 70.5784, y + 45.7602);
ctx.bezierCurveTo(x + 70.5386, y + 45.6394, x + 70.7377, y + 45.4783, x + 70.8572, y + 45.3171);
ctx.bezierCurveTo(x + 70.8971, y + 45.3171, x + 70.9369, y + 45.3171, x + 71.0166, y + 45.3171);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 42.7776, y + 106.062);
ctx.bezierCurveTo(x + 42.6183, y + 106.183, x + 42.4988, y + 106.385, x + 42.3395, y + 106.385);
ctx.bezierCurveTo(x + 42.1801, y + 106.385, x + 41.981, y + 106.183, x + 41.981, y + 106.022);
ctx.bezierCurveTo(x + 41.9412, y + 105.901, x + 42.1801, y + 105.659, x + 42.2996, y + 105.659);
ctx.bezierCurveTo(x + 42.4589, y + 105.659, x + 42.6183, y + 105.821, x + 42.7776, y + 105.901);
ctx.bezierCurveTo(x + 42.7378, y + 105.941, x + 42.7776, y + 106.022, x + 42.7776, y + 106.062);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 53.4519, y + 119.678);
ctx.bezierCurveTo(x + 53.2925, y + 119.799, x + 53.1731, y + 120, x + 53.0137, y + 119.96);
ctx.bezierCurveTo(x + 52.8544, y + 119.96, x + 52.6951, y + 119.758, x + 52.6553, y + 119.597);
ctx.bezierCurveTo(x + 52.6553, y + 119.476, x + 52.8544, y + 119.235, x + 52.9739, y + 119.235);
ctx.bezierCurveTo(x + 53.1332, y + 119.235, x + 53.2925, y + 119.396, x + 53.412, y + 119.476);
ctx.bezierCurveTo(x + 53.4519, y + 119.597, x + 53.4519, y + 119.637, x + 53.4519, y + 119.678);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 41.6223, y + 71.2185);
ctx.bezierCurveTo(x + 41.463, y + 71.3393, x + 41.3435, y + 71.5408, x + 41.1842, y + 71.5408);
ctx.bezierCurveTo(x + 41.0249, y + 71.5408, x + 40.8257, y + 71.3393, x + 40.8257, y + 71.1782);
ctx.bezierCurveTo(x + 40.7859, y + 71.0574, x + 41.0249, y + 70.8157, x + 41.1444, y + 70.8157);
ctx.bezierCurveTo(x + 41.3037, y + 70.8157, x + 41.463, y + 70.9768, x + 41.6223, y + 71.0574);
ctx.bezierCurveTo(x + 41.6223, y + 71.1379, x + 41.6223, y + 71.1782, x + 41.6223, y + 71.2185);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 109.134, y + 58.449);
ctx.bezierCurveTo(x + 108.975, y + 58.5698, x + 108.855, y + 58.7712, x + 108.696, y + 58.7712);
ctx.bezierCurveTo(x + 108.537, y + 58.7712, x + 108.377, y + 58.5698, x + 108.337, y + 58.4087);
ctx.bezierCurveTo(x + 108.298, y + 58.2878, x + 108.537, y + 58.0461, x + 108.656, y + 58.0461);
ctx.bezierCurveTo(x + 108.815, y + 58.0461, x + 108.975, y + 58.2073, x + 109.134, y + 58.2878);
ctx.bezierCurveTo(x + 109.134, y + 58.3684, x + 109.134, y + 58.4087, x + 109.134, y + 58.449);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 105.669, y + 55.146);
ctx.bezierCurveTo(x + 105.509, y + 55.2668, x + 105.39, y + 55.4682, x + 105.231, y + 55.428);
ctx.bezierCurveTo(x + 105.071, y + 55.428, x + 104.912, y + 55.2265, x + 104.872, y + 55.0654);
ctx.bezierCurveTo(x + 104.872, y + 54.9446, x + 105.071, y + 54.7029, x + 105.191, y + 54.7029);
ctx.bezierCurveTo(x + 105.35, y + 54.7029, x + 105.509, y + 54.864, x + 105.629, y + 54.9446);
ctx.bezierCurveTo(x + 105.669, y + 55.0251, x + 105.669, y + 55.0654, x + 105.669, y + 55.146);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 94.6753, y + 48.862);
ctx.bezierCurveTo(x + 94.5956, y + 48.7009, x + 94.3965, y + 48.5398, x + 94.3965, y + 48.4189);
ctx.bezierCurveTo(x + 94.4363, y + 48.2578, x + 94.6355, y + 48.0967, x + 94.7948, y + 48.0564);
ctx.bezierCurveTo(x + 94.8744, y + 48.0564, x + 95.1134, y + 48.2981, x + 95.1134, y + 48.4189);
ctx.bezierCurveTo(x + 95.1134, y + 48.5801, x + 94.9541, y + 48.7412, x + 94.8346, y + 48.862);
ctx.bezierCurveTo(x + 94.7948, y + 48.862, x + 94.755, y + 48.862, x + 94.6753, y + 48.862);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 61.2986, y + 49.6272);
ctx.bezierCurveTo(x + 61.1392, y + 49.7077, x + 60.9799, y + 49.9092, x + 60.8604, y + 49.9092);
ctx.bezierCurveTo(x + 60.7409, y + 49.8689, x + 60.5418, y + 49.6675, x + 60.502, y + 49.5063);
ctx.bezierCurveTo(x + 60.502, y + 49.3855, x + 60.7409, y + 49.1841, x + 60.8604, y + 49.1841);
ctx.bezierCurveTo(x + 61.0197, y + 49.1841, x + 61.1392, y + 49.3855, x + 61.2986, y + 49.4661);
ctx.bezierCurveTo(x + 61.3384, y + 49.5466, x + 61.2986, y + 49.5869, x + 61.2986, y + 49.6272);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 38.5555, y + 91.7219);
ctx.bezierCurveTo(x + 38.675, y + 91.8831, x + 38.8742, y + 92.0039, x + 38.8742, y + 92.165);
ctx.bezierCurveTo(x + 38.8742, y + 92.3261, x + 38.675, y + 92.5276, x + 38.5157, y + 92.5276);
ctx.bezierCurveTo(x + 38.436, y + 92.5678, x + 38.1572, y + 92.3261, x + 38.1572, y + 92.2053);
ctx.bezierCurveTo(x + 38.1572, y + 92.0442, x + 38.3165, y + 91.8831, x + 38.3962, y + 91.7219);
ctx.bezierCurveTo(x + 38.436, y + 91.7219, x + 38.5157, y + 91.7219, x + 38.5555, y + 91.7219);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 38.1565, y + 81.2083);
ctx.bezierCurveTo(x + 38.3158, y + 81.4499, x + 38.515, y + 81.6111, x + 38.4752, y + 81.7319);
ctx.bezierCurveTo(x + 38.4752, y + 81.8528, x + 38.276, y + 81.9736, x + 38.1565, y + 82.0945);
ctx.bezierCurveTo(x + 38.037, y + 81.9736, x + 37.8379, y + 81.8528, x + 37.8379, y + 81.7319);
ctx.bezierCurveTo(x + 37.8379, y + 81.6111, x + 37.9972, y + 81.4499, x + 38.1565, y + 81.2083);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 111.005, y + 114.199);
ctx.bezierCurveTo(x + 110.766, y + 114.36, x + 110.607, y + 114.562, x + 110.488, y + 114.522);
ctx.bezierCurveTo(x + 110.368, y + 114.522, x + 110.169, y + 114.32, x + 110.169, y + 114.199);
ctx.bezierCurveTo(x + 110.169, y + 114.078, x + 110.368, y + 113.877, x + 110.488, y + 113.877);
ctx.bezierCurveTo(x + 110.647, y + 113.837, x + 110.766, y + 113.998, x + 111.005, y + 114.199);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 119.887, y + 88.9021);
ctx.bezierCurveTo(x + 120.047, y + 89.1438, x + 120.206, y + 89.3049, x + 120.206, y + 89.4258);
ctx.bezierCurveTo(x + 120.206, y + 89.5466, x + 120.007, y + 89.6675, x + 119.887, y + 89.7883);
ctx.bezierCurveTo(x + 119.768, y + 89.6675, x + 119.569, y + 89.5466, x + 119.569, y + 89.4258);
ctx.bezierCurveTo(x + 119.529, y + 89.3049, x + 119.688, y + 89.1841, x + 119.887, y + 88.9021);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 119.609, y + 81.9333);
ctx.bezierCurveTo(x + 119.808, y + 82.175, x + 119.968, y + 82.2959, x + 119.968, y + 82.4167);
ctx.bezierCurveTo(x + 119.968, y + 82.5376, x + 119.769, y + 82.6584, x + 119.689, y + 82.8196);
ctx.bezierCurveTo(x + 119.569, y + 82.6987, x + 119.37, y + 82.6181, x + 119.33, y + 82.4973);
ctx.bezierCurveTo(x + 119.291, y + 82.3764, x + 119.45, y + 82.2153, x + 119.609, y + 81.9333);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 116.342, y + 68.6404);
ctx.bezierCurveTo(x + 116.103, y + 68.8418, x + 115.984, y + 69.0029, x + 115.864, y + 69.0029);
ctx.bezierCurveTo(x + 115.745, y + 69.0029, x + 115.506, y + 68.8015, x + 115.506, y + 68.6807);
ctx.bezierCurveTo(x + 115.506, y + 68.5598, x + 115.665, y + 68.3584, x + 115.824, y + 68.3181);
ctx.bezierCurveTo(x + 115.944, y + 68.3181, x + 116.063, y + 68.5195, x + 116.342, y + 68.6404);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 117.458, y + 103.525);
ctx.bezierCurveTo(x + 117.219, y + 103.686, x + 117.1, y + 103.887, x + 116.94, y + 103.887);
ctx.bezierCurveTo(x + 116.821, y + 103.887, x + 116.702, y + 103.686, x + 116.582, y + 103.565);
ctx.bezierCurveTo(x + 116.702, y + 103.444, x + 116.781, y + 103.243, x + 116.94, y + 103.243);
ctx.bezierCurveTo(x + 117.1, y + 103.162, x + 117.219, y + 103.323, x + 117.458, y + 103.525);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 107.78, y + 117.825);
ctx.bezierCurveTo(x + 107.541, y + 117.986, x + 107.421, y + 118.187, x + 107.262, y + 118.187);
ctx.bezierCurveTo(x + 107.143, y + 118.187, x + 106.943, y + 117.986, x + 106.943, y + 117.865);
ctx.bezierCurveTo(x + 106.943, y + 117.744, x + 107.143, y + 117.543, x + 107.262, y + 117.543);
ctx.bezierCurveTo(x + 107.381, y + 117.462, x + 107.541, y + 117.664, x + 107.78, y + 117.825);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 84.9966, y + 45.3172);
ctx.bezierCurveTo(x + 84.7576, y + 45.4783, x + 84.6381, y + 45.6797, x + 84.4788, y + 45.6797);
ctx.bezierCurveTo(x + 84.3593, y + 45.6797, x + 84.1602, y + 45.4783, x + 84.1602, y + 45.3574);
ctx.bezierCurveTo(x + 84.1602, y + 45.2366, x + 84.3593, y + 45.0352, x + 84.4788, y + 45.0352);
ctx.bezierCurveTo(x + 84.6381, y + 44.9546, x + 84.7576, y + 45.156, x + 84.9966, y + 45.3172);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 39.1128, y + 95.6697);
ctx.bezierCurveTo(x + 38.8738, y + 95.8711, x + 38.7543, y + 96.0322, x + 38.6348, y + 96.0322);
ctx.bezierCurveTo(x + 38.5153, y + 96.0322, x + 38.2764, y + 95.8308, x + 38.2764, y + 95.71);
ctx.bezierCurveTo(x + 38.2764, y + 95.5891, x + 38.4357, y + 95.3877, x + 38.595, y + 95.3474);
ctx.bezierCurveTo(x + 38.7145, y + 95.3474, x + 38.8738, y + 95.5085, x + 39.1128, y + 95.6697);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 54.7261, y + 53.2124);
ctx.bezierCurveTo(x + 54.4871, y + 53.4138, x + 54.3676, y + 53.5749, x + 54.2481, y + 53.5749);
ctx.bezierCurveTo(x + 54.1286, y + 53.5749, x + 53.8896, y + 53.3735, x + 53.8896, y + 53.2527);
ctx.bezierCurveTo(x + 53.8896, y + 53.1318, x + 54.049, y + 52.9304, x + 54.2083, y + 52.8901);
ctx.bezierCurveTo(x + 54.2879, y + 52.8901, x + 54.4473, y + 53.0513, x + 54.7261, y + 53.2124);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 44.4104, y + 64.6123);
ctx.bezierCurveTo(x + 44.2511, y + 64.3706, x + 44.0918, y + 64.2095, x + 44.0918, y + 64.0886);
ctx.bezierCurveTo(x + 44.0918, y + 63.9678, x + 44.2909, y + 63.7664, x + 44.4104, y + 63.7664);
ctx.bezierCurveTo(x + 44.5299, y + 63.7664, x + 44.7291, y + 63.9678, x + 44.7291, y + 64.0886);
ctx.bezierCurveTo(x + 44.7291, y + 64.2095, x + 44.5698, y + 64.3706, x + 44.4104, y + 64.6123);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 39.1923, y + 99.1339);
ctx.bezierCurveTo(x + 38.9932, y + 99.2951, x + 38.8737, y + 99.4562, x + 38.7542, y + 99.4562);
ctx.bezierCurveTo(x + 38.6347, y + 99.4562, x + 38.555, y + 99.2951, x + 38.4355, y + 99.1742);
ctx.bezierCurveTo(x + 38.555, y + 99.0534, x + 38.6347, y + 98.8922, x + 38.7542, y + 98.852);
ctx.bezierCurveTo(x + 38.8338, y + 98.8117, x + 38.9932, y + 98.9728, x + 39.1923, y + 99.1339);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 46.043, y + 113.353);
ctx.bezierCurveTo(x + 45.8837, y + 113.152, x + 45.6846, y + 113.031, x + 45.6846, y + 112.91);
ctx.bezierCurveTo(x + 45.6846, y + 112.79, x + 45.8837, y + 112.669, x + 45.9634, y + 112.548);
ctx.bezierCurveTo(x + 46.0829, y + 112.669, x + 46.2422, y + 112.749, x + 46.282, y + 112.87);
ctx.bezierCurveTo(x + 46.3218, y + 112.991, x + 46.1625, y + 113.112, x + 46.043, y + 113.353);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 113.794, y + 111.098);
ctx.bezierCurveTo(x + 113.635, y + 110.896, x + 113.436, y + 110.775, x + 113.436, y + 110.655);
ctx.bezierCurveTo(x + 113.436, y + 110.534, x + 113.635, y + 110.413, x + 113.714, y + 110.292);
ctx.bezierCurveTo(x + 113.834, y + 110.413, x + 113.993, y + 110.493, x + 114.033, y + 110.614);
ctx.bezierCurveTo(x + 114.073, y + 110.695, x + 113.953, y + 110.856, x + 113.794, y + 111.098);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 101.726, y + 52.1247);
ctx.bezierCurveTo(x + 101.566, y + 51.9233, x + 101.367, y + 51.8025, x + 101.367, y + 51.6816);
ctx.bezierCurveTo(x + 101.367, y + 51.5608, x + 101.566, y + 51.4399, x + 101.646, y + 51.3191);
ctx.bezierCurveTo(x + 101.765, y + 51.4399, x + 101.925, y + 51.5205, x + 101.965, y + 51.6413);
ctx.bezierCurveTo(x + 102.004, y + 51.7622, x + 101.845, y + 51.883, x + 101.726, y + 52.1247);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 57.9924, y + 49.6676);
ctx.bezierCurveTo(x + 57.7933, y + 49.8288, x + 57.6339, y + 49.9899, x + 57.5145, y + 49.9899);
ctx.bezierCurveTo(x + 57.395, y + 49.9899, x + 57.1958, y + 49.7885, x + 57.2356, y + 49.7079);
ctx.bezierCurveTo(x + 57.2755, y + 49.5871, x + 57.395, y + 49.4259, x + 57.5543, y + 49.3857);
ctx.bezierCurveTo(x + 57.6339, y + 49.3454, x + 57.7534, y + 49.5065, x + 57.9924, y + 49.6676);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 119.569, y + 79.5166);
ctx.bezierCurveTo(x + 119.41, y + 79.3152, x + 119.21, y + 79.154, x + 119.25, y + 79.0735);
ctx.bezierCurveTo(x + 119.29, y + 78.9526, x + 119.449, y + 78.8318, x + 119.569, y + 78.7109);
ctx.bezierCurveTo(x + 119.688, y + 78.8318, x + 119.848, y + 78.9123, x + 119.888, y + 79.0332);
ctx.bezierCurveTo(x + 119.848, y + 79.1138, x + 119.688, y + 79.2749, x + 119.569, y + 79.5166);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 88.3425, y + 45.1963);
ctx.bezierCurveTo(x + 88.1433, y + 45.3574, x + 87.984, y + 45.5588, x + 87.9044, y + 45.5185);
ctx.bezierCurveTo(x + 87.7849, y + 45.4783, x + 87.6654, y + 45.3171, x + 87.5459, y + 45.1963);
ctx.bezierCurveTo(x + 87.6654, y + 45.0754, x + 87.745, y + 44.9143, x + 87.8645, y + 44.874);
ctx.bezierCurveTo(x + 87.984, y + 44.874, x + 88.1035, y + 45.0352, x + 88.3425, y + 45.1963);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 68.029, y + 45.8408);
ctx.bezierCurveTo(x + 67.8299, y + 46.0019, x + 67.7104, y + 46.2033, x + 67.5909, y + 46.2033);
ctx.bezierCurveTo(x + 67.4714, y + 46.2033, x + 67.3519, y + 46.0019, x + 67.2324, y + 45.8811);
ctx.bezierCurveTo(x + 67.3519, y + 45.7602, x + 67.4316, y + 45.5991, x + 67.5511, y + 45.5588);
ctx.bezierCurveTo(x + 67.6705, y + 45.5588, x + 67.79, y + 45.72, x + 68.029, y + 45.8408);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 112.201, y + 62.3161);
ctx.bezierCurveTo(x + 112.041, y + 62.1147, x + 111.842, y + 61.9536, x + 111.882, y + 61.873);
ctx.bezierCurveTo(x + 111.922, y + 61.7522, x + 112.081, y + 61.6313, x + 112.201, y + 61.5105);
ctx.bezierCurveTo(x + 112.32, y + 61.6313, x + 112.48, y + 61.7119, x + 112.519, y + 61.8328);
ctx.bezierCurveTo(x + 112.48, y + 61.9536, x + 112.32, y + 62.0744, x + 112.201, y + 62.3161);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 38.5153, y + 78.1872);
ctx.bezierCurveTo(x + 38.3162, y + 78.3484, x + 38.1569, y + 78.5498, x + 38.0772, y + 78.5095);
ctx.bezierCurveTo(x + 37.9577, y + 78.4692, x + 37.8382, y + 78.3081, x + 37.7188, y + 78.1872);
ctx.bezierCurveTo(x + 37.8382, y + 78.0664, x + 37.9179, y + 77.9053, x + 38.0374, y + 77.865);
ctx.bezierCurveTo(x + 38.1569, y + 77.865, x + 38.3162, y + 78.0261, x + 38.5153, y + 78.1872);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 119.848, y + 75.4883);
ctx.bezierCurveTo(x + 119.648, y + 75.6494, x + 119.489, y + 75.8105, x + 119.37, y + 75.7702);
ctx.bezierCurveTo(x + 119.25, y + 75.7702, x + 119.091, y + 75.5688, x + 119.091, y + 75.4883);
ctx.bezierCurveTo(x + 119.131, y + 75.3674, x + 119.29, y + 75.2063, x + 119.409, y + 75.166);
ctx.bezierCurveTo(x + 119.529, y + 75.166, x + 119.648, y + 75.3271, x + 119.848, y + 75.4883);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 120.445, y + 92.9304);
ctx.bezierCurveTo(x + 120.246, y + 93.0915, x + 120.126, y + 93.2929, x + 120.007, y + 93.2929);
ctx.bezierCurveTo(x + 119.887, y + 93.2929, x + 119.768, y + 93.0915, x + 119.648, y + 92.9707);
ctx.bezierCurveTo(x + 119.768, y + 92.8498, x + 119.848, y + 92.6484, x + 119.967, y + 92.6484);
ctx.bezierCurveTo(x + 120.087, y + 92.6484, x + 120.206, y + 92.8096, x + 120.445, y + 92.9304);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 41.0646, y + 67.2305);
ctx.bezierCurveTo(x + 41.184, y + 67.4319, x + 41.3434, y + 67.5527, x + 41.3434, y + 67.6736);
ctx.bezierCurveTo(x + 41.3434, y + 67.7541, x + 41.1442, y + 67.9555, x + 41.1044, y + 67.9555);
ctx.bezierCurveTo(x + 40.9849, y + 67.9153, x + 40.8256, y + 67.7944, x + 40.8256, y + 67.6736);
ctx.bezierCurveTo(x + 40.7857, y + 67.5527, x + 40.9451, y + 67.4319, x + 41.0646, y + 67.2305);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 98.6183, y + 48.298);
ctx.bezierCurveTo(x + 98.4192, y + 48.4189, x + 98.2997, y + 48.58, x + 98.1802, y + 48.58);
ctx.bezierCurveTo(x + 98.1005, y + 48.58, x + 97.9014, y + 48.3786, x + 97.9014, y + 48.3383);
ctx.bezierCurveTo(x + 97.9412, y + 48.2175, x + 98.0607, y + 48.0564, x + 98.1802, y + 48.0564);
ctx.bezierCurveTo(x + 98.2997, y + 48.0161, x + 98.4192, y + 48.1772, x + 98.6183, y + 48.298);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 64.5242, y + 45.9617);
ctx.bezierCurveTo(x + 64.3648, y + 46.1228, x + 64.2454, y + 46.2839, x + 64.1657, y + 46.2839);
ctx.bezierCurveTo(x + 64.0462, y + 46.2839, x + 63.8869, y + 46.1228, x + 63.8471, y + 46.0019);
ctx.bezierCurveTo(x + 63.8072, y + 45.9214, x + 63.9665, y + 45.72, x + 64.086, y + 45.72);
ctx.bezierCurveTo(x + 64.2055, y + 45.72, x + 64.325, y + 45.8408, x + 64.5242, y + 45.9617);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 38.3561, y + 74.7633);
ctx.bezierCurveTo(x + 38.157, y + 74.8842, x + 38.0375, y + 75.0453, x + 37.918, y + 75.0453);
ctx.bezierCurveTo(x + 37.8384, y + 75.0453, x + 37.6392, y + 74.8439, x + 37.679, y + 74.7633);
ctx.bezierCurveTo(x + 37.7189, y + 74.6425, x + 37.8384, y + 74.4814, x + 37.9578, y + 74.4814);
ctx.bezierCurveTo(x + 38.0375, y + 74.4411, x + 38.157, y + 74.6022, x + 38.3561, y + 74.7633);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 42.3788, y + 109.043);
ctx.bezierCurveTo(x + 42.5382, y + 109.245, x + 42.6975, y + 109.325, x + 42.6975, y + 109.406);
ctx.bezierCurveTo(x + 42.6975, y + 109.527, x + 42.5382, y + 109.688, x + 42.4585, y + 109.728);
ctx.bezierCurveTo(x + 42.3788, y + 109.768, x + 42.1797, y + 109.567, x + 42.1797, y + 109.486);
ctx.bezierCurveTo(x + 42.1399, y + 109.365, x + 42.2593, y + 109.245, x + 42.3788, y + 109.043);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 120.525, y + 96.435);
ctx.bezierCurveTo(x + 120.325, y + 96.5559, x + 120.206, y + 96.6767, x + 120.086, y + 96.6767);
ctx.bezierCurveTo(x + 120.007, y + 96.6767, x + 119.927, y + 96.4753, x + 119.808, y + 96.3948);
ctx.bezierCurveTo(x + 119.927, y + 96.3142, x + 120.007, y + 96.1531, x + 120.126, y + 96.1128);
ctx.bezierCurveTo(x + 120.206, y + 96.1531, x + 120.325, y + 96.3142, x + 120.525, y + 96.435);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 51.2215, y + 53.3332);
ctx.bezierCurveTo(x + 51.0621, y + 53.4541, x + 50.9825, y + 53.6152, x + 50.9028, y + 53.5749);
ctx.bezierCurveTo(x + 50.7833, y + 53.5347, x + 50.7037, y + 53.4138, x + 50.624, y + 53.3332);
ctx.bezierCurveTo(x + 50.7037, y + 53.2527, x + 50.7833, y + 53.0916, x + 50.863, y + 53.0916);
ctx.bezierCurveTo(x + 50.9427, y + 53.0916, x + 51.0223, y + 53.2124, x + 51.2215, y + 53.3332);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 117.06, y + 106.586);
ctx.bezierCurveTo(x + 117.179, y + 106.747, x + 117.299, y + 106.868, x + 117.299, y + 106.948);
ctx.bezierCurveTo(x + 117.259, y + 107.069, x + 117.14, y + 107.15, x + 117.06, y + 107.23);
ctx.bezierCurveTo(x + 116.98, y + 107.15, x + 116.861, y + 107.069, x + 116.861, y + 106.948);
ctx.bezierCurveTo(x + 116.821, y + 106.868, x + 116.98, y + 106.747, x + 117.06, y + 106.586);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 120.524, y + 99.8589);
ctx.bezierCurveTo(x + 120.365, y + 99.9797, x + 120.285, y + 100.101, x + 120.206, y + 100.101);
ctx.bezierCurveTo(x + 120.126, y + 100.06, x + 120.046, y + 99.9394, x + 119.967, y + 99.8589);
ctx.bezierCurveTo(x + 120.046, y + 99.7783, x + 120.126, y + 99.6575, x + 120.206, y + 99.6575);
ctx.bezierCurveTo(x + 120.285, y + 99.6575, x + 120.405, y + 99.7783, x + 120.524, y + 99.8589);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 44.2509, y + 60.1812);
ctx.bezierCurveTo(x + 44.3704, y + 60.3423, x + 44.5297, y + 60.4228, x + 44.5297, y + 60.5034);
ctx.bezierCurveTo(x + 44.5297, y + 60.6243, x + 44.3704, y + 60.7048, x + 44.2907, y + 60.7854);
ctx.bezierCurveTo(x + 44.2111, y + 60.7048, x + 44.0518, y + 60.6243, x + 44.0518, y + 60.5437);
ctx.bezierCurveTo(x + 44.0518, y + 60.4631, x + 44.1314, y + 60.3423, x + 44.2509, y + 60.1812);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 105.43, y + 51.5205);
ctx.bezierCurveTo(x + 105.31, y + 51.6413, x + 105.191, y + 51.7622, x + 105.151, y + 51.7622);
ctx.bezierCurveTo(x + 105.071, y + 51.7219, x + 104.992, y + 51.6011, x + 104.872, y + 51.5205);
ctx.bezierCurveTo(x + 104.952, y + 51.4399, x + 105.031, y + 51.3191, x + 105.111, y + 51.3191);
ctx.bezierCurveTo(x + 105.191, y + 51.3191, x + 105.27, y + 51.3997, x + 105.43, y + 51.5205);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 47.5572, y + 56.6365);
ctx.bezierCurveTo(x + 47.6767, y + 56.7976, x + 47.7962, y + 56.9184, x + 47.7962, y + 56.999);
ctx.bezierCurveTo(x + 47.7564, y + 57.1199, x + 47.6369, y + 57.1601, x + 47.5174, y + 57.281);
ctx.bezierCurveTo(x + 47.4378, y + 57.2004, x + 47.3183, y + 57.0796, x + 47.3183, y + 56.999);
ctx.bezierCurveTo(x + 47.2784, y + 56.8782, x + 47.3979, y + 56.7976, x + 47.5572, y + 56.6365);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 108.616, y + 54.6223);
ctx.bezierCurveTo(x + 108.696, y + 54.7834, x + 108.855, y + 54.9043, x + 108.815, y + 54.9446);
ctx.bezierCurveTo(x + 108.775, y + 55.0251, x + 108.656, y + 55.1057, x + 108.576, y + 55.1863);
ctx.bezierCurveTo(x + 108.496, y + 55.1057, x + 108.377, y + 55.0251, x + 108.377, y + 54.9446);
ctx.bezierCurveTo(x + 108.377, y + 54.864, x + 108.496, y + 54.7834, x + 108.616, y + 54.6223);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 91.29, y + 44.7129);
ctx.bezierCurveTo(x + 91.4095, y + 44.874, x + 91.5688, y + 44.9546, x + 91.5688, y + 45.0351);
ctx.bezierCurveTo(x + 91.5688, y + 45.156, x + 91.4095, y + 45.2366, x + 91.3298, y + 45.3171);
ctx.bezierCurveTo(x + 91.2501, y + 45.2366, x + 91.0908, y + 45.156, x + 91.0908, y + 45.0754);
ctx.bezierCurveTo(x + 91.051, y + 44.9949, x + 91.1705, y + 44.9143, x + 91.29, y + 44.7129);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 46.0827, y + 116.656);
ctx.bezierCurveTo(x + 45.9632, y + 116.495, x + 45.8438, y + 116.415, x + 45.8438, y + 116.334);
ctx.bezierCurveTo(x + 45.8836, y + 116.254, x + 46.0031, y + 116.173, x + 46.0827, y + 116.093);
ctx.bezierCurveTo(x + 46.1624, y + 116.173, x + 46.2819, y + 116.254, x + 46.2819, y + 116.334);
ctx.bezierCurveTo(x + 46.3217, y + 116.415, x + 46.2022, y + 116.495, x + 46.0827, y + 116.656);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 116.064, y + 65.1762);
ctx.bezierCurveTo(x + 115.905, y + 65.2971, x + 115.785, y + 65.4179, x + 115.706, y + 65.4179);
ctx.bezierCurveTo(x + 115.586, y + 65.3776, x + 115.546, y + 65.2568, x + 115.427, y + 65.1359);
ctx.bezierCurveTo(x + 115.506, y + 65.0554, x + 115.586, y + 64.9345, x + 115.706, y + 64.9345);
ctx.bezierCurveTo(x + 115.825, y + 64.8942, x + 115.905, y + 65.0554, x + 116.064, y + 65.1762);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 112.081, y + 57.9656);
ctx.bezierCurveTo(x + 112.16, y + 58.1267, x + 112.32, y + 58.2475, x + 112.28, y + 58.2878);
ctx.bezierCurveTo(x + 112.24, y + 58.3684, x + 112.121, y + 58.449, x + 112.041, y + 58.5295);
ctx.bezierCurveTo(x + 111.961, y + 58.449, x + 111.842, y + 58.3684, x + 111.842, y + 58.2878);
ctx.bezierCurveTo(x + 111.842, y + 58.2073, x + 111.961, y + 58.0864, x + 112.081, y + 57.9656);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 38.8735, y + 102.961);
ctx.bezierCurveTo(x + 38.754, y + 102.8, x + 38.5947, y + 102.719, x + 38.5947, y + 102.638);
ctx.bezierCurveTo(x + 38.5947, y + 102.518, x + 38.754, y + 102.437, x + 38.8337, y + 102.356);
ctx.bezierCurveTo(x + 38.9134, y + 102.437, x + 39.0727, y + 102.518, x + 39.0727, y + 102.598);
ctx.bezierCurveTo(x + 39.1125, y + 102.679, x + 38.993, y + 102.759, x + 38.8735, y + 102.961);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 119.649, y + 72.0242);
ctx.bezierCurveTo(x + 119.49, y + 72.145, x + 119.37, y + 72.2659, x + 119.291, y + 72.2659);
ctx.bezierCurveTo(x + 119.171, y + 72.2256, x + 119.131, y + 72.1047, x + 119.012, y + 71.9839);
ctx.bezierCurveTo(x + 119.091, y + 71.9033, x + 119.171, y + 71.7825, x + 119.291, y + 71.7825);
ctx.bezierCurveTo(x + 119.41, y + 71.7825, x + 119.49, y + 71.9033, x + 119.649, y + 72.0242);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 49.5488, y + 119.396);
ctx.bezierCurveTo(x + 49.6682, y + 119.557, x + 49.7877, y + 119.637, x + 49.7877, y + 119.718);
ctx.bezierCurveTo(x + 49.7479, y + 119.799, x + 49.6284, y + 119.879, x + 49.5488, y + 120);
ctx.bezierCurveTo(x + 49.4691, y + 119.919, x + 49.3496, y + 119.839, x + 49.3496, y + 119.758);
ctx.bezierCurveTo(x + 49.3496, y + 119.678, x + 49.4691, y + 119.557, x + 49.5488, y + 119.396);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#30562C";

ctx.beginPath();
ctx.moveTo(x + 110.966, y + 117.664);
ctx.bezierCurveTo(x + 110.846, y + 117.784, x + 110.767, y + 117.945, x + 110.687, y + 117.945);
ctx.bezierCurveTo(x + 110.607, y + 117.945, x + 110.488, y + 117.825, x + 110.408, y + 117.744);
ctx.bezierCurveTo(x + 110.488, y + 117.664, x + 110.528, y + 117.543, x + 110.607, y + 117.502);
ctx.bezierCurveTo(x + 110.687, y + 117.462, x + 110.807, y + 117.583, x + 110.966, y + 117.664);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 127.416, y + 53.5749);
ctx.bezierCurveTo(x + 127.456, y + 58.9324, x + 126.58, y + 59.738, x + 126.58, y + 59.738);
ctx.lineTo(x + 124.349, y + 61.4299);
ctx.bezierCurveTo(x + 114.472, y + 63.1217, x + 105.191, y + 60.6243, x + 105.191, y + 60.6243);
ctx.bezierCurveTo(x + 105.191, y + 60.6243, x + 103.638, y + 59.7381, x + 103.16, y + 58.7713);
ctx.bezierCurveTo(x + 103.041, y + 57.8448, x + 103.08, y + 55.4279, x + 103.08, y + 54.2194);
ctx.lineTo(x + 103.08, y + 54.1389);
ctx.bezierCurveTo(x + 103.08, y + 54.0986, x + 103.08, y + 54.0583, x + 103.08, y + 54.018);
ctx.lineTo(x + 103.08, y + 53.4943);
ctx.lineTo(x + 103.996, y + 52.9304);
ctx.lineTo(x + 103.996, y + 47.7743);
ctx.bezierCurveTo(x + 102.284, y + 44.5517, x + 100.213, y + 44.5115, x + 97.4644, y + 44.874);
ctx.bezierCurveTo(x + 94.756, y + 45.2365, x + 80.3774, y + 47.2104, x + 80.3774, y + 47.2104);
ctx.bezierCurveTo(x + 80.3774, y + 47.2104, x + 66.0387, y + 49.1842, x + 63.2905, y + 49.5467);
ctx.bezierCurveTo(x + 60.5821, y + 49.9093, x + 58.5507, y + 50.5538, x + 57.794, y + 54.0986);
ctx.lineTo(x + 59.1482, y + 59.0935);
ctx.lineTo(x + 60.1838, y + 59.4158);
ctx.bezierCurveTo(x + 60.1838, y + 59.4158, x + 60.2634, y + 59.738, x + 60.4227, y + 60.2214);
ctx.bezierCurveTo(x + 60.7812, y + 61.4299, x + 61.4185, y + 63.6051, x + 61.538, y + 64.5316);
ctx.bezierCurveTo(x + 61.4185, y + 65.1358, x + 60.9804, y + 65.8206, x + 60.5821, y + 66.2637);
ctx.bezierCurveTo(x + 60.3033, y + 66.6263, x + 60.0643, y + 66.868, x + 60.0643, y + 66.868);
ctx.bezierCurveTo(x + 60.0643, y + 66.868, x + 51.7399, y + 71.7824, x + 41.8223, y + 72.7894);
ctx.lineTo(x + 39.1935, y + 71.7421);
ctx.bezierCurveTo(x + 39.1935, y + 71.7421, x + 38.1579, y + 71.2184, x + 36.8037, y + 66.022);
ctx.lineTo(x + 37.0825, y + 65.2164);
ctx.bezierCurveTo(x + 37.0825, y + 65.2164, x + 36.8435, y + 58.3685, x + 39.3926, y + 50.0704);
ctx.bezierCurveTo(x + 46.801, y + 46.6464, x + 52.5365, y + 44.1086, x + 58.5109, y + 42.1348);
ctx.bezierCurveTo(x + 64.4854, y + 40.161, x + 70.7386, y + 38.7109, x + 79.1029, y + 37.583);
ctx.bezierCurveTo(x + 94.5568, y + 35.4883, x + 103.2, y + 36.2537, x + 117.061, y + 38.4289);
ctx.bezierCurveTo(x + 118.295, y + 38.5095, x + 119.49, y + 38.6706, x + 120.725, y + 38.872);
ctx.bezierCurveTo(x + 120.884, y + 39.1137, x + 121.004, y + 39.3151, x + 121.163, y + 39.5568);
ctx.bezierCurveTo(x + 125.465, y + 46.6061, x + 126.978, y + 52.8901, x + 126.978, y + 52.8901);
ctx.lineTo(x + 127.416, y + 53.5749);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 52.6156, y + 65.6597);
ctx.bezierCurveTo(x + 52.8945, y + 66.4653, x + 52.6953, y + 67.271, x + 52.1775, y + 67.4321);
ctx.bezierCurveTo(x + 51.6597, y + 67.5932, x + 51.0225, y + 67.0696, x + 50.7835, y + 66.2639);
ctx.bezierCurveTo(x + 50.5047, y + 65.4583, x + 50.7038, y + 64.6527, x + 51.2216, y + 64.4915);
ctx.bezierCurveTo(x + 51.7394, y + 64.3304, x + 52.3767, y + 64.8541, x + 52.6156, y + 65.6597);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 50.5449, y + 58.9324);
ctx.bezierCurveTo(x + 51.461, y + 58.6505, x + 53.2534, y + 59.8186, x + 53.4127, y + 60.3423);
ctx.bezierCurveTo(x + 53.572, y + 60.9063, x + 53.0144, y + 61.5508, x + 52.0983, y + 61.873);
ctx.bezierCurveTo(x + 51.1822, y + 62.155, x + 50.306, y + 61.9536, x + 50.1467, y + 61.4299);
ctx.bezierCurveTo(x + 49.9873, y + 60.9063, x + 49.6289, y + 59.2144, x + 50.5449, y + 58.9324);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 116.861, y + 58.4089);
ctx.bezierCurveTo(x + 116.781, y + 59.2548, x + 115.825, y + 59.8591, x + 114.63, y + 59.7785);
ctx.bezierCurveTo(x + 113.475, y + 59.6979, x + 112.599, y + 58.9326, x + 112.639, y + 58.0867);
ctx.bezierCurveTo(x + 112.719, y + 57.2407, x + 112.52, y + 56.5157, x + 113.675, y + 56.6365);
ctx.bezierCurveTo(x + 114.869, y + 56.7171, x + 116.941, y + 57.563, x + 116.861, y + 58.4089);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 53.2138, y + 45.3171);
ctx.bezierCurveTo(x + 53.2138, y + 45.3171, x + 59.0688, y + 42.9002, x + 65.5212, y + 41.6515);
ctx.bezierCurveTo(x + 71.9338, y + 40.4027, x + 75.5185, y + 39.7179, x + 75.7574, y + 40.2416);
ctx.bezierCurveTo(x + 75.9964, y + 40.7653, x + 73.049, y + 41.6918, x + 70.938, y + 41.9737);
ctx.bezierCurveTo(x + 68.8669, y + 42.2557, x + 59.7061, y + 43.9878, x + 57.7942, y + 44.5115);
ctx.bezierCurveTo(x + 55.9621, y + 44.9949, x + 50.0673, y + 46.9284, x + 53.2138, y + 45.3171);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 82.0506, y + 38.993);
ctx.bezierCurveTo(x + 82.0506, y + 38.993, x + 89.5784, y + 38.1471, x + 97.5045, y + 38.3082);
ctx.bezierCurveTo(x + 105.431, y + 38.4694, x + 109.892, y + 38.7916, x + 109.971, y + 39.3959);
ctx.bezierCurveTo(x + 110.131, y + 40.564, x + 106.387, y + 40.0807, x + 103.837, y + 39.9598);
ctx.bezierCurveTo(x + 99.2968, y + 39.7584, x + 90.4546, y + 39.557, x + 86.1132, y + 39.7987);
ctx.bezierCurveTo(x + 80.9353, y + 40.0807, x + 77.9083, y + 39.6778, x + 82.0506, y + 38.993);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 123.154, y + 61.8731);
ctx.bezierCurveTo(x + 113.834, y + 63.1621, x + 105.231, y + 60.9063, x + 105.112, y + 60.866);
ctx.lineTo(x + 105.032, y + 60.8258);
ctx.bezierCurveTo(x + 104.952, y + 60.7855, x + 103.359, y + 59.8993, x + 102.881, y + 58.8519);
ctx.lineTo(x + 102.841, y + 58.8117);
ctx.lineTo(x + 102.841, y + 58.7714);
ctx.bezierCurveTo(x + 102.722, y + 57.8449, x + 102.762, y + 55.4682, x + 102.762, y + 54.1792);
ctx.lineTo(x + 102.762, y + 54.0987);
ctx.bezierCurveTo(x + 102.762, y + 54.0584, x + 102.762, y + 54.0181, x + 102.762, y + 53.9778);
ctx.lineTo(x + 102.762, y + 53.293);
ctx.lineTo(x + 103.678, y + 52.7291);
ctx.lineTo(x + 103.678, y + 47.7744);
ctx.bezierCurveTo(x + 102.045, y + 44.713, x + 100.093, y + 44.713, x + 97.4643, y + 45.0755);
ctx.lineTo(x + 63.2903, y + 49.7482);
ctx.bezierCurveTo(x + 60.7014, y + 50.1107, x + 58.7896, y + 50.6344, x + 58.0328, y + 54.0181);
ctx.lineTo(x + 59.3472, y + 58.7714);
ctx.lineTo(x + 60.3828, y + 59.0936);
ctx.lineTo(x + 60.4226, y + 59.2548);
ctx.bezierCurveTo(x + 60.4226, y + 59.2548, x + 60.5023, y + 59.577, x + 60.6616, y + 60.0604);
ctx.bezierCurveTo(x + 60.9404, y + 61.0272, x + 61.6573, y + 63.4441, x + 61.7768, y + 64.4108);
ctx.lineTo(x + 61.7768, y + 64.4511);
ctx.lineTo(x + 61.7768, y + 64.4914);
ctx.bezierCurveTo(x + 61.6573, y + 65.1762, x + 61.1395, y + 65.9013, x + 60.7811, y + 66.3444);
ctx.bezierCurveTo(x + 60.5023, y + 66.7069, x + 60.2235, y + 66.9486, x + 60.2235, y + 66.9486);
ctx.lineTo(x + 60.1836, y + 66.9889);
ctx.bezierCurveTo(x + 60.104, y + 67.0292, x + 52.4168, y + 71.5408, x + 43.0568, y + 72.7895);
ctx.bezierCurveTo(x + 42.6585, y + 72.8298, x + 42.2204, y + 72.9104, x + 41.7823, y + 72.9506);
ctx.lineTo(x + 41.7026, y + 72.9506);
ctx.lineTo(x + 38.9942, y + 71.863);
ctx.bezierCurveTo(x + 38.8747, y + 71.8227, x + 37.8391, y + 71.1379, x + 36.4451, y + 65.9818);
ctx.lineTo(x + 36.4053, y + 65.9013);
ctx.lineTo(x + 36.6841, y + 65.0554);
ctx.bezierCurveTo(x + 36.6841, y + 64.4108, x + 36.6044, y + 57.724, x + 39.034, y + 49.8691);
ctx.lineTo(x + 39.0739, y + 49.7482);
ctx.lineTo(x + 39.1934, y + 49.7079);
ctx.bezierCurveTo(x + 46.283, y + 46.4451, x + 52.1778, y + 43.7865, x + 58.3515, y + 41.7321);
ctx.bezierCurveTo(x + 64.5251, y + 39.6777, x + 70.8978, y + 38.2678, x + 78.9833, y + 37.14);
ctx.bezierCurveTo(x + 94.0389, y + 35.0856, x + 102.523, y + 35.6898, x + 117.061, y + 37.9859);
ctx.bezierCurveTo(x + 118.216, y + 38.147, x + 119.41, y + 38.3484, x + 120.645, y + 38.5498);
ctx.lineTo(x + 120.765, y + 38.5498);
ctx.lineTo(x + 120.844, y + 38.6707);
ctx.bezierCurveTo(x + 121.004, y + 38.9124, x + 121.123, y + 39.1138, x + 121.282, y + 39.3555);
ctx.bezierCurveTo(x + 125.385, y + 46.0423, x + 126.938, y + 52.0846, x + 127.098, y + 52.7291);
ctx.lineTo(x + 127.576, y + 53.4542);
ctx.lineTo(x + 127.576, y + 53.5347);
ctx.bezierCurveTo(x + 127.615, y + 58.8519, x + 126.779, y + 59.8187, x + 126.659, y + 59.8993);
ctx.lineTo(x + 126.62, y + 59.8993);
ctx.lineTo(x + 124.31, y + 61.6314);
ctx.lineTo(x + 124.23, y + 61.6314);
ctx.bezierCurveTo(x + 123.991, y + 61.7522, x + 123.553, y + 61.8328, x + 123.154, y + 61.8731);
ctx.closePath();
ctx.moveTo(x + 105.311, y + 60.3424);
ctx.bezierCurveTo(x + 105.948, y + 60.5035, x + 114.87, y + 62.719, x + 124.23, y + 61.148);
ctx.lineTo(x + 126.42, y + 59.4964);
ctx.bezierCurveTo(x + 126.46, y + 59.4159, x + 127.177, y + 58.4088, x + 127.137, y + 53.6556);
ctx.lineTo(x + 126.699, y + 52.9708);
ctx.lineTo(x + 126.699, y + 52.9305);
ctx.bezierCurveTo(x + 126.699, y + 52.8499, x + 125.146, y + 46.6062, x + 120.924, y + 39.6777);
ctx.bezierCurveTo(x + 120.804, y + 39.4763, x + 120.685, y + 39.3152, x + 120.566, y + 39.1138);
ctx.bezierCurveTo(x + 119.371, y + 38.9124, x + 118.216, y + 38.7512, x + 117.1, y + 38.5498);
ctx.bezierCurveTo(x + 102.642, y + 36.294, x + 94.1584, y + 35.6898, x + 79.2222, y + 37.7039);
ctx.bezierCurveTo(x + 71.1766, y + 38.7915, x + 64.8437, y + 40.2014, x + 58.6701, y + 42.2558);
ctx.bezierCurveTo(x + 52.5761, y + 44.2699, x + 46.7212, y + 46.9285, x + 39.7111, y + 50.151);
ctx.bezierCurveTo(x + 37.2417, y + 58.2477, x + 37.4408, y + 65.0151, x + 37.4408, y + 65.0956);
ctx.lineTo(x + 37.4408, y + 65.1359);
ctx.lineTo(x + 37.162, y + 65.9013);
ctx.bezierCurveTo(x + 38.3569, y + 70.4129, x + 39.3128, y + 71.2588, x + 39.3925, y + 71.3393);
ctx.lineTo(x + 41.9018, y + 72.3464);
ctx.bezierCurveTo(x + 51.3414, y + 71.3393, x + 59.387, y + 66.7875, x + 59.9446, y + 66.4652);
ctx.bezierCurveTo(x + 60.0243, y + 66.3847, x + 60.2235, y + 66.1833, x + 60.4226, y + 65.9013);
ctx.bezierCurveTo(x + 60.9006, y + 65.2971, x + 61.2192, y + 64.7734, x + 61.2989, y + 64.3303);
ctx.bezierCurveTo(x + 61.1395, y + 63.3635, x + 60.4226, y + 60.866, x + 60.2235, y + 60.141);
ctx.bezierCurveTo(x + 60.1438, y + 59.859, x + 60.0641, y + 59.6173, x + 60.0243, y + 59.4964);
ctx.lineTo(x + 58.9887, y + 59.1742);
ctx.lineTo(x + 57.5549, y + 53.9778);
ctx.lineTo(x + 57.5549, y + 53.8973);
ctx.bezierCurveTo(x + 58.3913, y + 50.1107, x + 60.6616, y + 49.5065, x + 63.2903, y + 49.144);
ctx.lineTo(x + 97.4643, y + 44.4713);
ctx.bezierCurveTo(x + 100.133, y + 44.1087, x + 102.443, y + 44.0684, x + 104.275, y + 47.5327);
ctx.lineTo(x + 104.315, y + 47.6133);
ctx.lineTo(x + 104.315, y + 53.011);
ctx.lineTo(x + 103.359, y + 53.575);
ctx.lineTo(x + 103.359, y + 53.9375);
ctx.bezierCurveTo(x + 103.359, y + 53.9778, x + 103.359, y + 54.0181, x + 103.359, y + 54.0584);
ctx.lineTo(x + 103.359, y + 54.1389);
ctx.bezierCurveTo(x + 103.319, y + 55.146, x + 103.279, y + 57.6435, x + 103.399, y + 58.6102);
ctx.bezierCurveTo(x + 103.837, y + 59.4964, x + 105.072, y + 60.2215, x + 105.311, y + 60.3424);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 126.381, y + 59.8992);
ctx.lineTo(x + 126.301, y + 59.9798);
ctx.lineTo(x + 126.062, y + 60.1409);
ctx.bezierCurveTo(x + 126.062, y + 60.1007, x + 126.341, y + 58.6505, x + 126.261, y + 56.2336);
ctx.bezierCurveTo(x + 126.221, y + 55.1863, x + 126.181, y + 54.5417, x + 126.142, y + 54.1389);
ctx.bezierCurveTo(x + 120.526, y + 55.3071, x + 107.939, y + 54.9848, x + 103.12, y + 53.4944);
ctx.lineTo(x + 104.036, y + 52.9305);
ctx.lineTo(x + 104.036, y + 47.7744);
ctx.bezierCurveTo(x + 102.323, y + 44.5518, x + 100.252, y + 44.5115, x + 97.504, y + 44.8741);
ctx.bezierCurveTo(x + 94.7956, y + 45.2366, x + 80.4171, y + 47.2104, x + 80.4171, y + 47.2104);
ctx.bezierCurveTo(x + 80.4171, y + 47.2104, x + 66.0784, y + 49.1842, x + 63.3301, y + 49.5468);
ctx.bezierCurveTo(x + 60.6217, y + 49.9093, x + 58.5904, y + 50.5538, x + 57.8336, y + 54.0986);
ctx.lineTo(x + 59.1878, y + 59.0936);
ctx.lineTo(x + 60.2234, y + 59.4159);
ctx.bezierCurveTo(x + 60.2234, y + 59.4159, x + 60.3031, y + 59.7381, x + 60.4624, y + 60.2215);
ctx.lineTo(x + 59.8251, y + 60.2618);
ctx.bezierCurveTo(x + 55.882, y + 60.5438, x + 54.8862, y + 60.584, x + 51.5405, y + 57.2809);
ctx.bezierCurveTo(x + 48.1948, y + 54.0181, x + 47.916, y + 52.7291, x + 48.2745, y + 52.286);
ctx.bezierCurveTo(x + 48.6329, y + 51.8429, x + 51.421, y + 52.3262, x + 51.421, y + 52.3262);
ctx.lineTo(x + 52.7354, y + 50.5941);
ctx.lineTo(x + 51.1024, y + 54.3001);
ctx.lineTo(x + 52.4566, y + 52.5679);
ctx.bezierCurveTo(x + 52.4566, y + 52.5679, x + 54.7269, y + 53.293, x + 55.3243, y + 53.5347);
ctx.bezierCurveTo(x + 55.2447, y + 52.4874, x + 56.2802, y + 50.5538, x + 57.7938, y + 49.8288);
ctx.bezierCurveTo(x + 56.3201, y + 49.7482, x + 55.3642, y + 49.9496, x + 55.3642, y + 49.9496);
ctx.bezierCurveTo(x + 59.0285, y + 47.7341, x + 60.6217, y + 47.3313, x + 62.4539, y + 46.9687);
ctx.bezierCurveTo(x + 64.286, y + 46.6062, x + 69.3046, y + 45.7603, x + 69.3046, y + 45.7603);
ctx.lineTo(x + 71.3757, y + 44.0282);
ctx.lineTo(x + 69.1453, y + 47.009);
ctx.lineTo(x + 71.1367, y + 45.3575);
ctx.lineTo(x + 78.5849, y + 44.2296);
ctx.bezierCurveTo(x + 78.5849, y + 44.2296, x + 85.5551, y + 41.1278, x + 88.7813, y + 40.4833);
ctx.bezierCurveTo(x + 82.8069, y + 43.1419, x + 79.8196, y + 44.2698, x + 78.0671, y + 45.3172);
ctx.lineTo(x + 83.8026, y + 43.4642);
ctx.bezierCurveTo(x + 83.8026, y + 43.4642, x + 93.999, y + 42.5377, x + 96.7074, y + 42.4572);
ctx.bezierCurveTo(x + 99.4159, y + 42.3766, x + 104.554, y + 43.2225, x + 104.554, y + 43.2225);
ctx.lineTo(x + 102.841, y + 44.4713);
ctx.bezierCurveTo(x + 103.001, y + 44.431, x + 107.143, y + 43.1822, x + 107.86, y + 43.867);
ctx.bezierCurveTo(x + 107.979, y + 44.6727, x + 107.382, y + 45.8811, x + 107.382, y + 45.8811);
ctx.bezierCurveTo(x + 107.382, y + 45.8811, x + 111.484, y + 42.1752, x + 115.308, y + 41.8932);
ctx.bezierCurveTo(x + 119.171, y + 41.6112, x + 122.716, y + 49.3454, x + 123.154, y + 53.4138);
ctx.lineTo(x + 124.987, y + 53.0513);
ctx.bezierCurveTo(x + 124.987, y + 53.0513, x + 119.729, y + 42.3363, x + 115.587, y + 39.3554);
ctx.bezierCurveTo(x + 117.459, y + 39.8791, x + 120.645, y + 44.149, x + 120.844, y + 44.431);
ctx.lineTo(x + 116.981, y + 38.429);
ctx.lineTo(x + 120.565, y + 38.9929);
ctx.bezierCurveTo(x + 120.565, y + 38.9929, x + 121.84, y + 42.4169, x + 123.951, y + 47.0896);
ctx.bezierCurveTo(x + 126.062, y + 51.722, x + 126.301, y + 53.6555, x + 126.301, y + 53.6555);
ctx.bezierCurveTo(x + 126.301, y + 53.6555, x + 127.217, y + 57.2809, x + 126.381, y + 59.8992);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 33.6167, y + 56.3142);
ctx.bezierCurveTo(x + 32.1032, y + 56.5156, x + 27.7219, y + 57.9658, x + 27.3236, y + 59.7785);
ctx.bezierCurveTo(x + 26.9253, y + 61.5911, x + 28.638, y + 61.5911, x + 28.638, y + 61.5911);
ctx.bezierCurveTo(x + 28.638, y + 61.5911, x + 27.1245, y + 62.7593, x + 27.4431, y + 64.0886);
ctx.bezierCurveTo(x + 27.7618, y + 65.4179, x + 28.9567, y + 65.0151, x + 28.9567, y + 65.0151);
ctx.bezierCurveTo(x + 28.9567, y + 65.0151, x + 27.2838, y + 66.0624, x + 27.8813, y + 67.714);
ctx.bezierCurveTo(x + 28.1202, y + 68.3182, x + 28.7177, y + 68.4391, x + 29.4744, y + 68.278);
ctx.bezierCurveTo(x + 28.1202, y + 69.3656, x + 28.0406, y + 70.2921, x + 28.3194, y + 71.0171);
ctx.bezierCurveTo(x + 28.5982, y + 71.6214, x + 29.3948, y + 71.6616, x + 29.8727, y + 71.5408);
ctx.bezierCurveTo(x + 28.9168, y + 72.145, x + 28.5584, y + 73.2729, x + 28.8372, y + 74.0786);
ctx.bezierCurveTo(x + 29.1558, y + 74.8842, x + 30.4304, y + 74.6828, x + 30.4304, y + 74.6828);
ctx.bezierCurveTo(x + 30.4304, y + 74.6828, x + 28.8372, y + 76.0927, x + 29.2753, y + 77.1803);
ctx.bezierCurveTo(x + 29.7134, y + 78.2679, x + 30.7888, y + 77.9053, x + 30.7888, y + 77.9053);
ctx.bezierCurveTo(x + 30.7888, y + 77.9053, x + 29.1956, y + 79.0735, x + 29.6338, y + 80.4028);
ctx.bezierCurveTo(x + 29.8329, y + 81.0473, x + 30.4304, y + 81.1279, x + 30.988, y + 81.0876);
ctx.bezierCurveTo(x + 29.6338, y + 81.8933, x + 29.5143, y + 82.8198, x + 29.6338, y + 83.3837);
ctx.bezierCurveTo(x + 29.7533, y + 83.9476, x + 30.4702, y + 84.1491, x + 30.8287, y + 84.1491);
ctx.bezierCurveTo(x + 29.5939, y + 84.8741, x + 29.116, y + 85.5992, x + 29.2753, y + 86.2437);
ctx.bezierCurveTo(x + 29.4346, y + 86.8882, x + 29.9922, y + 87.2105, x + 30.4304, y + 87.1299);
ctx.bezierCurveTo(x + 29.1558, y + 87.5327, x + 28.3592, y + 88.1773, x + 28.399, y + 88.9829);
ctx.bezierCurveTo(x + 27.6821, y + 88.4995, x + 26.1686, y + 88.6204, x + 26.4474, y + 90.3525);
ctx.bezierCurveTo(x + 25.7305, y + 89.3857, x + 22.9025, y + 88.2578, x + 23.4602, y + 90.8359);
ctx.bezierCurveTo(x + 22.3051, y + 89.3857, x + 19.995, y + 88.862, x + 20.2339, y + 91.0373);
ctx.bezierCurveTo(x + 19.1984, y + 89.6274, x + 17.0077, y + 88.7009, x + 16.8882, y + 91.0776);
ctx.bezierCurveTo(x + 15.9722, y + 89.8288, x + 13.5027, y + 88.6204, x + 12.5468, y + 90.3122);
ctx.bezierCurveTo(x + 11.1129, y + 89.426, x + 9.44009, y + 89.6677, x + 8.88247, y + 90.9567);
ctx.bezierCurveTo(x + 7.8469, y + 90.2719, x + 5.13848, y + 90.4733, x + 5.93507, y + 92.4471);
ctx.bezierCurveTo(x + 4.74018, y + 91.3595, x + 1.11567, y + 92.004, x + 2.70886, y + 93.8973);
ctx.bezierCurveTo(0.757207,94.139,-0.0393881,95.0252,0.000441656,96.8782);
ctx.bezierCurveTo(x + 0.0801011, y + 98.7311, x + 1.71312, y + 100.665, x + 2.74869, y + 99.2951);
ctx.bezierCurveTo(x + 3.06733, y + 101.067, x + 3.98342, y + 101.833, x + 5.05882, y + 101.994);
ctx.bezierCurveTo(x + 6.13422, y + 102.155, x + 6.3732, y + 100.866, x + 6.3732, y + 100.866);
ctx.bezierCurveTo(x + 6.3732, y + 100.866, x + 6.69184, y + 102.719, x + 8.72315, y + 102.719);
ctx.bezierCurveTo(x + 9.51975, y + 102.719, x + 9.79856, y + 102.155, x + 9.79856, y + 101.511);
ctx.bezierCurveTo(x + 10.0774, y + 102.357, x + 10.9536, y + 103.041, x + 12.1485, y + 103.041);
ctx.bezierCurveTo(x + 13.3434, y + 103.001, x + 13.2637, y + 101.752, x + 13.2637, y + 101.752);
ctx.bezierCurveTo(x + 13.2637, y + 101.752, x + 13.7019, y + 103.283, x + 15.534, y + 103.162);
ctx.bezierCurveTo(x + 16.2111, y + 103.122, x + 16.5298, y + 102.638, x + 16.6493, y + 101.873);
ctx.bezierCurveTo(x + 17.1671, y + 103.122, x + 18.2823, y + 103.283, x + 18.7602, y + 103.243);
ctx.bezierCurveTo(x + 19.2382, y + 103.202, x + 19.6763, y + 102.88, x + 19.756, y + 102.034);
ctx.bezierCurveTo(x + 20.2339, y + 102.759, x + 20.7517, y + 103.283, x + 21.9068, y + 103.323);
ctx.bezierCurveTo(x + 23.022, y + 103.364, x + 23.0619, y + 102.034, x + 23.0619, y + 102.034);
ctx.bezierCurveTo(x + 23.0619, y + 102.034, x + 23.739, y + 103.323, x + 25.2127, y + 103.323);
ctx.bezierCurveTo(x + 26.6864, y + 103.364, x + 26.3279, y + 101.954, x + 26.3279, y + 101.954);
ctx.bezierCurveTo(x + 26.3279, y + 101.954, x + 26.8855, y + 103.404, x + 28.4787, y + 103.323);
ctx.bezierCurveTo(x + 30.0719, y + 103.283, x + 29.6338, y + 101.873, x + 29.6338, y + 101.873);
ctx.bezierCurveTo(x + 29.6338, y + 101.873, x + 30.5498, y + 103.122, x + 32.143, y + 103.082);
ctx.bezierCurveTo(x + 33.7362, y + 103.001, x + 33.0591, y + 101.47, x + 33.0591, y + 101.47);
ctx.bezierCurveTo(x + 33.0591, y + 101.47, x + 34.0549, y + 102.92, x + 35.8472, y + 102.397);
ctx.bezierCurveTo(x + 36.5641, y + 102.195, x + 36.7633, y + 101.47, x + 36.4845, y + 100.786);
ctx.bezierCurveTo(x + 38.1972, y + 101.551, x + 38.8344, y + 101.47, x + 39.5912, y + 101.027);
ctx.bezierCurveTo(x + 40.3081, y + 100.584, x + 39.6709, y + 99.2145, x + 39.6709, y + 99.2145);
ctx.bezierCurveTo(x + 39.6709, y + 99.2145, x + 40.8657, y + 100.383, x + 42.1801, y + 99.577);
ctx.bezierCurveTo(x + 43.4547, y + 98.7714, x + 42.4191, y + 97.7644, x + 42.4191, y + 97.7644);
ctx.bezierCurveTo(x + 42.4191, y + 97.7644, x + 43.8132, y + 98.6103, x + 45.2072, y + 97.4018);
ctx.bezierCurveTo(x + 45.8046, y + 96.8782, x + 45.6055, y + 96.2336, x + 45.1674, y + 95.6697);
ctx.bezierCurveTo(x + 46.5216, y + 95.5489, x + 47.119, y + 95.4683, x + 47.7165, y + 94.7029);
ctx.bezierCurveTo(x + 48.3139, y + 93.9376, x + 47.358, y + 93.0111, x + 47.358, y + 93.0111);
ctx.bezierCurveTo(x + 47.358, y + 93.0111, x + 48.9114, y + 93.4542, x + 49.9469, y + 91.9638);
ctx.bezierCurveTo(x + 50.3851, y + 91.3595, x + 49.9868, y + 90.8359, x + 49.3893, y + 90.433);
ctx.bezierCurveTo(x + 50.4647, y + 90.3122, x + 51.6198, y + 90.1913, x + 52.0977, y + 89.3051);
ctx.bezierCurveTo(x + 52.5757, y + 88.4189, x + 51.2215, y + 87.6939, x + 51.2215, y + 87.6939);
ctx.bezierCurveTo(x + 51.2215, y + 87.6939, x + 52.1774, y + 88.0564, x + 52.5757, y + 87.7342);
ctx.bezierCurveTo(x + 52.974, y + 87.4522, x + 54.1291, y + 84.3505, x + 54.1291, y + 84.3505);
ctx.lineTo(x + 55.6028, y + 79.2347);
ctx.bezierCurveTo(x + 55.6028, y + 79.2347, x + 55.1248, y + 78.3484, x + 54.4079, y + 78.1873);
ctx.bezierCurveTo(x + 53.6909, y + 78.0262, x + 52.2969, y + 79.3152, x + 52.8147, y + 80.1209);
ctx.bezierCurveTo(x + 52.0181, y + 79.9194, x + 50.9825, y + 80.9265, x + 51.3011, y + 81.7321);
ctx.bezierCurveTo(x + 51.6198, y + 82.4975, x + 53.0536, y + 83.9074, x + 53.0536, y + 83.9074);
ctx.bezierCurveTo(x + 53.0536, y + 83.9074, x + 51.5799, y + 83.5045, x + 50.5444, y + 82.8197);
ctx.bezierCurveTo(x + 49.469, y + 82.135, x + 48.2741, y + 83.8268, x + 48.8715, y + 84.5116);
ctx.bezierCurveTo(x + 49.469, y + 85.1964, x + 50.9427, y + 86.2034, x + 50.9427, y + 86.2034);
ctx.bezierCurveTo(x + 50.9427, y + 86.2034, x + 49.0308, y + 85.9617, x + 48.1148, y + 85.4784);
ctx.bezierCurveTo(x + 47.1987, y + 84.995, x + 45.8843, y + 86.8077, x + 47.119, y + 87.5327);
ctx.bezierCurveTo(x + 48.3537, y + 88.2578, x + 48.9114, y + 88.5801, x + 48.9114, y + 88.5801);
ctx.bezierCurveTo(x + 48.9114, y + 88.5801, x + 47.3182, y + 88.7815, x + 46.2826, y + 88.2981);
ctx.bezierCurveTo(x + 45.247, y + 87.8147, x + 44.2114, y + 89.2649, x + 45.4063, y + 90.1108);
ctx.bezierCurveTo(x + 46.5614, y + 90.9567, x + 46.9597, y + 91.2387, x + 46.9597, y + 91.2387);
ctx.bezierCurveTo(x + 46.9597, y + 91.2387, x + 45.6851, y + 91.5609, x + 44.6097, y + 90.9567);
ctx.bezierCurveTo(x + 43.5343, y + 90.3928, x + 42.0208, y + 91.1581, x + 42.9767, y + 92.2054);
ctx.bezierCurveTo(x + 43.9725, y + 93.2528, x + 44.8089, y + 93.7362, x + 44.8089, y + 93.7362);
ctx.bezierCurveTo(x + 44.8089, y + 93.7362, x + 43.4149, y + 93.857, x + 42.4589, y + 93.0111);
ctx.bezierCurveTo(x + 41.503, y + 92.2054, x + 40.109, y + 93.4139, x + 40.9852, y + 94.3807);
ctx.bezierCurveTo(x + 41.8615, y + 95.3474, x + 42.3395, y + 96.0725, x + 42.3395, y + 96.0725);
ctx.bezierCurveTo(x + 42.3395, y + 96.0725, x + 41.2242, y + 95.7905, x + 40.109, y + 94.7029);
ctx.bezierCurveTo(x + 38.9938, y + 93.6153, x + 37.6794, y + 94.8238, x + 38.6353, y + 96.1128);
ctx.bezierCurveTo(x + 38.9141, y + 96.5156, x + 39.1531, y + 96.7976, x + 39.3522, y + 97.0796);
ctx.bezierCurveTo(x + 38.2768, y + 96.7976, x + 38.1175, y + 96.2739, x + 37.7989, y + 95.8308);
ctx.bezierCurveTo(x + 37.4802, y + 95.3877, x + 35.5286, y + 95.3474, x + 36.0464, y + 96.9184);
ctx.bezierCurveTo(x + 36.5641, y + 98.5297, x + 37.0023, y + 99.0937, x + 37.0023, y + 99.0937);
ctx.bezierCurveTo(x + 37.0023, y + 99.0937, x + 35.7277, y + 98.57, x + 35.3294, y + 97.4824);
ctx.bezierCurveTo(x + 34.8515, y + 96.1531, x + 33.099, y + 96.3142, x + 33.2583, y + 97.9658);
ctx.bezierCurveTo(x + 33.3778, y + 99.4562, x + 33.7761, y + 99.9799, x + 33.7761, y + 99.9799);
ctx.bezierCurveTo(x + 33.7761, y + 99.9799, x + 32.621, y + 99.1339, x + 32.2625, y + 97.7241);
ctx.bezierCurveTo(x + 31.9041, y + 96.3545, x + 29.9524, y + 96.7573, x + 30.1914, y + 98.3686);
ctx.bezierCurveTo(x + 30.4304, y + 99.9799, x + 30.5897, y + 100.383, x + 30.5897, y + 100.383);
ctx.bezierCurveTo(x + 30.5897, y + 100.383, x + 29.5541, y + 99.5771, x + 29.2753, y + 98.1269);
ctx.bezierCurveTo(x + 28.9965, y + 96.6768, x + 26.9253, y + 96.999, x + 27.0448, y + 98.5297);
ctx.bezierCurveTo(x + 27.1643, y + 100.02, x + 27.3635, y + 100.624, x + 27.3635, y + 100.624);
ctx.bezierCurveTo(x + 27.3635, y + 100.624, x + 26.2084, y + 99.3756, x + 26.0889, y + 98.2075);
ctx.bezierCurveTo(x + 25.9694, y + 97.0393, x + 23.8983, y + 96.8379, x + 23.9381, y + 98.57);
ctx.bezierCurveTo(x + 23.9779, y + 100.302, x + 24.0178, y + 100.544, x + 24.0178, y + 100.544);
ctx.bezierCurveTo(x + 24.0178, y + 100.544, x + 23.022, y + 99.4562, x + 22.8627, y + 98.4089);
ctx.bezierCurveTo(x + 22.7034, y + 97.3615, x + 20.9509, y + 96.7976, x + 20.7517, y + 98.1672);
ctx.bezierCurveTo(x + 20.5526, y + 99.5368, x + 20.7119, y + 100.383, x + 20.7119, y + 100.383);
ctx.bezierCurveTo(x + 20.7119, y + 100.383, x + 19.7958, y + 99.0937, x + 19.6763, y + 98.3283);
ctx.bezierCurveTo(x + 19.5967, y + 97.563, x + 17.884, y + 96.5156, x + 17.4857, y + 98.2477);
ctx.bezierCurveTo(x + 17.2865, y + 99.2145, x + 17.3264, y + 99.859, x + 17.4459, y + 100.262);
ctx.bezierCurveTo(x + 16.8484, y + 99.6173, x + 16.3705, y + 98.57, x + 16.3306, y + 97.8046);
ctx.bezierCurveTo(x + 16.2908, y + 97.0393, x + 14.2595, y + 96.5156, x + 14.1798, y + 97.9658);
ctx.bezierCurveTo(x + 14.0603, y + 99.4159, x + 14.2197, y + 100.181, x + 14.2197, y + 100.181);
ctx.bezierCurveTo(x + 14.2197, y + 100.181, x + 13.4231, y + 99.3756, x + 13.3036, y + 98.2477);
ctx.bezierCurveTo(x + 13.1841, y + 97.1601, x + 11.3917, y + 96.3545, x + 11.0731, y + 97.8046);
ctx.bezierCurveTo(x + 10.7545, y + 99.2951, x + 10.9536, y + 100.101, x + 10.9536, y + 100.101);
ctx.bezierCurveTo(x + 10.9536, y + 100.101, x + 9.9977, y + 98.7311, x + 9.9977, y + 97.9658);
ctx.bezierCurveTo(x + 9.9977, y + 97.2004, x + 9.67907, y + 96.5156, x + 9.08162, y + 96.4753);
ctx.bezierCurveTo(x + 8.48417, y + 96.4351, x + 7.8469, y + 96.7976, x + 7.76724, y + 97.7644);
ctx.bezierCurveTo(x + 7.64775, y + 98.7311, x + 7.76724, y + 99.7785, x + 7.76724, y + 99.7785);
ctx.bezierCurveTo(x + 7.76724, y + 99.7785, x + 6.93082, y + 98.5297, x + 7.0503, y + 97.6838);
ctx.bezierCurveTo(x + 7.16979, y + 96.8782, x + 7.16979, y + 96.2336, x + 6.45286, y + 95.9517);
ctx.bezierCurveTo(x + 5.77575, y + 95.6697, x + 5.49695, y + 93.9779, x + 5.49695, y + 93.9779);
ctx.bezierCurveTo(x + 5.49695, y + 93.9779, x + 6.65201, y + 94.7029, x + 7.0503, y + 95.2669);
ctx.bezierCurveTo(x + 7.4486, y + 95.8711, x + 7.60792, y + 96.4351, x + 8.72315, y + 96.2336);
ctx.bezierCurveTo(x + 9.83839, y + 96.0322, x + 9.79856, y + 94.9043, x + 9.67907, y + 94.3001);
ctx.bezierCurveTo(x + 10.157, y + 94.9043, x + 9.9977, y + 95.3877, x + 10.396, y + 95.6294);
ctx.bezierCurveTo(x + 10.7943, y + 95.9114, x + 12.4671, y + 96.0725, x + 12.8654, y + 95.3474);
ctx.bezierCurveTo(x + 13.1044, y + 94.9446, x + 13.0248, y + 94.4612, x + 12.9451, y + 94.139);
ctx.bezierCurveTo(x + 13.5027, y + 94.9849, x + 13.7019, y + 95.7503, x + 14.6976, y + 95.7503);
ctx.bezierCurveTo(x + 15.7332, y + 95.7503, x + 16.6891, y + 95.5489, x + 16.0518, y + 92.6486);
ctx.bezierCurveTo(x + 16.8484, y + 93.6153, x + 17.1671, y + 94.1793, x + 17.2069, y + 94.9446);
ctx.bezierCurveTo(x + 17.2467, y + 95.71, x + 19.0789, y + 96.1531, x + 19.4772, y + 95.0655);
ctx.bezierCurveTo(x + 19.8755, y + 93.9376, x + 19.278, y + 92.3666, x + 19.278, y + 92.3666);
ctx.bezierCurveTo(x + 19.278, y + 92.3666, x + 20.3136, y + 93.6153, x + 20.5924, y + 94.9043);
ctx.bezierCurveTo(x + 20.8314, y + 96.1934, x + 22.7432, y + 95.7503, x + 22.7432, y + 94.6626);
ctx.bezierCurveTo(x + 22.7432, y + 93.6153, x + 22.3848, y + 92.1652, x + 22.3848, y + 92.1652);
ctx.bezierCurveTo(x + 22.3848, y + 92.1652, x + 23.3407, y + 93.0111, x + 23.6991, y + 93.9376);
ctx.bezierCurveTo(x + 24.0178, y + 94.8641, x + 24.5356, y + 95.428, x + 25.2525, y + 95.3474);
ctx.bezierCurveTo(x + 25.9694, y + 95.2669, x + 26.9253, y + 94.8641, x + 25.7305, y + 92.0846);
ctx.bezierCurveTo(x + 26.7262, y + 92.6486, x + 27.005, y + 93.7362, x + 27.2838, y + 94.3001);
ctx.bezierCurveTo(x + 27.5626, y + 94.9043, x + 29.4346, y + 94.9849, x + 29.5939, y + 93.6556);
ctx.bezierCurveTo(x + 29.7134, y + 92.3263, x + 28.7575, y + 91.3192, x + 28.7575, y + 91.3192);
ctx.bezierCurveTo(x + 28.7575, y + 91.3192, x + 29.9524, y + 91.6818, x + 30.4702, y + 92.4874);
ctx.bezierCurveTo(x + 30.988, y + 93.2528, x + 31.5456, y + 93.7764, x + 32.382, y + 93.0917);
ctx.bezierCurveTo(x + 33.2184, y + 92.4069, x + 32.1829, y + 90.997, x + 32.1829, y + 90.997);
ctx.bezierCurveTo(x + 32.1829, y + 90.997, x + 33.6566, y + 91.8832, x + 34.1744, y + 90.6345);
ctx.bezierCurveTo(x + 34.6523, y + 89.3857, x + 33.4574, y + 88.9426, x + 31.7447, y + 88.4592);
ctx.bezierCurveTo(x + 32.4617, y + 87.8953, x + 33.9752, y + 88.0161, x + 34.4532, y + 87.9356);
ctx.bezierCurveTo(x + 34.9709, y + 87.855, x + 35.1701, y + 87.3716, x + 35.2099, y + 86.7271);
ctx.bezierCurveTo(x + 35.2498, y + 86.0826, x + 35.0506, y + 85.4381, x + 33.3379, y + 85.4381);
ctx.bezierCurveTo(x + 32.86, y + 85.4381, x + 32.4617, y + 85.4381, x + 32.1829, y + 85.4784);
ctx.bezierCurveTo(x + 32.9795, y + 84.713, x + 33.7362, y + 84.5519, x + 34.4133, y + 84.4713);
ctx.bezierCurveTo(x + 35.0904, y + 84.431, x + 35.6082, y + 84.1491, x + 35.6481, y + 83.2226);
ctx.bezierCurveTo(x + 35.6879, y + 82.3364, x + 34.8515, y + 81.9738, x + 34.1744, y + 82.0141);
ctx.bezierCurveTo(x + 33.4972, y + 82.0544, x + 32.382, y + 82.0947, x + 32.382, y + 82.0947);
ctx.bezierCurveTo(x + 32.382, y + 82.0947, x + 33.1786, y + 81.1279, x + 34.1744, y + 80.9668);
ctx.bezierCurveTo(x + 35.1701, y + 80.8057, x + 35.4887, y + 80.4834, x + 35.5286, y + 79.7986);
ctx.bezierCurveTo(x + 35.5684, y + 79.1138, x + 35.2099, y + 78.5096, x + 33.6964, y + 78.6304);
ctx.bezierCurveTo(x + 32.1829, y + 78.7916, x + 31.9439, y + 78.8318, x + 31.9439, y + 78.8318);
ctx.bezierCurveTo(x + 31.9439, y + 78.8318, x + 32.86, y + 77.9053, x + 34.015, y + 77.5428);
ctx.bezierCurveTo(x + 35.1701, y + 77.1803, x + 35.2896, y + 76.6566, x + 35.2896, y + 76.1732);
ctx.bezierCurveTo(x + 35.2896, y + 75.6898, x + 34.8913, y + 74.8439, x + 33.5371, y + 75.1259);
ctx.bezierCurveTo(x + 32.1829, y + 75.4079, x + 31.8244, y + 75.569, x + 31.8244, y + 75.569);
ctx.bezierCurveTo(x + 31.8244, y + 75.569, x + 32.8998, y + 74.4008, x + 33.7362, y + 74.1591);
ctx.bezierCurveTo(x + 34.5727, y + 73.9577, x + 34.8116, y + 73.2729, x + 34.8116, y + 72.8298);
ctx.bezierCurveTo(x + 34.8116, y + 72.3867, x + 34.493, y + 71.6616, x + 33.1388, y + 71.9436);
ctx.bezierCurveTo(x + 31.7846, y + 72.2256, x + 31.3863, y + 72.4673, x + 31.3863, y + 72.4673);
ctx.bezierCurveTo(x + 31.3863, y + 72.4673, x + 32.3422, y + 71.3797, x + 33.1786, y + 71.0171);
ctx.bezierCurveTo(x + 34.015, y + 70.6546, x + 34.3735, y + 70.3726, x + 34.2938, y + 69.567);
ctx.bezierCurveTo(x + 34.2142, y + 68.7613, x + 33.0591, y + 68.1974, x + 31.0278, y + 69.003);
ctx.bezierCurveTo(x + 31.7049, y + 68.3182, x + 32.382, y + 67.7543, x + 33.1388, y + 67.5529);
ctx.bezierCurveTo(x + 33.8955, y + 67.3515, x + 33.8557, y + 66.7472, x + 33.8159, y + 66.2236);
ctx.bezierCurveTo(x + 33.7761, y + 65.6999, x + 33.4176, y + 65.2165, x + 31.7846, y + 65.5791);
ctx.bezierCurveTo(x + 30.1516, y + 65.9416, x + 29.9524, y + 66.0222, x + 29.9524, y + 66.0222);
ctx.bezierCurveTo(x + 29.9524, y + 66.0222, x + 31.1075, y + 64.7734, x + 32.1032, y + 64.5317);
ctx.bezierCurveTo(x + 32.9396, y + 64.4109, x + 33.4574, y + 64.0483, x + 33.4574, y + 63.2427);
ctx.bezierCurveTo(x + 33.4176, y + 62.4371, x + 32.5812, y + 62.0745, x + 31.4261, y + 62.3968);
ctx.bezierCurveTo(x + 30.271, y + 62.719, x + 29.9524, y + 63.0413, x + 29.9524, y + 63.0413);
ctx.bezierCurveTo(x + 29.9524, y + 63.0413, x + 30.3905, y + 61.9134, x + 31.8642, y + 61.4703);
ctx.bezierCurveTo(x + 33.3379, y + 61.0272, x + 33.1786, y + 60.423, x + 33.1786, y + 60.1007);
ctx.bezierCurveTo(x + 33.1786, y + 59.7785, x + 32.9396, y + 59.0937, x + 31.9439, y + 59.134);
ctx.bezierCurveTo(x + 30.988, y + 59.134, x + 30.5897, y + 59.2951, x + 30.5897, y + 59.2951);
ctx.bezierCurveTo(x + 30.5897, y + 59.2951, x + 32.5015, y + 58.3686, x + 33.8557, y + 58.2477);
ctx.lineTo(x + 33.6167, y + 56.3142);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 15.6538, y + 99.6978);
ctx.bezierCurveTo(x + 15.7733, y + 100.221, x + 15.6538, y + 100.665, x + 15.4547, y + 100.705);
ctx.bezierCurveTo(x + 15.2157, y + 100.745, x + 14.9767, y + 100.383, x + 14.8572, y + 99.859);
ctx.bezierCurveTo(x + 14.7378, y + 99.3353, x + 14.8572, y + 98.8922, x + 15.0564, y + 98.8519);
ctx.bezierCurveTo(x + 15.2954, y + 98.8116, x + 15.5742, y + 99.2144, x + 15.6538, y + 99.6978);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 12.6265, y + 99.2146);
ctx.bezierCurveTo(x + 12.746, y + 99.7383, x + 12.6265, y + 100.181, x + 12.4273, y + 100.222);
ctx.bezierCurveTo(x + 12.1884, y + 100.262, x + 11.9494, y + 99.8994, x + 11.8299, y + 99.3757);
ctx.bezierCurveTo(x + 11.7104, y + 98.8521, x + 11.8299, y + 98.409, x + 12.029, y + 98.3687);
ctx.bezierCurveTo(x + 12.268, y + 98.2881, x + 12.507, y + 98.6909, x + 12.6265, y + 99.2146);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 8.52444, y + 93.132);
ctx.bezierCurveTo(x + 8.72358, y + 93.414, x + 8.76341, y + 93.6959, x + 8.6041, y + 93.857);
ctx.bezierCurveTo(x + 8.44478, y + 93.9779, x + 8.16597, y + 93.8571, x + 7.92699, y + 93.6154);
ctx.bezierCurveTo(x + 7.72784, y + 93.3334, x + 7.68801, y + 93.0514, x + 7.84733, y + 92.8903);
ctx.bezierCurveTo(x + 8.00665, y + 92.7292, x + 8.32529, y + 92.85, x + 8.52444, y + 93.132);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 11.591, y + 92.5278);
ctx.bezierCurveTo(x + 11.7104, y + 92.85, x + 11.6706, y + 93.132, x + 11.5113, y + 93.2126);
ctx.bezierCurveTo(x + 11.352, y + 93.2529, x + 11.1528, y + 93.0515, x + 11.0333, y + 92.7292);
ctx.bezierCurveTo(x + 10.9139, y + 92.407, x + 10.9537, y + 92.125, x + 11.113, y + 92.0444);
ctx.bezierCurveTo(x + 11.2723, y + 92.0041, x + 11.4715, y + 92.2055, x + 11.591, y + 92.5278);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 18.3221, y + 92.2458);
ctx.bezierCurveTo(x + 18.4018, y + 92.6486, x + 18.362, y + 93.0112, x + 18.2425, y + 93.0112);
ctx.bezierCurveTo(x + 18.123, y + 93.0515, x + 17.9238, y + 92.7292, x + 17.8442, y + 92.3264);
ctx.bezierCurveTo(x + 17.7645, y + 91.9236, x + 17.8043, y + 91.561, x + 17.9238, y + 91.561);
ctx.bezierCurveTo(x + 18.0433, y + 91.5207, x + 18.2425, y + 91.843, x + 18.3221, y + 92.2458);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 21.4286, y + 92.3264);
ctx.bezierCurveTo(x + 21.5082, y + 92.7292, x + 21.4684, y + 93.0918, x + 21.3489, y + 93.0918);
ctx.bezierCurveTo(x + 21.2294, y + 93.132, x + 21.0303, y + 92.8098, x + 20.9506, y + 92.407);
ctx.bezierCurveTo(x + 20.871, y + 92.0041, x + 20.9108, y + 91.6416, x + 21.0303, y + 91.6416);
ctx.bezierCurveTo(x + 21.1498, y + 91.6416, x + 21.3489, y + 91.9236, x + 21.4286, y + 92.3264);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 24.615, y + 92.0444);
ctx.bezierCurveTo(x + 24.6947, y + 92.3264, x + 24.6549, y + 92.6084, x + 24.615, y + 92.6084);
ctx.bezierCurveTo(x + 24.5354, y + 92.6084, x + 24.4557, y + 92.407, x + 24.3761, y + 92.0847);
ctx.bezierCurveTo(x + 24.2964, y + 91.8027, x + 24.3362, y + 91.5208, x + 24.3761, y + 91.5208);
ctx.bezierCurveTo(x + 24.4557, y + 91.5208, x + 24.5752, y + 91.7624, x + 24.615, y + 92.0444);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 27.8415, y + 91.2387);
ctx.bezierCurveTo(x + 27.9211, y + 91.6012, x + 27.9211, y + 91.8832, x + 27.8415, y + 91.9235);
ctx.bezierCurveTo(x + 27.7618, y + 91.9235, x + 27.6423, y + 91.6818, x + 27.5627, y + 91.3192);
ctx.bezierCurveTo(x + 27.483, y + 90.9567, x + 27.483, y + 90.6747, x + 27.5627, y + 90.6345);
ctx.bezierCurveTo(x + 27.6423, y + 90.5942, x + 27.7618, y + 90.8761, x + 27.8415, y + 91.2387);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 14.8174, y + 92.1249);
ctx.bezierCurveTo(x + 14.8572, y + 92.4472, x + 14.6979, y + 92.7292, x + 14.4987, y + 92.7694);
ctx.bezierCurveTo(x + 14.2598, y + 92.8097, x + 14.0606, y + 92.5277, x + 14.0208, y + 92.2055);
ctx.bezierCurveTo(x + 13.981, y + 91.8832, x + 14.1403, y + 91.6013, x + 14.3394, y + 91.561);
ctx.bezierCurveTo(x + 14.5784, y + 91.5207, x + 14.7776, y + 91.8027, x + 14.8174, y + 92.1249);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 5.77623, y + 98.4895);
ctx.bezierCurveTo(x + 5.77623, y + 98.7312, x + 5.69657, y + 98.9326, x + 5.57708, y + 98.9326);
ctx.bezierCurveTo(x + 5.45759, y + 98.9326, x + 5.37793, y + 98.7312, x + 5.37793, y + 98.4895);
ctx.bezierCurveTo(x + 5.37793, y + 98.2478, x + 5.45759, y + 98.0464, x + 5.57708, y + 98.0464);
ctx.bezierCurveTo(x + 5.69657, y + 98.0464, x + 5.77623, y + 98.2478, x + 5.77623, y + 98.4895);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 18.9996, y + 99.6577);
ctx.bezierCurveTo(x + 19.0792, y + 100.061, x + 18.9996, y + 100.463, x + 18.8403, y + 100.504);
ctx.bezierCurveTo(x + 18.6411, y + 100.544, x + 18.442, y + 100.222, x + 18.3623, y + 99.8188);
ctx.bezierCurveTo(x + 18.2826, y + 99.416, x + 18.3623, y + 99.0132, x + 18.5216, y + 98.9729);
ctx.bezierCurveTo(x + 18.6809, y + 98.9326, x + 18.9199, y + 99.2549, x + 18.9996, y + 99.6577);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 22.146, y + 99.9395);
ctx.bezierCurveTo(x + 22.146, y + 100.463, x + 21.9867, y + 100.947, x + 21.7477, y + 100.947);
ctx.bezierCurveTo(x + 21.5087, y + 100.947, x + 21.3096, y + 100.503, x + 21.3096, y + 99.9798);
ctx.bezierCurveTo(x + 21.3096, y + 99.4561, x + 21.4689, y + 98.9728, x + 21.7079, y + 98.9728);
ctx.bezierCurveTo(x + 21.9468, y + 98.9325, x + 22.146, y + 99.3756, x + 22.146, y + 99.9395);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 25.014, y + 99.3354);
ctx.bezierCurveTo(x + 24.8148, y + 99.3354, x + 24.6953, y + 99.698, x + 24.7352, y + 100.141);
ctx.bezierCurveTo(x + 24.775, y + 100.584, x + 24.9343, y + 100.906, x + 25.1335, y + 100.906);
ctx.bezierCurveTo(x + 25.3326, y + 100.906, x + 25.4521, y + 100.544, x + 25.4123, y + 100.101);
ctx.bezierCurveTo(x + 25.3724, y + 99.698, x + 25.2131, y + 99.3354, x + 25.014, y + 99.3354);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 28.1603, y + 99.5369);
ctx.bezierCurveTo(x + 28.0409, y + 99.5771, x + 27.9612, y + 99.8591, x + 28.0409, y + 100.141);
ctx.bezierCurveTo(x + 28.1205, y + 100.463, x + 28.2798, y + 100.705, x + 28.3993, y + 100.665);
ctx.bezierCurveTo(x + 28.5188, y + 100.624, x + 28.5985, y + 100.343, x + 28.5188, y + 100.061);
ctx.bezierCurveTo(x + 28.479, y + 99.7383, x + 28.3197, y + 99.4966, x + 28.1603, y + 99.5369);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 31.3064, y + 99.0938);
ctx.bezierCurveTo(x + 31.1869, y + 99.0938, x + 31.1072, y + 99.3757, x + 31.1471, y + 99.698);
ctx.bezierCurveTo(x + 31.1869, y + 100.02, x + 31.3462, y + 100.262, x + 31.4657, y + 100.222);
ctx.bezierCurveTo(x + 31.5852, y + 100.222, x + 31.6649, y + 99.9397, x + 31.625, y + 99.6174);
ctx.bezierCurveTo(x + 31.5852, y + 99.3354, x + 31.4657, y + 99.0938, x + 31.3064, y + 99.0938);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 34.3732, y + 98.2478);
ctx.bezierCurveTo(x + 34.2537, y + 98.2881, x + 34.1741, y + 98.5701, x + 34.2537, y + 98.8923);
ctx.bezierCurveTo(x + 34.3334, y + 99.2146, x + 34.4927, y + 99.4563, x + 34.6122, y + 99.416);
ctx.bezierCurveTo(x + 34.7317, y + 99.3757, x + 34.8114, y + 99.0937, x + 34.7317, y + 98.8118);
ctx.bezierCurveTo(x + 34.652, y + 98.4492, x + 34.4927, y + 98.2478, x + 34.3732, y + 98.2478);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 37.3604, y + 97.8046);
ctx.bezierCurveTo(x + 37.2409, y + 97.8449, x + 37.201, y + 98.0866, x + 37.2807, y + 98.3283);
ctx.bezierCurveTo(x + 37.3604, y + 98.57, x + 37.5595, y + 98.6908, x + 37.679, y + 98.6506);
ctx.bezierCurveTo(x + 37.7985, y + 98.6103, x + 37.8383, y + 98.3686, x + 37.7587, y + 98.1269);
ctx.bezierCurveTo(x + 37.679, y + 97.8852, x + 37.4799, y + 97.7241, x + 37.3604, y + 97.8046);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 4.58135, y + 96.9587);
ctx.bezierCurveTo(x + 4.86015, y + 97.281, x + 5.17879, y + 97.4421, x + 5.17879, y + 97.4421);
ctx.bezierCurveTo(x + 5.17879, y + 97.4421, x + 4.46186, y + 98.57, x + 4.46186, y + 98.8117);
ctx.bezierCurveTo(x + 4.46186, y + 98.8117, x + 4.26271, y + 97.9658, x + 4.58135, y + 96.9587);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 2.66895, y + 95.9114);
ctx.bezierCurveTo(x + 3.22656, y + 96.1933, x + 3.70452, y + 96.5559, x + 3.70452, y + 96.5559);
ctx.lineTo(x + 4.2223, y + 96.3545);
ctx.bezierCurveTo(x + 4.2223, y + 96.3545, x + 3.42571, y + 95.7502, x + 2.66895, y + 95.9114);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 33.3381, y + 82.86);
ctx.bezierCurveTo(x + 33.3381, y + 82.9809, x + 33.1389, y + 83.1017, x + 32.8203, y + 83.142);
ctx.bezierCurveTo(x + 32.5415, y + 83.1823, x + 32.2627, y + 83.142, x + 32.2627, y + 83.0614);
ctx.bezierCurveTo(x + 32.2627, y + 82.9406, x + 32.4618, y + 82.8197, x + 32.7805, y + 82.7795);
ctx.bezierCurveTo(x + 33.0593, y + 82.6989, x + 33.2983, y + 82.7392, x + 33.3381, y + 82.86);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 33.3382, y + 79.3152);
ctx.bezierCurveTo(x + 33.3382, y + 79.436, x + 33.0993, y + 79.5568, x + 32.7408, y + 79.6374);
ctx.bezierCurveTo(x + 32.3823, y + 79.6777, x + 32.1035, y + 79.6374, x + 32.1035, y + 79.5166);
ctx.bezierCurveTo(x + 32.1035, y + 79.3957, x + 32.3425, y + 79.2749, x + 32.701, y + 79.1943);
ctx.bezierCurveTo(x + 33.0594, y + 79.154, x + 33.3382, y + 79.1943, x + 33.3382, y + 79.3152);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 32.8996, y + 75.9316);
ctx.bezierCurveTo(x + 32.9394, y + 76.0928, x + 32.7004, y + 76.3345, x + 32.3419, y + 76.4553);
ctx.bezierCurveTo(x + 31.9835, y + 76.6164, x + 31.625, y + 76.6164, x + 31.5453, y + 76.4553);
ctx.bezierCurveTo(x + 31.5055, y + 76.2942, x + 31.7445, y + 76.0525, x + 32.103, y + 75.9316);
ctx.bezierCurveTo(x + 32.5013, y + 75.7705, x + 32.8199, y + 75.7705, x + 32.8996, y + 75.9316);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 32.6212, y + 73.1924);
ctx.bezierCurveTo(x + 32.6611, y + 73.3535, x + 32.4221, y + 73.5952, x + 32.0636, y + 73.716);
ctx.bezierCurveTo(x + 31.7052, y + 73.8772, x + 31.3467, y + 73.8772, x + 31.267, y + 73.716);
ctx.bezierCurveTo(x + 31.2272, y + 73.5549, x + 31.4662, y + 73.3132, x + 31.8246, y + 73.1924);
ctx.bezierCurveTo(x + 32.2229, y + 73.0313, x + 32.5416, y + 73.0313, x + 32.6212, y + 73.1924);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 31.5451, y + 66.6263);
ctx.bezierCurveTo(x + 31.585, y + 66.8277, x + 31.346, y + 67.0694, x + 31.0274, y + 67.1097);
ctx.bezierCurveTo(x + 30.7087, y + 67.1903, x + 30.4299, y + 67.0694, x + 30.3901, y + 66.868);
ctx.bezierCurveTo(x + 30.3503, y + 66.6666, x + 30.5892, y + 66.4249, x + 30.9079, y + 66.3846);
ctx.bezierCurveTo(x + 31.2265, y + 66.304, x + 31.5053, y + 66.4249, x + 31.5451, y + 66.6263);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 31.3062, y + 63.283);
ctx.bezierCurveTo(x + 31.346, y + 63.4442, x + 31.0274, y + 63.6456, x + 30.6291, y + 63.7261);
ctx.bezierCurveTo(x + 30.2308, y + 63.8067, x + 29.8723, y + 63.7664, x + 29.8325, y + 63.6053);
ctx.bezierCurveTo(x + 29.7926, y + 63.4442, x + 30.1113, y + 63.2428, x + 30.5096, y + 63.1622);
ctx.bezierCurveTo(x + 30.9079, y + 63.0413, x + 31.2663, y + 63.1219, x + 31.3062, y + 63.283);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 31.3861, y + 59.859);
ctx.bezierCurveTo(x + 31.4259, y + 60.0201, x + 31.1471, y + 60.2215, x + 30.7488, y + 60.3021);
ctx.bezierCurveTo(x + 30.3904, y + 60.3827, x + 30.0319, y + 60.3021, x + 29.9921, y + 60.141);
ctx.bezierCurveTo(x + 29.9522, y + 59.9798, x + 30.231, y + 59.7784, x + 30.6293, y + 59.6979);
ctx.bezierCurveTo(x + 31.0276, y + 59.6173, x + 31.3463, y + 59.6979, x + 31.3861, y + 59.859);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 33.6565, y + 56.7573);
ctx.bezierCurveTo(x + 31.9837, y + 57.0796, x + 29.8329, y + 58.0061, x + 29.4346, y + 58.288);
ctx.bezierCurveTo(x + 31.2269, y + 57.7644, x + 33.2582, y + 57.3616, x + 33.776, y + 57.281);
ctx.lineTo(x + 33.6565, y + 56.7573);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 106.665, y + 74.8036);
ctx.lineTo(x + 101.208, y + 72.2658);
ctx.lineTo(x + 99.1767, y + 47.7341);
ctx.lineTo(x + 95.4725, y + 47.4119);
ctx.lineTo(x + 95.1539, y + 53.4542);
ctx.lineTo(x + 94.3175, y + 53.9375);
ctx.lineTo(x + 81.1338, y + 54.1792);
ctx.lineTo(x + 67.9502, y + 54.4209);
ctx.lineTo(x + 67.0739, y + 53.9375);
ctx.lineTo(x + 66.5163, y + 47.8952);
ctx.lineTo(x + 62.852, y + 48.3383);
ctx.lineTo(x + 61.6172, y + 72.9104);
ctx.lineTo(x + 56.2801, y + 75.6898);
ctx.lineTo(x + 51.7793, y + 90.1913);
ctx.lineTo(x + 52.0979, y + 109.486);
ctx.lineTo(x + 62.8121, y + 109.285);
ctx.lineTo(x + 62.7723, y + 106.143);
ctx.lineTo(x + 81.9702, y + 105.78);
ctx.lineTo(x + 99.8538, y + 105.498);
ctx.lineTo(x + 100.65, y + 108.64);
ctx.lineTo(x + 111.962, y + 108.439);
ctx.lineTo(x + 111.643, y + 89.144);
ctx.lineTo(x + 106.665, y + 74.8036);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 112.241, y + 108.721);
ctx.lineTo(x + 100.452, y + 108.922);
ctx.lineTo(x + 99.6151, y + 105.78);
ctx.lineTo(x + 63.0116, y + 106.425);
ctx.lineTo(x + 63.0514, y + 109.607);
ctx.lineTo(x + 51.7796, y + 109.809);
ctx.lineTo(x + 51.4609, y + 90.1913);
ctx.lineTo(x + 56.0015, y + 75.5287);
ctx.lineTo(x + 61.2989, y + 72.7895);
ctx.lineTo(x + 62.5336, y + 48.1369);
ctx.lineTo(x + 66.7556, y + 47.6133);
ctx.lineTo(x + 67.3132, y + 53.7764);
ctx.lineTo(x + 67.9903, y + 54.1389);
ctx.lineTo(x + 94.1982, y + 53.6958);
ctx.lineTo(x + 94.8753, y + 53.293);
ctx.lineTo(x + 95.194, y + 47.1299);
ctx.lineTo(x + 99.4159, y + 47.4924);
ctx.lineTo(x + 101.447, y + 72.0644);
ctx.lineTo(x + 106.824, y + 74.6022);
ctx.lineTo(x + 111.883, y + 89.1037);
ctx.lineTo(x + 112.241, y + 108.721);
ctx.closePath();
ctx.moveTo(x + 100.89, y + 108.358);
ctx.lineTo(x + 111.684, y + 108.157);
ctx.lineTo(x + 111.365, y + 89.1843);
ctx.lineTo(x + 106.426, y + 75.005);
ctx.lineTo(x + 100.969, y + 72.427);
ctx.lineTo(x + 100.969, y + 72.2658);
ctx.lineTo(x + 98.938, y + 47.9758);
ctx.lineTo(x + 95.7516, y + 47.6938);
ctx.lineTo(x + 95.433, y + 53.575);
ctx.lineTo(x + 94.3974, y + 54.2195);
ctx.lineTo(x + 67.8708, y + 54.6626);
ctx.lineTo(x + 66.7954, y + 54.0584);
ctx.lineTo(x + 66.2776, y + 48.1772);
ctx.lineTo(x + 63.1311, y + 48.5398);
ctx.lineTo(x + 61.9362, y + 73.0312);
ctx.lineTo(x + 56.5591, y + 75.8106);
ctx.lineTo(x + 52.0982, y + 90.151);
ctx.lineTo(x + 52.4169, y + 109.124);
ctx.lineTo(x + 62.5336, y + 108.963);
ctx.lineTo(x + 62.4938, y + 105.78);
ctx.lineTo(x + 100.093, y + 105.136);
ctx.lineTo(x + 100.89, y + 108.358);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 107.542, y + 87.694);
ctx.bezierCurveTo(x + 107.581, y + 88.9427, x + 98.0223, y + 88.4996, x + 86.2327, y + 88.701);
ctx.bezierCurveTo(x + 74.483, y + 88.9024, x + 64.9238, y + 89.6275, x + 64.9238, y + 88.419);
ctx.bezierCurveTo(x + 64.9238, y + 87.5328, x + 74.4431, y + 87.6134, x + 86.2327, y + 87.412);
ctx.bezierCurveTo(x + 97.9825, y + 87.2106, x + 107.502, y + 86.4855, x + 107.542, y + 87.694);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 53.6914, y + 86.8076);
ctx.lineTo(x + 56.3998, y + 78.9526);
ctx.bezierCurveTo(x + 56.3998, y + 78.9526, x + 59.0286, y + 78.6706, x + 60.2235, y + 77.7844);
ctx.bezierCurveTo(x + 58.1922, y + 78.2275, x + 57.0769, y + 78.0261, x + 56.6388, y + 77.7441);
ctx.lineTo(x + 60.8608, y + 74.8438);
ctx.lineTo(x + 61.0599, y + 73.2326);
ctx.lineTo(x + 61.6175, y + 72.9506);
ctx.lineTo(x + 61.8963, y + 71.863);
ctx.bezierCurveTo(x + 61.8963, y + 71.863, x + 63.6488, y + 62.1953, x + 63.5294, y + 58.4088);
ctx.bezierCurveTo(x + 64.4454, y + 57.8448, x + 66.5564, y + 58.2477, x + 67.3132, y + 58.8519);
ctx.lineTo(x + 66.7556, y + 53.6958);
ctx.lineTo(x + 67.0344, y + 53.6958);
ctx.lineTo(x + 67.9505, y + 54.4209);
ctx.lineTo(x + 68.1894, y + 54.4209);
ctx.lineTo(x + 72.969, y + 54.6223);
ctx.lineTo(x + 67.5522, y + 54.864);
ctx.lineTo(x + 67.5522, y + 55.3876);
ctx.bezierCurveTo(x + 67.5522, y + 55.3876, x + 91.3703, y + 54.8237, x + 93.8398, y + 54.7028);
ctx.lineTo(x + 81.7714, y + 54.2195);
ctx.lineTo(x + 94.2779, y + 54.0181);
ctx.lineTo(x + 94.8754, y + 53.6555);
ctx.bezierCurveTo(x + 94.8754, y + 53.6555, x + 94.3576, y + 55.9113, x + 94.5965, y + 57.1198);
ctx.bezierCurveTo(x + 96.1101, y + 56.2738, x + 98.3007, y + 56.6767, x + 98.9778, y + 57.4017);
ctx.lineTo(x + 100.85, y + 68.3987);
ctx.lineTo(x + 101.168, y + 72.3463);
ctx.lineTo(x + 101.607, y + 72.5478);
ctx.bezierCurveTo(x + 101.607, y + 72.5478, x + 101.686, y + 73.2326, x + 101.846, y + 73.434);
ctx.bezierCurveTo(x + 102.005, y + 73.6354, x + 104.713, y + 75.5689, x + 104.952, y + 79.3151);
ctx.bezierCurveTo(x + 103.001, y + 77.9456, x + 102.085, y + 75.6495, x + 101.646, y + 74.0785);
ctx.bezierCurveTo(x + 101.607, y + 76.1329, x + 103.359, y + 80.443, x + 106.306, y + 83.7864);
ctx.bezierCurveTo(x + 104.156, y + 82.9002, x + 102.085, y + 79.5568, x + 101.288, y + 76.4954);
ctx.bezierCurveTo(x + 101.328, y + 79.3151, x + 102.085, y + 82.2557, x + 102.682, y + 83.1016);
ctx.bezierCurveTo(x + 101.527, y + 82.4974, x + 100.77, y + 80.0805, x + 100.77, y + 80.0805);
ctx.bezierCurveTo(x + 100.77, y + 80.0805, x + 100.89, y + 83.6656, x + 101.487, y + 84.5921);
ctx.bezierCurveTo(x + 96.6677, y + 85.3172, x + 79.4214, y + 85.9214, x + 79.4214, y + 85.9214);
ctx.lineTo(x + 81.1739, y + 86.8076);
ctx.bezierCurveTo(x + 81.1739, y + 86.8076, x + 78.9833, y + 86.4853, x + 77.3104, y + 85.8005);
ctx.bezierCurveTo(x + 75.6376, y + 85.1157, x + 74.0444, y + 84.7532, x + 74.0444, y + 84.7532);
ctx.lineTo(x + 76.7528, y + 86.0825);
ctx.lineTo(x + 72.2521, y + 86.0422);
ctx.lineTo(x + 74.1639, y + 87.6132);
ctx.bezierCurveTo(x + 74.1639, y + 87.6132, x + 71.8538, y + 86.3242, x + 70.6987, y + 85.438);
ctx.bezierCurveTo(x + 69.5436, y + 84.5518, x + 67.5522, y + 83.585, x + 67.5522, y + 83.585);
ctx.lineTo(x + 70.8182, y + 86.0422);
ctx.bezierCurveTo(x + 70.8182, y + 86.0422, x + 60.8608, y + 85.72, x + 58.2718, y + 85.6797);
ctx.bezierCurveTo(x + 58.2718, y + 85.6797, x + 59.7455, y + 82.1752, x + 60.2633, y + 79.3151);
ctx.bezierCurveTo(x + 58.5108, y + 83.2628, x + 57.3956, y + 85.5588, x + 54.966, y + 87.4924);
ctx.bezierCurveTo(x + 56.2803, y + 85.6797, x + 57.993, y + 82.6585, x + 57.993, y + 82.6585);
ctx.bezierCurveTo(x + 57.993, y + 82.6585, x + 55.2448, y + 86.2839, x + 53.6914, y + 86.8076);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 91.4893, y + 78.7915);
ctx.lineTo(x + 92.6842, y + 78.7915);
ctx.lineTo(x + 93.2816, y + 78.3887);
ctx.lineTo(x + 92.0469, y + 78.3887);
ctx.lineTo(x + 91.4893, y + 78.7915);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 70.9375, y + 78.8318);
ctx.lineTo(x + 71.4553, y + 80.1208);
ctx.bezierCurveTo(x + 71.4553, y + 80.1208, x + 73.6459, y + 81.1681, x + 75.3586, y + 81.4904);
ctx.bezierCurveTo(x + 73.9247, y + 80.7653, x + 73.1281, y + 79.8791, x + 73.1281, y + 79.8791);
ctx.lineTo(x + 70.9375, y + 78.8318);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 64.5244, y + 71.9436);
ctx.bezierCurveTo(x + 64.6837, y + 73.998, x + 66.1176, y + 75.9718, x + 68.2286, y + 78.0262);
ctx.lineTo(x + 67.2328, y + 76.2538);
ctx.lineTo(x + 65.2413, y + 73.5146);
ctx.lineTo(x + 64.5244, y + 71.9436);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 95.5524, y + 89.4663);
ctx.lineTo(x + 94.3973, y + 91.8027);
ctx.lineTo(x + 95.0744, y + 89.4663);
ctx.lineTo(x + 93.4812, y + 89.5066);
ctx.lineTo(x + 91.0516, y + 91.0776);
ctx.lineTo(x + 92.605, y + 89.5066);
ctx.lineTo(x + 86.9093, y + 89.6274);
ctx.bezierCurveTo(x + 86.6305, y + 89.8288, x + 86.3517, y + 89.99, x + 86.0729, y + 90.1511);
ctx.lineTo(x + 85.0772, y + 90.715);
ctx.bezierCurveTo(x + 84.4001, y + 91.1179, x + 83.7628, y + 91.4804, x + 83.0857, y + 91.8429);
ctx.bezierCurveTo(x + 83.723, y + 91.3998, x + 84.3204, y + 90.9567, x + 84.9577, y + 90.5136);
ctx.lineTo(x + 85.9136, y + 89.8288);
ctx.bezierCurveTo(x + 86.0331, y + 89.7483, x + 86.1127, y + 89.6677, x + 86.2322, y + 89.6274);
ctx.lineTo(x + 55.0057, y + 90.2719);
ctx.lineTo(x + 54.5676, y + 90.6345);
ctx.lineTo(x + 79.9391, y + 90.4331);
ctx.lineTo(x + 54.7667, y + 91.3193);
ctx.lineTo(x + 54.7667, y + 91.0776);
ctx.bezierCurveTo(x + 54.0498, y + 91.2387, x + 53.4524, y + 91.4401, x + 52.5761, y + 92.0041);
ctx.lineTo(x + 53.8507, y + 90.2719);
ctx.bezierCurveTo(x + 53.8507, y + 90.2719, x + 52.4168, y + 90.8762, x + 51.8193, y + 91.7624);
ctx.lineTo(x + 51.9388, y + 92.286);
ctx.lineTo(x + 51.8193, y + 92.3263);
ctx.lineTo(x + 52.0981, y + 109.527);
ctx.lineTo(x + 62.8123, y + 109.325);
ctx.lineTo(x + 62.7725, y + 106.143);
ctx.lineTo(x + 99.854, y + 105.499);
ctx.lineTo(x + 100.69, y + 108.641);
ctx.lineTo(x + 112.002, y + 108.439);
ctx.lineTo(x + 111.683, y + 89.144);
ctx.lineTo(x + 95.5524, y + 89.4663);
ctx.closePath();
ctx.moveTo(x + 58.6302, y + 94.9446);
ctx.lineTo(x + 57.515, y + 94.9446);
ctx.lineTo(x + 57.4752, y + 91.5207);
ctx.lineTo(x + 59.9844, y + 91.4804);
ctx.bezierCurveTo(x + 59.3073, y + 92.1652, x + 58.6302, y + 94.9446, x + 58.6302, y + 94.9446);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 38.0771, y + 54.9849);
ctx.lineTo(x + 33.6162, y + 56.1128);
ctx.lineTo(x + 33.9349, y + 58.57);
ctx.lineTo(x + 37.2009, y + 58.0463);
ctx.lineTo(x + 38.0771, y + 54.9849);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 33.6962, y + 58.8922);
ctx.lineTo(x + 33.2979, y + 55.8711);
ctx.lineTo(x + 38.4757, y + 54.582);
ctx.lineTo(x + 37.4003, y + 58.288);
ctx.lineTo(x + 33.6962, y + 58.8922);
ctx.closePath();
ctx.moveTo(x + 33.9351, y + 56.3142);
ctx.lineTo(x + 34.1741, y + 58.2477);
ctx.lineTo(x + 36.9622, y + 57.8046);
ctx.lineTo(x + 37.6393, y + 55.3877);
ctx.lineTo(x + 33.9351, y + 56.3142);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 33.8552, y + 56.0322);
ctx.lineTo(x + 34.2933, y + 57.5226);
ctx.bezierCurveTo(x + 34.2933, y + 57.5226, x + 35.8467, y + 57.1198, x + 37.0017, y + 56.9587);
ctx.lineTo(x + 37.5992, y + 55.1057);
ctx.lineTo(x + 38.0771, y + 54.9849);
ctx.lineTo(x + 37.2009, y + 58.0463);
ctx.lineTo(x + 33.9349, y + 58.57);
ctx.lineTo(x + 33.6162, y + 56.1128);
ctx.lineTo(x + 33.8552, y + 56.0322);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 98.7782, y + 68.157);
ctx.bezierCurveTo(x + 98.8977, y + 75.2063, x + 91.2105, y + 81.0875, x + 81.5717, y + 81.2486);
ctx.bezierCurveTo(x + 71.9329, y + 81.4098, x + 64.0466, y + 75.8106, x + 63.9272, y + 68.7612);
ctx.bezierCurveTo(x + 63.8077, y + 61.7119, x + 71.4948, y + 55.8307, x + 81.1336, y + 55.6696);
ctx.bezierCurveTo(x + 87.1479, y + 55.5487, x + 92.4851, y + 57.724, x + 95.6715, y + 61.0674);
ctx.bezierCurveTo(x + 97.1452, y + 62.5981, x + 98.1409, y + 64.3705, x + 98.5392, y + 66.3443);
ctx.bezierCurveTo(x + 98.6985, y + 66.9485, x + 98.7782, y + 67.5528, x + 98.7782, y + 68.157);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 81.5722, y + 81.5306);
ctx.bezierCurveTo(x + 71.8139, y + 81.6917, x + 63.7683, y + 75.9717, x + 63.6488, y + 68.7612);
ctx.bezierCurveTo(x + 63.5293, y + 61.5507, x + 71.3758, y + 55.5487, x + 81.1341, y + 55.3876);
ctx.bezierCurveTo(x + 86.989, y + 55.307, x + 92.5254, y + 57.3211, x + 95.8711, y + 60.8659);
ctx.bezierCurveTo(x + 97.4244, y + 62.4772, x + 98.4202, y + 64.3302, x + 98.8185, y + 66.2637);
ctx.bezierCurveTo(x + 98.938, y + 66.8679, x + 99.0176, y + 67.5125, x + 99.0176, y + 68.157);
ctx.bezierCurveTo(x + 99.1769, y + 75.3674, x + 91.3305, y + 81.3695, x + 81.5722, y + 81.5306);
ctx.closePath();
ctx.moveTo(x + 81.1341, y + 55.9918);
ctx.bezierCurveTo(x + 71.6944, y + 56.1529, x + 64.0869, y + 61.873, x + 64.2064, y + 68.7612);
ctx.bezierCurveTo(x + 64.3259, y + 75.6494, x + 72.0927, y + 81.1278, x + 81.5722, y + 80.9666);
ctx.bezierCurveTo(x + 91.0118, y + 80.8055, x + 98.6193, y + 75.0855, x + 98.4998, y + 68.1973);
ctx.bezierCurveTo(x + 98.4998, y + 67.593, x + 98.4202, y + 66.9888, x + 98.3007, y + 66.4248);
ctx.bezierCurveTo(x + 97.9024, y + 64.5719, x + 96.9465, y + 62.8397, x + 95.4728, y + 61.309);
ctx.bezierCurveTo(x + 92.2067, y + 57.8448, x + 86.8695, y + 55.871, x + 81.1341, y + 55.9918);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 81.2534, y + 62.2355);
ctx.bezierCurveTo(x + 76.3145, y + 62.316, x + 72.3316, y + 65.0149, x + 72.3714, y + 68.2375);
ctx.bezierCurveTo(x + 72.4112, y + 71.4601, x + 76.5137, y + 74.0381, x + 81.4526, y + 73.9173);
ctx.bezierCurveTo(x + 86.3915, y + 73.8367, x + 90.3744, y + 71.1378, x + 90.3346, y + 67.9152);
ctx.bezierCurveTo(x + 90.2549, y + 64.733, x + 86.1923, y + 62.1549, x + 81.2534, y + 62.2355);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 85.0371, y + 79.5164);
ctx.bezierCurveTo(x + 85.5947, y + 79.7178, x + 86.232, y + 79.7581, x + 86.8693, y + 79.5567);
ctx.bezierCurveTo(x + 87.387, y + 79.3955, x + 87.8252, y + 79.0733, x + 88.1438, y + 78.6705);
ctx.bezierCurveTo(x + 88.3031, y + 78.4691, x + 88.4226, y + 78.2677, x + 88.5023, y + 78.026);
ctx.bezierCurveTo(x + 88.6616, y + 77.5829, x + 88.7014, y + 77.0995, x + 88.5421, y + 76.6564);
ctx.bezierCurveTo(x + 88.5421, y + 76.6161, x + 88.5421, y + 76.6161, x + 88.5421, y + 76.6161);
ctx.bezierCurveTo(x + 88.1836, y + 75.5285, x + 86.9489, y + 74.9242, x + 85.7142, y + 75.1659);
ctx.bezierCurveTo(x + 85.6345, y + 75.1659, x + 85.5151, y + 75.2062, x + 85.4354, y + 75.2465);
ctx.bezierCurveTo(x + 84.121, y + 75.6896, x + 83.3642, y + 76.9786, x + 83.7625, y + 78.1871);
ctx.bezierCurveTo(x + 83.9617, y + 78.751, x + 84.3998, y + 79.2344, x + 84.9973, y + 79.4761);
ctx.lineTo(x + 85.0371, y + 79.5164);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 78.147, y + 80.3625);
ctx.bezierCurveTo(x + 78.7445, y + 80.6042, x + 79.3817, y + 80.6042, x + 80.019, y + 80.4028);
ctx.bezierCurveTo(x + 80.5368, y + 80.2417, x + 81.0147, y + 79.9194, x + 81.3334, y + 79.4763);
ctx.bezierCurveTo(x + 81.4927, y + 79.2749, x + 81.6122, y + 79.0332, x + 81.6918, y + 78.8318);
ctx.bezierCurveTo(x + 81.8512, y + 78.3484, x + 81.891, y + 77.865, x + 81.7317, y + 77.4219);
ctx.bezierCurveTo(x + 81.7317, y + 77.3816, x + 81.7317, y + 77.3816, x + 81.7317, y + 77.3816);
ctx.bezierCurveTo(x + 81.3334, y + 76.2537, x + 80.0987, y + 75.6092, x + 78.8241, y + 75.8912);
ctx.bezierCurveTo(x + 78.7445, y + 75.8912, x + 78.625, y + 75.9315, x + 78.5453, y + 75.9718);
ctx.bezierCurveTo(x + 77.1911, y + 76.4149, x + 76.4343, y + 77.7845, x + 76.8326, y + 78.9929);
ctx.bezierCurveTo(x + 77.0318, y + 79.5972, x + 77.5097, y + 80.0805, x + 78.1072, y + 80.3222);
ctx.lineTo(x + 78.147, y + 80.3625);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 70.9773, y + 77.3009);
ctx.bezierCurveTo(x + 71.3358, y + 77.8246, x + 71.8536, y + 78.1871, x + 72.4908, y + 78.3885);
ctx.bezierCurveTo(x + 73.0086, y + 78.5496, x + 73.5662, y + 78.5496, x + 74.084, y + 78.3885);
ctx.bezierCurveTo(x + 74.323, y + 78.308, x + 74.562, y + 78.1871, x + 74.7611, y + 78.0663);
ctx.bezierCurveTo(x + 75.1594, y + 77.7843, x + 75.4382, y + 77.3815, x + 75.5577, y + 76.9384);
ctx.bezierCurveTo(x + 75.5577, y + 76.8981, x + 75.5577, y + 76.8981, x + 75.5577, y + 76.8981);
ctx.bezierCurveTo(x + 75.8764, y + 75.7299, x + 75.1594, y + 74.4812, x + 73.9645, y + 73.9978);
ctx.bezierCurveTo(x + 73.8849, y + 73.9575, x + 73.7654, y + 73.9172, x + 73.6857, y + 73.8769);
ctx.bezierCurveTo(x + 72.2917, y + 73.4741, x + 70.9375, y + 74.1589, x + 70.579, y + 75.4077);
ctx.bezierCurveTo(x + 70.4197, y + 76.0119, x + 70.5392, y + 76.6564, x + 70.8976, y + 77.2606);
ctx.lineTo(x + 70.9773, y + 77.3009);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 68.6678, y + 73.5548);
ctx.bezierCurveTo(x + 69.2652, y + 73.7159, x + 69.8627, y + 73.6353, x + 70.4203, y + 73.3534);
ctx.bezierCurveTo(x + 70.8983, y + 73.1117, x + 71.2567, y + 72.7491, x + 71.4957, y + 72.306);
ctx.bezierCurveTo(x + 71.6152, y + 72.1046, x + 71.6949, y + 71.8629, x + 71.7347, y + 71.6212);
ctx.bezierCurveTo(x + 71.8144, y + 71.1379, x + 71.7745, y + 70.6545, x + 71.5355, y + 70.2114);
ctx.bezierCurveTo(x + 71.5355, y + 70.1711, x + 71.5355, y + 70.1711, x + 71.4957, y + 70.1711);
ctx.bezierCurveTo(x + 70.9381, y + 69.1238, x + 69.6635, y + 68.6404, x + 68.5085, y + 69.0835);
ctx.bezierCurveTo(x + 68.4288, y + 69.1238, x + 68.3492, y + 69.164, x + 68.2297, y + 69.2043);
ctx.bezierCurveTo(x + 67.0348, y + 69.8085, x + 66.517, y + 71.2587, x + 67.1144, y + 72.4269);
ctx.bezierCurveTo(x + 67.3933, y + 72.9908, x + 67.911, y + 73.3936, x + 68.5483, y + 73.5951);
ctx.lineTo(x + 68.6678, y + 73.5548);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 68.6677, y + 67.3915);
ctx.bezierCurveTo(x + 69.2651, y + 67.311, x + 69.8227, y + 67.0693, x + 70.3405, y + 66.6262);
ctx.bezierCurveTo(x + 70.7388, y + 66.2636, x + 71.0575, y + 65.8205, x + 71.2168, y + 65.3774);
ctx.bezierCurveTo(x + 71.2964, y + 65.1357, x + 71.3363, y + 64.9343, x + 71.3363, y + 64.6926);
ctx.bezierCurveTo(x + 71.3363, y + 64.2495, x + 71.2168, y + 63.8467, x + 70.938, y + 63.5647);
ctx.lineTo(x + 70.8981, y + 63.5245);
ctx.bezierCurveTo(x + 70.221, y + 62.7994, x + 68.9067, y + 62.7994, x + 67.8711, y + 63.5647);
ctx.bezierCurveTo(x + 67.7914, y + 63.605, x + 67.7118, y + 63.6856, x + 67.6321, y + 63.7662);
ctx.bezierCurveTo(x + 66.5567, y + 64.6926, x + 66.2779, y + 66.1025, x + 67.0347, y + 66.8679);
ctx.bezierCurveTo(x + 67.3931, y + 67.2707, x + 67.9507, y + 67.4318, x + 68.588, y + 67.3915);
ctx.lineTo(x + 68.6677, y + 67.3915);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 72.8093, y + 62.7995);
ctx.bezierCurveTo(x + 73.4067, y + 62.8398, x + 74.044, y + 62.6787, x + 74.6813, y + 62.3967);
ctx.bezierCurveTo(x + 75.1991, y + 62.155, x + 75.6372, y + 61.7925, x + 75.916, y + 61.3896);
ctx.bezierCurveTo(x + 76.0753, y + 61.1882, x + 76.155, y + 60.9868, x + 76.2346, y + 60.7854);
ctx.bezierCurveTo(x + 76.3541, y + 60.3826, x + 76.3541, y + 59.9798, x + 76.155, y + 59.6575);
ctx.lineTo(x + 76.155, y + 59.6172);
ctx.bezierCurveTo(x + 75.677, y + 58.8116, x + 74.3626, y + 58.6102, x + 73.1279, y + 59.1339);
ctx.bezierCurveTo(x + 73.0483, y + 59.1741, x + 72.9288, y + 59.2144, x + 72.8491, y + 59.2547);
ctx.bezierCurveTo(x + 71.5347, y + 59.9395, x + 70.8974, y + 61.1882, x + 71.4152, y + 62.0342);
ctx.bezierCurveTo(x + 71.6542, y + 62.4773, x + 72.172, y + 62.7189, x + 72.8093, y + 62.7995);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 78.5853, y + 60.6645);
ctx.bezierCurveTo(x + 79.1429, y + 60.9062, x + 79.7802, y + 61.0271, x + 80.4573, y + 60.9465);
ctx.bezierCurveTo(x + 81.0149, y + 60.8659, x + 81.5327, y + 60.7048, x + 81.9708, y + 60.4228);
ctx.bezierCurveTo(x + 82.17, y + 60.302, x + 82.3293, y + 60.1409, x + 82.4886, y + 59.9797);
ctx.bezierCurveTo(x + 82.7674, y + 59.6575, x + 82.8471, y + 59.2949, x + 82.8072, y + 58.8921);
ctx.lineTo(x + 82.8072, y + 58.8518);
ctx.bezierCurveTo(x + 82.6479, y + 57.9254, x + 81.4929, y + 57.2808, x + 80.1386, y + 57.3211);
ctx.bezierCurveTo(x + 80.0192, y + 57.3211, x + 79.9395, y + 57.3211, x + 79.82, y + 57.3614);
ctx.bezierCurveTo(x + 78.3463, y + 57.5225, x + 77.3107, y + 58.449, x + 77.5099, y + 59.4561);
ctx.bezierCurveTo(x + 77.5895, y + 59.9395, x + 77.948, y + 60.3826, x + 78.5455, y + 60.6645);
ctx.lineTo(x + 78.5853, y + 60.6645);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 84.9178, y + 61.2284);
ctx.bezierCurveTo(x + 85.3559, y + 61.6313, x + 85.9534, y + 61.9535, x + 86.5907, y + 62.1147);
ctx.bezierCurveTo(x + 87.1483, y + 62.2355, x + 87.7059, y + 62.2355, x + 88.1838, y + 62.1147);
ctx.bezierCurveTo(x + 88.4228, y + 62.0744, x + 88.622, y + 61.9535, x + 88.8211, y + 61.873);
ctx.bezierCurveTo(x + 89.1796, y + 61.6313, x + 89.4186, y + 61.3493, x + 89.4584, y + 60.9465);
ctx.lineTo(x + 89.4584, y + 60.9062);
ctx.bezierCurveTo(x + 89.5779, y + 59.9797, x + 88.7415, y + 58.9727, x + 87.4271, y + 58.5698);
ctx.bezierCurveTo(x + 87.3474, y + 58.5296, x + 87.2279, y + 58.4893, x + 87.1084, y + 58.4893);
ctx.bezierCurveTo(x + 85.6746, y + 58.167, x + 84.4, y + 58.6907, x + 84.2407, y + 59.6977);
ctx.bezierCurveTo(x + 84.161, y + 60.1811, x + 84.3602, y + 60.7048, x + 84.8381, y + 61.1882);
ctx.lineTo(x + 84.9178, y + 61.2284);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 92.1665, y + 69.2043);
ctx.bezierCurveTo(x + 92.0868, y + 69.2849, x + 90.7725, y + 70.6545, x + 90.7725, y + 70.6545);
ctx.lineTo(x + 94.2775, y + 71.7421);
ctx.bezierCurveTo(x + 94.2775, y + 71.7421, x + 95.2334, y + 74.2799, x + 98.141, y + 75.3675);
ctx.bezierCurveTo(x + 98.141, y + 75.3675, x + 98.4198, y + 72.2658, x + 98.4994, y + 70.7753);
ctx.bezierCurveTo(x + 98.5791, y + 69.2849, x + 92.1665, y + 69.2043, x + 92.1665, y + 69.2043);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 83.2051, y + 67.5527);
ctx.bezierCurveTo(x + 83.2051, y + 67.9152, x + 83.006, y + 68.1972, x + 82.6874, y + 68.4389);
ctx.bezierCurveTo(x + 82.3687, y + 68.6806, x + 81.8908, y + 68.8417, x + 81.373, y + 68.8417);
ctx.bezierCurveTo(x + 81.2933, y + 68.8417, x + 81.2137, y + 68.8417, x + 81.134, y + 68.8417);
ctx.bezierCurveTo(x + 80.2577, y + 68.7612, x + 79.5806, y + 68.2778, x + 79.501, y + 67.6735);
ctx.bezierCurveTo(x + 79.501, y + 67.6333, x + 79.501, y + 67.593, x + 79.501, y + 67.593);
ctx.bezierCurveTo(x + 79.501, y + 66.9082, x + 80.2976, y + 66.304, x + 81.3331, y + 66.304);
ctx.bezierCurveTo(x + 82.0899, y + 66.304, x + 83.1653, y + 66.8276, x + 83.2051, y + 67.5527);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 81.3735, y + 69.1237);
ctx.bezierCurveTo(x + 81.2938, y + 69.1237, x + 81.1743, y + 69.1237, x + 81.0947, y + 69.1237);
ctx.bezierCurveTo(x + 80.0591, y + 69.0431, x + 79.2625, y + 68.4389, x + 79.2227, y + 67.7138);
ctx.bezierCurveTo(x + 79.2227, y + 67.6735, x + 79.2227, y + 67.6333, x + 79.2227, y + 67.6333);
ctx.bezierCurveTo(x + 79.2227, y + 66.7471, x + 80.1387, y + 66.0623, x + 81.3336, y + 66.0623);
ctx.bezierCurveTo(x + 82.2099, y + 66.0623, x + 83.4844, y + 66.6262, x + 83.4844, y + 67.593);
ctx.bezierCurveTo(x + 83.4844, y + 68.0361, x + 83.2853, y + 68.4389, x + 82.8472, y + 68.7209);
ctx.bezierCurveTo(x + 82.4489, y + 68.9626, x + 81.9311, y + 69.1237, x + 81.3735, y + 69.1237);
ctx.closePath();
ctx.moveTo(x + 81.3336, y + 66.6262);
ctx.bezierCurveTo(x + 80.4972, y + 66.6262, x + 79.7803, y + 67.1096, x + 79.7803, y + 67.6333);
ctx.lineTo(x + 79.7803, y + 67.6735);
ctx.bezierCurveTo(x + 79.8201, y + 68.1166, x + 80.4176, y + 68.5195, x + 81.1345, y + 68.5597);
ctx.bezierCurveTo(x + 81.6523, y + 68.6, x + 82.1701, y + 68.4792, x + 82.4887, y + 68.2375);
ctx.bezierCurveTo(x + 82.7675, y + 68.0361, x + 82.887, y + 67.8347, x + 82.887, y + 67.593);
ctx.bezierCurveTo(x + 82.887, y + 67.0693, x + 82.0107, y + 66.5859, x + 81.3336, y + 66.6262);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 81.4526, y + 74.5216);
ctx.bezierCurveTo(x + 76.195, y + 74.6021, x + 71.8536, y + 71.8227, x + 71.8138, y + 68.2779);
ctx.bezierCurveTo(x + 71.7739, y + 64.7331, x + 75.9959, y + 61.7925, x + 81.2534, y + 61.7119);
ctx.bezierCurveTo(x + 86.5109, y + 61.6313, x + 90.8524, y + 64.4108, x + 90.8922, y + 67.9556);
ctx.bezierCurveTo(x + 90.932, y + 71.4602, x + 86.7101, y + 74.441, x + 81.4526, y + 74.5216);
ctx.closePath();
ctx.moveTo(x + 81.2534, y + 62.2356);
ctx.bezierCurveTo(x + 76.3145, y + 62.3161, x + 72.3315, y + 65.015, x + 72.3714, y + 68.2376);
ctx.bezierCurveTo(x + 72.4112, y + 71.4602, x + 76.5137, y + 74.0382, x + 81.4526, y + 73.9174);
ctx.bezierCurveTo(x + 86.3914, y + 73.8368, x + 90.3744, y + 71.1379, x + 90.3346, y + 67.9153);
ctx.bezierCurveTo(x + 90.2549, y + 64.7331, x + 86.1923, y + 62.155, x + 81.2534, y + 62.2356);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 87.6261, y + 72.5477);
ctx.bezierCurveTo(x + 85.1964, y + 70.6948, x + 82.4084, y + 67.1902, x + 84.6388, y + 65.015);
ctx.bezierCurveTo(x + 86.471, y + 63.2426, x + 91.2506, y + 66.4652, x + 89.976, y + 70.292);
ctx.bezierCurveTo(x + 89.9362, y + 70.3322, x + 89.1794, y + 71.7824, x + 87.6261, y + 72.5477);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 86.6704, y + 73.0713);
ctx.bezierCurveTo(x + 86.0729, y + 71.5809, x + 81.5324, y + 69.7682, x + 81.1341, y + 72.3059);
ctx.bezierCurveTo(x + 80.9747, y + 73.2727, x + 83.2052, y + 74.0784, x + 84.7586, y + 73.7964);
ctx.bezierCurveTo(x + 86.2721, y + 73.4741, x + 86.6704, y + 73.0713, x + 86.6704, y + 73.0713);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 72.2122, y + 69.1238);
ctx.bezierCurveTo(x + 72.2122, y + 69.1238, x + 77.1511, y + 69.4864, x + 78.8638, y + 66.9889);
ctx.bezierCurveTo(x + 79.74, y + 65.6999, x + 78.6646, y + 63.9677, x + 77.4299, y + 62.5579);
ctx.bezierCurveTo(x + 77.4299, y + 62.5579, x + 74.5622, y + 63.1621, x + 72.9292, y + 65.6193);
ctx.bezierCurveTo(x + 71.6944, y + 67.5125, x + 72.2122, y + 69.1238, x + 72.2122, y + 69.1238);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 78.3066, y + 62.3162);
ctx.bezierCurveTo(x + 79.0634, y + 62.6787, x + 80.7761, y + 64.9345, x + 80.7761, y + 64.9345);
ctx.bezierCurveTo(x + 80.7761, y + 64.9345, x + 80.5769, y + 62.9204, x + 79.7007, y + 62.0745);
ctx.bezierCurveTo(x + 79.7007, y + 62.0745, x + 78.8643, y + 62.1147, x + 78.3066, y + 62.3162);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 81.134, y + 68.8417);
ctx.bezierCurveTo(x + 80.2577, y + 68.7611, x + 79.5806, y + 68.2777, x + 79.501, y + 67.6735);
ctx.bezierCurveTo(x + 79.501, y + 67.6332, x + 79.501, y + 67.5929, x + 79.501, y + 67.5929);
ctx.bezierCurveTo(x + 80.2577, y + 67.5124, x + 81.0543, y + 67.9958, x + 81.134, y + 68.8417);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 83.1651, y + 67.5125);
ctx.bezierCurveTo(x + 83.1651, y + 67.875, x + 82.966, y + 68.157, x + 82.6473, y + 68.3987);
ctx.bezierCurveTo(x + 81.6118, y + 68.157, x + 81.2135, y + 67.5528, x + 81.3728, y + 67.0694);
ctx.bezierCurveTo(x + 81.5321, y + 66.586, x + 82.4482, y + 66.5054, x + 83.0058, y + 66.9888);
ctx.bezierCurveTo(x + 83.0855, y + 67.1902, x + 83.1651, y + 67.3514, x + 83.1651, y + 67.5125);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 74.9209, y + 71.0572);
ctx.bezierCurveTo(x + 75.1599, y + 70.9364, x + 75.4785, y + 70.8558, x + 75.7573, y + 70.8558);
ctx.bezierCurveTo(x + 76.0361, y + 70.8155, x + 76.3149, y + 70.8558, x + 76.5937, y + 70.8558);
ctx.bezierCurveTo(x + 76.8726, y + 70.8961, x + 77.1514, y + 70.9364, x + 77.4302, y + 71.0169);
ctx.bezierCurveTo(x + 77.709, y + 71.0975, x + 77.9878, y + 71.2183, x + 78.1869, y + 71.3795);
ctx.bezierCurveTo(x + 77.948, y + 71.2586, x + 77.6692, y + 71.2183, x + 77.3903, y + 71.1378);
ctx.bezierCurveTo(x + 77.1115, y + 71.0975, x + 76.8327, y + 71.0572, x + 76.5937, y + 71.0169);
ctx.bezierCurveTo(x + 76.3149, y + 70.9766, x + 76.0361, y + 70.9766, x + 75.7573, y + 70.9766);
ctx.bezierCurveTo(x + 75.4785, y + 70.9766, x + 75.1997, y + 70.9766, x + 74.9209, y + 71.0572);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.7609, y + 72.0642);
ctx.bezierCurveTo(x + 74.6812, y + 72.0642, x + 74.6016, y + 72.0642, x + 74.5617, y + 72.0642);
ctx.bezierCurveTo(x + 74.2829, y + 72.0642, x + 74.0041, y + 72.1448, x + 73.7253, y + 72.1851);
ctx.bezierCurveTo(x + 73.4465, y + 72.2656, x + 73.1677, y + 72.3462, x + 72.9287, y + 72.5476);
ctx.bezierCurveTo(x + 73.2075, y + 72.5073, x + 73.4863, y + 72.5073, x + 73.7651, y + 72.467);
ctx.bezierCurveTo(x + 74.0439, y + 72.467, x + 74.3228, y + 72.4267, x + 74.6016, y + 72.4267);
ctx.bezierCurveTo(x + 74.8007, y + 72.4267, x + 75.0397, y + 72.3865, x + 75.2388, y + 72.3865);
ctx.bezierCurveTo(x + 75.0795, y + 72.3059, x + 74.9202, y + 72.1851, x + 74.7609, y + 72.0642);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 72.5312, y + 72.2657);
ctx.bezierCurveTo(x + 72.7702, y + 72.0643, x + 73.049, y + 71.9837, x + 73.3278, y + 71.9032);
ctx.bezierCurveTo(x + 73.6067, y + 71.8226, x + 73.8855, y + 71.7823, x + 74.1643, y + 71.7823);
ctx.bezierCurveTo(x + 74.4431, y + 71.742, x + 74.7219, y + 71.7823, x + 75.0007, y + 71.7823);
ctx.bezierCurveTo(x + 75.2795, y + 71.8226, x + 75.5583, y + 71.8629, x + 75.8371, y + 71.9434);
ctx.bezierCurveTo(x + 75.5583, y + 72.024, x + 75.2795, y + 72.0643, x + 75.0007, y + 72.1046);
ctx.bezierCurveTo(x + 74.7219, y + 72.1448, x + 74.4431, y + 72.1448, x + 74.1643, y + 72.1851);
ctx.bezierCurveTo(x + 73.8855, y + 72.2254, x + 73.6067, y + 72.2254, x + 73.3278, y + 72.2254);
ctx.bezierCurveTo(x + 73.0889, y + 72.2254, x + 72.8101, y + 72.2657, x + 72.5312, y + 72.2657);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 98.5791, y + 66.3443);
ctx.bezierCurveTo(x + 91.6487, y + 64.9344, x + 90.5335, y + 61.0271, x + 91.0114, y + 60.3423);
ctx.bezierCurveTo(x + 91.5292, y + 59.5367, x + 93.441, y + 60.02, x + 95.6715, y + 61.0674);
ctx.bezierCurveTo(x + 97.1452, y + 62.6384, x + 98.1409, y + 64.4108, x + 98.5791, y + 66.3443);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 80.0585, y + 61.1479);
ctx.bezierCurveTo(x + 79.4212, y + 61.1479, x + 78.8636, y + 61.027, x + 78.3458, y + 60.7853);
ctx.bezierCurveTo(x + 78.1069, y + 60.6645, x + 77.8679, y + 60.5034, x + 77.6687, y + 60.3422);
ctx.bezierCurveTo(x + 77.2704, y + 59.9797, x + 77.0713, y + 59.5366, x + 77.0713, y + 59.0935);
ctx.bezierCurveTo(x + 77.0713, y + 57.9253, x + 78.3458, y + 56.9585, x + 79.9789, y + 56.9183);
ctx.bezierCurveTo(x + 81.6119, y + 56.878, x + 82.9661, y + 57.8045, x + 82.9661, y + 58.9726);
ctx.bezierCurveTo(x + 82.9661, y + 59.0532, x + 82.9661, y + 59.1338, x + 82.9661, y + 59.2143);
ctx.lineTo(x + 82.9661, y + 59.2546);
ctx.bezierCurveTo(x + 82.7669, y + 60.3422, x + 81.5322, y + 61.1479, x + 80.0585, y + 61.1479);
ctx.closePath();
ctx.moveTo(x + 79.9789, y + 57.3211);
ctx.bezierCurveTo(x + 78.545, y + 57.3614, x + 77.4298, y + 58.1267, x + 77.4298, y + 59.0935);
ctx.bezierCurveTo(x + 77.4298, y + 59.456, x + 77.5891, y + 59.7783, x + 77.9077, y + 60.1005);
ctx.bezierCurveTo(x + 78.067, y + 60.2617, x + 78.2662, y + 60.3825, x + 78.4653, y + 60.4631);
ctx.bezierCurveTo(x + 78.9035, y + 60.6645, x + 79.4611, y + 60.7853, x + 80.0187, y + 60.7853);
ctx.bezierCurveTo(x + 81.3331, y + 60.745, x + 82.4085, y + 60.1005, x + 82.5678, y + 59.2143);
ctx.lineTo(x + 82.5678, y + 59.174);
ctx.bezierCurveTo(x + 82.5678, y + 59.1338, x + 82.5678, y + 59.0532, x + 82.5678, y + 58.9726);
ctx.bezierCurveTo(x + 82.5678, y + 58.0462, x + 81.4127, y + 57.2808, x + 79.9789, y + 57.3211);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 82.7668, y + 59.013);
ctx.bezierCurveTo(x + 82.7668, y + 59.0936, x + 82.7668, y + 59.1742, x + 82.7668, y + 59.2547);
ctx.bezierCurveTo(x + 82.0897, y + 58.3282, x + 80.5363, y + 57.9254, x + 79.222, y + 58.3282);
ctx.bezierCurveTo(x + 78.0271, y + 58.7311, x + 77.6686, y + 59.5367, x + 77.7881, y + 60.2215);
ctx.bezierCurveTo(x + 77.4296, y + 59.8992, x + 77.2305, y + 59.5367, x + 77.2305, y + 59.0936);
ctx.bezierCurveTo(x + 77.2305, y + 58.0463, x + 78.4254, y + 57.1601, x + 79.9787, y + 57.1198);
ctx.bezierCurveTo(x + 81.4923, y + 57.0795, x + 82.7668, y + 57.9254, x + 82.7668, y + 59.013);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 73.0885, y + 62.9606);
ctx.bezierCurveTo(x + 72.8893, y + 62.9606, x + 72.73, y + 62.9606, x + 72.5308, y + 62.9203);
ctx.bezierCurveTo(x + 72.252, y + 62.88, x + 72.013, y + 62.7995, x + 71.7741, y + 62.6786);
ctx.bezierCurveTo(x + 71.6148, y + 62.598, x + 71.4953, y + 62.5175, x + 71.3758, y + 62.4369);
ctx.bezierCurveTo(x + 71.097, y + 62.2355, x + 70.9376, y + 61.9535, x + 70.8182, y + 61.6716);
ctx.bezierCurveTo(x + 70.619, y + 61.1076, x + 70.7783, y + 60.5034, x + 71.1766, y + 59.9394);
ctx.bezierCurveTo(x + 71.5749, y + 59.4158, x + 72.2122, y + 58.9727, x + 72.9291, y + 58.731);
ctx.bezierCurveTo(x + 74.4825, y + 58.2073, x + 76.0359, y + 58.6907, x + 76.3943, y + 59.7783);
ctx.bezierCurveTo(x + 76.4341, y + 59.8589, x + 76.4342, y + 59.9394, x + 76.4342, y + 60.02);
ctx.bezierCurveTo(x + 76.4342, y + 60.1006, x + 76.4342, y + 60.1811, x + 76.4342, y + 60.302);
ctx.bezierCurveTo(x + 76.3943, y + 61.2687, x + 75.4782, y + 62.2758, x + 74.2037, y + 62.6786);
ctx.bezierCurveTo(x + 73.885, y + 62.88, x + 73.4469, y + 62.9606, x + 73.0885, y + 62.9606);
ctx.closePath();
ctx.moveTo(x + 74.1639, y + 58.9324);
ctx.bezierCurveTo(x + 73.8054, y + 58.9324, x + 73.4469, y + 59.0129, x + 73.0885, y + 59.1338);
ctx.bezierCurveTo(x + 72.4113, y + 59.3755, x + 71.8537, y + 59.738, x + 71.4953, y + 60.2214);
ctx.bezierCurveTo(x + 71.1368, y + 60.6645, x + 71.0571, y + 61.1882, x + 71.1766, y + 61.591);
ctx.bezierCurveTo(x + 71.2563, y + 61.8327, x + 71.3758, y + 62.0341, x + 71.6147, y + 62.1952);
ctx.bezierCurveTo(x + 71.7342, y + 62.2758, x + 71.8139, y + 62.3563, x + 71.9732, y + 62.3966);
ctx.bezierCurveTo(x + 72.1724, y + 62.4772, x + 72.3715, y + 62.5578, x + 72.6105, y + 62.598);
ctx.bezierCurveTo(x + 73.0884, y + 62.6786, x + 73.6461, y + 62.598, x + 74.1639, y + 62.4369);
ctx.bezierCurveTo(x + 75.2791, y + 62.0744, x + 76.1155, y + 61.2285, x + 76.1155, y + 60.3825);
ctx.bezierCurveTo(x + 76.1155, y + 60.302, x + 76.1155, y + 60.2214, x + 76.1155, y + 60.1811);
ctx.lineTo(x + 76.1155, y + 60.1408);
ctx.bezierCurveTo(x + 76.1155, y + 60.1006, x + 76.0757, y + 60.02, x + 76.0757, y + 59.9797);
ctx.bezierCurveTo(x + 75.8367, y + 59.2949, x + 75.0799, y + 58.8921, x + 74.1639, y + 58.9324);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 87.3079, y + 62.2356);
ctx.bezierCurveTo(x + 86.9096, y + 62.2356, x + 86.5113, y + 62.1953, x + 86.113, y + 62.0744);
ctx.bezierCurveTo(x + 85.3164, y + 61.8327, x + 84.6791, y + 61.3896, x + 84.241, y + 60.8257);
ctx.bezierCurveTo(x + 83.9224, y + 60.3826, x + 83.7631, y + 59.8992, x + 83.8029, y + 59.4561);
ctx.lineTo(x + 83.8029, y + 59.4158);
ctx.bezierCurveTo(x + 83.8029, y + 59.3353, x + 83.8427, y + 59.2547, x + 83.8427, y + 59.1741);
ctx.bezierCurveTo(x + 84.1614, y + 58.0462, x + 85.7147, y + 57.5226, x + 87.2681, y + 58.006);
ctx.bezierCurveTo(x + 88.5426, y + 58.3685, x + 89.4587, y + 59.295, x + 89.5782, y + 60.2618);
ctx.bezierCurveTo(x + 89.618, y + 60.4632, x + 89.5782, y + 60.6646, x + 89.5384, y + 60.866);
ctx.bezierCurveTo(x + 89.4189, y + 61.3091, x + 89.1002, y + 61.6716, x + 88.6223, y + 61.9133);
ctx.bezierCurveTo(x + 88.3833, y + 62.0342, x + 88.1443, y + 62.1147, x + 87.8655, y + 62.155);
ctx.bezierCurveTo(x + 87.7062, y + 62.1953, x + 87.5071, y + 62.2356, x + 87.3079, y + 62.2356);
ctx.closePath();
ctx.moveTo(x + 84.2012, y + 59.4964);
ctx.bezierCurveTo(x + 84.1614, y + 59.8589, x + 84.2808, y + 60.2618, x + 84.5596, y + 60.6243);
ctx.bezierCurveTo(x + 84.9181, y + 61.1077, x + 85.5554, y + 61.5105, x + 86.2325, y + 61.7119);
ctx.bezierCurveTo(x + 86.7503, y + 61.873, x + 87.3079, y + 61.9133, x + 87.8257, y + 61.8327);
ctx.bezierCurveTo(x + 88.0647, y + 61.7925, x + 88.2638, y + 61.7119, x + 88.463, y + 61.6313);
ctx.bezierCurveTo(x + 88.8613, y + 61.4299, x + 89.1002, y + 61.148, x + 89.2197, y + 60.8257);
ctx.bezierCurveTo(x + 89.2596, y + 60.6646, x + 89.2596, y + 60.5437, x + 89.2596, y + 60.3826);
ctx.bezierCurveTo(x + 89.1799, y + 59.577, x + 88.3435, y + 58.7713, x + 87.2282, y + 58.4491);
ctx.bezierCurveTo(x + 85.874, y + 58.0462, x + 84.5198, y + 58.4491, x + 84.2808, y + 59.3755);
ctx.bezierCurveTo(x + 84.2012, y + 59.3353, x + 84.2012, y + 59.4158, x + 84.2012, y + 59.4964);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 68.3884, y + 67.7139);
ctx.bezierCurveTo(x + 68.2291, y + 67.7139, x + 68.1096, y + 67.7139, x + 67.9503, y + 67.6736);
ctx.bezierCurveTo(x + 67.5122, y + 67.593, x + 67.1537, y + 67.4319, x + 66.8351, y + 67.1499);
ctx.bezierCurveTo(x + 66.7554, y + 67.1097, x + 66.7156, y + 67.0291, x + 66.6359, y + 66.9485);
ctx.bezierCurveTo(x + 66.2775, y + 66.4651, x + 66.158, y + 65.8206, x + 66.3173, y + 65.1358);
ctx.bezierCurveTo(x + 66.4766, y + 64.451, x + 66.9147, y + 63.8468, x + 67.5122, y + 63.3634);
ctx.bezierCurveTo(x + 68.7867, y + 62.3967, x + 70.4198, y + 62.3967, x + 71.1765, y + 63.4037);
ctx.bezierCurveTo(x + 71.2163, y + 63.4843, x + 71.296, y + 63.5648, x + 71.3358, y + 63.6454);
ctx.lineTo(x + 71.3358, y + 63.6857);
ctx.bezierCurveTo(x + 71.4553, y + 63.9274, x + 71.535, y + 64.1691, x + 71.5748, y + 64.4913);
ctx.bezierCurveTo(x + 71.6545, y + 65.4178, x + 71.1367, y + 66.3846, x + 70.3003, y + 67.0694);
ctx.bezierCurveTo(x + 69.8223, y + 67.4319, x + 69.2647, y + 67.6736, x + 68.7071, y + 67.7542);
ctx.bezierCurveTo(x + 68.6274, y + 67.6736, x + 68.5079, y + 67.7139, x + 68.3884, y + 67.7139);
ctx.closePath();
ctx.moveTo(x + 69.5037, y + 63.0009);
ctx.bezierCurveTo(x + 68.9461, y + 63.0009, x + 68.3088, y + 63.2426, x + 67.791, y + 63.6454);
ctx.bezierCurveTo(x + 67.2732, y + 64.0482, x + 66.8749, y + 64.6122, x + 66.7156, y + 65.2164);
ctx.bezierCurveTo(x + 66.5563, y + 65.7803, x + 66.6359, y + 66.304, x + 66.9546, y + 66.7068);
ctx.bezierCurveTo(x + 66.9944, y + 66.7874, x + 67.0342, y + 66.8277, x + 67.1139, y + 66.868);
ctx.bezierCurveTo(x + 67.3529, y + 67.1097, x + 67.6715, y + 67.2305, x + 68.03, y + 67.3111);
ctx.bezierCurveTo(x + 68.2291, y + 67.3513, x + 68.4681, y + 67.3513, x + 68.7071, y + 67.3111);
ctx.bezierCurveTo(x + 69.185, y + 67.2305, x + 69.7028, y + 67.0291, x + 70.1011, y + 66.6665);
ctx.bezierCurveTo(x + 70.8579, y + 66.0623, x + 71.296, y + 65.2164, x + 71.2163, y + 64.451);
ctx.bezierCurveTo(x + 71.2163, y + 64.2094, x + 71.1367, y + 64.0079, x + 71.0172, y + 63.8065);
ctx.lineTo(x + 71.0172, y + 63.7662);
ctx.bezierCurveTo(x + 70.9774, y + 63.726, x + 70.9375, y + 63.6454, x + 70.8977, y + 63.6051);
ctx.bezierCurveTo(x + 70.6189, y + 63.162, x + 70.1011, y + 62.9606, x + 69.5037, y + 63.0009);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 69.3448, y + 73.7562);
ctx.bezierCurveTo(x + 69.066, y + 73.7562, x + 68.827, y + 73.716, x + 68.588, y + 73.6757);
ctx.bezierCurveTo(x + 68.0702, y + 73.5548, x + 67.6321, y + 73.2326, x + 67.3134, y + 72.8297);
ctx.bezierCurveTo(x + 67.3134, y + 72.7895, x + 67.2736, y + 72.7895, x + 67.2736, y + 72.7492);
ctx.bezierCurveTo(x + 66.8355, y + 72.1852, x + 66.6363, y + 71.4602, x + 66.7558, y + 70.7754);
ctx.bezierCurveTo(x + 66.8355, y + 70.0906, x + 67.2338, y + 69.4461, x + 67.7914, y + 69.003);
ctx.bezierCurveTo(x + 68.349, y + 68.5599, x + 69.066, y + 68.3585, x + 69.7829, y + 68.439);
ctx.bezierCurveTo(x + 70.46, y + 68.5196, x + 71.0973, y + 68.8821, x + 71.4956, y + 69.4461);
ctx.bezierCurveTo(x + 71.5354, y + 69.5266, x + 71.6151, y + 69.6072, x + 71.6549, y + 69.6878);
ctx.bezierCurveTo(x + 71.6549, y + 69.6878, x + 71.6549, y + 69.6878, x + 71.6549, y + 69.728);
ctx.bezierCurveTo(x + 71.854, y + 70.0503, x + 71.9337, y + 70.4128, x + 71.9735, y + 70.7754);
ctx.bezierCurveTo(x + 72.0532, y + 71.7019, x + 71.6947, y + 72.5881, x + 70.938, y + 73.1923);
ctx.bezierCurveTo(x + 70.4998, y + 73.5548, x + 69.9422, y + 73.7562, x + 69.3846, y + 73.7562);
ctx.bezierCurveTo(x + 69.3846, y + 73.7562, x + 69.3846, y + 73.7562, x + 69.3448, y + 73.7562);
ctx.closePath();
ctx.moveTo(x + 69.3448, y + 68.8418);
ctx.bezierCurveTo(x + 68.8668, y + 68.8418, x + 68.3888, y + 69.003, x + 67.9906, y + 69.3252);
ctx.bezierCurveTo(x + 67.5126, y + 69.6878, x + 67.194, y + 70.2517, x + 67.1143, y + 70.8559);
ctx.bezierCurveTo(x + 67.0346, y + 71.4602, x + 67.194, y + 72.0644, x + 67.5524, y + 72.5478);
ctx.bezierCurveTo(x + 67.5923, y + 72.5881, x + 67.5923, y + 72.5881, x + 67.5923, y + 72.6283);
ctx.bezierCurveTo(x + 67.8711, y + 72.9909, x + 68.2694, y + 73.2326, x + 68.7075, y + 73.3534);
ctx.bezierCurveTo(x + 68.9465, y + 73.434, x + 69.1456, y + 73.434, x + 69.4244, y + 73.434);
ctx.bezierCurveTo(x + 69.9024, y + 73.3937, x + 70.3803, y + 73.2326, x + 70.7388, y + 72.9506);
ctx.bezierCurveTo(x + 71.3761, y + 72.4672, x + 71.6947, y + 71.6616, x + 71.6151, y + 70.8962);
ctx.bezierCurveTo(x + 71.5752, y + 70.574, x + 71.4956, y + 70.2517, x + 71.3362, y + 70.01);
ctx.lineTo(x + 71.3362, y + 69.9697);
ctx.bezierCurveTo(x + 71.2964, y + 69.8892, x + 71.2566, y + 69.8086, x + 71.1769, y + 69.7683);
ctx.bezierCurveTo(x + 70.8185, y + 69.2849, x + 70.3007, y + 69.003, x + 69.7032, y + 68.9224);
ctx.bezierCurveTo(x + 69.5439, y + 68.8418, x + 69.4643, y + 68.8418, x + 69.3448, y + 68.8418);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 73.2481, y + 78.8318);
ctx.bezierCurveTo(x + 72.7702, y + 78.8318, x + 72.3321, y + 78.7512, x + 71.8541, y + 78.5095);
ctx.bezierCurveTo(x + 71.2567, y + 78.2275, x + 70.7787, y + 77.7844, x + 70.4999, y + 77.2205);
ctx.bezierCurveTo(x + 70.1016, y + 76.4551, x + 70.0618, y + 75.6092, x + 70.3804, y + 74.8439);
ctx.bezierCurveTo(x + 71.0177, y + 73.5146, x + 72.6905, y + 72.9909, x + 74.1244, y + 73.716);
ctx.bezierCurveTo(x + 74.2439, y + 73.7562, x + 74.3235, y + 73.8368, x + 74.4032, y + 73.8771);
ctx.bezierCurveTo(x + 74.4032, y + 73.8771, x + 74.4032, y + 73.8771, x + 74.443, y + 73.8771);
ctx.bezierCurveTo(x + 75.1998, y + 74.3605, x + 75.7176, y + 75.1258, x + 75.7972, y + 75.9315);
ctx.bezierCurveTo(x + 75.8769, y + 76.4149, x + 75.7972, y + 76.8982, x + 75.5981, y + 77.3413);
ctx.bezierCurveTo(x + 75.3591, y + 77.865, x + 74.9608, y + 78.2678, x + 74.443, y + 78.5095);
ctx.bezierCurveTo(x + 74.1642, y + 78.6304, x + 73.8854, y + 78.7109, x + 73.6066, y + 78.7512);
ctx.bezierCurveTo(x + 73.4871, y + 78.8318, x + 73.3676, y + 78.8318, x + 73.2481, y + 78.8318);
ctx.closePath();
ctx.moveTo(x + 72.7702, y + 73.7965);
ctx.bezierCurveTo(x + 71.8939, y + 73.7965, x + 71.0973, y + 74.2396, x + 70.7389, y + 75.0453);
ctx.bezierCurveTo(x + 70.4601, y + 75.6898, x + 70.4601, y + 76.4149, x + 70.8185, y + 77.0594);
ctx.bezierCurveTo(x + 71.0973, y + 77.5428, x + 71.4956, y + 77.9456, x + 72.0134, y + 78.1873);
ctx.bezierCurveTo(x + 72.4914, y + 78.429, x + 73.049, y + 78.5095, x + 73.5668, y + 78.429);
ctx.bezierCurveTo(x + 73.8057, y + 78.3887, x + 74.0447, y + 78.3081, x + 74.2837, y + 78.2275);
ctx.bezierCurveTo(x + 74.7218, y + 78.0261, x + 75.0803, y + 77.6636, x + 75.2794, y + 77.2205);
ctx.bezierCurveTo(x + 75.4388, y + 76.858, x + 75.5184, y + 76.4551, x + 75.4388, y + 76.0523);
ctx.bezierCurveTo(x + 75.3591, y + 75.3272, x + 74.8812, y + 74.6425, x + 74.2439, y + 74.2396);
ctx.lineTo(x + 74.204, y + 74.2396);
ctx.bezierCurveTo(x + 74.1244, y + 74.1994, x + 74.0447, y + 74.1591, x + 73.9651, y + 74.1188);
ctx.bezierCurveTo(x + 73.5668, y + 73.8771, x + 73.1685, y + 73.7965, x + 72.7702, y + 73.7965);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 79.3813, y + 80.6847);
ctx.bezierCurveTo(x + 79.2618, y + 80.6847, x + 79.1024, y + 80.6847, x + 78.983, y + 80.6847);
ctx.bezierCurveTo(x + 78.1864, y + 80.6041, x + 77.4694, y + 80.2416, x + 76.9915, y + 79.6776);
ctx.bezierCurveTo(x + 76.5135, y + 79.154, x + 76.3144, y + 78.5094, x + 76.394, y + 77.8247);
ctx.bezierCurveTo(x + 76.5533, y + 76.4148, x + 77.9474, y + 75.3675, x + 79.5406, y + 75.5286);
ctx.bezierCurveTo(x + 79.6601, y + 75.5286, x + 79.7795, y + 75.5689, x + 79.8592, y + 75.5689);
ctx.lineTo(x + 79.899, y + 75.5689);
ctx.bezierCurveTo(x + 80.8151, y + 75.7703, x + 81.6117, y + 76.3745, x + 81.9702, y + 77.1801);
ctx.bezierCurveTo(x + 82.1295, y + 77.5427, x + 82.2092, y + 77.9858, x + 82.1693, y + 78.3886);
ctx.bezierCurveTo(x + 82.1295, y + 78.9525, x + 81.8507, y + 79.4359, x + 81.4524, y + 79.8387);
ctx.bezierCurveTo(x + 81.2533, y + 80.0402, x + 81.0143, y + 80.2013, x + 80.7753, y + 80.3221);
ctx.bezierCurveTo(x + 80.3372, y + 80.5638, x + 79.8592, y + 80.6847, x + 79.3813, y + 80.6847);
ctx.closePath();
ctx.moveTo(x + 79.1423, y + 75.8911);
ctx.bezierCurveTo(x + 77.9076, y + 75.9314, x + 76.872, y + 76.737, x + 76.7525, y + 77.8649);
ctx.bezierCurveTo(x + 76.7127, y + 78.4289, x + 76.872, y + 78.9928, x + 77.2703, y + 79.4359);
ctx.bezierCurveTo(x + 77.7084, y + 79.9193, x + 78.3457, y + 80.2416, x + 79.0228, y + 80.3221);
ctx.bezierCurveTo(x + 79.5804, y + 80.3624, x + 80.0982, y + 80.2819, x + 80.5363, y + 80.0402);
ctx.bezierCurveTo(x + 80.7753, y + 79.9193, x + 80.9744, y + 79.7985, x + 81.1338, y + 79.5971);
ctx.bezierCurveTo(x + 81.4922, y + 79.2748, x + 81.6914, y + 78.8317, x + 81.7312, y + 78.3483);
ctx.bezierCurveTo(x + 81.771, y + 78.0261, x + 81.6914, y + 77.6635, x + 81.5719, y + 77.3413);
ctx.bezierCurveTo(x + 81.2532, y + 76.6565, x + 80.5761, y + 76.1328, x + 79.7796, y + 75.9717);
ctx.lineTo(x + 79.7397, y + 75.9717);
ctx.bezierCurveTo(x + 79.6601, y + 75.9717, x + 79.5804, y + 75.9314, x + 79.4609, y + 75.9314);
ctx.bezierCurveTo(x + 79.3813, y + 75.8911, x + 79.2618, y + 75.8911, x + 79.1423, y + 75.8911);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 86.0334, y + 79.9193);
ctx.bezierCurveTo(x + 85.2368, y + 79.9193, x + 84.5199, y + 79.6776, x + 83.9623, y + 79.1539);
ctx.bezierCurveTo(x + 83.5242, y + 78.7511, x + 83.2454, y + 78.2274, x + 83.2055, y + 77.6635);
ctx.bezierCurveTo(x + 83.1259, y + 76.9787, x + 83.3648, y + 76.2939, x + 83.8428, y + 75.73);
ctx.bezierCurveTo(x + 84.3208, y + 75.2063, x + 85.0377, y + 74.8437, x + 85.7945, y + 74.7632);
ctx.bezierCurveTo(x + 85.914, y + 74.7632, x + 85.9936, y + 74.7632, x + 86.1131, y + 74.7632);
ctx.lineTo(x + 86.1529, y + 74.7632);
ctx.bezierCurveTo(x + 87.6266, y + 74.7632, x + 88.8215, y + 75.73, x + 88.941, y + 77.019);
ctx.bezierCurveTo(x + 88.941, y + 77.1398, x + 88.941, y + 77.2607, x + 88.941, y + 77.3815);
ctx.bezierCurveTo(x + 88.941, y + 77.7843, x + 88.7817, y + 78.2274, x + 88.5427, y + 78.59);
ctx.bezierCurveTo(x + 88.3834, y + 78.8317, x + 88.1842, y + 79.0331, x + 87.9851, y + 79.2345);
ctx.bezierCurveTo(x + 87.547, y + 79.597, x + 86.9495, y + 79.8387, x + 86.3521, y + 79.9193);
ctx.bezierCurveTo(x + 86.2326, y + 79.9193, x + 86.1131, y + 79.9193, x + 86.0334, y + 79.9193);
ctx.closePath();
ctx.moveTo(x + 86.0334, y + 75.1257);
ctx.bezierCurveTo(x + 85.9538, y + 75.1257, x + 85.8741, y + 75.1257, x + 85.7945, y + 75.1257);
ctx.bezierCurveTo(x + 85.1174, y + 75.2063, x + 84.5199, y + 75.4883, x + 84.0818, y + 75.9716);
ctx.bezierCurveTo(x + 83.6437, y + 76.455, x + 83.4843, y + 77.019, x + 83.5242, y + 77.5829);
ctx.bezierCurveTo(x + 83.564, y + 78.0663, x + 83.803, y + 78.5094, x + 84.1614, y + 78.8317);
ctx.bezierCurveTo(x + 84.7191, y + 79.315, x + 85.4758, y + 79.5567, x + 86.2724, y + 79.4762);
ctx.bezierCurveTo(x + 86.83, y + 79.3956, x + 87.308, y + 79.1942, x + 87.7063, y + 78.8719);
ctx.bezierCurveTo(x + 87.9054, y + 78.7108, x + 88.0648, y + 78.5497, x + 88.1842, y + 78.308);
ctx.bezierCurveTo(x + 88.3834, y + 77.9857, x + 88.5029, y + 77.6232, x + 88.5029, y + 77.2607);
ctx.bezierCurveTo(x + 88.5029, y + 77.1398, x + 88.5029, y + 77.0593, x + 88.5029, y + 76.9787);
ctx.bezierCurveTo(x + 88.3834, y + 75.8911, x + 87.3478, y + 75.0452, x + 86.0733, y + 75.0452);
ctx.lineTo(x + 86.0334, y + 75.0452);
ctx.bezierCurveTo(x + 86.0733, y + 75.1257, x + 86.0733, y + 75.1257, x + 86.0334, y + 75.1257);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 91.5697, y + 77.0994);
ctx.bezierCurveTo(x + 90.9723, y + 77.0994, x + 90.3749, y + 76.898, x + 89.9367, y + 76.5355);
ctx.lineTo(x + 89.8571, y + 76.4952);
ctx.bezierCurveTo(x + 89.3393, y + 76.0521, x + 89.0206, y + 75.4479, x + 88.941, y + 74.7631);
ctx.bezierCurveTo(x + 88.7817, y + 73.3129, x + 89.8172, y + 71.9836, x + 91.2511, y + 71.8225);
ctx.bezierCurveTo(x + 91.3706, y + 71.8225, x + 91.4503, y + 71.8225, x + 91.5697, y + 71.8225);
ctx.bezierCurveTo(x + 92.8841, y + 71.8225, x + 93.9994, y + 72.8698, x + 94.1188, y + 74.1991);
ctx.bezierCurveTo(x + 94.1188, y + 74.2394, x + 94.1188, y + 74.2394, x + 94.1188, y + 74.2797);
ctx.bezierCurveTo(x + 94.1587, y + 74.8034, x + 94.0392, y + 75.327, x + 93.8002, y + 75.8104);
ctx.bezierCurveTo(x + 93.6807, y + 76.0521, x + 93.4816, y + 76.2535, x + 93.2824, y + 76.4549);
ctx.bezierCurveTo(x + 92.8841, y + 76.8578, x + 92.3663, y + 77.0592, x + 91.8087, y + 77.1397);
ctx.bezierCurveTo(x + 91.7689, y + 77.0994, x + 91.6494, y + 77.0994, x + 91.5697, y + 77.0994);
ctx.closePath();
ctx.moveTo(x + 90.2155, y + 76.2938);
ctx.bezierCurveTo(x + 90.6537, y + 76.6161, x + 91.2113, y + 76.7772, x + 91.7689, y + 76.6966);
ctx.bezierCurveTo(x + 92.2469, y + 76.6564, x + 92.685, y + 76.4549, x + 93.0434, y + 76.0924);
ctx.bezierCurveTo(x + 93.2028, y + 75.9313, x + 93.3621, y + 75.7299, x + 93.4816, y + 75.5285);
ctx.bezierCurveTo(x + 93.7205, y + 75.1256, x + 93.8002, y + 74.6825, x + 93.7604, y + 74.1991);
ctx.bezierCurveTo(x + 93.7604, y + 74.1589, x + 93.7604, y + 74.1589, x + 93.7604, y + 74.1589);
ctx.bezierCurveTo(x + 93.6409, y + 73.031, x + 92.685, y + 72.1448, x + 91.5697, y + 72.1448);
ctx.bezierCurveTo(x + 91.4901, y + 72.1448, x + 91.4104, y + 72.1448, x + 91.2909, y + 72.1448);
ctx.bezierCurveTo(x + 90.0562, y + 72.2656, x + 89.18, y + 73.3935, x + 89.3393, y + 74.6423);
ctx.bezierCurveTo(x + 89.4189, y + 75.2465, x + 89.6977, y + 75.8104, x + 90.1757, y + 76.173);
ctx.lineTo(x + 90.2155, y + 76.2938);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 91.4502, y + 68.157);
ctx.bezierCurveTo(x + 91.4502, y + 68.2778, x + 91.49, y + 69.4863, x + 91.49, y + 69.4863);
ctx.lineTo(x + 97.8628, y + 72.5477);
ctx.bezierCurveTo(x + 97.8628, y + 72.5477, x + 98.8585, y + 70.6142, x + 98.8187, y + 68.7209);
ctx.lineTo(x + 96.5086, y + 68.8015);
ctx.bezierCurveTo(x + 96.4687, y + 68.8015, x + 94.7959, y + 67.9556, x + 91.4502, y + 68.157);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 97.9025, y + 72.7894);
ctx.lineTo(x + 91.2908, y + 69.6071);
ctx.lineTo(x + 91.2908, y + 69.4863);
ctx.bezierCurveTo(x + 91.2908, y + 69.2848, x + 91.251, y + 68.2778, x + 91.251, y + 68.157);
ctx.lineTo(x + 91.251, y + 67.9958);
ctx.lineTo(x + 91.4103, y + 67.9958);
ctx.bezierCurveTo(x + 94.517, y + 67.7944, x + 96.1899, y + 68.5195, x + 96.4687, y + 68.6403);
ctx.lineTo(x + 98.9381, y + 68.5598);
ctx.lineTo(x + 98.9381, y + 68.7612);
ctx.bezierCurveTo(x + 98.9779, y + 70.6947, x + 98.022, y + 72.588, x + 97.9822, y + 72.6685);
ctx.lineTo(x + 97.9025, y + 72.7894);
ctx.closePath();
ctx.moveTo(x + 91.6493, y + 69.3251);
ctx.lineTo(x + 97.7432, y + 72.2657);
ctx.bezierCurveTo(x + 97.9822, y + 71.7823, x + 98.5796, y + 70.3322, x + 98.5796, y + 68.882);
ctx.lineTo(x + 96.4288, y + 68.9626);
ctx.lineTo(x + 96.389, y + 68.9223);
ctx.bezierCurveTo(x + 96.389, y + 68.9223, x + 94.756, y + 68.1167, x + 91.6493, y + 68.2778);
ctx.bezierCurveTo(x + 91.6094, y + 68.5598, x + 91.6493, y + 68.9626, x + 91.6493, y + 69.3251);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 76.3147, y + 60.3423);
ctx.bezierCurveTo(x + 75.7173, y + 59.8186, x + 74.5224, y + 59.6172, x + 73.2877, y + 60.0603);
ctx.bezierCurveTo(x + 72.0529, y + 60.5034, x + 71.5352, y + 61.3896, x + 71.4953, y + 62.2758);
ctx.bezierCurveTo(x + 71.2563, y + 62.1147, x + 71.097, y + 61.873, x + 71.0174, y + 61.591);
ctx.bezierCurveTo(x + 70.6987, y + 60.584, x + 71.575, y + 59.3755, x + 73.0487, y + 58.8921);
ctx.bezierCurveTo(x + 74.4826, y + 58.4087, x + 75.9563, y + 58.8115, x + 76.2749, y + 59.8186);
ctx.bezierCurveTo(x + 76.3147, y + 59.8992, x + 76.3147, y + 59.9797, x + 76.3147, y + 60.02);
ctx.bezierCurveTo(x + 76.3147, y + 60.1811, x + 76.3147, y + 60.2617, x + 76.3147, y + 60.3423);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 71.4158, y + 64.4107);
ctx.bezierCurveTo(x + 70.9776, y + 63.9676, x + 70.1014, y + 63.605, x + 68.9065, y + 63.9676);
ctx.bezierCurveTo(x + 67.5523, y + 64.4107, x + 67.0345, y + 65.4983, x + 66.9548, y + 66.9887);
ctx.bezierCurveTo(x + 66.8752, y + 66.9484, x + 66.8354, y + 66.8679, x + 66.7955, y + 66.7873);
ctx.bezierCurveTo(x + 66.0786, y + 65.8608, x + 66.4769, y + 64.3704, x + 67.6718, y + 63.4439);
ctx.bezierCurveTo(x + 68.8667, y + 62.5174, x + 70.3802, y + 62.5174, x + 71.0971, y + 63.4439);
ctx.bezierCurveTo(x + 71.137, y + 63.5245, x + 71.1768, y + 63.5647, x + 71.2166, y + 63.6453);
ctx.bezierCurveTo(x + 71.3361, y + 63.9273, x + 71.4158, y + 64.169, x + 71.4158, y + 64.4107);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 71.7739, y + 70.8156);
ctx.bezierCurveTo(x + 71.2561, y + 70.2114, x + 70.3002, y + 69.3655, x + 69.1451, y + 69.7683);
ctx.bezierCurveTo(x + 67.6714, y + 70.2919, x + 67.313, y + 71.3393, x + 67.4723, y + 72.7089);
ctx.bezierCurveTo(x + 67.4324, y + 72.6686, x + 67.4324, y + 72.6686, x + 67.3926, y + 72.6283);
ctx.bezierCurveTo(x + 66.5562, y + 71.5407, x + 66.7952, y + 70.01, x + 67.8706, y + 69.1641);
ctx.bezierCurveTo(x + 68.946, y + 68.3181, x + 70.4993, y + 68.4793, x + 71.2959, y + 69.5669);
ctx.bezierCurveTo(x + 71.3358, y + 69.6474, x + 71.4154, y + 69.728, x + 71.4553, y + 69.8086);
ctx.bezierCurveTo(x + 71.6544, y + 70.1308, x + 71.7341, y + 70.4531, x + 71.7739, y + 70.8156);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 75.6379, y + 76.0119);
ctx.bezierCurveTo(x + 75.1599, y + 75.5286, x + 74.1243, y + 74.7229, x + 72.7303, y + 75.0049);
ctx.bezierCurveTo(x + 70.8185, y + 75.3271, x + 70.699, y + 77.0593, x + 70.699, y + 77.1801);
ctx.bezierCurveTo(x + 70.3405, y + 76.4953, x + 70.2609, y + 75.6897, x + 70.5795, y + 75.0049);
ctx.bezierCurveTo(x + 71.1769, y + 73.7964, x + 72.7303, y + 73.313, x + 74.0845, y + 73.9576);
ctx.bezierCurveTo(x + 74.1642, y + 73.9978, x + 74.2837, y + 74.0381, x + 74.3633, y + 74.1187);
ctx.bezierCurveTo(x + 75.0803, y + 74.5215, x + 75.5184, y + 75.2466, x + 75.6379, y + 76.0119);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 81.7713, y + 77.2606);
ctx.bezierCurveTo(x + 80.5764, y + 76.5758, x + 78.8637, y + 76.6161, x + 78.0671, y + 77.1397);
ctx.bezierCurveTo(x + 77.39, y + 77.5828, x + 76.8722, y + 78.4288, x + 77.151, y + 79.5567);
ctx.bezierCurveTo(x + 76.7527, y + 79.0733, x + 76.5137, y + 78.469, x + 76.5934, y + 77.8648);
ctx.bezierCurveTo(x + 76.7129, y + 76.5355, x + 78.0273, y + 75.609, x + 79.501, y + 75.7701);
ctx.bezierCurveTo(x + 79.6204, y + 75.7701, x + 79.7001, y + 75.8104, x + 79.8196, y + 75.8104);
ctx.bezierCurveTo(x + 79.8196, y + 75.8104, x + 79.8196, y + 75.8104, x + 79.8594, y + 75.8104);
ctx.bezierCurveTo(x + 80.7357, y + 75.9716, x + 81.4526, y + 76.5355, x + 81.7713, y + 77.2606);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 90.2153, y + 76.2938);
ctx.bezierCurveTo(x + 90.6534, y + 76.6161, x + 91.211, y + 76.7772, x + 91.7686, y + 76.6966);
ctx.bezierCurveTo(x + 92.2466, y + 76.6564, x + 92.6847, y + 76.4549, x + 93.0432, y + 76.0924);
ctx.bezierCurveTo(x + 93.2025, y + 75.9313, x + 93.3618, y + 75.7299, x + 93.4813, y + 75.5285);
ctx.bezierCurveTo(x + 93.7203, y + 75.1256, x + 93.7999, y + 74.6825, x + 93.7601, y + 74.1992);
ctx.bezierCurveTo(x + 93.7601, y + 74.1589, x + 93.7601, y + 74.1589, x + 93.7601, y + 74.1589);
ctx.bezierCurveTo(x + 93.6406, y + 73.031, x + 92.6847, y + 72.1448, x + 91.5695, y + 72.1448);
ctx.bezierCurveTo(x + 91.4898, y + 72.1448, x + 91.4102, y + 72.1448, x + 91.2907, y + 72.1448);
ctx.bezierCurveTo(x + 90.056, y + 72.2656, x + 89.1797, y + 73.3935, x + 89.339, y + 74.6423);
ctx.bezierCurveTo(x + 89.4187, y + 75.2465, x + 89.6975, y + 75.8104, x + 90.1754, y + 76.173);
ctx.lineTo(x + 90.2153, y + 76.2938);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 88.7413, y + 77.3412);
ctx.bezierCurveTo(x + 88.0642, y + 76.3342, x + 86.9091, y + 75.8508, x + 85.5151, y + 76.2536);
ctx.bezierCurveTo(x + 84.2405, y + 76.6162, x + 83.7626, y + 77.7441, x + 84.0812, y + 79.0331);
ctx.bezierCurveTo(x + 83.6829, y + 78.6705, x + 83.4439, y + 78.1872, x + 83.3643, y + 77.6635);
ctx.bezierCurveTo(x + 83.205, y + 76.3342, x + 84.2804, y + 75.1257, x + 85.7939, y + 74.9646);
ctx.bezierCurveTo(x + 85.9134, y + 74.9646, x + 85.993, y + 74.9646, x + 86.1125, y + 74.9646);
ctx.lineTo(x + 86.1523, y + 74.9646);
ctx.bezierCurveTo(x + 87.5066, y + 74.9646, x + 88.6218, y + 75.8508, x + 88.7811, y + 77.0593);
ctx.bezierCurveTo(x + 88.7413, y + 77.1398, x + 88.7413, y + 77.2204, x + 88.7413, y + 77.3412);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 93.9588, y + 74.2394);
ctx.bezierCurveTo(x + 93.441, y + 73.5949, x + 92.3656, y + 72.749, x + 91.1309, y + 73.2324);
ctx.bezierCurveTo(x + 89.5377, y + 73.8769, x + 89.5775, y + 75.5284, x + 90.0555, y + 76.3744);
ctx.bezierCurveTo(x + 89.5775, y + 75.9716, x + 89.2191, y + 75.4076, x + 89.1394, y + 74.7228);
ctx.bezierCurveTo(x + 88.9801, y + 73.3532, x + 89.936, y + 72.1448, x + 91.2902, y + 71.9836);
ctx.bezierCurveTo(x + 91.3699, y + 71.9836, x + 91.4894, y + 71.9836, x + 91.569, y + 71.9836);
ctx.lineTo(x + 91.6089, y + 71.9836);
ctx.bezierCurveTo(x + 92.8037, y + 71.9836, x + 93.8393, y + 72.9101, x + 93.9986, y + 74.1589);
ctx.bezierCurveTo(x + 93.9588, y + 74.1991, x + 93.9588, y + 74.1991, x + 93.9588, y + 74.2394);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 89.419, y + 60.3021);
ctx.bezierCurveTo(x + 88.0648, y + 58.9325, x + 86.3919, y + 58.7311, x + 85.4758, y + 59.0533);
ctx.bezierCurveTo(x + 84.7589, y + 59.295, x + 84.281, y + 59.8993, x + 84.4004, y + 60.7049);
ctx.bezierCurveTo(x + 84.1216, y + 60.3021, x + 83.9623, y + 59.8993, x + 84.0022, y + 59.4562);
ctx.bezierCurveTo(x + 84.0022, y + 59.3756, x + 84.042, y + 59.295, x + 84.042, y + 59.2547);
ctx.bezierCurveTo(x + 84.3208, y + 58.2477, x + 85.7547, y + 57.7643, x + 87.2284, y + 58.2074);
ctx.bezierCurveTo(x + 88.4631, y + 58.5297, x + 89.3393, y + 59.4159, x + 89.419, y + 60.3021);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 52.7354, y + 95.4682);
ctx.bezierCurveTo(x + 56.798, y + 95.3876, x + 60.8606, y + 95.2668, x + 64.9232, y + 95.2265);
ctx.bezierCurveTo(x + 68.9859, y + 95.1459, x + 73.0485, y + 95.1056, x + 77.1112, y + 95.0251);
ctx.bezierCurveTo(x + 79.1425, y + 94.9848, x + 81.1738, y + 94.9445, x + 83.2051, y + 94.9445);
ctx.lineTo(x + 89.299, y + 94.9042);
ctx.bezierCurveTo(x + 93.3617, y + 94.864, x + 97.4243, y + 94.864, x + 101.487, y + 94.9042);
ctx.bezierCurveTo(x + 97.4243, y + 95.0654, x + 93.3617, y + 95.2265, x + 89.299, y + 95.3473);
ctx.lineTo(x + 83.2051, y + 95.5085);
ctx.bezierCurveTo(x + 81.1738, y + 95.5487, x + 79.1425, y + 95.589, x + 77.1112, y + 95.6293);
ctx.bezierCurveTo(x + 73.0485, y + 95.7099, x + 68.9859, y + 95.7904, x + 64.9232, y + 95.871);
ctx.bezierCurveTo(x + 60.8606, y + 95.9516, x + 56.798, y + 95.9919, x + 52.7354, y + 96.0321);
ctx.lineTo(x + 52.7354, y + 95.4682);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 76.5137, y + 96.9586);
ctx.bezierCurveTo(x + 77.1111, y + 96.5558, x + 77.6687, y + 96.153, x + 78.2662, y + 95.7904);
ctx.bezierCurveTo(x + 78.8636, y + 95.4279, x + 79.4212, y + 95.0251, x + 80.0187, y + 94.7028);
ctx.bezierCurveTo(x + 80.6161, y + 94.3403, x + 81.2136, y + 94.018, x + 81.8509, y + 93.6958);
ctx.bezierCurveTo(x + 82.4483, y + 93.3735, x + 83.0856, y + 93.0513, x + 83.7627, y + 92.8096);
ctx.bezierCurveTo(x + 83.2449, y + 93.293, x + 82.6873, y + 93.6958, x + 82.0898, y + 94.0986);
ctx.bezierCurveTo(x + 81.5322, y + 94.5014, x + 80.9348, y + 94.8639, x + 80.3373, y + 95.2265);
ctx.bezierCurveTo(x + 79.7399, y + 95.589, x + 79.1424, y + 95.9113, x + 78.5052, y + 96.2335);
ctx.bezierCurveTo(x + 77.8679, y + 96.4752, x + 77.2306, y + 96.7572, x + 76.5137, y + 96.9586);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 77.8281, y + 96.4752);
ctx.bezierCurveTo(x + 78.4256, y + 96.1127, x + 79.023, y + 95.7501, x + 79.6205, y + 95.3876);
ctx.bezierCurveTo(x + 80.2179, y + 95.0251, x + 80.8154, y + 94.6625, x + 81.4128, y + 94.3);
ctx.bezierCurveTo(x + 82.0102, y + 93.9374, x + 82.6077, y + 93.6152, x + 83.2051, y + 93.2527);
ctx.bezierCurveTo(x + 83.8026, y + 92.9304, x + 84.4399, y + 92.5679, x + 85.0771, y + 92.2859);
ctx.bezierCurveTo(x + 84.5195, y + 92.729, x + 83.9619, y + 93.1318, x + 83.3645, y + 93.4943);
ctx.bezierCurveTo(x + 82.767, y + 93.8972, x + 82.2094, y + 94.2597, x + 81.6119, y + 94.6222);
ctx.bezierCurveTo(x + 81.0145, y + 94.9848, x + 80.4171, y + 95.307, x + 79.7798, y + 95.6293);
ctx.bezierCurveTo(x + 79.1027, y + 95.9515, x + 78.5052, y + 96.2738, x + 77.8281, y + 96.4752);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 84.3203, y + 90.2719);
ctx.bezierCurveTo(x + 84.639, y + 90.0302, x + 84.9576, y + 89.8691, x + 85.3161, y + 89.6677);
ctx.lineTo(x + 86.3516, y + 89.1037);
ctx.bezierCurveTo(x + 87.0287, y + 88.7412, x + 87.7058, y + 88.3787, x + 88.4228, y + 88.0161);
ctx.bezierCurveTo(x + 87.8253, y + 88.4995, x + 87.1881, y + 88.9426, x + 86.5508, y + 89.426);
ctx.lineTo(x + 85.5949, y + 90.1108);
ctx.bezierCurveTo(x + 85.2762, y + 90.3525, x + 84.9576, y + 90.5539, x + 84.639, y + 90.7553);
ctx.lineTo(x + 84.3203, y + 90.2719);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 91.4492, y + 89.8691);
ctx.lineTo(x + 93.7195, y + 88.4995);
ctx.lineTo(x + 91.8077, y + 90.3525);
ctx.lineTo(x + 91.4492, y + 89.8691);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 57.5148, y + 95.6697);
ctx.lineTo(x + 57.3555, y + 106.103);
ctx.lineTo(x + 58.3114, y + 106.103);
ctx.bezierCurveTo(x + 58.3114, y + 106.103, x + 57.5546, y + 104.854, x + 57.7538, y + 101.067);
ctx.bezierCurveTo(x + 57.9529, y + 97.3212, x + 58.5105, y + 95.6697, x + 58.5105, y + 95.6697);
ctx.lineTo(x + 57.5148, y + 95.6697);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 52.8142, y + 109.124);
ctx.lineTo(x + 52.7744, y + 106.707);
ctx.bezierCurveTo(x + 52.7744, y + 106.707, x + 60.7802, y + 106.586, x + 62.0946, y + 106.707);
ctx.bezierCurveTo(x + 59.7048, y + 107.271, x + 53.1329, y + 107.351, x + 53.1329, y + 107.351);
ctx.lineTo(x + 53.1727, y + 109.124);
ctx.lineTo(x + 52.8142, y + 109.124);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 52.7746, y + 106.264);
ctx.lineTo(x + 54.5271, y + 106.223);
ctx.bezierCurveTo(x + 54.5271, y + 106.223, x + 53.5314, y + 101.43, x + 53.7704, y + 95.7501);
ctx.lineTo(x + 53.3322, y + 95.7501);
ctx.lineTo(x + 53.3322, y + 95.0251);
ctx.lineTo(x + 53.7704, y + 95.0251);
ctx.bezierCurveTo(x + 53.7704, y + 95.0251, x + 53.8102, y + 92.6484, x + 53.9297, y + 92.165);
ctx.lineTo(x + 52.2568, y + 92.2053);
ctx.lineTo(x + 52.7746, y + 106.264);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 110.608, y + 95.3071);
ctx.lineTo(x + 106.585, y + 94.8237);
ctx.lineTo(x + 110.568, y + 94.1792);
ctx.lineTo(x + 110.608, y + 95.3071);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 110.17, y + 94.2196);
ctx.lineTo(x + 110.329, y + 104.935);
ctx.lineTo(x + 111.325, y + 104.935);
ctx.lineTo(x + 111.086, y + 90.3525);
ctx.lineTo(x + 110.09, y + 90.3525);
ctx.lineTo(x + 110.17, y + 94.0182);
ctx.lineTo(x + 110.568, y + 94.0182);
ctx.lineTo(x + 110.568, y + 94.2196);
ctx.lineTo(x + 110.17, y + 94.2196);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 60.7803, y + 105.499);
ctx.bezierCurveTo(x + 62.7718, y + 105.418, x + 64.7234, y + 105.378, x + 66.7149, y + 105.297);
ctx.lineTo(x + 72.6495, y + 105.136);
ctx.bezierCurveTo(x + 76.5927, y + 105.055, x + 80.5358, y + 104.975, x + 84.5188, y + 104.894);
ctx.bezierCurveTo(x + 88.4619, y + 104.854, x + 92.4051, y + 104.773, x + 96.3881, y + 104.733);
ctx.lineTo(x + 102.323, y + 104.693);
ctx.bezierCurveTo(x + 104.314, y + 104.693, x + 106.266, y + 104.693, x + 108.257, y + 104.693);
ctx.bezierCurveTo(x + 106.266, y + 104.773, x + 104.314, y + 104.814, x + 102.323, y + 104.894);
ctx.lineTo(x + 96.3881, y + 105.055);
ctx.bezierCurveTo(x + 92.4449, y + 105.136, x + 88.5018, y + 105.217, x + 84.5188, y + 105.297);
ctx.bezierCurveTo(x + 80.5756, y + 105.337, x + 76.6325, y + 105.418, x + 72.6495, y + 105.458);
ctx.lineTo(x + 66.7149, y + 105.499);
ctx.bezierCurveTo(x + 64.7234, y + 105.499, x + 62.7319, y + 105.499, x + 60.7803, y + 105.499);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 101.725, y + 106.304);
ctx.lineTo(x + 101.725, y + 105.901);
ctx.lineTo(x + 100.371, y + 105.942);
ctx.lineTo(x + 100.969, y + 108.036);
ctx.lineTo(x + 101.327, y + 107.996);
ctx.lineTo(x + 100.889, y + 106.304);
ctx.lineTo(x + 101.725, y + 106.304);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 111.33, y + 105.744);
ctx.lineTo(x + 102.289, y + 105.899);
ctx.lineTo(x + 102.295, y + 106.262);
ctx.lineTo(x + 111.336, y + 106.106);
ctx.lineTo(x + 111.33, y + 105.744);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 58.0719, y + 86.0825);
ctx.lineTo(x + 57.6338, y + 86.8882);
ctx.bezierCurveTo(x + 57.6338, y + 86.8882, x + 61.9752, y + 86.9687, x + 62.0549, y + 86.9687);
ctx.bezierCurveTo(x + 62.1345, y + 86.9687, x + 64.8828, y + 86.2034, x + 64.8828, y + 86.2034);
ctx.lineTo(x + 58.0719, y + 86.0825);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 57.4746, y + 87.4119);
ctx.bezierCurveTo(x + 58.2314, y + 87.8952, x + 60.3423, y + 88.0967, x + 61.6567, y + 87.4119);
ctx.lineTo(x + 57.4746, y + 87.4119);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 99.1367, y + 70.1309);
ctx.bezierCurveTo(x + 99.1765, y + 70.6142, x + 99.1367, y + 71.0976, x + 99.1367, y + 71.5407);
ctx.bezierCurveTo(x + 99.1367, y + 72.0241, x + 99.0969, y + 72.5075, x + 99.057, y + 72.9506);
ctx.bezierCurveTo(x + 99.0172, y + 73.434, x + 98.9774, y + 73.9174, x + 98.9376, y + 74.3605);
ctx.bezierCurveTo(x + 98.8977, y + 74.8438, x + 98.8181, y + 75.287, x + 98.7384, y + 75.7703);
ctx.bezierCurveTo(x + 98.6986, y + 75.287, x + 98.7384, y + 74.8036, x + 98.7384, y + 74.3605);
ctx.bezierCurveTo(x + 98.7384, y + 73.8771, x + 98.7782, y + 73.3937, x + 98.8181, y + 72.9506);
ctx.bezierCurveTo(x + 98.8579, y + 72.4672, x + 98.8977, y + 71.9838, x + 98.9376, y + 71.5407);
ctx.bezierCurveTo(x + 98.9774, y + 71.0976, x + 99.057, y + 70.6142, x + 99.1367, y + 70.1309);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 98.1014, y + 73.5549);
ctx.bezierCurveTo(x + 97.6234, y + 75.0454, x + 96.7472, y + 76.3747, x + 95.6718, y + 77.5026);
ctx.bezierCurveTo(x + 94.5964, y + 78.6305, x + 93.3616, y + 79.5972, x + 92.0074, y + 80.3626);
ctx.bezierCurveTo(x + 89.299, y + 81.8933, x + 86.2719, y + 82.7392, x + 83.205, y + 83.0212);
ctx.bezierCurveTo(x + 80.1382, y + 83.3032, x + 76.9916, y + 83.0212, x + 74.0442, y + 82.0544);
ctx.bezierCurveTo(x + 73.3273, y + 81.8127, x + 72.5705, y + 81.5308, x + 71.8934, y + 81.2085);
ctx.bezierCurveTo(x + 71.1765, y + 80.8863, x + 70.4994, y + 80.5237, x + 69.8621, y + 80.0806);
ctx.bezierCurveTo(x + 69.2248, y + 79.6778, x + 68.5875, y + 79.1944, x + 68.0299, y + 78.6707);
ctx.bezierCurveTo(x + 67.4723, y + 78.1471, x + 66.9147, y + 77.5831, x + 66.4766, y + 76.9789);
ctx.bezierCurveTo(x + 67.552, y + 78.1068, x + 68.7469, y + 79.0333, x + 70.1011, y + 79.7584);
ctx.bezierCurveTo(x + 71.4154, y + 80.4834, x + 72.8095, y + 81.0877, x + 74.2832, y + 81.4905);
ctx.bezierCurveTo(x + 75.0001, y + 81.6919, x + 75.7569, y + 81.8933, x + 76.4738, y + 82.0141);
ctx.bezierCurveTo(x + 77.2306, y + 82.1753, x + 77.9475, y + 82.2558, x + 78.7043, y + 82.3364);
ctx.bezierCurveTo(x + 80.2178, y + 82.4975, x + 81.7313, y + 82.5378, x + 83.205, y + 82.417);
ctx.bezierCurveTo(x + 86.1923, y + 82.1753, x + 89.1795, y + 81.3696, x + 91.8481, y + 79.8792);
ctx.bezierCurveTo(x + 94.437, y + 78.5096, x + 96.7073, y + 76.3344, x + 98.1014, y + 73.5549);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 104.195, y + 75.1662);
ctx.lineTo(x + 106.426, y + 76.2941);
ctx.lineTo(x + 105.908, y + 74.4814);
ctx.lineTo(x + 106.625, y + 74.844);
ctx.lineTo(x + 111.604, y + 89.1844);
ctx.lineTo(x + 110.887, y + 89.1844);
ctx.lineTo(x + 107.541, y + 79.1542);
ctx.bezierCurveTo(x + 107.541, y + 79.1542, x + 105.47, y + 78.1874, x + 104.195, y + 75.1662);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 99.296, y + 48.6202);
ctx.bezierCurveTo(x + 98.2206, y + 47.9354, x + 97.4639, y + 48.2979, x + 97.4639, y + 48.6605);
ctx.bezierCurveTo(x + 97.4639, y + 49.2647, x + 98.5791, y + 49.9495, x + 99.4155, y + 50.2315);
ctx.lineTo(x + 99.296, y + 48.6202);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 64.0467, y + 49.1439);
ctx.bezierCurveTo(x + 63.8475, y + 49.6675, x + 65.4009, y + 50.2315, x + 66.6754, y + 49.9092);
ctx.lineTo(x + 66.5559, y + 48.7008);
ctx.bezierCurveTo(x + 66.5958, y + 48.7008, x + 64.2458, y + 48.6605, x + 64.0467, y + 49.1439);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 47.6371, y + 61.1882);
ctx.bezierCurveTo(x + 47.2388, y + 58.731, x + 46.3227, y + 55.589, x + 45.088, y + 53.4943);
ctx.lineTo(x + 44.2516, y + 55.1861);
ctx.bezierCurveTo(x + 44.0524, y + 55.589, x + 43.8533, y + 55.9918, x + 43.694, y + 56.3946);
ctx.bezierCurveTo(x + 43.4948, y + 56.7974, x + 43.3355, y + 57.2405, x + 43.1762, y + 57.6433);
ctx.bezierCurveTo(x + 43.2559, y + 57.2002, x + 43.3753, y + 56.7571, x + 43.5347, y + 56.314);
ctx.bezierCurveTo(x + 43.6542, y + 55.8709, x + 43.8135, y + 55.4681, x + 43.9728, y + 55.025);
ctx.bezierCurveTo(x + 44.1321, y + 54.5819, x + 44.2914, y + 54.1791, x + 44.4906, y + 53.7763);
ctx.bezierCurveTo(x + 44.6101, y + 53.5346, x + 45.8448, y + 50.6343, x + 45.8448, y + 50.6343);
ctx.lineTo(x + 44.4507, y + 52.5275);
ctx.lineTo(x + 44.4906, y + 52.5678);
ctx.bezierCurveTo(x + 43.8135, y + 51.6816, x + 43.0567, y + 51.1579, x + 42.2601, y + 51.1579);
ctx.bezierCurveTo(x + 42.1406, y + 51.1579, x + 42.0211, y + 51.1982, x + 41.9016, y + 51.1982);
ctx.bezierCurveTo(x + 41.6627, y + 51.1579, x + 41.3839, y + 51.1982, x + 41.1449, y + 51.3594);
ctx.bezierCurveTo(x + 40.5076, y + 51.7219, x + 40.3881, y + 52.0844, x + 40.5076, y + 52.7289);
ctx.bezierCurveTo(x + 38.7949, y + 55.8307, x + 37.7593, y + 62.5577, x + 37.7593, y + 63.6454);
ctx.bezierCurveTo(x + 37.7593, y + 63.6454, x + 37.7593, y + 59.8991, x + 37.7593, y + 57.4016);
ctx.bezierCurveTo(x + 37.7593, y + 57.4016, x + 37.1619, y + 59.8589, x + 37.1221, y + 65.1358);
ctx.bezierCurveTo(x + 38.8347, y + 65.0149, x + 46.7609, y + 63.9676, x + 48.6329, y + 62.7994);
ctx.bezierCurveTo(x + 49.1108, y + 62.5577, x + 48.6329, y + 61.9132, x + 47.6371, y + 61.1882);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 39.1934, y + 50.8357);
ctx.bezierCurveTo(x + 41.623, y + 50.4732, x + 45.6458, y + 49.023, x + 46.8407, y + 47.8146);
ctx.bezierCurveTo(x + 47.1991, y + 47.4521, x + 46.4424, y + 47.3715, x + 45.1678, y + 47.4118);
ctx.lineTo(x + 39.4323, y + 49.9898);
ctx.lineTo(x + 39.1934, y + 50.8357);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 46.1236, y + 48.9426);
ctx.bezierCurveTo(x + 46.1236, y + 49.1843, x + 48.832, y + 48.862, x + 48.832, y + 48.862);
ctx.lineTo(x + 48.1947, y + 48.3787);
ctx.bezierCurveTo(x + 48.2346, y + 48.3787, x + 46.0838, y + 48.6204, x + 46.1236, y + 48.9426);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 60.4618, y + 65.5388);
ctx.bezierCurveTo(x + 53.6908, y + 69.567, x + 44.6892, y + 71.3394, x + 41.3037, y + 71.1782);
ctx.bezierCurveTo(x + 44.2511, y + 70.6949, x + 50.7434, y + 68.8822, x + 50.7434, y + 68.8822);
ctx.lineTo(x + 48.0748, y + 64.0081);
ctx.lineTo(x + 48.0349, y + 64.0081);
ctx.bezierCurveTo(x + 46.7206, y + 64.3706, x + 39.352, y + 65.6596, x + 37.1216, y + 65.136);
ctx.lineTo(x + 36.8428, y + 65.9416);
ctx.bezierCurveTo(x + 38.2368, y + 71.0977, x + 39.2326, y + 71.6616, x + 39.2326, y + 71.6616);
ctx.lineTo(x + 41.8613, y + 72.709);
ctx.bezierCurveTo(x + 51.8188, y + 71.7019, x + 60.1033, y + 66.7875, x + 60.1033, y + 66.7875);
ctx.bezierCurveTo(x + 60.1033, y + 66.7875, x + 60.3423, y + 66.5458, x + 60.6211, y + 66.1833);
ctx.lineTo(x + 60.4618, y + 65.5388);
ctx.closePath();
ctx.moveTo(x + 39.5512, y + 71.4199);
ctx.bezierCurveTo(x + 39.5512, y + 71.4199, x + 38.5156, y + 70.292, x + 38.0775, y + 68.5196);
ctx.bezierCurveTo(x + 37.719, y + 67.0695, x + 37.7987, y + 66.3041, x + 37.7987, y + 66.3041);
ctx.lineTo(x + 38.3563, y + 66.2236);
ctx.bezierCurveTo(x + 38.3563, y + 66.2236, x + 38.5555, y + 69.9295, x + 40.2283, y + 71.2991);
ctx.lineTo(x + 39.5512, y + 71.4199);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 60.3819, y + 65.2969);
ctx.bezierCurveTo(x + 60.2624, y + 63.8468, x + 60.7404, y + 61.027, x + 60.7404, y + 61.027);
ctx.lineTo(x + 60.2624, y + 59.3755);
ctx.bezierCurveTo(x + 60.2624, y + 59.3755, x + 57.1955, y + 61.7118, x + 54.049, y + 62.88);
ctx.bezierCurveTo(x + 54.049, y + 62.88, x + 54.1685, y + 64.0079, x + 54.4074, y + 64.3705);
ctx.bezierCurveTo(x + 53.7303, y + 63.6051, x + 53.332, y + 63.0009, x + 53.332, y + 63.0009);
ctx.bezierCurveTo(x + 53.332, y + 63.0009, x + 53.7702, y + 66.2637, x + 55.2837, y + 67.4319);
ctx.bezierCurveTo(x + 55.3235, y + 67.3916, x + 57.8726, y + 66.5457, x + 60.3819, y + 65.2969);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 117.777, y + 55.428);
ctx.bezierCurveTo(x + 117.937, y + 55.7502, x + 118.016, y + 56.1128, x + 118.096, y + 56.4753);
ctx.bezierCurveTo(x + 118.176, y + 56.8378, x + 118.215, y + 57.2004, x + 118.255, y + 57.5629);
ctx.bezierCurveTo(x + 118.295, y + 57.9255, x + 118.295, y + 58.288, x + 118.255, y + 58.6505);
ctx.bezierCurveTo(x + 118.255, y + 59.0131, x + 118.215, y + 59.3756, x + 118.136, y + 59.7381);
ctx.bezierCurveTo(x + 118.056, y + 59.3756, x + 118.016, y + 59.0131, x + 117.976, y + 58.6505);
ctx.bezierCurveTo(x + 117.937, y + 58.288, x + 117.897, y + 57.9255, x + 117.897, y + 57.5629);
ctx.bezierCurveTo(x + 117.857, y + 57.2004, x + 117.857, y + 56.8378, x + 117.857, y + 56.4753);
ctx.bezierCurveTo(x + 117.777, y + 56.1531, x + 117.777, y + 55.8308, x + 117.777, y + 55.428);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 125.265, y + 54.7834);
ctx.bezierCurveTo(x + 124.787, y + 54.8237, x + 124.389, y + 55.3474, x + 124.309, y + 56.7572);
ctx.bezierCurveTo(x + 124.229, y + 55.9113, x + 123.99, y + 55.0654, x + 123.99, y + 55.0654);
ctx.lineTo(x + 119.529, y + 55.4279);
ctx.bezierCurveTo(x + 119.888, y + 56.2336, x + 119.888, y + 57.7643, x + 119.888, y + 58.8519);
ctx.bezierCurveTo(x + 119.808, y + 57.8046, x + 119.33, y + 56.2739, x + 118.653, y + 55.1057);
ctx.bezierCurveTo(x + 118.813, y + 57.0795, x + 119.012, y + 60.0201, x + 119.649, y + 59.8992);
ctx.bezierCurveTo(x + 119.768, y + 59.8992, x + 119.808, y + 59.7784, x + 119.888, y + 59.6575);
ctx.bezierCurveTo(x + 119.888, y + 59.8992, x + 119.848, y + 60.0604, x + 119.848, y + 60.0604);
ctx.lineTo(x + 125.185, y + 59.8992);
ctx.bezierCurveTo(x + 125.185, y + 59.8992, x + 122.198, y + 60.7854, x + 115.228, y + 60.7452);
ctx.bezierCurveTo(x + 108.258, y + 60.6646, x + 104.713, y + 59.4159, x + 104.713, y + 59.4159);
ctx.lineTo(x + 110.608, y + 59.8187);
ctx.bezierCurveTo(x + 110.608, y + 59.8187, x + 110.209, y + 56.3544, x + 110.807, y + 55.3877);
ctx.bezierCurveTo(x + 104.992, y + 54.9043, x + 103.12, y + 54.1389, x + 103.12, y + 54.1389);
ctx.bezierCurveTo(x + 103.08, y + 55.3474, x + 103.04, y + 57.7643, x + 103.199, y + 58.6908);
ctx.bezierCurveTo(x + 103.677, y + 59.6978, x + 105.231, y + 60.5438, x + 105.231, y + 60.5438);
ctx.bezierCurveTo(x + 105.231, y + 60.5438, x + 114.511, y + 63.0412, x + 124.389, y + 61.3494);
ctx.lineTo(x + 125.384, y + 60.584);
ctx.bezierCurveTo(x + 125.384, y + 60.584, x + 125.823, y + 58.7713, x + 125.982, y + 57.2406);
ctx.bezierCurveTo(x + 126.101, y + 55.7905, x + 125.703, y + 54.7431, x + 125.265, y + 54.7834);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 56.7979, y + 42.4571);
ctx.bezierCurveTo(x + 57.9927, y + 42.1752, x + 59.1876, y + 41.8932, x + 60.3825, y + 41.6515);
ctx.bezierCurveTo(x + 60.98, y + 41.5307, x + 61.5774, y + 41.4098, x + 62.1749, y + 41.289);
ctx.bezierCurveTo(x + 62.7723, y + 41.1681, x + 63.3698, y + 41.0473, x + 63.9672, y + 40.9264);
ctx.bezierCurveTo(x + 66.3968, y + 40.443, x + 68.8264, y + 40.0402, x + 71.256, y + 39.6777);
ctx.bezierCurveTo(x + 73.6857, y + 39.3152, x + 76.1153, y + 39.0332, x + 78.5847, y + 38.7512);
ctx.bezierCurveTo(x + 79.8194, y + 38.6304, x + 81.0143, y + 38.5095, x + 82.2491, y + 38.4289);
ctx.bezierCurveTo(x + 83.4838, y + 38.3484, x + 84.7185, y + 38.2678, x + 85.9134, y + 38.2275);
ctx.bezierCurveTo(x + 84.6787, y + 38.3081, x + 83.4838, y + 38.4289, x + 82.2491, y + 38.5901);
ctx.bezierCurveTo(x + 81.0143, y + 38.7109, x + 79.8194, y + 38.872, x + 78.5847, y + 39.0332);
ctx.bezierCurveTo(x + 76.1551, y + 39.3554, x + 73.7255, y + 39.6777, x + 71.2959, y + 40.0805);
ctx.bezierCurveTo(x + 70.101, y + 40.2819, x + 68.8663, y + 40.4833, x + 67.6714, y + 40.6847);
ctx.bezierCurveTo(x + 66.4765, y + 40.8862, x + 65.2418, y + 41.1278, x + 64.0469, y + 41.3695);
ctx.bezierCurveTo(x + 63.4494, y + 41.4904, x + 62.852, y + 41.6112, x + 62.2545, y + 41.7321);
ctx.bezierCurveTo(x + 61.6571, y + 41.8529, x + 61.0596, y + 41.9738, x + 60.4622, y + 42.0946);
ctx.bezierCurveTo(x + 59.2673, y + 42.3363, x + 58.0724, y + 42.6183, x + 56.8775, y + 42.86);
ctx.lineTo(x + 56.7979, y + 42.4571);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 81.6914, y + 37.9053);
ctx.lineTo(x + 75.5576, y + 41.732);
ctx.lineTo(x + 81.2533, y + 37.2607);
ctx.lineTo(x + 81.6914, y + 37.9053);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#8CA7AF";

ctx.beginPath();
ctx.moveTo(x + 79.2612, y + 38.2275);
ctx.lineTo(x + 74.8799, y + 41.6515);
ctx.lineTo(x + 80.7349, y + 38.0261);
ctx.bezierCurveTo(x + 80.2171, y + 38.0664, x + 79.7391, y + 38.147, x + 79.2612, y + 38.2275);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 121.123, y + 39.5568);
ctx.bezierCurveTo(x + 120.525, y + 39.5971, x + 119.728, y + 39.5568, x + 118.693, y + 39.3151);
ctx.bezierCurveTo(x + 109.253, y + 37.3816, x + 94.7951, y + 36.7773, x + 85.5546, y + 37.6635);
ctx.bezierCurveTo(x + 76.3539, y + 38.5497, x + 72.4506, y + 39.2345, x + 66.9939, y + 40.5638);
ctx.lineTo(x + 64.166, y + 41.0875);
ctx.lineTo(x + 58.8288, y + 42.1751);
ctx.lineTo(x + 58.5898, y + 42.014);
ctx.bezierCurveTo(x + 64.5643, y + 40.0402, x + 70.8176, y + 38.59, x + 79.1818, y + 37.4621);
ctx.bezierCurveTo(x + 94.6357, y + 35.3675, x + 103.279, y + 36.1328, x + 117.14, y + 38.308);
ctx.bezierCurveTo(x + 118.295, y + 38.5094, x + 119.49, y + 38.6706, x + 120.724, y + 38.872);
ctx.bezierCurveTo(x + 120.844, y + 39.1137, x + 121.003, y + 39.3151, x + 121.123, y + 39.5568);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 52.4961, y + 63.4844);
ctx.bezierCurveTo(x + 52.6554, y + 63.8469, x + 52.8147, y + 64.2095, x + 52.9741, y + 64.5317);
ctx.bezierCurveTo(x + 53.1334, y + 64.854, x + 53.3325, y + 65.2165, x + 53.5317, y + 65.5388);
ctx.lineTo(x + 54.0893, y + 66.5458);
ctx.bezierCurveTo(x + 54.2884, y + 66.8681, x + 54.4477, y + 67.2306, x + 54.6071, y + 67.5931);
ctx.lineTo(x + 54.0495, y + 67.7945);
ctx.bezierCurveTo(x + 53.8105, y + 67.4723, x + 53.691, y + 67.2306, x + 53.4918, y + 66.8681);
ctx.bezierCurveTo(x + 53.2927, y + 66.5055, x + 53.1334, y + 66.1833, x + 53.0139, y + 65.7804);
ctx.bezierCurveTo(x + 52.8546, y + 65.4179, x + 52.7351, y + 65.0554, x + 52.6554, y + 64.6525);
ctx.bezierCurveTo(x + 52.5758, y + 64.29, x + 52.4961, y + 63.8872, x + 52.4961, y + 63.4844);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 50.7433, y + 68.882);
ctx.lineTo(x + 50.584, y + 68.7209);
ctx.bezierCurveTo(x + 52.7746, y + 68.1167, x + 55.2042, y + 67.1902, x + 55.2441, y + 67.1902);
ctx.lineTo(x + 55.2839, y + 67.3916);
ctx.bezierCurveTo(x + 55.2839, y + 67.3916, x + 52.9339, y + 68.2778, x + 50.7433, y + 68.882);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 48.0352, y + 64.0482);
ctx.bezierCurveTo(x + 48.8716, y + 63.8468, x + 49.6682, y + 63.6454, x + 50.5046, y + 63.4037);
ctx.bezierCurveTo(x + 51.3012, y + 63.162, x + 52.1376, y + 62.9203, x + 52.9342, y + 62.6384);
ctx.bezierCurveTo(x + 54.5274, y + 62.1147, x + 56.1206, y + 61.5105, x + 57.6739, y + 60.866);
ctx.bezierCurveTo(x + 56.9172, y + 61.2285, x + 56.1206, y + 61.591, x + 55.3638, y + 61.9133);
ctx.bezierCurveTo(x + 54.5672, y + 62.2356, x + 53.8105, y + 62.5981, x + 53.0139, y + 62.8801);
ctx.bezierCurveTo(x + 52.2173, y + 63.2023, x + 51.4207, y + 63.4843, x + 50.6241, y + 63.7663);
ctx.bezierCurveTo(x + 49.8275, y + 64.0482, x + 48.9911, y + 64.3302, x + 48.1945, y + 64.6122);
ctx.lineTo(x + 48.0352, y + 64.0482);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 126.54, y + 40.9265);
ctx.bezierCurveTo(x + 126.102, y + 39.9195, x + 125.584, y + 39.1139, x + 124.947, y + 38.4291);
ctx.bezierCurveTo(x + 124.309, y + 37.7443, x + 123.553, y + 37.1803, x + 122.756, y + 36.6969);
ctx.bezierCurveTo(x + 121.88, y + 36.2538, x + 121.004, y + 35.851, x + 120.087, y + 35.4482);
ctx.bezierCurveTo(x + 119.171, y + 35.0857, x + 118.215, y + 34.7634, x + 117.22, y + 34.3606);
ctx.bezierCurveTo(x + 118.255, y + 34.1189, x + 119.371, y + 34.1189, x + 120.406, y + 34.28);
ctx.bezierCurveTo(x + 121.482, y + 34.4411, x + 122.517, y + 34.8037, x + 123.473, y + 35.3676);
ctx.bezierCurveTo(x + 124.429, y + 35.9316, x + 125.305, y + 36.7372, x + 125.863, y + 37.704);
ctx.bezierCurveTo(x + 126.46, y + 38.711, x + 126.699, y + 39.8792, x + 126.54, y + 40.9265);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 128.969, y + 39.6778);
ctx.bezierCurveTo(x + 128.611, y + 38.8721, x + 128.292, y + 38.1068, x + 127.934, y + 37.3817);
ctx.bezierCurveTo(x + 127.575, y + 36.6566, x + 127.177, y + 35.9718, x + 126.659, y + 35.3676);
ctx.bezierCurveTo(x + 126.181, y + 34.7633, x + 125.624, y + 34.1994, x + 124.986, y + 33.6757);
ctx.bezierCurveTo(x + 124.349, y + 33.1521, x + 123.672, y + 32.709, x + 122.955, y + 32.2256);
ctx.bezierCurveTo(x + 123.831, y + 32.2659, x + 124.708, y + 32.5076, x + 125.504, y + 32.9104);
ctx.bezierCurveTo(x + 126.301, y + 33.3132, x + 127.018, y + 33.9174, x + 127.575, y + 34.6425);
ctx.bezierCurveTo(x + 128.133, y + 35.3676, x + 128.531, y + 36.2135, x + 128.77, y + 37.0594);
ctx.bezierCurveTo(x + 129.009, y + 37.9053, x + 129.089, y + 38.7915, x + 128.969, y + 39.6778);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 130.643, y + 36.6968);
ctx.bezierCurveTo(x + 130.643, y + 36.3746, x + 130.643, y + 36.0523, x + 130.563, y + 35.7703);
ctx.bezierCurveTo(x + 130.523, y + 35.4884, x + 130.444, y + 35.1661, x + 130.324, y + 34.8841);
ctx.bezierCurveTo(x + 130.125, y + 34.3202, x + 129.846, y + 33.7965, x + 129.488, y + 33.3131);
ctx.bezierCurveTo(x + 129.169, y + 32.8298, x + 128.771, y + 32.3464, x + 128.372, y + 31.863);
ctx.bezierCurveTo(x + 127.974, y + 31.3796, x + 127.536, y + 30.9365, x + 127.138, y + 30.4531);
ctx.bezierCurveTo(x + 127.735, y + 30.6948, x + 128.293, y + 31.0171, x + 128.811, y + 31.4199);
ctx.bezierCurveTo(x + 129.328, y + 31.8227, x + 129.766, y + 32.3061, x + 130.165, y + 32.87);
ctx.bezierCurveTo(x + 130.523, y + 33.434, x + 130.842, y + 34.0382, x + 130.922, y + 34.723);
ctx.bezierCurveTo(x + 130.961, y + 35.0453, x + 131.001, y + 35.4078, x + 130.961, y + 35.7301);
ctx.bezierCurveTo(x + 130.922, y + 36.0926, x + 130.802, y + 36.4149, x + 130.643, y + 36.6968);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 34.8115, y + 51.561);
ctx.bezierCurveTo(x + 34.8514, y + 50.3526, x + 35.2895, y + 49.1441, x + 35.9666, y + 48.0968);
ctx.bezierCurveTo(x + 36.6039, y + 47.0494, x + 37.5199, y + 46.1632, x + 38.4759, y + 45.4381);
ctx.bezierCurveTo(x + 39.4716, y + 44.7131, x + 40.547, y + 44.1491, x + 41.7021, y + 43.7866);
ctx.bezierCurveTo(x + 42.8571, y + 43.424, x + 44.052, y + 43.1824, x + 45.2469, y + 43.2226);
ctx.bezierCurveTo(x + 44.1317, y + 43.6657, x + 43.0563, y + 44.1088, x + 42.0605, y + 44.6325);
ctx.bezierCurveTo(x + 41.025, y + 45.1562, x + 40.069, y + 45.7201, x + 39.153, y + 46.4049);
ctx.bezierCurveTo(x + 38.2369, y + 47.0494, x + 37.4005, y + 47.8148, x + 36.6835, y + 48.6607);
ctx.bezierCurveTo(x + 35.9666, y + 49.5066, x + 35.3691, y + 50.4734, x + 34.8115, y + 51.561);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 37.281, y + 42.0947);
ctx.bezierCurveTo(x + 36.4446, y + 42.699, x + 35.7277, y + 43.3838, x + 35.1302, y + 44.1491);
ctx.bezierCurveTo(x + 34.5328, y + 44.9145, x + 34.015, y + 45.7201, x + 33.6565, y + 46.6063);
ctx.bezierCurveTo(x + 33.2582, y + 47.4925, x + 32.9794, y + 48.419, x + 32.7803, y + 49.3455);
ctx.bezierCurveTo(x + 32.5413, y + 50.3123, x + 32.4616, y + 51.3193, x + 32.382, y + 52.3666);
ctx.bezierCurveTo(x + 31.9837, y + 51.3999, x + 31.7845, y + 50.3122, x + 31.8243, y + 49.2649);
ctx.bezierCurveTo(x + 31.8642, y + 48.1773, x + 32.143, y + 47.13, x + 32.5811, y + 46.1229);
ctx.bezierCurveTo(x + 33.0192, y + 45.1562, x + 33.6565, y + 44.2297, x + 34.4531, y + 43.5046);
ctx.bezierCurveTo(x + 35.2497, y + 42.8198, x + 36.2454, y + 42.2961, x + 37.281, y + 42.0947);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 30.47, y + 43.9478);
ctx.bezierCurveTo(x + 30.1115, y + 44.5923, x + 29.7531, y + 45.2771, x + 29.5141, y + 45.9619);
ctx.bezierCurveTo(x + 29.4344, y + 46.123, x + 29.3946, y + 46.2841, x + 29.3149, y + 46.4855);
ctx.bezierCurveTo(x + 29.2751, y + 46.6466, x + 29.1954, y + 46.8481, x + 29.1556, y + 47.0092);
ctx.bezierCurveTo(x + 29.076, y + 47.3717, x + 28.9963, y + 47.694, x + 28.9166, y + 48.0565);
ctx.bezierCurveTo(x + 28.7971, y + 48.7816, x + 28.7573, y + 49.5067, x + 28.7573, y + 50.2317);
ctx.bezierCurveTo(x + 28.7573, y + 50.9568, x + 28.837, y + 51.6819, x + 28.9565, y + 52.4473);
ctx.bezierCurveTo(x + 28.598, y + 51.7625, x + 28.3988, y + 51.0374, x + 28.3192, y + 50.272);
ctx.bezierCurveTo(x + 28.2395, y + 49.5067, x + 28.2395, y + 48.7413, x + 28.359, y + 47.976);
ctx.bezierCurveTo(x + 28.4387, y + 47.6134, x + 28.5183, y + 47.2106, x + 28.6378, y + 46.8481);
ctx.bezierCurveTo(x + 28.6777, y + 46.6466, x + 28.7573, y + 46.4855, x + 28.837, y + 46.3244);
ctx.bezierCurveTo(x + 28.8768, y + 46.2438, x + 28.9166, y + 46.1633, x + 28.9565, y + 46.0424);
ctx.lineTo(x + 29.076, y + 45.8007);
ctx.bezierCurveTo(x + 29.4344, y + 45.0756, x + 29.9124, y + 44.4311, x + 30.47, y + 43.9478);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 107.66, y + 71.6616);
ctx.bezierCurveTo(x + 108.457, y + 71.2588, x + 109.333, y + 71.0977, x + 110.169, y + 71.0574);
ctx.bezierCurveTo(x + 111.046, y + 71.0171, x + 111.922, y + 71.0977, x + 112.758, y + 71.2588);
ctx.bezierCurveTo(x + 113.595, y + 71.4199, x + 114.431, y + 71.6616, x + 115.228, y + 71.9839);
ctx.bezierCurveTo(x + 116.024, y + 72.3061, x + 116.781, y + 72.7089, x + 117.498, y + 73.2326);
ctx.bezierCurveTo(x + 116.622, y + 73.1521, x + 115.785, y + 73.0312, x + 114.989, y + 72.8701);
ctx.bezierCurveTo(x + 114.152, y + 72.7089, x + 113.356, y + 72.5478, x + 112.559, y + 72.427);
ctx.bezierCurveTo(x + 111.763, y + 72.2658, x + 110.966, y + 72.145, x + 110.13, y + 71.9839);
ctx.bezierCurveTo(x + 109.373, y + 71.8227, x + 108.536, y + 71.7019, x + 107.66, y + 71.6616);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 107.621, y + 69.003);
ctx.bezierCurveTo(x + 108.378, y + 68.5197, x + 109.214, y + 68.1974, x + 110.091, y + 67.9154);
ctx.bezierCurveTo(x + 110.967, y + 67.6737, x + 111.843, y + 67.5126, x + 112.759, y + 67.4321);
ctx.bezierCurveTo(x + 113.675, y + 67.3515, x + 114.551, y + 67.3918, x + 115.468, y + 67.5126);
ctx.bezierCurveTo(x + 116.344, y + 67.6737, x + 117.26, y + 67.9154, x + 118.017, y + 68.3988);
ctx.bezierCurveTo(x + 117.14, y + 68.2377, x + 116.264, y + 68.1571, x + 115.388, y + 68.1571);
ctx.bezierCurveTo(x + 114.512, y + 68.1168, x + 113.675, y + 68.1571, x + 112.799, y + 68.2377);
ctx.bezierCurveTo(x + 111.923, y + 68.3183, x + 111.086, y + 68.3988, x + 110.21, y + 68.5599);
ctx.bezierCurveTo(x + 109.334, y + 68.6405, x + 108.497, y + 68.8419, x + 107.621, y + 69.003);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 105.151, y + 68.3182);
ctx.bezierCurveTo(x + 105.231, y + 67.7946, x + 105.43, y + 67.3515, x + 105.709, y + 66.9084);
ctx.bezierCurveTo(x + 105.988, y + 66.4653, x + 106.346, y + 66.1027, x + 106.705, y + 65.7805);
ctx.bezierCurveTo(x + 107.103, y + 65.4582, x + 107.501, y + 65.1763, x + 107.939, y + 64.9346);
ctx.bezierCurveTo(x + 108.378, y + 64.6929, x + 108.856, y + 64.4915, x + 109.333, y + 64.4109);
ctx.bezierCurveTo(x + 108.935, y + 64.7331, x + 108.577, y + 65.0151, x + 108.178, y + 65.3374);
ctx.bezierCurveTo(x + 107.78, y + 65.6193, x + 107.422, y + 65.9416, x + 107.063, y + 66.2639);
ctx.bezierCurveTo(x + 106.705, y + 66.5861, x + 106.346, y + 66.9084, x + 106.028, y + 67.2306);
ctx.bezierCurveTo(x + 105.749, y + 67.5126, x + 105.47, y + 67.9154, x + 105.151, y + 68.3182);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 110.011, y + 74.4411);
ctx.bezierCurveTo(x + 110.688, y + 74.3605, x + 111.405, y + 74.5619, x + 112.002, y + 74.9648);
ctx.bezierCurveTo(x + 112.281, y + 75.1662, x + 112.56, y + 75.4079, x + 112.759, y + 75.7301);
ctx.bezierCurveTo(x + 112.958, y + 76.0121, x + 113.117, y + 76.3746, x + 113.117, y + 76.6969);
ctx.bezierCurveTo(x + 112.958, y + 76.3746, x + 112.759, y + 76.1329, x + 112.52, y + 75.8912);
ctx.bezierCurveTo(x + 112.281, y + 75.6496, x + 112.042, y + 75.4481, x + 111.763, y + 75.287);
ctx.bezierCurveTo(x + 111.484, y + 75.0856, x + 111.245, y + 74.9245, x + 110.927, y + 74.8036);
ctx.bezierCurveTo(x + 110.648, y + 74.6425, x + 110.369, y + 74.5619, x + 110.011, y + 74.4411);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 52.7348, y + 33.5548);
ctx.bezierCurveTo(x + 53.4119, y + 34.1591, x + 54.089, y + 34.8036, x + 54.7661, y + 35.4078);
ctx.bezierCurveTo(x + 54.9652, y + 35.6092, x + 55.0449, y + 35.7301, x + 55.0847, y + 35.8509);
ctx.bezierCurveTo(x + 55.0847, y + 35.9717, x + 55.0051, y + 36.0926, x + 54.7661, y + 36.2134);
ctx.bezierCurveTo(x + 54.4873, y + 36.3343, x + 54.2483, y + 36.4551, x + 54.089, y + 36.576);
ctx.bezierCurveTo(x + 53.8898, y + 36.6968, x + 53.6509, y + 36.7774, x + 53.4119, y + 36.8177);
ctx.bezierCurveTo(x + 53.1331, y + 36.858, x + 52.8543, y + 36.8177, x + 52.5755, y + 36.7371);
ctx.bezierCurveTo(x + 52.2966, y + 36.6565, x + 51.978, y + 36.4551, x + 51.6195, y + 36.2134);
ctx.bezierCurveTo(x + 51.3407, y + 36.012, x + 50.9026, y + 35.6898, x + 50.345, y + 35.287);
ctx.bezierCurveTo(x + 49.7874, y + 34.8841, x + 49.1501, y + 34.441, x + 48.4332, y + 33.9174);
ctx.bezierCurveTo(x + 47.7162, y + 33.3937, x + 46.9993, y + 32.87, x + 46.2027, y + 32.2658);
ctx.bezierCurveTo(x + 45.4061, y + 31.6616, x + 44.6095, y + 31.0573, x + 43.8527, y + 30.4531);
ctx.bezierCurveTo(x + 43.096, y + 29.8489, x + 42.3392, y + 29.2447, x + 41.6223, y + 28.6807);
ctx.bezierCurveTo(x + 40.9053, y + 28.0765, x + 40.3079, y + 27.5528, x + 39.7901, y + 27.0694);
ctx.bezierCurveTo(x + 39.2325, y + 26.586, x + 38.8342, y + 26.1429, x + 38.5554, y + 25.7804);
ctx.bezierCurveTo(x + 38.2766, y + 25.3776, x + 38.1571, y + 25.0956, x + 38.1969, y + 24.9345);
ctx.bezierCurveTo(x + 38.4757, y + 24.1288, x + 38.8342, y + 23.2829, x + 39.2325, y + 22.437);
ctx.bezierCurveTo(x + 39.6308, y + 21.5911, x + 40.1884, y + 20.8257, x + 40.8257, y + 20.1812);
ctx.bezierCurveTo(x + 41.463, y + 19.5367, x + 42.1799, y + 19.013, x + 43.0163, y + 18.6102);
ctx.bezierCurveTo(x + 43.8527, y + 18.2477, x + 44.7688, y + 18.0866, x + 45.7646, y + 18.2074);
ctx.bezierCurveTo(x + 46.601, y + 18.3282, x + 47.4374, y + 18.4894, x + 48.234, y + 18.7311);
ctx.bezierCurveTo(x + 49.0306, y + 18.9728, x + 49.8272, y + 19.3756, x + 50.6636, y + 19.8992);
ctx.bezierCurveTo(x + 51.5001, y + 20.5035, x + 52.0178, y + 21.1077, x + 52.2568, y + 21.7119);
ctx.bezierCurveTo(x + 52.6153, y + 22.6787, x + 52.7348, y + 23.7663, x + 52.6551, y + 24.9345);
ctx.bezierCurveTo(x + 52.5755, y + 26.1027, x + 52.3365, y + 27.3514, x + 52.0178, y + 28.6807);
ctx.bezierCurveTo(x + 52.5356, y + 28.7613, x + 53.0932, y + 28.8418, x + 53.6509, y + 28.9627);
ctx.bezierCurveTo(x + 54.2085, y + 29.0433, x + 54.8059, y + 29.1641, x + 55.3635, y + 29.2447);
ctx.bezierCurveTo(x + 55.9212, y + 29.3252, x + 56.4788, y + 29.4058, x + 56.9966, y + 29.4864);
ctx.bezierCurveTo(x + 57.5143, y + 29.5669, x + 57.9923, y + 29.6072, x + 58.3906, y + 29.6475);
ctx.bezierCurveTo(x + 58.7092, y + 29.6878, x + 58.9482, y + 29.7683, x + 59.0279, y + 29.8892);
ctx.bezierCurveTo(x + 59.1075, y + 30.01, x + 59.1872, y + 30.1711, x + 59.1872, y + 30.3726);
ctx.bezierCurveTo(x + 59.227, y + 30.6545, x + 59.1872, y + 30.8157, x + 59.1474, y + 30.9365);
ctx.bezierCurveTo(x + 59.1075, y + 31.0573, x + 59.0279, y + 31.1782, x + 58.9084, y + 31.3393);
ctx.bezierCurveTo(x + 58.8287, y + 31.5407, x + 58.6694, y + 31.7421, x + 58.4703, y + 31.9033);
ctx.bezierCurveTo(x + 58.3109, y + 32.1047, x + 57.9525, y + 32.1852, x + 57.4347, y + 32.2255);
ctx.bezierCurveTo(x + 57.0762, y + 32.2255, x + 56.6381, y + 32.2255, x + 56.1203, y + 32.1852);
ctx.bezierCurveTo(x + 55.6025, y + 32.145, x + 55.0449, y + 32.1047, x + 54.4475, y + 32.0644);
ctx.bezierCurveTo(x + 53.85, y + 32.0241, x + 53.2127, y + 31.9436, x + 52.5356, y + 31.863);
ctx.bezierCurveTo(x + 51.8585, y + 31.7824, x + 51.2212, y + 31.7019, x + 50.584, y + 31.581);
ctx.bezierCurveTo(x + 51.3407, y + 32.2658, x + 52.0577, y + 32.9506, x + 52.7348, y + 33.5548);
ctx.closePath();
ctx.moveTo(x + 45.7247, y + 26.3444);
ctx.bezierCurveTo(x + 46.3222, y + 27.0292, x + 46.9993, y + 27.7945, x + 47.7162, y + 28.5599);
ctx.bezierCurveTo(x + 48.0349, y + 27.7945, x + 48.234, y + 27.0292, x + 48.3137, y + 26.3041);
ctx.bezierCurveTo(x + 48.3933, y + 25.5387, x + 48.4332, y + 24.8539, x + 48.3535, y + 24.2497);
ctx.bezierCurveTo(x + 48.3137, y + 23.6052, x + 48.1942, y + 23.0815, x + 47.995, y + 22.6384);
ctx.bezierCurveTo(x + 47.7959, y + 22.1953, x + 47.5569, y + 21.9133, x + 47.2781, y + 21.7925);
ctx.bezierCurveTo(x + 46.84, y + 21.5911, x + 46.2824, y + 21.7522, x + 45.6451, y + 22.1953);
ctx.bezierCurveTo(x + 45.3264, y + 22.437, x + 45.0078, y + 22.719, x + 44.729, y + 23.0815);
ctx.bezierCurveTo(x + 44.4502, y + 23.4441, x + 44.2112, y + 23.8469, x + 44.0519, y + 24.3705);
ctx.bezierCurveTo(x + 44.5697, y + 25.0151, x + 45.0875, y + 25.6596, x + 45.7247, y + 26.3444);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 54.4876, y + 14.3);
ctx.bezierCurveTo(x + 54.6867, y + 14.4209, x + 54.846, y + 14.6223, x + 55.0054, y + 14.9848);
ctx.bezierCurveTo(x + 55.2443, y + 15.5488, x + 55.4833, y + 16.2336, x + 55.802, y + 16.9587);
ctx.bezierCurveTo(x + 56.1206, y + 17.6837, x + 56.4791, y + 18.4491, x + 56.8774, y + 19.2547);
ctx.bezierCurveTo(x + 57.2757, y + 20.0604, x + 57.7138, y + 20.866, x + 58.1917, y + 21.7119);
ctx.bezierCurveTo(x + 58.6697, y + 22.5578, x + 59.1078, y + 23.3635, x + 59.5858, y + 24.1288);
ctx.bezierCurveTo(x + 60.0637, y + 24.9345, x + 60.5019, y + 25.6596, x + 60.9798, y + 26.3444);
ctx.bezierCurveTo(x + 61.418, y + 27.0291, x + 61.8162, y + 27.6334, x + 62.2145, y + 28.1973);
ctx.bezierCurveTo(x + 62.334, y + 28.3987, x + 62.4137, y + 28.5599, x + 62.3739, y + 28.6807);
ctx.bezierCurveTo(x + 62.3739, y + 28.8016, x + 62.2145, y + 28.8821, x + 61.9756, y + 29.003);
ctx.bezierCurveTo(x + 61.7366, y + 29.0835, x + 61.4578, y + 29.1641, x + 61.2188, y + 29.2447);
ctx.bezierCurveTo(x + 60.9798, y + 29.3252, x + 60.7408, y + 29.3655, x + 60.462, y + 29.4058);
ctx.bezierCurveTo(x + 60.1832, y + 29.4461, x + 59.9442, y + 29.4058, x + 59.7053, y + 29.3252);
ctx.bezierCurveTo(x + 59.5061, y + 29.2447, x + 59.2671, y + 29.0432, x + 58.9883, y + 28.721);
ctx.bezierCurveTo(x + 58.6299, y + 28.3585, x + 58.1917, y + 27.8348, x + 57.6341, y + 27.2306);
ctx.bezierCurveTo(x + 57.1163, y + 26.6263, x + 56.5189, y + 25.9013, x + 55.9214, y + 25.1762);
ctx.bezierCurveTo(x + 55.324, y + 24.4108, x + 54.6867, y + 23.6052, x + 54.0494, y + 22.7593);
ctx.bezierCurveTo(x + 53.4122, y + 21.9133, x + 52.8147, y + 21.0674, x + 52.2173, y + 20.2618);
ctx.bezierCurveTo(x + 51.6198, y + 19.4561, x + 51.102, y + 18.6505, x + 50.6241, y + 17.8851);
ctx.bezierCurveTo(x + 50.1461, y + 17.1198, x + 49.7478, y + 16.4753, x + 49.3894, y + 15.871);
ctx.bezierCurveTo(x + 49.23, y + 15.5085, x + 49.1902, y + 15.2265, x + 49.3097, y + 15.0251);
ctx.bezierCurveTo(x + 49.4292, y + 14.8237, x + 49.7478, y + 14.7029, x + 50.2258, y + 14.5417);
ctx.bezierCurveTo(x + 50.7038, y + 14.4209, x + 51.2215, y + 14.3, x + 51.819, y + 14.2195);
ctx.bezierCurveTo(x + 52.4164, y + 14.1389, x + 52.9342, y + 14.0986, x + 53.452, y + 14.0986);
ctx.bezierCurveTo(x + 53.93, y + 14.0986, x + 54.2884, y + 14.1792, x + 54.4876, y + 14.3);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 64.5245, y + 12.8902);
ctx.bezierCurveTo(x + 64.1262, y + 11.3192, x + 63.8075, y + 9.86906, x + 63.6084, y + 8.49947);
ctx.bezierCurveTo(x + 63.5686, y + 8.13693, x + 63.6084, y + 7.85496, x + 63.8075, y + 7.69383);
ctx.bezierCurveTo(x + 64.0067, y + 7.5327, x + 64.3253, y + 7.41186, x + 64.7634, y + 7.29101);
ctx.bezierCurveTo(x + 64.9626, y + 7.25073, x + 65.1617, y + 7.21045, x + 65.3609, y + 7.17016);
ctx.bezierCurveTo(x + 65.5202, y + 7.12988, x + 65.7194, y + 7.12988, x + 65.8787, y + 7.12988);
ctx.bezierCurveTo(x + 66.038, y + 7.12988, x + 66.2371, y + 7.12988, x + 66.4363, y + 7.12988);
ctx.bezierCurveTo(x + 66.6354, y + 7.12988, x + 66.8744, y + 7.17016, x + 67.1532, y + 7.21045);
ctx.bezierCurveTo(x + 67.5914, y + 7.25073, x + 67.91, y + 7.37157, x + 68.0295, y + 7.57298);
ctx.bezierCurveTo(x + 68.149, y + 7.77439, x + 68.2286, y + 8.01609, x + 68.2286, y + 8.33834);
ctx.bezierCurveTo(x + 68.2685, y + 9.26483, x + 68.3481, y + 10.3122, x + 68.4676, y + 11.5206);
ctx.bezierCurveTo(x + 68.5871, y + 12.6888, x + 68.7862, y + 13.8973, x + 68.9854, y + 15.1057);
ctx.bezierCurveTo(x + 69.1845, y + 16.3142, x + 69.4235, y + 17.4824, x + 69.7023, y + 18.6505);
ctx.bezierCurveTo(x + 69.9811, y + 19.7784, x + 70.2201, y + 20.7855, x + 70.4591, y + 21.6717);
ctx.bezierCurveTo(x + 70.6184, y + 22.1148, x + 70.4591, y + 22.437, x + 69.9413, y + 22.5982);
ctx.bezierCurveTo(x + 69.5032, y + 22.7593, x + 69.0651, y + 22.8801, x + 68.5871, y + 22.9607);
ctx.bezierCurveTo(x + 68.149, y + 22.9607, x + 67.7108, y + 22.7996, x + 67.2727, y + 22.437);
ctx.bezierCurveTo(x + 66.9541, y + 22.1953, x + 66.5956, y + 21.8731, x + 66.1973, y + 21.5105);
ctx.bezierCurveTo(x + 65.799, y + 21.148, x + 65.3609, y + 20.7452, x + 64.8829, y + 20.3021);
ctx.bezierCurveTo(x + 64.405, y + 19.859, x + 63.927, y + 19.4159, x + 63.4092, y + 18.9325);
ctx.bezierCurveTo(x + 62.8914, y + 18.4491, x + 62.3737, y + 17.9657, x + 61.8559, y + 17.4824);
ctx.bezierCurveTo(x + 62.2143, y + 18.2477, x + 62.533, y + 18.9728, x + 62.8914, y + 19.7381);
ctx.bezierCurveTo(x + 63.2499, y + 20.5035, x + 63.5686, y + 21.1883, x + 63.927, y + 21.8731);
ctx.bezierCurveTo(x + 64.2457, y + 22.5579, x + 64.5643, y + 23.2024, x + 64.8829, y + 23.7663);
ctx.bezierCurveTo(x + 65.2016, y + 24.3303, x + 65.4405, y + 24.854, x + 65.6795, y + 25.2568);
ctx.bezierCurveTo(x + 65.799, y + 25.4582, x + 65.799, y + 25.6193, x + 65.799, y + 25.7402);
ctx.bezierCurveTo(x + 65.799, y + 25.861, x + 65.6397, y + 25.9416, x + 65.3609, y + 26.0221);
ctx.bezierCurveTo(x + 65.1219, y + 26.1027, x + 64.8829, y + 26.1833, x + 64.644, y + 26.2638);
ctx.bezierCurveTo(x + 64.405, y + 26.3444, x + 64.1262, y + 26.3847, x + 63.8474, y + 26.3847);
ctx.bezierCurveTo(x + 63.5686, y + 26.3847, x + 63.3694, y + 26.3444, x + 63.1703, y + 26.2638);
ctx.bezierCurveTo(x + 62.9711, y + 26.143, x + 62.772, y + 25.9416, x + 62.5728, y + 25.6596);
ctx.bezierCurveTo(x + 62.3338, y + 25.3373, x + 62.055, y + 24.9345, x + 61.6567, y + 24.3706);
ctx.bezierCurveTo(x + 61.2584, y + 23.8066, x + 60.8203, y + 23.1621, x + 60.3423, y + 22.437);
ctx.bezierCurveTo(x + 59.8644, y + 21.712, x + 59.3466, y + 20.9063, x + 58.8288, y + 20.0604);
ctx.bezierCurveTo(x + 58.311, y + 19.2145, x + 57.7932, y + 18.3686, x + 57.2755, y + 17.5226);
ctx.bezierCurveTo(x + 56.7975, y + 16.6767, x + 56.3195, y + 15.8308, x + 55.8814, y + 15.0654);
ctx.bezierCurveTo(x + 55.4433, y + 14.2598, x + 55.0848, y + 13.5347, x + 54.806, y + 12.8902);
ctx.bezierCurveTo(x + 54.6467, y + 12.5277, x + 54.6467, y + 12.2457, x + 54.806, y + 12.0443);
ctx.bezierCurveTo(x + 54.9653, y + 11.7623, x + 55.284, y + 11.6012, x + 55.7619, y + 11.4803);
ctx.bezierCurveTo(x + 56.3195, y + 11.3595, x + 56.8772, y + 11.2386, x + 57.3949, y + 11.1581);
ctx.bezierCurveTo(x + 57.9127, y + 11.0372, x + 58.4703, y + 10.997, x + 59.1076, y + 10.9567);
ctx.bezierCurveTo(x + 59.5856, y + 10.9164, x + 59.9839, y + 10.9567, x + 60.2627, y + 11.0775);
ctx.bezierCurveTo(x + 60.5415, y + 11.1984, x + 60.8601, y + 11.4803, x + 61.1788, y + 11.8429);
ctx.bezierCurveTo(x + 61.4177, y + 12.1248, x + 61.7364, y + 12.4874, x + 62.1347, y + 12.9305);
ctx.bezierCurveTo(x + 62.533, y + 13.3736, x + 62.9313, y + 13.857, x + 63.3694, y + 14.3806);
ctx.bezierCurveTo(x + 63.8075, y + 14.9043, x + 64.2855, y + 15.428, x + 64.7236, y + 15.9919);
ctx.bezierCurveTo(x + 65.2016, y + 16.5559, x + 65.6397, y + 17.0795, x + 66.038, y + 17.5629);
ctx.bezierCurveTo(x + 65.4406, y + 16.0322, x + 64.9228, y + 14.4612, x + 64.5245, y + 12.8902);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 79.6199, y + 9.1037);
ctx.bezierCurveTo(x + 79.5004, y + 9.22455, x + 79.3411, y + 9.30511, x + 79.0224, y + 9.38568);
ctx.bezierCurveTo(x + 78.2258, y + 9.54681, x + 77.5886, y + 9.54681, x + 77.1903, y + 9.3454);
ctx.bezierCurveTo(x + 76.7521, y + 9.14399, x + 76.4733, y + 8.78145, x + 76.314, y + 8.2175);
ctx.bezierCurveTo(x + 76.2742, y + 8.09666, x + 76.2343, y + 8.01609, x + 76.1945, y + 7.89525);
ctx.bezierCurveTo(x + 76.1547, y + 7.7744, x + 76.1547, y + 7.69384, x + 76.1547, y + 7.57299);
ctx.bezierCurveTo(x + 76.1149, y + 7.45214, x + 76.1149, y + 7.3313, x + 76.075, y + 7.25073);
ctx.bezierCurveTo(x + 76.0352, y + 7.12989, x + 75.9954, y + 7.04932, x + 75.9954, y + 6.92848);
ctx.bezierCurveTo(x + 75.9157, y + 6.72707, x + 75.8361, y + 6.56594, x + 75.7564, y + 6.44509);
ctx.bezierCurveTo(x + 75.6767, y + 6.28397, x + 75.5572, y + 6.24368, x + 75.4378, y + 6.24368);
ctx.bezierCurveTo(x + 75.1589, y + 6.24368, x + 74.8801, y + 6.44509, x + 74.6013, y + 6.80763);
ctx.bezierCurveTo(x + 74.3225, y + 7.17017, x + 74.0437, y + 7.65355, x + 73.8047, y + 8.25778);
ctx.bezierCurveTo(x + 73.5658, y + 8.86201, x + 73.3666, y + 9.50652, x + 73.2471, y + 10.2719);
ctx.bezierCurveTo(x + 73.0878, y + 10.997, x + 73.0081, y + 11.7623, x + 73.0081, y + 12.5277);
ctx.bezierCurveTo(x + 72.9683, y + 13.1319, x + 73.0081, y + 13.7361, x + 73.1276, y + 14.3404);
ctx.bezierCurveTo(x + 73.2073, y + 14.9446, x + 73.3666, y + 15.4683, x + 73.5259, y + 15.9516);
ctx.bezierCurveTo(x + 73.6852, y + 16.435, x + 73.8844, y + 16.7976, x + 74.0835, y + 17.0795);
ctx.bezierCurveTo(x + 74.2827, y + 17.3615, x + 74.5217, y + 17.4824, x + 74.7208, y + 17.4824);
ctx.bezierCurveTo(x + 74.92, y + 17.4421, x + 75.0793, y + 17.3615, x + 75.2386, y + 17.1601);
ctx.bezierCurveTo(x + 75.3979, y + 16.9587, x + 75.5174, y + 16.717, x + 75.6369, y + 16.3947);
ctx.bezierCurveTo(x + 75.7564, y + 16.0725, x + 75.8759, y + 15.7502, x + 75.9555, y + 15.3474);
ctx.bezierCurveTo(x + 76.075, y + 14.9446, x + 76.1547, y + 14.5418, x + 76.2343, y + 14.0987);
ctx.bezierCurveTo(x + 75.6369, y + 14.4209, x + 75.1589, y + 14.5015, x + 74.7606, y + 14.3806);
ctx.bezierCurveTo(x + 74.3624, y + 14.2598, x + 73.964, y + 13.9375, x + 73.6056, y + 13.4139);
ctx.bezierCurveTo(x + 73.5259, y + 13.293, x + 73.4861, y + 13.1722, x + 73.5259, y + 13.0513);
ctx.bezierCurveTo(x + 73.5658, y + 12.9305, x + 73.6056, y + 12.8499, x + 73.7251, y + 12.7291);
ctx.bezierCurveTo(x + 73.8446, y + 12.6082, x + 73.9641, y + 12.5277, x + 74.1234, y + 12.4068);
ctx.bezierCurveTo(x + 74.2827, y + 12.286, x + 74.4818, y + 12.2054, x + 74.681, y + 12.0846);
ctx.bezierCurveTo(x + 75.0793, y + 11.8429, x + 75.4776, y + 11.6012, x + 75.8759, y + 11.3595);
ctx.bezierCurveTo(x + 76.314, y + 11.1178, x + 76.6725, y + 10.9164, x + 76.9911, y + 10.7553);
ctx.bezierCurveTo(x + 77.3496, y + 10.5539, x + 77.6682, y + 10.433, x + 77.9072, y + 10.433);
ctx.bezierCurveTo(x + 78.1462, y + 10.3927, x + 78.3852, y + 10.4733, x + 78.6241, y + 10.5941);
ctx.bezierCurveTo(x + 78.7834, y + 10.6747, x + 78.9029, y + 10.7955, x + 79.0623, y + 10.9164);
ctx.bezierCurveTo(x + 79.1817, y + 11.0372, x + 79.3012, y + 11.1178, x + 79.4207, y + 11.2386);
ctx.bezierCurveTo(x + 79.6199, y + 11.4401, x + 79.7394, y + 11.6012, x + 79.7792, y + 11.8026);
ctx.bezierCurveTo(x + 79.819, y + 12.004, x + 79.7792, y + 12.2457, x + 79.6995, y + 12.568);
ctx.bezierCurveTo(x + 79.4207, y + 13.6958, x + 79.1021, y + 14.7029, x + 78.7436, y + 15.5891);
ctx.bezierCurveTo(x + 78.3852, y + 16.4753, x + 78.0267, y + 17.2004, x + 77.5886, y + 17.8449);
ctx.bezierCurveTo(x + 77.3097, y + 18.2477, x + 77.0309, y + 18.57, x + 76.7123, y + 18.8117);
ctx.bezierCurveTo(x + 76.3937, y + 19.0534, x + 76.0352, y + 19.2548, x + 75.6369, y + 19.4159);
ctx.bezierCurveTo(x + 74.9598, y + 19.6576, x + 74.2827, y + 19.8187, x + 73.5259, y + 19.8187);
ctx.bezierCurveTo(x + 73.2471, y + 19.7784, x + 72.9683, y + 19.6979, x + 72.6497, y + 19.577);
ctx.bezierCurveTo(x + 72.331, y + 19.4562, x + 72.0522, y + 19.2548, x + 71.8132, y + 19.0131);
ctx.bezierCurveTo(x + 71.3751, y + 18.6505, x + 70.9768, y + 18.1671, x + 70.5785, y + 17.5226);
ctx.bezierCurveTo(x + 70.1802, y + 16.8378, x + 69.8616, y + 16.1128, x + 69.5828, y + 15.3474);
ctx.bezierCurveTo(x + 69.304, y + 14.5821, x + 69.1048, y + 13.7361, x + 69.0252, y + 12.8499);
ctx.bezierCurveTo(x + 68.9057, y + 11.9637, x + 68.9057, y + 11.0775, x + 69.0252, y + 10.1913);
ctx.bezierCurveTo(x + 69.1447, y + 9.30511, x + 69.3438, y + 8.41891, x + 69.7023, y + 7.53271);
ctx.bezierCurveTo(x + 70.0607, y + 6.68679, x + 70.5387, y + 5.88115, x + 71.176, y + 5.15607);
ctx.bezierCurveTo(x + 71.3751, y + 4.91438, x + 71.6141, y + 4.71297, x + 71.8531, y + 4.51156);
ctx.bezierCurveTo(x + 72.1319, y + 4.31015, x + 72.3709, y + 4.1893, x + 72.6895, y + 4.02818);
ctx.bezierCurveTo(x + 72.9683, y + 3.90733, x + 73.2471, y + 3.78648, x + 73.5658, y + 3.70592);
ctx.bezierCurveTo(x + 73.8446, y + 3.62536, x + 74.1234, y + 3.54479, x + 74.3623, y + 3.50451);
ctx.bezierCurveTo(x + 74.7208, y + 3.42395, x + 75.1191, y + 3.38366, x + 75.4776, y + 3.34338);
ctx.bezierCurveTo(x + 75.8759, y + 3.3031, x + 76.2343, y + 3.3031, x + 76.5928, y + 3.3031);
ctx.bezierCurveTo(x + 76.9513, y + 3.3031, x + 77.3097, y + 3.34338, x + 77.6284, y + 3.38366);
ctx.bezierCurveTo(x + 77.947, y + 3.42395, x + 78.2258, y + 3.50451, x + 78.5046, y + 3.58507);
ctx.bezierCurveTo(x + 78.9826, y + 3.7462, x + 79.3411, y + 3.98789, x + 79.5402, y + 4.26987);
ctx.bezierCurveTo(x + 79.7394, y + 4.55184, x + 79.8987, y + 4.91438, x + 79.9783, y + 5.35748);
ctx.bezierCurveTo(x + 80.0182, y + 5.59917, x + 80.0182, y + 5.84086, x + 80.0182, y + 6.12284);
ctx.bezierCurveTo(x + 80.0182, y + 6.40481, x + 80.0182, y + 6.68679, x + 80.0182, y + 6.96876);
ctx.bezierCurveTo(x + 80.0182, y + 7.25073, x + 79.9783, y + 7.53271, x + 79.9783, y + 7.81468);
ctx.bezierCurveTo(x + 79.9385, y + 8.09666, x + 79.9385, y + 8.33835, x + 79.8987, y + 8.49948);
ctx.bezierCurveTo(x + 79.819, y + 8.78145, x + 79.7394, y + 8.98286, x + 79.6199, y + 9.1037);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 80.815, y + 14.4612);
ctx.bezierCurveTo(x + 80.8947, y + 14.2195, x + 81.0142, y + 13.9778, x + 81.1735, y + 13.7764);
ctx.bezierCurveTo(x + 81.3328, y + 13.575, x + 81.5319, y + 13.4139, x + 81.8108, y + 13.2528);
ctx.bezierCurveTo(x + 82.0497, y + 13.1319, x + 82.3285, y + 13.0514, x + 82.6472, y + 13.0111);
ctx.bezierCurveTo(x + 82.926, y + 12.9708, x + 83.1251, y + 13.0111, x + 83.2845, y + 13.0916);
ctx.bezierCurveTo(x + 83.4836, y + 13.1722, x + 83.6031, y + 13.293, x + 83.6429, y + 13.4139);
ctx.bezierCurveTo(x + 83.7226, y + 13.575, x + 83.7226, y + 13.6959, x + 83.7226, y + 13.8973);
ctx.bezierCurveTo(x + 83.7226, y + 14.0584, x + 83.6828, y + 14.2195, x + 83.6429, y + 14.3807);
ctx.bezierCurveTo(x + 83.6031, y + 14.5015, x + 83.5633, y + 14.6224, x + 83.4836, y + 14.7835);
ctx.bezierCurveTo(x + 83.4039, y + 14.9446, x + 83.2844, y + 15.1057, x + 83.165, y + 15.2669);
ctx.bezierCurveTo(x + 83.0455, y + 15.428, x + 82.926, y + 15.5891, x + 82.7667, y + 15.7502);
ctx.bezierCurveTo(x + 82.6472, y + 15.8711, x + 82.448, y + 15.9919, x + 82.2887, y + 16.1128);
ctx.bezierCurveTo(x + 81.8904, y + 16.3142, x + 81.5319, y + 16.3545, x + 81.2133, y + 16.1934);
ctx.bezierCurveTo(x + 80.8947, y + 16.0322, x + 80.7354, y + 15.71, x + 80.7354, y + 15.1863);
ctx.bezierCurveTo(x + 80.7354, y + 14.9446, x + 80.7354, y + 14.7029, x + 80.815, y + 14.4612);
ctx.closePath();
ctx.moveTo(x + 88.4225, y + 0.845921);
ctx.bezierCurveTo(x + 88.5022, y + 1.00705, x + 88.4225, y + 1.24874, x + 88.2632, y + 1.571);
ctx.bezierCurveTo(x + 87.7852, y + 2.41692, x + 87.3073, y + 3.30312, x + 86.909, y + 4.18932);
ctx.bezierCurveTo(x + 86.4708, y + 5.07553, x + 86.0725, y + 5.96173, x + 85.7141, y + 6.80765);
ctx.bezierCurveTo(x + 85.3556, y + 7.69386, x + 85.037, y + 8.4995, x + 84.7582, y + 9.30513);
ctx.bezierCurveTo(x + 84.4793, y + 10.1108, x + 84.2404, y + 10.8761, x + 84.081, y + 11.5609);
ctx.bezierCurveTo(x + 84.0014, y + 11.8026, x + 83.9217, y + 11.9637, x + 83.8022, y + 12.0443);
ctx.bezierCurveTo(x + 83.6828, y + 12.1249, x + 83.5234, y + 12.2054, x + 83.2845, y + 12.2054);
ctx.bezierCurveTo(x + 83.0056, y + 12.2457, x + 82.7667, y + 12.286, x + 82.5277, y + 12.286);
ctx.bezierCurveTo(x + 82.2887, y + 12.286, x + 82.0497, y + 12.286, x + 81.8506, y + 12.2457);
ctx.bezierCurveTo(x + 81.6116, y + 12.2054, x + 81.4523, y + 12.1249, x + 81.3726, y + 12.004);
ctx.bezierCurveTo(x + 81.2531, y + 11.9235, x + 81.2531, y + 11.6818, x + 81.293, y + 11.3595);
ctx.bezierCurveTo(x + 81.3726, y + 10.715, x + 81.4523, y + 9.90936, x + 81.6116, y + 9.02316);
ctx.bezierCurveTo(x + 81.7709, y + 8.13696, x + 81.9302, y + 7.17019, x + 82.1692, y + 6.2437);
ctx.bezierCurveTo(x + 82.3684, y + 5.27694, x + 82.6073, y + 4.35045, x + 82.8862, y + 3.38369);
ctx.bezierCurveTo(x + 83.165, y + 2.4572, x + 83.4039, y + 1.61128, x + 83.6828, y + 0.886203);
ctx.bezierCurveTo(x + 83.8022, y + 0.523666, x + 84.0014, y + 0.281974, x + 84.2005, y + 0.161128);
ctx.bezierCurveTo(x + 84.3997, y + 0.040282, x + 84.7582, y + 0, x + 85.1963, y + 0);
ctx.bezierCurveTo(x + 85.6344, y + 0, x + 86.0725, y + 0.040282, x + 86.5505, y + 0.0805639);
ctx.bezierCurveTo(x + 87.0284, y + 0.161128, x + 87.4666, y + 0.241692, x + 87.7852, y + 0.362538);
ctx.bezierCurveTo(x + 88.1437, y + 0.523666, x + 88.3428, y + 0.644511, x + 88.4225, y + 0.845921);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 80.8946, y + 31.7826);
ctx.bezierCurveTo(x + 81.1336, y + 32.1048, x + 81.4124, y + 32.4271, x + 81.6514, y + 32.7493);
ctx.bezierCurveTo(x + 81.6912, y + 32.8299, x + 81.731, y + 32.9105, x + 81.6912, y + 32.9507);
ctx.bezierCurveTo(x + 81.6514, y + 32.991, x + 81.5319, y + 33.0313, x + 81.2929, y + 33.0716);
ctx.bezierCurveTo(x + 81.0141, y + 33.1119, x + 80.815, y + 33.1522, x + 80.6158, y + 33.1924);
ctx.bezierCurveTo(x + 80.4167, y + 33.2327, x + 80.2175, y + 33.273, x + 79.9785, y + 33.273);
ctx.bezierCurveTo(x + 79.7396, y + 33.273, x + 79.5404, y + 33.273, x + 79.3811, y + 33.2327);
ctx.bezierCurveTo(x + 79.2218, y + 33.1924, x + 79.0625, y + 33.1119, x + 78.9031, y + 32.991);
ctx.bezierCurveTo(x + 78.7836, y + 32.9105, x + 78.5845, y + 32.7493, x + 78.3455, y + 32.5479);
ctx.bezierCurveTo(x + 78.1065, y + 32.3465, x + 77.8277, y + 32.1451, x + 77.5489, y + 31.9034);
ctx.bezierCurveTo(x + 77.2701, y + 31.6617, x + 76.9515, y + 31.3797, x + 76.6328, y + 31.0978);
ctx.bezierCurveTo(x + 76.3142, y + 30.8561, x + 75.9956, y + 30.5338, x + 75.6769, y + 30.2519);
ctx.bezierCurveTo(x + 75.3583, y + 29.9296, x + 75.0795, y + 29.6476, x + 74.8007, y + 29.3254);
ctx.bezierCurveTo(x + 74.5219, y + 29.0031, x + 74.2829, y + 28.7211, x + 74.1236, y + 28.4794);
ctx.bezierCurveTo(x + 73.9244, y + 28.1975, x + 73.8049, y + 27.9558, x + 73.7651, y + 27.7141);
ctx.bezierCurveTo(x + 73.6854, y + 27.5127, x + 73.7253, y + 27.3113, x + 73.8049, y + 27.1904);
ctx.bezierCurveTo(x + 74.2431, y + 26.6265, x + 74.721, y + 26.0625, x + 75.2786, y + 25.418);
ctx.bezierCurveTo(x + 75.7964, y + 24.8138, x + 76.3939, y + 24.2498, x + 77.0311, y + 23.7262);
ctx.bezierCurveTo(x + 77.6684, y + 23.2025, x + 78.3455, y + 22.7997, x + 79.0226, y + 22.4774);
ctx.bezierCurveTo(x + 79.6997, y + 22.1552, x + 80.4167, y + 22.0343, x + 81.0938, y + 22.0746);
ctx.bezierCurveTo(x + 81.6514, y + 22.1552, x + 82.209, y + 22.276, x + 82.7268, y + 22.4372);
ctx.bezierCurveTo(x + 83.2446, y + 22.5983, x + 83.7225, y + 22.9205, x + 84.2005, y + 23.3234);
ctx.bezierCurveTo(x + 84.6386, y + 23.8067, x + 84.8378, y + 24.2498, x + 84.8378, y + 24.6929);
ctx.bezierCurveTo(x + 84.8378, y + 25.3777, x + 84.559, y + 26.1028, x + 84.081, y + 26.8682);
ctx.bezierCurveTo(x + 83.603, y + 27.6335, x + 83.0056, y + 28.3586, x + 82.2887, y + 29.124);
ctx.bezierCurveTo(x + 82.6471, y + 29.2045, x + 83.0454, y + 29.2851, x + 83.4437, y + 29.3657);
ctx.bezierCurveTo(x + 83.842, y + 29.4462, x + 84.2403, y + 29.5671, x + 84.6784, y + 29.6879);
ctx.bezierCurveTo(x + 85.0767, y + 29.8088, x + 85.475, y + 29.8893, x + 85.8733, y + 30.0102);
ctx.bezierCurveTo(x + 86.2716, y + 30.131, x + 86.5903, y + 30.2116, x + 86.9089, y + 30.2921);
ctx.bezierCurveTo(x + 87.1479, y + 30.3727, x + 87.3072, y + 30.4533, x + 87.347, y + 30.5338);
ctx.bezierCurveTo(x + 87.3869, y + 30.6144, x + 87.347, y + 30.695, x + 87.3072, y + 30.8158);
ctx.bezierCurveTo(x + 87.2275, y + 30.9769, x + 87.1479, y + 31.0575, x + 87.0682, y + 31.0978);
ctx.bezierCurveTo(x + 86.9886, y + 31.1381, x + 86.8691, y + 31.1783, x + 86.7496, y + 31.2589);
ctx.bezierCurveTo(x + 86.5903, y + 31.3395, x + 86.3911, y + 31.42, x + 86.192, y + 31.4603);
ctx.bezierCurveTo(x + 85.953, y + 31.5006, x + 85.6344, y + 31.5006, x + 85.2361, y + 31.4603);
ctx.bezierCurveTo(x + 84.9573, y + 31.42, x + 84.6386, y + 31.3395, x + 84.2403, y + 31.2992);
ctx.bezierCurveTo(x + 83.842, y + 31.2186, x + 83.4437, y + 31.1381, x + 83.0056, y + 31.0978);
ctx.bezierCurveTo(x + 82.5675, y + 31.0172, x + 82.0895, y + 30.9366, x + 81.6514, y + 30.8964);
ctx.bezierCurveTo(x + 81.1734, y + 30.8158, x + 80.7353, y + 30.7755, x + 80.2972, y + 30.695);
ctx.bezierCurveTo(x + 80.4167, y + 31.0978, x + 80.6556, y + 31.42, x + 80.8946, y + 31.7826);
ctx.closePath();
ctx.moveTo(x + 78.5048, y + 27.6738);
ctx.bezierCurveTo(x + 78.704, y + 28.0766, x + 78.9031, y + 28.5197, x + 79.1421, y + 29.0031);
ctx.bezierCurveTo(x + 79.6599, y + 28.56, x + 80.0582, y + 28.0766, x + 80.3768, y + 27.6335);
ctx.bezierCurveTo(x + 80.6955, y + 27.1501, x + 80.9345, y + 26.7473, x + 81.0938, y + 26.3042);
ctx.bezierCurveTo(x + 81.2531, y + 25.9014, x + 81.3327, y + 25.5389, x + 81.3327, y + 25.2569);
ctx.bezierCurveTo(x + 81.3327, y + 24.9749, x + 81.2531, y + 24.7735, x + 81.0938, y + 24.6929);
ctx.bezierCurveTo(x + 80.815, y + 24.5721, x + 80.3768, y + 24.6527, x + 79.7794, y + 25.0152);
ctx.bezierCurveTo(x + 79.5006, y + 25.1763, x + 79.1819, y + 25.3777, x + 78.8633, y + 25.6194);
ctx.bezierCurveTo(x + 78.5447, y + 25.8611, x + 78.2659, y + 26.1431, x + 77.9871, y + 26.5056);
ctx.bezierCurveTo(x + 78.1065, y + 26.8682, x + 78.3057, y + 27.271, x + 78.5048, y + 27.6738);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 88.6218, y + 19.1742);
ctx.bezierCurveTo(x + 88.7412, y + 19.295, x + 88.7811, y + 19.4964, x + 88.8209, y + 19.7784);
ctx.bezierCurveTo(x + 88.8209, y + 20.2618, x + 88.8607, y + 20.8257, x + 88.9006, y + 21.4299);
ctx.bezierCurveTo(x + 88.9404, y + 22.0342, x + 89.0201, y + 22.6787, x + 89.0997, y + 23.3232);
ctx.bezierCurveTo(x + 89.1794, y + 23.9677, x + 89.2989, y + 24.6122, x + 89.4183, y + 25.297);
ctx.bezierCurveTo(x + 89.5378, y + 25.9415, x + 89.6573, y + 26.586, x + 89.7768, y + 27.1903);
ctx.bezierCurveTo(x + 89.8963, y + 27.7945, x + 90.0158, y + 28.3584, x + 90.1751, y + 28.8821);
ctx.bezierCurveTo(x + 90.2946, y + 29.4058, x + 90.4141, y + 29.8892, x + 90.5336, y + 30.292);
ctx.bezierCurveTo(x + 90.5734, y + 30.4531, x + 90.5734, y + 30.5337, x + 90.4937, y + 30.6142);
ctx.bezierCurveTo(x + 90.4539, y + 30.6545, x + 90.2946, y + 30.6948, x + 90.0556, y + 30.6948);
ctx.bezierCurveTo(x + 89.8166, y + 30.6948, x + 89.5777, y + 30.6545, x + 89.3387, y + 30.6545);
ctx.bezierCurveTo(x + 89.0997, y + 30.6545, x + 88.9006, y + 30.6142, x + 88.6616, y + 30.5739);
ctx.bezierCurveTo(x + 88.4226, y + 30.5337, x + 88.2235, y + 30.4531, x + 88.104, y + 30.3725);
ctx.bezierCurveTo(x + 87.9845, y + 30.292, x + 87.865, y + 30.1308, x + 87.7455, y + 29.9294);
ctx.bezierCurveTo(x + 87.5862, y + 29.6475, x + 87.4269, y + 29.2849, x + 87.1879, y + 28.8418);
ctx.bezierCurveTo(x + 86.9887, y + 28.3987, x + 86.7498, y + 27.8751, x + 86.5506, y + 27.3514);
ctx.bezierCurveTo(x + 86.3116, y + 26.7874, x + 86.1125, y + 26.2235, x + 85.8735, y + 25.579);
ctx.bezierCurveTo(x + 85.6345, y + 24.9345, x + 85.4354, y + 24.3302, x + 85.2362, y + 23.6857);
ctx.bezierCurveTo(x + 85.0371, y + 23.0815, x + 84.8778, y + 22.4773, x + 84.7184, y + 21.873);
ctx.bezierCurveTo(x + 84.5591, y + 21.3091, x + 84.4795, y + 20.7854, x + 84.36, y + 20.302);
ctx.bezierCurveTo(x + 84.3201, y + 20.0201, x + 84.3998, y + 19.7784, x + 84.5193, y + 19.6575);
ctx.bezierCurveTo(x + 84.6786, y + 19.4964, x + 84.9176, y + 19.3756, x + 85.3159, y + 19.295);
ctx.bezierCurveTo(x + 85.7142, y + 19.1742, x + 86.1125, y + 19.0936, x + 86.5904, y + 19.0533);
ctx.bezierCurveTo(x + 87.0684, y + 19.013, x + 87.4667, y + 18.9727, x + 87.8252, y + 19.013);
ctx.bezierCurveTo(x + 88.2633, y + 19.013, x + 88.5023, y + 19.0936, x + 88.6218, y + 19.1742);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 96.9063, y + 19.1339);
ctx.bezierCurveTo(x + 96.986, y + 17.6032, x + 97.0656, y + 16.1127, x + 97.2249, y + 14.7431);
ctx.bezierCurveTo(x + 97.2648, y + 14.3806, x + 97.3842, y + 14.0986, x + 97.5834, y + 13.9778);
ctx.bezierCurveTo(x + 97.7825, y + 13.8166, x + 98.0614, y + 13.7361, x + 98.4596, y + 13.6958);
ctx.bezierCurveTo(x + 98.6588, y + 13.6958, x + 98.8181, y + 13.6555, x + 98.9376, y + 13.6555);
ctx.bezierCurveTo(x + 99.0969, y + 13.6555, x + 99.2164, y + 13.6555, x + 99.3757, y + 13.6555);
ctx.bezierCurveTo(x + 99.5351, y + 13.6555, x + 99.6545, y + 13.6958, x + 99.8139, y + 13.7361);
ctx.bezierCurveTo(x + 99.9732, y + 13.7764, x + 100.172, y + 13.8166, x + 100.371, y + 13.8972);
ctx.bezierCurveTo(x + 100.73, y + 14.0181, x + 100.929, y + 14.1792, x + 101.009, y + 14.4209);
ctx.bezierCurveTo(x + 101.049, y + 14.6223, x + 101.049, y + 14.9445, x + 101.009, y + 15.2668);
ctx.bezierCurveTo(x + 100.81, y + 16.2738, x + 100.61, y + 17.4017, x + 100.451, y + 18.6102);
ctx.bezierCurveTo(x + 100.292, y + 19.8187, x + 100.133, y + 21.0674, x + 100.013, y + 22.2759);
ctx.bezierCurveTo(x + 99.8935, y + 23.4843, x + 99.8139, y + 24.6928, x + 99.7342, y + 25.8207);
ctx.bezierCurveTo(x + 99.6545, y + 26.9486, x + 99.6147, y + 27.9153, x + 99.6147, y + 28.7613);
ctx.bezierCurveTo(x + 99.6147, y + 29.2044, x + 99.4156, y + 29.3655, x + 98.9376, y + 29.2849);
ctx.bezierCurveTo(x + 98.5393, y + 29.2044, x + 98.1012, y + 29.1238, x + 97.6631, y + 28.9627);
ctx.bezierCurveTo(x + 97.2648, y + 28.8015, x + 96.9063, y + 28.5196, x + 96.6275, y + 28.0765);
ctx.bezierCurveTo(x + 96.4283, y + 27.7542, x + 96.2292, y + 27.3917, x + 95.9902, y + 26.9888);
ctx.bezierCurveTo(x + 95.7512, y + 26.586, x + 95.5122, y + 26.1429, x + 95.2334, y + 25.6595);
ctx.bezierCurveTo(x + 94.9546, y + 25.1762, x + 94.6758, y + 24.6928, x + 94.397, y + 24.1691);
ctx.bezierCurveTo(x + 94.1182, y + 23.6857, x + 93.8394, y + 23.1621, x + 93.5208, y + 22.6787);
ctx.bezierCurveTo(x + 93.6004, y + 23.3635, x + 93.6801, y + 24.008, x + 93.7597, y + 24.6928);
ctx.bezierCurveTo(x + 93.8394, y + 25.3373, x + 93.9191, y + 25.9818, x + 93.9987, y + 26.586);
ctx.bezierCurveTo(x + 94.0784, y + 27.1903, x + 94.158, y + 27.7139, x + 94.2377, y + 28.2376);
ctx.bezierCurveTo(x + 94.3174, y + 28.721, x + 94.397, y + 29.1641, x + 94.4767, y + 29.5266);
ctx.bezierCurveTo(x + 94.5165, y + 29.6877, x + 94.4767, y + 29.8086, x + 94.397, y + 29.8891);
ctx.bezierCurveTo(x + 94.3174, y + 29.9294, x + 94.1979, y + 29.9697, x + 93.9589, y + 29.9294);
ctx.bezierCurveTo(x + 93.7199, y + 29.8892, x + 93.5208, y + 29.8891, x + 93.2818, y + 29.8489);
ctx.bezierCurveTo(x + 93.0428, y + 29.8086, x + 92.8038, y + 29.7683, x + 92.5648, y + 29.6475);
ctx.bezierCurveTo(x + 92.3259, y + 29.5669, x + 92.1666, y + 29.4863, x + 92.0471, y + 29.3655);
ctx.bezierCurveTo(x + 91.9276, y + 29.2446, x + 91.8081, y + 29.0835, x + 91.7284, y + 28.8015);
ctx.bezierCurveTo(x + 91.6089, y + 28.5598, x + 91.4894, y + 28.1973, x + 91.37, y + 27.7139);
ctx.bezierCurveTo(x + 91.2106, y + 27.2305, x + 91.0513, y + 26.7069, x + 90.892, y + 26.1026);
ctx.bezierCurveTo(x + 90.7327, y + 25.4984, x + 90.5335, y + 24.8539, x + 90.3742, y + 24.1288);
ctx.bezierCurveTo(x + 90.2149, y + 23.4038, x + 90.0556, y + 22.719, x + 89.8963, y + 21.9939);
ctx.bezierCurveTo(x + 89.7369, y + 21.2688, x + 89.6174, y + 20.5437, x + 89.498, y + 19.8589);
ctx.bezierCurveTo(x + 89.3785, y + 19.1741, x + 89.2988, y + 18.5296, x + 89.259, y + 17.9657);
ctx.bezierCurveTo(x + 89.2192, y + 17.6434, x + 89.2988, y + 17.4017, x + 89.498, y + 17.2406);
ctx.bezierCurveTo(x + 89.6971, y + 17.0795, x + 89.9759, y + 16.9586, x + 90.3344, y + 16.8781);
ctx.bezierCurveTo(x + 90.8123, y + 16.7975, x + 91.2505, y + 16.7169, x + 91.6886, y + 16.6767);
ctx.bezierCurveTo(x + 92.1267, y + 16.6364, x + 92.5649, y + 16.5961, x + 93.0826, y + 16.6364);
ctx.bezierCurveTo(x + 93.4809, y + 16.6364, x + 93.7597, y + 16.7169, x + 93.9589, y + 16.8781);
ctx.bezierCurveTo(x + 94.158, y + 17.0392, x + 94.3174, y + 17.3212, x + 94.4767, y + 17.6837);
ctx.bezierCurveTo(x + 94.5962, y + 17.9657, x + 94.7555, y + 18.3685, x + 94.9546, y + 18.8116);
ctx.bezierCurveTo(x + 95.1538, y + 19.2547, x + 95.3529, y + 19.7784, x + 95.5919, y + 20.3423);
ctx.bezierCurveTo(x + 95.8309, y + 20.9063, x + 96.0699, y + 21.4702, x + 96.269, y + 22.0342);
ctx.bezierCurveTo(x + 96.508, y + 22.6384, x + 96.747, y + 23.2023, x + 96.9461, y + 23.726);
ctx.bezierCurveTo(x + 96.8266, y + 22.1953, x + 96.8266, y + 20.6646, x + 96.9063, y + 19.1339);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 110.369, y + 19.0132);
ctx.bezierCurveTo(x + 110.25, y + 19.134, x + 110.09, y + 19.1743, x + 109.811, y + 19.1743);
ctx.bezierCurveTo(x + 109.095, y + 19.0937, x + 108.577, y + 18.8923, x + 108.258, y + 18.4895);
ctx.bezierCurveTo(x + 107.939, y + 18.0867, x + 107.78, y + 17.563, x + 107.74, y + 16.8379);
ctx.bezierCurveTo(x + 107.74, y + 16.7171, x + 107.7, y + 16.556, x + 107.74, y + 16.4351);
ctx.bezierCurveTo(x + 107.74, y + 16.3143, x + 107.74, y + 16.1532, x + 107.78, y + 15.992);
ctx.bezierCurveTo(x + 107.78, y + 15.8309, x + 107.78, y + 15.7101, x + 107.78, y + 15.5489);
ctx.bezierCurveTo(x + 107.78, y + 15.4281, x + 107.78, y + 15.267, x + 107.78, y + 15.1461);
ctx.bezierCurveTo(x + 107.74, y + 14.9044, x + 107.7, y + 14.6627, x + 107.7, y + 14.5016);
ctx.bezierCurveTo(x + 107.621, y + 14.3405, x + 107.541, y + 14.2599, x + 107.422, y + 14.2196);
ctx.bezierCurveTo(x + 107.183, y + 14.1793, x + 106.904, y + 14.3405, x + 106.585, y + 14.7433);
ctx.bezierCurveTo(x + 106.267, y + 15.1058, x + 105.948, y + 15.6295, x + 105.589, y + 16.274);
ctx.bezierCurveTo(x + 105.271, y + 16.9185, x + 104.952, y + 17.6436, x + 104.673, y + 18.4089);
ctx.bezierCurveTo(x + 104.395, y + 19.2146, x + 104.156, y + 20.0202, x + 103.956, y + 20.8259);
ctx.bezierCurveTo(x + 103.797, y + 21.4704, x + 103.678, y + 22.1552, x + 103.638, y + 22.84);
ctx.bezierCurveTo(x + 103.598, y + 23.5248, x + 103.558, y + 24.129, x + 103.598, y + 24.6929);
ctx.bezierCurveTo(x + 103.638, y + 25.2569, x + 103.717, y + 25.7403, x + 103.837, y + 26.1028);
ctx.bezierCurveTo(x + 103.956, y + 26.5056, x + 104.116, y + 26.7473, x + 104.275, y + 26.8279);
ctx.bezierCurveTo(x + 104.434, y + 26.9084, x + 104.594, y + 26.8682, x + 104.793, y + 26.7473);
ctx.bezierCurveTo(x + 104.952, y + 26.6265, x + 105.151, y + 26.4251, x + 105.311, y + 26.1431);
ctx.bezierCurveTo(x + 105.47, y + 25.8611, x + 105.669, y + 25.5389, x + 105.828, y + 25.136);
ctx.bezierCurveTo(x + 105.988, y + 24.7332, x + 106.187, y + 24.2901, x + 106.346, y + 23.847);
ctx.bezierCurveTo(x + 105.789, y + 23.9276, x + 105.351, y + 23.847, x + 105.032, y + 23.5248);
ctx.bezierCurveTo(x + 104.713, y + 23.2428, x + 104.474, y + 22.7191, x + 104.275, y + 21.994);
ctx.bezierCurveTo(x + 104.235, y + 21.8329, x + 104.235, y + 21.6718, x + 104.275, y + 21.5912);
ctx.bezierCurveTo(x + 104.315, y + 21.4704, x + 104.395, y + 21.3898, x + 104.514, y + 21.3092);
ctx.bezierCurveTo(x + 104.634, y + 21.2287, x + 104.753, y + 21.1481, x + 104.912, y + 21.1078);
ctx.bezierCurveTo(x + 105.072, y + 21.0676, x + 105.271, y + 20.987, x + 105.47, y + 20.9064);
ctx.bezierCurveTo(x + 105.828, y + 20.7453, x + 106.227, y + 20.5842, x + 106.665, y + 20.5036);
ctx.bezierCurveTo(x + 107.063, y + 20.3828, x + 107.422, y + 20.2619, x + 107.74, y + 20.1814);
ctx.bezierCurveTo(x + 108.099, y + 20.0605, x + 108.378, y + 20.0202, x + 108.577, y + 20.1008);
ctx.bezierCurveTo(x + 108.776, y + 20.1411, x + 108.975, y + 20.3022, x + 109.134, y + 20.5842);
ctx.bezierCurveTo(x + 109.254, y + 20.7453, x + 109.333, y + 20.9467, x + 109.413, y + 21.1481);
ctx.bezierCurveTo(x + 109.493, y + 21.3495, x + 109.572, y + 21.5107, x + 109.652, y + 21.7121);
ctx.bezierCurveTo(x + 109.772, y + 22.0343, x + 109.851, y + 22.3163, x + 109.811, y + 22.5983);
ctx.bezierCurveTo(x + 109.772, y + 22.8802, x + 109.732, y + 23.2025, x + 109.572, y + 23.565);
ctx.bezierCurveTo(x + 109.095, y + 24.8943, x + 108.577, y + 26.0222, x + 108.099, y + 26.8682);
ctx.bezierCurveTo(x + 107.621, y + 27.7544, x + 107.103, y + 28.3989, x + 106.625, y + 28.842);
ctx.bezierCurveTo(x + 106.306, y + 29.1239, x + 105.988, y + 29.2851, x + 105.629, y + 29.3656);
ctx.bezierCurveTo(x + 105.311, y + 29.4462, x + 104.952, y + 29.4462, x + 104.554, y + 29.3656);
ctx.bezierCurveTo(x + 103.917, y + 29.2448, x + 103.279, y + 28.9628, x + 102.642, y + 28.56);
ctx.bezierCurveTo(x + 102.403, y + 28.3989, x + 102.164, y + 28.1572, x + 101.925, y + 27.8752);
ctx.bezierCurveTo(x + 101.686, y + 27.5932, x + 101.487, y + 27.271, x + 101.328, y + 26.9487);
ctx.bezierCurveTo(x + 101.168, y + 26.3848, x + 100.929, y + 25.7805, x + 100.77, y + 25.0555);
ctx.bezierCurveTo(x + 100.611, y + 24.3304, x + 100.491, y + 23.565, x + 100.451, y + 22.7191);
ctx.bezierCurveTo(x + 100.412, y + 21.8732, x + 100.451, y + 20.987, x + 100.571, y + 20.1008);
ctx.bezierCurveTo(x + 100.69, y + 19.1743, x + 100.89, y + 18.2881, x + 101.208, y + 17.3616);
ctx.bezierCurveTo(x + 101.487, y + 16.4351, x + 101.885, y + 15.5489, x + 102.363, y + 14.6627);
ctx.bezierCurveTo(x + 102.841, y + 13.7765, x + 103.439, y + 12.9709, x + 104.076, y + 12.2458);
ctx.bezierCurveTo(x + 104.275, y + 12.0041, x + 104.514, y + 11.8027, x + 104.793, y + 11.6013);
ctx.bezierCurveTo(x + 105.032, y + 11.4402, x + 105.311, y + 11.279, x + 105.589, y + 11.1582);
ctx.bezierCurveTo(x + 105.868, y + 11.0373, x + 106.107, y + 10.9568, x + 106.386, y + 10.8762);
ctx.bezierCurveTo(x + 106.665, y + 10.7957, x + 106.904, y + 10.7554, x + 107.103, y + 10.7554);
ctx.bezierCurveTo(x + 107.422, y + 10.7151, x + 107.74, y + 10.7151, x + 108.059, y + 10.7151);
ctx.bezierCurveTo(x + 108.378, y + 10.7151, x + 108.696, y + 10.7554, x + 109.015, y + 10.8359);
ctx.bezierCurveTo(x + 109.333, y + 10.9165, x + 109.612, y + 10.9971, x + 109.851, y + 11.1179);
ctx.bezierCurveTo(x + 110.13, y + 11.2388, x + 110.329, y + 11.3999, x + 110.528, y + 11.561);
ctx.bezierCurveTo(x + 110.887, y + 11.8833, x + 111.126, y + 12.2458, x + 111.245, y + 12.6889);
ctx.bezierCurveTo(x + 111.365, y + 13.132, x + 111.405, y + 13.6557, x + 111.405, y + 14.2196);
ctx.bezierCurveTo(x + 111.365, y + 14.5419, x + 111.325, y + 14.8641, x + 111.285, y + 15.267);
ctx.bezierCurveTo(x + 111.245, y + 15.6698, x + 111.166, y + 16.0323, x + 111.086, y + 16.4351);
ctx.bezierCurveTo(x + 111.006, y + 16.8379, x + 110.927, y + 17.2005, x + 110.847, y + 17.563);
ctx.bezierCurveTo(x + 110.767, y + 17.9256, x + 110.688, y + 18.2075, x + 110.608, y + 18.4492);
ctx.bezierCurveTo(x + 110.568, y + 18.7312, x + 110.449, y + 18.9326, x + 110.369, y + 19.0132);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 110.21, y + 26.707);
ctx.bezierCurveTo(x + 110.329, y + 26.425, x + 110.488, y + 26.2236, x + 110.688, y + 26.0222);
ctx.bezierCurveTo(x + 110.887, y + 25.8208, x + 111.086, y + 25.7402, x + 111.325, y + 25.6597);
ctx.bezierCurveTo(x + 111.564, y + 25.6194, x + 111.843, y + 25.6597, x + 112.082, y + 25.8208);
ctx.bezierCurveTo(x + 112.321, y + 25.9416, x + 112.48, y + 26.1028, x + 112.599, y + 26.3042);
ctx.bezierCurveTo(x + 112.719, y + 26.5056, x + 112.799, y + 26.7473, x + 112.799, y + 27.0293);
ctx.bezierCurveTo(x + 112.838, y + 27.2709, x + 112.799, y + 27.5529, x + 112.759, y + 27.7946);
ctx.bezierCurveTo(x + 112.719, y + 28.0363, x + 112.679, y + 28.278, x + 112.599, y + 28.4391);
ctx.bezierCurveTo(x + 112.56, y + 28.56, x + 112.48, y + 28.7211, x + 112.36, y + 28.9225);
ctx.bezierCurveTo(x + 112.241, y + 29.1239, x + 112.121, y + 29.285, x + 112.002, y + 29.4462);
ctx.bezierCurveTo(x + 111.882, y + 29.6073, x + 111.723, y + 29.7281, x + 111.564, y + 29.8087);
ctx.bezierCurveTo(x + 111.405, y + 29.8893, x + 111.245, y + 29.9296, x + 111.046, y + 29.9296);
ctx.bezierCurveTo(x + 110.648, y + 29.8893, x + 110.369, y + 29.6879, x + 110.13, y + 29.285);
ctx.bezierCurveTo(x + 109.891, y + 28.8822, x + 109.851, y + 28.3183, x + 109.931, y + 27.5932);
ctx.bezierCurveTo(x + 110.01, y + 27.3112, x + 110.09, y + 26.989, x + 110.21, y + 26.707);
ctx.closePath();
ctx.moveTo(x + 119.609, y + 9.42603);
ctx.bezierCurveTo(x + 119.609, y + 9.708, x + 119.53, y + 10.0705, x + 119.291, y + 10.5539);
ctx.bezierCurveTo(x + 118.693, y + 11.8027, x + 118.096, y + 13.0514, x + 117.538, y + 14.3404);
ctx.bezierCurveTo(x + 116.981, y + 15.5892, x + 116.463, y + 16.8379, x + 115.945, y + 18.0464);
ctx.bezierCurveTo(x + 115.467, y + 19.2548, x + 114.989, y + 20.423, x + 114.591, y + 21.5106);
ctx.bezierCurveTo(x + 114.193, y + 22.5982, x + 113.834, y + 23.6456, x + 113.516, y + 24.5721);
ctx.bezierCurveTo(x + 113.396, y + 24.8943, x + 113.316, y + 25.0957, x + 113.197, y + 25.1763);
ctx.bezierCurveTo(x + 113.077, y + 25.2568, x + 112.918, y + 25.2568, x + 112.719, y + 25.136);
ctx.bezierCurveTo(x + 112.48, y + 25.0554, x + 112.241, y + 24.9346, x + 112.042, y + 24.8137);
ctx.bezierCurveTo(x + 111.843, y + 24.6929, x + 111.644, y + 24.5721, x + 111.484, y + 24.3706);
ctx.bezierCurveTo(x + 111.325, y + 24.1692, x + 111.205, y + 23.9678, x + 111.166, y + 23.7664);
ctx.bezierCurveTo(x + 111.126, y + 23.565, x + 111.166, y + 23.2025, x + 111.245, y + 22.7996);
ctx.bezierCurveTo(x + 111.444, y + 21.9134, x + 111.683, y + 20.9064, x + 112.002, y + 19.6979);
ctx.bezierCurveTo(x + 112.321, y + 18.4895, x + 112.679, y + 17.2407, x + 113.077, y + 15.9517);
ctx.bezierCurveTo(x + 113.476, y + 14.6627, x + 113.874, y + 13.3737, x + 114.312, y + 12.0846);
ctx.bezierCurveTo(x + 114.71, y + 10.7956, x + 115.149, y + 9.66772, x + 115.507, y + 8.62039);
ctx.bezierCurveTo(x + 115.706, y + 8.13701, x + 115.905, y + 7.81475, x + 116.104, y + 7.65362);
ctx.bezierCurveTo(x + 116.343, y + 7.4925, x + 116.622, y + 7.4925, x + 117.021, y + 7.57306);
ctx.bezierCurveTo(x + 117.379, y + 7.65362, x + 117.777, y + 7.73419, x + 118.176, y + 7.9356);
ctx.bezierCurveTo(x + 118.574, y + 8.09673, x + 118.932, y + 8.29814, x + 119.171, y + 8.58011);
ctx.bezierCurveTo(x + 119.45, y + 8.8218, x + 119.609, y + 9.10378, x + 119.609, y + 9.42603);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.restore();
ctx.restore();


  }

  drawElementBombOG(ctx, scale, x, y) {
    x = x / scale;
    y = y / scale;
    ctx.save();
    ctx.strokeStyle="rgba(0,0,0,0)";
    ctx.miterLimit=4;

    ctx.fillStyle="rgba(0,0,0,0)";

    ctx.scale(scale, scale);
    // ctx.scale(0.6837606837606838,0.6837606837606838);
    ctx.save();
    ctx.fillStyle="#020202";

    ctx.beginPath();
    ctx.moveTo(x + 60.6723, y + 20.0585);
    ctx.bezierCurveTo(x + 70.3001, y + 21.3745, x + 76.9617, y + 27.6998, x + 79.9876, y + 33.1809);
    ctx.bezierCurveTo(x + 83.0678, y + 38.7656, x + 83.9515, y + 44.5364, x + 82.6603, y + 49.9533);
    ctx.lineTo(x + 76.3147, y + 49.096);
    ctx.lineTo(x + 75.4274, y + 55.7522);
    ctx.bezierCurveTo(x + 63.9043, y + 57.6323, x + 54.4687, y + 66.8566, x + 52.8412, y + 79.0655);
    ctx.bezierCurveTo(x + 50.8481, y + 94.0173, x + 61.3168, y + 107.77, x + 76.2248, y + 109.784);
    ctx.bezierCurveTo(x + 91.1328, y + 111.798, x + 104.833, y + 101.311, x + 106.826, y + 86.3589);
    ctx.bezierCurveTo(x + 108.385, y + 74.6626, x + 102.299, y + 63.7279, x + 92.4467, y + 58.5441);
    ctx.lineTo(x + 93.3985, y + 51.4041);
    ctx.lineTo(x + 86.7426, y + 50.5049);
    ctx.bezierCurveTo(x + 86.8899, y + 49.8284, x + 87.0345, y + 49.1503, x + 87.1259, y + 48.4649);
    ctx.bezierCurveTo(x + 87.8853, y + 42.7682, x + 86.7131, y + 36.8036, x + 83.6053, y + 31.1747);
    ctx.bezierCurveTo(x + 80.0945, y + 24.8118, x + 72.3704, y + 17.4708, x + 61.2259, y + 15.9471);
    ctx.lineTo(x + 60.6723, y + 20.0585);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#ED1B24";

    ctx.beginPath();
    ctx.moveTo(x + 69.1806, y + 11.7096);
    ctx.bezierCurveTo(x + 65.7317, y + 13.2735, x + 62.7039, y + 14.6642, x + 61.9231, y + 18.0022);
    ctx.bezierCurveTo(x + 61.1438, y + 21.3404, x + 62.6744, y + 23.2549, x + 65.6352, y + 26.8875);
    ctx.bezierCurveTo(x + 62.3906, y + 25.5667, x + 59.886, y + 23.7449, x + 56.7972, y + 24.4537);
    ctx.bezierCurveTo(x + 53.7084, y + 25.1625, x + 51.9208, y + 27.6068, x + 50.3027, y + 31.8524);
    ctx.bezierCurveTo(x + 49.6884, y + 28.1958, x + 49.8118, y + 24.8622, x + 47.3378, y + 23.7211);
    ctx.bezierCurveTo(x + 44.864, y + 22.5785, x + 42.6327, y + 23.2319, x + 39.2955, y + 23.1301);
    ctx.bezierCurveTo(x + 42.3944, y + 21.2469, x + 45.6659, y + 19.719, x + 46.5942, y + 16.3285);
    ctx.bezierCurveTo(x + 47.5227, y + 12.9365, x + 45.3317, y + 10.2743, x + 44.256, y + 6.45619);
    ctx.bezierCurveTo(x + 46.7686, y + 8.94993, x + 48.5191, y + 10.3516, x + 51.5228, y + 9.21564);
    ctx.bezierCurveTo(x + 54.5265, y + 8.0797, x + 54.3289, y + 5.036, x + 56.3268, y + 1.88928);
    ctx.bezierCurveTo(x + 56.5975, y + 6.24559, x + 57.1223, y + 8.47298, x + 59.8337, y + 10.2349);
    ctx.bezierCurveTo(x + 62.5452, y + 11.9968, x + 64.8869, y + 11.3919, x + 69.1806, y + 11.7096);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#F9ED32";

    ctx.beginPath();
    ctx.moveTo(x + 66.1969, y + 12.3224);
    ctx.bezierCurveTo(x + 63.8124, y + 13.5729, x + 61.8525, y + 15.1055, x + 61.2152, y + 17.8353);
    ctx.bezierCurveTo(x + 60.8625, y + 19.3469, x + 60.9306, y + 20.6659, x + 61.4324, y + 21.9878);
    ctx.bezierCurveTo(x + 61.8087, y + 22.9774, x + 62.4203, y + 23.9445, x + 63.1993, y + 24.9929);
    ctx.bezierCurveTo(x + 61.0782, y + 24.0125, x + 59.0287, y + 23.1952, x + 56.6318, y + 23.7438);
    ctx.bezierCurveTo(x + 54.074, y + 24.3306, x + 52.2507, y + 25.9556, x + 50.6597, y + 29.1812);
    ctx.bezierCurveTo(x + 50.4867, y + 27.8871, x + 50.2977, y + 26.6717, x + 49.9092, y + 25.6484);
    ctx.bezierCurveTo(x + 49.4308, y + 24.391, x + 48.6892, y + 23.543, x + 47.6403, y + 23.0592);
    ctx.bezierCurveTo(x + 45.7668, y + 22.1947, x + 44.0522, y + 22.2694, x + 42.0661, y + 22.3561);
    ctx.bezierCurveTo(x + 42.0507, y + 22.3568, x + 42.0367, y + 22.3577, x + 42.0199, y + 22.3582);
    ctx.bezierCurveTo(x + 44.3522, y + 20.9347, x + 46.5336, y + 19.3066, x + 47.296, y + 16.5254);
    ctx.bezierCurveTo(x + 47.8671, y + 14.4393, x + 47.3631, y + 12.6206, x + 46.7345, y + 10.965);
    ctx.bezierCurveTo(x + 46.555, y + 10.4943, x + 46.3581, y + 10.0185, x + 46.1546, y + 9.52929);
    ctx.bezierCurveTo(x + 46.0734, y + 9.33418, x + 45.9914, y + 9.13478, x + 45.9095, y + 8.934);
    ctx.bezierCurveTo(x + 47.6212, y + 10.2412, x + 49.3621, y + 10.8158, x + 51.7783, y + 9.90156);
    ctx.bezierCurveTo(x + 54.0232, y + 9.052, x + 54.7256, y + 7.2655, x + 55.4697, y + 5.37447);
    ctx.bezierCurveTo(x + 55.5855, y + 5.07911, x + 55.7029, y + 4.78256, x + 55.8277, y + 4.48283);
    ctx.bezierCurveTo(x + 55.9672, y + 5.53667, x + 56.1666, y + 6.46472, x + 56.4799, y + 7.28963);
    ctx.bezierCurveTo(x + 57.0519, y + 8.79536, x + 57.9647, y + 9.89391, x + 59.4364, y + 10.8505);
    ctx.bezierCurveTo(x + 61.5804, y + 12.2441, x + 63.5449, y + 12.2786, x + 66.0313, y + 12.3223);
    ctx.bezierCurveTo(x + 66.0873, y + 12.3201, x + 66.1415, y + 12.3205, x + 66.1969, y + 12.3224);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(x + 60.7169, y + 13.872);
    ctx.bezierCurveTo(x + 59.9918, y + 14.8144, x + 59.4096, y + 15.9477, x + 59.0863, y + 17.3323);
    ctx.bezierCurveTo(x + 58.7529, y + 18.7615, x + 58.72, y + 20.1073, x + 58.9919, y + 21.4107);
    ctx.bezierCurveTo(x + 58.0881, y + 21.3316, x + 57.1413, y + 21.3777, x + 56.1423, y + 21.6065);
    ctx.bezierCurveTo(x + 54.394, y + 22.0073, x + 52.8956, y + 22.8101, x + 51.5964, y + 24.0611);
    ctx.bezierCurveTo(x + 50.9, y + 22.685, x + 49.8786, y + 21.6805, x + 48.5532, y + 21.0672);
    ctx.bezierCurveTo(x + 48.2149, y + 20.9112, x + 47.8804, y + 20.7794, x + 47.5513, y + 20.6693);
    ctx.bezierCurveTo(x + 48.3682, y + 19.6752, x + 49.0211, y + 18.5124, x + 49.4056, y + 17.1068);
    ctx.bezierCurveTo(x + 49.8634, y + 15.4336, x + 49.792, y + 13.9091, x + 49.4972, y + 12.5371);
    ctx.bezierCurveTo(x + 50.4149, y + 12.5428, x + 51.4322, y + 12.375, x + 52.5548, y + 11.9495);
    ctx.bezierCurveTo(x + 53.8165, y + 11.4718, x + 54.7324, y + 10.7798, x + 55.4291, y + 9.98836);
    ctx.bezierCurveTo(x + 56.1351, y + 11.0311, x + 57.0602, y + 11.9123, x + 58.2515, y + 12.686);
    ctx.bezierCurveTo(x + 59.0904, y + 13.2319, x + 59.9085, y + 13.6092, x + 60.7169, y + 13.872);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(x + 70.5671, y + 63.5602);
    ctx.bezierCurveTo(x + 73.334, y + 63.9341, x + 75.2776, y + 66.4875, x + 74.9077, y + 69.2628);
    ctx.bezierCurveTo(x + 74.5377, y + 72.038, x + 71.9942, y + 73.9853, x + 69.2273, y + 73.6114);
    ctx.bezierCurveTo(x + 66.4604, y + 73.2376, x + 64.5168, y + 70.6841, x + 64.8867, y + 67.9089);
    ctx.bezierCurveTo(x + 65.2566, y + 65.1336, x + 67.8002, y + 63.1864, x + 70.5671, y + 63.5602);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#F7941E";

    ctx.beginPath();
    ctx.moveTo(x + 59.2461, y + 106.087);
    ctx.lineTo(x + 59.0211, y + 106.148);
    ctx.bezierCurveTo(x + 58.7721, y + 106.138, x + 58.7483, y + 105.992, x + 58.7347, y + 105.907);
    ctx.lineTo(x + 55.7679, y + 97.9768);
    ctx.lineTo(x + 55.4352, y + 106.431);
    ctx.bezierCurveTo(x + 55.4049, y + 106.784, x + 55.064, y + 106.899, x + 54.6888, y + 106.959);
    ctx.bezierCurveTo(x + 53.8307, y + 107.094, x + 53.2674, y + 107.209, x + 52.4091, y + 107.346);
    ctx.bezierCurveTo(x + 50.6329, y + 107.627, x + 50.1219, y + 107.684, x + 48.5505, y + 107.932);
    ctx.bezierCurveTo(x + 48.2719, y + 107.977, x + 47.9598, y + 107.876, x + 47.6813, y + 107.921);
    ctx.lineTo(x + 47.4676, y + 107.98);
    ctx.bezierCurveTo(x + 47.2059, y + 107.971, x + 47.1835, y + 107.825, x + 47.1697, y + 107.741);
    ctx.lineTo(x + 44.1993, y + 100.172);
    ctx.bezierCurveTo(x + 43.4838, y + 98.2353, x + 42.6939, y + 96.1475, x + 42.0395, y + 94.2009);
    ctx.bezierCurveTo(x + 41.7518, y + 94.0225, x + 41.6258, y + 93.2354, x + 41.5426, y + 92.701);
    ctx.bezierCurveTo(x + 41.4755, y + 92.2762, x + 41.5222, y + 91.9463, x + 41.8732, y + 91.8905);
    ctx.bezierCurveTo(x + 42.2596, y + 91.8297, x + 44.6485, y + 91.501, x + 44.7211, y + 91.4885);
    ctx.lineTo(x + 45.7967, y + 91.3185);
    ctx.bezierCurveTo(x + 45.9315, y + 91.3088, x + 45.9696, y + 91.3154, x + 46.0114, y + 91.3461);
    ctx.lineTo(x + 46.0532, y + 91.3769);
    ctx.bezierCurveTo(x + 46.1384, y + 91.3633, x + 46.2074, y + 91.2526, x + 46.3879, y + 91.224);
    ctx.lineTo(x + 46.4603, y + 91.2129);
    ctx.bezierCurveTo(x + 46.4959, y + 91.2065, x + 47.6843, y + 91.1188, x + 48.3238, y + 91.0168);
    ctx.bezierCurveTo(x + 48.7755, y + 91.6038, x + 49.4189, y + 93.7889, x + 50.2894, y + 96.1484);
    ctx.bezierCurveTo(x + 50.3031, y + 96.2339, x + 51.163, y + 98.6939, x + 51.1692, y + 98.731);
    ctx.lineTo(x + 51.2109, y + 98.8356);
    ctx.bezierCurveTo(x + 51.236, y + 98.9186, x + 51.26, y + 98.9888, x + 51.3144, y + 99.0924);
    ctx.bezierCurveTo(x + 51.3338, y + 98.9778, x + 51.3213, y + 98.905, x + 51.3203, y + 98.8184);
    ctx.lineTo(x + 51.3271, y + 98.7049);
    ctx.bezierCurveTo(x + 51.3207, y + 98.6691, x + 51.3903, y + 96.06, x + 51.3779, y + 95.976);
    ctx.bezierCurveTo(x + 51.4622, y + 93.4651, x + 51.5206, y + 91.9524, x + 51.6239, y + 91.0414);
    ctx.bezierCurveTo(x + 51.657, y + 90.6259, x + 51.686, y + 90.3355, x + 52.9307, y + 90.1382);
    ctx.bezierCurveTo(x + 53.2206, y + 90.0922, x + 54.8137, y + 89.8276, x + 55.4594, y + 89.7627);
    ctx.bezierCurveTo(x + 55.4964, y + 89.7566, x + 55.5522, y + 89.7237, x + 55.5892, y + 89.7175);
    ctx.bezierCurveTo(x + 55.6857, y + 89.7026, x + 55.7849, y + 89.6993, x + 55.7899, y + 89.7349);
    ctx.bezierCurveTo(x + 56.6976, y + 89.6036, x + 57.135, y + 89.5469, x + 57.3701, y + 89.5466);
    ctx.bezierCurveTo(x + 57.5049, y + 89.5369, x + 57.5912, y + 89.536, x + 57.6051, y + 89.5462);
    ctx.bezierCurveTo(x + 57.6904, y + 89.5327, x + 57.7707, y + 89.4207, x + 58.0123, y + 89.3822);
    ctx.bezierCurveTo(x + 58.0479, y + 89.3759, x + 58.858, y + 89.1728, x + 58.9477, y + 89.3454);
    ctx.bezierCurveTo(x + 59.2961, y + 90.0607, x + 59.7004, y + 91.9108, x + 60.5298, y + 94.015);
    ctx.bezierCurveTo(x + 60.5472, y + 94.1248, x + 61.5217, y + 97.3005, x + 61.5292, y + 97.3489);
    ctx.lineTo(x + 61.5682, y + 97.4421);
    ctx.bezierCurveTo(x + 61.5896, y + 97.5008, x + 61.6198, y + 97.6081, x + 61.6728, y + 97.7115);
    ctx.bezierCurveTo(x + 61.6922, y + 97.597, x + 61.6749, y + 97.4872, x + 61.6777, y + 97.4248);
    ctx.lineTo(x + 61.6869, y + 97.3242);
    ctx.bezierCurveTo(x + 61.6794, y + 97.2758, x + 61.6356, y + 93.9523, x + 61.6183, y + 93.8426);
    ctx.bezierCurveTo(x + 61.7552, y + 91.5843, x + 61.7087, y + 89.491, x + 61.9675, y + 88.8536);
    ctx.bezierCurveTo(x + 62.1608, y + 88.8225, x + 62.4368, y + 88.7663, x + 62.6607, y + 88.6933);
    ctx.lineTo(x + 63.0638, y + 88.5804);
    ctx.lineTo(x + 63.1362, y + 88.5692);
    ctx.bezierCurveTo(x + 63.1845, y + 88.5618, x + 63.2123, y + 88.6562, x + 63.2477, y + 88.6513);
    ctx.bezierCurveTo(x + 63.5019, y + 88.6117, x + 63.492, y + 88.5503, x + 63.4857, y + 88.5146);
    ctx.lineTo(x + 64.7902, y + 88.3072);
    ctx.bezierCurveTo(x + 64.7864, y + 88.283, x + 67.2593, y + 87.8666, x + 67.6344, y + 87.807);
    ctx.bezierCurveTo(x + 67.9613, y + 87.7549, x + 68.1355, y + 88.0756, x + 68.199, y + 88.4762);
    ctx.bezierCurveTo(x + 68.0356, y + 89.0861, x + 68.1515, y + 89.8132, x + 68.1888, y + 90.0554);
    ctx.bezierCurveTo(x + 68.0695, y + 92.3482, x + 67.8667, y + 94.903, x + 67.6049, y + 97.2323);
    ctx.lineTo(x + 67.0014, y + 104.598);
    ctx.bezierCurveTo(x + 66.7608, y + 104.723, x + 66.7845, y + 104.868, x + 66.792, y + 104.917);
    ctx.lineTo(x + 66.5708, y + 104.927);
    ctx.bezierCurveTo(x + 66.3421, y + 104.963, x + 66.2147, y + 105.022, x + 65.9846, y + 105.057);
    ctx.bezierCurveTo(x + 64.5224, y + 105.29, x + 62.0675, y + 105.665, x + 60.6778, y + 105.886);
    ctx.bezierCurveTo(x + 60.2047, y + 105.96, x + 59.6938, y + 106.015, x + 59.2461, y + 106.087);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(x + 41.829, y + 91.8983);
    ctx.bezierCurveTo(x + 41.8434, y + 91.8947, x + 41.8576, y + 91.8924, x + 41.8731, y + 91.8903);
    ctx.bezierCurveTo(x + 42.2596, y + 91.8295, x + 44.6485, y + 91.5008, x + 44.7197, y + 91.4881);
    ctx.lineTo(x + 45.7952, y + 91.3181);
    ctx.bezierCurveTo(x + 45.9301, y + 91.3084, x + 45.9682, y + 91.315, x + 46.01, y + 91.3457);
    ctx.lineTo(x + 46.0517, y + 91.3765);
    ctx.bezierCurveTo(x + 46.0547, y + 91.3755, x + 46.0574, y + 91.3759, x + 46.0603, y + 91.3749);
    ctx.bezierCurveTo(x + 46.135, y + 91.3571, x + 46.1997, y + 91.2681, x + 46.3464, y + 91.2321);
    ctx.bezierCurveTo(x + 46.3592, y + 91.2297, x + 46.3723, y + 91.2259, x + 46.3849, y + 91.2248);
    ctx.lineTo(x + 46.4573, y + 91.2137);
    ctx.bezierCurveTo(x + 46.493, y + 91.2073, x + 47.6814, y + 91.1195, x + 48.3208, y + 91.0176);
    ctx.bezierCurveTo(x + 48.7725, y + 91.6046, x + 49.4159, y + 93.7897, x + 50.2865, y + 96.1492);
    ctx.bezierCurveTo(x + 50.3001, y + 96.2348, x + 51.1601, y + 98.6947, x + 51.1662, y + 98.7318);
    ctx.lineTo(x + 51.2079, y + 98.8365);
    ctx.bezierCurveTo(x + 51.233, y + 98.9194, x + 51.257, y + 98.9896, x + 51.3114, y + 99.0932);
    ctx.bezierCurveTo(x + 51.3308, y + 98.9787, x + 51.3183, y + 98.9058, x + 51.3173, y + 98.8192);
    ctx.lineTo(x + 51.3241, y + 98.7057);
    ctx.bezierCurveTo(x + 51.3177, y + 98.67, x + 51.3874, y + 96.0608, x + 51.3749, y + 95.9768);
    ctx.bezierCurveTo(x + 51.4592, y + 93.4659, x + 51.5176, y + 91.9532, x + 51.621, y + 91.0422);
    ctx.bezierCurveTo(x + 51.649, y + 90.686, x + 51.6745, y + 90.4216, x + 52.4666, y + 90.2287);
    ctx.bezierCurveTo(x + 52.5975, y + 90.1962, x + 52.7502, y + 90.1666, x + 52.9264, y + 90.1388);
    ctx.bezierCurveTo(x + 53.2163, y + 90.0928, x + 54.8094, y + 89.8282, x + 55.4551, y + 89.7633);
    ctx.bezierCurveTo(x + 55.458, y + 89.7623, x + 55.4607, y + 89.7627, x + 55.4636, y + 89.7617);
    ctx.bezierCurveTo(x + 55.4967, y + 89.7536, x + 55.5433, y + 89.7278, x + 55.5763, y + 89.7197);
    ctx.bezierCurveTo(x + 55.5792, y + 89.7187, x + 55.582, y + 89.7191, x + 55.5849, y + 89.7181);
    ctx.bezierCurveTo(x + 55.6814, y + 89.7033, x + 55.7806, y + 89.6999, x + 55.7856, y + 89.7355);
    ctx.bezierCurveTo(x + 56.6933, y + 89.6042, x + 57.1306, y + 89.5475, x + 57.3658, y + 89.5472);
    ctx.bezierCurveTo(x + 57.5006, y + 89.5375, x + 57.5869, y + 89.5366, x + 57.6009, y + 89.5469);
    ctx.bezierCurveTo(x + 57.6038, y + 89.5459, x + 57.6079, y + 89.5464, x + 57.6108, y + 89.5454);
    ctx.bezierCurveTo(x + 57.6841, y + 89.5274, x + 57.7582, y + 89.4412, x + 57.9409, y + 89.3961);
    ctx.bezierCurveTo(x + 57.9625, y + 89.3906, x + 57.9839, y + 89.3865, x + 58.008, y + 89.3828);
    ctx.bezierCurveTo(x + 58.0436, y + 89.3765, x + 58.8551, y + 89.1736, x + 58.9434, y + 89.346);
    ctx.bezierCurveTo(x + 59.2918, y + 90.0613, x + 59.6961, y + 91.9114, x + 60.5256, y + 94.0156);
    ctx.bezierCurveTo(x + 60.5429, y + 94.1254, x + 61.5175, y + 97.3011, x + 61.5249, y + 97.3496);
    ctx.lineTo(x + 61.564, y + 97.4428);
    ctx.bezierCurveTo(x + 61.5854, y + 97.5014, x + 61.6156, y + 97.6088, x + 61.6685, y + 97.7122);
    ctx.bezierCurveTo(x + 61.688, y + 97.5976, x + 61.6706, y + 97.4878, x + 61.6734, y + 97.4254);
    ctx.lineTo(x + 61.6826, y + 97.3248);
    ctx.bezierCurveTo(x + 61.6751, y + 97.2764, x + 61.6313, y + 93.953, x + 61.614, y + 93.8432);
    ctx.bezierCurveTo(x + 61.751, y + 91.5836, x + 61.7044, y + 89.4916, x + 61.9632, y + 88.8542);
    ctx.bezierCurveTo(x + 62.0855, y + 88.8344, x + 62.2396, y + 88.805, x + 62.3933, y + 88.7686);
    ctx.bezierCurveTo(x + 62.4838, y + 88.7473, x + 62.5734, y + 88.7218, x + 62.6562, y + 88.6953);
    ctx.lineTo(x + 63.0594, y + 88.5824);
    ctx.lineTo(x + 63.1318, y + 88.5712);
    ctx.bezierCurveTo(x + 63.1801, y + 88.5638, x + 63.2078, y + 88.6582, x + 63.2432, y + 88.6532);
    ctx.bezierCurveTo(x + 63.2787, y + 88.6482, x + 63.3088, y + 88.6412, x + 63.3347, y + 88.6349);
    ctx.bezierCurveTo(x + 63.4942, y + 88.5965, x + 63.4869, y + 88.5467, x + 63.4814, y + 88.5152);
    ctx.lineTo(x + 64.7859, y + 88.3078);
    ctx.bezierCurveTo(x + 64.7859, y + 88.3078, x + 64.7962, y + 88.3036, x + 64.8149, y + 88.2992);
    ctx.bezierCurveTo(x + 65.0893, y + 88.233, x + 67.2792, y + 87.8634, x + 67.6302, y + 87.8076);
    ctx.bezierCurveTo(x + 67.957, y + 87.7555, x + 68.1313, y + 88.0762, x + 68.1947, y + 88.4768);
    ctx.bezierCurveTo(x + 68.0313, y + 89.0867, x + 68.1472, y + 89.8139, x + 68.1845, y + 90.0561);
    ctx.bezierCurveTo(x + 68.0653, y + 92.3488, x + 67.8624, y + 94.9037, x + 67.6006, y + 97.233);
    ctx.lineTo(x + 66.9972, y + 104.598);
    ctx.bezierCurveTo(x + 66.7565, y + 104.724, x + 66.7803, y + 104.869, x + 66.7877, y + 104.917);
    ctx.lineTo(x + 66.5666, y + 104.928);
    ctx.bezierCurveTo(x + 66.4969, y + 104.94, x + 66.4367, y + 104.952, x + 66.3807, y + 104.966);
    ctx.bezierCurveTo(x + 66.3074, y + 104.984, x + 66.2395, y + 105.002, x + 66.1662, y + 105.02);
    ctx.bezierCurveTo(x + 66.1101, y + 105.034, x + 66.05, y + 105.047, x + 65.9803, y + 105.058);
    ctx.bezierCurveTo(x + 64.5182, y + 105.29, x + 62.0632, y + 105.666, x + 60.6735, y + 105.887);
    ctx.bezierCurveTo(x + 60.2018, y + 105.961, x + 59.6907, y + 106.018, x + 59.2445, y + 106.089);
    ctx.lineTo(x + 59.0195, y + 106.149);
    ctx.bezierCurveTo(x + 58.7705, y + 106.139, x + 58.7468, y + 105.993, x + 58.7331, y + 105.908);
    ctx.lineTo(x + 55.7663, y + 97.9778);
    ctx.lineTo(x + 55.4337, y + 106.432);
    ctx.bezierCurveTo(x + 55.409, y + 106.721, x + 55.1746, y + 106.851, x + 54.8857, y + 106.921);
    ctx.bezierCurveTo(x + 54.8212, y + 106.936, x + 54.7554, y + 106.95, x + 54.6872, y + 106.96);
    ctx.bezierCurveTo(x + 53.8291, y + 107.095, x + 53.2658, y + 107.21, x + 52.4075, y + 107.347);
    ctx.bezierCurveTo(x + 50.6313, y + 107.628, x + 50.1203, y + 107.685, x + 48.5489, y + 107.933);
    ctx.bezierCurveTo(x + 48.2703, y + 107.978, x + 47.9582, y + 107.877, x + 47.6797, y + 107.922);
    ctx.lineTo(x + 47.4659, y + 107.981);
    ctx.bezierCurveTo(x + 47.2042, y + 107.972, x + 47.1819, y + 107.827, x + 47.1681, y + 107.742);
    ctx.lineTo(x + 44.1977, y + 100.173);
    ctx.bezierCurveTo(x + 43.4822, y + 98.2363, x + 42.6923, y + 96.1486, x + 42.0379, y + 94.2019);
    ctx.bezierCurveTo(x + 41.7501, y + 94.0235, x + 41.6242, y + 93.2364, x + 41.5397, y + 92.7018);
    ctx.bezierCurveTo(x + 41.4785, y + 92.2946, x + 41.5183, y + 91.9749, x + 41.829, y + 91.8983);
    ctx.closePath();
    ctx.moveTo(x + 41.3352, y + 89.8631);
    ctx.bezierCurveTo(x + 40.2054, y + 90.1374, x + 39.1942, y + 91.2229, x + 39.4808, y + 93.0278);
    ctx.bezierCurveTo(x + 39.5887, y + 93.7106, x + 39.7253, y + 94.5744, x + 40.1956, y + 95.2616);
    ctx.bezierCurveTo(x + 40.7119, y + 96.7725, x + 41.2934, y + 98.3368, x + 41.8562, y + 99.8539);
    ctx.lineTo(x + 42.2428, y + 100.898);
    ctx.lineTo(x + 45.1791, y + 108.379);
    ctx.bezierCurveTo(x + 45.4654, y + 109.372, x + 46.3264, y + 110.039, x + 47.4067, y + 110.074);
    ctx.lineTo(x + 47.7211, y + 110.084);
    ctx.lineTo(x + 47.9651, y + 110.017);
    ctx.bezierCurveTo(x + 48.2443, y + 110.04, x + 48.5398, y + 110.057, x + 48.8809, y + 110.002);
    ctx.bezierCurveTo(x + 49.6325, y + 109.883, x + 50.1375, y + 109.809, x + 50.6597, y + 109.732);
    ctx.bezierCurveTo(x + 51.2272, y + 109.648, x + 51.8131, y + 109.563, x + 52.7395, y + 109.416);
    ctx.bezierCurveTo(x + 53.1814, y + 109.346, x + 53.5475, y + 109.281, x + 53.9134, y + 109.217);
    ctx.bezierCurveTo(x + 54.2582, y + 109.156, x + 54.6029, y + 109.096, x + 55.0191, y + 109.03);
    ctx.bezierCurveTo(x + 55.1441, y + 109.011, x + 55.2655, y + 108.987, x + 55.3834, y + 108.958);
    ctx.bezierCurveTo(x + 56.3782, y + 108.716, x + 56.9734, y + 108.132, x + 57.2763, y + 107.498);
    ctx.bezierCurveTo(x + 57.6887, y + 107.942, x + 58.2711, y + 108.216, x + 58.9393, y + 108.243);
    ctx.lineTo(x + 59.2573, y + 108.257);
    ctx.lineTo(x + 59.5646, y + 108.174);
    ctx.lineTo(x + 59.68, y + 108.144);
    ctx.bezierCurveTo(x + 59.8532, y + 108.117, x + 60.0357, y + 108.094, x + 60.2212, y + 108.069);
    ctx.bezierCurveTo(x + 60.4845, y + 108.035, x + 60.7509, y + 107.998, x + 61.0067, y + 107.957);
    ctx.lineTo(x + 63.589, y + 107.554);
    ctx.lineTo(x + 66.3135, y + 107.129);
    ctx.bezierCurveTo(x + 66.4443, y + 107.107, x + 66.5588, y + 107.084, x + 66.6652, y + 107.058);
    ctx.lineTo(x + 66.8106, y + 107.02);
    ctx.lineTo(x + 66.81, y + 107.014);
    ctx.lineTo(x + 66.8927, y + 107.01);
    ctx.lineTo(x + 69.2215, y + 106.902);
    ctx.lineTo(x + 69.0163, y + 105.604);
    ctx.lineTo(x + 69.0839, y + 104.773);
    ctx.lineTo(x + 69.6873, y + 97.4075);
    ctx.bezierCurveTo(x + 69.9373, y + 95.198, x + 70.1494, y + 92.6053, x + 70.2752, y + 90.1697);
    ctx.lineTo(x + 70.2865, y + 89.9494);
    ctx.lineTo(x + 70.2515, y + 89.7313);
    ctx.bezierCurveTo(x + 70.174, y + 89.2381, x + 70.2083, y + 89.0544, x + 70.2166, y + 89.0234);
    ctx.lineTo(x + 70.317, y + 88.6143);
    ctx.lineTo(x + 70.2618, y + 88.152);
    ctx.bezierCurveTo(x + 70.1733, y + 87.5946, x + 69.9803, y + 87.1123, x + 69.6863, y + 86.7196);
    ctx.bezierCurveTo(x + 69.1198, y + 85.9609, x + 68.2297, y + 85.5951, x + 67.3076, y + 85.7412);
    ctx.bezierCurveTo(x + 67.2848, y + 85.7451, x + 64.8529, y + 86.1461, x + 64.3552, y + 86.2589);
    ctx.lineTo(x + 63.1588, y + 86.4488);
    ctx.lineTo(x + 62.8078, y + 86.5046);
    ctx.lineTo(x + 62.7793, y + 86.5091);
    ctx.lineTo(x + 61.0956, y + 86.7755);
    ctx.lineTo(x + 61.1105, y + 86.8724);
    ctx.lineTo(x + 60.4753, y + 86.9735);
    ctx.lineTo(x + 60.1974, y + 87.66);
    ctx.bezierCurveTo(x + 59.5832, y + 87.1864, x + 58.7124, y + 87.0827, x + 57.5871, y + 87.3338);
    ctx.lineTo(x + 57.5032, y + 87.3476);
    ctx.lineTo(x + 57.4495, y + 87.364);
    ctx.bezierCurveTo(x + 57.3316, y + 87.3927, x + 57.2241, y + 87.427, x + 57.1276, y + 87.4628);
    ctx.bezierCurveTo(x + 56.8417, y + 87.4786, x + 56.4712, y + 87.5248, x + 55.8175, y + 87.6179);
    ctx.bezierCurveTo(x + 55.6379, y + 87.6089, x + 55.4555, y + 87.6206, x + 55.258, y + 87.6525);
    ctx.lineTo(x + 55.1742, y + 87.6649);
    ctx.lineTo(x + 55.0838, y + 87.6861);
    ctx.lineTo(x + 54.9774, y + 87.7122);
    ctx.bezierCurveTo(x + 54.4088, y + 87.7833, x + 53.5648, y + 87.9162, x + 52.7885, y + 88.0429);
    ctx.lineTo(x + 52.5995, y + 88.0731);
    ctx.bezierCurveTo(x + 52.3593, y + 88.1118, x + 52.1522, y + 88.1522, x + 51.9739, y + 88.1965);
    ctx.bezierCurveTo(x + 50.9748, y + 88.4396, x + 50.2765, y + 88.92, x + 49.8897, y + 89.6308);
    ctx.lineTo(x + 49.2173, y + 88.7587);
    ctx.lineTo(x + 47.9953, y + 88.9522);
    ctx.bezierCurveTo(x + 47.5236, y + 89.0266, x + 46.7249, y + 89.0916, x + 46.4183, y + 89.1172);
    ctx.bezierCurveTo(x + 46.2494, y + 89.132, x + 46.1462, y + 89.1446, x + 46.1306, y + 89.1466);
    ctx.bezierCurveTo(x + 45.9871, y + 89.1691, x + 45.9184, y + 89.1836, x + 45.8538, y + 89.1986);
    ctx.bezierCurveTo(x + 45.8208, y + 89.2066, x + 45.7877, y + 89.2147, x + 45.7558, y + 89.2244);
    ctx.bezierCurveTo(x + 45.7167, y + 89.2261, x + 45.6829, y + 89.2285, x + 45.6549, y + 89.2303);
    ctx.lineTo(x + 45.5608, y + 89.2371);
    ctx.lineTo(x + 45.467, y + 89.2523);
    ctx.lineTo(x + 44.3914, y + 89.4223);
    ctx.lineTo(x + 43.8486, y + 89.4982);
    ctx.bezierCurveTo(x + 43.0834, y + 89.6041, x + 41.8192, y + 89.7806, x + 41.5449, y + 89.8245);
    ctx.lineTo(x + 41.461, y + 89.8383);
    ctx.lineTo(x + 41.3352, y + 89.8631);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#F7941E";

    ctx.beginPath();
    ctx.moveTo(x + 67.8685, y + 86.7122);
    ctx.bezierCurveTo(x + 67.6008, y + 86.2156, x + 66.5597, y + 84.9783, x + 66.27, y + 84.4383);
    ctx.bezierCurveTo(x + 66.1017, y + 84.1253, x + 65.9239, y + 83.8725, x + 65.6194, y + 83.59);
    ctx.bezierCurveTo(x + 65.3173, y + 83.2366, x + 67.6918, y + 82.1203, x + 67.9323, y + 81.7664);
    ctx.lineTo(x + 71.6366, y + 79.7638);
    ctx.bezierCurveTo(x + 72.0744, y + 79.7769, x + 72.7023, y + 79.5227, x + 72.9864, y + 80.0522);
    ctx.bezierCurveTo(x + 73.283, y + 80.6029, x + 73.5206, y + 81.2001, x + 73.6338, y + 81.8223);
    ctx.lineTo(x + 74.8231, y + 85.3497);
    ctx.bezierCurveTo(x + 74.8106, y + 85.4541, x + 75.1406, y + 86.2242, x + 75.1595, y + 86.3118);
    ctx.bezierCurveTo(x + 75.5719, y + 87.0791, x + 75.8527, y + 88.3225, x + 76.2139, y + 89.5364);
    ctx.bezierCurveTo(x + 76.2967, y + 89.8964, x + 74.7671, y + 90.6957, x + 73.2696, y + 91.5049);
    ctx.bezierCurveTo(x + 73.0643, y + 91.6153, x + 71.8499, y + 92.1474, x + 71.6636, y + 92.1362);
    ctx.bezierCurveTo(x + 71.4633, y + 92.0213, x + 70.8462, y + 91.0575, x + 70.7154, y + 90.8905);
    ctx.bezierCurveTo(x + 70.4753, y + 90.5735, x + 69.3403, y + 88.9551, x + 69.1002, y + 88.638);
    ctx.bezierCurveTo(x + 68.872, y + 88.3463, x + 67.9139, y + 86.7993, x + 67.8685, y + 86.7122);
    ctx.closePath();
    ctx.moveTo(x + 78.989, y + 93.7427);
    ctx.bezierCurveTo(x + 79.8068, y + 95.1842, x + 79.7588, y + 95.2517, x + 78.9299, y + 95.6992);
    ctx.bezierCurveTo(x + 78.4891, y + 95.9382, x + 78.1933, y + 96.1117, x + 77.6887, y + 96.2863);
    ctx.bezierCurveTo(x + 77.6393, y + 96.2712, x + 74.6536, y + 97.9551, x + 74.5197, y + 97.7068);
    ctx.lineTo(x + 73.4207, y + 95.8185);
    ctx.bezierCurveTo(x + 72.6159, y + 94.4261, x + 73.0159, y + 94.9629, x + 72.6449, y + 94.271);
    ctx.bezierCurveTo(x + 72.5429, y + 94.1595, x + 72.6237, y + 93.7937, x + 72.8395, y + 93.6778);
    ctx.bezierCurveTo(x + 73.3026, y + 93.4278, x + 74.2706, y + 92.8763, x + 74.7879, y + 92.596);
    ctx.lineTo(x + 75.6497, y + 92.1306);
    ctx.bezierCurveTo(x + 76.4458, y + 91.6996, x + 77.5591, y + 91.2375, x + 77.7522, y + 91.5943);
    ctx.bezierCurveTo(x + 78.2679, y + 92.5569, x + 78.4968, y + 92.906, x + 78.989, y + 93.7427);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(x + 71.635, y + 79.7651);
    ctx.bezierCurveTo(x + 72.0728, y + 79.7782, x + 72.7007, y + 79.524, x + 72.9848, y + 80.0535);
    ctx.bezierCurveTo(x + 73.2814, y + 80.6043, x + 73.519, y + 81.2014, x + 73.6322, y + 81.8236);
    ctx.lineTo(x + 74.8215, y + 85.351);
    ctx.bezierCurveTo(x + 74.809, y + 85.4554, x + 75.1389, y + 86.2255, x + 75.1579, y + 86.3131);
    ctx.bezierCurveTo(x + 75.5703, y + 87.0804, x + 75.8511, y + 88.3238, x + 76.2123, y + 89.5376);
    ctx.bezierCurveTo(x + 76.2951, y + 89.8976, x + 74.7655, y + 90.6969, x + 73.268, y + 91.5061);
    ctx.bezierCurveTo(x + 73.085, y + 91.6056, x + 72.0921, y + 92.0421, x + 71.7514, y + 92.1244);
    ctx.bezierCurveTo(x + 71.7111, y + 92.1343, x + 71.6813, y + 92.1387, x + 71.662, y + 92.1375);
    ctx.bezierCurveTo(x + 71.4617, y + 92.0225, x + 70.8446, y + 91.0587, x + 70.7138, y + 90.8918);
    ctx.bezierCurveTo(x + 70.4737, y + 90.5747, x + 69.3387, y + 88.9564, x + 69.0986, y + 88.6393);
    ctx.bezierCurveTo(x + 68.8708, y + 88.3448, x + 67.9127, y + 86.7978, x + 67.8673, y + 86.7108);
    ctx.bezierCurveTo(x + 67.5996, y + 86.2142, x + 66.5585, y + 84.9769, x + 66.2688, y + 84.4368);
    ctx.bezierCurveTo(x + 66.1005, y + 84.1239, x + 65.9228, y + 83.871, x + 65.6182, y + 83.5885);
    ctx.bezierCurveTo(x + 65.3162, y + 83.2352, x + 67.6906, y + 82.1189, x + 67.9311, y + 81.765);
    ctx.lineTo(x + 71.635, y + 79.7651);
    ctx.closePath();
    ctx.moveTo(x + 77.1115, y + 91.5162);
    ctx.bezierCurveTo(x + 77.4262, y + 91.4401, x + 77.669, y + 91.445, x + 77.7505, y + 91.5956);
    ctx.bezierCurveTo(x + 78.2678, y + 92.557, x + 78.4979, y + 92.9076, x + 78.9887, y + 93.7441);
    ctx.bezierCurveTo(x + 79.8064, y + 95.1856, x + 79.7585, y + 95.253, x + 78.9296, y + 95.7005);
    ctx.bezierCurveTo(x + 78.4888, y + 95.9396, x + 78.193, y + 96.1131, x + 77.6884, y + 96.2877);
    ctx.bezierCurveTo(x + 77.6884, y + 96.2877, x + 77.6871, y + 96.2875, x + 77.6841, y + 96.2885);
    ctx.bezierCurveTo(x + 77.5721, y + 96.3152, x + 75.359, y + 97.5565, x + 74.6978, y + 97.7169);
    ctx.bezierCurveTo(x + 74.5985, y + 97.7412, x + 74.5346, y + 97.7409, x + 74.5179, y + 97.7094);
    ctx.lineTo(x + 73.4189, y + 95.821);
    ctx.bezierCurveTo(x + 72.6141, y + 94.4287, x + 73.0141, y + 94.9655, x + 72.6431, y + 94.2735);
    ctx.bezierCurveTo(x + 72.5412, y + 94.1621, x + 72.6219, y + 93.7963, x + 72.8377, y + 93.6804);
    ctx.bezierCurveTo(x + 73.3008, y + 93.4304, x + 74.2688, y + 92.8789, x + 74.786, y + 92.5986);
    ctx.lineTo(x + 75.6479, y + 92.1332);
    ctx.bezierCurveTo(x + 76.1099, y + 91.8817, x + 76.6774, y + 91.6208, x + 77.1115, y + 91.5162);
    ctx.closePath();
    ctx.moveTo(x + 71.0791, y + 77.653);
    ctx.lineTo(x + 70.6428, y + 77.9205);
    ctx.lineTo(x + 66.9386, y + 79.9231);
    ctx.lineTo(x + 66.492, y + 80.1641);
    ctx.lineTo(x + 66.3708, y + 80.3431);
    ctx.bezierCurveTo(x + 66.2397, y + 80.4286, x + 66.0737, y + 80.5262, x + 65.8996, y + 80.6324);
    ctx.bezierCurveTo(x + 64.7305, y + 81.3465, x + 63.722, y + 81.9622, x + 63.5308, y + 83.167);
    ctx.lineTo(x + 63.3797, y + 84.1232);
    ctx.lineTo(x + 64.0317, y + 84.9508);
    ctx.lineTo(x + 64.1123, y + 85.0454);
    ctx.lineTo(x + 64.2027, y + 85.1288);
    ctx.bezierCurveTo(x + 64.3093, y + 85.2269, x + 64.3517, y + 85.2842, x + 64.4308, y + 85.4316);
    ctx.bezierCurveTo(x + 64.655, y + 85.847, x + 65.0319, y + 86.3486, x + 65.4299, y + 86.8795);
    ctx.bezierCurveTo(x + 65.6377, y + 87.1574, x + 65.9532, y + 87.5767, x + 66.0348, y + 87.7161);
    ctx.bezierCurveTo(x + 66.1306, y + 87.8951, x + 67.1379, y + 89.5213, x + 67.45, y + 89.9248);
    ctx.bezierCurveTo(x + 67.5518, y + 90.0585, x + 67.8782, y + 90.5212, x + 68.2062, y + 90.9827);
    ctx.bezierCurveTo(x + 68.5658, y + 91.4889, x + 68.9255, y + 91.9938, x + 69.0508, y + 92.16);
    ctx.lineTo(x + 69.1897, y + 92.3601);
    ctx.bezierCurveTo(x + 69.7116, y + 93.1199, x + 70.0447, y + 93.5848, x + 70.521, y + 93.8934);
    ctx.bezierCurveTo(x + 70.4736, y + 94.4158, x + 70.5883, y + 94.9224, x + 70.8477, y + 95.3453);
    ctx.bezierCurveTo(x + 70.8598, y + 95.3692, x + 70.8697, y + 95.3887, x + 70.8773, y + 95.4051);
    ctx.bezierCurveTo(x + 70.9706, y + 95.6967, x + 71.0985, y + 95.9791, x + 71.6128, y + 96.869);
    ctx.lineTo(x + 72.7151, y + 98.7634);
    ctx.bezierCurveTo(x + 73.0449, y + 99.3786, x + 73.9208, y + 100.061, x + 75.1915, y + 99.7523);
    ctx.bezierCurveTo(x + 75.7981, y + 99.6054, x + 76.6509, y + 99.1877, x + 78.1107, y + 98.4208);
    ctx.bezierCurveTo(x + 78.2588, y + 98.3432, x + 78.383, y + 98.2776, x + 78.4666, y + 98.2345);
    ctx.bezierCurveTo(x + 79.0234, y + 98.0335, x + 79.4074, y + 97.8244, x + 79.7793, y + 97.6222);
    ctx.lineTo(x + 79.9204, y + 97.545);
    ctx.bezierCurveTo(x + 80.4241, y + 97.2726, x + 81.2665, y + 96.8171, x + 81.5685, y + 95.7627);
    ctx.bezierCurveTo(x + 81.8919, y + 94.6302, x + 81.3626, y + 93.6965, x + 80.8029, y + 92.7084);
    ctx.lineTo(x + 80.427, y + 92.0744);
    ctx.bezierCurveTo(x + 80.1563, y + 91.622, x + 79.9437, y + 91.2654, x + 79.5858, y + 90.6004);
    ctx.bezierCurveTo(x + 79.3449, y + 90.1534, x + 78.9184, y + 89.7317, x + 78.3109, y + 89.5198);
    ctx.bezierCurveTo(x + 78.3022, y + 89.3763, x + 78.2818, y + 89.2271, x + 78.2457, y + 89.0701);
    ctx.lineTo(x + 78.2307, y + 89.0053);
    ctx.lineTo(x + 78.2114, y + 88.9413);
    ctx.bezierCurveTo(x + 78.124, y + 88.6477, x + 78.0412, y + 88.3505, x + 77.9602, y + 88.0605);
    ctx.bezierCurveTo(x + 77.6957, y + 87.1123, x + 77.4453, y + 86.2148, x + 77.0683, y + 85.4634);
    ctx.bezierCurveTo(x + 77.0458, y + 85.4032, x + 77.0226, y + 85.3373, x + 76.9954, y + 85.2694);
    ctx.bezierCurveTo(x + 76.9809, y + 85.2326, x + 76.9651, y + 85.1942, x + 76.9496, y + 85.1544);
    ctx.lineTo(x + 76.9516, y + 85.1393);
    ctx.lineTo(x + 76.7981, y + 84.6833);
    ctx.lineTo(x + 75.6539, y + 81.2876);
    ctx.bezierCurveTo(x + 75.5026, y + 80.5542, x + 75.2226, y + 79.8062, x + 74.8213, y + 79.0599);
    ctx.bezierCurveTo(x + 74.4188, y + 78.3121, x + 73.5611, y + 77.4623, x + 71.7598, y + 77.6599);
    ctx.lineTo(x + 71.6386, y + 77.6714);
    ctx.lineTo(x + 71.0791, y + 77.653);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#F7941E";

    ctx.beginPath();
    ctx.moveTo(x + 24.3229, y + 102.738);
    ctx.bezierCurveTo(x + 22.7157, y + 96.1056, x + 24.903, y + 92.7193, x + 31.8462, y + 91.0318);
    ctx.bezierCurveTo(x + 35.3768, y + 90.1736, x + 41.121, y + 90.3442, x + 42.775, y + 97.1682);
    ctx.bezierCurveTo(x + 44.6724, y + 104.993, x + 41.3211, y + 107.324, x + 35.8643, y + 108.65);
    ctx.bezierCurveTo(x + 31.1334, y + 109.799, x + 26.1641, y + 110.337, x + 24.3229, y + 102.738);
    ctx.closePath();
    ctx.moveTo(x + 35.0955, y + 106.361);
    ctx.bezierCurveTo(x + 36.2254, y + 106.087, x + 34.9215, y + 100.707, x + 34.5949, y + 99.3583);
    ctx.bezierCurveTo(x + 34.4908, y + 98.9285, x + 33.097, y + 93.1791, x + 31.9672, y + 93.4533);
    ctx.bezierCurveTo(x + 30.8733, y + 93.7185, x + 31.7673, y + 97.4053, x + 32.4894, y + 100.388);
    ctx.bezierCurveTo(x + 32.8487, y + 101.867, x + 34.0016, y + 106.626, x + 35.0955, y + 106.361);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(x + 31.8457, y + 91.0316);
    ctx.bezierCurveTo(x + 35.3763, y + 90.1734, x + 41.1205, y + 90.344, x + 42.7744, y + 97.168);
    ctx.bezierCurveTo(x + 44.6719, y + 104.993, x + 41.3206, y + 107.324, x + 35.8637, y + 108.65);
    ctx.bezierCurveTo(x + 31.1315, y + 109.799, x + 26.1635, y + 110.337, x + 24.3221, y + 102.739);
    ctx.bezierCurveTo(x + 22.7151, y + 96.1054, x + 24.9024, y + 92.7191, x + 31.8457, y + 91.0316);
    ctx.closePath();
    ctx.moveTo(x + 35.095, y + 106.361);
    ctx.bezierCurveTo(x + 36.2248, y + 106.087, x + 34.9209, y + 100.707, x + 34.5943, y + 99.3581);
    ctx.bezierCurveTo(x + 34.4903, y + 98.9283, x + 33.0965, y + 93.1789, x + 31.9666, y + 93.4531);
    ctx.bezierCurveTo(x + 30.8727, y + 93.7183, x + 31.7667, y + 97.4051, x + 32.4889, y + 100.388);
    ctx.bezierCurveTo(x + 32.8482, y + 101.866, x + 34.0011, y + 106.626, x + 35.095, y + 106.361);
    ctx.closePath();
    ctx.moveTo(x + 31.3519, y + 88.9963);
    ctx.bezierCurveTo(x + 23.2918, y + 90.9543, x + 20.4132, y + 95.4777, x + 22.2939, y + 103.231);
    ctx.bezierCurveTo(x + 24.7825, y + 113.498, x + 32.8944, y + 111.527, x + 36.3588, y + 110.685);
    ctx.bezierCurveTo(x + 41.5655, y + 109.42, x + 47.2313, y + 106.684, x + 44.8056, y + 96.675);
    ctx.bezierCurveTo(x + 42.9562, y + 89.0532, x + 36.6435, y + 87.7106, x + 31.3519, y + 88.9963);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="#F7941E";

    ctx.beginPath();
    ctx.moveTo(x + 4.23628, y + 105.235);
    ctx.bezierCurveTo(x + 4.12415, y + 104.949, x + 4.31707, y + 104.503, x + 4.60052, y + 104.391);
    ctx.bezierCurveTo(x + 6.68276, y + 103.567, x + 8.15699, y + 103.037, x + 9.24959, y + 102.604);
    ctx.bezierCurveTo(x + 10.9456, y + 101.933, x + 12.8071, y + 101.118, x + 15.0948, y + 100.213);
    ctx.bezierCurveTo(x + 17.6439, y + 99.2053, x + 21.895, y + 98.5783, x + 23.6534, y + 103.043);
    ctx.bezierCurveTo(x + 25.5876, y + 107.954, x + 23.675, y + 110.677, x + 19.7264, y + 112.239);
    ctx.lineTo(x + 16.5399, y + 113.499);
    ctx.bezierCurveTo(x + 17.0008, y + 114.57, x + 17.0075, y + 114.687, x + 17.4983, y + 115.931);
    ctx.bezierCurveTo(x + 17.943, y + 117.061, x + 17.5044, y + 117.314, x + 16.685, y + 117.639);
    ctx.bezierCurveTo(x + 14.5234, y + 118.494, x + 13.7531, y + 118.878, x + 10.9087, y + 120.003);
    ctx.bezierCurveTo(x + 10.3286, y + 120.233, x + 9.95875, y + 119.428, x + 9.72092, y + 118.823);
    ctx.bezierCurveTo(x + 9.14916, y + 117.373, x + 7.48855, y + 113.489, x + 6.2652, y + 110.384);
    ctx.lineTo(x + 4.23628, y + 105.235);
    ctx.closePath();
    ctx.moveTo(x + 15.7316, y + 110.547);
    ctx.bezierCurveTo(x + 15.8699, y + 110.532, x + 16.1314, y + 110.428, x + 16.6672, y + 110.217);
    ctx.bezierCurveTo(x + 17.7479, y + 109.789, x + 16.3739, y + 106.333, x + 16.0319, y + 105.465);
    ctx.bezierCurveTo(x + 15.9739, y + 105.317, x + 14.9885, y + 102.816, x + 13.9194, y + 103.239);
    ctx.bezierCurveTo(x + 13.4069, y + 103.442, x + 13.802, y + 105.278, x + 14.3556, y + 107.053);
    ctx.bezierCurveTo(x + 14.6764, y + 108.101, x + 15.081, y + 109.26, x + 15.5891, y + 110.551);
    ctx.bezierCurveTo(x + 15.5933, y + 110.561, x + 15.6483, y + 110.566, x + 15.7316, y + 110.547);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.fillStyle="white";

    ctx.beginPath();
    ctx.moveTo(x + 16.5576, y + 99.7465);
    ctx.bezierCurveTo(x + 19.0475, y + 99.1412, x + 22.2, y + 99.3564, x + 23.6532, y + 103.044);
    ctx.bezierCurveTo(x + 25.5874, y + 107.954, x + 23.6748, y + 110.677, x + 19.7262, y + 112.239);
    ctx.lineTo(x + 16.5397, y + 113.499);
    ctx.bezierCurveTo(x + 17.0006, y + 114.57, x + 17.0073, y + 114.687, x + 17.4979, y + 115.932);
    ctx.bezierCurveTo(x + 17.9426, y + 117.062, x + 17.504, y + 117.316, x + 16.6846, y + 117.64);
    ctx.bezierCurveTo(x + 14.5231, y + 118.495, x + 13.7527, y + 118.879, x + 10.9084, y + 120.005);
    ctx.bezierCurveTo(x + 10.8819, y + 120.015, x + 10.8557, y + 120.024, x + 10.8285, y + 120.03);
    ctx.bezierCurveTo(x + 10.2937, y + 120.16, x + 9.94685, y + 119.402, x + 9.71904, y + 118.825);
    ctx.bezierCurveTo(x + 9.14728, y + 117.375, x + 7.48667, y + 113.491, x + 6.26333, y + 110.386);
    ctx.lineTo(x + 4.2346, y + 105.236);
    ctx.bezierCurveTo(x + 4.12247, y + 104.95, x + 4.31539, y + 104.505, x + 4.59884, y + 104.392);
    ctx.bezierCurveTo(x + 6.68107, y + 103.569, x + 8.15532, y + 103.038, x + 9.24791, y + 102.605);
    ctx.bezierCurveTo(x + 10.9439, y + 101.935, x + 12.8053, y + 101.119, x + 15.0931, y + 100.214);
    ctx.bezierCurveTo(x + 15.538, y + 100.038, x + 16.0329, y + 99.8737, x + 16.5576, y + 99.7465);
    ctx.closePath();
    ctx.moveTo(x + 15.8099, y + 110.532);
    ctx.bezierCurveTo(x + 15.9622, y + 110.496, x + 16.2192, y + 110.394, x + 16.6672, y + 110.216);
    ctx.bezierCurveTo(x + 17.7479, y + 109.788, x + 16.3739, y + 106.332, x + 16.0319, y + 105.464);
    ctx.bezierCurveTo(x + 15.9761, y + 105.32, x + 15.0446, y + 102.958, x + 14.011, y + 103.209);
    ctx.bezierCurveTo(x + 13.9809, y + 103.216, x + 13.949, y + 103.225, x + 13.9181, y + 103.238);
    ctx.bezierCurveTo(x + 13.4056, y + 103.441, x + 13.8007, y + 105.277, x + 14.3556, y + 107.051);
    ctx.bezierCurveTo(x + 14.6764, y + 108.099, x + 15.081, y + 109.259, x + 15.5891, y + 110.55);
    ctx.bezierCurveTo(x + 15.5931, y + 110.562, x + 15.6481, y + 110.566, x + 15.733, y + 110.546);
    ctx.bezierCurveTo(x + 15.754, y + 110.544, x + 15.7797, y + 110.539, x + 15.8099, y + 110.532);
    ctx.closePath();
    ctx.moveTo(x + 16.064, y + 97.7098);
    ctx.bezierCurveTo(x + 15.4833, y + 97.8504, x + 14.8978, y + 98.0377, x + 14.325, y + 98.2645);
    ctx.bezierCurveTo(x + 13.0828, y + 98.7552, x + 11.9664, y + 99.2211, x + 10.9313, y + 99.6504);
    ctx.bezierCurveTo(x + 10.0624, y + 100.012, x + 9.25382, y + 100.349, x + 8.48002, y + 100.654);
    ctx.bezierCurveTo(x + 8.03066, y + 100.832, x + 7.51361, y + 101.028, x + 6.91593, y + 101.254);
    ctx.bezierCurveTo(x + 6.06488, y + 101.575, x + 5.05118, y + 101.959, x + 3.83112, y + 102.44);
    ctx.bezierCurveTo(x + 3.1836, y + 102.696, x + 2.64465, y + 103.233, x + 2.35108, y + 103.912);
    ctx.bezierCurveTo(x + 2.0575, y + 104.59, x + 2.03665, y + 105.352, x + 2.29222, y + 106.002);
    ctx.lineTo(x + 4.32095, y + 111.152);
    ctx.bezierCurveTo(x + 5.05272, y + 113.009, x + 5.93943, y + 115.144, x + 6.66013, y + 116.875);
    ctx.bezierCurveTo(x + 7.14253, y + 118.035, x + 7.54803, y + 119.011, x + 7.77666, y + 119.591);
    ctx.bezierCurveTo(x + 8.82025, y + 122.239, x + 10.4454, y + 122.278, x + 11.321, y + 122.064);
    ctx.lineTo(x + 11.4605, y + 122.03);
    ctx.lineTo(x + 11.6741, y + 121.951);
    ctx.bezierCurveTo(x + 13.2129, y + 121.343, x + 14.1516, y + 120.948, x + 15.0253, y + 120.582);
    ctx.bezierCurveTo(x + 15.7665, y + 120.27, x + 16.4591, y + 119.979, x + 17.4503, y + 119.587);
    ctx.bezierCurveTo(x + 20.2594, y + 118.476, x + 19.9017, y + 116.338, x + 19.4381, y + 115.162);
    ctx.bezierCurveTo(x + 19.3653, y + 114.978, x + 19.303, y + 114.819, x + 19.2495, y + 114.677);
    ctx.lineTo(x + 20.4917, y + 114.187);
    ctx.bezierCurveTo(x + 23.0732, y + 113.165, x + 24.8492, y + 111.696, x + 25.7683, y + 109.821);
    ctx.bezierCurveTo(x + 26.798, y + 107.721, x + 26.7386, y + 105.182, x + 25.5932, y + 102.275);
    ctx.bezierCurveTo(x + 24.046, y + 98.3432, x + 20.483, y + 96.6368, x + 16.064, y + 97.7098);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.restore();

  }

  drawElementCrashOG(ctx,scale, x, y) {
    x = x / scale;
    y = y / scale;
ctx.save();
ctx.strokeStyle="rgba(0,0,0,0)";
ctx.miterLimit=4;

ctx.fillStyle="rgba(0,0,0,0)";

// ctx.scale(0.7017543859649122,0.7017543859649122);
ctx.scale(scale, scale);
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 64.3006, y + 14.3766);
ctx.bezierCurveTo(x + 64.313, y + 14.3788, x + 64.3243, y + 14.3699, x + 64.3264, y + 14.3575);
ctx.bezierCurveTo(x + 64.3285, y + 14.3451, x + 64.3196, y + 14.3337, x + 64.3073, y + 14.3316);
ctx.bezierCurveTo(x + 64.2949, y + 14.3295, x + 64.2836, y + 14.3383, x + 64.2815, y + 14.3508);
ctx.bezierCurveTo(x + 64.2797, y + 14.3626, x + 64.2883, y + 14.3745, x + 64.3006, y + 14.3766);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 66.9823, y + 14.8115);
ctx.bezierCurveTo(x + 66.9946, y + 14.8136, x + 67.0059, y + 14.8047, x + 67.008, y + 14.7923);
ctx.bezierCurveTo(x + 67.0101, y + 14.7799, x + 67.0013, y + 14.7685, x + 66.9889, y + 14.7664);
ctx.bezierCurveTo(x + 66.9765, y + 14.7643, x + 66.9652, y + 14.7731, x + 66.9631, y + 14.7856);
ctx.bezierCurveTo(x + 66.9614, y + 14.7974, x + 66.9699, y + 14.8093, x + 66.9823, y + 14.8115);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 69.6639, y + 15.2455);
ctx.bezierCurveTo(x + 69.6763, y + 15.2477, x + 69.6876, y + 15.2388, x + 69.6897, y + 15.2264);
ctx.bezierCurveTo(x + 69.6918, y + 15.214, x + 69.6829, y + 15.2026, x + 69.6705, y + 15.2005);
ctx.bezierCurveTo(x + 69.6582, y + 15.1984, x + 69.6469, y + 15.2072, x + 69.6448, y + 15.2196);
ctx.bezierCurveTo(x + 69.6427, y + 15.2321, x + 69.6512, y + 15.244, x + 69.6639, y + 15.2455);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 72.3456, y + 15.6804);
ctx.bezierCurveTo(x + 72.3579, y + 15.6825, x + 72.3692, y + 15.6736, x + 72.3713, y + 15.6612);
ctx.bezierCurveTo(x + 72.3734, y + 15.6488, x + 72.3646, y + 15.6374, x + 72.3522, y + 15.6353);
ctx.bezierCurveTo(x + 72.3398, y + 15.6332, x + 72.3285, y + 15.642, x + 72.3264, y + 15.6545);
ctx.bezierCurveTo(x + 72.3247, y + 15.6663, x + 72.3326, y + 15.6779, x + 72.3456, y + 15.6804);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 75.0281, y + 16.1077);
ctx.bezierCurveTo(x + 75.0361, y + 16.109, x + 75.0438, y + 16.1037, x + 75.0454, y + 16.095);
ctx.bezierCurveTo(x + 75.0467, y + 16.0869, x + 75.0414, y + 16.0792, x + 75.0334, y + 16.0779);
ctx.bezierCurveTo(x + 75.0253, y + 16.0766, x + 75.0176, y + 16.0819, x + 75.0164, y + 16.0899);
ctx.bezierCurveTo(x + 75.0141, y + 16.0983, x + 75.0194, y + 16.106, x + 75.0281, y + 16.1077);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 77.7108, y + 16.5354);
ctx.bezierCurveTo(x + 77.7153, y + 16.5363, x + 77.7194, y + 16.5335, x + 77.7203, y + 16.5289);
ctx.bezierCurveTo(x + 77.7208, y + 16.5249, x + 77.718, y + 16.5208, x + 77.7134, y + 16.52);
ctx.bezierCurveTo(x + 77.7088, y + 16.5191, x + 77.7048, y + 16.5219, x + 77.7039, y + 16.5265);
ctx.bezierCurveTo(x + 77.7034, y + 16.5304, x + 77.7062, y + 16.5345, x + 77.7108, y + 16.5354);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 54.4836, y + 15.5408);
ctx.bezierCurveTo(x + 54.4917, y + 15.5421, x + 54.4994, y + 15.5368, x + 54.501, y + 15.5281);
ctx.bezierCurveTo(x + 54.5023, y + 15.52, x + 54.497, y + 15.5123, x + 54.489, y + 15.511);
ctx.bezierCurveTo(x + 54.4809, y + 15.5097, x + 54.4732, y + 15.515, x + 54.4716, y + 15.5236);
ctx.bezierCurveTo(x + 54.4703, y + 15.5317, x + 54.4756, y + 15.5395, x + 54.4836, y + 15.5408);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 57.1642, y + 15.9831);
ctx.bezierCurveTo(x + 57.1765, y + 15.9852, x + 57.1878, y + 15.9763, x + 57.1899, y + 15.9639);
ctx.bezierCurveTo(x + 57.192, y + 15.9515, x + 57.1832, y + 15.9402, x + 57.1708, y + 15.938);
ctx.bezierCurveTo(x + 57.1584, y + 15.9359, x + 57.1471, y + 15.9448, x + 57.145, y + 15.9572);
ctx.bezierCurveTo(x + 57.1433, y + 15.969, x + 57.1518, y + 15.981, x + 57.1642, y + 15.9831);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 59.8389, y + 16.4619);
ctx.bezierCurveTo(x + 59.8754, y + 16.468, x + 59.9102, y + 16.4426, x + 59.9165, y + 16.4054);
ctx.bezierCurveTo(x + 59.9224, y + 16.3688, x + 59.8975, y + 16.3332, x + 59.86, y + 16.3275);
ctx.bezierCurveTo(x + 59.8229, y + 16.3211, x + 59.7887, y + 16.3467, x + 59.7825, y + 16.384);
ctx.bezierCurveTo(x + 59.7765, y + 16.4206, x + 59.8015, y + 16.4561, x + 59.8389, y + 16.4619);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 62.5177, y + 16.9112);
ctx.bezierCurveTo(x + 62.5629, y + 16.9189, x + 62.6057, y + 16.8877, x + 62.6127, y + 16.8421);
ctx.bezierCurveTo(x + 62.6196, y + 16.7964, x + 62.5887, y + 16.7544, x + 62.5442, y + 16.747);
ctx.bezierCurveTo(x + 62.499, y + 16.7393, x + 62.4566, y + 16.7699, x + 62.449, y + 16.8152);
ctx.bezierCurveTo(x + 62.4417, y + 16.8615, x + 62.4722, y + 16.9042, x + 62.5177, y + 16.9112);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.1647, y + 17.5625);
ctx.bezierCurveTo(x + 65.3293, y + 17.5891, x + 65.4838, y + 17.4773, x + 65.5099, y + 17.3121);
ctx.bezierCurveTo(x + 65.5364, y + 17.1479, x + 65.4244, y + 16.9917, x + 65.2598, y + 16.9651);
ctx.bezierCurveTo(x + 65.0951, y + 16.9385, x + 64.9407, y + 17.0503, x + 64.9143, y + 17.2146);
ctx.bezierCurveTo(x + 64.8884, y + 17.3807, x + 65.0001, y + 17.5359, x + 65.1647, y + 17.5625);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 67.8461, y + 17.9971);
ctx.bezierCurveTo(x + 68.0107, y + 18.0237, x + 68.1652, y + 17.9119, x + 68.1913, y + 17.7467);
ctx.bezierCurveTo(x + 68.2178, y + 17.5824, x + 68.1058, y + 17.4263, x + 67.9412, y + 17.3997);
ctx.bezierCurveTo(x + 67.7765, y + 17.3731, x + 67.6221, y + 17.4849, x + 67.5957, y + 17.6491);
ctx.bezierCurveTo(x + 67.5698, y + 17.8153, x + 67.6814, y + 17.9705, x + 67.8461, y + 17.9971);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 70.5486, y + 18.2975);
ctx.bezierCurveTo(x + 70.6393, y + 18.3122, x + 70.7245, y + 18.2505, x + 70.7387, y + 18.1601);
ctx.bezierCurveTo(x + 70.7529, y + 18.0697, x + 70.6918, y + 17.9844, x + 70.6012, y + 17.9696);
ctx.bezierCurveTo(x + 70.5105, y + 17.9548, x + 70.4252, y + 18.0166, x + 70.411, y + 18.107);
ctx.bezierCurveTo(x + 70.3968, y + 18.1974, x + 70.4586, y + 18.2831, x + 70.5486, y + 18.2975);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 73.2339, y + 18.7097);
ctx.bezierCurveTo(x + 73.3122, y + 18.7223, x + 73.3856, y + 18.669, x + 73.398, y + 18.5905);
ctx.bezierCurveTo(x + 73.4105, y + 18.5119, x + 73.3573, y + 18.4382, x + 73.279, y + 18.4255);
ctx.bezierCurveTo(x + 73.2007, y + 18.4129, x + 73.1273, y + 18.4662, x + 73.1146, y + 18.5438);
ctx.bezierCurveTo(x + 73.1024, y + 18.6233, x + 73.1562, y + 18.6974, x + 73.2339, y + 18.7097);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 75.9192, y + 19.1218);
ctx.bezierCurveTo(x + 75.9851, y + 19.1323, x + 76.0466, y + 19.0876, x + 76.0569, y + 19.0214);
ctx.bezierCurveTo(x + 76.0673, y + 18.9553, x + 76.0226, y + 18.8935, x + 75.9576, y + 18.8827);
ctx.bezierCurveTo(x + 75.8917, y + 18.8722, x + 75.8302, y + 18.9169, x + 75.8193, y + 18.9827);
ctx.bezierCurveTo(x + 75.8089, y + 19.0489, x + 75.8533, y + 19.1113, x + 75.9192, y + 19.1218);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 78.6064, y + 19.5189);
ctx.bezierCurveTo(x + 78.6515, y + 19.5266, x + 78.6943, y + 19.4954, x + 78.7013, y + 19.4497);
ctx.bezierCurveTo(x + 78.7083, y + 19.4041, x + 78.6774, y + 19.362, x + 78.6328, y + 19.3547);
ctx.bezierCurveTo(x + 78.5876, y + 19.347, x + 78.5452, y + 19.3776, x + 78.5376, y + 19.4229);
ctx.bezierCurveTo(x + 78.53, y + 19.4682, x + 78.5615, y + 19.5122, x + 78.6064, y + 19.5189);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 81.2977, y + 19.8944);
ctx.bezierCurveTo(x + 81.3101, y + 19.8965, x + 81.3214, y + 19.8876, x + 81.3235, y + 19.8752);
ctx.bezierCurveTo(x + 81.3256, y + 19.8628, x + 81.3167, y + 19.8514, x + 81.3043, y + 19.8493);
ctx.bezierCurveTo(x + 81.292, y + 19.8472, x + 81.2801, y + 19.8557, x + 81.2786, y + 19.8685);
ctx.bezierCurveTo(x + 81.2768, y + 19.8803, x + 81.2853, y + 19.8922, x + 81.2977, y + 19.8944);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 50.0278, y + 17.5893);
ctx.bezierCurveTo(x + 50.0402, y + 17.5914, x + 50.0521, y + 17.5829, x + 50.0536, y + 17.5701);
ctx.bezierCurveTo(x + 50.0557, y + 17.5577, x + 50.0471, y + 17.5458, x + 50.0344, y + 17.5442);
ctx.bezierCurveTo(x + 50.0221, y + 17.5421, x + 50.0108, y + 17.551, x + 50.0087, y + 17.5634);
ctx.bezierCurveTo(x + 50.0069, y + 17.5752, x + 50.0154, y + 17.5872, x + 50.0278, y + 17.5893);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 52.6994, y + 18.0834);
ctx.bezierCurveTo(x + 52.7445, y + 18.0911, x + 52.7873, y + 18.0599, x + 52.7943, y + 18.0142);
ctx.bezierCurveTo(x + 52.8019, y + 17.9689, x + 52.7704, y + 17.9265, x + 52.7258, y + 17.9191);
ctx.bezierCurveTo(x + 52.6807, y + 17.9114, x + 52.6382, y + 17.942, x + 52.6306, y + 17.9873);
ctx.bezierCurveTo(x + 52.6237, y + 18.033, x + 52.6542, y + 18.0757, x + 52.6994, y + 18.0834);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 55.3467, y + 18.7339);
ctx.bezierCurveTo(x + 55.5113, y + 18.7605, x + 55.6658, y + 18.6487, x + 55.692, y + 18.4835);
ctx.bezierCurveTo(x + 55.7184, y + 18.3192, x + 55.6061, y + 18.1637, x + 55.4418, y + 18.1365);
ctx.bezierCurveTo(x + 55.2772, y + 18.1099, x + 55.1227, y + 18.2217, x + 55.0963, y + 18.386);
ctx.bezierCurveTo(x + 55.0704, y + 18.5521, x + 55.1821, y + 18.7073, x + 55.3467, y + 18.7339);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 58.0373, y + 19.1091);
ctx.bezierCurveTo(x + 58.1688, y + 19.1308, x + 58.2927, y + 19.041, x + 58.3134, y + 18.9087);
ctx.bezierCurveTo(x + 58.3347, y + 18.7768, x + 58.2447, y + 18.6529, x + 58.1138, y + 18.6316);
ctx.bezierCurveTo(x + 57.9823, y + 18.61, x + 57.8584, y + 18.6997, x + 57.8375, y + 18.8311);
ctx.bezierCurveTo(x + 57.8168, y + 18.9634, x + 57.9064, y + 19.0878, x + 58.0373, y + 19.1091);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 60.7096, y + 19.6035);
ctx.bezierCurveTo(x + 60.8742, y + 19.6301, x + 61.0287, y + 19.5183, x + 61.0549, y + 19.3531);
ctx.bezierCurveTo(x + 61.0813, y + 19.1889, x + 60.9693, y + 19.0327, x + 60.8047, y + 19.0061);
ctx.bezierCurveTo(x + 60.6401, y + 18.9795, x + 60.4856, y + 19.0914, x + 60.4592, y + 19.2556);
ctx.bezierCurveTo(x + 60.4336, y + 19.4211, x + 60.545, y + 19.5769, x + 60.7096, y + 19.6035);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 63.3541, y + 20.2694);
ctx.bezierCurveTo(x + 63.6459, y + 20.3168, x + 63.92, y + 20.1185, x + 63.9667, y + 19.8257);
ctx.bezierCurveTo(x + 64.0133, y + 19.5329, x + 63.8152, y + 19.2574, x + 63.5234, y + 19.21);
ctx.bezierCurveTo(x + 63.2316, y + 19.1626, x + 62.9575, y + 19.3609, x + 62.9108, y + 19.6537);
ctx.bezierCurveTo(x + 62.8636, y + 19.9462, x + 63.0623, y + 20.222, x + 63.3541, y + 20.2694);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 66.0234, y + 20.7789);
ctx.bezierCurveTo(x + 66.3561, y + 20.8331, x + 66.6691, y + 20.6063, x + 66.7229, y + 20.2719);
ctx.bezierCurveTo(x + 66.7763, y + 19.9381, x + 66.5497, y + 19.6235, x + 66.217, y + 19.5692);
ctx.bezierCurveTo(x + 65.8844, y + 19.515, x + 65.5713, y + 19.7418, x + 65.5179, y + 20.0756);
ctx.bezierCurveTo(x + 65.4641, y + 20.41, x + 65.6907, y + 20.7246, x + 66.0234, y + 20.7789);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 68.7049, y + 21.2136);
ctx.bezierCurveTo(x + 69.0376, y + 21.2678, x + 69.3506, y + 21.041, x + 69.404, y + 20.7072);
ctx.bezierCurveTo(x + 69.4575, y + 20.3734, x + 69.2308, y + 20.0588, x + 68.8982, y + 20.0045);
ctx.bezierCurveTo(x + 68.5655, y + 19.9503, x + 68.2525, y + 20.1771, x + 68.199, y + 20.5109);
ctx.bezierCurveTo(x + 68.1456, y + 20.8447, x + 68.3722, y + 21.1593, x + 68.7049, y + 21.2136);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 71.3864, y + 21.6485);
ctx.bezierCurveTo(x + 71.7191, y + 21.7028, x + 72.0322, y + 21.4759, x + 72.0859, y + 21.1415);
ctx.bezierCurveTo(x + 72.1393, y + 20.8077, x + 71.9127, y + 20.4931, x + 71.5801, y + 20.4389);
ctx.bezierCurveTo(x + 71.2474, y + 20.3846, x + 70.9344, y + 20.6115, x + 70.8809, y + 20.9452);
ctx.bezierCurveTo(x + 70.8272, y + 21.2796, x + 71.0538, y + 21.5943, x + 71.3864, y + 21.6485);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.1102, y + 21.8215);
ctx.bezierCurveTo(x + 74.2989, y + 21.852, x + 74.4768, y + 21.7237, x + 74.5072, y + 21.5337);
ctx.bezierCurveTo(x + 74.5372, y + 21.3443, x + 74.4091, y + 21.1655, x + 74.2197, y + 21.1347);
ctx.bezierCurveTo(x + 74.031, y + 21.1042, x + 73.8527, y + 21.233, x + 73.8227, y + 21.4224);
ctx.bezierCurveTo(x + 73.7923, y + 21.6125, x + 73.9208, y + 21.7907, x + 74.1102, y + 21.8215);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 76.7935, y + 22.2412);
ctx.bezierCurveTo(x + 76.9742, y + 22.2704, x + 77.1444, y + 22.1475, x + 77.1731, y + 21.9661);
ctx.bezierCurveTo(x + 77.2019, y + 21.7848, x + 77.079, y + 21.6137, x + 76.8983, y + 21.5845);
ctx.bezierCurveTo(x + 76.7176, y + 21.5554, x + 76.5474, y + 21.6783, x + 76.518, y + 21.8593);
ctx.bezierCurveTo(x + 76.4896, y + 22.0401, x + 76.6131, y + 22.2114, x + 76.7935, y + 22.2412);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 79.4796, y + 22.646);
ctx.bezierCurveTo(x + 79.6443, y + 22.6726, x + 79.7987, y + 22.5608, x + 79.8249, y + 22.3956);
ctx.bezierCurveTo(x + 79.8513, y + 22.2313, x + 79.7394, y + 22.0752, x + 79.5747, y + 22.0486);
ctx.bezierCurveTo(x + 79.4101, y + 22.022, x + 79.2556, y + 22.1338, x + 79.2292, y + 22.2981);
ctx.bezierCurveTo(x + 79.2036, y + 22.4636, x + 79.3153, y + 22.6188, x + 79.4796, y + 22.646);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 82.1674, y + 23.0433);
ctx.bezierCurveTo(x + 82.3113, y + 23.0671, x + 82.4464, y + 22.9685, x + 82.4698, y + 22.8241);
ctx.bezierCurveTo(x + 82.4932, y + 22.6798, x + 82.3947, y + 22.5439, x + 82.2515, y + 22.5205);
ctx.bezierCurveTo(x + 82.1076, y + 22.4967, x + 81.9724, y + 22.5954, x + 81.9493, y + 22.7391);
ctx.bezierCurveTo(x + 81.9259, y + 22.8835, x + 82.0235, y + 23.0196, x + 82.1674, y + 23.0433);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 84.8775, y + 23.2984);
ctx.bezierCurveTo(x + 84.9227, y + 23.3061, x + 84.9655, y + 23.2749, x + 84.9725, y + 23.2292);
ctx.bezierCurveTo(x + 84.9794, y + 23.1836, x + 84.9485, y + 23.1415, x + 84.904, y + 23.1342);
ctx.bezierCurveTo(x + 84.8594, y + 23.1268, x + 84.8164, y + 23.1571, x + 84.8088, y + 23.2024);
ctx.bezierCurveTo(x + 84.8015, y + 23.2487, x + 84.832, y + 23.2913, x + 84.8775, y + 23.2984);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 87.57, y + 23.6658);
ctx.bezierCurveTo(x + 87.5781, y + 23.6671, x + 87.5858, y + 23.6618, x + 87.5874, y + 23.6531);
ctx.bezierCurveTo(x + 87.5887, y + 23.645, x + 87.5834, y + 23.6373, x + 87.5754, y + 23.636);
ctx.bezierCurveTo(x + 87.5673, y + 23.6347, x + 87.5596, y + 23.64, x + 87.558, y + 23.6486);
ctx.bezierCurveTo(x + 87.5558, y + 23.657, x + 87.5617, y + 23.6651, x + 87.57, y + 23.6658);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 45.573, y + 19.6298);
ctx.bezierCurveTo(x + 45.5853, y + 19.632, x + 45.5966, y + 19.6231, x + 45.5987, y + 19.6107);
ctx.bezierCurveTo(x + 45.6008, y + 19.5983, x + 45.5923, y + 19.5863, x + 45.5796, y + 19.5848);
ctx.bezierCurveTo(x + 45.5672, y + 19.5826, x + 45.5559, y + 19.5915, x + 45.5538, y + 19.6039);
ctx.bezierCurveTo(x + 45.5517, y + 19.6163, x + 45.56, y + 19.6274, x + 45.573, y + 19.6298);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 48.2447, y + 20.124);
ctx.bezierCurveTo(x + 48.2899, y + 20.1317, x + 48.3327, y + 20.1005, x + 48.3397, y + 20.0548);
ctx.bezierCurveTo(x + 48.3473, y + 20.0095, x + 48.3157, y + 19.9671, x + 48.2712, y + 19.9597);
ctx.bezierCurveTo(x + 48.226, y + 19.952, x + 48.1836, y + 19.9826, x + 48.1766, y + 20.0283);
ctx.bezierCurveTo(x + 48.1687, y + 20.0742, x + 48.1992, y + 20.1169, x + 48.2447, y + 20.124);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 50.8951, y + 20.7532);
ctx.bezierCurveTo(x + 51.047, y + 20.7782, x + 51.1905, y + 20.6747, x + 51.2146, y + 20.5219);
ctx.bezierCurveTo(x + 51.2393, y + 20.3695, x + 51.1355, y + 20.2259, x + 50.9836, y + 20.2008);
ctx.bezierCurveTo(x + 50.8316, y + 20.1757, x + 50.6882, y + 20.2793, x + 50.6641, y + 20.4321);
ctx.bezierCurveTo(x + 50.6394, y + 20.5845, x + 50.7432, y + 20.7281, x + 50.8951, y + 20.7532);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 53.524, y + 21.5158);
ctx.bezierCurveTo(x + 53.8566, y + 21.5701, x + 54.1697, y + 21.3432, x + 54.2231, y + 21.0094);
ctx.bezierCurveTo(x + 54.2766, y + 20.6757, x + 54.0499, y + 20.361, x + 53.7173, y + 20.3068);
ctx.bezierCurveTo(x + 53.3846, y + 20.2525, x + 53.0716, y + 20.4794, x + 53.0181, y + 20.8132);
ctx.bezierCurveTo(x + 52.9647, y + 21.1469, x + 53.1913, y + 21.4616, x + 53.524, y + 21.5158);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 56.2281, y + 21.8089);
ctx.bezierCurveTo(x + 56.4825, y + 21.8505, x + 56.7222, y + 21.6769, x + 56.7635, y + 21.4211);
ctx.bezierCurveTo(x + 56.8045, y + 21.1659, x + 56.6311, y + 20.925, x + 56.3761, y + 20.883);
ctx.bezierCurveTo(x + 56.1217, y + 20.8414, x + 55.8811, y + 21.0153, x + 55.8407, y + 21.2708);
ctx.bezierCurveTo(x + 55.7997, y + 21.526, x + 55.9732, y + 21.7669, x + 56.2281, y + 21.8089);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 58.8979, y + 22.318);
ctx.bezierCurveTo(x + 59.1935, y + 22.3658, x + 59.4724, y + 22.1646, x + 59.5195, y + 21.8681);
ctx.bezierCurveTo(x + 59.5666, y + 21.5716, x + 59.3653, y + 21.2918, x + 59.0698, y + 21.244);
ctx.bezierCurveTo(x + 58.7742, y + 21.1961, x + 58.4953, y + 21.3973, x + 58.4482, y + 21.6939);
ctx.bezierCurveTo(x + 58.4004, y + 21.99, x + 58.6018, y + 22.2698, x + 58.8979, y + 22.318);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 61.5684, y + 22.82);
ctx.bezierCurveTo(x + 61.9011, y + 22.8743, x + 62.2141, y + 22.6474, x + 62.2676, y + 22.3136);
ctx.bezierCurveTo(x + 62.321, y + 21.9799, x + 62.0944, y + 21.6652, x + 61.7617, y + 21.611);
ctx.bezierCurveTo(x + 61.4291, y + 21.5567, x + 61.116, y + 21.7836, x + 61.0626, y + 22.1174);
ctx.bezierCurveTo(x + 61.0091, y + 22.4511, x + 61.2358, y + 22.7658, x + 61.5684, y + 22.82);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 64.2102, y + 23.5004);
ctx.bezierCurveTo(x + 64.6787, y + 23.5771, x + 65.1195, y + 23.2579, x + 65.1944, y + 22.7875);
ctx.bezierCurveTo(x + 65.2696, y + 22.318, x + 64.9507, y + 21.875, x + 64.4822, y + 21.7983);
ctx.bezierCurveTo(x + 64.0137, y + 21.7216, x + 63.573, y + 22.0408, x + 63.4984, y + 22.5106);
ctx.bezierCurveTo(x + 63.4231, y + 22.9817, x + 63.7424, y + 23.4241, x + 64.2102, y + 23.5004);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 66.9206, y + 23.7563);
ctx.bezierCurveTo(x + 67.2904, y + 23.817, x + 67.6382, y + 23.5648, x + 67.6979, y + 23.1938);
ctx.bezierCurveTo(x + 67.7571, y + 22.8224, x + 67.5058, y + 22.4732, x + 67.1356, y + 22.4132);
ctx.bezierCurveTo(x + 66.7655, y + 22.3531, x + 66.4181, y + 22.6047, x + 66.3583, y + 22.9757);
ctx.bezierCurveTo(x + 66.299, y + 23.3461, x + 66.5509, y + 23.6957, x + 66.9206, y + 23.7563);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 69.6061, y + 24.1683);
ctx.bezierCurveTo(x + 69.9635, y + 24.2268, x + 70.2994, y + 23.9832, x + 70.357, y + 23.6246);
ctx.bezierCurveTo(x + 70.4146, y + 23.266, x + 70.1712, y + 22.9284, x + 69.8138, y + 22.8698);
ctx.bezierCurveTo(x + 69.4564, y + 22.8113, x + 69.1205, y + 23.055, x + 69.0629, y + 23.4136);
ctx.bezierCurveTo(x + 69.0053, y + 23.7722, x + 69.2487, y + 24.1098, x + 69.6061, y + 24.1683);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 72.2946, y + 24.5584);
ctx.bezierCurveTo(x + 72.6273, y + 24.6127, x + 72.9404, y + 24.3858, x + 72.9941, y + 24.0514);
ctx.bezierCurveTo(x + 73.0476, y + 23.7177, x + 72.8209, y + 23.403, x + 72.4883, y + 23.3488);
ctx.bezierCurveTo(x + 72.1556, y + 23.2945, x + 71.8426, y + 23.5214, x + 71.7891, y + 23.8552);
ctx.bezierCurveTo(x + 71.7354, y + 24.1895, x + 71.962, y + 24.5042, x + 72.2946, y + 24.5584);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.9756, y + 24.9929);
ctx.bezierCurveTo(x + 75.3083, y + 25.0471, x + 75.6214, y + 24.8203, x + 75.6748, y + 24.4865);
ctx.bezierCurveTo(x + 75.7282, y + 24.1527, x + 75.5016, y + 23.8381, x + 75.1689, y + 23.7838);
ctx.bezierCurveTo(x + 74.8363, y + 23.7296, x + 74.5232, y + 23.9564, x + 74.4698, y + 24.2902);
ctx.bezierCurveTo(x + 74.4164, y + 24.624, x + 74.643, y + 24.9386, x + 74.9756, y + 24.9929);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 77.6623, y + 25.3979);
ctx.bezierCurveTo(x + 77.9782, y + 25.4492, x + 78.2762, y + 25.2338, x + 78.327, y + 24.9162);
ctx.bezierCurveTo(x + 78.3775, y + 24.5992, x + 78.1624, y + 24.2998, x + 77.8458, y + 24.2481);
ctx.bezierCurveTo(x + 77.5293, y + 24.1965, x + 77.232, y + 24.4122, x + 77.1811, y + 24.7298);
ctx.bezierCurveTo(x + 77.1306, y + 25.0468, x + 77.3457, y + 25.3462, x + 77.6623, y + 25.3979);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 80.3715, y + 25.6603);
ctx.bezierCurveTo(x + 80.5931, y + 25.6964, x + 80.8019, y + 25.5455, x + 80.8377, y + 25.3225);
ctx.bezierCurveTo(x + 80.8732, y + 25.1002, x + 80.7219, y + 24.89, x + 80.5003, y + 24.854);
ctx.bezierCurveTo(x + 80.2787, y + 24.8179, x + 80.0699, y + 24.9689, x + 80.0344, y + 25.1912);
ctx.bezierCurveTo(x + 79.9983, y + 25.4147, x + 80.1494, y + 25.6239, x + 80.3715, y + 25.6603);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 83.0804, y + 25.9233);
ctx.bezierCurveTo(x + 83.2075, y + 25.9441, x + 83.3276, y + 25.857, x + 83.348, y + 25.7294);
ctx.bezierCurveTo(x + 83.3685, y + 25.6018, x + 83.2821, y + 25.4815, x + 83.1544, y + 25.4603);
ctx.bezierCurveTo(x + 83.0272, y + 25.4395, x + 82.9072, y + 25.5267, x + 82.8867, y + 25.6543);
ctx.bezierCurveTo(x + 82.8662, y + 25.7819, x + 82.9522, y + 25.9028, x + 83.0804, y + 25.9233);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 85.7565, y + 26.3878);
ctx.bezierCurveTo(x + 85.9004, y + 26.4116, x + 86.0355, y + 26.313, x + 86.0589, y + 26.1686);
ctx.bezierCurveTo(x + 86.0823, y + 26.0242, x + 85.9838, y + 25.8884, x + 85.8406, y + 25.865);
ctx.bezierCurveTo(x + 85.6967, y + 25.8412, x + 85.5615, y + 25.9398, x + 85.5385, y + 26.0836);
ctx.bezierCurveTo(x + 85.5153, y + 26.2289, x + 85.6132, y + 26.3644, x + 85.7565, y + 26.3878);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 88.4675, y + 26.6432);
ctx.bezierCurveTo(x + 88.5126, y + 26.6509, x + 88.5554, y + 26.6197, x + 88.5624, y + 26.574);
ctx.bezierCurveTo(x + 88.5693, y + 26.5284, x + 88.5384, y + 26.4863, x + 88.4939, y + 26.4789);
ctx.bezierCurveTo(x + 88.4487, y + 26.4712, x + 88.4063, y + 26.5018, x + 88.3987, y + 26.5472);
ctx.bezierCurveTo(x + 88.3908, y + 26.5931, x + 88.422, y + 26.6361, x + 88.4675, y + 26.6432);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 43.7964, y + 22.12);
ctx.bezierCurveTo(x + 43.8168, y + 22.1234, x + 43.8364, y + 22.1096, x + 43.8401, y + 22.0885);
ctx.bezierCurveTo(x + 43.8435, y + 22.068, x + 43.8294, y + 22.0489, x + 43.809, y + 22.0455);
ctx.bezierCurveTo(x + 43.7885, y + 22.0421, x + 43.7689, y + 22.0559, x + 43.7656, y + 22.0764);
ctx.bezierCurveTo(x + 43.7618, y + 22.0975, x + 43.776, y + 22.1166, x + 43.7964, y + 22.12);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 46.4471, y + 22.7485);
ctx.bezierCurveTo(x + 46.5742, y + 22.7693, x + 46.6943, y + 22.6822, x + 46.7148, y + 22.5546);
ctx.bezierCurveTo(x + 46.7352, y + 22.427, x + 46.6482, y + 22.3064, x + 46.5211, y + 22.2855);
ctx.bezierCurveTo(x + 46.3939, y + 22.2647, x + 46.2739, y + 22.3518, x + 46.2534, y + 22.4795);
ctx.bezierCurveTo(x + 46.2335, y + 22.6074, x + 46.3195, y + 22.7283, x + 46.4471, y + 22.7485);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 49.1176, y + 23.2507);
ctx.bezierCurveTo(x + 49.2819, y + 23.2779, x + 49.4366, y + 23.1655, x + 49.4628, y + 23.0003);
ctx.bezierCurveTo(x + 49.4893, y + 22.8361, x + 49.3773, y + 22.6799, x + 49.2127, y + 22.6533);
ctx.bezierCurveTo(x + 49.048, y + 22.6268, x + 48.8936, y + 22.7386, x + 48.8671, y + 22.9028);
ctx.bezierCurveTo(x + 48.8416, y + 23.0683, x + 48.9539, y + 23.2239, x + 49.1176, y + 23.2507);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 51.7625, y + 23.9167);
ctx.bezierCurveTo(x + 52.0543, y + 23.9641, x + 52.3287, y + 23.7652, x + 52.3754, y + 23.4724);
ctx.bezierCurveTo(x + 52.4221, y + 23.1796, x + 52.224, y + 22.9041, x + 51.9322, y + 22.8567);
ctx.bezierCurveTo(x + 51.6403, y + 22.8093, x + 51.3662, y + 23.0076, x + 51.319, y + 23.3001);
ctx.bezierCurveTo(x + 51.272, y + 23.5935, x + 51.4707, y + 23.8693, x + 51.7625, y + 23.9167);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 54.4319, y + 24.4262);
ctx.bezierCurveTo(x + 54.7646, y + 24.4805, x + 55.0777, y + 24.2536, x + 55.1311, y + 23.9198);
ctx.bezierCurveTo(x + 55.1845, y + 23.5861, x + 54.9579, y + 23.2714, x + 54.6252, y + 23.2172);
ctx.bezierCurveTo(x + 54.2926, y + 23.1629, x + 53.9795, y + 23.3898, x + 53.9261, y + 23.7236);
ctx.bezierCurveTo(x + 53.8727, y + 24.0573, x + 54.0993, y + 24.372, x + 54.4319, y + 24.4262);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 57.0574, y + 25.2111);
ctx.bezierCurveTo(x + 57.5832, y + 25.2967, x + 58.0783, y + 24.9383, x + 58.1626, y + 24.4108);
ctx.bezierCurveTo(x + 58.2469, y + 23.8833, x + 57.8885, y + 23.3863, x + 57.3628, y + 23.3007);
ctx.bezierCurveTo(x + 56.837, y + 23.2151, x + 56.3419, y + 23.5735, x + 56.2579, y + 24.1004);
ctx.bezierCurveTo(x + 56.1733, y + 24.6285, x + 56.5317, y + 25.1256, x + 57.0574, y + 25.2111);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 59.7707, y + 25.4445);
ctx.bezierCurveTo(x + 60.1854, y + 25.5119, x + 60.5763, y + 25.2295, x + 60.643, y + 24.8128);
ctx.bezierCurveTo(x + 60.7097, y + 24.3961, x + 60.4272, y + 24.0039, x + 60.0125, y + 23.9365);
ctx.bezierCurveTo(x + 59.5978, y + 23.8691, x + 59.207, y + 24.1516, x + 59.1406, y + 24.5676);
ctx.bezierCurveTo(x + 59.0739, y + 24.9843, x + 59.3561, y + 25.3772, x + 59.7707, y + 25.4445);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 62.444, y + 25.9314);
ctx.bezierCurveTo(x + 62.8877, y + 26.0039, x + 63.305, y + 25.7011, x + 63.3764, y + 25.2558);
ctx.bezierCurveTo(x + 63.4474, y + 24.8112, x + 63.1458, y + 24.3915, x + 62.7021, y + 24.3191);
ctx.bezierCurveTo(x + 62.2584, y + 24.2466, x + 61.841, y + 24.5494, x + 61.77, y + 24.9941);
ctx.bezierCurveTo(x + 61.6987, y + 25.4393, x + 62.0002, y + 25.859, x + 62.444, y + 25.9314);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.1019, y + 26.5153);
ctx.bezierCurveTo(x + 65.6276, y + 26.6009, x + 66.1228, y + 26.2425, x + 66.207, y + 25.715);
ctx.bezierCurveTo(x + 66.2913, y + 25.1875, x + 65.9336, y + 24.6908, x + 65.4072, y + 24.6049);
ctx.bezierCurveTo(x + 64.8815, y + 24.5193, x + 64.3863, y + 24.8777, x + 64.302, y + 25.4052);
ctx.bezierCurveTo(x + 64.2181, y + 25.9321, x + 64.5761, y + 26.4298, x + 65.1019, y + 26.5153);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 67.7833, y + 26.9502);
ctx.bezierCurveTo(x + 68.309, y + 27.0357, x + 68.8042, y + 26.6774, x + 68.8884, y + 26.1498);
ctx.bezierCurveTo(x + 68.9727, y + 25.6223, x + 68.615, y + 25.1256, x + 68.0886, y + 25.0397);
ctx.bezierCurveTo(x + 67.5628, y + 24.9541, x + 67.0677, y + 25.3125, x + 66.9838, y + 25.8394);
ctx.bezierCurveTo(x + 66.8995, y + 26.3669, x + 67.2569, y + 26.8642, x + 67.7833, y + 26.9502);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 70.4651, y + 27.3842);
ctx.bezierCurveTo(x + 70.9909, y + 27.4698, x + 71.486, y + 27.1114, x + 71.5703, y + 26.5839);
ctx.bezierCurveTo(x + 71.6546, y + 26.0564, x + 71.2963, y + 25.5594, x + 70.7705, y + 25.4738);
ctx.bezierCurveTo(x + 70.2447, y + 25.3882, x + 69.7496, y + 25.7466, x + 69.6653, y + 26.2741);
ctx.bezierCurveTo(x + 69.5811, y + 26.8016, x + 69.9388, y + 27.2983, x + 70.4651, y + 27.3842);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 73.1621, y + 27.7222);
ctx.bezierCurveTo(x + 73.6343, y + 27.7994, x + 74.0793, y + 27.4769, x + 74.1553, y + 27.0031);
ctx.bezierCurveTo(x + 74.2313, y + 26.5293, x + 73.9092, y + 26.0821, x + 73.4366, y + 26.0055);
ctx.bezierCurveTo(x + 72.9644, y + 25.9283, x + 72.5194, y + 26.2508, x + 72.4438, y + 26.724);
ctx.bezierCurveTo(x + 72.3674, y + 27.1984, x + 72.689, y + 27.6453, x + 73.1621, y + 27.7222);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 75.8282, y + 28.2539);
ctx.bezierCurveTo(x + 76.3539, y + 28.3394, x + 76.8491, y + 27.9811, x + 76.9333, y + 27.4535);
ctx.bezierCurveTo(x + 77.0176, y + 26.926, x + 76.6599, y + 26.4293, x + 76.1335, y + 26.3434);
ctx.bezierCurveTo(x + 75.6078, y + 26.2578, x + 75.1126, y + 26.6162, x + 75.0284, y + 27.1437);
ctx.bezierCurveTo(x + 74.9444, y + 27.6707, x + 75.3018, y + 28.168, x + 75.8282, y + 28.2539);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 78.5499, y + 28.4346);
ctx.bezierCurveTo(x + 78.9358, y + 28.4978, x + 79.2994, y + 28.2345, x + 79.3614, y + 27.8463);
ctx.bezierCurveTo(x + 79.4231, y + 27.4588, x + 79.1606, y + 27.0938, x + 78.7744, y + 27.0311);
ctx.bezierCurveTo(x + 78.3882, y + 26.9685, x + 78.025, y + 27.2312, x + 77.9633, y + 27.6188);
ctx.bezierCurveTo(x + 77.9007, y + 28.0065, x + 78.1637, y + 28.3719, x + 78.5499, y + 28.4346);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 81.2469, y + 28.7724);
ctx.bezierCurveTo(x + 81.5796, y + 28.8267, x + 81.8926, y + 28.5998, x + 81.946, y + 28.266);
ctx.bezierCurveTo(x + 81.9995, y + 27.9323, x + 81.7728, y + 27.6176, x + 81.4402, y + 27.5634);
ctx.bezierCurveTo(x + 81.1075, y + 27.5091, x + 80.7945, y + 27.736, x + 80.741, y + 28.0698);
ctx.bezierCurveTo(x + 80.6876, y + 28.4035, x + 80.9142, y + 28.7182, x + 81.2469, y + 28.7724);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 83.945, y + 29.1022);
ctx.bezierCurveTo(x + 84.2207, y + 29.147, x + 84.4794, y + 28.9592, x + 84.5232, y + 28.6832);
ctx.bezierCurveTo(x + 84.567, y + 28.4071, x + 84.3804, y + 28.1469, x + 84.1046, y + 28.1021);
ctx.bezierCurveTo(x + 83.8289, y + 28.0573, x + 83.5702, y + 28.245, x + 83.5264, y + 28.5211);
ctx.bezierCurveTo(x + 83.4827, y + 28.7971, x + 83.6699, y + 29.0577, x + 83.945, y + 29.1022);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 86.6586, y + 29.3352);
ctx.bezierCurveTo(x + 86.8229, y + 29.3624, x + 86.9777, y + 29.25, x + 87.0038, y + 29.0848);
ctx.bezierCurveTo(x + 87.0303, y + 28.9206, x + 86.9183, y + 28.7644, x + 86.7537, y + 28.7378);
ctx.bezierCurveTo(x + 86.589, y + 28.7112, x + 86.4346, y + 28.823, x + 86.4082, y + 28.9873);
ctx.bezierCurveTo(x + 86.3826, y + 29.1528, x + 86.4943, y + 29.308, x + 86.6586, y + 29.3352);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 89.34, y + 29.77);
ctx.bezierCurveTo(x + 89.5046, y + 29.7966, x + 89.6591, y + 29.6848, x + 89.6852, y + 29.5196);
ctx.bezierCurveTo(x + 89.7117, y + 29.3554, x + 89.5997, y + 29.1992, x + 89.4351, y + 29.1726);
ctx.bezierCurveTo(x + 89.2704, y + 29.146, x + 89.116, y + 29.2579, x + 89.0896, y + 29.4221);
ctx.bezierCurveTo(x + 89.064, y + 29.5876, x + 89.1757, y + 29.7428, x + 89.34, y + 29.77);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 92.0625, y + 29.9511);
ctx.bezierCurveTo(x + 92.0873, y + 29.9553, x + 92.1101, y + 29.9385, x + 92.1143, y + 29.9137);
ctx.bezierCurveTo(x + 92.1185, y + 29.8889, x + 92.1017, y + 29.8659, x + 92.077, y + 29.8616);
ctx.bezierCurveTo(x + 92.0523, y + 29.8574, x + 92.0294, y + 29.8742, x + 92.0252, y + 29.899);
ctx.bezierCurveTo(x + 92.0214, y + 29.9232, x + 92.0378, y + 29.9468, x + 92.0625, y + 29.9511);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 39.3341, y + 24.2059);
ctx.bezierCurveTo(x + 39.3792, y + 24.2136, x + 39.422, y + 24.1824, x + 39.429, y + 24.1367);
ctx.bezierCurveTo(x + 39.436, y + 24.0911, x + 39.4051, y + 24.049, x + 39.3605, y + 24.0416);
ctx.bezierCurveTo(x + 39.316, y + 24.0343, x + 39.2729, y + 24.0646, x + 39.2653, y + 24.1099);
ctx.bezierCurveTo(x + 39.2577, y + 24.1552, x + 39.2895, y + 24.1985, x + 39.3341, y + 24.2059);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 41.9811, y + 24.8569);
ctx.bezierCurveTo(x + 42.1457, y + 24.8835, x + 42.3002, y + 24.7717, x + 42.3263, y + 24.6065);
ctx.bezierCurveTo(x + 42.3528, y + 24.4423, x + 42.2408, y + 24.2861, x + 42.0762, y + 24.2595);
ctx.bezierCurveTo(x + 41.9115, y + 24.233, x + 41.7571, y + 24.3448, x + 41.7307, y + 24.509);
ctx.bezierCurveTo(x + 41.7051, y + 24.6745, x + 41.8168, y + 24.8298, x + 41.9811, y + 24.8569);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 44.6196, y + 25.5604);
ctx.bezierCurveTo(x + 44.9318, y + 25.6112, x + 45.2259, y + 25.3985, x + 45.2759, y + 25.0852);
ctx.bezierCurveTo(x + 45.326, y + 24.7719, x + 45.1131, y + 24.477, x + 44.8009, y + 24.4262);
ctx.bezierCurveTo(x + 44.4887, y + 24.3754, x + 44.1946, y + 24.5881, x + 44.1446, y + 24.9014);
ctx.bezierCurveTo(x + 44.0948, y + 25.2141, x + 44.3073, y + 25.5096, x + 44.6196, y + 25.5604);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 47.2955, y + 26.0327);
ctx.bezierCurveTo(x + 47.6281, y + 26.0869, x + 47.9412, y + 25.8601, x + 47.9946, y + 25.5263);
ctx.bezierCurveTo(x + 48.048, y + 25.1925, x + 47.8214, y + 24.8779, x + 47.4888, y + 24.8236);
ctx.bezierCurveTo(x + 47.1561, y + 24.7694, x + 46.843, y + 24.9962, x + 46.7896, y + 25.33);
ctx.bezierCurveTo(x + 46.7362, y + 25.6638, x + 46.9628, y + 25.9784, x + 47.2955, y + 26.0327);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 49.9388, y + 26.7059);
ctx.bezierCurveTo(x + 50.403, y + 26.7818, x + 50.8399, y + 26.4652, x + 50.914, y + 25.9991);
ctx.bezierCurveTo(x + 50.9888, y + 25.5334, x + 50.6725, y + 25.0943, x + 50.2083, y + 25.0184);
ctx.bezierCurveTo(x + 49.7442, y + 24.9425, x + 49.3072, y + 25.2591, x + 49.2325, y + 25.7248);
ctx.bezierCurveTo(x + 49.1584, y + 26.1909, x + 49.4747, y + 26.63, x + 49.9388, y + 26.7059);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 52.6024, y + 27.2522);
ctx.bezierCurveTo(x + 53.1281, y + 27.3377, x + 53.6233, y + 26.9794, x + 53.7075, y + 26.4518);
ctx.bezierCurveTo(x + 53.7918, y + 25.9243, x + 53.4335, y + 25.4273, x + 52.9077, y + 25.3417);
ctx.bezierCurveTo(x + 52.3819, y + 25.2561, x + 51.8868, y + 25.6145, x + 51.8029, y + 26.1414);
ctx.bezierCurveTo(x + 51.7183, y + 26.6696, x + 52.0766, y + 27.1666, x + 52.6024, y + 27.2522);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 55.2275, y + 28.0374);
ctx.bezierCurveTo(x + 55.9464, y + 28.1543, x + 56.6233, y + 27.665, x + 56.7387, y + 26.9431);
ctx.bezierCurveTo(x + 56.8538, y + 26.2218, x + 56.3641, y + 25.5418, x + 55.6453, y + 25.4249);
ctx.bezierCurveTo(x + 54.9264, y + 25.308, x + 54.2495, y + 25.7973, x + 54.1344, y + 26.5186);
ctx.bezierCurveTo(x + 54.019, y + 27.2404, x + 54.5087, y + 27.9205, x + 55.2275, y + 28.0374);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 57.938, y + 28.2933);
ctx.bezierCurveTo(x + 58.5582, y + 28.3942, x + 59.1421, y + 27.972, x + 59.2417, y + 27.3491);
ctx.bezierCurveTo(x + 59.341, y + 26.7269, x + 58.9192, y + 26.14, x + 58.2991, y + 26.0392);
ctx.bezierCurveTo(x + 57.679, y + 25.9384, x + 57.095, y + 26.3606, x + 56.9954, y + 26.9834);
ctx.bezierCurveTo(x + 56.8955, y + 27.6053, x + 57.3173, y + 28.1922, x + 57.938, y + 28.2933);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 60.6123, y + 28.7728);
ctx.bezierCurveTo(x + 61.2572, y + 28.8779, x + 61.8643, y + 28.4383, x + 61.9678, y + 27.7912);
ctx.bezierCurveTo(x + 62.0713, y + 27.1441, x + 61.6318, y + 26.5346, x + 60.9869, y + 26.4295);
ctx.bezierCurveTo(x + 60.342, y + 26.3244, x + 59.7349, y + 26.764, x + 59.6314, y + 27.4111);
ctx.bezierCurveTo(x + 59.5283, y + 28.0575, x + 59.9668, y + 28.6674, x + 60.6123, y + 28.7728);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 63.2868, y + 29.2516);
ctx.bezierCurveTo(x + 63.9565, y + 29.3609, x + 64.5864, y + 28.9046, x + 64.6941, y + 28.2327);
ctx.bezierCurveTo(x + 64.8014, y + 27.5614, x + 64.3459, y + 26.9276, x + 63.6759, y + 26.8189);
ctx.bezierCurveTo(x + 63.0059, y + 26.7102, x + 62.3763, y + 27.166, x + 62.2686, y + 27.8379);
ctx.bezierCurveTo(x + 62.1613, y + 28.5091, x + 62.6168, y + 29.1429, x + 63.2868, y + 29.2516);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.9611, y + 29.7312);
ctx.bezierCurveTo(x + 66.6549, y + 29.8444, x + 67.3087, y + 29.371, x + 67.4199, y + 28.6739);
ctx.bezierCurveTo(x + 67.5308, y + 27.9775, x + 67.0585, y + 27.3208, x + 66.3644, y + 27.2081);
ctx.bezierCurveTo(x + 65.6706, y + 27.0949, x + 65.0169, y + 27.5683, x + 64.9053, y + 28.2644);
ctx.bezierCurveTo(x + 64.7941, y + 28.9615, x + 65.2664, y + 29.6182, x + 65.9611, y + 29.7312);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 68.6747, y + 29.9642);
ctx.bezierCurveTo(x + 69.258, y + 30.0596, x + 69.8069, y + 29.6617, x + 69.9008, y + 29.0765);
ctx.bezierCurveTo(x + 69.9947, y + 28.4912, x + 69.5973, y + 27.9396, x + 69.0137, y + 27.8448);
ctx.bezierCurveTo(x + 68.4301, y + 27.75, x + 67.8815, y + 28.1472, x + 67.7876, y + 28.7325);
ctx.bezierCurveTo(x + 67.6942, y + 29.3181, x + 68.091, y + 29.8694, x + 68.6747, y + 29.9642);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 71.3561, y + 30.3988);
ctx.bezierCurveTo(x + 71.9394, y + 30.4941, x + 72.4883, y + 30.0963, x + 72.5822, y + 29.5111);
ctx.bezierCurveTo(x + 72.6761, y + 28.9258, x + 72.2787, y + 28.3741, x + 71.6951, y + 28.2794);
ctx.bezierCurveTo(x + 71.1115, y + 28.1846, x + 70.5629, y + 28.5818, x + 70.469, y + 29.1671);
ctx.bezierCurveTo(x + 70.3756, y + 29.7527, x + 70.7724, y + 30.304, x + 71.3561, y + 30.3988);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.0376, y + 30.8337);
ctx.bezierCurveTo(x + 74.6209, y + 30.9291, x + 75.1698, y + 30.5312, x + 75.2631, y + 29.9456);
ctx.bezierCurveTo(x + 75.357, y + 29.3604, x + 74.9596, y + 28.8087, x + 74.376, y + 28.7139);
ctx.bezierCurveTo(x + 73.7924, y + 28.6191, x + 73.2438, y + 29.0164, x + 73.1499, y + 29.6016);
ctx.bezierCurveTo(x + 73.0575, y + 30.187, x + 73.4543, y + 30.7383, x + 74.0376, y + 30.8337);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 76.7359, y + 31.1635);
ctx.bezierCurveTo(x + 77.2617, y + 31.2491, x + 77.7568, y + 30.8907, x + 77.8411, y + 30.3632);
ctx.bezierCurveTo(x + 77.9253, y + 29.8357, x + 77.567, y + 29.3387, x + 77.0413, y + 29.2531);
ctx.bezierCurveTo(x + 76.5155, y + 29.1675, x + 76.0203, y + 29.5259, x + 75.9364, y + 30.0528);
ctx.bezierCurveTo(x + 75.8518, y + 30.5809, x + 76.2102, y + 31.078, x + 76.7359, y + 31.1635);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 79.439, y + 31.4641);
ctx.bezierCurveTo(x + 79.8908, y + 31.5378, x + 80.3158, y + 31.2298, x + 80.3884, y + 30.7764);
ctx.bezierCurveTo(x + 80.4611, y + 30.3231, x + 80.1533, y + 29.896, x + 79.7015, y + 29.8222);
ctx.bezierCurveTo(x + 79.2497, y + 29.7484, x + 78.8241, y + 30.0562, x + 78.7521, y + 30.5098);
ctx.bezierCurveTo(x + 78.6794, y + 30.9632, x + 78.9872, y + 31.3903, x + 79.439, y + 31.4641);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 82.1371, y + 31.7938);
ctx.bezierCurveTo(x + 82.5313, y + 31.8578, x + 82.9023, y + 31.5897, x + 82.9656, y + 31.1936);
ctx.bezierCurveTo(x + 83.0285, y + 30.798, x + 82.7602, y + 30.4248, x + 82.3659, y + 30.3609);
ctx.bezierCurveTo(x + 81.9717, y + 30.2969, x + 81.6004, y + 30.5656, x + 81.5369, y + 30.9608);
ctx.bezierCurveTo(x + 81.4735, y + 31.357, x + 81.7428, y + 31.7299, x + 82.1371, y + 31.7938);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 84.8366, y + 32.1173);
ctx.bezierCurveTo(x + 85.1693, y + 32.1715, x + 85.4823, y + 31.9447, x + 85.5361, y + 31.6103);
ctx.bezierCurveTo(x + 85.5895, y + 31.2765, x + 85.3629, y + 30.9619, x + 85.0303, y + 30.9076);
ctx.bezierCurveTo(x + 84.6976, y + 30.8533, x + 84.3845, y + 31.0802, x + 84.3311, y + 31.414);
ctx.bezierCurveTo(x + 84.2774, y + 31.7484, x + 84.504, y + 32.063, x + 84.8366, y + 32.1173);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 87.5668, y + 32.2451);
ctx.bezierCurveTo(x + 87.7311, y + 32.2723, x + 87.8859, y + 32.1599, x + 87.912, y + 31.9947);
ctx.bezierCurveTo(x + 87.9385, y + 31.8305, x + 87.8265, y + 31.6743, x + 87.6619, y + 31.6477);
ctx.bezierCurveTo(x + 87.4972, y + 31.6211, x + 87.3428, y + 31.733, x + 87.3164, y + 31.8972);
ctx.bezierCurveTo(x + 87.2905, y + 32.0633, x + 87.4021, y + 32.2186, x + 87.5668, y + 32.2451);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 90.2685, y + 32.5529);
ctx.bezierCurveTo(x + 90.3629, y + 32.5682, x + 90.452, y + 32.5038, x + 90.467, y + 32.4091);
ctx.bezierCurveTo(x + 90.482, y + 32.3144, x + 90.4176, y + 32.2248, x + 90.3232, y + 32.2095);
ctx.bezierCurveTo(x + 90.2289, y + 32.1943, x + 90.1397, y + 32.2587, x + 90.1247, y + 32.3534);
ctx.bezierCurveTo(x + 90.1097, y + 32.4481, x + 90.1741, y + 32.5377, x + 90.2685, y + 32.5529);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 92.9736, y + 32.8387);
ctx.bezierCurveTo(x + 92.986, y + 32.8408, x + 92.9979, y + 32.8323, x + 92.9994, y + 32.8195);
ctx.bezierCurveTo(x + 93.0015, y + 32.8071, x + 92.9929, y + 32.7952, x + 92.9802, y + 32.7937);
ctx.bezierCurveTo(x + 92.9679, y + 32.7915, x + 92.956, y + 32.8, x + 92.9545, y + 32.8128);
ctx.bezierCurveTo(x + 92.9533, y + 32.8249, x + 92.9612, y + 32.8366, x + 92.9736, y + 32.8387);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 37.5708, y + 26.6218);
ctx.bezierCurveTo(x + 37.5831, y + 26.6239, x + 37.5944, y + 26.615, x + 37.5965, y + 26.6026);
ctx.bezierCurveTo(x + 37.5986, y + 26.5902, x + 37.5901, y + 26.5782, x + 37.5774, y + 26.5767);
ctx.bezierCurveTo(x + 37.565, y + 26.5746, x + 37.5537, y + 26.5835, x + 37.5516, y + 26.5959);
ctx.bezierCurveTo(x + 37.5499, y + 26.6077, x + 37.5584, y + 26.6196, x + 37.5708, y + 26.6218);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 40.2124, y + 27.3021);
ctx.bezierCurveTo(x + 40.3604, y + 27.3257, x + 40.4996, y + 27.2254, x + 40.5229, y + 27.0769);
ctx.bezierCurveTo(x + 40.5468, y + 26.9288, x + 40.4456, y + 26.7891, x + 40.298, y + 26.7649);
ctx.bezierCurveTo(x + 40.1501, y + 26.7413, x + 40.0108, y + 26.8416, x + 39.9869, y + 26.9897);
ctx.bezierCurveTo(x + 39.9637, y + 27.1381, x + 40.0645, y + 27.2784, x + 40.2124, y + 27.3021);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 42.8546, y + 27.9835);
ctx.bezierCurveTo(x + 43.1383, y + 28.0296, x + 43.4048, y + 27.8366, x + 43.4501, y + 27.5519);
ctx.bezierCurveTo(x + 43.4952, y + 27.2677, x + 43.3027, y + 26.9994, x + 43.0189, y + 26.9533);
ctx.bezierCurveTo(x + 42.7352, y + 26.9072, x + 42.4688, y + 27.1002, x + 42.4228, y + 27.3846);
ctx.bezierCurveTo(x + 42.3783, y + 27.6691, x + 42.5708, y + 27.9374, x + 42.8546, y + 27.9835);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 45.528, y + 28.4703);
ctx.bezierCurveTo(x + 45.8403, y + 28.5211, x + 46.1343, y + 28.3084, x + 46.1844, y + 27.9951);
ctx.bezierCurveTo(x + 46.2344, y + 27.6818, x + 46.0216, y + 27.3869, x + 45.7093, y + 27.3361);
ctx.bezierCurveTo(x + 45.3971, y + 27.2853, x + 45.103, y + 27.498, x + 45.053, y + 27.8113);
ctx.bezierCurveTo(x + 45.003, y + 28.1246, x + 45.2158, y + 28.4195, x + 45.528, y + 28.4703);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 48.1522, y + 29.2632);
ctx.bezierCurveTo(x + 48.6619, y + 29.3462, x + 49.1413, y + 28.999, x + 49.2226, y + 28.4882);
ctx.bezierCurveTo(x + 49.3043, y + 27.9768, x + 48.9578, y + 27.496, x + 48.4481, y + 27.413);
ctx.bezierCurveTo(x + 47.9384, y + 27.33, x + 47.459, y + 27.6772, x + 47.3777, y + 28.188);
ctx.bezierCurveTo(x + 47.2957, y + 28.6985, x + 47.6425, y + 29.1803, x + 48.1522, y + 29.2632);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 50.8289, y + 29.728);
ctx.bezierCurveTo(x + 51.3547, y + 29.8136, x + 51.8498, y + 29.4552, x + 51.9341, y + 28.9277);
ctx.bezierCurveTo(x + 52.0184, y + 28.4001, x + 51.6606, y + 27.9034, x + 51.1343, y + 27.8175);
ctx.bezierCurveTo(x + 50.6085, y + 27.732, x + 50.1134, y + 28.0903, x + 50.0291, y + 28.6179);
ctx.bezierCurveTo(x + 49.9452, y + 29.1448, x + 50.3026, y + 29.6421, x + 50.8289, y + 29.728);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 53.4733, y + 30.3938);
ctx.bezierCurveTo(x + 54.1268, y + 30.5005, x + 54.7414, y + 30.0547, x + 54.8461, y + 29.3996);
ctx.bezierCurveTo(x + 54.9509, y + 28.7444, x + 54.5065, y + 28.1265, x + 53.8529, y + 28.0198);
ctx.bezierCurveTo(x + 53.1994, y + 27.9131, x + 52.5848, y + 28.3589, x + 52.4801, y + 29.014);
ctx.bezierCurveTo(x + 52.3753, y + 29.6692, x + 52.8203, y + 30.2874, x + 53.4733, y + 30.3938);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 56.1355, y + 30.948);
ctx.bezierCurveTo(x + 56.8544, y + 31.0649, x + 57.5313, y + 30.5756, x + 57.6467, y + 29.8537);
ctx.bezierCurveTo(x + 57.7618, y + 29.1325, x + 57.2721, y + 28.4524, x + 56.5532, y + 28.3355);
ctx.bezierCurveTo(x + 55.8344, y + 28.2186, x + 55.1575, y + 28.7079, x + 55.0424, y + 29.4292);
ctx.bezierCurveTo(x + 54.9269, y + 30.1511, x + 55.417, y + 30.8305, x + 56.1355, y + 30.948);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 58.7781, y + 31.6286);
ctx.bezierCurveTo(x + 59.6321, y + 31.7676, x + 60.4361, y + 31.1857, x + 60.5734, y + 30.3281);
ctx.bezierCurveTo(x + 60.7106, y + 29.4705, x + 60.1289, y + 28.663, x + 59.2742, y + 28.5237);
ctx.bezierCurveTo(x + 58.4195, y + 28.3844, x + 57.6161, y + 28.9667, x + 57.4789, y + 29.8243);
ctx.bezierCurveTo(x + 57.342, y + 30.6812, x + 57.9234, y + 31.4893, x + 58.7781, y + 31.6286);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 61.4942, y + 31.847);
ctx.bezierCurveTo(x + 62.2297, y + 31.9669, x + 62.9212, y + 31.4658, x + 63.0392, y + 30.7277);
ctx.bezierCurveTo(x + 63.1572, y + 29.9897, x + 62.6566, y + 29.2948, x + 61.921, y + 29.1749);
ctx.bezierCurveTo(x + 61.1855, y + 29.0551, x + 60.4941, y + 29.5562, x + 60.376, y + 30.2942);
ctx.bezierCurveTo(x + 60.2584, y + 31.0317, x + 60.7586, y + 31.7272, x + 61.4942, y + 31.847);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 64.1769, y + 32.2737);
ctx.bezierCurveTo(x + 64.9081, y + 32.3927, x + 65.5963, y + 31.8946, x + 65.7135, y + 31.1609);
ctx.bezierCurveTo(x + 65.8307, y + 30.4272, x + 65.3328, y + 29.7361, x + 64.6019, y + 29.6165);
ctx.bezierCurveTo(x + 63.8707, y + 29.4975, x + 63.1825, y + 29.9956, x + 63.0653, y + 30.7293);
ctx.bezierCurveTo(x + 62.9471, y + 31.4633, x + 63.4457, y + 32.1547, x + 64.1769, y + 32.2737);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 66.8592, y + 32.7012);
ctx.bezierCurveTo(x + 67.5861, y + 32.8194, x + 68.2704, y + 32.3239, x + 68.3872, y + 31.594);
ctx.bezierCurveTo(x + 68.5035, y + 30.8646, x + 68.0086, y + 30.1768, x + 67.2817, y + 30.0586);
ctx.bezierCurveTo(x + 66.5548, y + 29.9404, x + 65.8704, y + 30.4359, x + 65.754, y + 31.1653);
ctx.bezierCurveTo(x + 65.6373, y + 31.8952, x + 66.1323, y + 32.583, x + 66.8592, y + 32.7012);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 69.5432, y + 33.1214);
ctx.bezierCurveTo(x + 70.2621, y + 33.2382, x + 70.939, y + 32.749, x + 71.0544, y + 32.0271);
ctx.bezierCurveTo(x + 71.1695, y + 31.3058, x + 70.6798, y + 30.6258, x + 69.961, y + 30.5089);
ctx.bezierCurveTo(x + 69.2421, y + 30.392, x + 68.5652, y + 30.8812, x + 68.4501, y + 31.6025);
ctx.bezierCurveTo(x + 68.3347, y + 32.3244, x + 68.8247, y + 33.0039, x + 69.5432, y + 33.1214);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 72.2251, y + 33.5554);
ctx.bezierCurveTo(x + 72.944, y + 33.6723, x + 73.6202, y + 33.1827, x + 73.7363, y + 32.4612);
ctx.bezierCurveTo(x + 73.8514, y + 31.7399, x + 73.3617, y + 31.0598, x + 72.6429, y + 30.943);
ctx.bezierCurveTo(x + 71.924, y + 30.8261, x + 71.2471, y + 31.3153, x + 71.132, y + 32.0366);
ctx.bezierCurveTo(x + 71.0165, y + 32.7585, x + 71.5062, y + 33.4385, x + 72.2251, y + 33.5554);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.906, y + 33.9898);
ctx.bezierCurveTo(x + 75.6249, y + 34.1066, x + 76.3018, y + 33.6174, x + 76.4172, y + 32.8955);
ctx.bezierCurveTo(x + 76.5323, y + 32.1742, x + 76.0426, y + 31.4942, x + 75.3238, y + 31.3773);
ctx.bezierCurveTo(x + 74.6049, y + 31.2604, x + 73.928, y + 31.7497, x + 73.8129, y + 32.4709);
ctx.bezierCurveTo(x + 73.6981, y + 33.1932, x + 74.1871, y + 33.8729, x + 74.906, y + 33.9898);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 77.6164, y + 34.2458);
ctx.bezierCurveTo(x + 78.2365, y + 34.3467, x + 78.8204, y + 33.9245, x + 78.9201, y + 33.3016);
ctx.bezierCurveTo(x + 79.0193, y + 32.6794, x + 78.5976, y + 32.0925, x + 77.9768, y + 31.9914);
ctx.bezierCurveTo(x + 77.3567, y + 31.8905, x + 76.7728, y + 32.3127, x + 76.6732, y + 32.9356);
ctx.bezierCurveTo(x + 76.5739, y + 33.5578, x + 76.9956, y + 34.1447, x + 77.6164, y + 34.2458);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 80.3126, y + 34.5905);
ctx.bezierCurveTo(x + 80.8835, y + 34.6838, x + 81.4211, y + 34.2948, x + 81.5127, y + 33.721);
ctx.bezierCurveTo(x + 81.6046, y + 33.1482, x + 81.2157, y + 32.6085, x + 80.6447, y + 32.5152);
ctx.bezierCurveTo(x + 80.0738, y + 32.422, x + 79.5362, y + 32.8109, x + 79.445, y + 33.3841);
ctx.bezierCurveTo(x + 79.3522, y + 33.9572, x + 79.7407, y + 34.4976, x + 80.3126, y + 34.5905);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 83.0088, y + 34.9281);
ctx.bezierCurveTo(x + 83.5265, y + 35.0124, x + 84.0136, y + 34.6599, x + 84.096, y + 34.1401);
ctx.bezierCurveTo(x + 84.179, y + 33.6206, x + 83.8269, y + 33.1311, x + 83.3092, y + 33.0468);
ctx.bezierCurveTo(x + 82.7915, y + 32.9626, x + 82.305, y + 33.3154, x + 82.2214, y + 33.8345);
ctx.bezierCurveTo(x + 82.139, y + 34.3543, x + 82.4911, y + 34.8439, x + 83.0088, y + 34.9281);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 85.7289, y + 35.1238);
ctx.bezierCurveTo(x + 86.1151, y + 35.1864, x + 86.4783, y + 34.9237, x + 86.5403, y + 34.5356);
ctx.bezierCurveTo(x + 86.602, y + 34.148, x + 86.3396, y + 33.783, x + 85.9534, y + 33.7204);
ctx.bezierCurveTo(x + 85.5672, y + 33.6577, x + 85.2039, y + 33.9205, x + 85.1422, y + 34.308);
ctx.bezierCurveTo(x + 85.0802, y + 34.6961, x + 85.3427, y + 35.0611, x + 85.7289, y + 35.1238);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 88.4495, y + 35.312);
ctx.bezierCurveTo(x + 88.7002, y + 35.3531, x + 88.936, y + 35.1821, x + 88.9759, y + 34.9303);
ctx.bezierCurveTo(x + 89.0164, y + 34.6788, x + 88.8453, y + 34.4424, x + 88.5946, y + 34.4013);
ctx.bezierCurveTo(x + 88.344, y + 34.3602, x + 88.1082, y + 34.5311, x + 88.0677, y + 34.7826);
ctx.bezierCurveTo(x + 88.0284, y + 35.0348, x + 88.1995, y + 35.2712, x + 88.4495, y + 35.312);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 91.1566, y + 35.5901);
ctx.bezierCurveTo(x + 91.3213, y + 35.6167, x + 91.4757, y + 35.5049, x + 91.5019, y + 35.3397);
ctx.bezierCurveTo(x + 91.5283, y + 35.1754, x + 91.4164, y + 35.0193, x + 91.2517, y + 34.9927);
ctx.bezierCurveTo(x + 91.0871, y + 34.9661, x + 90.9327, y + 35.0779, x + 90.9062, y + 35.2422);
ctx.bezierCurveTo(x + 90.8797, y + 35.408, x + 90.992, y + 35.5635, x + 91.1566, y + 35.5901);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 93.8722, y + 35.808);
ctx.bezierCurveTo(x + 93.9174, y + 35.8157, x + 93.9602, y + 35.7845, x + 93.9672, y + 35.7388);
ctx.bezierCurveTo(x + 93.9747, y + 35.6935, x + 93.9432, y + 35.6511, x + 93.8987, y + 35.6437);
ctx.bezierCurveTo(x + 93.8535, y + 35.636, x + 93.811, y + 35.6666, x + 93.8035, y + 35.712);
ctx.bezierCurveTo(x + 93.7959, y + 35.7573, x + 93.8277, y + 35.8006, x + 93.8722, y + 35.808);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 96.5562, y + 36.2282);
ctx.bezierCurveTo(x + 96.5933, y + 36.2345, x + 96.6275, y + 36.2089, x + 96.6337, y + 36.1716);
ctx.bezierCurveTo(x + 96.6397, y + 36.135, x + 96.6147, y + 36.0995, x + 96.5773, y + 36.0937);
ctx.bezierCurveTo(x + 96.5402, y + 36.0873, x + 96.5054, y + 36.1126, x + 96.4997, y + 36.1502);
ctx.bezierCurveTo(x + 96.4944, y + 36.1872, x + 96.5197, y + 36.2221, x + 96.5562, y + 36.2282);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 33.1167, y + 28.6555);
ctx.bezierCurveTo(x + 33.1247, y + 28.6568, x + 33.1324, y + 28.6515, x + 33.134, y + 28.6428);
ctx.bezierCurveTo(x + 33.1353, y + 28.6348, x + 33.1301, y + 28.627, x + 33.122, y + 28.6257);
ctx.bezierCurveTo(x + 33.114, y + 28.6244, x + 33.1063, y + 28.6297, x + 33.1046, y + 28.6384);
ctx.bezierCurveTo(x + 33.1027, y + 28.6461, x + 33.1086, y + 28.6542, x + 33.1167, y + 28.6555);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 35.7873, y + 29.1569);
ctx.bezierCurveTo(x + 35.8324, y + 29.1645, x + 35.8752, y + 29.1333, x + 35.8822, y + 29.0877);
ctx.bezierCurveTo(x + 35.8892, y + 29.042, x + 35.8583, y + 29, x + 35.8137, y + 28.9926);
ctx.bezierCurveTo(x + 35.7685, y + 28.9849, x + 35.7261, y + 29.0155, x + 35.7185, y + 29.0608);
ctx.bezierCurveTo(x + 35.7116, y + 29.1065, x + 35.7421, y + 29.1492, x + 35.7873, y + 29.1569);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 38.4344, y + 29.8081);
ctx.bezierCurveTo(x + 38.599, y + 29.8347, x + 38.7534, y + 29.7229, x + 38.7796, y + 29.5577);
ctx.bezierCurveTo(x + 38.806, y + 29.3935, x + 38.6937, y + 29.2379, x + 38.5294, y + 29.2107);
ctx.bezierCurveTo(x + 38.3648, y + 29.1841, x + 38.2104, y + 29.2959, x + 38.1836, y + 29.4608);
ctx.bezierCurveTo(x + 38.1584, y + 29.6257, x + 38.2701, y + 29.7809, x + 38.4344, y + 29.8081);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 41.0812, y + 30.4594);
ctx.bezierCurveTo(x + 41.3649, y + 30.5054, x + 41.6313, y + 30.3124, x + 41.6767, y + 30.0277);
ctx.bezierCurveTo(x + 41.7217, y + 29.7436, x + 41.5293, y + 29.4752, x + 41.2455, y + 29.4291);
ctx.bezierCurveTo(x + 40.9617, y + 29.383, x + 40.6953, y + 29.5761, x + 40.6493, y + 29.8605);
ctx.bezierCurveTo(x + 40.6043, y + 30.1446, x + 40.7977, y + 30.4127, x + 41.0812, y + 30.4594);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 43.7237, y + 31.1401);
ctx.bezierCurveTo(x + 44.1427, y + 31.2083, x + 44.5368, y + 30.9229, x + 44.6043, y + 30.5019);
ctx.bezierCurveTo(x + 44.6714, y + 30.0815, x + 44.3863, y + 29.6854, x + 43.9673, y + 29.6172);
ctx.bezierCurveTo(x + 43.5483, y + 29.549, x + 43.1542, y + 29.8344, x + 43.0871, y + 30.2548);
ctx.bezierCurveTo(x + 43.019, y + 30.6755, x + 43.3041, y + 31.0716, x + 43.7237, y + 31.1401);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 46.3785, y + 31.7391);
ctx.bezierCurveTo(x + 46.8882, y + 31.822, x + 47.3676, y + 31.4748, x + 47.4489, y + 30.964);
ctx.bezierCurveTo(x + 47.5306, y + 30.4527, x + 47.1841, y + 29.9718, x + 46.6744, y + 29.8888);
ctx.bezierCurveTo(x + 46.1647, y + 29.8059, x + 45.6857, y + 30.1525, x + 45.604, y + 30.6639);
ctx.bezierCurveTo(x + 45.522, y + 31.1743, x + 45.8692, y + 31.6555, x + 46.3785, y + 31.7391);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 49.0037, y + 32.5244);
ctx.bezierCurveTo(x + 49.7061, y + 32.6393, x + 50.367, y + 32.1602, x + 50.4802, y + 31.4554);
ctx.bezierCurveTo(x + 50.5927, y + 30.7503, x + 50.1142, y + 30.0861, x + 49.412, y + 29.9721);
ctx.bezierCurveTo(x + 48.7092, y + 29.8579, x + 48.0487, y + 30.3363, x + 47.9356, y + 31.0411);
ctx.bezierCurveTo(x + 47.8234, y + 31.7456, x + 48.3013, y + 32.4095, x + 49.0037, y + 32.5244);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 51.6809, y + 32.9885);
ctx.bezierCurveTo(x + 52.3998, y + 33.1054, x + 53.0767, y + 32.6162, x + 53.1921, y + 31.8943);
ctx.bezierCurveTo(x + 53.3072, y + 31.173, x + 52.8175, y + 30.4929, x + 52.0987, y + 30.3761);
ctx.bezierCurveTo(x + 51.3798, y + 30.2592, x + 50.7029, y + 30.7484, x + 50.5878, y + 31.4697);
ctx.bezierCurveTo(x + 50.4724, y + 32.1916, x + 50.962, y + 32.8717, x + 51.6809, y + 32.9885);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 54.3252, y + 33.6543);
ctx.bezierCurveTo(x + 55.1713, y + 33.792, x + 55.9676, y + 33.2153, x + 56.1035, y + 32.3658);
ctx.bezierCurveTo(x + 56.2391, y + 31.5169, x + 55.663, y + 30.7165, x + 54.817, y + 30.5788);
ctx.bezierCurveTo(x + 53.9709, y + 30.4411, x + 53.174, y + 31.0175, x + 53.0384, y + 31.8664);
ctx.bezierCurveTo(x + 52.9028, y + 32.7169, x + 53.4792, y + 33.5166, x + 54.3252, y + 33.6543);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 56.9946, y + 34.1638);
ctx.bezierCurveTo(x + 57.8821, y + 34.3087, x + 58.7168, y + 33.7031, x + 58.8591, y + 32.8133);
ctx.bezierCurveTo(x + 59.0015, y + 31.9234, x + 58.3978, y + 31.0837, x + 57.51, y + 30.9394);
ctx.bezierCurveTo(x + 56.6225, y + 30.7945, x + 55.7872, y + 31.3998, x + 55.6455, y + 32.29);
ctx.bezierCurveTo(x + 55.5031, y + 33.1798, x + 56.1068, y + 34.0196, x + 56.9946, y + 34.1638);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 59.6835, y + 34.5541);
ctx.bezierCurveTo(x + 60.5462, y + 34.6947, x + 61.3583, y + 34.1068, x + 61.4962, y + 33.2408);
ctx.bezierCurveTo(x + 61.6347, y + 32.3752, x + 61.0471, y + 31.5597, x + 60.1843, y + 31.419);
ctx.bezierCurveTo(x + 59.3216, y + 31.2784, x + 58.5095, y + 31.8663, x + 58.371, y + 32.7319);
ctx.bezierCurveTo(x + 58.2335, y + 33.5973, x + 58.8207, y + 34.4134, x + 59.6835, y + 34.5541);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 62.3625, y + 35.0032);
ctx.bezierCurveTo(x + 63.2332, y + 35.1452, x + 64.0527, y + 34.5511, x + 64.1925, y + 33.6774);
ctx.bezierCurveTo(x + 64.3323, y + 32.8036, x + 63.7398, y + 31.9797, x + 62.8687, y + 31.8384);
ctx.bezierCurveTo(x + 61.9979, y + 31.6964, x + 61.1784, y + 32.2906, x + 61.0389, y + 33.1637);
ctx.bezierCurveTo(x + 60.8988, y + 34.038, x + 61.4917, y + 34.8613, x + 62.3625, y + 35.0032);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.0595, y + 35.3405);
ctx.bezierCurveTo(x + 65.8771, y + 35.4734, x + 66.6464, y + 34.9168, x + 66.7773, y + 34.0964);
ctx.bezierCurveTo(x + 66.9082, y + 33.2761, x + 66.3512, y + 32.5032, x + 65.5346, y + 32.37);
ctx.bezierCurveTo(x + 64.717, y + 32.2371, x + 63.9477, y + 32.7937, x + 63.8168, y + 33.6141);
ctx.bezierCurveTo(x + 63.6853, y + 34.434, x + 64.242, y + 35.2075, x + 65.0595, y + 35.3405);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 67.742, y + 35.768);
ctx.bezierCurveTo(x + 68.5553, y + 35.9001, x + 69.3207, y + 35.3461, x + 69.4511, y + 34.5295);
ctx.bezierCurveTo(x + 69.5818, y + 33.7139, x + 69.0278, y + 32.9443, x + 68.2149, y + 32.8115);
ctx.bezierCurveTo(x + 67.401, y + 32.679, x + 66.6362, y + 33.2334, x + 66.5052, y + 34.0497);
ctx.bezierCurveTo(x + 66.3747, y + 34.8663, x + 66.9288, y + 35.6359, x + 67.742, y + 35.768);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 70.4251, y + 36.1956);
ctx.bezierCurveTo(x + 71.2346, y + 36.3272, x + 71.9956, y + 35.7755, x + 72.1258, y + 34.9636);
ctx.bezierCurveTo(x + 72.2561, y + 34.1517, x + 71.7047, y + 33.3859, x + 70.8958, y + 33.2546);
ctx.bezierCurveTo(x + 70.0868, y + 33.1233, x + 69.3253, y + 33.6747, x + 69.1954, y + 34.486);
ctx.bezierCurveTo(x + 69.0651, y + 35.2979, x + 69.6159, y + 36.0633, x + 70.4251, y + 36.1956);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 73.1207, y + 36.54);
ctx.bezierCurveTo(x + 73.881, y + 36.6641, x + 74.5963, y + 36.1459, x + 74.7175, y + 35.3833);
ctx.bezierCurveTo(x + 74.8394, y + 34.6211, x + 74.3218, y + 33.9023, x + 73.5621, y + 33.7785);
ctx.bezierCurveTo(x + 72.8018, y + 33.6544, x + 72.0866, y + 34.1726, x + 71.9647, y + 34.9348);
ctx.bezierCurveTo(x + 71.8434, y + 35.6974, x + 72.361, y + 36.4163, x + 73.1207, y + 36.54);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 75.825, y + 36.8331);
ctx.bezierCurveTo(x + 76.5073, y + 36.944, x + 77.1482, y + 36.4793, x + 77.258, y + 35.795);
ctx.bezierCurveTo(x + 77.3674, y + 35.1113, x + 76.9034, y + 34.4656, x + 76.221, y + 34.3548);
ctx.bezierCurveTo(x + 75.5387, y + 34.2439, x + 74.8977, y + 34.7086, x + 74.788, y + 35.3929);
ctx.bezierCurveTo(x + 74.6788, y + 36.0775, x + 75.1426, y + 36.7223, x + 75.825, y + 36.8331);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 78.5183, y + 37.193);
ctx.bezierCurveTo(x + 79.1588, y + 37.2972, x + 79.7617, y + 36.8609, x + 79.8647, y + 36.2176);
ctx.bezierCurveTo(x + 79.9674, y + 35.5748, x + 79.5315, y + 34.9689, x + 78.8904, y + 34.8643);
ctx.bezierCurveTo(x + 78.2492, y + 34.7597, x + 77.6463, y + 35.196, x + 77.5433, y + 35.8394);
ctx.bezierCurveTo(x + 77.4412, y + 36.4824, x + 77.8771, y + 37.0884, x + 78.5183, y + 37.193);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 81.2164, y + 37.5228);
ctx.bezierCurveTo(x + 81.7997, y + 37.6182, x + 82.3486, y + 37.2204, x + 82.4425, y + 36.6351);
ctx.bezierCurveTo(x + 82.5365, y + 36.0498, x + 82.1391, y + 35.4982, x + 81.5555, y + 35.4034);
ctx.bezierCurveTo(x + 80.9722, y + 35.308, x + 80.4232, y + 35.7058, x + 80.3293, y + 36.2911);
ctx.bezierCurveTo(x + 80.236, y + 36.8767, x + 80.6328, y + 37.428, x + 81.2164, y + 37.5228);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 83.9144, y + 37.8532);
ctx.bezierCurveTo(x + 84.4401, y + 37.9388, x + 84.9353, y + 37.5804, x + 85.0195, y + 37.0529);
ctx.bezierCurveTo(x + 85.1038, y + 36.5254, x + 84.7461, y + 36.0287, x + 84.2197, y + 35.9428);
ctx.bezierCurveTo(x + 83.694, y + 35.8572, x + 83.1988, y + 36.2156, x + 83.1145, y + 36.7431);
ctx.bezierCurveTo(x + 83.0306, y + 37.27, x + 83.3886, y + 37.7677, x + 83.9144, y + 37.8532);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 86.6525, y + 37.9368);
ctx.bezierCurveTo(x + 86.9852, y + 37.9911, x + 87.2983, y + 37.7642, x + 87.352, y + 37.4299);
ctx.bezierCurveTo(x + 87.4055, y + 37.0961, x + 87.1788, y + 36.7814, x + 86.8462, y + 36.7272);
ctx.bezierCurveTo(x + 86.5135, y + 36.6729, x + 86.2005, y + 36.8998, x + 86.147, y + 37.2336);
ctx.bezierCurveTo(x + 86.0933, y + 37.568, x + 86.3196, y + 37.8832, x + 86.6525, y + 37.9368);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 89.3339, y + 38.3717);
ctx.bezierCurveTo(x + 89.6666, y + 38.4259, x + 89.9797, y + 38.199, x + 90.0334, y + 37.8647);
ctx.bezierCurveTo(x + 90.0868, y + 37.5309, x + 89.8602, y + 37.2163, x + 89.5276, y + 37.162);
ctx.bezierCurveTo(x + 89.1949, y + 37.1077, x + 88.8819, y + 37.3346, x + 88.8284, y + 37.6684);
ctx.bezierCurveTo(x + 88.7747, y + 38.0028, x + 89.0013, y + 38.3174, x + 89.3339, y + 38.3717);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 92.0639, y + 38.5003);
ctx.bezierCurveTo(x + 92.2285, y + 38.5268, x + 92.3829, y + 38.415, x + 92.4091, y + 38.2498);
ctx.bezierCurveTo(x + 92.4355, y + 38.0856, x + 92.3236, y + 37.9294, x + 92.159, y + 37.9029);
ctx.bezierCurveTo(x + 91.9943, y + 37.8763, x + 91.8399, y + 37.9881, x + 91.8134, y + 38.1523);
ctx.bezierCurveTo(x + 91.7879, y + 38.3179, x + 91.8996, y + 38.4731, x + 92.0639, y + 38.5003);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 94.7804, y + 38.7181);
ctx.bezierCurveTo(x + 94.8256, y + 38.7258, x + 94.8684, y + 38.6946, x + 94.8754, y + 38.649);
ctx.bezierCurveTo(x + 94.8829, y + 38.6036, x + 94.8514, y + 38.5612, x + 94.8069, y + 38.5539);
ctx.bezierCurveTo(x + 94.7617, y + 38.5462, x + 94.7193, y + 38.5768, x + 94.7117, y + 38.6221);
ctx.bezierCurveTo(x + 94.7044, y + 38.6684, x + 94.7349, y + 38.7111, x + 94.7804, y + 38.7181);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 34.0142, y + 31.6323);
ctx.bezierCurveTo(x + 34.0593, y + 31.64, x + 34.1021, y + 31.6088, x + 34.1088, y + 31.5638);
ctx.bezierCurveTo(x + 34.1163, y + 31.5184, x + 34.0848, y + 31.476, x + 34.0403, y + 31.4687);
ctx.bezierCurveTo(x + 33.9951, y + 31.461, x + 33.9526, y + 31.4916, x + 33.9451, y + 31.5369);
ctx.bezierCurveTo(x + 33.9375, y + 31.5822, x + 33.9687, y + 31.6252, x + 34.0142, y + 31.6323);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 36.661, y + 32.2835);
ctx.bezierCurveTo(x + 36.8257, y + 32.31, x + 36.9801, y + 32.1982, x + 37.0063, y + 32.033);
ctx.bezierCurveTo(x + 37.0327, y + 31.8688, x + 36.9207, y + 31.7126, x + 36.7561, y + 31.6861);
ctx.bezierCurveTo(x + 36.5915, y + 31.6595, x + 36.437, y + 31.7713, x + 36.4106, y + 31.9355);
ctx.bezierCurveTo(x + 36.3841, y + 32.1013, x + 36.4964, y + 32.2569, x + 36.661, y + 32.2835);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 39.316, y + 32.8824);
ctx.bezierCurveTo(x + 39.5704, y + 32.924, x + 39.8104, y + 32.7498, x + 39.8514, y + 32.4946);
ctx.bezierCurveTo(x + 39.8924, y + 32.2393, x + 39.719, y + 31.9984, x + 39.464, y + 31.9565);
ctx.bezierCurveTo(x + 39.2096, y + 31.9149, x + 38.969, y + 32.0887, x + 38.9286, y + 32.3443);
ctx.bezierCurveTo(x + 38.8876, y + 32.5995, x + 39.061, y + 32.8404, x + 39.316, y + 32.8824);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 41.9749, y + 33.4587);
ctx.bezierCurveTo(x + 42.3076, y + 33.513, x + 42.6206, y + 33.2861, x + 42.6741, y + 32.9523);
ctx.bezierCurveTo(x + 42.7275, y + 32.6185, x + 42.5009, y + 32.3039, x + 42.1682, y + 32.2496);
ctx.bezierCurveTo(x + 41.8356, y + 32.1954, x + 41.5225, y + 32.4223, x + 41.4691, y + 32.756);
ctx.bezierCurveTo(x + 41.4156, y + 33.0898, x + 41.6423, y + 33.4044, x + 41.9749, y + 33.4587);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 44.6002, y + 34.2441);
ctx.bezierCurveTo(x + 45.1259, y + 34.3297, x + 45.6211, y + 33.9713, x + 45.7053, y + 33.4438);
ctx.bezierCurveTo(x + 45.7896, y + 32.9162, x + 45.4313, y + 32.4192, x + 44.9055, y + 32.3336);
ctx.bezierCurveTo(x + 44.3797, y + 32.2481, x + 43.8846, y + 32.6064, x + 43.8003, y + 33.134);
ctx.bezierCurveTo(x + 43.7164, y + 33.6609, x + 44.0744, y + 34.1585, x + 44.6002, y + 34.2441);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 47.2516, y + 34.8652);
ctx.bezierCurveTo(x + 47.8798, y + 34.9673, x + 48.4718, y + 34.5392, x + 48.5727, y + 33.9083);
ctx.bezierCurveTo(x + 48.6733, y + 33.278, x + 48.2453, y + 32.6836, x + 47.6171, y + 32.5815);
ctx.bezierCurveTo(x + 46.9889, y + 32.4794, x + 46.397, y + 32.9075, x + 46.2964, y + 33.5378);
ctx.bezierCurveTo(x + 46.1955, y + 34.1687, x + 46.6235, y + 34.763, x + 47.2516, y + 34.8652);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 49.9119, y + 35.4343);
ctx.bezierCurveTo(x + 50.6144, y + 35.5492, x + 51.2752, y + 35.0701, x + 51.3884, y + 34.3653);
ctx.bezierCurveTo(x + 51.5009, y + 33.6602, x + 51.023, y + 32.9963, x + 50.3202, y + 32.882);
ctx.bezierCurveTo(x + 49.6174, y + 32.7678, x + 48.9569, y + 33.2462, x + 48.8438, y + 33.951);
ctx.bezierCurveTo(x + 48.731, y + 34.6552, x + 49.2092, y + 35.32, x + 49.9119, y + 35.4343);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 52.566, y + 36.0407);
ctx.bezierCurveTo(x + 53.3628, y + 36.1709, x + 54.1128, y + 35.6274, x + 54.2409, y + 34.8279);
ctx.bezierCurveTo(x + 54.3691, y + 34.0284, x + 53.8262, y + 33.2746, x + 53.0294, y + 33.1445);
ctx.bezierCurveTo(x + 52.2325, y + 33.0144, x + 51.4826, y + 33.5578, x + 51.3544, y + 34.3573);
ctx.bezierCurveTo(x + 51.2262, y + 35.1568, x + 51.7688, y + 35.9112, x + 52.566, y + 36.0407);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 55.2332, y + 36.5649);
ctx.bezierCurveTo(x + 56.0792, y + 36.7026, x + 56.8761, y + 36.1262, x + 57.0115, y + 35.2764);
ctx.bezierCurveTo(x + 57.1471, y + 34.4275, x + 56.571, y + 33.6272, x + 55.7249, y + 33.4895);
ctx.bezierCurveTo(x + 54.8789, y + 33.3518, x + 54.082, y + 33.9282, x + 53.9464, y + 34.7771);
ctx.bezierCurveTo(x + 53.8105, y + 35.6266, x + 54.3866, y + 36.4269, x + 55.2332, y + 36.5649);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 57.8884, y + 37.1633);
ctx.bezierCurveTo(x + 58.8251, y + 37.3158, x + 59.7063, y + 36.6779, x + 59.8568, y + 35.7374);
ctx.bezierCurveTo(x + 60.0069, y + 34.7976, x + 59.3688, y + 33.9122, x + 58.4324, y + 33.7591);
ctx.bezierCurveTo(x + 57.4957, y + 33.6066, x + 56.6145, y + 34.2445, x + 56.4643, y + 35.1844);
ctx.bezierCurveTo(x + 56.3135, y + 36.1255, x + 56.9517, y + 37.0109, x + 57.8884, y + 37.1633);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 60.5546, y + 37.6949);
ctx.bezierCurveTo(x + 61.5445, y + 37.8564, x + 62.4763, y + 37.182, x + 62.635, y + 36.1878);
ctx.bezierCurveTo(x + 62.794, y + 35.1945, x + 62.1194, y + 34.2584, x + 61.1295, y + 34.0969);
ctx.bezierCurveTo(x + 60.1395, y + 33.9354, x + 59.2078, y + 34.6098, x + 59.0488, y + 35.6031);
ctx.bezierCurveTo(x + 58.8901, y + 36.5973, x + 59.5643, y + 37.5341, x + 60.5546, y + 37.6949);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 63.2585, y + 37.9882);
ctx.bezierCurveTo(x + 64.1705, y + 38.1364, x + 65.0289, y + 37.5153, x + 65.1748, y + 36.6002);
ctx.bezierCurveTo(x + 65.3214, y + 35.6855, x + 64.7003, y + 34.8225, x + 63.7883, y + 34.6743);
ctx.bezierCurveTo(x + 62.8767, y + 34.5255, x + 62.018, y + 35.1472, x + 61.8721, y + 36.0622);
ctx.bezierCurveTo(x + 61.7255, y + 36.9769, x + 62.346, y + 37.8396, x + 63.2585, y + 37.9882);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.9424, y + 38.4073);
ctx.bezierCurveTo(x + 66.8463, y + 38.5542, x + 67.6966, y + 37.939, x + 67.8416, y + 37.0314);
ctx.bezierCurveTo(x + 67.9869, y + 36.1248, x + 67.3714, y + 35.2705, x + 66.4678, y + 35.1229);
ctx.bezierCurveTo(x + 65.5642, y + 34.9754, x + 64.7135, y + 35.5913, x + 64.5683, y + 36.4979);
ctx.bezierCurveTo(x + 64.4233, y + 37.4055, x + 65.0385, y + 38.2604, x + 65.9424, y + 38.4073);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 68.6253, y + 38.835);
ctx.bezierCurveTo(x + 69.5245, y + 38.9817, x + 70.3714, y + 38.3685, x + 70.5155, y + 37.4653);
ctx.bezierCurveTo(x + 70.66, y + 36.563, x + 70.0475, y + 35.7119, x + 69.1482, y + 35.5652);
ctx.bezierCurveTo(x + 68.249, y + 35.4185, x + 67.4021, y + 36.0317, x + 67.2574, y + 36.9346);
ctx.bezierCurveTo(x + 67.1126, y + 37.8375, x + 67.7251, y + 38.6886, x + 68.6253, y + 38.835);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 71.3103, y + 39.2478);
ctx.bezierCurveTo(x + 72.1978, y + 39.3927, x + 73.0324, y + 38.7871, x + 73.1748, y + 37.8973);
ctx.bezierCurveTo(x + 73.3172, y + 37.0074, x + 72.7135, y + 36.1677, x + 71.8257, y + 36.0234);
ctx.bezierCurveTo(x + 70.9382, y + 35.8785, x + 70.1029, y + 36.4837, x + 69.9612, y + 37.3739);
ctx.bezierCurveTo(x + 69.8188, y + 38.2638, x + 70.4228, y + 39.1029, x + 71.3103, y + 39.2478);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 73.9977, y + 39.6442);
ctx.bezierCurveTo(x + 74.8642, y + 39.7853, x + 75.6801, y + 39.1948, x + 75.8188, y + 38.3245);
ctx.bezierCurveTo(x + 75.9581, y + 37.4545, x + 75.3679, y + 36.6351, x + 74.5015, y + 36.494);
ctx.bezierCurveTo(x + 73.6344, y + 36.3525, x + 72.8191, y + 36.9433, x + 72.6798, y + 37.8133);
ctx.bezierCurveTo(x + 72.5411, y + 38.6837, x + 73.1307, y + 39.5027, x + 73.9977, y + 39.6442);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 76.6968, y + 39.9666);
ctx.bezierCurveTo(x + 77.502, y + 40.0974, x + 78.2597, y + 39.5486, x + 78.3892, y + 38.741);
ctx.bezierCurveTo(x + 78.5186, y + 37.9335, x + 77.9698, y + 37.1716, x + 77.1646, y + 37.0408);
ctx.bezierCurveTo(x + 76.3594, y + 36.91, x + 75.6017, y + 37.4587, x + 75.4726, y + 38.2657);
ctx.bezierCurveTo(x + 75.3435, y + 39.0742, x + 75.8916, y + 39.8357, x + 76.6968, y + 39.9666);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 79.4036, y + 40.2454);
ctx.bezierCurveTo(x + 80.1224, y + 40.3623, x + 80.7987, y + 39.8727, x + 80.9148, y + 39.1511);
ctx.bezierCurveTo(x + 81.0299, y + 38.4298, x + 80.5402, y + 37.7498, x + 79.8213, y + 37.6329);
ctx.bezierCurveTo(x + 79.1025, y + 37.516, x + 78.4256, y + 38.0053, x + 78.3105, y + 38.7266);
ctx.bezierCurveTo(x + 78.195, y + 39.4484, x + 78.685, y + 40.1279, x + 79.4036, y + 40.2454);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 82.0863, y + 40.672);
ctx.bezierCurveTo(x + 82.8015, y + 40.7884, x + 83.4739, y + 40.3015, x + 83.5885, y + 39.5839);
ctx.bezierCurveTo(x + 83.7034, y + 38.8673, x + 83.2164, y + 38.1912, x + 82.5022, y + 38.0745);
ctx.bezierCurveTo(x + 81.7871, y + 37.9581, x + 81.1146, y + 38.445, x + 81.0003, y + 39.162);
ctx.bezierCurveTo(x + 80.8847, y + 39.8798, x + 81.3712, y + 40.5556, x + 82.0863, y + 40.672);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 84.7734, y + 41.0692);
ctx.bezierCurveTo(x + 85.4672, y + 41.1824, x + 86.121, y + 40.709, x + 86.2322, y + 40.0119);
ctx.bezierCurveTo(x + 86.3435, y + 39.3149, x + 85.8708, y + 38.6588, x + 85.177, y + 38.5455);
ctx.bezierCurveTo(x + 84.4833, y + 38.4323, x + 83.8295, y + 38.9057, x + 83.718, y + 39.6018);
ctx.bezierCurveTo(x + 83.607, y + 40.2998, x + 84.0793, y + 40.9566, x + 84.7734, y + 41.0692);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 87.504, y + 41.1982);
ctx.bezierCurveTo(x + 88.0297, y + 41.2838, x + 88.5249, y + 40.9254, x + 88.6091, y + 40.3979);
ctx.bezierCurveTo(x + 88.6934, y + 39.8703, x + 88.3357, y + 39.3737, x + 87.8093, y + 39.2878);
ctx.bezierCurveTo(x + 87.2836, y + 39.2022, x + 86.7884, y + 39.5605, x + 86.7041, y + 40.0881);
ctx.bezierCurveTo(x + 86.6202, y + 40.615, x + 86.9782, y + 41.1126, x + 87.504, y + 41.1982);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 90.2415, y + 41.2815);
ctx.bezierCurveTo(x + 90.5742, y + 41.3357, x + 90.8872, y + 41.1088, x + 90.9407, y + 40.7751);
ctx.bezierCurveTo(x + 90.9941, y + 40.4413, x + 90.7675, y + 40.1267, x + 90.4348, y + 40.0724);
ctx.bezierCurveTo(x + 90.1022, y + 40.0182, x + 89.7891, y + 40.245, x + 89.7357, y + 40.5788);
ctx.bezierCurveTo(x + 89.6819, y + 40.9132, x + 89.9091, y + 41.2282, x + 90.2415, y + 41.2815);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 92.9722, y + 41.4104);
ctx.bezierCurveTo(x + 93.1368, y + 41.437, x + 93.2913, y + 41.3252, x + 93.3174, y + 41.16);
ctx.bezierCurveTo(x + 93.3439, y + 40.9958, x + 93.2316, y + 40.8402, x + 93.0673, y + 40.813);
ctx.bezierCurveTo(x + 92.9026, y + 40.7864, x + 92.7482, y + 40.8982, x + 92.7214, y + 41.0631);
ctx.bezierCurveTo(x + 92.6962, y + 41.228, x + 92.8076, y + 41.3838, x + 92.9722, y + 41.4104);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 95.6883, y + 41.6287);
ctx.bezierCurveTo(x + 95.7335, y + 41.6364, x + 95.7763, y + 41.6052, x + 95.7833, y + 41.5596);
ctx.bezierCurveTo(x + 95.7908, y + 41.5143, x + 95.7593, y + 41.4718, x + 95.7148, y + 41.4645);
ctx.bezierCurveTo(x + 95.6702, y + 41.4571, x + 95.6271, y + 41.4874, x + 95.6196, y + 41.5327);
ctx.bezierCurveTo(x + 95.6126, y + 41.5784, x + 95.6432, y + 41.621, x + 95.6883, y + 41.6287);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 98.3819, y + 41.9895);
ctx.bezierCurveTo(x + 98.3865, y + 41.9904, x + 98.3905, y + 41.9876, x + 98.3914, y + 41.983);
ctx.bezierCurveTo(x + 98.3919, y + 41.979, x + 98.3891, y + 41.975, x + 98.3845, y + 41.9741);
ctx.bezierCurveTo(x + 98.38, y + 41.9732, x + 98.3759, y + 41.976, x + 98.3751, y + 41.9806);
ctx.bezierCurveTo(x + 98.3746, y + 41.9845, x + 98.3773, y + 41.9886, x + 98.3819, y + 41.9895);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 29.5683, y + 33.6136);
ctx.bezierCurveTo(x + 29.5807, y + 33.6157, x + 29.592, y + 33.6069, x + 29.5941, y + 33.5944);
ctx.bezierCurveTo(x + 29.5962, y + 33.582, x + 29.5879, y + 33.571, x + 29.5756, y + 33.5689);
ctx.bezierCurveTo(x + 29.5632, y + 33.5668, x + 29.5519, y + 33.5756, x + 29.5498, y + 33.588);
ctx.bezierCurveTo(x + 29.5481, y + 33.5999, x + 29.556, y + 33.6115, x + 29.5683, y + 33.6136);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 32.2118, y + 34.287);
ctx.bezierCurveTo(x + 32.3557, y + 34.3108, x + 32.4909, y + 34.2121, x + 32.5143, y + 34.0678);
ctx.bezierCurveTo(x + 32.5377, y + 33.9234, x + 32.4391, y + 33.7876, x + 32.2959, y + 33.7641);
ctx.bezierCurveTo(x + 32.152, y + 33.7404, x + 32.0168, y + 33.839, x + 31.9938, y + 33.9828);
ctx.bezierCurveTo(x + 31.97, y + 34.1277, x + 32.0682, y + 34.2642, x + 32.2118, y + 34.287);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 34.8432, y + 35.0349);
ctx.bezierCurveTo(x + 35.1591, y + 35.0862, x + 35.4571, y + 34.8708, x + 35.5079, y + 34.5532);
ctx.bezierCurveTo(x + 35.5584, y + 34.2361, x + 35.3433, y + 33.9367, x + 35.0267, y + 33.8851);
ctx.bezierCurveTo(x + 34.7102, y + 33.8334, x + 34.4129, y + 34.0491, x + 34.362, y + 34.3668);
ctx.bezierCurveTo(x + 34.3115, y + 34.6838, x + 34.5266, y + 34.9832, x + 34.8432, y + 35.0349);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 37.52, y + 35.4998);
ctx.bezierCurveTo(x + 37.8526, y + 35.5541, x + 38.1657, y + 35.3272, x + 38.2195, y + 34.9928);
ctx.bezierCurveTo(x + 38.2729, y + 34.6591, x + 38.0463, y + 34.3444, x + 37.7136, y + 34.2902);
ctx.bezierCurveTo(x + 37.381, y + 34.2359, x + 37.0679, y + 34.4628, x + 37.0145, y + 34.7966);
ctx.bezierCurveTo(x + 36.9607, y + 35.131, x + 37.1873, y + 35.4456, x + 37.52, y + 35.4998);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 40.1479, y + 36.2698);
ctx.bezierCurveTo(x + 40.6656, y + 36.3541, x + 41.1521, y + 36.0013, x + 41.2356, y + 35.4821);
ctx.bezierCurveTo(x + 41.3186, y + 34.9627, x + 40.9665, y + 34.4731, x + 40.4488, y + 34.3889);
ctx.bezierCurveTo(x + 39.9311, y + 34.3046, x + 39.4446, y + 34.6574, x + 39.361, y + 35.1765);
ctx.bezierCurveTo(x + 39.278, y + 35.696, x + 39.6302, y + 36.1856, x + 40.1479, y + 36.2698);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 42.8267, y + 36.7192);
ctx.bezierCurveTo(x + 43.3525, y + 36.8048, x + 43.8476, y + 36.4464, x + 43.9319, y + 35.9189);
ctx.bezierCurveTo(x + 44.0162, y + 35.3914, x + 43.6584, y + 34.8947, x + 43.1321, y + 34.8087);
ctx.bezierCurveTo(x + 42.6063, y + 34.7232, x + 42.1112, y + 35.0815, x + 42.0272, y + 35.6085);
ctx.bezierCurveTo(x + 41.9426, y + 36.1366, x + 42.301, y + 36.6336, x + 42.8267, y + 36.7192);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 45.4708, y + 37.3858);
ctx.bezierCurveTo(x + 46.1244, y + 37.4925, x + 46.7389, y + 37.0466, x + 46.8437, y + 36.3915);
ctx.bezierCurveTo(x + 46.9484, y + 35.7364, x + 46.504, y + 35.1184, x + 45.8505, y + 35.0117);
ctx.bezierCurveTo(x + 45.1969, y + 34.905, x + 44.5824, y + 35.3508, x + 44.4776, y + 36.006);
ctx.bezierCurveTo(x + 44.3735, y + 36.6614, x + 44.8179, y + 37.2794, x + 45.4708, y + 37.3858);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 48.1335, y + 37.9395);
ctx.bezierCurveTo(x + 48.8524, y + 38.0563, x + 49.5293, y + 37.5671, x + 49.6447, y + 36.8452);
ctx.bezierCurveTo(x + 49.7598, y + 36.1239, x + 49.2701, y + 35.4439, x + 48.5513, y + 35.327);
ctx.bezierCurveTo(x + 47.8324, y + 35.2101, x + 47.1555, y + 35.6994, x + 47.0404, y + 36.4206);
ctx.bezierCurveTo(x + 46.925, y + 37.1425, x + 47.4147, y + 37.8226, x + 48.1335, y + 37.9395);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 50.7804, y + 38.5904);
ctx.bezierCurveTo(x + 51.6184, y + 38.7268, x + 52.4067, y + 38.156, x + 52.5413, y + 37.3145);
ctx.bezierCurveTo(x + 52.6756, y + 36.4737, x + 52.1054, y + 35.6815, x + 51.2674, y + 35.5451);
ctx.bezierCurveTo(x + 50.4294, y + 35.4087, x + 49.6412, y + 35.9795, x + 49.5069, y + 36.8204);
ctx.bezierCurveTo(x + 49.3722, y + 37.6618, x + 49.9424, y + 38.454, x + 50.7804, y + 38.5904);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 53.448, y + 39.1151);
ctx.bezierCurveTo(x + 54.3355, y + 39.26, x + 55.1701, y + 38.6544, x + 55.3125, y + 37.7646);
ctx.bezierCurveTo(x + 55.4549, y + 36.8747, x + 54.8512, y + 36.035, x + 53.9634, y + 35.8907);
ctx.bezierCurveTo(x + 53.0759, y + 35.7458, x + 52.2412, y + 36.3514, x + 52.0989, y + 37.2412);
ctx.bezierCurveTo(x + 51.9565, y + 38.1311, x + 52.5602, y + 38.9708, x + 53.448, y + 39.1151);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 56.1067, y + 39.6915);
ctx.bezierCurveTo(x + 57.0719, y + 39.8487, x + 57.9807, y + 39.1911, x + 58.1359, y + 38.2221);
ctx.bezierCurveTo(x + 58.2907, y + 37.2536, x + 57.6335, y + 36.3408, x + 56.6677, y + 36.1832);
ctx.bezierCurveTo(x + 55.7025, y + 36.026, x + 54.7936, y + 36.6836, x + 54.6388, y + 37.6521);
ctx.bezierCurveTo(x + 54.4837, y + 38.6211, x + 55.1409, y + 39.534, x + 56.1067, y + 39.6915);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 58.7755, y + 40.2007);
ctx.bezierCurveTo(x + 59.7822, y + 40.3651, x + 60.729, y + 39.6793, x + 60.8903, y + 38.6689);
ctx.bezierCurveTo(x + 61.0519, y + 37.6595, x + 60.3668, y + 36.7079, x + 59.3601, y + 36.5435);
ctx.bezierCurveTo(x + 58.3535, y + 36.3791, x + 57.4063, y + 37.0655, x + 57.2447, y + 38.0749);
ctx.bezierCurveTo(x + 57.0844, y + 39.085, x + 57.7695, y + 40.0367, x + 58.7755, y + 40.2007);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 61.4599, y + 40.6203);
ctx.bezierCurveTo(x + 62.4579, y + 40.783, x + 63.3977, y + 40.1028, x + 63.5577, y + 39.1005);
ctx.bezierCurveTo(x + 63.718, y + 38.0991, x + 63.0384, y + 37.1546, x + 62.0401, y + 36.9925);
ctx.bezierCurveTo(x + 61.0422, y + 36.8297, x + 60.1024, y + 37.51, x + 59.9427, y + 38.5117);
ctx.bezierCurveTo(x + 59.7821, y + 39.5136, x + 60.4616, y + 40.4581, x + 61.4599, y + 40.6203);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 64.1543, y + 40.9726);
ctx.bezierCurveTo(x + 65.1071, y + 41.1277, x + 66.004, y + 40.4786, x + 66.1571, y + 39.522);
ctx.bezierCurveTo(x + 66.3098, y + 38.566, x + 65.6608, y + 37.6641, x + 64.708, y + 37.5091);
ctx.bezierCurveTo(x + 63.7552, y + 37.354, x + 62.8582, y + 38.0031, x + 62.7052, y + 38.9597);
ctx.bezierCurveTo(x + 62.5522, y + 39.9163, x + 63.2015, y + 40.8175, x + 64.1543, y + 40.9726);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 66.8367, y + 41.4001);
ctx.bezierCurveTo(x + 67.7858, y + 41.5547, x + 68.6789, y + 40.9082, x + 68.8312, y + 39.956);
ctx.bezierCurveTo(x + 68.9834, y + 39.0037, x + 68.3373, y + 38.1066, x + 67.3882, y + 37.9521);
ctx.bezierCurveTo(x + 66.4392, y + 37.7975, x + 65.546, y + 38.4439, x + 65.3938, y + 39.3962);
ctx.bezierCurveTo(x + 65.2419, y + 40.3478, x + 65.8886, y + 41.2452, x + 66.8367, y + 41.4001);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 69.5236, y + 41.8051);
ctx.bezierCurveTo(x + 70.456, y + 41.9567, x + 71.3334, y + 41.3215, x + 71.483, y + 40.3853);
ctx.bezierCurveTo(x + 71.6323, y + 39.4498, x + 70.9978, y + 38.568, x + 70.0654, y + 38.4164);
ctx.bezierCurveTo(x + 69.1324, y + 38.2644, x + 68.255, y + 38.8996, x + 68.1057, y + 39.8352);
ctx.bezierCurveTo(x + 67.9564, y + 40.7707, x + 68.591, y + 41.6525, x + 69.5236, y + 41.8051);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 72.2097, y + 42.2095);
ctx.bezierCurveTo(x + 73.126, y + 42.3586, x + 73.9876, y + 41.7345, x + 74.1347, y + 40.8145);
ctx.bezierCurveTo(x + 74.2821, y + 39.8955, x + 73.6581, y + 39.0291, x + 72.7421, y + 38.8795);
ctx.bezierCurveTo(x + 71.8258, y + 38.7305, x + 70.9642, y + 39.3546, x + 70.8169, y + 40.2736);
ctx.bezierCurveTo(x + 70.6698, y + 41.1936, x + 71.2934, y + 42.0605, x + 72.2097, y + 42.2095);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.9114, y + 42.5173);
ctx.bezierCurveTo(x + 75.7574, y + 42.655, x + 76.5537, y + 42.0783, x + 76.6899, y + 41.2298);
ctx.bezierCurveTo(x + 76.8255, y + 40.3809, x + 76.2494, y + 39.5806, x + 75.4034, y + 39.4429);
ctx.bezierCurveTo(x + 74.5574, y + 39.3052, x + 73.7605, y + 39.8815, x + 73.6249, y + 40.7304);
ctx.bezierCurveTo(x + 73.4886, y + 41.579, x + 74.0654, y + 42.3796, x + 74.9114, y + 42.5173);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 77.5808, y + 43.0269);
ctx.bezierCurveTo(x + 78.4683, y + 43.1718, x + 79.303, y + 42.5662, x + 79.4453, y + 41.6763);
ctx.bezierCurveTo(x + 79.5877, y + 40.7864, x + 78.984, y + 39.9467, x + 78.0962, y + 39.8024);
ctx.bezierCurveTo(x + 77.2087, y + 39.6575, x + 76.3734, y + 40.2628, x + 76.2317, y + 41.153);
ctx.bezierCurveTo(x + 76.0897, y + 42.0422, x + 76.6933, y + 42.882, x + 77.5808, y + 43.0269);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 80.2876, y + 43.304);
ctx.bezierCurveTo(x + 81.0881, y + 43.4347, x + 81.8426, y + 42.8889, x + 81.971, y + 42.0847);
ctx.bezierCurveTo(x + 82.0996, y + 41.2815, x + 81.5541, y + 40.5238, x + 80.7529, y + 40.3929);
ctx.bezierCurveTo(x + 79.9524, y + 40.2623, x + 79.1979, y + 40.808, x + 79.0699, y + 41.6116);
ctx.bezierCurveTo(x + 78.9412, y + 42.4164, x + 79.4867, y + 43.174, x + 80.2876, y + 43.304);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 82.9927, y + 43.5896);
ctx.bezierCurveTo(x + 83.7115, y + 43.7065, x + 84.3878, y + 43.2169, x + 84.5039, y + 42.4953);
ctx.bezierCurveTo(x + 84.619, y + 41.7741, x + 84.1293, y + 41.094, x + 83.4104, y + 40.9771);
ctx.bezierCurveTo(x + 82.6916, y + 40.8603, x + 82.0147, y + 41.3495, x + 81.8996, y + 42.0708);
ctx.bezierCurveTo(x + 81.7841, y + 42.7927, x + 82.2742, y + 43.4721, x + 82.9927, y + 43.5896);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 85.7308, y + 43.6733);
ctx.bezierCurveTo(x + 86.2565, y + 43.7589, x + 86.7517, y + 43.4005, x + 86.8359, y + 42.873);
ctx.bezierCurveTo(x + 86.9202, y + 42.3454, x + 86.5619, y + 41.8484, x + 86.0361, y + 41.7628);
ctx.bezierCurveTo(x + 85.5104, y + 41.6773, x + 85.0152, y + 42.0356, x + 84.9313, y + 42.5626);
ctx.bezierCurveTo(x + 84.8467, y + 43.0907, x + 85.2044, y + 43.5874, x + 85.7308, y + 43.6733);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 88.468, y + 43.7572);
ctx.bezierCurveTo(x + 88.8006, y + 43.8114, x + 89.1137, y + 43.5846, x + 89.1675, y + 43.2502);
ctx.bezierCurveTo(x + 89.2209, y + 42.9164, x + 88.9943, y + 42.6017, x + 88.6616, y + 42.5475);
ctx.bezierCurveTo(x + 88.329, y + 42.4932, x + 88.0159, y + 42.7201, x + 87.9625, y + 43.0539);
ctx.bezierCurveTo(x + 87.9087, y + 43.3883, x + 88.1353, y + 43.7029, x + 88.468, y + 43.7572);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 91.1842, y + 43.9757);
ctx.bezierCurveTo(x + 91.3977, y + 44.0104, x + 91.5988, y + 43.8648, x + 91.633, y + 43.6505);
ctx.bezierCurveTo(x + 91.6672, y + 43.4363, x + 91.5217, y + 43.2342, x + 91.3082, y + 43.1994);
ctx.bezierCurveTo(x + 91.0947, y + 43.1647, x + 90.8936, y + 43.3103, x + 90.8594, y + 43.5246);
ctx.bezierCurveTo(x + 90.8252, y + 43.7388, x + 90.9707, y + 43.9409, x + 91.1842, y + 43.9757);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 93.9017, y + 44.1859);
ctx.bezierCurveTo(x + 93.9923, y + 44.2007, x + 94.0776, y + 44.1389, x + 94.0918, y + 44.0485);
ctx.bezierCurveTo(x + 94.106, y + 43.9582, x + 94.0449, y + 43.8728, x + 93.9542, y + 43.858);
ctx.bezierCurveTo(x + 93.8635, y + 43.8433, x + 93.7783, y + 43.9051, x + 93.7641, y + 43.9954);
ctx.bezierCurveTo(x + 93.7499, y + 44.0858, x + 93.8116, y + 44.1715, x + 93.9017, y + 44.1859);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 96.6057, y + 44.4789);
ctx.bezierCurveTo(x + 96.6181, y + 44.4811, x + 96.6293, y + 44.4722, x + 96.6314, y + 44.4598);
ctx.bezierCurveTo(x + 96.6335, y + 44.4474, x + 96.625, y + 44.4354, x + 96.6123, y + 44.4339);
ctx.bezierCurveTo(x + 96.5999, y + 44.4318, x + 96.5886, y + 44.4406, x + 96.5865, y + 44.453);
ctx.bezierCurveTo(x + 96.5854, y + 44.4652, x + 96.5933, y + 44.4768, x + 96.6057, y + 44.4789);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 30.4765, y + 36.5236);
ctx.bezierCurveTo(x + 30.4889, y + 36.5258, x + 30.5002, y + 36.5169, x + 30.5023, y + 36.5045);
ctx.bezierCurveTo(x + 30.5044, y + 36.492, x + 30.4965, y + 36.4804, x + 30.4832, y + 36.4786);
ctx.bezierCurveTo(x + 30.4708, y + 36.4764, x + 30.4595, y + 36.4853, x + 30.4574, y + 36.4977);
ctx.bezierCurveTo(x + 30.4556, y + 36.5095, x + 30.4642, y + 36.5215, x + 30.4765, y + 36.5236);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 33.1195, y + 37.1976);
ctx.bezierCurveTo(x + 33.2634, y + 37.2214, x + 33.3986, y + 37.1228, x + 33.422, y + 36.9784);
ctx.bezierCurveTo(x + 33.4454, y + 36.8341, x + 33.3469, y + 36.6982, x + 33.2036, y + 36.6748);
ctx.bezierCurveTo(x + 33.0597, y + 36.651, x + 32.9246, y + 36.7497, x + 32.9015, y + 36.8934);
ctx.bezierCurveTo(x + 32.8781, y + 37.0378, x + 32.9757, y + 37.1739, x + 33.1195, y + 37.1976);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 35.764, y + 37.8632);
ctx.bezierCurveTo(x + 36.0354, y + 37.9071, x + 36.2899, y + 37.7226, x + 36.3338, y + 37.4507);
ctx.bezierCurveTo(x + 36.3773, y + 37.1793, x + 36.1928, y + 36.9226, x + 35.9217, y + 36.878);
ctx.bezierCurveTo(x + 35.6506, y + 36.8334, x + 35.3958, y + 37.0185, x + 35.3519, y + 37.2905);
ctx.bezierCurveTo(x + 35.3084, y + 37.5619, x + 35.4929, y + 37.8186, x + 35.764, y + 37.8632);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 38.3872, y + 38.6636);
ctx.bezierCurveTo(x + 38.8594, y + 38.7408, x + 39.3044, y + 38.4183, x + 39.3804, y + 37.9445);
ctx.bezierCurveTo(x + 39.4564, y + 37.4707, x + 39.1343, y + 37.0235, x + 38.6617, y + 36.9469);
ctx.bezierCurveTo(x + 38.1895, y + 36.8697, x + 37.7445, y + 37.1922, x + 37.6689, y + 37.6654);
ctx.bezierCurveTo(x + 37.5925, y + 38.1398, x + 37.915, y + 38.5864, x + 38.3872, y + 38.6636);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 41.0552, y + 39.1802);
ctx.bezierCurveTo(x + 41.5729, y + 39.2645, x + 42.0594, y + 38.9116, x + 42.1424, y + 38.3922);
ctx.bezierCurveTo(x + 42.2254, y + 37.8727, x + 41.8733, y + 37.3832, x + 41.3556, y + 37.2989);
ctx.bezierCurveTo(x + 40.8378, y + 37.2146, x + 40.3507, y + 37.5671, x + 40.2678, y + 38.0866);
ctx.bezierCurveTo(x + 40.1854, y + 38.6064, x + 40.5375, y + 39.0959, x + 41.0552, y + 39.1802);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 43.6832, y + 39.9504);
ctx.bezierCurveTo(x + 44.3859, y + 40.0647, x + 45.0465, y + 39.5862, x + 45.1596, y + 38.8814);
ctx.bezierCurveTo(x + 45.2721, y + 38.1763, x + 44.7942, y + 37.5124, x + 44.0914, y + 37.3982);
ctx.bezierCurveTo(x + 43.3887, y + 37.2839, x + 42.7281, y + 37.7623, x + 42.615, y + 38.4671);
ctx.bezierCurveTo(x + 42.5025, y + 39.1722, x + 42.981, y + 39.8364, x + 43.6832, y + 39.9504);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 46.3599, y + 40.4153);
ctx.bezierCurveTo(x + 47.0787, y + 40.5322, x + 47.7556, y + 40.0429, x + 47.8711, y + 39.321);
ctx.bezierCurveTo(x + 47.9862, y + 38.5997, x + 47.4965, y + 37.9197, x + 46.7776, y + 37.8028);
ctx.bezierCurveTo(x + 46.0588, y + 37.6859, x + 45.3819, y + 38.1752, x + 45.2667, y + 38.8965);
ctx.bezierCurveTo(x + 45.1513, y + 39.6184, x + 45.6413, y + 40.2978, x + 46.3599, y + 40.4153);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 48.9977, y + 41.126);
ctx.bezierCurveTo(x + 49.8685, y + 41.268, x + 50.688, y + 40.6739, x + 50.8278, y + 39.8001);
ctx.bezierCurveTo(x + 50.9676, y + 38.9264, x + 50.375, y + 38.1025, x + 49.5039, y + 37.9612);
ctx.bezierCurveTo(x + 48.6331, y + 37.8192, x + 47.8136, y + 38.4134, x + 47.6738, y + 39.2871);
ctx.bezierCurveTo(x + 47.5334, y + 40.1605, x + 48.1263, y + 40.9837, x + 48.9977, y + 41.126);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 51.6738, y + 41.5905);
ctx.bezierCurveTo(x + 52.5613, y + 41.7354, x + 53.396, y + 41.1298, x + 53.5383, y + 40.2399);
ctx.bezierCurveTo(x + 53.6807, y + 39.35, x + 53.077, y + 38.5103, x + 52.1892, y + 38.366);
ctx.bezierCurveTo(x + 51.3017, y + 38.2211, x + 50.4671, y + 38.8267, x + 50.3247, y + 39.7166);
ctx.bezierCurveTo(x + 50.1823, y + 40.6064, x + 50.787, y + 41.4459, x + 51.6738, y + 41.5905);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 54.3325, y + 42.1668);
ctx.bezierCurveTo(x + 55.2977, y + 42.324, x + 56.2066, y + 41.6664, x + 56.3611, y + 40.6971);
ctx.bezierCurveTo(x + 56.5159, y + 39.7286, x + 55.8587, y + 38.8158, x + 54.8935, y + 38.6586);
ctx.bezierCurveTo(x + 53.9283, y + 38.5014, x + 53.0195, y + 39.159, x + 52.8646, y + 40.1274);
ctx.bezierCurveTo(x + 52.7101, y + 41.0968, x + 53.3673, y + 42.0096, x + 54.3325, y + 42.1668);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 57.0024, y + 42.6758);
ctx.bezierCurveTo(x + 58.009, y + 42.8402, x + 58.9562, y + 42.1538, x + 59.1171, y + 41.144);
ctx.bezierCurveTo(x + 59.2787, y + 40.1346, x + 58.5936, y + 39.183, x + 57.5869, y + 39.0186);
ctx.bezierCurveTo(x + 56.5803, y + 38.8542, x + 55.6331, y + 39.5406, x + 55.4715, y + 40.55);
ctx.bezierCurveTo(x + 55.3106, y + 41.5598, x + 55.9954, y + 42.5121, x + 57.0024, y + 42.6758);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 59.6766, y + 43.1554);
ctx.bezierCurveTo(x + 60.7077, y + 43.3231, x + 61.678, y + 42.6208, x + 61.8435, y + 41.5856);
ctx.bezierCurveTo(x + 62.0087, y + 40.551, x + 61.3071, y + 39.5758, x + 60.276, y + 39.4081);
ctx.bezierCurveTo(x + 59.2449, y + 39.2404, x + 58.2742, y + 39.9433, x + 58.1094, y + 40.9773);
ctx.bezierCurveTo(x + 57.9439, y + 42.0125, x + 58.6455, y + 42.9877, x + 59.6766, y + 43.1554);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 62.3544, y + 43.6127);
ctx.bezierCurveTo(x + 63.3979, y + 43.7825, x + 64.3795, y + 43.0713, x + 64.5468, y + 42.0244);
ctx.bezierCurveTo(x + 64.714, y + 40.9774, x + 64.0036, y + 39.9908, x + 62.9605, y + 39.8203);
ctx.bezierCurveTo(x + 61.9173, y + 39.6499, x + 60.9353, y + 40.3617, x + 60.7675, y + 41.4083);
ctx.bezierCurveTo(x + 60.6008, y + 42.4557, x + 61.3113, y + 43.4423, x + 62.3544, y + 43.6127);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.0479, y + 43.9727);
ctx.bezierCurveTo(x + 66.0501, y + 44.1363, x + 66.9932, y + 43.453, x + 67.1546, y + 42.4468);
ctx.bezierCurveTo(x + 67.3154, y + 41.4417, x + 66.6332, y + 40.4933, x + 65.6309, y + 40.3297);
ctx.bezierCurveTo(x + 64.6286, y + 40.1661, x + 63.6852, y + 40.85, x + 63.5245, y + 41.855);
ctx.bezierCurveTo(x + 63.363, y + 42.8613, x + 64.0456, y + 43.8091, x + 65.0479, y + 43.9727);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 67.7287, y + 44.4144);
ctx.bezierCurveTo(x + 68.7353, y + 44.5788, x + 69.6825, y + 43.8923, x + 69.8435, y + 42.8825);
ctx.bezierCurveTo(x + 70.005, y + 41.8731, x + 69.3199, y + 40.9215, x + 68.3133, y + 40.7571);
ctx.bezierCurveTo(x + 67.3067, y + 40.5927, x + 66.3594, y + 41.2792, x + 66.1978, y + 42.2886);
ctx.bezierCurveTo(x + 66.0366, y + 43.2989, x + 66.7217, y + 44.2506, x + 67.7287, y + 44.4144);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 70.4101, y + 44.8492);
ctx.bezierCurveTo(x + 71.4167, y + 45.0136, x + 72.3636, y + 44.3277, x + 72.5249, y + 43.3173);
ctx.bezierCurveTo(x + 72.6864, y + 42.3079, x + 72.0013, y + 41.3563, x + 70.9947, y + 41.1919);
ctx.bezierCurveTo(x + 69.988, y + 41.0275, x + 69.0408, y + 41.714, x + 68.8792, y + 42.7234);
ctx.bezierCurveTo(x + 68.7179, y + 43.7337, x + 69.4031, y + 44.6854, x + 70.4101, y + 44.8492);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 73.0917, y + 45.2838);
ctx.bezierCurveTo(x + 74.0983, y + 45.4482, x + 75.0455, y + 44.7617, x + 75.2065, y + 43.7519);
ctx.bezierCurveTo(x + 75.3681, y + 42.7425, x + 74.6829, y + 41.7909, x + 73.6763, y + 41.6265);
ctx.bezierCurveTo(x + 72.6697, y + 41.4621, x + 71.7225, y + 42.1486, x + 71.5609, y + 43.158);
ctx.bezierCurveTo(x + 71.3999, y + 44.1677, x + 72.0848, y + 45.12, x + 73.0917, y + 45.2838);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 75.7886, y + 45.6218);
ctx.bezierCurveTo(x + 76.7414, y + 45.7768, x + 77.6383, y + 45.1278, x + 77.7914, y + 44.1712);
ctx.bezierCurveTo(x + 77.9441, y + 43.2152, x + 77.2951, y + 42.3133, x + 76.3423, y + 42.1582);
ctx.bezierCurveTo(x + 75.3895, y + 42.0032, x + 74.4925, y + 42.6522, x + 74.3395, y + 43.6088);
ctx.bezierCurveTo(x + 74.1862, y + 44.5645, x + 74.8355, y + 45.4658, x + 75.7886, y + 45.6218);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 78.4893, y + 45.9369);
ctx.bezierCurveTo(x + 79.3768, y + 46.0818, x + 80.2114, y + 45.4762, x + 80.3538, y + 44.5863);
ctx.bezierCurveTo(x + 80.4961, y + 43.6965, x + 79.8924, y + 42.8567, x + 79.0046, y + 42.7124);
ctx.bezierCurveTo(x + 78.1171, y + 42.5675, x + 77.2825, y + 43.1731, x + 77.1401, y + 44.063);
ctx.bezierCurveTo(x + 76.9978, y + 44.9529, x + 77.6018, y + 45.792, x + 78.4893, y + 45.9369);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 81.1922, y + 46.2368);
ctx.bezierCurveTo(x + 82.0054, y + 46.3689, x + 82.7709, y + 45.8149, x + 82.9013, y + 44.9983);
ctx.bezierCurveTo(x + 83.0314, y + 44.1823, x + 82.478, y + 43.413, x + 81.6651, y + 43.2803);
ctx.bezierCurveTo(x + 80.8512, y + 43.1478, x + 80.0864, y + 43.7022, x + 79.9557, y + 44.5178);
ctx.bezierCurveTo(x + 79.8249, y + 45.335, x + 80.379, y + 46.1046, x + 81.1922, y + 46.2368);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 83.9011, y + 46.4998);
ctx.bezierCurveTo(x + 84.62, y + 46.6166, x + 85.2963, y + 46.1271, x + 85.4123, y + 45.4055);
ctx.bezierCurveTo(x + 85.5274, y + 44.6842, x + 85.0377, y + 44.0042, x + 84.3189, y + 43.8873);
ctx.bezierCurveTo(x + 83.6, y + 43.7704, x + 82.9231, y + 44.2597, x + 82.808, y + 44.9809);
ctx.bezierCurveTo(x + 82.6926, y + 45.7028, x + 83.1823, y + 46.3829, x + 83.9011, y + 46.4998);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 86.6385, y + 46.583);
ctx.bezierCurveTo(x + 87.1642, y + 46.6685, x + 87.6594, y + 46.3102, x + 87.7437, y + 45.7826);
ctx.bezierCurveTo(x + 87.8279, y + 45.2551, x + 87.4696, y + 44.7581, x + 86.9438, y + 44.6725);
ctx.bezierCurveTo(x + 86.4181, y + 44.5869, x + 85.9229, y + 44.9453, x + 85.839, y + 45.4722);
ctx.bezierCurveTo(x + 85.7544, y + 46.0004, x + 86.1127, y + 46.4974, x + 86.6385, y + 46.583);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 89.3764, y + 46.6673);
ctx.bezierCurveTo(x + 89.7091, y + 46.7216, x + 90.0221, y + 46.4947, x + 90.0759, y + 46.1603);
ctx.bezierCurveTo(x + 90.1293, y + 45.8265, x + 89.9027, y + 45.5119, x + 89.5701, y + 45.4577);
ctx.bezierCurveTo(x + 89.2374, y + 45.4034, x + 88.9243, y + 45.6303, x + 88.8709, y + 45.964);
ctx.bezierCurveTo(x + 88.8172, y + 46.2984, x + 89.0434, y + 46.6137, x + 89.3764, y + 46.6673);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 92.0823, y + 46.9456);
ctx.bezierCurveTo(x + 92.3286, y + 46.9859, x + 92.5606, y + 46.8176, x + 92.6003, y + 46.5705);
ctx.bezierCurveTo(x + 92.64, y + 46.3233, x + 92.4718, y + 46.0902, x + 92.2255, y + 46.0499);
ctx.bezierCurveTo(x + 91.9792, y + 46.0096, x + 91.7472, y + 46.1779, x + 91.7075, y + 46.425);
ctx.bezierCurveTo(x + 91.6688, y + 46.6719, x + 91.836, y + 46.9053, x + 92.0823, y + 46.9456);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 94.8033, y + 47.1339);
ctx.bezierCurveTo(x + 94.9144, y + 47.1521, x + 95.0186, y + 47.0761, x + 95.0365, y + 46.9647);
ctx.bezierCurveTo(x + 95.0541, y + 46.8538, x + 94.9792, y + 46.7488, x + 94.8681, y + 46.7306);
ctx.bezierCurveTo(x + 94.757, y + 46.7124, x + 94.6528, y + 46.7883, x + 94.6352, y + 46.8992);
ctx.bezierCurveTo(x + 94.6173, y + 47.0106, x + 94.6922, y + 47.1157, x + 94.8033, y + 47.1339);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 97.514, y + 47.389);
ctx.bezierCurveTo(x + 97.5264, y + 47.3911, x + 97.5383, y + 47.3826, x + 97.5398, y + 47.3698);
ctx.bezierCurveTo(x + 97.5419, y + 47.3574, x + 97.533, y + 47.3461, x + 97.5207, y + 47.3439);
ctx.bezierCurveTo(x + 97.5083, y + 47.3418, x + 97.4964, y + 47.3503, x + 97.4949, y + 47.3631);
ctx.bezierCurveTo(x + 97.4931, y + 47.3749, x + 97.5016, y + 47.3869, x + 97.514, y + 47.389);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 28.6972, y + 39.0361);
ctx.bezierCurveTo(x + 28.7299, y + 39.0417, x + 28.7609, y + 39.019, x + 28.7663, y + 38.9861);
ctx.bezierCurveTo(x + 28.7718, y + 38.9532, x + 28.7492, y + 38.9221, x + 28.7164, y + 38.9166);
ctx.bezierCurveTo(x + 28.6836, y + 38.911, x + 28.6527, y + 38.9337, x + 28.6472, y + 38.9666);
ctx.bezierCurveTo(x + 28.6414, y + 39.0001, x + 28.664, y + 39.0312, x + 28.6972, y + 39.0361);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 31.3402, y + 39.71);
ctx.bezierCurveTo(x + 31.5049, y + 39.7366, x + 31.6593, y + 39.6247, x + 31.6855, y + 39.4596);
ctx.bezierCurveTo(x + 31.7119, y + 39.2953, x + 31.5999, y + 39.1391, x + 31.4353, y + 39.1126);
ctx.bezierCurveTo(x + 31.2707, y + 39.086, x + 31.1162, y + 39.1978, x + 31.0898, y + 39.362);
ctx.bezierCurveTo(x + 31.0642, y + 39.5276, x + 31.1759, y + 39.6828, x + 31.3402, y + 39.71);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 33.9908, y + 40.3385);
ctx.bezierCurveTo(x + 34.2622, y + 40.3825, x + 34.517, y + 40.1974, x + 34.5606, y + 39.926);
ctx.bezierCurveTo(x + 34.6042, y + 39.6546, x + 34.4196, y + 39.3979, x + 34.1485, y + 39.3533);
ctx.bezierCurveTo(x + 33.8771, y + 39.3094, x + 33.6223, y + 39.4945, x + 33.5787, y + 39.7659);
ctx.bezierCurveTo(x + 33.5348, y + 40.0378, x + 33.7194, y + 40.2946, x + 33.9908, y + 40.3385);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 36.6304, y + 41.0344);
ctx.bezierCurveTo(x + 37.0451, y + 41.1018, x + 37.4353, y + 40.819, x + 37.502, y + 40.4023);
ctx.bezierCurveTo(x + 37.5684, y + 39.9863, x + 37.2859, y + 39.594, x + 36.8716, y + 39.526);
ctx.bezierCurveTo(x + 36.4569, y + 39.4587, x + 36.066, y + 39.7411, x + 35.9997, y + 40.1572);
ctx.bezierCurveTo(x + 35.9333, y + 40.5748, x + 36.2151, y + 40.9667, x + 36.6304, y + 41.0344);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 39.2801, y + 41.6704);
ctx.bezierCurveTo(x + 39.8058, y + 41.7559, x + 40.301, y + 41.3976, x + 40.3853, y + 40.87);
ctx.bezierCurveTo(x + 40.4695, y + 40.3425, x + 40.1112, y + 39.8455, x + 39.5854, y + 39.7599);
ctx.bezierCurveTo(x + 39.0597, y + 39.6743, x + 38.5645, y + 40.0327, x + 38.4803, y + 40.5602);
ctx.bezierCurveTo(x + 38.3954, y + 41.0874, x + 38.7537, y + 41.5845, x + 39.2801, y + 41.6704);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 41.9182, y + 42.3734);
ctx.bezierCurveTo(x + 42.5915, y + 42.4832, x + 43.226, y + 42.0246, x + 43.3338, y + 41.348);
ctx.bezierCurveTo(x + 43.442, y + 40.6724, x + 42.9828, y + 40.035, x + 42.3095, y + 39.9252);
ctx.bezierCurveTo(x + 41.6361, y + 39.8154, x + 41.0014, y + 40.2747, x + 40.8938, y + 40.9506);
ctx.bezierCurveTo(x + 40.786, y + 41.6272, x + 41.2445, y + 42.2642, x + 41.9182, y + 42.3734);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 44.5628, y + 43.0402);
ctx.bezierCurveTo(x + 45.3637, y + 43.1702, x + 46.1178, y + 42.6251, x + 46.2461, y + 41.8209);
ctx.bezierCurveTo(x + 46.3751, y + 41.0171, x + 45.8292, y + 40.26, x + 45.0281, y + 40.1291);
ctx.bezierCurveTo(x + 44.2266, y + 39.9987, x + 43.4731, y + 40.5442, x + 43.3447, y + 41.3484);
ctx.bezierCurveTo(x + 43.2161, y + 42.1516, x + 43.7616, y + 42.9093, x + 44.5628, y + 43.0402);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 47.2287, y + 43.5718);
ctx.bezierCurveTo(x + 48.0828, y + 43.7108, x + 48.8868, y + 43.1288, x + 49.024, y + 42.2712);
ctx.bezierCurveTo(x + 49.1613, y + 41.4136, x + 48.5796, y + 40.6062, x + 47.7249, y + 40.4668);
ctx.bezierCurveTo(x + 46.8702, y + 40.3275, x + 46.0668, y + 40.9098, x + 45.9296, y + 41.7674);
ctx.bezierCurveTo(x + 45.7927, y + 42.6244, x + 46.374, y + 43.4324, x + 47.2287, y + 43.5718);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 49.8895, y + 44.1333);
ctx.bezierCurveTo(x + 50.8139, y + 44.2836, x + 51.6835, y + 43.6536, x + 51.8316, y + 42.7262);
ctx.bezierCurveTo(x + 51.9802, y + 41.7991, x + 51.3509, y + 40.925, x + 50.426, y + 40.7744);
ctx.bezierCurveTo(x + 49.5016, y + 40.624, x + 48.632, y + 41.254, x + 48.4833, y + 42.1811);
ctx.bezierCurveTo(x + 48.3362, y + 43.1083, x + 48.9655, y + 43.9823, x + 49.8895, y + 44.1333);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 52.5593, y + 44.6422);
ctx.bezierCurveTo(x + 53.5245, y + 44.7994, x + 54.4334, y + 44.1418, x + 54.5885, y + 43.1728);
ctx.bezierCurveTo(x + 54.7433, y + 42.2043, x + 54.0861, y + 41.2915, x + 53.1203, y + 41.1339);
ctx.bezierCurveTo(x + 52.1551, y + 40.9767, x + 51.2463, y + 41.6343, x + 51.0915, y + 42.6028);
ctx.bezierCurveTo(x + 50.9363, y + 43.5718, x + 51.5942, y + 44.485, x + 52.5593, y + 44.6422);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 55.2288, y + 45.1517);
ctx.bezierCurveTo(x + 56.2354, y + 45.3161, x + 57.1826, y + 44.6296, x + 57.3436, y + 43.6198);
ctx.bezierCurveTo(x + 57.5051, y + 42.6104, x + 56.8203, y + 41.6582, x + 55.8134, y + 41.4944);
ctx.bezierCurveTo(x + 54.8064, y + 41.3306, x + 53.8595, y + 42.0165, x + 53.698, y + 43.0259);
ctx.bezierCurveTo(x + 53.537, y + 44.0356, x + 54.2222, y + 44.9873, x + 55.2288, y + 45.1517);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 57.9032, y + 45.6312);
ctx.bezierCurveTo(x + 58.9343, y + 45.7989, x + 59.9046, y + 45.0966, x + 60.0701, y + 44.0614);
ctx.bezierCurveTo(x + 60.2353, y + 43.0269, x + 59.5337, y + 42.0516, x + 58.5026, y + 41.8839);
ctx.bezierCurveTo(x + 57.4715, y + 41.7162, x + 56.5011, y + 42.4185, x + 56.336, y + 43.4531);
ctx.bezierCurveTo(x + 56.1702, y + 44.4873, x + 56.8721, y + 45.4635, x + 57.9032, y + 45.6312);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 60.5803, y + 46.0954);
ctx.bezierCurveTo(x + 61.6281, y + 46.2661, x + 62.6136, y + 45.5522, x + 62.7816, y + 44.5009);
ctx.bezierCurveTo(x + 62.9493, y + 43.4502, x + 62.2366, y + 42.4591, x + 61.1888, y + 42.2885);
ctx.bezierCurveTo(x + 60.141, y + 42.1178, x + 59.1555, y + 42.8317, x + 58.9878, y + 43.8824);
ctx.bezierCurveTo(x + 58.8194, y + 44.9343, x + 59.5325, y + 45.9248, x + 60.5803, y + 46.0954);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 63.264, y + 46.5148);
ctx.bezierCurveTo(x + 64.3038, y + 46.6841, x + 65.2816, y + 45.9756, x + 65.448, y + 44.9329);
ctx.bezierCurveTo(x + 65.6144, y + 43.8903, x + 64.907, y + 42.907, x + 63.8678, y + 42.7379);
ctx.bezierCurveTo(x + 62.8281, y + 42.5686, x + 61.8503, y + 43.2771, x + 61.6839, y + 44.3198);
ctx.bezierCurveTo(x + 61.5171, y + 45.363, x + 62.2249, y + 46.3458, x + 63.264, y + 46.5148);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.9455, y + 46.9495);
ctx.bezierCurveTo(x + 66.9852, y + 47.1189, x + 67.963, y + 46.4103, x + 68.1294, y + 45.3677);
ctx.bezierCurveTo(x + 68.2959, y + 44.325, x + 67.5884, y + 43.3417, x + 66.5493, y + 43.1727);
ctx.bezierCurveTo(x + 65.5095, y + 43.0033, x + 64.5317, y + 43.7119, x + 64.3647, y + 44.7542);
ctx.bezierCurveTo(x + 64.1985, y + 45.7978, x + 64.9063, y + 46.7805, x + 65.9455, y + 46.9495);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 68.6268, y + 47.3842);
ctx.bezierCurveTo(x + 69.6666, y + 47.5535, x + 70.6443, y + 46.8449, x + 70.8108, y + 45.8023);
ctx.bezierCurveTo(x + 70.9772, y + 44.7597, x + 70.2697, y + 43.7763, x + 69.2306, y + 43.6073);
ctx.bezierCurveTo(x + 68.1909, y + 43.438, x + 67.2131, y + 44.1465, x + 67.0466, y + 45.1892);
ctx.bezierCurveTo(x + 66.8796, y + 46.2315, x + 67.5871, y + 47.2148, x + 68.6268, y + 47.3842);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 71.3184, y + 47.7591);
ctx.bezierCurveTo(x + 72.325, y + 47.9235, x + 73.2722, y + 47.237, x + 73.4332, y + 46.2273);
ctx.bezierCurveTo(x + 73.5947, y + 45.2179, x + 72.9099, y + 44.2656, x + 71.903, y + 44.1018);
ctx.bezierCurveTo(x + 70.896, y + 43.938, x + 69.9491, y + 44.6239, x + 69.7876, y + 45.6333);
ctx.bezierCurveTo(x + 69.6263, y + 46.6436, x + 70.3114, y + 47.5953, x + 71.3184, y + 47.7591);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.0244, y + 48.0374);
ctx.bezierCurveTo(x + 74.9444, y + 48.1869, x + 75.8105, y + 47.5605, x + 75.9581, y + 46.6368);
ctx.bezierCurveTo(x + 76.1056, y + 45.7131, x + 75.4786, y + 44.8435, x + 74.559, y + 44.6934);
ctx.bezierCurveTo(x + 73.6383, y + 44.5436, x + 72.7729, y + 45.1703, x + 72.6253, y + 46.094);
ctx.bezierCurveTo(x + 72.4775, y + 47.0168, x + 73.1041, y + 47.887, x + 74.0244, y + 48.0374);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 76.7153, y + 48.4119);
ctx.bezierCurveTo(x + 77.6028, y + 48.5568, x + 78.4375, y + 47.9512, x + 78.5798, y + 47.0613);
ctx.bezierCurveTo(x + 78.7222, y + 46.1714, x + 78.1185, y + 45.3317, x + 77.2307, y + 45.1874);
ctx.bezierCurveTo(x + 76.3432, y + 45.0425, x + 75.508, y + 45.6478, x + 75.3662, y + 46.538);
ctx.bezierCurveTo(x + 75.2238, y + 47.4279, x + 75.8281, y + 48.2679, x + 76.7153, y + 48.4119);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 79.4306, y + 48.6377);
ctx.bezierCurveTo(x + 80.2027, y + 48.7636, x + 80.9294, y + 48.2375, x + 81.0537, y + 47.4622);
ctx.bezierCurveTo(x + 81.1777, y + 46.6876, x + 80.6516, y + 45.9568, x + 79.8792, y + 45.8315);
ctx.bezierCurveTo(x + 79.1071, y + 45.7056, x + 78.3803, y + 46.2317, x + 78.2563, y + 47.0064);
ctx.bezierCurveTo(x + 78.132, y + 47.7817, x + 78.6585, y + 48.5118, x + 79.4306, y + 48.6377);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 82.1277, y + 48.975);
ctx.bezierCurveTo(x + 82.8466, y + 49.0919, x + 83.5228, y + 48.6023, x + 83.6389, y + 47.8807);
ctx.bezierCurveTo(x + 83.754, y + 47.1594, x + 83.2643, y + 46.4794, x + 82.5454, y + 46.3625);
ctx.bezierCurveTo(x + 81.8266, y + 46.2456, x + 81.1503, y + 46.7352, x + 81.0346, y + 47.4562);
ctx.bezierCurveTo(x + 80.9191, y + 48.178, x + 81.4088, y + 48.8581, x + 82.1277, y + 48.975);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 84.865, y + 49.0588);
ctx.bezierCurveTo(x + 85.3908, y + 49.1444, x + 85.8859, y + 48.786, x + 85.9702, y + 48.2585);
ctx.bezierCurveTo(x + 86.0545, y + 47.7309, x + 85.6961, y + 47.2339, x + 85.1704, y + 47.1483);
ctx.bezierCurveTo(x + 84.6446, y + 47.0628, x + 84.1495, y + 47.4211, x + 84.0652, y + 47.9487);
ctx.bezierCurveTo(x + 83.9813, y + 48.4756, x + 84.3393, y + 48.9732, x + 84.865, y + 49.0588);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 87.6028, y + 49.1432);
ctx.bezierCurveTo(x + 87.9354, y + 49.1974, x + 88.2485, y + 48.9705, x + 88.3022, y + 48.6362);
ctx.bezierCurveTo(x + 88.3557, y + 48.3024, x + 88.129, y + 47.9877, x + 87.7964, y + 47.9335);
ctx.bezierCurveTo(x + 87.4637, y + 47.8792, x + 87.1507, y + 48.1061, x + 87.0972, y + 48.4399);
ctx.bezierCurveTo(x + 87.0435, y + 48.7743, x + 87.2701, y + 49.0889, x + 87.6028, y + 49.1432);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 90.301, y + 49.473);
ctx.bezierCurveTo(x + 90.5767, y + 49.5178, x + 90.8354, y + 49.3301, x + 90.8792, y + 49.054);
ctx.bezierCurveTo(x + 90.9229, y + 48.778, x + 90.7363, y + 48.5177, x + 90.4606, y + 48.4729);
ctx.bezierCurveTo(x + 90.1849, y + 48.4281, x + 89.9262, y + 48.6159, x + 89.8824, y + 48.8919);
ctx.bezierCurveTo(x + 89.838, y + 49.1676, x + 90.0253, y + 49.4282, x + 90.301, y + 49.473);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 93.0243, y + 49.6466);
ctx.bezierCurveTo(x + 93.1558, y + 49.6682, x + 93.2796, y + 49.5785, x + 93.3003, y + 49.4462);
ctx.bezierCurveTo(x + 93.3216, y + 49.3142, x + 93.2316, y + 49.1903, x + 93.1001, y + 49.1687);
ctx.bezierCurveTo(x + 92.9686, y + 49.1471, x + 92.8448, y + 49.2368, x + 92.8238, y + 49.3682);
ctx.bezierCurveTo(x + 92.8031, y + 49.5005, x + 92.8927, y + 49.6249, x + 93.0243, y + 49.6466);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 95.7332, y + 49.9097);
ctx.bezierCurveTo(x + 95.7703, y + 49.9161, x + 95.8045, y + 49.8904, x + 95.8107, y + 49.8532);
ctx.bezierCurveTo(x + 95.8167, y + 49.8165, x + 95.7917, y + 49.781, x + 95.7543, y + 49.7752);
ctx.bezierCurveTo(x + 95.7172, y + 49.7688, x + 95.683, y + 49.7945, x + 95.6767, y + 49.8317);
ctx.bezierCurveTo(x + 95.6708, y + 49.8684, x + 95.6961, y + 49.9033, x + 95.7332, y + 49.9097);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 29.6017, y + 41.9688);
ctx.bezierCurveTo(x + 29.6468, y + 41.9765, x + 29.6896, y + 41.9453, x + 29.6966, y + 41.8996);
ctx.bezierCurveTo(x + 29.7042, y + 41.8543, x + 29.6727, y + 41.8119, x + 29.6281, y + 41.8046);
ctx.bezierCurveTo(x + 29.5835, y + 41.7972, x + 29.5405, y + 41.8275, x + 29.5329, y + 41.8728);
ctx.bezierCurveTo(x + 29.5253, y + 41.9181, x + 29.5562, y + 41.9618, x + 29.6017, y + 41.9688);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 32.2483, y + 42.6201);
ctx.bezierCurveTo(x + 32.413, y + 42.6467, x + 32.5674, y + 42.5349, x + 32.5936, y + 42.3697);
ctx.bezierCurveTo(x + 32.62, y + 42.2055, x + 32.5077, y + 42.0499, x + 32.3434, y + 42.0227);
ctx.bezierCurveTo(x + 32.1788, y + 41.9961, x + 32.0243, y + 42.1079, x + 31.9979, y + 42.2722);
ctx.bezierCurveTo(x + 31.9714, y + 42.438, x + 32.0837, y + 42.5935, x + 32.2483, y + 42.6201);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 34.8808, y + 43.3607);
ctx.bezierCurveTo(x + 35.2135, y + 43.4149, x + 35.5265, y + 43.1881, x + 35.5803, y + 42.8537);
ctx.bezierCurveTo(x + 35.6337, y + 42.5199, x + 35.4071, y + 42.2053, x + 35.0745, y + 42.151);
ctx.bezierCurveTo(x + 34.7418, y + 42.0968, x + 34.4287, y + 42.3236, x + 34.3753, y + 42.6574);
ctx.bezierCurveTo(x + 34.3215, y + 42.9918, x + 34.5482, y + 43.3064, x + 34.8808, y + 43.3607);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 37.5297, y + 43.9969);
ctx.bezierCurveTo(x + 37.9734, y + 44.0693, x + 38.3907, y + 43.7665, x + 38.4621, y + 43.3213);
ctx.bezierCurveTo(x + 38.5331, y + 42.8767, x + 38.2315, y + 42.457, x + 37.7878, y + 42.3845);
ctx.bezierCurveTo(x + 37.3441, y + 42.3121, x + 36.9267, y + 42.6149, x + 36.8557, y + 43.0595);
ctx.bezierCurveTo(x + 36.7844, y + 43.5047, x + 37.0859, y + 43.9244, x + 37.5297, y + 43.9969);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 40.1873, y + 44.5808);
ctx.bezierCurveTo(x + 40.7131, y + 44.6663, x + 41.2082, y + 44.308, x + 41.2925, y + 43.7804);
ctx.bezierCurveTo(x + 41.3767, y + 43.2529, x + 41.0184, y + 42.7559, x + 40.4927, y + 42.6703);
ctx.bezierCurveTo(x + 39.9669, y + 42.5847, x + 39.4718, y + 42.9431, x + 39.3878, y + 43.47);
ctx.bezierCurveTo(x + 39.3036, y + 43.9976, x + 39.6616, y + 44.4952, x + 40.1873, y + 44.5808);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 42.8355, y + 45.2238);
ctx.bezierCurveTo(x + 43.4761, y + 45.328, x + 44.079, y + 44.8917, x + 44.182, y + 44.2484);
ctx.bezierCurveTo(x + 44.285, y + 43.605, x + 43.8488, y + 42.9997, x + 43.2076, y + 42.8951);
ctx.bezierCurveTo(x + 42.5671, y + 42.7908, x + 41.9635, y + 43.2268, x + 41.8605, y + 43.8702);
ctx.bezierCurveTo(x + 41.7581, y + 44.5138, x + 42.195, y + 45.1195, x + 42.8355, y + 45.2238);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 45.4648, y + 45.9875);
ctx.bezierCurveTo(x + 46.2867, y + 46.1213, x + 47.0599, y + 45.562, x + 47.1916, y + 44.7373);
ctx.bezierCurveTo(x + 47.3233, y + 43.9126, x + 46.7637, y + 43.1359, x + 45.9424, y + 43.0025);
ctx.bezierCurveTo(x + 45.1205, y + 42.8687, x + 44.3474, y + 43.428, x + 44.2156, y + 44.2527);
ctx.bezierCurveTo(x + 44.0836, y + 45.0764, x + 44.6429, y + 45.8537, x + 45.4648, y + 45.9875);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 48.1364, y + 46.4816);
ctx.bezierCurveTo(x + 48.9911, y + 46.6209, x + 49.7945, y + 46.0386, x + 49.9317, y + 45.181);
ctx.bezierCurveTo(x + 50.0686, y + 44.324, x + 49.4872, y + 43.516, x + 48.6326, y + 43.3766);
ctx.bezierCurveTo(x + 47.7785, y + 43.2376, x + 46.9745, y + 43.8196, x + 46.8372, y + 44.6772);
ctx.bezierCurveTo(x + 46.7003, y + 45.5342, x + 47.2823, y + 46.3426, x + 48.1364, y + 46.4816);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 50.793, y + 47.0733);
ctx.bezierCurveTo(x + 51.734, y + 47.2266, x + 52.6188, y + 46.5851, x + 52.7698, y + 45.6409);
ctx.bezierCurveTo(x + 52.9204, y + 44.6973, x + 52.2805, y + 43.8078, x + 51.3395, y + 43.6545);
ctx.bezierCurveTo(x + 50.3985, y + 43.5012, x + 49.5137, y + 44.1427, x + 49.3624, y + 45.086);
ctx.bezierCurveTo(x + 49.2115, y + 46.0302, x + 49.852, y + 46.92, x + 50.793, y + 47.0733);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 53.4673, y + 47.5528);
ctx.bezierCurveTo(x + 54.4325, y + 47.71, x + 55.3413, y + 47.0524, x + 55.4959, y + 46.083);
ctx.bezierCurveTo(x + 55.6507, y + 45.1146, x + 54.9934, y + 44.2018, x + 54.0283, y + 44.0446);
ctx.bezierCurveTo(x + 53.0631, y + 43.8874, x + 52.1542, y + 44.545, x + 51.9994, y + 45.5134);
ctx.bezierCurveTo(x + 51.8443, y + 46.4824, x + 52.5015, y + 47.3953, x + 53.4673, y + 47.5528);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 56.1371, y + 48.0618);
ctx.bezierCurveTo(x + 57.1437, y + 48.2262, x + 58.0909, y + 47.5397, x + 58.2519, y + 46.53);
ctx.bezierCurveTo(x + 58.4135, y + 45.5206, x + 57.7283, y + 44.5689, x + 56.7217, y + 44.4045);
ctx.bezierCurveTo(x + 55.7148, y + 44.2407, x + 54.7679, y + 44.9266, x + 54.6063, y + 45.936);
ctx.bezierCurveTo(x + 54.4453, y + 46.9458, x + 55.1302, y + 47.898, x + 56.1371, y + 48.0618);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 58.809, y + 48.5559);
ctx.bezierCurveTo(x + 59.8487, y + 48.7253, x + 60.8265, y + 48.0167, x + 60.993, y + 46.9741);
ctx.bezierCurveTo(x + 61.1594, y + 45.9315, x + 60.4519, y + 44.9481, x + 59.4128, y + 44.7791);
ctx.bezierCurveTo(x + 58.373, y + 44.6098, x + 57.3953, y + 45.3183, x + 57.2282, y + 46.3606);
ctx.bezierCurveTo(x + 57.0614, y + 47.4039, x + 57.7692, y + 48.3866, x + 58.809, y + 48.5559);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 61.4875, y + 49.0058);
ctx.bezierCurveTo(x + 62.5353, y + 49.1765, x + 63.5208, y + 48.4626, x + 63.6889, y + 47.4113);
ctx.bezierCurveTo(x + 63.8566, y + 46.3606, x + 63.1438, y + 45.3695, x + 62.096, y + 45.1989);
ctx.bezierCurveTo(x + 61.0482, y + 45.0282, x + 60.0628, y + 45.7421, x + 59.895, y + 46.7928);
ctx.bezierCurveTo(x + 59.727, y + 47.8441, x + 60.4407, y + 48.8349, x + 61.4875, y + 49.0058);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 64.1694, y + 49.4399);
ctx.bezierCurveTo(x + 65.2172, y + 49.6106, x + 66.2027, y + 48.8967, x + 66.3707, y + 47.8454);
ctx.bezierCurveTo(x + 66.5385, y + 46.7947, x + 65.8257, y + 45.8036, x + 64.7779, y + 45.633);
ctx.bezierCurveTo(x + 63.7301, y + 45.4623, x + 62.7446, y + 46.1761, x + 62.5769, y + 47.2269);
ctx.bezierCurveTo(x + 62.4085, y + 48.2788, x + 63.1222, y + 49.2696, x + 64.1694, y + 49.4399);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 66.8534, y + 49.8602);
ctx.bezierCurveTo(x + 67.8931, y + 50.0296, x + 68.8709, y + 49.321, x + 69.0373, y + 48.2784);
ctx.bezierCurveTo(x + 69.2038, y + 47.2357, x + 68.4963, y + 46.2524, x + 67.4572, y + 46.0834);
ctx.bezierCurveTo(x + 66.4174, y + 45.9141, x + 65.4396, y + 46.6226, x + 65.2732, y + 47.6652);
ctx.bezierCurveTo(x + 65.1062, y + 48.7076, x + 65.814, y + 49.6903, x + 66.8534, y + 49.8602);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 69.5443, y + 50.2347);
ctx.bezierCurveTo(x + 70.5509, y + 50.3991, x + 71.4982, y + 49.7126, x + 71.6591, y + 48.7028);
ctx.bezierCurveTo(x + 71.8207, y + 47.6934, x + 71.1355, y + 46.7418, x + 70.1289, y + 46.5774);
ctx.bezierCurveTo(x + 69.122, y + 46.4136, x + 68.1751, y + 47.0995, x + 68.0135, y + 48.1089);
ctx.bezierCurveTo(x + 67.8526, y + 49.1186, x + 68.5377, y + 50.0703, x + 69.5443, y + 50.2347);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 72.2339, y + 50.6173);
ctx.bezierCurveTo(x + 73.2114, y + 50.7766, x + 74.1316, y + 50.1101, x + 74.2885, y + 49.1293);
ctx.bezierCurveTo(x + 74.4454, y + 48.1485, x + 73.7797, y + 47.2237, x + 72.8021, y + 47.0643);
ctx.bezierCurveTo(x + 71.8246, y + 46.905, x + 70.9044, y + 47.5715, x + 70.7475, y + 48.5523);
ctx.bezierCurveTo(x + 70.5906, y + 49.5331, x + 71.2564, y + 50.4579, x + 72.2339, y + 50.6173);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.9239, y + 50.9992);
ctx.bezierCurveTo(x + 75.873, y + 51.1538, x + 76.7661, y + 50.5073, x + 76.9183, y + 49.5551);
ctx.bezierCurveTo(x + 77.0706, y + 48.6028, x + 76.4245, y + 47.7058, x + 75.4754, y + 47.5512);
ctx.bezierCurveTo(x + 74.5263, y + 47.3966, x + 73.6332, y + 48.043, x + 73.481, y + 48.9953);
ctx.bezierCurveTo(x + 73.3291, y + 49.947, x + 73.9748, y + 50.8446, x + 74.9239, y + 50.9992);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 77.6233, y + 51.3225);
ctx.bezierCurveTo(x + 78.5108, y + 51.4674, x + 79.3454, y + 50.8618, x + 79.4878, y + 49.972);
ctx.bezierCurveTo(x + 79.6302, y + 49.0821, x + 79.0265, y + 48.2424, x + 78.1387, y + 48.0981);
ctx.bezierCurveTo(x + 77.2512, y + 47.9532, x + 76.4159, y + 48.5584, x + 76.2742, y + 49.4486);
ctx.bezierCurveTo(x + 76.1318, y + 50.3385, x + 76.7358, y + 51.1776, x + 77.6233, y + 51.3225);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 80.3315, y + 51.5924);
ctx.bezierCurveTo(x + 81.1283, y + 51.7225, x + 81.8783, y + 51.179, x + 82.0058, y + 50.3792);
ctx.bezierCurveTo(x + 82.134, y + 49.5797, x + 81.5911, y + 48.8259, x + 80.7943, y + 48.6958);
ctx.bezierCurveTo(x + 79.9971, y + 48.5662, x + 79.2475, y + 49.1091, x + 79.1193, y + 49.9086);
ctx.bezierCurveTo(x + 78.9914, y + 50.7091, x + 79.5343, y + 51.4628, x + 80.3315, y + 51.5924);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 83.0582, y + 51.743);
ctx.bezierCurveTo(x + 83.6988, y + 51.8473, x + 84.3017, y + 51.4109, x + 84.4047, y + 50.7676);
ctx.bezierCurveTo(x + 84.5074, y + 50.1249, x + 84.0715, y + 49.5189, x + 83.4303, y + 49.4143);
ctx.bezierCurveTo(x + 82.7898, y + 49.3101, x + 82.1862, y + 49.7461, x + 82.0832, y + 50.3894);
ctx.bezierCurveTo(x + 81.9808, y + 51.0331, x + 82.4177, y + 51.6388, x + 83.0582, y + 51.743);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 85.7733, y + 51.9689);
ctx.bezierCurveTo(x + 86.299, y + 52.0545, x + 86.7942, y + 51.6962, x + 86.8784, y + 51.1686);
ctx.bezierCurveTo(x + 86.9627, y + 50.6411, x + 86.605, y + 50.1444, x + 86.0786, y + 50.0585);
ctx.bezierCurveTo(x + 85.5528, y + 49.9729, x + 85.0577, y + 50.3313, x + 84.9738, y + 50.8582);
ctx.bezierCurveTo(x + 84.8892, y + 51.3864, x + 85.2469, y + 51.883, x + 85.7733, y + 51.9689);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 88.4856, y + 52.2099);
ctx.bezierCurveTo(x + 88.9046, y + 52.2781, x + 89.2988, y + 51.9927, x + 89.3663, y + 51.5717);
ctx.bezierCurveTo(x + 89.4334, y + 51.1513, x + 89.1483, y + 50.7552, x + 88.7293, y + 50.687);
ctx.bezierCurveTo(x + 88.3103, y + 50.6188, x + 87.9162, y + 50.9042, x + 87.849, y + 51.3246);
ctx.bezierCurveTo(x + 87.7809, y + 51.7453, x + 88.0666, y + 52.1417, x + 88.4856, y + 52.2099);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 91.1919, y + 52.4875);
ctx.bezierCurveTo(x + 91.5246, y + 52.5418, x + 91.8377, y + 52.3149, x + 91.8911, y + 51.9811);
ctx.bezierCurveTo(x + 91.9445, y + 51.6473, x + 91.7179, y + 51.3327, x + 91.3852, y + 51.2785);
ctx.bezierCurveTo(x + 91.0526, y + 51.2242, x + 90.7395, y + 51.4511, x + 90.6861, y + 51.7848);
ctx.bezierCurveTo(x + 90.6327, y + 52.1186, x + 90.8593, y + 52.4333, x + 91.1919, y + 52.4875);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 93.9248, y + 52.6011);
ctx.bezierCurveTo(x + 94.0811, y + 52.627, x + 94.2275, y + 52.5195, x + 94.2527, y + 52.3633);
ctx.bezierCurveTo(x + 94.2778, y + 52.2072, x + 94.1717, y + 52.0591, x + 94.0152, y + 52.0338);
ctx.bezierCurveTo(x + 93.8589, y + 52.0079, x + 93.7118, y + 52.1151, x + 93.6873, y + 52.2716);
ctx.bezierCurveTo(x + 93.6627, y + 52.4281, x + 93.7688, y + 52.5761, x + 93.9248, y + 52.6011);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 96.6391, y + 52.8343);
ctx.bezierCurveTo(x + 96.6843, y + 52.842, x + 96.727, y + 52.8108, x + 96.734, y + 52.7652);
ctx.bezierCurveTo(x + 96.7416, y + 52.7199, x + 96.7101, y + 52.6774, x + 96.6655, y + 52.6701);
ctx.bezierCurveTo(x + 96.6204, y + 52.6624, x + 96.5779, y + 52.693, x + 96.5703, y + 52.7383);
ctx.bezierCurveTo(x + 96.5624, y + 52.7843, x + 96.5936, y + 52.8273, x + 96.6391, y + 52.8343);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 99.3295, y + 53.2094);
ctx.bezierCurveTo(x + 99.3419, y + 53.2115, x + 99.3532, y + 53.2027, x + 99.3553, y + 53.1903);
ctx.bezierCurveTo(x + 99.3574, y + 53.1778, x + 99.3489, y + 53.1659, x + 99.3362, y + 53.1644);
ctx.bezierCurveTo(x + 99.3238, y + 53.1622, x + 99.3125, y + 53.1711, x + 99.3104, y + 53.1835);
ctx.bezierCurveTo(x + 99.3093, y + 53.1957, x + 99.3172, y + 53.2073, x + 99.3295, y + 53.2094);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 25.1557, y + 43.9503);
ctx.bezierCurveTo(x + 25.1681, y + 43.9524, x + 25.1794, y + 43.9435, x + 25.1815, y + 43.9311);
ctx.bezierCurveTo(x + 25.1836, y + 43.9187, x + 25.1747, y + 43.9074, x + 25.163, y + 43.9056);
ctx.bezierCurveTo(x + 25.1506, y + 43.9034, x + 25.1393, y + 43.9123, x + 25.1375, y + 43.9241);
ctx.bezierCurveTo(x + 25.1355, y + 43.9365, x + 25.1434, y + 43.9481, x + 25.1557, y + 43.9503);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 27.8273, y + 44.4444);
ctx.bezierCurveTo(x + 27.8725, y + 44.4521, x + 27.9153, y + 44.4209, x + 27.9222, y + 44.3753);
ctx.bezierCurveTo(x + 27.9298, y + 44.33, x + 27.8983, y + 44.2876, x + 27.8537, y + 44.2802);
ctx.bezierCurveTo(x + 27.8082, y + 44.2731, x + 27.7661, y + 44.3031, x + 27.7586, y + 44.3484);
ctx.bezierCurveTo(x + 27.7516, y + 44.3941, x + 27.7821, y + 44.4368, x + 27.8273, y + 44.4444);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 30.4743, y + 45.0955);
ctx.bezierCurveTo(x + 30.6389, y + 45.122, x + 30.7933, y + 45.0102, x + 30.8195, y + 44.845);
ctx.bezierCurveTo(x + 30.8459, y + 44.6808, x + 30.734, y + 44.5246, x + 30.5693, y + 44.4981);
ctx.bezierCurveTo(x + 30.4047, y + 44.4715, x + 30.2503, y + 44.5833, x + 30.2238, y + 44.7475);
ctx.bezierCurveTo(x + 30.1983, y + 44.9131, x + 30.31, y + 45.0683, x + 30.4743, y + 45.0955);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 33.113, y + 45.7989);
ctx.bezierCurveTo(x + 33.4252, y + 45.8498, x + 33.7193, y + 45.637, x + 33.7693, y + 45.3238);
ctx.bezierCurveTo(x + 33.8194, y + 45.0105, x + 33.6065, y + 44.7155, x + 33.2943, y + 44.6647);
ctx.bezierCurveTo(x + 32.9821, y + 44.6139, x + 32.688, y + 44.8266, x + 32.638, y + 45.1399);
ctx.bezierCurveTo(x + 32.5883, y + 45.4526, x + 32.8008, y + 45.7481, x + 33.113, y + 45.7989);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 35.7418, y + 46.5615);
ctx.bezierCurveTo(x + 36.2348, y + 46.6416, x + 36.6984, y + 46.3055, x + 36.7778, y + 45.8112);
ctx.bezierCurveTo(x + 36.8566, y + 45.3166, x + 36.5213, y + 44.85, x + 36.0283, y + 44.77);
ctx.bezierCurveTo(x + 35.5353, y + 44.69, x + 35.0711, y + 45.0257, x + 34.9923, y + 45.5203);
ctx.bezierCurveTo(x + 34.9132, y + 46.0156, x + 35.2488, y + 46.4815, x + 35.7418, y + 46.5615);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 38.4141, y + 47.0559);
ctx.bezierCurveTo(x + 38.9399, y + 47.1414, x + 39.435, y + 46.7831, x + 39.5193, y + 46.2555);
ctx.bezierCurveTo(x + 39.6035, y + 45.728, x + 39.2452, y + 45.231, x + 38.7195, y + 45.1454);
ctx.bezierCurveTo(x + 38.1937, y + 45.0598, x + 37.6986, y + 45.4182, x + 37.6143, y + 45.9458);
ctx.bezierCurveTo(x + 37.53, y + 46.4733, x + 37.8884, y + 46.9703, x + 38.4141, y + 47.0559);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 41.0621, y + 47.6997);
ctx.bezierCurveTo(x + 41.7026, y + 47.804, x + 42.3056, y + 47.3677, x + 42.4086, y + 46.7243);
ctx.bezierCurveTo(x + 42.5112, y + 46.0816, x + 42.0754, y + 45.4756, x + 41.4342, y + 45.371);
ctx.bezierCurveTo(x + 40.7936, y + 45.2668, x + 40.1907, y + 45.7031, x + 40.0877, y + 46.3465);
ctx.bezierCurveTo(x + 39.9847, y + 46.9898, x + 40.4215, y + 47.5955, x + 41.0621, y + 47.6997);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 43.7006, y + 48.4029);
ctx.bezierCurveTo(x + 44.4893, y + 48.5318, x + 45.2313, y + 47.9941, x + 45.3581, y + 47.2027);
ctx.bezierCurveTo(x + 45.485, y + 46.4113, x + 44.948, y + 45.6656, x + 44.1589, y + 45.5374);
ctx.bezierCurveTo(x + 43.3698, y + 45.4092, x + 42.6282, y + 45.9462, x + 42.5013, y + 46.7376);
ctx.bezierCurveTo(x + 42.3748, y + 47.5284, x + 42.9114, y + 48.2747, x + 43.7006, y + 48.4029);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 46.3538, y + 49.017);
ctx.bezierCurveTo(x + 47.2413, y + 49.1619, x + 48.0759, y + 48.5563, x + 48.2183, y + 47.6664);
ctx.bezierCurveTo(x + 48.3606, y + 46.7765, x + 47.7569, y + 45.9368, x + 46.8691, y + 45.7925);
ctx.bezierCurveTo(x + 45.9816, y + 45.6476, x + 45.147, y + 46.2532, x + 45.0046, y + 47.1431);
ctx.bezierCurveTo(x + 44.8623, y + 48.033, x + 45.4659, y + 48.8727, x + 46.3538, y + 49.017);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 49.0218, y + 49.5337);
ctx.bezierCurveTo(x + 49.9542, y + 49.6853, x + 50.8316, y + 49.05, x + 50.9819, y + 48.1142);
ctx.bezierCurveTo(x + 51.1312, y + 47.1787, x + 50.4966, y + 46.2969, x + 49.5636, y + 46.145);
ctx.bezierCurveTo(x + 48.6312, y + 45.9933, x + 47.7539, y + 46.6286, x + 47.6039, y + 47.5638);
ctx.bezierCurveTo(x + 47.4543, y + 48.4999, x + 48.0888, y + 49.3817, x + 49.0218, y + 49.5337);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 51.6771, y + 50.1321);
ctx.bezierCurveTo(x + 52.7001, y + 50.2985, x + 53.6627, y + 49.6015, x + 53.8266, y + 48.575);
ctx.bezierCurveTo(x + 53.9911, y + 47.5488, x + 53.2938, y + 46.5816, x + 52.2711, y + 46.4146);
ctx.bezierCurveTo(x + 51.2481, y + 46.2482, x + 50.2854, y + 46.9452, x + 50.1213, y + 47.9708);
ctx.bezierCurveTo(x + 49.9577, y + 48.9982, x + 50.654, y + 49.9657, x + 51.6771, y + 50.1321);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 54.3539, y + 50.597);
ctx.bezierCurveTo(x + 55.3936, y + 50.7664, x + 56.3714, y + 50.0578, x + 56.5378, y + 49.0152);
ctx.bezierCurveTo(x + 56.7043, y + 47.9726, x + 55.9968, y + 46.9892, x + 54.9577, y + 46.8202);
ctx.bezierCurveTo(x + 53.9179, y + 46.6509, x + 52.9401, y + 47.3594, x + 52.7737, y + 48.4021);
ctx.bezierCurveTo(x + 52.6066, y + 49.4444, x + 53.3141, y + 50.4277, x + 54.3539, y + 50.597);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 57.0353, y + 51.0316);
ctx.bezierCurveTo(x + 58.075, y + 51.201, x + 59.0528, y + 50.4924, x + 59.2192, y + 49.4498);
ctx.bezierCurveTo(x + 59.3857, y + 48.4071, x + 58.6782, y + 47.4238, x + 57.6391, y + 47.2548);
ctx.bezierCurveTo(x + 56.5993, y + 47.0854, x + 55.6215, y + 47.794, x + 55.4551, y + 48.8366);
ctx.bezierCurveTo(x + 55.288, y + 49.8789, x + 55.9955, y + 50.8623, x + 57.0353, y + 51.0316);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 59.7143, y + 51.4812);
ctx.bezierCurveTo(x + 60.7621, y + 51.6518, x + 61.7476, y + 50.938, x + 61.9157, y + 49.8867);
ctx.bezierCurveTo(x + 62.0834, y + 48.8359, x + 61.3706, y + 47.8449, x + 60.3228, y + 47.6742);
ctx.bezierCurveTo(x + 59.275, y + 47.5036, x + 58.2896, y + 48.2174, x + 58.1218, y + 49.2681);
ctx.bezierCurveTo(x + 57.9534, y + 50.32, x + 58.6665, y + 51.3105, x + 59.7143, y + 51.4812);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 62.3957, y + 51.9157);
ctx.bezierCurveTo(x + 63.4435, y + 52.0864, x + 64.429, y + 51.3726, x + 64.597, y + 50.3212);
ctx.bezierCurveTo(x + 64.7648, y + 49.2705, x + 64.052, y + 48.2794, x + 63.0042, y + 48.1088);
ctx.bezierCurveTo(x + 61.9565, y + 47.9381, x + 60.971, y + 48.652, x + 60.8032, y + 49.7027);
ctx.bezierCurveTo(x + 60.6348, y + 50.7546, x + 61.3479, y + 51.7451, x + 62.3957, y + 51.9157);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.0829, y + 52.313);
ctx.bezierCurveTo(x + 66.1103, y + 52.4802, x + 67.0762, y + 51.7802, x + 67.2409, y + 50.7494);
ctx.bezierCurveTo(x + 67.4052, y + 49.7191, x + 66.7063, y + 48.7478, x + 65.6798, y + 48.5803);
ctx.bezierCurveTo(x + 64.6525, y + 48.4131, x + 63.6866, y + 49.1131, x + 63.5216, y + 50.143);
ctx.bezierCurveTo(x + 63.3572, y + 51.1748, x + 64.0565, y + 52.1455, x + 65.0829, y + 52.313);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 67.7707, y + 52.7105);
ctx.bezierCurveTo(x + 68.7776, y + 52.8743, x + 69.7245, y + 52.1884, x + 69.8855, y + 51.1787);
ctx.bezierCurveTo(x + 70.047, y + 50.1693, x + 69.3619, y + 49.2176, x + 68.3553, y + 49.0532);
ctx.bezierCurveTo(x + 67.3486, y + 48.8888, x + 66.4017, y + 49.5747, x + 66.2398, y + 50.5847);
ctx.bezierCurveTo(x + 66.0789, y + 51.5945, x + 66.764, y + 52.5461, x + 67.7707, y + 52.7105);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 70.4607, y + 53.0926);
ctx.bezierCurveTo(x + 71.4383, y + 53.2519, x + 72.3584, y + 52.5855, x + 72.5153, y + 51.6047);
ctx.bezierCurveTo(x + 72.6722, y + 50.6238, x + 72.0065, y + 49.699, x + 71.0289, y + 49.5397);
ctx.bezierCurveTo(x + 70.0514, y + 49.3803, x + 69.1312, y + 50.0468, x + 68.9743, y + 51.0276);
ctx.bezierCurveTo(x + 68.8174, y + 52.0085, x + 69.4832, y + 52.9333, x + 70.4607, y + 53.0926);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 73.1576, y + 53.4304);
ctx.bezierCurveTo(x + 74.0819, y + 53.5807, x + 74.9516, y + 52.9508, x + 75.0996, y + 52.0233);
ctx.bezierCurveTo(x + 75.2483, y + 51.0962, x + 74.619, y + 50.2221, x + 73.694, y + 50.0715);
ctx.bezierCurveTo(x + 72.7697, y + 49.9211, x + 71.9, y + 50.5511, x + 71.7514, y + 51.4782);
ctx.bezierCurveTo(x + 71.6043, y + 52.4054, x + 72.2333, y + 53.2801, x + 73.1576, y + 53.4304);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 75.8593, y + 53.7382);
ctx.bezierCurveTo(x + 76.7134, y + 53.8772, x + 77.5174, y + 53.2952, x + 77.6546, y + 52.4376);
ctx.bezierCurveTo(x + 77.7915, y + 51.5806, x + 77.2101, y + 50.7726, x + 76.3554, y + 50.6332);
ctx.bezierCurveTo(x + 75.5014, y + 50.4942, x + 74.6974, y + 51.0762, x + 74.5601, y + 51.9338);
ctx.bezierCurveTo(x + 74.4233, y + 52.7908, x + 75.0052, y + 53.5992, x + 75.8593, y + 53.7382);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 78.5493, y + 54.1201);
ctx.bezierCurveTo(x + 79.3749, y + 54.2544, x + 80.1516, y + 53.6915, x + 80.2845, y + 52.8634);
ctx.bezierCurveTo(x + 80.4167, y + 52.035, x + 79.8553, y + 51.2542, x + 79.0291, y + 51.1196);
ctx.bezierCurveTo(x + 78.2028, y + 50.9849, x + 77.4262, y + 51.5479, x + 77.2939, y + 52.3763);
ctx.bezierCurveTo(x + 77.1617, y + 53.2047, x + 77.7237, y + 53.9859, x + 78.5493, y + 54.1201);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 81.2774, y + 54.2637);
ctx.bezierCurveTo(x + 81.9427, y + 54.3722, x + 82.5688, y + 53.9185, x + 82.676, y + 53.2503);
ctx.bezierCurveTo(x + 82.7829, y + 52.5828, x + 82.3296, y + 51.9535, x + 81.6643, y + 51.845);
ctx.bezierCurveTo(x + 80.999, y + 51.7365, x + 80.3729, y + 52.1902, x + 80.266, y + 52.8578);
ctx.bezierCurveTo(x + 80.1588, y + 53.5259, x + 80.6117, y + 54.1558, x + 81.2774, y + 54.2637);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 83.9991, y + 54.4445);
ctx.bezierCurveTo(x + 84.5248, y + 54.5301, x + 85.02, y + 54.1718, x + 85.1043, y + 53.6442);
ctx.bezierCurveTo(x + 85.1885, y + 53.1167, x + 84.8302, y + 52.6196, x + 84.3044, y + 52.5341);
ctx.bezierCurveTo(x + 83.7787, y + 52.4485, x + 83.2835, y + 52.8069, x + 83.1996, y + 53.3338);
ctx.bezierCurveTo(x + 83.1159, y + 53.8617, x + 83.4733, y + 54.359, x + 83.9991, y + 54.4445);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 86.7061, y + 54.7225);
ctx.bezierCurveTo(x + 87.1455, y + 54.7941, x + 87.5592, y + 54.4949, x + 87.6301, y + 54.0534);
ctx.bezierCurveTo(x + 87.7006, y + 53.6125, x + 87.4008, y + 53.1969, x + 86.9614, y + 53.1253);
ctx.bezierCurveTo(x + 86.5219, y + 53.0537, x + 86.1082, y + 53.3529, x + 86.0377, y + 53.7938);
ctx.bezierCurveTo(x + 85.9668, y + 54.2353, x + 86.2666, y + 54.6509, x + 86.7061, y + 54.7225);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 89.4188, y + 54.9629);
ctx.bezierCurveTo(x + 89.7514, y + 55.0171, x + 90.0645, y + 54.7902, x + 90.1179, y + 54.4565);
ctx.bezierCurveTo(x + 90.1713, y + 54.1227, x + 89.9447, y + 53.8081, x + 89.6121, y + 53.7538);
ctx.bezierCurveTo(x + 89.2794, y + 53.6996, x + 88.9663, y + 53.9264, x + 88.9129, y + 54.2602);
ctx.bezierCurveTo(x + 88.8591, y + 54.5946, x + 89.0858, y + 54.9092, x + 89.4188, y + 54.9629);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 92.1487, y + 55.0913);
ctx.bezierCurveTo(x + 92.3133, y + 55.1179, x + 92.4678, y + 55.0061, x + 92.494, y + 54.8409);
ctx.bezierCurveTo(x + 92.5204, y + 54.6767, x + 92.4081, y + 54.5211, x + 92.2438, y + 54.4939);
ctx.bezierCurveTo(x + 92.0792, y + 54.4673, x + 91.9247, y + 54.5791, x + 91.8983, y + 54.7434);
ctx.bezierCurveTo(x + 91.8727, y + 54.9089, x + 91.9841, y + 55.0647, x + 92.1487, y + 55.0913);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 94.8455, y + 55.4293);
ctx.bezierCurveTo(x + 94.9566, y + 55.4475, x + 95.0608, y + 55.3715, x + 95.0788, y + 55.2601);
ctx.bezierCurveTo(x + 95.0964, y + 55.1492, x + 95.0214, y + 55.0442, x + 94.9104, y + 55.026);
ctx.bezierCurveTo(x + 94.7993, y + 55.0078, x + 94.695, y + 55.0837, x + 94.6774, y + 55.1946);
ctx.bezierCurveTo(x + 94.6595, y + 55.306, x + 94.7344, y + 55.4111, x + 94.8455, y + 55.4293);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 97.5584, y + 55.6706);
ctx.bezierCurveTo(x + 97.563, y + 55.6715, x + 97.5671, y + 55.6687, x + 97.5679, y + 55.6641);
ctx.bezierCurveTo(x + 97.5684, y + 55.6602, x + 97.5656, y + 55.6561, x + 97.5611, y + 55.6552);
ctx.bezierCurveTo(x + 97.5565, y + 55.6544, x + 97.5524, y + 55.6572, x + 97.5516, y + 55.6617);
ctx.bezierCurveTo(x + 97.5511, y + 55.6657, x + 97.5539, y + 55.6698, x + 97.5584, y + 55.6706);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 28.7381, y + 47.3399);
ctx.bezierCurveTo(x + 28.7752, y + 47.3463, x + 28.8094, y + 47.3206, x + 28.8157, y + 47.2834);
ctx.bezierCurveTo(x + 28.8216, y + 47.2467, x + 28.7963, y + 47.2118, x + 28.7598, y + 47.2058);
ctx.bezierCurveTo(x + 28.7227, y + 47.1994, x + 28.6879, y + 47.2247, x + 28.6823, y + 47.2623);
ctx.bezierCurveTo(x + 28.6757, y + 47.2986, x + 28.701, y + 47.3335, x + 28.7381, y + 47.3399);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 31.3825, y + 48.0056);
ctx.bezierCurveTo(x + 31.5468, y + 48.0328, x + 31.7015, y + 47.9204, x + 31.7277, y + 47.7552);
ctx.bezierCurveTo(x + 31.7541, y + 47.5909, x + 31.6422, y + 47.4348, x + 31.4775, y + 47.4082);
ctx.bezierCurveTo(x + 31.3129, y + 47.3816, x + 31.1585, y + 47.4934, x + 31.132, y + 47.6577);
ctx.bezierCurveTo(x + 31.1065, y + 47.8232, x + 31.2182, y + 47.9784, x + 31.3825, y + 48.0056);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 34.0319, y + 48.6422);
ctx.bezierCurveTo(x + 34.3077, y + 48.687, x + 34.5663, y + 48.4992, x + 34.6101, y + 48.2232);
ctx.bezierCurveTo(x + 34.6545, y + 47.9475, x + 34.4673, y + 47.6869, x + 34.1915, y + 47.6421);
ctx.bezierCurveTo(x + 33.9158, y + 47.5973, x + 33.6571, y + 47.7851, x + 33.6134, y + 48.0611);
ctx.bezierCurveTo(x + 33.569, y + 48.3368, x + 33.7565, y + 48.5968, x + 34.0319, y + 48.6422);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 36.6647, y + 49.3821);
ctx.bezierCurveTo(x + 37.1084, y + 49.4546, x + 37.5257, y + 49.1518, x + 37.5971, y + 48.7065);
ctx.bezierCurveTo(x + 37.6681, y + 48.2619, x + 37.3665, y + 47.8422, x + 36.9228, y + 47.7698);
ctx.bezierCurveTo(x + 36.4791, y + 47.6973, x + 36.0617, y + 48.0001, x + 35.9907, y + 48.4448);
ctx.bezierCurveTo(x + 35.919, y + 48.8906, x + 36.2206, y + 49.3103, x + 36.6647, y + 49.3821);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 39.3216, y + 49.9663);
ctx.bezierCurveTo(x + 39.8474, y + 50.0518, x + 40.3425, y + 49.6935, x + 40.4268, y + 49.1659);
ctx.bezierCurveTo(x + 40.511, y + 48.6384, x + 40.1527, y + 48.1414, x + 39.6269, y + 48.0558);
ctx.bezierCurveTo(x + 39.1012, y + 47.9702, x + 38.606, y + 48.3286, x + 38.5221, y + 48.8555);
ctx.bezierCurveTo(x + 38.4378, y + 49.3831, x + 38.7962, y + 49.8801, x + 39.3216, y + 49.9663);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 41.9473, y + 50.752);
ctx.bezierCurveTo(x + 42.6661, y + 50.8689, x + 43.3424, y + 50.3792, x + 43.4585, y + 49.6577);
ctx.bezierCurveTo(x + 43.5736, y + 48.9364, x + 43.0839, y + 48.2564, x + 42.365, y + 48.1395);
ctx.bezierCurveTo(x + 41.6462, y + 48.0226, x + 40.9693, y + 48.5119, x + 40.8541, y + 49.2332);
ctx.bezierCurveTo(x + 40.7387, y + 49.9551, x + 41.2287, y + 50.6345, x + 41.9473, y + 50.752);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 44.5989, y + 51.373);
ctx.bezierCurveTo(x + 45.4208, y + 51.5068, x + 46.1939, y + 50.9475, x + 46.3256, y + 50.1228);
ctx.bezierCurveTo(x + 46.4574, y + 49.2981, x + 45.8977, y + 48.5214, x + 45.0764, y + 48.388);
ctx.bezierCurveTo(x + 44.2545, y + 48.2542, x + 43.4814, y + 48.8135, x + 43.3497, y + 49.6382);
ctx.bezierCurveTo(x + 43.2183, y + 50.4622, x + 43.7779, y + 51.239, x + 44.5989, y + 51.373);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 47.2504, y + 51.9941);
ctx.bezierCurveTo(x + 48.1747, y + 52.1445, x + 49.0444, y + 51.5145, x + 49.1924, y + 50.587);
ctx.bezierCurveTo(x + 49.3405, y + 49.6596, x + 48.7118, y + 48.7859, x + 47.7868, y + 48.6352);
ctx.bezierCurveTo(x + 46.8625, y + 48.4849, x + 45.9928, y + 49.1148, x + 45.8442, y + 50.0419);
ctx.bezierCurveTo(x + 45.6967, y + 50.9697, x + 46.326, y + 51.8438, x + 47.2504, y + 51.9941);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 49.92, y + 52.5036);
ctx.bezierCurveTo(x + 50.8852, y + 52.6608, x + 51.7941, y + 52.0033, x + 51.9492, y + 51.0342);
ctx.bezierCurveTo(x + 52.104, y + 50.0658, x + 51.4468, y + 49.1529, x + 50.4816, y + 48.9957);
ctx.bezierCurveTo(x + 49.5165, y + 48.8385, x + 48.6076, y + 49.4961, x + 48.4528, y + 50.4646);
ctx.bezierCurveTo(x + 48.2976, y + 51.4336, x + 48.9549, y + 52.3464, x + 49.92, y + 52.5036);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 52.5897, y + 53.0125);
ctx.bezierCurveTo(x + 53.5967, y + 53.1763, x + 54.5436, y + 52.4904, x + 54.7046, y + 51.4807);
ctx.bezierCurveTo(x + 54.8661, y + 50.4713, x + 54.181, y + 49.5196, x + 53.1743, y + 49.3552);
ctx.bezierCurveTo(x + 52.1677, y + 49.1908, x + 51.2205, y + 49.8773, x + 51.0589, y + 50.8867);
ctx.bezierCurveTo(x + 50.898, y + 51.8965, x + 51.5828, y + 52.8487, x + 52.5897, y + 53.0125);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 55.2714, y + 53.4473);
ctx.bezierCurveTo(x + 56.2783, y + 53.6111, x + 57.2252, y + 52.9252, x + 57.3862, y + 51.9155);
ctx.bezierCurveTo(x + 57.5478, y + 50.9061, x + 56.8626, y + 49.9544, x + 55.856, y + 49.79);
ctx.bezierCurveTo(x + 54.849, y + 49.6262, x + 53.9021, y + 50.3121, x + 53.7406, y + 51.3215);
ctx.bezierCurveTo(x + 53.5796, y + 52.3313, x + 54.2648, y + 53.2829, x + 55.2714, y + 53.4473);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 57.9447, y + 53.9344);
ctx.bezierCurveTo(x + 58.9801, y + 54.1029, x + 59.9543, y + 53.3979, x + 60.1203, y + 52.359);
ctx.bezierCurveTo(x + 60.2862, y + 51.3201, x + 59.5811, y + 50.3413, x + 58.5463, y + 50.1731);
ctx.bezierCurveTo(x + 57.5108, y + 50.0046, x + 56.5366, y + 50.7095, x + 56.3707, y + 51.7484);
ctx.bezierCurveTo(x + 56.2044, y + 52.7864, x + 56.9096, y + 53.7652, x + 57.9447, y + 53.9344);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 60.6261, y + 54.3689);
ctx.bezierCurveTo(x + 61.6615, y + 54.5375, x + 62.6351, y + 53.8322, x + 62.8017, y + 52.7936);
ctx.bezierCurveTo(x + 62.9676, y + 51.7547, x + 62.2631, y + 50.7762, x + 61.2277, y + 50.6077);
ctx.bezierCurveTo(x + 60.1922, y + 50.4391, x + 59.218, y + 51.1441, x + 59.0521, y + 52.183);
ctx.bezierCurveTo(x + 58.8858, y + 53.221, x + 59.591, y + 54.1998, x + 60.6261, y + 54.3689);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 63.3041, y + 54.8259);
ctx.bezierCurveTo(x + 64.3519, y + 54.9965, x + 65.3374, y + 54.2827, x + 65.5055, y + 53.2314);
ctx.bezierCurveTo(x + 65.6732, y + 52.1807, x + 64.9605, y + 51.1896, x + 63.9127, y + 51.0189);
ctx.bezierCurveTo(x + 62.8649, y + 50.8483, x + 61.8794, y + 51.5621, x + 61.7117, y + 52.6128);
ctx.bezierCurveTo(x + 61.5433, y + 53.6648, x + 62.2563, y + 54.6552, x + 63.3041, y + 54.8259);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.9886, y + 55.2376);
ctx.bezierCurveTo(x + 67.0241, y + 55.4061, x + 67.9983, y + 54.7012, x + 68.1642, y + 53.6623);
ctx.bezierCurveTo(x + 68.3302, y + 52.6234, x + 67.6256, y + 51.6448, x + 66.5902, y + 51.4763);
ctx.bezierCurveTo(x + 65.5548, y + 51.3078, x + 64.5806, y + 52.0127, x + 64.4146, y + 53.0517);
ctx.bezierCurveTo(x + 64.2487, y + 54.0906, x + 64.9538, y + 55.0694, x + 65.9886, y + 55.2376);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 68.681, y + 55.6056);
ctx.bezierCurveTo(x + 69.679, y + 55.7684, x + 70.6181, y + 55.0878, x + 70.7788, y + 54.0858);
ctx.bezierCurveTo(x + 70.939, y + 53.0845, x + 70.2592, y + 52.1406, x + 69.2612, y + 51.9778);
ctx.bezierCurveTo(x + 68.2632, y + 51.8151, x + 67.3234, y + 52.4953, x + 67.1638, y + 53.497);
ctx.bezierCurveTo(x + 67.0031, y + 54.4989, x + 67.683, y + 55.4428, x + 68.681, y + 55.6056);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 71.3733, y + 55.9731);
ctx.bezierCurveTo(x + 72.3348, y + 56.1298, x + 73.2392, y + 55.4745, x + 73.3935, y + 54.5099);
ctx.bezierCurveTo(x + 73.5475, y + 53.5458, x + 72.8932, y + 52.6362, x + 71.9324, y + 52.4798);
ctx.bezierCurveTo(x + 70.971, y + 52.3231, x + 70.0665, y + 52.9784, x + 69.9125, y + 53.9425);
ctx.bezierCurveTo(x + 69.7573, y + 54.9074, x + 70.4119, y + 55.8164, x + 71.3733, y + 55.9731);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.0659, y + 56.3404);
ctx.bezierCurveTo(x + 74.9902, y + 56.4907, x + 75.8599, y + 55.8607, x + 76.0079, y + 54.9333);
ctx.bezierCurveTo(x + 76.156, y + 54.0058, x + 75.5273, y + 53.1321, x + 74.6027, y + 52.9808);
ctx.bezierCurveTo(x + 73.6783, y + 52.8305, x + 72.8087, y + 53.4605, x + 72.66, y + 54.3876);
ctx.bezierCurveTo(x + 72.5126, y + 55.3154, x + 73.1409, y + 56.1897, x + 74.0659, y + 56.3404);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 76.7594, y + 56.7003);
ctx.bezierCurveTo(x + 77.6426, y + 56.8444, x + 78.4736, y + 56.2423, x + 78.6152, y + 55.3552);
ctx.bezierCurveTo(x + 78.7571, y + 54.4691, x + 78.1558, y + 53.6339, x + 77.2726, y + 53.4898);
ctx.bezierCurveTo(x + 76.3894, y + 53.3457, x + 75.5584, y + 53.9477, x + 75.4165, y + 54.8339);
ctx.bezierCurveTo(x + 75.2749, y + 55.721, x + 75.8763, y + 56.5562, x + 76.7594, y + 56.7003);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 79.4647, y + 56.9855);
ctx.bezierCurveTo(x + 80.2652, y + 57.1161, x + 81.0197, y + 56.5703, x + 81.148, y + 55.7661);
ctx.bezierCurveTo(x + 81.276, y + 54.9626, x + 80.7311, y + 54.2053, x + 79.93, y + 54.0743);
ctx.bezierCurveTo(x + 79.1285, y + 53.944, x + 78.375, y + 54.4895, x + 78.247, y + 55.293);
ctx.bezierCurveTo(x + 78.1177, y + 56.0975, x + 78.6632, y + 56.8551, x + 79.4647, y + 56.9855);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 82.1779, y + 57.2189);
ctx.bezierCurveTo(x + 82.8683, y + 57.3311, x + 83.5179, y + 56.8609, x + 83.6283, y + 56.1682);
ctx.bezierCurveTo(x + 83.7394, y + 55.4758, x + 83.2694, y + 54.8235, x + 82.5787, y + 54.7104);
ctx.bezierCurveTo(x + 81.8886, y + 54.5977, x + 81.2387, y + 55.0685, x + 81.1286, y + 55.7606);
ctx.bezierCurveTo(x + 81.0182, y + 56.4533, x + 81.4879, y + 57.1062, x + 82.1779, y + 57.2189);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 84.9073, y + 57.3545);
ctx.bezierCurveTo(x + 85.4331, y + 57.44, x + 85.9282, y + 57.0817, x + 86.0125, y + 56.5541);
ctx.bezierCurveTo(x + 86.0967, y + 56.0266, x + 85.7384, y + 55.5296, x + 85.2126, y + 55.444);
ctx.bezierCurveTo(x + 84.6869, y + 55.3584, x + 84.1917, y + 55.7168, x + 84.1078, y + 56.2437);
ctx.bezierCurveTo(x + 84.0232, y + 56.7719, x + 84.3815, y + 57.2689, x + 84.9073, y + 57.3545);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 87.6068, y + 57.6778);
ctx.bezierCurveTo(x + 88.071, y + 57.7537, x + 88.5079, y + 57.4371, x + 88.582, y + 56.971);
ctx.bezierCurveTo(x + 88.6567, y + 56.5053, x + 88.3405, y + 56.0662, x + 87.8763, y + 55.9903);
ctx.bezierCurveTo(x + 87.4121, y + 55.9144, x + 86.9752, y + 56.231, x + 86.9005, y + 56.6968);
ctx.bezierCurveTo(x + 86.8264, y + 57.1628, x + 87.1426, y + 57.602, x + 87.6068, y + 57.6778);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 90.3266, y + 57.8734);
ctx.bezierCurveTo(x + 90.6593, y + 57.9276, x + 90.9723, y + 57.7008, x + 91.0261, y + 57.3664);
ctx.bezierCurveTo(x + 91.0795, y + 57.0326, x + 90.8529, y + 56.718, x + 90.5202, y + 56.6637);
ctx.bezierCurveTo(x + 90.1876, y + 56.6095, x + 89.8745, y + 56.8363, x + 89.8211, y + 57.1701);
ctx.bezierCurveTo(x + 89.7673, y + 57.5045, x + 89.994, y + 57.8191, x + 90.3266, y + 57.8734);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 93.057, y + 58.0015);
ctx.bezierCurveTo(x + 93.2213, y + 58.0287, x + 93.3761, y + 57.9163, x + 93.4023, y + 57.7511);
ctx.bezierCurveTo(x + 93.4287, y + 57.5868, x + 93.3168, y + 57.4307, x + 93.1521, y + 57.4041);
ctx.bezierCurveTo(x + 92.9875, y + 57.3775, x + 92.833, y + 57.4893, x + 92.8066, y + 57.6535);
ctx.bezierCurveTo(x + 92.7807, y + 57.8197, x + 92.8924, y + 57.9749, x + 93.057, y + 58.0015);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 95.7634, y + 58.2791);
ctx.bezierCurveTo(x + 95.8417, y + 58.2917, x + 95.9151, y + 58.2384, x + 95.9275, y + 58.1599);
ctx.bezierCurveTo(x + 95.94, y + 58.0813, x + 95.8867, y + 58.0076, x + 95.8085, y + 57.995);
ctx.bezierCurveTo(x + 95.7302, y + 57.9823, x + 95.6568, y + 58.0356, x + 95.6447, y + 58.1135);
ctx.bezierCurveTo(x + 95.6325, y + 58.193, x + 95.6857, y + 58.2668, x + 95.7634, y + 58.2791);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 98.4656, y + 58.5872);
ctx.bezierCurveTo(x + 98.4736, y + 58.5885, x + 98.4813, y + 58.5832, x + 98.4829, y + 58.5745);
ctx.bezierCurveTo(x + 98.4842, y + 58.5664, x + 98.4789, y + 58.5587, x + 98.4709, y + 58.5574);
ctx.bezierCurveTo(x + 98.4628, y + 58.5561, x + 98.4551, y + 58.5613, x + 98.4539, y + 58.5694);
ctx.bezierCurveTo(x + 98.4513, y + 58.5784, x + 98.4566, y + 58.5861, x + 98.4656, y + 58.5872);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 26.9669, y + 49.8003);
ctx.bezierCurveTo(x + 26.9954, y + 49.805, x + 27.0224, y + 49.785, x + 27.0271, y + 49.7565);
ctx.bezierCurveTo(x + 27.0318, y + 49.7279, x + 27.0121, y + 49.7001, x + 26.9833, y + 49.696);
ctx.bezierCurveTo(x + 26.9548, y + 49.6912, x + 26.9272, y + 49.7109, x + 26.9231, y + 49.7398);
ctx.bezierCurveTo(x + 26.9184, y + 49.7684, x + 26.9385, y + 49.7956, x + 26.9669, y + 49.8003);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 29.6093, y + 50.481);
ctx.bezierCurveTo(x + 29.7739, y + 50.5075, x + 29.9283, y + 50.3957, x + 29.9545, y + 50.2306);
ctx.bezierCurveTo(x + 29.981, y + 50.0663, x + 29.869, y + 49.9101, x + 29.7044, y + 49.8836);
ctx.bezierCurveTo(x + 29.5397, y + 49.857, x + 29.3853, y + 49.9688, x + 29.3588, y + 50.133);
ctx.bezierCurveTo(x + 29.3323, y + 50.2988, x + 29.4446, y + 50.4544, x + 29.6093, y + 50.481);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 32.27, y + 51.0423);
ctx.bezierCurveTo(x + 32.5039, y + 51.0805, x + 32.7246, y + 50.921, x + 32.7622, y + 50.6863);
ctx.bezierCurveTo(x + 32.7998, y + 50.4516, x + 32.6402, y + 50.2304, x + 32.4063, y + 50.1922);
ctx.bezierCurveTo(x + 32.1723, y + 50.154, x + 31.9516, y + 50.3135, x + 31.914, y + 50.5482);
ctx.bezierCurveTo(x + 31.8764, y + 50.7829, x + 32.036, y + 51.0041, x + 32.27, y + 51.0423);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 34.9049, y + 51.7683);
ctx.bezierCurveTo(x + 35.2991, y + 51.8322, x + 35.6704, y + 51.5636, x + 35.7334, y + 51.168);
ctx.bezierCurveTo(x + 35.7963, y + 50.7724, x + 35.528, y + 50.3993, x + 35.1337, y + 50.3353);
ctx.bezierCurveTo(x + 34.7395, y + 50.2714, x + 34.3682, y + 50.54, x + 34.3052, y + 50.9356);
ctx.bezierCurveTo(x + 34.2423, y + 51.3312, x + 34.511, y + 51.7037, x + 34.9049, y + 51.7683);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 37.5484, y + 52.4416);
ctx.bezierCurveTo(x + 38.0741, y + 52.5272, x + 38.5693, y + 52.1688, x + 38.6536, y + 51.6413);
ctx.bezierCurveTo(x + 38.7378, y + 51.1138, x + 38.3795, y + 50.6167, x + 37.8537, y + 50.5312);
ctx.bezierCurveTo(x + 37.328, y + 50.4456, x + 36.8328, y + 50.8039, x + 36.7489, y + 51.3309);
ctx.bezierCurveTo(x + 36.6643, y + 51.859, x + 37.0226, y + 52.356, x + 37.5484, y + 52.4416);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 40.1668, y + 53.2718);
ctx.bezierCurveTo(x + 40.9104, y + 53.3929, x + 41.6105, y + 52.8862, x + 41.7298, y + 52.1401);
ctx.bezierCurveTo(x + 41.8491, y + 51.394, x + 41.3426, y + 50.691, x + 40.599, y + 50.5699);
ctx.bezierCurveTo(x + 39.8554, y + 50.4487, x + 39.1559, y + 50.9557, x + 39.0364, y + 51.7009);
ctx.bezierCurveTo(x + 38.9167, y + 52.4476, x + 39.4232, y + 53.1506, x + 40.1668, y + 53.2718);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 42.8301, y + 53.8186);
ctx.bezierCurveTo(x + 43.6353, y + 53.9494, x + 44.393, y + 53.4007, x + 44.5225, y + 52.5931);
ctx.bezierCurveTo(x + 44.6519, y + 51.7855, x + 44.1031, y + 51.0237, x + 43.2979, y + 50.8928);
ctx.bezierCurveTo(x + 42.4927, y + 50.762, x + 41.735, y + 51.3108, x + 41.6059, y + 52.1178);
ctx.bezierCurveTo(x + 41.4771, y + 52.9257, x + 42.0253, y + 53.6872, x + 42.8301, y + 53.8186);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 45.4952, y + 54.3578);
ctx.bezierCurveTo(x + 46.358, y + 54.4984, x + 47.17, y + 53.9105, x + 47.3079, y + 53.0446);
ctx.bezierCurveTo(x + 47.4464, y + 52.1789, x + 46.8588, y + 51.3634, x + 45.9961, y + 51.2227);
ctx.bezierCurveTo(x + 45.1334, y + 51.0821, x + 44.3213, y + 51.67, x + 44.1828, y + 52.5356);
ctx.bezierCurveTo(x + 44.0452, y + 53.401, x + 44.6325, y + 54.2171, x + 45.4952, y + 54.3578);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 48.1558, y + 54.9193);
ctx.bezierCurveTo(x + 49.0882, y + 55.071, x + 49.9656, y + 54.4357, x + 50.1158, y + 53.4999);
ctx.bezierCurveTo(x + 50.2652, y + 52.5644, x + 49.6306, y + 51.6826, x + 48.6982, y + 51.531);
ctx.bezierCurveTo(x + 47.7652, y + 51.379, x + 46.8885, y + 52.0146, x + 46.7385, y + 52.9498);
ctx.bezierCurveTo(x + 46.5892, y + 53.8853, x + 47.2238, y + 54.7671, x + 48.1558, y + 54.9193);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 50.8307, y + 55.399);
ctx.bezierCurveTo(x + 51.7878, y + 55.5549, x + 52.6883, y + 54.9022, x + 52.8419, y + 53.9419);
ctx.bezierCurveTo(x + 52.9954, y + 52.9815, x + 52.3444, y + 52.0761, x + 51.3863, y + 51.9205);
ctx.bezierCurveTo(x + 50.4292, y + 51.7646, x + 49.5286, y + 52.4173, x + 49.3751, y + 53.3776);
ctx.bezierCurveTo(x + 49.2219, y + 54.3373, x + 49.8729, y + 55.2427, x + 50.8307, y + 55.399);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 53.5015, y + 55.9005);
ctx.bezierCurveTo(x + 54.4957, y + 56.0627, x + 55.4311, y + 55.3847, x + 55.5909, y + 54.3872);
ctx.bezierCurveTo(x + 55.7503, y + 53.3902, x + 55.0734, y + 52.4495, x + 54.0792, y + 52.2872);
ctx.bezierCurveTo(x + 53.0849, y + 52.125, x + 52.1496, y + 52.8029, x + 51.9901, y + 53.7999);
ctx.bezierCurveTo(x + 51.83, y + 54.7981, x + 52.5072, y + 55.7382, x + 53.5015, y + 55.9005);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 56.1796, y + 56.3575);
ctx.bezierCurveTo(x + 57.1865, y + 56.5213, x + 58.1334, y + 55.8354, x + 58.2944, y + 54.8257);
ctx.bezierCurveTo(x + 58.456, y + 53.8163, x + 57.7708, y + 52.8646, x + 56.7642, y + 52.7002);
ctx.bezierCurveTo(x + 55.7576, y + 52.5358, x + 54.8103, y + 53.2223, x + 54.6488, y + 54.2317);
ctx.bezierCurveTo(x + 54.4878, y + 55.2414, x + 55.1726, y + 56.1937, x + 56.1796, y + 56.3575);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 58.8644, y + 56.77);
ctx.bezierCurveTo(x + 59.8587, y + 56.9323, x + 60.794, y + 56.2543, x + 60.9538, y + 55.2567);
ctx.bezierCurveTo(x + 61.1133, y + 54.2597, x + 60.4364, y + 53.3191, x + 59.4418, y + 53.1574);
ctx.bezierCurveTo(x + 58.4476, y + 52.9952, x + 57.5122, y + 53.6731, x + 57.3528, y + 54.6701);
ctx.bezierCurveTo(x + 57.1933, y + 55.6671, x + 57.8702, y + 56.6077, x + 58.8644, y + 56.77);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 61.5329, y + 57.2862);
ctx.bezierCurveTo(x + 62.5726, y + 57.4555, x + 63.5504, y + 56.747, x + 63.7168, y + 55.7043);
ctx.bezierCurveTo(x + 63.8833, y + 54.6617, x + 63.1758, y + 53.6784, x + 62.1367, y + 53.5093);
ctx.bezierCurveTo(x + 61.0969, y + 53.34, x + 60.1191, y + 54.0486, x + 59.9521, y + 55.0909);
ctx.bezierCurveTo(x + 59.7853, y + 56.1341, x + 60.4931, y + 57.1168, x + 61.5329, y + 57.2862);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 64.2142, y + 57.7209);
ctx.bezierCurveTo(x + 65.2533, y + 57.89, x + 66.2317, y + 57.1817, x + 66.3982, y + 56.1391);
ctx.bezierCurveTo(x + 66.5646, y + 55.0965, x + 65.8571, y + 54.1131, x + 64.818, y + 53.9441);
ctx.bezierCurveTo(x + 63.7789, y + 53.7751, x + 62.8005, y + 54.4833, x + 62.6334, y + 55.5256);
ctx.bezierCurveTo(x + 62.467, y + 56.5683, x + 63.1744, y + 57.5516, x + 64.2142, y + 57.7209);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 66.9052, y + 58.0955);
ctx.bezierCurveTo(x + 67.9121, y + 58.2593, x + 68.859, y + 57.5734, x + 69.02, y + 56.5637);
ctx.bezierCurveTo(x + 69.1815, y + 55.5543, x + 68.4964, y + 54.6026, x + 67.4898, y + 54.4382);
ctx.bezierCurveTo(x + 66.4831, y + 54.2738, x + 65.5359, y + 54.9603, x + 65.3744, y + 55.9697);
ctx.bezierCurveTo(x + 65.2131, y + 56.9801, x + 65.8988, y + 57.9321, x + 66.9052, y + 58.0955);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 69.5988, y + 58.4555);
ctx.bezierCurveTo(x + 70.5639, y + 58.6127, x + 71.4728, y + 57.9551, x + 71.6273, y + 56.9857);
ctx.bezierCurveTo(x + 71.7821, y + 56.0173, x + 71.1249, y + 55.1045, x + 70.1591, y + 54.9469);
ctx.bezierCurveTo(x + 69.194, y + 54.7897, x + 68.2851, y + 55.4473, x + 68.1303, y + 56.4157);
ctx.bezierCurveTo(x + 67.976, y + 57.3861, x + 68.6336, y + 58.2983, x + 69.5988, y + 58.4555);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 72.3027, y + 58.7487);
ctx.bezierCurveTo(x + 73.1902, y + 58.8936, x + 74.0249, y + 58.288, x + 74.1672, y + 57.3981);
ctx.bezierCurveTo(x + 74.3096, y + 56.5082, x + 73.7059, y + 55.6685, x + 72.8181, y + 55.5242);
ctx.bezierCurveTo(x + 71.9306, y + 55.3793, x + 71.096, y + 55.9849, x + 70.9536, y + 56.8748);
ctx.bezierCurveTo(x + 70.8112, y + 57.7647, x + 71.4155, y + 58.6047, x + 72.3027, y + 58.7487);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.9842, y + 59.1834);
ctx.bezierCurveTo(x + 75.8716, y + 59.3283, x + 76.7063, y + 58.7227, x + 76.8486, y + 57.8328);
ctx.bezierCurveTo(x + 76.991, y + 56.9429, x + 76.3873, y + 56.1032, x + 75.4995, y + 55.9589);
ctx.bezierCurveTo(x + 74.612, y + 55.814, x + 73.7767, y + 56.4193, x + 73.635, y + 57.3095);
ctx.bezierCurveTo(x + 73.4926, y + 58.1994, x + 74.0967, y + 59.0385, x + 74.9842, y + 59.1834);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 77.6905, y + 59.4611);
ctx.bezierCurveTo(x + 78.4916, y + 59.592, x + 79.2455, y + 59.0459, x + 79.3739, y + 58.2417);
ctx.bezierCurveTo(x + 79.5025, y + 57.4385, x + 78.957, y + 56.6809, x + 78.1558, y + 56.5499);
ctx.bezierCurveTo(x + 77.3543, y + 56.4196, x + 76.6008, y + 56.9651, x + 76.4725, y + 57.7692);
ctx.bezierCurveTo(x + 76.3441, y + 58.5734, x + 76.89, y + 59.3305, x + 77.6905, y + 59.4611);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 80.3975, y + 59.739);
ctx.bezierCurveTo(x + 81.1126, y + 59.8554, x + 81.785, y + 59.3685, x + 81.8997, y + 58.6509);
ctx.bezierCurveTo(x + 82.014, y + 57.934, x + 81.5275, y + 57.2581, x + 80.8127, y + 57.1411);
ctx.bezierCurveTo(x + 80.0976, y + 57.0247, x + 79.4252, y + 57.5117, x + 79.3109, y + 58.2286);
ctx.bezierCurveTo(x + 79.1962, y + 58.9462, x + 79.6823, y + 59.6226, x + 80.3975, y + 59.739);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 83.1338, y + 59.8303);
ctx.bezierCurveTo(x + 83.6596, y + 59.9159, x + 84.1547, y + 59.5575, x + 84.239, y + 59.03);
ctx.bezierCurveTo(x + 84.3233, y + 58.5024, x + 83.965, y + 58.0054, x + 83.4392, y + 57.9198);
ctx.bezierCurveTo(x + 82.9134, y + 57.8343, x + 82.4183, y + 58.1926, x + 82.334, y + 58.7202);
ctx.bezierCurveTo(x + 82.2501, y + 59.2471, x + 82.6081, y + 59.7447, x + 83.1338, y + 59.8303);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 85.8273, y + 60.1904);
ctx.bezierCurveTo(x + 86.3119, y + 60.2697, x + 86.7684, y + 59.9393, x + 86.8459, y + 59.4527);
ctx.bezierCurveTo(x + 86.9234, y + 58.9662, x + 86.5936, y + 58.5083, x + 86.1091, y + 58.429);
ctx.bezierCurveTo(x + 85.6245, y + 58.3497, x + 85.1679, y + 58.6801, x + 85.0904, y + 59.1666);
ctx.bezierCurveTo(x + 85.0123, y + 59.6528, x + 85.3427, y + 60.1111, x + 85.8273, y + 60.1904);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 88.5682, y + 60.2514);
ctx.bezierCurveTo(x + 88.8477, y + 60.2967, x + 89.1109, y + 60.1066, x + 89.1554, y + 59.8262);
ctx.bezierCurveTo(x + 89.2, y + 59.5458, x + 89.0098, y + 59.282, x + 88.7307, y + 59.2361);
ctx.bezierCurveTo(x + 88.4513, y + 59.1908, x + 88.1881, y + 59.3809, x + 88.1435, y + 59.6613);
ctx.bezierCurveTo(x + 88.099, y + 59.9417, x + 88.2888, y + 60.2061, x + 88.5682, y + 60.2514);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 91.2833, y + 60.4773);
ctx.bezierCurveTo(x + 91.448, y + 60.5039, x + 91.6024, y + 60.3921, x + 91.6286, y + 60.2269);
ctx.bezierCurveTo(x + 91.655, y + 60.0626, x + 91.5431, y + 59.9065, x + 91.3784, y + 59.8799);
ctx.bezierCurveTo(x + 91.2138, y + 59.8533, x + 91.0594, y + 59.9651, x + 91.0329, y + 60.1294);
ctx.bezierCurveTo(x + 91.0074, y + 60.2949, x + 91.119, y + 60.4501, x + 91.2833, y + 60.4773);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 93.9842, y + 60.7925);
ctx.bezierCurveTo(x + 94.0829, y + 60.8086, x + 94.1753, y + 60.7412, x + 94.1911, y + 60.6421);
ctx.bezierCurveTo(x + 94.2069, y + 60.5431, x + 94.1396, y + 60.4503, x + 94.0412, y + 60.4336);
ctx.bezierCurveTo(x + 93.9428, y + 60.4169, x + 93.8501, y + 60.4849, x + 93.8337, y + 60.5836);
ctx.bezierCurveTo(x + 93.8185, y + 60.683, x + 93.8855, y + 60.7765, x + 93.9842, y + 60.7925);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 96.6921, y + 61.063);
ctx.bezierCurveTo(x + 96.7002, y + 61.0643, x + 96.7079, y + 61.059, x + 96.7095, y + 61.0503);
ctx.bezierCurveTo(x + 96.7108, y + 61.0423, x + 96.7055, y + 61.0345, x + 96.6975, y + 61.0332);
ctx.bezierCurveTo(x + 96.6894, y + 61.0319, x + 96.6817, y + 61.0372, x + 96.6804, y + 61.0452);
ctx.bezierCurveTo(x + 96.6782, y + 61.0536, x + 96.6835, y + 61.0613, x + 96.6921, y + 61.063);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 27.8797, y + 52.6808);
ctx.bezierCurveTo(x + 27.892, y + 52.6829, x + 27.9033, y + 52.674, x + 27.9054, y + 52.6616);
ctx.bezierCurveTo(x + 27.9075, y + 52.6492, x + 27.899, y + 52.6372, x + 27.8863, y + 52.6357);
ctx.bezierCurveTo(x + 27.8739, y + 52.6336, x + 27.8626, y + 52.6425, x + 27.8599, y + 52.6545);
ctx.bezierCurveTo(x + 27.8588, y + 52.6667, x + 27.8673, y + 52.6786, x + 27.8797, y + 52.6808);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 30.5167, y + 53.3911);
ctx.bezierCurveTo(x + 30.6814, y + 53.4177, x + 30.8358, y + 53.3059, x + 30.862, y + 53.1407);
ctx.bezierCurveTo(x + 30.8884, y + 52.9765, x + 30.7765, y + 52.8203, x + 30.6118, y + 52.7937);
ctx.bezierCurveTo(x + 30.4472, y + 52.7671, x + 30.2928, y + 52.8789, x + 30.266, y + 53.0438);
ctx.bezierCurveTo(x + 30.2408, y + 53.2087, x + 30.3524, y + 53.3639, x + 30.5167, y + 53.3911);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 33.1783, y + 53.9523);
ctx.bezierCurveTo(x + 33.4122, y + 53.9905, x + 33.6329, y + 53.8311, x + 33.6699, y + 53.596);
ctx.bezierCurveTo(x + 33.7075, y + 53.3613, x + 33.5479, y + 53.1401, x + 33.314, y + 53.1019);
ctx.bezierCurveTo(x + 33.08, y + 53.0637, x + 32.8593, y + 53.2232, x + 32.8217, y + 53.4579);
ctx.bezierCurveTo(x + 32.7844, y + 53.6936, x + 32.944, y + 53.9148, x + 33.1783, y + 53.9523);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 35.7747, y + 54.9174);
ctx.bezierCurveTo(x + 36.3005, y + 55.003, x + 36.7956, y + 54.6447, x + 36.8799, y + 54.1171);
ctx.bezierCurveTo(x + 36.9642, y + 53.5896, x + 36.6064, y + 53.0929, x + 36.0801, y + 53.007);
ctx.bezierCurveTo(x + 35.5543, y + 52.9214, x + 35.0592, y + 53.2798, x + 34.9749, y + 53.8073);
ctx.bezierCurveTo(x + 34.891, y + 54.3342, x + 35.249, y + 54.8319, x + 35.7747, y + 54.9174);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 38.46, y + 55.3295);
ctx.bezierCurveTo(x + 38.9734, y + 55.4129, x + 39.4567, y + 55.0631, x + 39.5388, y + 54.548);
ctx.bezierCurveTo(x + 39.621, y + 54.0328, x + 39.2715, y + 53.5472, x + 38.7582, y + 53.4637);
ctx.bezierCurveTo(x + 38.2448, y + 53.3803, x + 37.7609, y + 53.7298, x + 37.6787, y + 54.2449);
ctx.bezierCurveTo(x + 37.5966, y + 54.76, x + 37.9467, y + 55.246, x + 38.46, y + 55.3295);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 41.0962, y + 56.0475);
ctx.bezierCurveTo(x + 41.7658, y + 56.1568, x + 42.3958, y + 55.7005, x + 42.5034, y + 55.0286);
ctx.bezierCurveTo(x + 42.6108, y + 54.3573, x + 42.1552, y + 53.7235, x + 41.4852, y + 53.6148);
ctx.bezierCurveTo(x + 40.8156, y + 53.5055, x + 40.1856, y + 53.9619, x + 40.078, y + 54.6337);
ctx.bezierCurveTo(x + 39.9706, y + 55.305, x + 40.4262, y + 55.9388, x + 41.0962, y + 56.0475);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 43.7632, y + 56.5715);
ctx.bezierCurveTo(x + 44.482, y + 56.6884, x + 45.1589, y + 56.1992, x + 45.2744, y + 55.4773);
ctx.bezierCurveTo(x + 45.3895, y + 54.756, x + 44.8998, y + 54.076, x + 44.1809, y + 53.9591);
ctx.bezierCurveTo(x + 43.4621, y + 53.8422, x + 42.7852, y + 54.3314, x + 42.6701, y + 55.0527);
ctx.bezierCurveTo(x + 42.5546, y + 55.7746, x + 43.0443, y + 56.4547, x + 43.7632, y + 56.5715);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 46.4236, y + 57.1408);
ctx.bezierCurveTo(x + 47.216, y + 57.2701, x + 47.9628, y + 56.7296, x + 48.0895, y + 55.9341);
ctx.bezierCurveTo(x + 48.2169, y + 55.139, x + 47.6766, y + 54.3891, x + 46.8841, y + 54.2597);
ctx.bezierCurveTo(x + 46.0916, y + 54.1304, x + 45.3449, y + 54.6709, x + 45.2175, y + 55.4661);
ctx.bezierCurveTo(x + 45.0905, y + 56.2622, x + 45.6301, y + 57.0118, x + 46.4236, y + 57.1408);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 49.0809, y + 57.7242);
ctx.bezierCurveTo(x + 49.956, y + 57.867, x + 50.779, y + 57.2709, x + 50.92, y + 56.3922);
ctx.bezierCurveTo(x + 51.0606, y + 55.5141, x + 50.4644, y + 54.6866, x + 49.5896, y + 54.5448);
ctx.bezierCurveTo(x + 48.7145, y + 54.402, x + 47.8915, y + 54.9982, x + 47.7509, y + 55.8762);
ctx.bezierCurveTo(x + 47.6099, y + 56.7549, x + 48.206, y + 57.5824, x + 49.0809, y + 57.7242);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 51.7585, y + 58.1818);
ctx.bezierCurveTo(x + 52.646, y + 58.3267, x + 53.4807, y + 57.7211, x + 53.623, y + 56.8312);
ctx.bezierCurveTo(x + 53.7654, y + 55.9413, x + 53.1617, y + 55.1016, x + 52.2739, y + 54.9573);
ctx.bezierCurveTo(x + 51.3864, y + 54.8124, x + 50.5518, y + 55.418, x + 50.4094, y + 56.3079);
ctx.bezierCurveTo(x + 50.2677, y + 57.1981, x + 50.8713, y + 58.0378, x + 51.7585, y + 58.1818);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 54.4152, y + 58.7735);
ctx.bezierCurveTo(x + 55.3884, y + 58.932, x + 56.3053, y + 58.2685, x + 56.4611, y + 57.2911);
ctx.bezierCurveTo(x + 56.6176, y + 56.314, x + 55.9544, y + 55.393, x + 54.9809, y + 55.2351);
ctx.bezierCurveTo(x + 54.0073, y + 55.0773, x + 53.0907, y + 55.7401, x + 52.9353, y + 56.7169);
ctx.bezierCurveTo(x + 52.7788, y + 57.6941, x + 53.4413, y + 58.6147, x + 54.4152, y + 58.7735);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 57.0917, y + 59.2376);
ctx.bezierCurveTo(x + 58.0816, y + 59.3991, x + 59.0134, y + 58.7247, x + 59.1721, y + 57.7305);
ctx.bezierCurveTo(x + 59.3311, y + 56.7372, x + 58.6565, y + 55.8011, x + 57.6666, y + 55.6396);
ctx.bezierCurveTo(x + 56.6766, y + 55.4782, x + 55.7449, y + 56.1525, x + 55.5859, y + 57.1458);
ctx.bezierCurveTo(x + 55.4278, y + 58.1403, x + 56.1024, y + 59.0765, x + 57.0917, y + 59.2376);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 59.7832, y + 59.6123);
ctx.bezierCurveTo(x + 60.7403, y + 59.7682, x + 61.6409, y + 59.1156, x + 61.7944, y + 58.1552);
ctx.bezierCurveTo(x + 61.9479, y + 57.1949, x + 61.296, y + 56.2898, x + 60.3388, y + 56.1339);
ctx.bezierCurveTo(x + 59.3817, y + 55.978, x + 58.4811, y + 56.6306, x + 58.3276, y + 57.591);
ctx.bezierCurveTo(x + 58.1741, y + 58.5513, x + 58.8261, y + 59.4565, x + 59.7832, y + 59.6123);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 62.4526, y + 60.122);
ctx.bezierCurveTo(x + 63.4505, y + 60.2847, x + 64.3903, y + 59.6045, x + 64.5503, y + 58.6022);
ctx.bezierCurveTo(x + 64.7106, y + 57.6009, x + 64.0311, y + 56.6563, x + 63.0328, y + 56.4942);
ctx.bezierCurveTo(x + 62.0348, y + 56.3314, x + 61.095, y + 57.0117, x + 60.9354, y + 58.0134);
ctx.bezierCurveTo(x + 60.7747, y + 59.0153, x + 61.4546, y + 59.9592, x + 62.4526, y + 60.122);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.1326, y + 60.5638);
ctx.bezierCurveTo(x + 66.1349, y + 60.7273, x + 67.0779, y + 60.0441, x + 67.2393, y + 59.0378);
ctx.bezierCurveTo(x + 67.4001, y + 58.0328, x + 66.7179, y + 57.0844, x + 65.7156, y + 56.9208);
ctx.bezierCurveTo(x + 64.7133, y + 56.7572, x + 63.77, y + 57.4411, x + 63.6092, y + 58.4461);
ctx.bezierCurveTo(x + 63.4484, y + 59.4527, x + 64.1303, y + 60.4002, x + 65.1326, y + 60.5638);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 67.8261, y + 60.9239);
ctx.bezierCurveTo(x + 68.7875, y + 61.0806, x + 69.6919, y + 60.4253, x + 69.8463, y + 59.4606);
ctx.bezierCurveTo(x + 70.0003, y + 58.4965, x + 69.346, y + 57.587, x + 68.3846, y + 57.4302);
ctx.bezierCurveTo(x + 67.4231, y + 57.2735, x + 66.5187, y + 57.9288, x + 66.3647, y + 58.8929);
ctx.bezierCurveTo(x + 66.2106, y + 59.8585, x + 66.8646, y + 60.7672, x + 67.8261, y + 60.9239);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 70.5185, y + 61.2913);
ctx.bezierCurveTo(x + 71.4429, y + 61.4416, x + 72.3125, y + 60.8116, x + 72.4606, y + 59.8842);
ctx.bezierCurveTo(x + 72.6086, y + 58.9567, x + 71.9799, y + 58.083, x + 71.0553, y + 57.9317);
ctx.bezierCurveTo(x + 70.131, y + 57.7814, x + 69.2613, y + 58.4114, x + 69.1127, y + 59.3385);
ctx.bezierCurveTo(x + 68.9649, y + 60.2669, x + 69.5942, y + 61.141, x + 70.5185, y + 61.2913);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 73.2107, y + 61.6592);
ctx.bezierCurveTo(x + 74.0982, y + 61.8041, x + 74.9328, y + 61.1985, x + 75.0752, y + 60.3086);
ctx.bezierCurveTo(x + 75.2175, y + 59.4188, x + 74.6139, y + 58.579, x + 73.726, y + 58.4347);
ctx.bezierCurveTo(x + 72.8386, y + 58.2898, x + 72.0033, y + 58.8951, x + 71.8616, y + 59.7853);
ctx.bezierCurveTo(x + 71.7195, y + 60.6746, x + 72.3232, y + 61.5143, x + 73.2107, y + 61.6592);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 75.9093, y + 61.9884);
ctx.bezierCurveTo(x + 76.7392, y + 62.1235, x + 77.5194, y + 61.5586, x + 77.6534, y + 60.7256);
ctx.bezierCurveTo(x + 77.7864, y + 59.8928, x + 77.2215, y + 59.1083, x + 76.3916, y + 58.9733);
ctx.bezierCurveTo(x + 75.5616, y + 58.8382, x + 74.7811, y + 59.4037, x + 74.6478, y + 60.2355);
ctx.bezierCurveTo(x + 74.5144, y + 61.0689, x + 75.0793, y + 61.8533, x + 75.9093, y + 61.9884);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 78.6226, y + 62.2219);
ctx.bezierCurveTo(x + 79.3414, y + 62.3388, x + 80.0177, y + 61.8492, x + 80.1338, y + 61.1277);
ctx.bezierCurveTo(x + 80.2489, y + 60.4064, x + 79.7592, y + 59.7264, x + 79.0403, y + 59.6095);
ctx.bezierCurveTo(x + 78.3215, y + 59.4926, x + 77.6446, y + 59.9818, x + 77.5294, y + 60.7031);
ctx.bezierCurveTo(x + 77.414, y + 61.425, x + 77.904, y + 62.1044, x + 78.6226, y + 62.2219);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 81.3042, y + 62.656);
ctx.bezierCurveTo(x + 82.0231, y + 62.7729, x + 82.7, y + 62.2836, x + 82.8154, y + 61.5618);
ctx.bezierCurveTo(x + 82.9305, y + 60.8405, x + 82.4408, y + 60.1604, x + 81.722, y + 60.0435);
ctx.bezierCurveTo(x + 81.0031, y + 59.9267, x + 80.3262, y + 60.4159, x + 80.2111, y + 61.1372);
ctx.bezierCurveTo(x + 80.0956, y + 61.8591, x + 80.5853, y + 62.5391, x + 81.3042, y + 62.656);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 84.042, y + 62.7404);
ctx.bezierCurveTo(x + 84.5678, y + 62.826, x + 85.0629, y + 62.4676, x + 85.1472, y + 61.9401);
ctx.bezierCurveTo(x + 85.2315, y + 61.4126, x + 84.8738, y + 60.9159, x + 84.3474, y + 60.83);
ctx.bezierCurveTo(x + 83.8216, y + 60.7444, x + 83.3265, y + 61.1028, x + 83.2422, y + 61.6303);
ctx.bezierCurveTo(x + 83.1583, y + 62.1572, x + 83.5157, y + 62.6545, x + 84.042, y + 62.7404);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 86.7293, y + 63.1376);
ctx.bezierCurveTo(x + 87.2347, y + 63.2197, x + 87.7099, y + 62.8757, x + 87.7911, y + 62.3681);
ctx.bezierCurveTo(x + 87.872, y + 61.8611, x + 87.5284, y + 61.3835, x + 87.0231, y + 61.3013);
ctx.bezierCurveTo(x + 86.5177, y + 61.2192, x + 86.0425, y + 61.5631, x + 85.9616, y + 62.0702);
ctx.bezierCurveTo(x + 85.8804, y + 62.5778, x + 86.224, y + 63.0554, x + 86.7293, y + 63.1376);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 89.4665, y + 63.2215);
ctx.bezierCurveTo(x + 89.7787, y + 63.2724, x + 90.0728, y + 63.0596, x + 90.1228, y + 62.7464);
ctx.bezierCurveTo(x + 90.1729, y + 62.4331, x + 89.96, y + 62.1381, x + 89.6478, y + 62.0873);
ctx.bezierCurveTo(x + 89.3356, y + 62.0365, x + 89.0415, y + 62.2492, x + 88.9915, y + 62.5625);
ctx.bezierCurveTo(x + 88.9418, y + 62.8752, x + 89.1549, y + 63.1711, x + 89.4665, y + 63.2215);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 92.1911, y + 63.387);
ctx.bezierCurveTo(x + 92.3557, y + 63.4136, x + 92.5101, y + 63.3017, x + 92.5363, y + 63.1366);
ctx.bezierCurveTo(x + 92.5627, y + 62.9723, x + 92.4508, y + 62.8162, x + 92.2861, y + 62.7896);
ctx.bezierCurveTo(x + 92.1215, y + 62.763, x + 91.9671, y + 62.8748, x + 91.9406, y + 63.039);
ctx.bezierCurveTo(x + 91.9151, y + 63.2046, x + 92.027, y + 63.3607, x + 92.1911, y + 63.387);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 94.8862, y + 63.7399);
ctx.bezierCurveTo(x + 95.0053, y + 63.7594, x + 95.1173, y + 63.6781, x + 95.1365, y + 63.5586);
ctx.bezierCurveTo(x + 95.1557, y + 63.4391, x + 95.0746, y + 63.3265, x + 94.9554, y + 63.307);
ctx.bezierCurveTo(x + 94.8363, y + 63.2875, x + 94.7243, y + 63.3687, x + 94.7051, y + 63.4883);
ctx.bezierCurveTo(x + 94.6859, y + 63.6078, x + 94.7671, y + 63.7204, x + 94.8862, y + 63.7399);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 26.1064, y + 55.1559);
ctx.bezierCurveTo(x + 26.1188, y + 55.1581, x + 26.1301, y + 55.1492, x + 26.1322, y + 55.1368);
ctx.bezierCurveTo(x + 26.1343, y + 55.1244, x + 26.1257, y + 55.1124, x + 26.113, y + 55.1109);
ctx.bezierCurveTo(x + 26.1007, y + 55.1088, x + 26.0894, y + 55.1176, x + 26.0873, y + 55.1301);
ctx.bezierCurveTo(x + 26.0855, y + 55.1419, x + 26.094, y + 55.1538, x + 26.1064, y + 55.1559);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 28.7435, y + 55.8665);
ctx.bezierCurveTo(x + 28.9082, y + 55.893, x + 29.0626, y + 55.7812, x + 29.0888, y + 55.616);
ctx.bezierCurveTo(x + 29.1152, y + 55.4518, x + 29.0033, y + 55.2956, x + 28.8386, y + 55.2691);
ctx.bezierCurveTo(x + 28.674, y + 55.2425, x + 28.5196, y + 55.3543, x + 28.4928, y + 55.5191);
ctx.bezierCurveTo(x + 28.4672, y + 55.6847, x + 28.5789, y + 55.8399, x + 28.7435, y + 55.8665);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 31.4275, y + 56.2866);
ctx.bezierCurveTo(x + 31.5841, y + 56.3119, x + 31.7302, y + 56.205, x + 31.7554, y + 56.0488);
ctx.bezierCurveTo(x + 31.7805, y + 55.8927, x + 31.6744, y + 55.7446, x + 31.5178, y + 55.7193);
ctx.bezierCurveTo(x + 31.3612, y + 55.6941, x + 31.2145, y + 55.8006, x + 31.19, y + 55.9571);
ctx.bezierCurveTo(x + 31.1648, y + 56.1133, x + 31.2709, y + 56.2613, x + 31.4275, y + 56.2866);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 34.0654, y + 56.9897);
ctx.bezierCurveTo(x + 34.3696, y + 57.0392, x + 34.6556, y + 56.8324, x + 34.7043, y + 56.5272);
ctx.bezierCurveTo(x + 34.7531, y + 56.2219, x + 34.5461, y + 55.9351, x + 34.2423, y + 55.885);
ctx.bezierCurveTo(x + 33.9381, y + 55.8355, x + 33.6527, y + 56.0426, x + 33.6033, y + 56.3475);
ctx.bezierCurveTo(x + 33.5546, y + 56.6527, x + 33.7618, y + 56.9405, x + 34.0654, y + 56.9897);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 36.7003, y + 57.7157);
ctx.bezierCurveTo(x + 37.1645, y + 57.7916, x + 37.6014, y + 57.475, x + 37.6755, y + 57.0089);
ctx.bezierCurveTo(x + 37.7502, y + 56.5432, x + 37.434, y + 56.104, x + 36.9698, y + 56.0282);
ctx.bezierCurveTo(x + 36.5056, y + 55.9523, x + 36.0687, y + 56.2689, x + 35.994, y + 56.7346);
ctx.bezierCurveTo(x + 35.9205, y + 57.201, x + 36.2361, y + 57.6398, x + 36.7003, y + 57.7157);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 39.338, y + 58.4264);
ctx.bezierCurveTo(x + 39.9545, y + 58.5267, x + 40.5339, y + 58.1068, x + 40.6327, y + 57.4883);
ctx.bezierCurveTo(x + 40.7312, y + 56.8704, x + 40.3121, y + 56.2874, x + 39.6957, y + 56.1871);
ctx.bezierCurveTo(x + 39.0792, y + 56.0867, x + 38.4998, y + 56.5066, x + 38.4004, y + 57.1248);
ctx.bezierCurveTo(x + 38.3019, y + 57.7427, x + 38.7216, y + 58.326, x + 39.338, y + 58.4264);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 41.9968, y + 59.0027);
ctx.bezierCurveTo(x + 42.6906, y + 59.1159, x + 43.3443, y + 58.6425, x + 43.4556, y + 57.9454);
ctx.bezierCurveTo(x + 43.5671, y + 57.2493, x + 43.0942, y + 56.5922, x + 42.4001, y + 56.4796);
ctx.bezierCurveTo(x + 41.7063, y + 56.3664, x + 41.0525, y + 56.8398, x + 40.941, y + 57.5359);
ctx.bezierCurveTo(x + 40.8297, y + 58.233, x + 41.3021, y + 58.8897, x + 41.9968, y + 59.0027);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 44.6711, y + 59.4822);
ctx.bezierCurveTo(x + 45.39, y + 59.5991, x + 46.0669, y + 59.1098, x + 46.1823, y + 58.3879);
ctx.bezierCurveTo(x + 46.2975, y + 57.6666, x + 45.8078, y + 56.9866, x + 45.0889, y + 56.8697);
ctx.bezierCurveTo(x + 44.37, y + 56.7528, x + 43.6931, y + 57.2421, x + 43.578, y + 57.9634);
ctx.bezierCurveTo(x + 43.4626, y + 58.6853, x + 43.9526, y + 59.3647, x + 44.6711, y + 59.4822);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 47.3289, y + 60.0661);
ctx.bezierCurveTo(x + 48.1294, y + 60.1967, x + 48.8839, y + 59.651, x + 49.0123, y + 58.8468);
ctx.bezierCurveTo(x + 49.1412, y + 58.0429, x + 48.5953, y + 57.2859, x + 47.7942, y + 57.1549);
ctx.bezierCurveTo(x + 46.9931, y + 57.024, x + 46.2392, y + 57.5701, x + 46.1112, y + 58.3737);
ctx.bezierCurveTo(x + 45.9822, y + 59.1775, x + 46.5278, y + 59.9352, x + 47.3289, y + 60.0661);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 49.9935, y + 60.6047);
ctx.bezierCurveTo(x + 50.8519, y + 60.7445, x + 51.6601, y + 60.1593, x + 51.7978, y + 59.298);
ctx.bezierCurveTo(x + 51.9355, y + 58.4367, x + 51.3509, y + 57.6244, x + 50.4924, y + 57.4846);
ctx.bezierCurveTo(x + 49.634, y + 57.3448, x + 48.8258, y + 57.93, x + 48.6881, y + 58.7913);
ctx.bezierCurveTo(x + 48.5504, y + 59.6526, x + 49.1351, y + 60.4649, x + 49.9935, y + 60.6047);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 52.6669, y + 61.0918);
ctx.bezierCurveTo(x + 53.5544, y + 61.2367, x + 54.389, y + 60.6311, x + 54.5314, y + 59.7412);
ctx.bezierCurveTo(x + 54.6737, y + 58.8514, x + 54.0697, y + 58.0123, x + 53.1822, y + 57.8674);
ctx.bezierCurveTo(x + 52.2947, y + 57.7225, x + 51.4598, y + 58.3271, x + 51.3178, y + 59.2179);
ctx.bezierCurveTo(x + 51.1754, y + 60.1078, x + 51.7791, y + 60.9475, x + 52.6669, y + 61.0918);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 55.3434, y + 61.5566);
ctx.bezierCurveTo(x + 56.247, y + 61.7041, x + 57.0977, y + 61.0882, x + 57.2427, y + 60.1807);
ctx.bezierCurveTo(x + 57.388, y + 59.274, x + 56.7724, y + 58.4197, x + 55.8689, y + 58.2722);
ctx.bezierCurveTo(x + 54.9649, y + 58.1253, x + 54.1146, y + 58.7405, x + 53.97, y + 59.6475);
ctx.bezierCurveTo(x + 53.8244, y + 60.5547, x + 54.4399, y + 61.409, x + 55.3434, y + 61.5566);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 58.0215, y + 62.0135);
ctx.bezierCurveTo(x + 58.9378, y + 62.1625, x + 59.7998, y + 61.5378, x + 59.9465, y + 60.6185);
ctx.bezierCurveTo(x + 60.0939, y + 59.6994, x + 59.4698, y + 58.8331, x + 58.5539, y + 58.6835);
ctx.bezierCurveTo(x + 57.6376, y + 58.5344, x + 56.776, y + 59.1585, x + 56.6286, y + 60.0776);
ctx.bezierCurveTo(x + 56.4815, y + 60.9976, x + 57.1052, y + 61.8645, x + 58.0215, y + 62.0135);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 60.6995, y + 62.4703);
ctx.bezierCurveTo(x + 61.6282, y + 62.6214, x + 62.5017, y + 61.9888, x + 62.6506, y + 61.057);
ctx.bezierCurveTo(x + 62.7994, y + 60.1252, x + 62.1675, y + 59.2473, x + 61.2394, y + 59.0965);
ctx.bezierCurveTo(x + 60.3108, y + 58.9453, x + 59.4373, y + 59.578, x + 59.2884, y + 60.5097);
ctx.bezierCurveTo(x + 59.1389, y + 61.4412, x + 59.7709, y + 62.3191, x + 60.6995, y + 62.4703);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 63.3585, y + 63.0467);
ctx.bezierCurveTo(x + 64.3655, y + 63.2105, x + 65.3124, y + 62.5246, x + 65.4733, y + 61.5149);
ctx.bezierCurveTo(x + 65.6349, y + 60.5055, x + 64.9498, y + 59.5538, x + 63.9431, y + 59.3894);
ctx.bezierCurveTo(x + 62.9362, y + 59.2256, x + 61.9893, y + 59.9115, x + 61.8277, y + 60.9209);
ctx.bezierCurveTo(x + 61.6664, y + 61.9312, x + 62.3516, y + 62.8829, x + 63.3585, y + 63.0467);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 66.0515, y + 63.4071);
ctx.bezierCurveTo(x + 67.0167, y + 63.5643, x + 67.9256, y + 62.9067, x + 68.0807, y + 61.9376);
ctx.bezierCurveTo(x + 68.2355, y + 60.9692, x + 67.5783, y + 60.0564, x + 66.6125, y + 59.8988);
ctx.bezierCurveTo(x + 65.6473, y + 59.7416, x + 64.7384, y + 60.3992, x + 64.5836, y + 61.3677);
ctx.bezierCurveTo(x + 64.4285, y + 62.3367, x + 65.0857, y + 63.2495, x + 66.0515, y + 63.4071);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 68.745, y + 63.7671);
ctx.bezierCurveTo(x + 69.6693, y + 63.9174, x + 70.539, y + 63.2874, x + 70.687, y + 62.36);
ctx.bezierCurveTo(x + 70.8351, y + 61.4325, x + 70.2064, y + 60.5588, x + 69.2814, y + 60.4081);
ctx.bezierCurveTo(x + 68.3571, y + 60.2578, x + 67.4875, y + 60.8878, x + 67.3388, y + 61.8149);
ctx.bezierCurveTo(x + 67.1917, y + 62.7421, x + 67.8204, y + 63.6158, x + 68.745, y + 63.7671);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 71.4376, y + 64.1346);
ctx.bezierCurveTo(x + 72.3251, y + 64.2795, x + 73.1597, y + 63.6739, x + 73.3024, y + 62.7834);
ctx.bezierCurveTo(x + 73.4448, y + 61.8935, x + 72.8408, y + 61.0544, x + 71.9533, y + 60.9095);
ctx.bezierCurveTo(x + 71.0658, y + 60.7646, x + 70.2309, y + 61.3693, x + 70.0882, y + 62.2598);
ctx.bezierCurveTo(x + 69.9461, y + 63.1506, x + 70.5498, y + 63.9903, x + 71.4376, y + 64.1346);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.1439, y + 64.412);
ctx.bezierCurveTo(x + 74.9454, y + 64.5424, x + 75.6989, y + 63.9968, x + 75.8272, y + 63.1927);
ctx.bezierCurveTo(x + 75.9553, y + 62.3891, x + 75.4103, y + 61.6318, x + 74.6092, y + 61.5008);
ctx.bezierCurveTo(x + 73.808, y + 61.3699, x + 73.0542, y + 61.916, x + 72.9262, y + 62.7196);
ctx.bezierCurveTo(x + 72.7975, y + 63.5244, x + 73.3427, y + 64.281, x + 74.1439, y + 64.412);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 76.8494, y + 64.6973);
ctx.bezierCurveTo(x + 77.5682, y + 64.8142, x + 78.2445, y + 64.3246, x + 78.3606, y + 63.603);
ctx.bezierCurveTo(x + 78.4757, y + 62.8817, x + 77.986, y + 62.2017, x + 77.2671, y + 62.0848);
ctx.bezierCurveTo(x + 76.5483, y + 61.9679, x + 75.8714, y + 62.4572, x + 75.7563, y + 63.1785);
ctx.bezierCurveTo(x + 75.6408, y + 63.9004, x + 76.1305, y + 64.5804, x + 76.8494, y + 64.6973);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 79.5582, y + 64.9604);
ctx.bezierCurveTo(x + 80.1827, y + 65.062, x + 80.7702, y + 64.6362, x + 80.8703, y + 64.0096);
ctx.bezierCurveTo(x + 80.9704, y + 63.3831, x + 80.5456, y + 62.7929, x + 79.9212, y + 62.6913);
ctx.bezierCurveTo(x + 79.2967, y + 62.5897, x + 78.7092, y + 63.0154, x + 78.6085, y + 63.6417);
ctx.bezierCurveTo(x + 78.5084, y + 64.2682, x + 78.9337, y + 64.8587, x + 79.5582, y + 64.9604);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 82.2679, y + 65.2158);
ctx.bezierCurveTo(x + 82.7936, y + 65.3013, x + 83.2888, y + 64.943, x + 83.373, y + 64.4154);
ctx.bezierCurveTo(x + 83.4573, y + 63.8879, x + 83.099, y + 63.3909, x + 82.5732, y + 63.3053);
ctx.bezierCurveTo(x + 82.0475, y + 63.2197, x + 81.5523, y + 63.5781, x + 81.4681, y + 64.1057);
ctx.bezierCurveTo(x + 81.3841, y + 64.6326, x + 81.7425, y + 65.1296, x + 82.2679, y + 65.2158);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 84.9549, y + 65.6208);
ctx.bezierCurveTo(x + 85.4645, y + 65.7037, x + 85.9439, y + 65.3565, x + 86.0256, y + 64.8451);
ctx.bezierCurveTo(x + 86.1073, y + 64.3337, x + 85.7607, y + 63.8529, x + 85.2511, y + 63.7699);
ctx.bezierCurveTo(x + 84.7414, y + 63.687, x + 84.262, y + 64.0342, x + 84.1807, y + 64.545);
ctx.bezierCurveTo(x + 84.0984, y + 65.056, x + 84.4452, y + 65.5378, x + 84.9549, y + 65.6208);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 87.6877, y + 65.7342);
ctx.bezierCurveTo(x + 88.0204, y + 65.7885, x + 88.3334, y + 65.5616, x + 88.3872, y + 65.2272);
ctx.bezierCurveTo(x + 88.4406, y + 64.8934, x + 88.214, y + 64.5788, x + 87.8813, y + 64.5245);
ctx.bezierCurveTo(x + 87.5487, y + 64.4703, x + 87.2356, y + 64.6972, x + 87.1822, y + 65.0309);
ctx.bezierCurveTo(x + 87.1284, y + 65.3653, x + 87.3551, y + 65.68, x + 87.6877, y + 65.7342);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 90.4194, y + 65.8552);
ctx.bezierCurveTo(x + 90.5793, y + 65.8815, x + 90.7299, y + 65.7724, x + 90.7562, y + 65.6112);
ctx.bezierCurveTo(x + 90.7822, y + 65.4507, x + 90.6725, y + 65.299, x + 90.5126, y + 65.2727);
ctx.bezierCurveTo(x + 90.3526, y + 65.2463, x + 90.2017, y + 65.3561, x + 90.1757, y + 65.5166);
ctx.bezierCurveTo(x + 90.1494, y + 65.6777, x + 90.2584, y + 65.8291, x + 90.4194, y + 65.8552);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 93.1339, y + 66.0807);
ctx.bezierCurveTo(x + 93.1791, y + 66.0884, x + 93.2219, y + 66.0572, x + 93.2289, y + 66.0115);
ctx.bezierCurveTo(x + 93.2358, y + 65.9659, x + 93.2049, y + 65.9238, x + 93.1604, y + 65.9164);
ctx.bezierCurveTo(x + 93.1152, y + 65.9087, x + 93.0728, y + 65.9393, x + 93.0652, y + 65.9847);
ctx.bezierCurveTo(x + 93.0579, y + 66.0309, x + 93.0884, y + 66.0736, x + 93.1339, y + 66.0807);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 29.687, y + 58.5533);
ctx.bezierCurveTo(x + 29.7278, y + 58.5602, x + 29.7668, y + 58.5316, x + 29.7735, y + 58.4906);
ctx.bezierCurveTo(x + 29.7803, y + 58.4496, x + 29.7518, y + 58.4105, x + 29.7109, y + 58.4036);
ctx.bezierCurveTo(x + 29.6701, y + 58.3968, x + 29.6312, y + 58.4253, x + 29.6244, y + 58.4663);
ctx.bezierCurveTo(x + 29.6182, y + 58.5076, x + 29.6462, y + 58.5464, x + 29.687, y + 58.5533);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 32.3414, y + 59.159);
ctx.bezierCurveTo(x + 32.4766, y + 59.1811, x + 32.6044, y + 59.0888, x + 32.6265, y + 58.9525);
ctx.bezierCurveTo(x + 32.6486, y + 58.8162, x + 32.556, y + 58.6884, x + 32.4201, y + 58.666);
ctx.bezierCurveTo(x + 32.2849, y + 58.6439, x + 32.1572, y + 58.7362, x + 32.1354, y + 58.8719);
ctx.bezierCurveTo(x + 32.1133, y + 59.0082, x + 32.2056, y + 59.1366, x + 32.3414, y + 59.159);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 34.9835, y + 59.8402);
ctx.bezierCurveTo(x + 35.2549, y + 59.8842, x + 35.5097, y + 59.6991, x + 35.5533, y + 59.4277);
ctx.bezierCurveTo(x + 35.5968, y + 59.1563, x + 35.4122, y + 58.8996, x + 35.1412, y + 58.855);
ctx.bezierCurveTo(x + 34.8698, y + 58.8111, x + 34.615, y + 58.9962, x + 34.5714, y + 59.2676);
ctx.bezierCurveTo(x + 34.5279, y + 59.5389, x + 34.7124, y + 59.7957, x + 34.9835, y + 59.8402);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 37.6469, y + 60.3866);
ctx.bezierCurveTo(x + 37.9796, y + 60.4408, x + 38.2927, y + 60.2139, x + 38.3464, y + 59.8796);
ctx.bezierCurveTo(x + 38.3999, y + 59.5458, x + 38.1732, y + 59.2311, x + 37.8406, y + 59.1769);
ctx.bezierCurveTo(x + 37.5079, y + 59.1226, x + 37.1948, y + 59.3495, x + 37.1414, y + 59.6833);
ctx.bezierCurveTo(x + 37.0877, y + 60.0177, x + 37.3139, y + 60.3329, x + 37.6469, y + 60.3866);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 40.2723, y + 61.1718);
ctx.bezierCurveTo(x + 40.798, y + 61.2574, x + 41.2932, y + 60.899, x + 41.3775, y + 60.3715);
ctx.bezierCurveTo(x + 41.4617, y + 59.844, x + 41.1034, y + 59.3469, x + 40.5776, y + 59.2614);
ctx.bezierCurveTo(x + 40.0519, y + 59.1758, x + 39.5567, y + 59.5342, x + 39.4725, y + 60.0617);
ctx.bezierCurveTo(x + 39.3882, y + 60.5892, x + 39.7465, y + 61.0863, x + 40.2723, y + 61.1718);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 42.9446, y + 61.6662);
ctx.bezierCurveTo(x + 43.5032, y + 61.7573, x + 44.0292, y + 61.3763, x + 44.119, y + 60.8158);
ctx.bezierCurveTo(x + 44.2087, y + 60.2554, x + 43.8281, y + 59.7267, x + 43.2692, y + 59.6362);
ctx.bezierCurveTo(x + 42.7106, y + 59.5451, x + 42.1849, y + 59.9255, x + 42.0949, y + 60.4865);
ctx.bezierCurveTo(x + 42.0051, y + 61.047, x + 42.3857, y + 61.5757, x + 42.9446, y + 61.6662);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 45.6088, y + 62.2057);
ctx.bezierCurveTo(x + 46.2252, y + 62.306, x + 46.8047, y + 61.8861, x + 46.9035, y + 61.2676);
ctx.bezierCurveTo(x + 47.002, y + 60.6497, x + 46.5828, y + 60.0667, x + 45.9664, y + 59.9664);
ctx.bezierCurveTo(x + 45.35, y + 59.866, x + 44.7705, y + 60.2859, x + 44.6711, y + 60.9041);
ctx.bezierCurveTo(x + 44.5733, y + 61.5223, x + 44.9924, y + 62.1053, x + 45.6088, y + 62.2057);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 48.2704, y + 62.7668);
ctx.bezierCurveTo(x + 48.9561, y + 62.8787, x + 49.6018, y + 62.4111, x + 49.7124, y + 61.7225);
ctx.bezierCurveTo(x + 49.8226, y + 61.0345, x + 49.3556, y + 60.3855, x + 48.6689, y + 60.2738);
ctx.bezierCurveTo(x + 47.9832, y + 60.1619, x + 47.3375, y + 60.6294, x + 47.2272, y + 61.3174);
ctx.bezierCurveTo(x + 47.1173, y + 62.0064, x + 47.5843, y + 62.6554, x + 48.2704, y + 62.7668);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 50.9278, y + 63.3511);
ctx.bezierCurveTo(x + 51.6961, y + 63.4765, x + 52.4188, y + 62.9521, x + 52.542, y + 62.1818);
ctx.bezierCurveTo(x + 52.6651, y + 61.4114, x + 52.1426, y + 60.6842, x + 51.3739, y + 60.5595);
ctx.bezierCurveTo(x + 50.6055, y + 60.4341, x + 49.8829, y + 60.9585, x + 49.7597, y + 61.7288);
ctx.bezierCurveTo(x + 49.6365, y + 62.4991, x + 50.1594, y + 63.2257, x + 50.9278, y + 63.3511);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 53.5749, y + 64.0025);
ctx.bezierCurveTo(x + 54.4623, y + 64.1474, x + 55.297, y + 63.5417, x + 55.4393, y + 62.6519);
ctx.bezierCurveTo(x + 55.5817, y + 61.762, x + 54.9777, y + 60.9229, x + 54.0902, y + 60.778);
ctx.bezierCurveTo(x + 53.2027, y + 60.6331, x + 52.3678, y + 61.2378, x + 52.2257, y + 62.1286);
ctx.bezierCurveTo(x + 52.0833, y + 63.0184, x + 52.6874, y + 63.8576, x + 53.5749, y + 64.0025);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 56.2562, y + 64.4372);
ctx.bezierCurveTo(x + 57.1436, y + 64.5821, x + 57.9783, y + 63.9764, x + 58.121, y + 63.086);
ctx.bezierCurveTo(x + 58.2633, y + 62.1961, x + 57.6593, y + 61.357, x + 56.7718, y + 61.2121);
ctx.bezierCurveTo(x + 55.8843, y + 61.0672, x + 55.0494, y + 61.6718, x + 54.9073, y + 62.5627);
ctx.bezierCurveTo(x + 54.7647, y + 63.4531, x + 55.3687, y + 64.2923, x + 56.2562, y + 64.4372);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 58.9381, y + 64.8712);
ctx.bezierCurveTo(x + 59.8255, y + 65.0161, x + 60.6602, y + 64.4105, x + 60.8029, y + 63.5201);
ctx.bezierCurveTo(x + 60.9452, y + 62.6302, x + 60.3412, y + 61.7911, x + 59.4537, y + 61.6462);
ctx.bezierCurveTo(x + 58.5662, y + 61.5013, x + 57.7313, y + 62.1059, x + 57.5892, y + 62.9967);
ctx.bezierCurveTo(x + 57.4465, y + 63.8872, x + 58.0502, y + 64.727, x + 58.9381, y + 64.8712);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 61.6196, y + 65.3061);
ctx.bezierCurveTo(x + 62.5071, y + 65.451, x + 63.3417, y + 64.8454, x + 63.4841, y + 63.9555);
ctx.bezierCurveTo(x + 63.6264, y + 63.0657, x + 63.0224, y + 62.2265, x + 62.1349, y + 62.0816);
ctx.bezierCurveTo(x + 61.2474, y + 61.9367, x + 60.4125, y + 62.5414, x + 60.2698, y + 63.4319);
ctx.bezierCurveTo(x + 60.1281, y + 64.3221, x + 60.7318, y + 65.1618, x + 61.6196, y + 65.3061);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 64.2947, y + 65.778);
ctx.bezierCurveTo(x + 65.2026, y + 65.9263, x + 66.0569, y + 65.3069, x + 66.203, y + 64.3959);
ctx.bezierCurveTo(x + 66.3484, y + 63.4846, x + 65.7303, y + 62.6264, x + 64.823, y + 62.4784);
ctx.bezierCurveTo(x + 63.9147, y + 62.3307, x + 63.0608, y + 62.9495, x + 62.9151, y + 63.8598);
ctx.bezierCurveTo(x + 62.7687, y + 64.7714, x + 63.3868, y + 65.6296, x + 64.2947, y + 65.778);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 66.9592, y + 66.3167);
ctx.bezierCurveTo(x + 67.9244, y + 66.4739, x + 68.8333, y + 65.8163, x + 68.9878, y + 64.847);
ctx.bezierCurveTo(x + 69.1426, y + 63.8785, x + 68.4854, y + 62.9657, x + 67.5202, y + 62.8085);
ctx.bezierCurveTo(x + 66.555, y + 62.6513, x + 65.6462, y + 63.3089, x + 65.4914, y + 64.2773);
ctx.bezierCurveTo(x + 65.3368, y + 65.2467, x + 65.9941, y + 66.1595, x + 66.9592, y + 66.3167);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 69.6634, y + 66.61);
ctx.bezierCurveTo(x + 70.5509, y + 66.7549, x + 71.3855, y + 66.1493, x + 71.5282, y + 65.2588);
ctx.bezierCurveTo(x + 71.6706, y + 64.369, x + 71.0665, y + 63.5298, x + 70.1791, y + 63.3849);
ctx.bezierCurveTo(x + 69.2916, y + 63.24, x + 68.4567, y + 63.8447, x + 68.3146, y + 64.7355);
ctx.bezierCurveTo(x + 68.1719, y + 65.626, x + 68.7765, y + 66.4654, x + 69.6634, y + 66.61);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 72.3548, y + 66.9849);
ctx.bezierCurveTo(x + 73.2095, y + 67.1243, x + 74.0129, y + 66.5419, x + 74.1501, y + 65.6844);
ctx.bezierCurveTo(x + 74.287, y + 64.8274, x + 73.7056, y + 64.0193, x + 72.8509, y + 63.88);
ctx.bezierCurveTo(x + 71.9962, y + 63.7407, x + 71.1925, y + 64.3236, x + 71.055, y + 65.1802);
ctx.bezierCurveTo(x + 70.9187, y + 66.0375, x + 71.5001, y + 66.8456, x + 72.3548, y + 66.9849);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 75.0551, y + 67.2998);
ctx.bezierCurveTo(x + 75.8442, y + 67.428, x + 76.5861, y + 66.8904, x + 76.7127, y + 66.0996);
ctx.bezierCurveTo(x + 76.8392, y + 65.3088, x + 76.3025, y + 64.5625, x + 75.5134, y + 64.4343);
ctx.bezierCurveTo(x + 74.7243, y + 64.3061, x + 73.9824, y + 64.8437, x + 73.8558, y + 65.6345);
ctx.bezierCurveTo(x + 73.7293, y + 66.4253, x + 74.2669, y + 67.1713, x + 75.0551, y + 67.2998);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 77.7573, y + 67.6079);
ctx.bezierCurveTo(x + 78.4762, y + 67.7248, x + 79.1531, y + 67.2355, x + 79.2685, y + 66.5137);
ctx.bezierCurveTo(x + 79.3836, y + 65.7924, x + 78.8939, y + 65.1123, x + 78.1751, y + 64.9954);
ctx.bezierCurveTo(x + 77.4562, y + 64.8786, x + 76.7793, y + 65.3678, x + 76.6642, y + 66.0891);
ctx.bezierCurveTo(x + 76.5488, y + 66.811, x + 77.0388, y + 67.4904, x + 77.7573, y + 67.6079);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 80.4755, y + 67.8107);
ctx.bezierCurveTo(x + 81.0672, y + 67.9068, x + 81.6238, y + 67.5037, x + 81.7184, y + 66.91);
ctx.bezierCurveTo(x + 81.8137, y + 66.3167, x + 81.411, y + 65.7573, x + 80.8193, y + 65.6612);
ctx.bezierCurveTo(x + 80.2276, y + 65.5651, x + 79.671, y + 65.9682, x + 79.5758, y + 66.5615);
ctx.bezierCurveTo(x + 79.4812, y + 67.1552, x + 79.8839, y + 67.7146, x + 80.4755, y + 67.8107);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 83.1763, y + 68.1259);
ctx.bezierCurveTo(x + 83.7021, y + 68.2115, x + 84.1972, y + 67.8531, x + 84.2815, y + 67.3256);
ctx.bezierCurveTo(x + 84.3658, y + 66.7981, x + 84.0074, y + 66.3011, x + 83.4817, y + 66.2155);
ctx.bezierCurveTo(x + 82.9559, y + 66.1299, x + 82.4608, y + 66.4883, x + 82.3765, y + 67.0158);
ctx.bezierCurveTo(x + 82.2926, y + 67.5427, x + 82.6506, y + 68.0404, x + 83.1763, y + 68.1259);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 85.8826, y + 68.4036);
ctx.bezierCurveTo(x + 86.322, y + 68.4753, x + 86.7357, y + 68.176, x + 86.8066, y + 67.7345);
ctx.bezierCurveTo(x + 86.8771, y + 67.2936, x + 86.5773, y + 66.8781, x + 86.1379, y + 66.8065);
ctx.bezierCurveTo(x + 85.6985, y + 66.7348, x + 85.2847, y + 67.0341, x + 85.2142, y + 67.475);
ctx.bezierCurveTo(x + 85.1439, y + 67.9168, x + 85.4432, y + 68.332, x + 85.8826, y + 68.4036);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 88.5953, y + 68.644);
ctx.bezierCurveTo(x + 88.9279, y + 68.6983, x + 89.241, y + 68.4714, x + 89.2944, y + 68.1376);
ctx.bezierCurveTo(x + 89.3478, y + 67.8038, x + 89.1212, y + 67.4892, x + 88.7886, y + 67.4349);
ctx.bezierCurveTo(x + 88.4559, y + 67.3807, x + 88.1428, y + 67.6076, x + 88.0894, y + 67.9413);
ctx.bezierCurveTo(x + 88.0357, y + 68.2757, x + 88.2623, y + 68.5904, x + 88.5953, y + 68.644);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 91.3258, y + 68.7728);
ctx.bezierCurveTo(x + 91.4904, y + 68.7994, x + 91.6448, y + 68.6876, x + 91.671, y + 68.5224);
ctx.bezierCurveTo(x + 91.6975, y + 68.3581, x + 91.5855, y + 68.202, x + 91.4209, y + 68.1754);
ctx.bezierCurveTo(x + 91.2562, y + 68.1488, x + 91.1018, y + 68.2606, x + 91.076, y + 68.4252);
ctx.bezierCurveTo(x + 91.0498, y + 68.5904, x + 91.1611, y + 68.7462, x + 91.3258, y + 68.7728);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 94.0419, y + 68.9913);
ctx.bezierCurveTo(x + 94.0871, y + 68.999, x + 94.1299, y + 68.9678, x + 94.1368, y + 68.9222);
ctx.bezierCurveTo(x + 94.1444, y + 68.8768, x + 94.1129, y + 68.8344, x + 94.0683, y + 68.8271);
ctx.bezierCurveTo(x + 94.0232, y + 68.8194, x + 93.9807, y + 68.85, x + 93.9732, y + 68.8953);
ctx.bezierCurveTo(x + 93.9662, y + 68.941, x + 93.9968, y + 68.9836, x + 94.0419, y + 68.9913);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 27.9228, y + 60.9689);
ctx.bezierCurveTo(x + 27.9308, y + 60.9702, x + 27.9385, y + 60.9649, x + 27.9401, y + 60.9562);
ctx.bezierCurveTo(x + 27.9414, y + 60.9481, x + 27.9362, y + 60.9404, x + 27.9275, y + 60.9388);
ctx.bezierCurveTo(x + 27.9189, y + 60.9371, x + 27.9117, y + 60.9427, x + 27.9105, y + 60.9508);
ctx.bezierCurveTo(x + 27.9094, y + 60.9598, x + 27.9147, y + 60.9676, x + 27.9228, y + 60.9689);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 30.5975, y + 61.4477);
ctx.bezierCurveTo(x + 30.6303, y + 61.4533, x + 30.6612, y + 61.4306, x + 30.6666, y + 61.3977);
ctx.bezierCurveTo(x + 30.6721, y + 61.3648, x + 30.6495, y + 61.3337, x + 30.6163, y + 61.3288);
ctx.bezierCurveTo(x + 30.5835, y + 61.3232, x + 30.5526, y + 61.3459, x + 30.5472, y + 61.3788);
ctx.bezierCurveTo(x + 30.5423, y + 61.412, x + 30.5643, y + 61.4427, x + 30.5975, y + 61.4477);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 33.2406, y + 62.1216);
ctx.bezierCurveTo(x + 33.4053, y + 62.1482, x + 33.5597, y + 62.0364, x + 33.5859, y + 61.8712);
ctx.bezierCurveTo(x + 33.6123, y + 61.7069, x + 33.5003, y + 61.5508, x + 33.3357, y + 61.5242);
ctx.bezierCurveTo(x + 33.1711, y + 61.4976, x + 33.0166, y + 61.6094, x + 32.9902, y + 61.7737);
ctx.bezierCurveTo(x + 32.9646, y + 61.9392, x + 33.0763, y + 62.0944, x + 33.2406, y + 62.1216);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 35.9022, y + 62.6826);
ctx.bezierCurveTo(x + 36.1361, y + 62.7207, x + 36.3568, y + 62.5613, x + 36.3938, y + 62.3262);
ctx.bezierCurveTo(x + 36.4314, y + 62.0915, x + 36.2718, y + 61.8703, x + 36.0378, y + 61.8321);
ctx.bezierCurveTo(x + 35.8039, y + 61.7939, x + 35.5832, y + 61.9534, x + 35.5456, y + 62.1881);
ctx.bezierCurveTo(x + 35.5083, y + 62.4238, x + 35.6679, y + 62.645, x + 35.9022, y + 62.6826);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 38.5443, y + 63.3639);
ctx.bezierCurveTo(x + 38.9135, y + 63.4242, x + 39.2619, y + 63.1723, x + 39.321, y + 62.801);
ctx.bezierCurveTo(x + 39.3801, y + 62.4296, x + 39.1288, y + 62.0804, x + 38.7587, y + 62.0203);
ctx.bezierCurveTo(x + 38.3886, y + 61.9603, x + 38.0411, y + 62.2119, x + 37.9814, y + 62.5829);
ctx.bezierCurveTo(x + 37.9223, y + 62.9543, x + 38.1742, y + 63.3038, x + 38.5443, y + 63.3639);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 41.1805, y + 64.082);
ctx.bezierCurveTo(x + 41.7062, y + 64.1676, x + 42.2014, y + 63.8092, x + 42.2856, y + 63.2817);
ctx.bezierCurveTo(x + 42.3699, y + 62.7541, x + 42.0116, y + 62.2571, x + 41.4858, y + 62.1715);
ctx.bezierCurveTo(x + 40.9601, y + 62.086, x + 40.4649, y + 62.4443, x + 40.3807, y + 62.9719);
ctx.bezierCurveTo(x + 40.2964, y + 63.4994, x + 40.6547, y + 63.9964, x + 41.1805, y + 64.082);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 43.8446, y + 64.6212);
ctx.bezierCurveTo(x + 44.4279, y + 64.7166, x + 44.9768, y + 64.3187, x + 45.0707, y + 63.7335);
ctx.bezierCurveTo(x + 45.1647, y + 63.1482, x + 44.7672, y + 62.5965, x + 44.1836, y + 62.5018);
ctx.bezierCurveTo(x + 43.6003, y + 62.4064, x + 43.0514, y + 62.8042, x + 42.9575, y + 63.3895);
ctx.bezierCurveTo(x + 42.8645, y + 63.9745, x + 43.2619, y + 64.5261, x + 43.8446, y + 64.6212);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 46.5097, y + 65.1605);
ctx.bezierCurveTo(x + 47.1502, y + 65.2647, x + 47.7531, y + 64.8284, x + 47.8561, y + 64.1851);
ctx.bezierCurveTo(x + 47.9588, y + 63.5423, x + 47.5229, y + 62.9364, x + 46.8818, y + 62.8318);
ctx.bezierCurveTo(x + 46.2412, y + 62.7275, x + 45.6377, y + 63.1635, x + 45.5347, y + 63.8069);
ctx.bezierCurveTo(x + 45.4326, y + 64.4499, x + 45.8691, y + 65.0562, x + 46.5097, y + 65.1605);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 49.1739, y + 65.707);
ctx.bezierCurveTo(x + 49.8767, y + 65.8213, x + 50.5372, y + 65.3428, x + 50.6503, y + 64.638);
ctx.bezierCurveTo(x + 50.7629, y + 63.9329, x + 50.2849, y + 63.269, x + 49.5822, y + 63.1547);
ctx.bezierCurveTo(x + 48.8797, y + 63.0399, x + 48.2189, y + 63.5189, x + 48.1057, y + 64.2237);
ctx.bezierCurveTo(x + 47.9926, y + 64.9285, x + 48.4711, y + 65.5927, x + 49.1739, y + 65.707);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 51.8501, y + 66.1714);
ctx.bezierCurveTo(x + 52.569, y + 66.2883, x + 53.2452, y + 65.7987, x + 53.3613, y + 65.0771);
ctx.bezierCurveTo(x + 53.4764, y + 64.3559, x + 52.9867, y + 63.6758, x + 52.2678, y + 63.5589);
ctx.bezierCurveTo(x + 51.549, y + 63.442, x + 50.8721, y + 63.9313, x + 50.757, y + 64.6526);
ctx.bezierCurveTo(x + 50.6415, y + 65.3745, x + 51.1312, y + 66.0545, x + 51.8501, y + 66.1714);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 54.5136, y + 66.7177);
ctx.bezierCurveTo(x + 55.2943, y + 66.8453, x + 56.0286, y + 66.3129, x + 56.1535, y + 65.5292);
ctx.bezierCurveTo(x + 56.2788, y + 64.7465, x + 55.7474, y + 64.008, x + 54.9673, y + 63.8808);
ctx.bezierCurveTo(x + 54.1865, y + 63.7532, x + 53.4523, y + 64.2856, x + 53.327, y + 65.0683);
ctx.bezierCurveTo(x + 53.2017, y + 65.8526, x + 53.7331, y + 66.5912, x + 54.5136, y + 66.7177);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 57.1893, y + 67.1901);
ctx.bezierCurveTo(x + 57.9898, y + 67.3207, x + 58.7443, y + 66.7749, x + 58.8726, y + 65.9707);
ctx.bezierCurveTo(x + 59.0007, y + 65.1672, x + 58.4557, y + 64.4099, x + 57.6546, y + 64.2789);
ctx.bezierCurveTo(x + 56.8534, y + 64.1479, x + 56.0996, y + 64.6941, x + 55.9716, y + 65.4976);
ctx.bezierCurveTo(x + 55.8429, y + 66.3024, x + 56.3881, y + 67.0591, x + 57.1893, y + 67.1901);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 59.8659, y + 67.654);
ctx.bezierCurveTo(x + 60.6835, y + 67.7869, x + 61.4528, y + 67.2302, x + 61.5837, y + 66.4099);
ctx.bezierCurveTo(x + 61.7146, y + 65.5896, x + 61.1582, y + 64.8171, x + 60.341, y + 64.6835);
ctx.bezierCurveTo(x + 59.5234, y + 64.5505, x + 58.7541, y + 65.1072, x + 58.6232, y + 65.9275);
ctx.bezierCurveTo(x + 58.4919, y + 66.7485, x + 59.049, y + 67.5213, x + 59.8659, y + 67.654);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 62.5288, y + 68.2087);
ctx.bezierCurveTo(x + 63.412, y + 68.3528, x + 64.243, y + 67.7508, x + 64.3853, y + 66.864);
ctx.bezierCurveTo(x + 64.5271, y + 65.9779, x + 63.9258, y + 65.1427, x + 63.0426, y + 64.9986);
ctx.bezierCurveTo(x + 62.1595, y + 64.8545, x + 61.3284, y + 65.4565, x + 61.1865, y + 66.3427);
ctx.bezierCurveTo(x + 61.0443, y + 67.2294, x + 61.6453, y + 68.0653, x + 62.5288, y + 68.2087);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.1976, y + 68.7178);
ctx.bezierCurveTo(x + 66.122, y + 68.8681, x + 66.9916, y + 68.2381, x + 67.1397, y + 67.3107);
ctx.bezierCurveTo(x + 67.2877, y + 66.3832, x + 66.659, y + 65.5095, x + 65.7341, y + 65.3588);
ctx.bezierCurveTo(x + 64.8098, y + 65.2085, x + 63.9401, y + 65.8385, x + 63.7914, y + 66.7656);
ctx.bezierCurveTo(x + 63.6443, y + 67.6928, x + 64.2736, y + 68.5668, x + 65.1976, y + 68.7178);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 67.8902, y + 69.0853);
ctx.bezierCurveTo(x + 68.7777, y + 69.2302, x + 69.6124, y + 68.6246, x + 69.7551, y + 67.7341);
ctx.bezierCurveTo(x + 69.8974, y + 66.8442, x + 69.2934, y + 66.0051, x + 68.4059, y + 65.8602);
ctx.bezierCurveTo(x + 67.5184, y + 65.7153, x + 66.6835, y + 66.32, x + 66.5408, y + 67.2104);
ctx.bezierCurveTo(x + 66.3987, y + 68.1012, x + 67.0024, y + 68.941, x + 67.8902, y + 69.0853);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 70.5955, y + 69.3704);
ctx.bezierCurveTo(x + 71.4007, y + 69.5012, x + 72.1584, y + 68.9524, x + 72.2879, y + 68.1449);
ctx.bezierCurveTo(x + 72.4173, y + 67.3373, x + 71.8685, y + 66.5754, x + 71.0633, y + 66.4446);
ctx.bezierCurveTo(x + 70.2581, y + 66.3138, x + 69.5004, y + 66.8625, x + 69.371, y + 67.6701);
ctx.bezierCurveTo(x + 69.2421, y + 68.478, x + 69.7903, y + 69.2396, x + 70.5955, y + 69.3704);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 73.2817, y + 69.7749);
ctx.bezierCurveTo(x + 74.0704, y + 69.9038, x + 74.8124, y + 69.3662, x + 74.9392, y + 68.5747);
ctx.bezierCurveTo(x + 75.0658, y + 67.7839, x + 74.5291, y + 67.0376, x + 73.74, y + 66.9094);
ctx.bezierCurveTo(x + 72.9509, y + 66.7812, x + 72.2089, y + 67.3188, x + 72.0824, y + 68.1096);
ctx.bezierCurveTo(x + 71.9559, y + 68.9004, x + 72.4925, y + 69.6467, x + 73.2817, y + 69.7749);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 75.9849, y + 70.0757);
ctx.bezierCurveTo(x + 76.7, y + 70.1921, x + 77.3725, y + 69.7051, x + 77.4871, y + 68.9876);
ctx.bezierCurveTo(x + 77.6014, y + 68.2706, x + 77.1149, y + 67.5948, x + 76.4001, y + 67.4778);
ctx.bezierCurveTo(x + 75.685, y + 67.3614, x + 75.0126, y + 67.8483, x + 74.8983, y + 68.5653);
ctx.bezierCurveTo(x + 74.7836, y + 69.2828, x + 75.2698, y + 69.9593, x + 75.9849, y + 70.0757);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 78.6841, y + 70.398);
ctx.bezierCurveTo(x + 79.337, y + 70.5044, x + 79.9522, y + 70.059, x + 80.0563, y + 69.4035);
ctx.bezierCurveTo(x + 80.1611, y + 68.7483, x + 79.7167, y + 68.1304, x + 79.0631, y + 68.0237);
ctx.bezierCurveTo(x + 78.4096, y + 67.917, x + 77.795, y + 68.3628, x + 77.6903, y + 69.0179);
ctx.bezierCurveTo(x + 77.5864, y + 69.6744, x + 78.0308, y + 70.2923, x + 78.6841, y + 70.398);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 81.4241, y + 70.4668);
ctx.bezierCurveTo(x + 81.8759, y + 70.5405, x + 82.3009, y + 70.2324, x + 82.3735, y + 69.7791);
ctx.bezierCurveTo(x + 82.4462, y + 69.3258, x + 82.1384, y + 68.8986, x + 81.6866, y + 68.8249);
ctx.bezierCurveTo(x + 81.2348, y + 68.7511, x + 80.8092, y + 69.0589, x + 80.7372, y + 69.5125);
ctx.bezierCurveTo(x + 80.6645, y + 69.9658, x + 80.9723, y + 70.393, x + 81.4241, y + 70.4668);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 84.1403, y + 70.6851);
ctx.bezierCurveTo(x + 84.473, y + 70.7394, x + 84.7861, y + 70.5125, x + 84.8398, y + 70.1781);
ctx.bezierCurveTo(x + 84.8932, y + 69.8444, x + 84.6666, y + 69.5297, x + 84.334, y + 69.4755);
ctx.bezierCurveTo(x + 84.0013, y + 69.4212, x + 83.6883, y + 69.6481, x + 83.6348, y + 69.9819);
ctx.bezierCurveTo(x + 83.5811, y + 70.3162, x + 83.8077, y + 70.6309, x + 84.1403, y + 70.6851);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 86.8419, y + 70.9928);
ctx.bezierCurveTo(x + 87.1052, y + 71.0355, x + 87.352, y + 70.8562, x + 87.3946, y + 70.5923);
ctx.bezierCurveTo(x + 87.4369, y + 70.329, x + 87.2576, y + 70.0801, x + 86.9948, y + 70.0377);
ctx.bezierCurveTo(x + 86.7318, y + 69.9945, x + 86.4847, y + 70.1743, x + 86.4424, y + 70.4376);
ctx.bezierCurveTo(x + 86.4001, y + 70.7009, x + 86.5795, y + 70.9499, x + 86.8419, y + 70.9928);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 89.5526, y + 71.2481);
ctx.bezierCurveTo(x + 89.7169, y + 71.2752, x + 89.8717, y + 71.1628, x + 89.8979, y + 70.9976);
ctx.bezierCurveTo(x + 89.9243, y + 70.8334, x + 89.8123, y + 70.6772, x + 89.6477, y + 70.6506);
ctx.bezierCurveTo(x + 89.4831, y + 70.6241, x + 89.3286, y + 70.7359, x + 89.3022, y + 70.9001);
ctx.bezierCurveTo(x + 89.2757, y + 71.0659, x + 89.388, y + 71.2215, x + 89.5526, y + 71.2481);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 92.2754, y + 71.4215);
ctx.bezierCurveTo(x + 92.2958, y + 71.4249, x + 92.3154, y + 71.4111, x + 92.3191, y + 71.39);
ctx.bezierCurveTo(x + 92.3225, y + 71.3695, x + 92.3084, y + 71.3505, x + 92.288, y + 71.347);
ctx.bezierCurveTo(x + 92.2675, y + 71.3436, x + 92.2479, y + 71.3574, x + 92.2446, y + 71.3779);
ctx.bezierCurveTo(x + 92.2408, y + 71.399, x + 92.255, y + 71.4181, x + 92.2754, y + 71.4215);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 31.5117, y + 64.321);
ctx.bezierCurveTo(x + 31.524, y + 64.3231, x + 31.5353, y + 64.3142, x + 31.5374, y + 64.3018);
ctx.bezierCurveTo(x + 31.5395, y + 64.2894, x + 31.531, y + 64.2775, x + 31.5183, y + 64.2759);
ctx.bezierCurveTo(x + 31.5059, y + 64.2738, x + 31.4946, y + 64.2827, x + 31.4925, y + 64.2951);
ctx.bezierCurveTo(x + 31.4908, y + 64.3069, x + 31.4987, y + 64.3185, x + 31.5117, y + 64.321);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 34.1835, y + 64.8151);
ctx.bezierCurveTo(x + 34.2286, y + 64.8228, x + 34.2714, y + 64.7916, x + 34.2784, y + 64.746);
ctx.bezierCurveTo(x + 34.286, y + 64.7006, x + 34.2545, y + 64.6582, x + 34.2099, y + 64.6509);
ctx.bezierCurveTo(x + 34.1647, y + 64.6432, x + 34.1223, y + 64.6738, x + 34.1153, y + 64.7194);
ctx.bezierCurveTo(x + 34.1077, y + 64.7648, x + 34.1383, y + 64.8074, x + 34.1835, y + 64.8151);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 36.8302, y + 65.4663);
ctx.bezierCurveTo(x + 36.9949, y + 65.4929, x + 37.1493, y + 65.3811, x + 37.1755, y + 65.2159);
ctx.bezierCurveTo(x + 37.2019, y + 65.0517, x + 37.0899, y + 64.8955, x + 36.9253, y + 64.8689);
ctx.bezierCurveTo(x + 36.7607, y + 64.8423, x + 36.6062, y + 64.9541, x + 36.5798, y + 65.1184);
ctx.bezierCurveTo(x + 36.5542, y + 65.2839, x + 36.6659, y + 65.4391, x + 36.8302, y + 65.4663);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 39.4626, y + 66.2069);
ctx.bezierCurveTo(x + 39.7953, y + 66.2611, x + 40.1083, y + 66.0343, x + 40.1621, y + 65.6999);
ctx.bezierCurveTo(x + 40.2155, y + 65.3661, x + 39.9889, y + 65.0515, x + 39.6562, y + 64.9972);
ctx.bezierCurveTo(x + 39.3236, y + 64.943, x + 39.0105, y + 65.1698, x + 38.9571, y + 65.5036);
ctx.bezierCurveTo(x + 38.9033, y + 65.838, x + 39.13, y + 66.1526, x + 39.4626, y + 66.2069);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 42.1253, y + 66.7606);
ctx.bezierCurveTo(x + 42.5239, y + 66.8253, x + 42.899, y + 66.5541, x + 42.9628, y + 66.1541);
ctx.bezierCurveTo(x + 43.0266, y + 65.7542, x + 42.7553, y + 65.3778, x + 42.357, y + 65.3124);
ctx.bezierCurveTo(x + 41.9585, y + 65.2477, x + 41.5833, y + 65.5189, x + 41.5196, y + 65.9189);
ctx.bezierCurveTo(x + 41.4558, y + 66.3188, x + 41.7268, y + 66.6958, x + 42.1253, y + 66.7606);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 44.7875, y + 67.3148);
ctx.bezierCurveTo(x + 45.2516, y + 67.3907, x + 45.6886, y + 67.0741, x + 45.7627, y + 66.608);
ctx.bezierCurveTo(x + 45.8374, y + 66.1423, x + 45.5211, y + 65.7032, x + 45.057, y + 65.6273);
ctx.bezierCurveTo(x + 44.5928, y + 65.5514, x + 44.1559, y + 65.868, x + 44.0811, y + 66.3337);
ctx.bezierCurveTo(x + 44.0076, y + 66.8001, x + 44.323, y + 67.2395, x + 44.7875, y + 67.3148);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 47.451, y + 67.861);
ctx.bezierCurveTo(x + 47.9767, y + 67.9466, x + 48.4719, y + 67.5882, x + 48.5561, y + 67.0607);
ctx.bezierCurveTo(x + 48.6404, y + 66.5332, x + 48.2827, y + 66.0365, x + 47.7563, y + 65.9506);
ctx.bezierCurveTo(x + 47.2306, y + 65.865, x + 46.7354, y + 66.2234, x + 46.6512, y + 66.7509);
ctx.bezierCurveTo(x + 46.5669, y + 67.2784, x + 46.9252, y + 67.7755, x + 47.451, y + 67.861);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 50.0885, y + 68.5725);
ctx.bezierCurveTo(x + 50.7662, y + 68.6832, x + 51.4042, y + 68.2209, x + 51.5126, y + 67.5406);
ctx.bezierCurveTo(x + 51.6215, y + 66.8606, x + 51.1598, y + 66.2194, x + 50.4821, y + 66.1088);
ctx.bezierCurveTo(x + 49.8044, y + 65.9981, x + 49.1664, y + 66.4604, x + 49.058, y + 67.1407);
ctx.bezierCurveTo(x + 48.9491, y + 67.8207, x + 49.4109, y + 68.4619, x + 50.0885, y + 68.5725);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 52.7713, y + 68.9991);
ctx.bezierCurveTo(x + 53.4446, y + 69.1089, x + 54.079, y + 68.6502, x + 54.1869, y + 67.9736);
ctx.bezierCurveTo(x + 54.2951, y + 67.298, x + 53.8359, y + 66.6607, x + 53.1626, y + 66.5509);
ctx.bezierCurveTo(x + 52.4892, y + 66.441, x + 51.8544, y + 66.9003, x + 51.7463, y + 67.5759);
ctx.bezierCurveTo(x + 51.6384, y + 68.2525, x + 52.0979, y + 68.8893, x + 52.7713, y + 68.9991);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 55.4397, y + 69.5161);
ctx.bezierCurveTo(x + 56.1586, y + 69.633, x + 56.8355, y + 69.1438, x + 56.9509, y + 68.4219);
ctx.bezierCurveTo(x + 57.066, y + 67.7006, x + 56.5763, y + 67.0205, x + 55.8575, y + 66.9037);
ctx.bezierCurveTo(x + 55.1386, y + 66.7868, x + 54.4617, y + 67.276, x + 54.3466, y + 67.9973);
ctx.bezierCurveTo(x + 54.2311, y + 68.7192, x + 54.7208, y + 69.3992, x + 55.4397, y + 69.5161);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 58.1213, y + 69.9511);
ctx.bezierCurveTo(x + 58.8402, y + 70.0679, x + 59.5165, y + 69.5783, x + 59.6325, y + 68.8568);
ctx.bezierCurveTo(x + 59.7476, y + 68.1355, x + 59.258, y + 67.4555, x + 58.5391, y + 67.3386);
ctx.bezierCurveTo(x + 57.8202, y + 67.2217, x + 57.1439, y + 67.7113, x + 57.0282, y + 68.4322);
ctx.bezierCurveTo(x + 56.9128, y + 69.1541, x + 57.4025, y + 69.8342, x + 58.1213, y + 69.9511);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 60.7739, y + 70.5646);
ctx.bezierCurveTo(x + 61.5915, y + 70.6976, x + 62.3607, y + 70.1409, x + 62.4917, y + 69.3205);
ctx.bezierCurveTo(x + 62.6226, y + 68.5002, x + 62.0656, y + 67.7274, x + 61.2489, y + 67.5941);
ctx.bezierCurveTo(x + 60.4314, y + 67.4612, x + 59.6621, y + 68.0179, x + 59.5312, y + 68.8382);
ctx.bezierCurveTo(x + 59.3996, y + 69.6582, x + 59.9567, y + 70.431, x + 60.7739, y + 70.5646);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 63.4552, y + 70.9993);
ctx.bezierCurveTo(x + 64.2728, y + 71.1323, x + 65.042, y + 70.5756, x + 65.1733, y + 69.7546);
ctx.bezierCurveTo(x + 65.3042, y + 68.9343, x + 64.7478, y + 68.1618, x + 63.9306, y + 68.0282);
ctx.bezierCurveTo(x + 63.113, y + 67.8953, x + 62.3437, y + 68.4519, x + 62.2128, y + 69.2723);
ctx.bezierCurveTo(x + 62.0809, y + 70.0929, x + 62.638, y + 70.8657, x + 63.4552, y + 70.9993);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 66.1377, y + 71.4267);
ctx.bezierCurveTo(x + 66.9509, y + 71.5588, x + 67.7163, y + 71.0048, x + 67.8468, y + 70.1882);
ctx.bezierCurveTo(x + 67.9775, y + 69.3725, x + 67.4235, y + 68.6029, x + 66.6106, y + 68.4702);
ctx.bezierCurveTo(x + 65.7973, y + 68.338, x + 65.0319, y + 68.8921, x + 64.9012, y + 69.7077);
ctx.bezierCurveTo(x + 64.7707, y + 70.5243, x + 65.3248, y + 71.2939, x + 66.1377, y + 71.4267);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 68.7994, y + 71.9879);
ctx.bezierCurveTo(x + 69.6826, y + 72.132, x + 70.5137, y + 71.5299, x + 70.6553, y + 70.6429);
ctx.bezierCurveTo(x + 70.7972, y + 69.7567, x + 70.1958, y + 68.9215, x + 69.3126, y + 68.7774);
ctx.bezierCurveTo(x + 68.4295, y + 68.6333, x + 67.5984, y + 69.2353, x + 67.4565, y + 70.1215);
ctx.bezierCurveTo(x + 67.3149, y + 71.0086, x + 67.9163, y + 71.8438, x + 68.7994, y + 71.9879);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 71.5037, y + 72.2803);
ctx.bezierCurveTo(x + 72.3089, y + 72.4111, x + 73.0666, y + 71.8623, x + 73.1961, y + 71.0548);
ctx.bezierCurveTo(x + 73.3255, y + 70.2472, x + 72.7767, y + 69.4854, x + 71.9715, y + 69.3545);
ctx.bezierCurveTo(x + 71.1663, y + 69.2237, x + 70.4086, y + 69.7725, x + 70.2795, y + 70.5794);
ctx.bezierCurveTo(x + 70.1497, y + 71.3876, x + 70.6979, y + 72.1491, x + 71.5037, y + 72.2803);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.21, y + 72.5586);
ctx.bezierCurveTo(x + 74.9288, y + 72.6755, x + 75.6057, y + 72.1862, x + 75.7212, y + 71.4643);
ctx.bezierCurveTo(x + 75.8363, y + 70.7431, x + 75.3466, y + 70.063, x + 74.6277, y + 69.9461);
ctx.bezierCurveTo(x + 73.9089, y + 69.8292, x + 73.232, y + 70.3185, x + 73.1169, y + 71.0398);
ctx.bezierCurveTo(x + 73.0014, y + 71.7617, x + 73.4914, y + 72.4411, x + 74.21, y + 72.5586);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 76.8916, y + 72.9927);
ctx.bezierCurveTo(x + 77.6105, y + 73.1096, x + 78.2867, y + 72.62, x + 78.4028, y + 71.8984);
ctx.bezierCurveTo(x + 78.5179, y + 71.1771, x + 78.0282, y + 70.4971, x + 77.3093, y + 70.3802);
ctx.bezierCurveTo(x + 76.5905, y + 70.2633, x + 75.9136, y + 70.7526, x + 75.7985, y + 71.4739);
ctx.bezierCurveTo(x + 75.683, y + 72.1958, x + 76.1727, y + 72.8758, x + 76.8916, y + 72.9927);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 79.6351, y + 73.0394);
ctx.bezierCurveTo(x + 80.1404, y + 73.1216, x + 80.6156, y + 72.7776, x + 80.6968, y + 72.2699);
ctx.bezierCurveTo(x + 80.7777, y + 71.7629, x + 80.4342, y + 71.2853, x + 79.9288, y + 71.2032);
ctx.bezierCurveTo(x + 79.4235, y + 71.121, x + 78.9483, y + 71.465, x + 78.8674, y + 71.972);
ctx.bezierCurveTo(x + 78.7856, y + 72.4794, x + 79.1297, y + 72.9573, x + 79.6351, y + 73.0394);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 82.332, y + 73.3773);
ctx.bezierCurveTo(x + 82.7838, y + 73.451, x + 83.2089, y + 73.143, x + 83.2815, y + 72.6896);
ctx.bezierCurveTo(x + 83.3541, y + 72.2363, x + 83.0464, y + 71.8091, x + 82.5946, y + 71.7354);
ctx.bezierCurveTo(x + 82.1428, y + 71.6616, x + 81.7178, y + 71.9697, x + 81.6451, y + 72.423);
ctx.bezierCurveTo(x + 81.5728, y + 72.8757, x + 81.8803, y + 73.3035, x + 82.332, y + 73.3773);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 85.0649, y + 73.4908);
ctx.bezierCurveTo(x + 85.3406, y + 73.5356, x + 85.5993, y + 73.3479, x + 85.6431, y + 73.0718);
ctx.bezierCurveTo(x + 85.6868, y + 72.7958, x + 85.5002, y + 72.5355, x + 85.2245, y + 72.4907);
ctx.bezierCurveTo(x + 84.9488, y + 72.446, x + 84.6901, y + 72.6337, x + 84.6463, y + 72.9097);
ctx.bezierCurveTo(x + 84.6026, y + 73.1858, x + 84.7892, y + 73.4461, x + 85.0649, y + 73.4908);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 87.7785, y + 73.7236);
ctx.bezierCurveTo(x + 87.9431, y + 73.7502, x + 88.0975, y + 73.6384, x + 88.1237, y + 73.4732);
ctx.bezierCurveTo(x + 88.1501, y + 73.309, x + 88.0382, y + 73.1528, x + 87.8735, y + 73.1262);
ctx.bezierCurveTo(x + 87.7089, y + 73.0997, x + 87.5545, y + 73.2115, x + 87.528, y + 73.3757);
ctx.bezierCurveTo(x + 87.5025, y + 73.5412, x + 87.6138, y + 73.6971, x + 87.7785, y + 73.7236);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 90.472, y + 74.0835);
ctx.bezierCurveTo(x + 90.5949, y + 74.1035, x + 90.7113, y + 74.02, x + 90.7313, y + 73.8961);
ctx.bezierCurveTo(x + 90.751, y + 73.7729, x + 90.6666, y + 73.6561, x + 90.5438, y + 73.6361);
ctx.bezierCurveTo(x + 90.4209, y + 73.6162, x + 90.3045, y + 73.6997, x + 90.2845, y + 73.8235);
ctx.bezierCurveTo(x + 90.2648, y + 73.9468, x + 90.3492, y + 74.0636, x + 90.472, y + 74.0835);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 93.1862, y + 74.3168);
ctx.bezierCurveTo(x + 93.1986, y + 74.319, x + 93.2099, y + 74.3101, x + 93.212, y + 74.2977);
ctx.bezierCurveTo(x + 93.2141, y + 74.2853, x + 93.2056, y + 74.2733, x + 93.1929, y + 74.2718);
ctx.bezierCurveTo(x + 93.1805, y + 74.2697, x + 93.1692, y + 74.2785, x + 93.1671, y + 74.2909);
ctx.bezierCurveTo(x + 93.165, y + 74.3033, x + 93.1735, y + 74.3153, x + 93.1862, y + 74.3168);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 32.4193, y + 67.2307);
ctx.bezierCurveTo(x + 32.4317, y + 67.2328, x + 32.4435, y + 67.2243, x + 32.445, y + 67.2115);
ctx.bezierCurveTo(x + 32.4471, y + 67.1991, x + 32.4386, y + 67.1872, x + 32.4265, y + 67.186);
ctx.bezierCurveTo(x + 32.4141, y + 67.1839, x + 32.4022, y + 67.1924, x + 32.4008, y + 67.2051);
ctx.bezierCurveTo(x + 32.399, y + 67.2169, x + 32.4066, y + 67.2292, x + 32.4193, y + 67.2307);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 35.0624, y + 67.9047);
ctx.bezierCurveTo(x + 35.2063, y + 67.9284, x + 35.3414, y + 67.8298, x + 35.3648, y + 67.6854);
ctx.bezierCurveTo(x + 35.3882, y + 67.5411, x + 35.2897, y + 67.4052, x + 35.1465, y + 67.3818);
ctx.bezierCurveTo(x + 35.0026, y + 67.3581, x + 34.8674, y + 67.4567, x + 34.8444, y + 67.6004);
ctx.bezierCurveTo(x + 34.821, y + 67.7448, x + 34.9191, y + 67.8812, x + 35.0624, y + 67.9047);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 37.7394, y + 68.3688);
ctx.bezierCurveTo(x + 37.8994, y + 68.3952, x + 38.05, y + 68.286, x + 38.0763, y + 68.1249);
ctx.bezierCurveTo(x + 38.1023, y + 67.9644, x + 37.9926, y + 67.8127, x + 37.8326, y + 67.7864);
ctx.bezierCurveTo(x + 37.6727, y + 67.76, x + 37.5218, y + 67.8698, x + 37.4958, y + 68.0303);
ctx.bezierCurveTo(x + 37.4701, y + 68.1917, x + 37.5795, y + 68.3425, x + 37.7394, y + 68.3688);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 40.3829, y + 69.0421);
ctx.bezierCurveTo(x + 40.6747, y + 69.0895, x + 40.9488, y + 68.8912, x + 40.9955, y + 68.5984);
ctx.bezierCurveTo(x + 41.0421, y + 68.3056, x + 40.844, y + 68.0301, x + 40.5522, y + 67.9827);
ctx.bezierCurveTo(x + 40.2604, y + 67.9353, x + 39.9863, y + 68.1337, x + 39.9396, y + 68.4265);
ctx.bezierCurveTo(x + 39.8924, y + 68.7189, x + 40.0911, y + 68.9947, x + 40.3829, y + 69.0421);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 43.0523, y + 69.5517);
ctx.bezierCurveTo(x + 43.385, y + 69.606, x + 43.698, y + 69.3791, x + 43.7515, y + 69.0453);
ctx.bezierCurveTo(x + 43.8049, y + 68.7116, x + 43.5783, y + 68.3969, x + 43.2456, y + 68.3427);
ctx.bezierCurveTo(x + 42.9129, y + 68.2884, x + 42.5999, y + 68.5153, x + 42.5465, y + 68.849);
ctx.bezierCurveTo(x + 42.493, y + 69.1828, x + 42.7197, y + 69.4975, x + 43.0523, y + 69.5517);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 45.6857, y + 70.2849);
ctx.bezierCurveTo(x + 46.183, y + 70.3657, x + 46.6505, y + 70.027, x + 46.7301, y + 69.5281);
ctx.bezierCurveTo(x + 46.81, y + 69.0301, x + 46.4714, y + 68.5593, x + 45.9741, y + 68.4784);
ctx.bezierCurveTo(x + 45.4768, y + 68.3976, x + 45.0093, y + 68.7363, x + 44.9295, y + 69.2343);
ctx.bezierCurveTo(x + 44.8505, y + 69.7336, x + 45.1888, y + 70.2034, x + 45.6857, y + 70.2849);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 48.3589, y + 70.7717);
ctx.bezierCurveTo(x + 48.8847, y + 70.8573, x + 49.3798, y + 70.4989, x + 49.4641, y + 69.9714);
ctx.bezierCurveTo(x + 49.5484, y + 69.4438, x + 49.1907, y + 68.9471, x + 48.6643, y + 68.8612);
ctx.bezierCurveTo(x + 48.1385, y + 68.7757, x + 47.6434, y + 69.134, x + 47.5591, y + 69.6616);
ctx.bezierCurveTo(x + 47.4752, y + 70.1885, x + 47.8332, y + 70.6861, x + 48.3589, y + 70.7717);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 51.0286, y + 71.2813);
ctx.bezierCurveTo(x + 51.5952, y + 71.3738, x + 52.1289, y + 70.9874, x + 52.2203, y + 70.4183);
ctx.bezierCurveTo(x + 52.3113, y + 69.8498, x + 51.9254, y + 69.3134, x + 51.3582, y + 69.2206);
ctx.bezierCurveTo(x + 50.7916, y + 69.1282, x + 50.2578, y + 69.5145, x + 50.1665, y + 70.0836);
ctx.bezierCurveTo(x + 50.076, y + 70.6524, x + 50.462, y + 71.1889, x + 51.0286, y + 71.2813);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 53.6994, y + 71.7828);
ctx.bezierCurveTo(x + 54.3035, y + 71.881, x + 54.8717, y + 71.47, x + 54.9684, y + 70.8639);
ctx.bezierCurveTo(x + 55.0651, y + 70.2578, x + 54.6545, y + 69.6867, x + 54.0504, y + 69.5885);
ctx.bezierCurveTo(x + 53.4464, y + 69.4903, x + 52.8782, y + 69.9014, x + 52.7815, y + 70.5074);
ctx.bezierCurveTo(x + 52.6848, y + 71.1135, x + 53.0957, y + 71.684, x + 53.6994, y + 71.7828);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 56.3474, y + 72.426);
ctx.bezierCurveTo(x + 57.0663, y + 72.5429, x + 57.7426, y + 72.0533, x + 57.8586, y + 71.3318);
ctx.bezierCurveTo(x + 57.9737, y + 70.6105, x + 57.484, y + 69.9305, x + 56.7652, y + 69.8136);
ctx.bezierCurveTo(x + 56.0463, y + 69.6967, x + 55.3694, y + 70.1859, x + 55.2543, y + 70.9072);
ctx.bezierCurveTo(x + 55.1389, y + 71.6291, x + 55.6286, y + 72.3092, x + 56.3474, y + 72.426);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 59.0353, y + 72.8235);
ctx.bezierCurveTo(x + 59.7337, y + 72.937, x + 60.391, y + 72.4615, x + 60.5027, y + 71.7607);
ctx.bezierCurveTo(x + 60.6151, y + 71.0603, x + 60.1395, y + 70.3993, x + 59.4411, y + 70.2859);
ctx.bezierCurveTo(x + 58.7426, y + 70.1724, x + 58.0853, y + 70.6479, x + 57.9736, y + 71.3487);
ctx.bezierCurveTo(x + 57.8613, y + 72.0491, x + 58.3362, y + 72.7097, x + 59.0353, y + 72.8235);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 61.7224, y + 73.2207);
ctx.bezierCurveTo(x + 62.4001, y + 73.3313, x + 63.0381, y + 72.869, x + 63.1464, y + 72.1887);
ctx.bezierCurveTo(x + 63.2554, y + 71.5088, x + 62.7936, y + 70.8675, x + 62.1159, y + 70.7569);
ctx.bezierCurveTo(x + 61.4382, y + 70.6463, x + 60.8002, y + 71.1085, x + 60.6913, y + 71.7885);
ctx.bezierCurveTo(x + 60.5835, y + 72.4691, x + 61.0444, y + 73.1106, x + 61.7224, y + 73.2207);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 64.3918, y + 73.7303);
ctx.bezierCurveTo(x + 65.1107, y + 73.8472, x + 65.787, y + 73.3576, x + 65.903, y + 72.6361);
ctx.bezierCurveTo(x + 66.0182, y + 71.9148, x + 65.5285, y + 71.2348, x + 64.8096, y + 71.1179);
ctx.bezierCurveTo(x + 64.0907, y + 71.001, x + 63.4145, y + 71.4906, x + 63.2987, y + 72.2115);
ctx.bezierCurveTo(x + 63.1833, y + 72.9334, x + 63.6733, y + 73.6129, x + 64.3918, y + 73.7303);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 67.0472, y + 74.3286);
ctx.bezierCurveTo(x + 67.8564, y + 74.4608, x + 68.6177, y + 73.9085, x + 68.748, y + 73.0966);
ctx.bezierCurveTo(x + 68.8782, y + 72.2846, x + 68.3268, y + 71.5189, x + 67.5179, y + 71.3876);
ctx.bezierCurveTo(x + 66.7087, y + 71.2553, x + 65.9468, y + 71.8074, x + 65.8175, y + 72.619);
ctx.bezierCurveTo(x + 65.6869, y + 73.4315, x + 66.2383, y + 74.1972, x + 67.0472, y + 74.3286);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 69.7551, y + 74.5991);
ctx.bezierCurveTo(x + 70.474, y + 74.716, x + 71.1503, y + 74.2264, x + 71.2663, y + 73.5049);
ctx.bezierCurveTo(x + 71.3814, y + 72.7836, x + 70.8917, y + 72.1035, x + 70.1729, y + 71.9867);
ctx.bezierCurveTo(x + 69.454, y + 71.8698, x + 68.7771, y + 72.359, x + 68.662, y + 73.0803);
ctx.bezierCurveTo(x + 68.5466, y + 73.8022, x + 69.0363, y + 74.4822, x + 69.7551, y + 74.5991);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 72.4554, y + 74.915);
ctx.bezierCurveTo(x + 73.1084, y + 75.0214, x + 73.7235, y + 74.5759, x + 73.8283, y + 73.9208);
ctx.bezierCurveTo(x + 73.9331, y + 73.2657, x + 73.4887, y + 72.6477, x + 72.8351, y + 72.541);
ctx.bezierCurveTo(x + 72.1816, y + 72.4343, x + 71.567, y + 72.8801, x + 71.4623, y + 73.5353);
ctx.bezierCurveTo(x + 71.3575, y + 74.1904, x + 71.8019, y + 74.8083, x + 72.4554, y + 74.915);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 75.1546, y + 75.2373);
ctx.bezierCurveTo(x + 75.7463, y + 75.3334, x + 76.3029, y + 74.9303, x + 76.3975, y + 74.3366);
ctx.bezierCurveTo(x + 76.4927, y + 73.7433, x + 76.09, y + 73.1838, x + 75.4987, y + 73.0871);
ctx.bezierCurveTo(x + 74.907, y + 72.9911, x + 74.3504, y + 73.3942, x + 74.2552, y + 73.9875);
ctx.bezierCurveTo(x + 74.1605, y + 74.5812, x + 74.5632, y + 75.1406, x + 75.1546, y + 75.2373);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 77.8558, y + 75.552);
ctx.bezierCurveTo(x + 78.3815, y + 75.6375, x + 78.8767, y + 75.2792, x + 78.9609, y + 74.7516);
ctx.bezierCurveTo(x + 79.0452, y + 74.2241, x + 78.6869, y + 73.7271, x + 78.1611, y + 73.6415);
ctx.bezierCurveTo(x + 77.6354, y + 73.5559, x + 77.1402, y + 73.9143, x + 77.0559, y + 74.4418);
ctx.bezierCurveTo(x + 76.9717, y + 74.9694, x + 77.33, y + 75.4664, x + 77.8558, y + 75.552);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 80.5644, y + 75.8151);
ctx.bezierCurveTo(x + 80.9958, y + 75.8854, x + 81.4018, y + 75.5915, x + 81.4705, y + 75.1583);
ctx.bezierCurveTo(x + 81.5397, y + 74.7255, x + 81.2461, y + 74.3174, x + 80.8147, y + 74.2471);
ctx.bezierCurveTo(x + 80.3834, y + 74.1767, x + 79.9773, y + 74.4707, x + 79.9081, y + 74.9035);
ctx.bezierCurveTo(x + 79.8397, y + 75.3376, x + 80.1331, y + 75.7447, x + 80.5644, y + 75.8151);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 83.2807, y + 76.0333);
ctx.bezierCurveTo(x + 83.5929, y + 76.0842, x + 83.887, y + 75.8714, x + 83.937, y + 75.5581);
ctx.bezierCurveTo(x + 83.9871, y + 75.2448, x + 83.7743, y + 74.9499, x + 83.462, y + 74.8991);
ctx.bezierCurveTo(x + 83.1498, y + 74.8483, x + 82.8557, y + 75.061, x + 82.8057, y + 75.3743);
ctx.bezierCurveTo(x + 82.756, y + 75.687, x + 82.9685, y + 75.9825, x + 83.2807, y + 76.0333);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 86.015, y + 76.1398);
ctx.bezierCurveTo(x + 86.1465, y + 76.1614, x + 86.2704, y + 76.0716, x + 86.2911, y + 75.9393);
ctx.bezierCurveTo(x + 86.3124, y + 75.8074, x + 86.2224, y + 75.6835, x + 86.0909, y + 75.6619);
ctx.bezierCurveTo(x + 85.9594, y + 75.6403, x + 85.8355, y + 75.73, x + 85.8145, y + 75.8613);
ctx.bezierCurveTo(x + 85.7935, y + 75.9942, x + 85.8835, y + 76.1181, x + 86.015, y + 76.1398);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 88.7214, y + 76.4174);
ctx.bezierCurveTo(x + 88.7665, y + 76.425, x + 88.8093, y + 76.3938, x + 88.8163, y + 76.3482);
ctx.bezierCurveTo(x + 88.8239, y + 76.3029, x + 88.7924, y + 76.2605, x + 88.7478, y + 76.2531);
ctx.bezierCurveTo(x + 88.7026, y + 76.2454, x + 88.6602, y + 76.276, x + 88.6526, y + 76.3213);
ctx.bezierCurveTo(x + 88.6453, y + 76.3676, x + 88.6759, y + 76.4103, x + 88.7214, y + 76.4174);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 35.9989, y + 70.6354);
ctx.bezierCurveTo(x + 36.0441, y + 70.6431, x + 36.0869, y + 70.6119, x + 36.0939, y + 70.5662);
ctx.bezierCurveTo(x + 36.1014, y + 70.5209, x + 36.0699, y + 70.4785, x + 36.0254, y + 70.4711);
ctx.bezierCurveTo(x + 35.9802, y + 70.4634, x + 35.9378, y + 70.494, x + 35.9302, y + 70.5394);
ctx.bezierCurveTo(x + 35.9226, y + 70.5847, x + 35.9538, y + 70.6277, x + 35.9989, y + 70.6354);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 38.6545, y + 71.2339);
ctx.bezierCurveTo(x + 38.7897, y + 71.256, x + 38.9174, y + 71.1636, x + 38.9395, y + 71.0274);
ctx.bezierCurveTo(x + 38.9617, y + 70.8911, x + 38.869, y + 70.7633, x + 38.7332, y + 70.7409);
ctx.bezierCurveTo(x + 38.5974, y + 70.7184, x + 38.4696, y + 70.8108, x + 38.4485, y + 70.9468);
ctx.bezierCurveTo(x + 38.4266, y + 71.0841, x + 38.5189, y + 71.2124, x + 38.6545, y + 71.2339);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 41.3278, y + 71.7207);
ctx.bezierCurveTo(x + 41.4924, y + 71.7473, x + 41.6468, y + 71.6355, x + 41.673, y + 71.4703);
ctx.bezierCurveTo(x + 41.6995, y + 71.3061, x + 41.5875, y + 71.1499, x + 41.4229, y + 71.1233);
ctx.bezierCurveTo(x + 41.2582, y + 71.0967, x + 41.1038, y + 71.2086, x + 41.077, y + 71.3734);
ctx.bezierCurveTo(x + 41.0514, y + 71.5389, x + 41.1631, y + 71.6941, x + 41.3278, y + 71.7207);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 43.9828, y + 72.3197);
ctx.bezierCurveTo(x + 44.2372, y + 72.3613, x + 44.4772, y + 72.1871, x + 44.5182, y + 71.9319);
ctx.bezierCurveTo(x + 44.5592, y + 71.6766, x + 44.3858, y + 71.4357, x + 44.1308, y + 71.3938);
ctx.bezierCurveTo(x + 43.8758, y + 71.3518, x + 43.6358, y + 71.526, x + 43.5958, y + 71.781);
ctx.bezierCurveTo(x + 43.555, y + 72.0371, x + 43.7285, y + 72.278, x + 43.9828, y + 72.3197);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 46.6414, y + 72.8962);
ctx.bezierCurveTo(x + 46.9741, y + 72.9504, x + 47.2871, y + 72.7236, x + 47.3406, y + 72.3898);
ctx.bezierCurveTo(x + 47.394, y + 72.056, x + 47.1674, y + 71.7414, x + 46.8347, y + 71.6871);
ctx.bezierCurveTo(x + 46.5021, y + 71.6329, x + 46.189, y + 71.8598, x + 46.1356, y + 72.1935);
ctx.bezierCurveTo(x + 46.0821, y + 72.5273, x + 46.3088, y + 72.8419, x + 46.6414, y + 72.8962);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 49.2674, y + 73.6818);
ctx.bezierCurveTo(x + 49.7931, y + 73.7674, x + 50.2883, y + 73.4091, x + 50.3726, y + 72.8815);
ctx.bezierCurveTo(x + 50.4568, y + 72.354, x + 50.0985, y + 71.857, x + 49.5727, y + 71.7714);
ctx.bezierCurveTo(x + 49.047, y + 71.6858, x + 48.5518, y + 72.0442, x + 48.4676, y + 72.5717);
ctx.bezierCurveTo(x + 48.3836, y + 73.0987, x + 48.741, y + 73.5959, x + 49.2674, y + 73.6818);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 51.9488, y + 74.1164);
ctx.bezierCurveTo(x + 52.4745, y + 74.202, x + 52.9697, y + 73.8436, x + 53.0539, y + 73.3161);
ctx.bezierCurveTo(x + 53.1382, y + 72.7886, x + 52.7799, y + 72.2915, x + 52.2541, y + 72.206);
ctx.bezierCurveTo(x + 51.7284, y + 72.1204, x + 51.2332, y + 72.4788, x + 51.149, y + 73.0063);
ctx.bezierCurveTo(x + 51.065, y + 73.5332, x + 51.4224, y + 74.0305, x + 51.9488, y + 74.1164);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 54.6307, y + 74.5507);
ctx.bezierCurveTo(x + 55.1564, y + 74.6363, x + 55.6516, y + 74.2779, x + 55.7358, y + 73.7504);
ctx.bezierCurveTo(x + 55.8201, y + 73.2229, x + 55.4624, y + 72.7262, x + 54.936, y + 72.6403);
ctx.bezierCurveTo(x + 54.4103, y + 72.5547, x + 53.9151, y + 72.9131, x + 53.8312, y + 73.44);
ctx.bezierCurveTo(x + 53.7466, y + 73.9682, x + 54.104, y + 74.4654, x + 54.6307, y + 74.5507);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 57.2996, y + 75.0599);
ctx.bezierCurveTo(x + 57.8661, y + 75.1523, x + 58.3999, y + 74.766, x + 58.4913, y + 74.1969);
ctx.bezierCurveTo(x + 58.5823, y + 73.6284, x + 58.1964, y + 73.0919, x + 57.6292, y + 72.9992);
ctx.bezierCurveTo(x + 57.0626, y + 72.9067, x + 56.5288, y + 73.2931, x + 56.4375, y + 73.8622);
ctx.bezierCurveTo(x + 56.3467, y + 74.4316, x + 56.7326, y + 74.9681, x + 57.2996, y + 75.0599);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 59.9634, y + 75.6071);
ctx.bezierCurveTo(x + 60.5916, y + 75.7093, x + 61.1836, y + 75.2812, x + 61.2845, y + 74.6503);
ctx.bezierCurveTo(x + 61.385, y + 74.02, x + 60.9571, y + 73.4256, x + 60.3289, y + 73.3235);
ctx.bezierCurveTo(x + 59.7001, y + 73.221, x + 59.1087, y + 73.6495, x + 59.0081, y + 74.2798);
ctx.bezierCurveTo(x + 58.9066, y + 74.9103, x + 59.3349, y + 75.5041, x + 59.9634, y + 75.6071);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 62.6303, y + 76.1314);
ctx.bezierCurveTo(x + 63.308, y + 76.242, x + 63.946, y + 75.7798, x + 64.0543, y + 75.0995);
ctx.bezierCurveTo(x + 64.1633, y + 74.4195, x + 63.7015, y + 73.7782, x + 63.0238, y + 73.6676);
ctx.bezierCurveTo(x + 62.3462, y + 73.557, x + 61.7081, y + 74.0192, x + 61.5998, y + 74.6996);
ctx.bezierCurveTo(x + 61.4914, y + 75.3799, x + 61.9526, y + 76.0208, x + 62.6303, y + 76.1314);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.3083, y + 76.5881);
ctx.bezierCurveTo(x + 65.9987, y + 76.7002, x + 66.6483, y + 76.23, x + 66.7587, y + 75.5373);
ctx.bezierCurveTo(x + 66.8698, y + 74.8449, x + 66.3997, y + 74.1927, x + 65.7091, y + 74.0796);
ctx.bezierCurveTo(x + 65.019, y + 73.9668, x + 64.3691, y + 74.4376, x + 64.259, y + 75.1297);
ctx.bezierCurveTo(x + 64.1482, y + 75.8231, x + 64.6182, y + 76.4753, x + 65.3083, y + 76.5881);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 67.9854, y + 77.0524);
ctx.bezierCurveTo(x + 68.6919, y + 77.1672, x + 69.3566, y + 76.6855, x + 69.4702, y + 75.977);
ctx.bezierCurveTo(x + 69.5832, y + 75.2681, x + 69.103, y + 74.5997, x + 68.3959, y + 74.4846);
ctx.bezierCurveTo(x + 67.6888, y + 74.3695, x + 67.0241, y + 74.8512, x + 66.9111, y + 75.5601);
ctx.bezierCurveTo(x + 66.7975, y + 76.2686, x + 67.2783, y + 76.9373, x + 67.9854, y + 77.0524);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 70.6631, y + 77.5098);
ctx.bezierCurveTo(x + 71.3819, y + 77.6267, x + 72.0582, y + 77.1371, x + 72.1743, y + 76.4155);
ctx.bezierCurveTo(x + 72.2894, y + 75.6942, x + 71.7997, y + 75.0142, x + 71.0808, y + 74.8973);
ctx.bezierCurveTo(x + 70.362, y + 74.7804, x + 69.6851, y + 75.2697, x + 69.57, y + 75.991);
ctx.bezierCurveTo(x + 69.4545, y + 76.7129, x + 69.9446, y + 77.3923, x + 70.6631, y + 77.5098);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 73.3638, y + 77.8249);
ctx.bezierCurveTo(x + 74.0174, y + 77.9316, x + 74.6319, y + 77.4858, x + 74.7367, y + 76.8307);
ctx.bezierCurveTo(x + 74.8414, y + 76.1756, x + 74.397, y + 75.5576, x + 73.7435, y + 75.4509);
ctx.bezierCurveTo(x + 73.0906, y + 75.3445, x + 72.4754, y + 75.79, x + 72.3706, y + 76.4451);
ctx.bezierCurveTo(x + 72.2659, y + 77.1003, x + 72.7103, y + 77.7182, x + 73.3638, y + 77.8249);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 76.0821, y + 78.0278);
ctx.bezierCurveTo(x + 76.6078, y + 78.1134, x + 77.103, y + 77.755, x + 77.1873, y + 77.2275);
ctx.bezierCurveTo(x + 77.2715, y + 76.6999, x + 76.9132, y + 76.2029, x + 76.3874, y + 76.1173);
ctx.bezierCurveTo(x + 75.8617, y + 76.0318, x + 75.3665, y + 76.3901, x + 75.2826, y + 76.917);
ctx.bezierCurveTo(x + 75.1983, y + 77.4446, x + 75.5563, y + 77.9422, x + 76.0821, y + 78.0278);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 78.8038, y + 78.2085);
ctx.bezierCurveTo(x + 79.19, y + 78.2711, x + 79.5533, y + 78.0084, x + 79.6153, y + 77.6203);
ctx.bezierCurveTo(x + 79.677, y + 77.2328, x + 79.4145, y + 76.8677, x + 79.0283, y + 76.8051);
ctx.bezierCurveTo(x + 78.6421, y + 76.7424, x + 78.2789, y + 77.0052, x + 78.2172, y + 77.3927);
ctx.bezierCurveTo(x + 78.1552, y + 77.7808, x + 78.4176, y + 78.1459, x + 78.8038, y + 78.2085);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 81.5007, y + 78.5465);
ctx.bezierCurveTo(x + 81.8334, y + 78.6007, x + 82.1464, y + 78.3738, x + 82.2002, y + 78.0395);
ctx.bezierCurveTo(x + 82.2536, y + 77.7057, x + 82.027, y + 77.3911, x + 81.6943, y + 77.3368);
ctx.bezierCurveTo(x + 81.3617, y + 77.2826, x + 81.0486, y + 77.5094, x + 80.9952, y + 77.8432);
ctx.bezierCurveTo(x + 80.9414, y + 78.1776, x + 81.168, y + 78.4922, x + 81.5007, y + 78.5465);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 84.2062, y + 78.8317);
ctx.bezierCurveTo(x + 84.4569, y + 78.8728, x + 84.6927, y + 78.7018, x + 84.7332, y + 78.4503);
ctx.bezierCurveTo(x + 84.7737, y + 78.1989, x + 84.6026, y + 77.9625, x + 84.352, y + 77.9213);
ctx.bezierCurveTo(x + 84.1013, y + 77.8802, x + 83.8655, y + 78.0511, x + 83.825, y + 78.3026);
ctx.bezierCurveTo(x + 83.7854, y + 78.5538, x + 83.9562, y + 78.7909, x + 84.2062, y + 78.8317);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 86.915, y + 79.0947);
ctx.bezierCurveTo(x + 87.0713, y + 79.1206, x + 87.2184, y + 79.0135, x + 87.2429, y + 78.857);
ctx.bezierCurveTo(x + 87.2681, y + 78.7008, x + 87.162, y + 78.5527, x + 87.0054, y + 78.5275);
ctx.bezierCurveTo(x + 86.8488, y + 78.5022, x + 86.7021, y + 78.6087, x + 86.6775, y + 78.7652);
ctx.bezierCurveTo(x + 86.653, y + 78.9217, x + 86.7594, y + 79.0692, x + 86.915, y + 79.0947);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 89.6302, y + 79.3205);
ctx.bezierCurveTo(x + 89.6711, y + 79.3274, x + 89.7097, y + 79.2994, x + 89.7168, y + 79.2579);
ctx.bezierCurveTo(x + 89.7236, y + 79.2169, x + 89.6956, y + 79.1781, x + 89.6548, y + 79.1712);
ctx.bezierCurveTo(x + 89.614, y + 79.1643, x + 89.575, y + 79.1929, x + 89.5682, y + 79.2339);
ctx.bezierCurveTo(x + 89.5615, y + 79.2749, x + 89.5894, y + 79.3137, x + 89.6302, y + 79.3205);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 36.9098, y + 73.5309);
ctx.bezierCurveTo(x + 36.9469, y + 73.5373, x + 36.9811, y + 73.5116, x + 36.9874, y + 73.4744);
ctx.bezierCurveTo(x + 36.9933, y + 73.4378, x + 36.9684, y + 73.4022, x + 36.9315, y + 73.3968);
ctx.bezierCurveTo(x + 36.8944, y + 73.3904, x + 36.8603, y + 73.4161, x + 36.854, y + 73.4533);
ctx.bezierCurveTo(x + 36.8474, y + 73.4896, x + 36.8727, y + 73.5245, x + 36.9098, y + 73.5309);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 39.5696, y + 74.0997);
ctx.bezierCurveTo(x + 39.6807, y + 74.1179, x + 39.785, y + 74.0419, x + 39.8029, y + 73.9305);
ctx.bezierCurveTo(x + 39.8205, y + 73.8196, x + 39.7456, y + 73.7146, x + 39.6345, y + 73.6964);
ctx.bezierCurveTo(x + 39.5234, y + 73.6782, x + 39.4191, y + 73.7541, x + 39.4016, y + 73.865);
ctx.bezierCurveTo(x + 39.3836, y + 73.9764, x + 39.4585, y + 74.0815, x + 39.5696, y + 74.0997);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 42.236, y + 74.6309);
ctx.bezierCurveTo(x + 42.4003, y + 74.6581, x + 42.555, y + 74.5456, x + 42.5812, y + 74.3805);
ctx.bezierCurveTo(x + 42.6077, y + 74.2162, x + 42.4957, y + 74.06, x + 42.3311, y + 74.0335);
ctx.bezierCurveTo(x + 42.1664, y + 74.0069, x + 42.012, y + 74.1187, x + 41.9856, y + 74.2829);
ctx.bezierCurveTo(x + 41.9597, y + 74.4491, x + 42.0713, y + 74.6043, x + 42.236, y + 74.6309);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 44.88, y + 75.2973);
ctx.bezierCurveTo(x + 45.1718, y + 75.3446, x + 45.4459, y + 75.1464, x + 45.4925, y + 74.8536);
ctx.bezierCurveTo(x + 45.5392, y + 74.5608, x + 45.3411, y + 74.2852, x + 45.0493, y + 74.2379);
ctx.bezierCurveTo(x + 44.7575, y + 74.1905, x + 44.483, y + 74.3894, x + 44.4367, y + 74.6816);
ctx.bezierCurveTo(x + 44.3894, y + 74.974, x + 44.5885, y + 75.2493, x + 44.88, y + 75.2973);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 47.5495, y + 75.8067);
ctx.bezierCurveTo(x + 47.8822, y + 75.861, x + 48.1952, y + 75.6341, x + 48.249, y + 75.2997);
ctx.bezierCurveTo(x + 48.3024, y + 74.9659, x + 48.0758, y + 74.6513, x + 47.7432, y + 74.5971);
ctx.bezierCurveTo(x + 47.4105, y + 74.5428, x + 47.0974, y + 74.7697, x + 47.044, y + 75.1034);
ctx.bezierCurveTo(x + 46.9902, y + 75.4378, x + 47.2169, y + 75.7525, x + 47.5495, y + 75.8067);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 50.1846, y + 76.5323);
ctx.bezierCurveTo(x + 50.6775, y + 76.6123, x + 51.1412, y + 76.2762, x + 51.2206, y + 75.7819);
ctx.bezierCurveTo(x + 51.2994, y + 75.2873, x + 50.9637, y + 74.8213, x + 50.471, y + 74.7407);
ctx.bezierCurveTo(x + 49.9781, y + 74.6607, x + 49.5138, y + 74.9964, x + 49.4351, y + 75.491);
ctx.bezierCurveTo(x + 49.3563, y + 75.9857, x + 49.6916, y + 76.4522, x + 50.1846, y + 76.5323);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 52.8637, y + 76.9816);
ctx.bezierCurveTo(x + 53.3653, y + 77.0633, x + 53.8366, y + 76.7219, x + 53.9171, y + 76.2186);
ctx.bezierCurveTo(x + 53.9971, y + 75.7159, x + 53.6562, y + 75.2422, x + 53.1549, y + 75.1599);
ctx.bezierCurveTo(x + 52.6533, y + 75.0783, x + 52.1819, y + 75.4196, x + 52.1019, y + 75.9223);
ctx.bezierCurveTo(x + 52.0211, y + 76.4262, x + 52.3621, y + 76.8999, x + 52.8637, y + 76.9816);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 55.5428, y + 77.4317);
ctx.bezierCurveTo(x + 56.0525, y + 77.5147, x + 56.5318, y + 77.1675, x + 56.6135, y + 76.6561);
ctx.bezierCurveTo(x + 56.6949, y + 76.1453, x + 56.3487, y + 75.6639, x + 55.839, y + 75.5809);
ctx.bezierCurveTo(x + 55.3293, y + 75.498, x + 54.8503, y + 75.8445, x + 54.7686, y + 76.3559);
ctx.bezierCurveTo(x + 54.6866, y + 76.8664, x + 55.0335, y + 77.3482, x + 55.5428, y + 77.4317);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 58.2223, y + 77.8804);
ctx.bezierCurveTo(x + 58.74, y + 77.9647, x + 59.2271, y + 77.6122, x + 59.3101, y + 77.0927);
ctx.bezierCurveTo(x + 59.3931, y + 76.5733, x + 59.041, y + 76.0837, x + 58.5233, y + 75.9995);
ctx.bezierCurveTo(x + 58.0056, y + 75.9152, x + 57.5191, y + 76.268, x + 57.4355, y + 76.7871);
ctx.bezierCurveTo(x + 57.3525, y + 77.3066, x + 57.7046, y + 77.7961, x + 58.2223, y + 77.8804);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 60.9012, y + 78.3298);
ctx.bezierCurveTo(x + 61.4269, y + 78.4154, x + 61.9221, y + 78.057, x + 62.0063, y + 77.5295);
ctx.bezierCurveTo(x + 62.0906, y + 77.0019, x + 61.7323, y + 76.5049, x + 61.2065, y + 76.4193);
ctx.bezierCurveTo(x + 60.6808, y + 76.3338, x + 60.1856, y + 76.6921, x + 60.1014, y + 77.2197);
ctx.bezierCurveTo(x + 60.0171, y + 77.7472, x + 60.3754, y + 78.2442, x + 60.9012, y + 78.3298);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 63.5644, y + 78.8767);
ctx.bezierCurveTo(x + 64.1517, y + 78.972, x + 64.7051, y + 78.5718, x + 64.7989, y + 77.9825);
ctx.bezierCurveTo(x + 64.8933, y + 77.3935, x + 64.4932, y + 76.838, x + 63.9056, y + 76.7418);
ctx.bezierCurveTo(x + 63.3183, y + 76.6465, x + 62.7649, y + 77.0466, x + 62.6711, y + 77.636);
ctx.bezierCurveTo(x + 62.5773, y + 78.2253, x + 62.9774, y + 78.7809, x + 63.5644, y + 78.8767);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 66.2532, y + 79.2668);
ctx.bezierCurveTo(x + 66.8161, y + 79.3588, x + 67.3454, y + 78.9748, x + 67.4359, y + 78.41);
ctx.bezierCurveTo(x + 67.5265, y + 77.8452, x + 67.1429, y + 77.3133, x + 66.5806, y + 77.2216);
ctx.bezierCurveTo(x + 66.0177, y + 77.1297, x + 65.4884, y + 77.5137, x + 65.3982, y + 78.0779);
ctx.bezierCurveTo(x + 65.3077, y + 78.6426, x + 65.6903, y + 79.1749, x + 66.2532, y + 79.2668);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 68.9109, y + 79.8507);
ctx.bezierCurveTo(x + 69.5558, y + 79.9557, x + 70.1629, y + 79.5161, x + 70.2664, y + 78.8691);
ctx.bezierCurveTo(x + 70.3698, y + 78.222, x + 69.9304, y + 77.6124, x + 69.2855, y + 77.5074);
ctx.bezierCurveTo(x + 68.6406, y + 77.4023, x + 68.0335, y + 77.8419, x + 67.93, y + 78.489);
ctx.bezierCurveTo(x + 67.8269, y + 79.1354, x + 68.266, y + 79.7456, x + 68.9109, y + 79.8507);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 71.6327, y + 80.0314);
ctx.bezierCurveTo(x + 72.138, y + 80.1135, x + 72.6132, y + 79.7695, x + 72.6944, y + 79.2619);
ctx.bezierCurveTo(x + 72.7753, y + 78.7549, x + 72.4317, y + 78.2773, x + 71.9264, y + 78.1951);
ctx.bezierCurveTo(x + 71.421, y + 78.113, x + 70.9458, y + 78.4569, x + 70.865, y + 78.964);
ctx.bezierCurveTo(x + 70.7837, y + 79.4716, x + 71.1273, y + 79.9492, x + 71.6327, y + 80.0314);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.3316, y + 80.3615);
ctx.bezierCurveTo(x + 74.779, y + 80.4345, x + 75.2008, y + 80.1294, x + 75.2724, y + 79.6794);
ctx.bezierCurveTo(x + 75.3442, y + 79.2305, x + 75.0394, y + 78.8066, x + 74.592, y + 78.7336);
ctx.bezierCurveTo(x + 74.1445, y + 78.6607, x + 73.7227, y + 78.9658, x + 73.6509, y + 79.4148);
ctx.bezierCurveTo(x + 73.579, y + 79.8653, x + 73.8832, y + 80.2889, x + 74.3316, y + 80.3615);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 77.0461, y + 80.587);
ctx.bezierCurveTo(x + 77.3788, y + 80.6413, x + 77.6918, y + 80.4144, x + 77.7456, y + 80.08);
ctx.bezierCurveTo(x + 77.799, y + 79.7462, x + 77.5724, y + 79.4316, x + 77.2397, y + 79.3773);
ctx.bezierCurveTo(x + 76.9071, y + 79.3231, x + 76.594, y + 79.55, x + 76.5406, y + 79.8837);
ctx.bezierCurveTo(x + 76.4868, y + 80.2181, x + 76.7131, y + 80.5334, x + 77.0461, y + 80.587);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 79.743, y + 80.9249);
ctx.bezierCurveTo(x + 80.0224, y + 80.9702, x + 80.2846, y + 80.7804, x + 80.3301, y + 80.4998);
ctx.bezierCurveTo(x + 80.3747, y + 80.2194, x + 80.1845, y + 79.9555, x + 79.9051, y + 79.9103);
ctx.bezierCurveTo(x + 79.6256, y + 79.865, x + 79.3628, y + 80.0544, x + 79.3179, y + 80.3354);
ctx.bezierCurveTo(x + 79.2737, y + 80.6152, x + 79.4639, y + 80.8791, x + 79.743, y + 80.9249);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 82.4581, y + 81.1507);
ctx.bezierCurveTo(x + 82.6227, y + 81.1773, x + 82.7772, y + 81.0655, x + 82.8033, y + 80.9003);
ctx.bezierCurveTo(x + 82.8298, y + 80.7361, x + 82.7178, y + 80.5799, x + 82.5532, y + 80.5533);
ctx.bezierCurveTo(x + 82.3885, y + 80.5267, x + 82.2341, y + 80.6385, x + 82.2083, y + 80.8031);
ctx.bezierCurveTo(x + 82.1815, y + 80.968, x + 82.2938, y + 81.1235, x + 82.4581, y + 81.1507);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 85.1621, y + 81.4429);
ctx.bezierCurveTo(x + 85.2484, y + 81.4568, x + 85.3295, y + 81.3983, x + 85.3435, y + 81.311);
ctx.bezierCurveTo(x + 85.3573, y + 81.2244, x + 85.2988, y + 81.1429, x + 85.2125, y + 81.129);
ctx.bezierCurveTo(x + 85.1261, y + 81.115, x + 85.045, y + 81.1736, x + 85.0313, y + 81.2602);
ctx.bezierCurveTo(x + 85.0172, y + 81.3475, x + 85.0763, y + 81.4293, x + 85.1621, y + 81.4429);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 87.8652, y + 81.7436);
ctx.bezierCurveTo(x + 87.8776, y + 81.7457, x + 87.8889, y + 81.7369, x + 87.891, y + 81.7244);
ctx.bezierCurveTo(x + 87.8931, y + 81.712, x + 87.8845, y + 81.7001, x + 87.8718, y + 81.6985);
ctx.bezierCurveTo(x + 87.8594, y + 81.6964, x + 87.8482, y + 81.7053, x + 87.8461, y + 81.7177);
ctx.bezierCurveTo(x + 87.8449, y + 81.7299, x + 87.8528, y + 81.7415, x + 87.8652, y + 81.7436);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 40.5061, y + 76.8305);
ctx.bezierCurveTo(x + 40.5184, y + 76.8326, x + 40.5297, y + 76.8238, x + 40.5318, y + 76.8114);
ctx.bezierCurveTo(x + 40.5339, y + 76.7989, x + 40.5254, y + 76.787, x + 40.5127, y + 76.7855);
ctx.bezierCurveTo(x + 40.5003, y + 76.7833, x + 40.489, y + 76.7922, x + 40.4869, y + 76.8046);
ctx.bezierCurveTo(x + 40.4858, y + 76.8168, x + 40.4937, y + 76.8284, x + 40.5061, y + 76.8305);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 43.1779, y + 77.3246);
ctx.bezierCurveTo(x + 43.2231, y + 77.3323, x + 43.2659, y + 77.3011, x + 43.2728, y + 77.2554);
ctx.bezierCurveTo(x + 43.2798, y + 77.2098, x + 43.2489, y + 77.1677, x + 43.2043, y + 77.1603);
ctx.bezierCurveTo(x + 43.1592, y + 77.1526, x + 43.1167, y + 77.1832, x + 43.1091, y + 77.2286);
ctx.bezierCurveTo(x + 43.1022, y + 77.2742, x + 43.1333, y + 77.3172, x + 43.1779, y + 77.3246);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 45.8248, y + 77.9759);
ctx.bezierCurveTo(x + 45.9895, y + 78.0024, x + 46.1439, y + 77.8906, x + 46.1701, y + 77.7254);
ctx.bezierCurveTo(x + 46.1965, y + 77.5612, x + 46.0846, y + 77.405, x + 45.9199, y + 77.3784);
ctx.bezierCurveTo(x + 45.7553, y + 77.3519, x + 45.6009, y + 77.4637, x + 45.5744, y + 77.6279);
ctx.bezierCurveTo(x + 45.5488, y + 77.7935, x + 45.6605, y + 77.9487, x + 45.8248, y + 77.9759);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 48.4909, y + 78.5074);
ctx.bezierCurveTo(x + 48.7087, y + 78.543, x + 48.9134, y + 78.3937, x + 48.9481, y + 78.1758);
ctx.bezierCurveTo(x + 48.9828, y + 77.9578, x + 48.835, y + 77.7512, x + 48.6171, y + 77.7156);
ctx.bezierCurveTo(x + 48.3993, y + 77.6801, x + 48.1946, y + 77.8293, x + 48.1593, y + 78.0469);
ctx.bezierCurveTo(x + 48.1249, y + 78.2659, x + 48.273, y + 78.4718, x + 48.4909, y + 78.5074);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 51.1391, y + 79.1514);
ctx.bezierCurveTo(x + 51.4718, y + 79.2057, x + 51.7848, y + 78.9788, x + 51.8386, y + 78.6444);
ctx.bezierCurveTo(x + 51.892, y + 78.3107, x + 51.6654, y + 77.996, x + 51.3327, y + 77.9418);
ctx.bezierCurveTo(x + 51.0001, y + 77.8875, x + 50.687, y + 78.1144, x + 50.6336, y + 78.4482);
ctx.bezierCurveTo(x + 50.5799, y + 78.7826, x + 50.8065, y + 79.0972, x + 51.1391, y + 79.1514);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 53.8208, y + 79.5863);
ctx.bezierCurveTo(x + 54.1534, y + 79.6405, x + 54.4665, y + 79.4136, x + 54.5202, y + 79.0793);
ctx.bezierCurveTo(x + 54.5737, y + 78.7455, x + 54.347, y + 78.4309, x + 54.0144, y + 78.3766);
ctx.bezierCurveTo(x + 53.6817, y + 78.3223, x + 53.3687, y + 78.5492, x + 53.3153, y + 78.883);
ctx.bezierCurveTo(x + 53.2618, y + 79.2168, x + 53.4881, y + 79.532, x + 53.8208, y + 79.5863);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 56.5019, y + 80.0201);
ctx.bezierCurveTo(x + 56.8346, y + 80.0743, x + 57.1476, y + 79.8475, x + 57.2014, y + 79.5131);
ctx.bezierCurveTo(x + 57.2548, y + 79.1793, x + 57.0282, y + 78.8647, x + 56.6955, y + 78.8104);
ctx.bezierCurveTo(x + 56.3629, y + 78.7562, x + 56.0498, y + 78.983, x + 55.9964, y + 79.3168);
ctx.bezierCurveTo(x + 55.9433, y + 79.6515, x + 56.1693, y + 79.9658, x + 56.5019, y + 80.0201);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 59.1679, y + 80.5518);
ctx.bezierCurveTo(x + 59.5541, y + 80.6144, x + 59.9173, y + 80.3517, x + 59.9793, y + 79.9635);
ctx.bezierCurveTo(x + 60.041, y + 79.576, x + 59.7785, y + 79.211, x + 59.3923, y + 79.1483);
ctx.bezierCurveTo(x + 59.0061, y + 79.0857, x + 58.6429, y + 79.3484, x + 58.5812, y + 79.7359);
ctx.bezierCurveTo(x + 58.5192, y + 80.1241, x + 58.7817, y + 80.4891, x + 59.1679, y + 80.5518);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 61.8331, y + 81.0909);
ctx.bezierCurveTo(x + 62.2769, y + 81.1633, x + 62.6942, y + 80.8605, x + 62.7655, y + 80.4153);
ctx.bezierCurveTo(x + 62.8365, y + 79.9706, x + 62.535, y + 79.551, x + 62.0913, y + 79.4785);
ctx.bezierCurveTo(x + 61.6475, y + 79.4061, x + 61.2302, y + 79.7089, x + 61.1592, y + 80.1535);
ctx.bezierCurveTo(x + 61.0875, y + 80.5993, x + 61.389, y + 81.019, x + 61.8331, y + 81.0909);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 64.518, y + 81.5035);
ctx.bezierCurveTo(x + 64.9494, y + 81.5739, x + 65.3554, y + 81.2799, x + 65.4241, y + 80.8468);
ctx.bezierCurveTo(x + 65.4933, y + 80.4139, x + 65.1997, y + 80.0059, x + 64.7683, y + 79.9355);
ctx.bezierCurveTo(x + 64.337, y + 79.8652, x + 63.9309, y + 80.1592, x + 63.8617, y + 80.592);
ctx.bezierCurveTo(x + 63.793, y + 81.0251, x + 64.0867, y + 81.4332, x + 64.518, y + 81.5035);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 67.2017, y + 81.9228);
ctx.bezierCurveTo(x + 67.625, y + 81.9918, x + 68.023, y + 81.7037, x + 68.091, y + 81.279);
ctx.bezierCurveTo(x + 68.159, y + 80.8542, x + 67.8703, y + 80.4545, x + 67.4475, y + 80.3858);
ctx.bezierCurveTo(x + 67.0242, y + 80.3168, x + 66.6262, y + 80.6048, x + 66.5583, y + 81.0296);
ctx.bezierCurveTo(x + 66.4906, y + 81.4537, x + 66.779, y + 81.8541, x + 67.2017, y + 81.9228);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 69.8776, y + 82.3951);
ctx.bezierCurveTo(x + 70.3213, y + 82.4675, x + 70.7386, y + 82.1647, x + 70.81, y + 81.7195);
ctx.bezierCurveTo(x + 70.881, y + 81.2748, x + 70.5794, y + 80.8552, x + 70.1357, y + 80.7827);
ctx.bezierCurveTo(x + 69.692, y + 80.7103, x + 69.2746, y + 81.013, x + 69.2036, y + 81.4577);
ctx.bezierCurveTo(x + 69.1323, y + 81.9029, x + 69.4338, y + 82.3226, x + 69.8776, y + 82.3951);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 72.5347, y + 82.9787);
ctx.bezierCurveTo(x + 73.0605, y + 83.0643, x + 73.5556, y + 82.7059, x + 73.6399, y + 82.1784);
ctx.bezierCurveTo(x + 73.7241, y + 81.6509, x + 73.3658, y + 81.1538, x + 72.8401, y + 81.0683);
ctx.bezierCurveTo(x + 72.3143, y + 80.9827, x + 71.8192, y + 81.3411, x + 71.7352, y + 81.868);
ctx.bezierCurveTo(x + 71.651, y + 82.3955, x + 72.009, y + 82.8932, x + 72.5347, y + 82.9787);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 75.2727, y + 83.0628);
ctx.bezierCurveTo(x + 75.6053, y + 83.1171, x + 75.9184, y + 82.8902, x + 75.9722, y + 82.5558);
ctx.bezierCurveTo(x + 76.0256, y + 82.222, x + 75.799, y + 81.9074, x + 75.4663, y + 81.8532);
ctx.bezierCurveTo(x + 75.1337, y + 81.7989, x + 74.8206, y + 82.0258, x + 74.7672, y + 82.3595);
ctx.bezierCurveTo(x + 74.7134, y + 82.6939, x + 74.94, y + 83.0086, x + 75.2727, y + 83.0628);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 77.9659, y + 83.4229);
ctx.bezierCurveTo(x + 78.2577, y + 83.4703, x + 78.5319, y + 83.272, x + 78.5785, y + 82.9792);
ctx.bezierCurveTo(x + 78.6252, y + 82.6864, x + 78.4271, y + 82.4109, x + 78.1353, y + 82.3635);
ctx.bezierCurveTo(x + 77.8435, y + 82.3161, x + 77.569, y + 82.515, x + 77.5221, y + 82.8069);
ctx.bezierCurveTo(x + 77.4758, y + 83.0991, x + 77.6745, y + 83.3749, x + 77.9659, y + 83.4229);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 80.6845, y + 83.6255);
ctx.bezierCurveTo(x + 80.8491, y + 83.6521, x + 81.0035, y + 83.5403, x + 81.0297, y + 83.3751);
ctx.bezierCurveTo(x + 81.0562, y + 83.2108, x + 80.9442, y + 83.0547, x + 80.7795, y + 83.0281);
ctx.bezierCurveTo(x + 80.6149, y + 83.0015, x + 80.4605, y + 83.1133, x + 80.434, y + 83.2776);
ctx.bezierCurveTo(x + 80.4085, y + 83.4431, x + 80.5198, y + 83.5989, x + 80.6845, y + 83.6255);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 83.3913, y + 83.9036);
ctx.bezierCurveTo(x + 83.469, y + 83.9159, x + 83.543, y + 83.863, x + 83.5555, y + 83.7844);
ctx.bezierCurveTo(x + 83.5679, y + 83.7058, x + 83.5147, y + 83.6321, x + 83.4364, y + 83.6195);
ctx.bezierCurveTo(x + 83.3581, y + 83.6068, x + 83.2847, y + 83.6601, x + 83.2726, y + 83.7381);
ctx.bezierCurveTo(x + 83.2598, y + 83.8172, x + 83.313, y + 83.8909, x + 83.3913, y + 83.9036);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 86.0905, y + 84.226);
ctx.bezierCurveTo(x + 86.1066, y + 84.2286, x + 86.1223, y + 84.2175, x + 86.1249, y + 84.2013);
ctx.bezierCurveTo(x + 86.1275, y + 84.1852, x + 86.1163, y + 84.1693, x + 86.1002, y + 84.1667);
ctx.bezierCurveTo(x + 86.0841, y + 84.1641, x + 86.0684, y + 84.1753, x + 86.0658, y + 84.1914);
ctx.bezierCurveTo(x + 86.0629, y + 84.2082, x + 86.0741, y + 84.224, x + 86.0905, y + 84.226);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 41.4163, y + 79.7268);
ctx.bezierCurveTo(x + 41.4209, y + 79.7277, x + 41.425, y + 79.7249, x + 41.4258, y + 79.7203);
ctx.bezierCurveTo(x + 41.4263, y + 79.7163, x + 41.4235, y + 79.7123, x + 41.419, y + 79.7114);
ctx.bezierCurveTo(x + 41.4144, y + 79.7105, x + 41.4103, y + 79.7133, x + 41.4095, y + 79.7179);
ctx.bezierCurveTo(x + 41.409, y + 79.7218, x + 41.4118, y + 79.7259, x + 41.4163, y + 79.7268);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 44.086, y + 80.2347);
ctx.bezierCurveTo(x + 44.1312, y + 80.2424, x + 44.174, y + 80.2112, x + 44.181, y + 80.1655);
ctx.bezierCurveTo(x + 44.1885, y + 80.1202, x + 44.157, y + 80.0778, x + 44.1125, y + 80.0705);
ctx.bezierCurveTo(x + 44.0679, y + 80.0631, x + 44.0249, y + 80.0933, x + 44.0173, y + 80.1387);
ctx.bezierCurveTo(x + 44.01, y + 80.1849, x + 44.0405, y + 80.2276, x + 44.086, y + 80.2347);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 46.7331, y + 80.8858);
ctx.bezierCurveTo(x + 46.8977, y + 80.9123, x + 47.0521, y + 80.8005, x + 47.0783, y + 80.6353);
ctx.bezierCurveTo(x + 47.1047, y + 80.4711, x + 46.9928, y + 80.3149, x + 46.8281, y + 80.2883);
ctx.bezierCurveTo(x + 46.6635, y + 80.2618, x + 46.5091, y + 80.3736, x + 46.4826, y + 80.5378);
ctx.bezierCurveTo(x + 46.4571, y + 80.7033, x + 46.5684, y + 80.8592, x + 46.7331, y + 80.8858);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 49.4208, y + 81.2834);
ctx.bezierCurveTo(x + 49.5647, y + 81.3071, x + 49.6999, y + 81.2085, x + 49.7233, y + 81.0641);
ctx.bezierCurveTo(x + 49.7467, y + 80.9197, x + 49.6481, y + 80.7839, x + 49.5049, y + 80.7605);
ctx.bezierCurveTo(x + 49.361, y + 80.7367, x + 49.2258, y + 80.8353, x + 49.2028, y + 80.9791);
ctx.bezierCurveTo(x + 49.179, y + 81.1241, x + 49.2766, y + 81.2602, x + 49.4208, y + 81.2834);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 52.0814, y + 81.8448);
ctx.bezierCurveTo(x + 52.2949, y + 81.8796, x + 52.496, y + 81.7339, x + 52.5303, y + 81.5197);
ctx.bezierCurveTo(x + 52.5645, y + 81.3054, x + 52.419, y + 81.1033, x + 52.2054, y + 81.0686);
ctx.bezierCurveTo(x + 51.9919, y + 81.0338, x + 51.7908, y + 81.1795, x + 51.7566, y + 81.3937);
ctx.bezierCurveTo(x + 51.7224, y + 81.608, x + 51.8679, y + 81.8101, x + 52.0814, y + 81.8448);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 54.7557, y + 82.3242);
ctx.bezierCurveTo(x + 54.9939, y + 82.3632, x + 55.2179, y + 82.2008, x + 55.2566, y + 81.9611);
ctx.bezierCurveTo(x + 55.295, y + 81.722, x + 55.1328, y + 81.497, x + 54.8945, y + 81.458);
ctx.bezierCurveTo(x + 54.6563, y + 81.419, x + 54.4317, y + 81.581, x + 54.3939, y + 81.8205);
ctx.bezierCurveTo(x + 54.3551, y + 82.0601, x + 54.5174, y + 82.2852, x + 54.7557, y + 82.3242);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 57.4145, y + 82.9006);
ctx.bezierCurveTo(x + 57.731, y + 82.9522, x + 58.0283, y + 82.7365, x + 58.0792, y + 82.4189);
ctx.bezierCurveTo(x + 58.1297, y + 82.1019, x + 57.9146, y + 81.8025, x + 57.598, y + 81.7508);
ctx.bezierCurveTo(x + 57.2815, y + 81.6992, x + 56.9842, y + 81.9149, x + 56.9333, y + 82.2325);
ctx.bezierCurveTo(x + 56.8834, y + 82.5499, x + 57.0985, y + 82.8493, x + 57.4145, y + 82.9006);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 60.0916, y + 83.3649);
ctx.bezierCurveTo(x + 60.4243, y + 83.4192, x + 60.7373, y + 83.1923, x + 60.7908, y + 82.8586);
ctx.bezierCurveTo(x + 60.8442, y + 82.5248, x + 60.6176, y + 82.2101, x + 60.2849, y + 82.1559);
ctx.bezierCurveTo(x + 59.9522, y + 82.1016, x + 59.6392, y + 82.3285, x + 59.5858, y + 82.6623);
ctx.bezierCurveTo(x + 59.5323, y + 82.9961, x + 59.759, y + 83.3107, x + 60.0916, y + 83.3649);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 62.7755, y + 83.7852);
ctx.bezierCurveTo(x + 63.1001, y + 83.8381, x + 63.4051, y + 83.6171, x + 63.4576, y + 83.2908);
ctx.bezierCurveTo(x + 63.5098, y + 82.9651, x + 63.2884, y + 82.6582, x + 62.9644, y + 82.6056);
ctx.bezierCurveTo(x + 62.6398, y + 82.5527, x + 62.3348, y + 82.7736, x + 62.2826, y + 83.0993);
ctx.bezierCurveTo(x + 62.2295, y + 83.4253, x + 62.4509, y + 83.7322, x + 62.7755, y + 83.7852);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.4594, y + 84.2043);
ctx.bezierCurveTo(x + 65.7754, y + 84.2556, x + 66.0733, y + 84.0402, x + 66.1241, y + 83.7226);
ctx.bezierCurveTo(x + 66.1747, y + 83.4056, x + 65.9595, y + 83.1062, x + 65.643, y + 83.0545);
ctx.bezierCurveTo(x + 65.3264, y + 83.0029, x + 65.0291, y + 83.2186, x + 64.9786, y + 83.5356);
ctx.bezierCurveTo(x + 64.9277, y + 83.8532, x + 65.1429, y + 84.1526, x + 65.4594, y + 84.2043);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 68.1437, y + 84.6238);
ctx.bezierCurveTo(x + 68.4516, y + 84.6738, x + 68.7415, y + 84.4643, x + 68.791, y + 84.1548);
ctx.bezierCurveTo(x + 68.8403, y + 83.8458, x + 68.631, y + 83.5545, x + 68.3225, y + 83.5042);
ctx.bezierCurveTo(x + 68.014, y + 83.4538, x + 67.7244, y + 83.6643, x + 67.6745, y + 83.9729);
ctx.bezierCurveTo(x + 67.625, y + 84.2824, x + 67.8352, y + 84.5735, x + 68.1437, y + 84.6238);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 70.8175, y + 85.104);
ctx.bezierCurveTo(x + 71.1501, y + 85.1582, x + 71.4632, y + 84.9314, x + 71.5166, y + 84.5976);
ctx.bezierCurveTo(x + 71.57, y + 84.2638, x + 71.3434, y + 83.9492, x + 71.0107, y + 83.8949);
ctx.bezierCurveTo(x + 70.6781, y + 83.8407, x + 70.365, y + 84.0675, x + 70.3116, y + 84.4013);
ctx.bezierCurveTo(x + 70.2582, y + 84.7351, x + 70.4848, y + 85.0497, x + 70.8175, y + 85.104);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 73.5148, y + 85.4414);
ctx.bezierCurveTo(x + 73.7942, y + 85.4866, x + 74.0574, y + 85.2966, x + 74.102, y + 85.0162);
ctx.bezierCurveTo(x + 74.1465, y + 84.7358, x + 73.9563, y + 84.4719, x + 73.6772, y + 84.426);
ctx.bezierCurveTo(x + 73.3978, y + 84.3808, x + 73.1346, y + 84.5708, x + 73.0901, y + 84.8512);
ctx.bezierCurveTo(x + 73.0449, y + 85.1313, x + 73.2354, y + 85.3961, x + 73.5148, y + 85.4414);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 76.2294, y + 85.6668);
ctx.bezierCurveTo(x + 76.394, y + 85.6933, x + 76.5485, y + 85.5815, x + 76.5746, y + 85.4163);
ctx.bezierCurveTo(x + 76.6011, y + 85.2521, x + 76.4891, y + 85.0959, x + 76.3245, y + 85.0693);
ctx.bezierCurveTo(x + 76.1598, y + 85.0428, x + 76.0054, y + 85.1546, x + 75.979, y + 85.3188);
ctx.bezierCurveTo(x + 75.9534, y + 85.4844, x + 76.0651, y + 85.6396, x + 76.2294, y + 85.6668);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 78.9227, y + 86.0267);
ctx.bezierCurveTo(x + 79.0456, y + 86.0467, x + 79.162, y + 85.9631, x + 79.182, y + 85.8393);
ctx.bezierCurveTo(x + 79.2017, y + 85.716, x + 79.1173, y + 85.5992, x + 78.9945, y + 85.5793);
ctx.bezierCurveTo(x + 78.8716, y + 85.5593, x + 78.7552, y + 85.6428, x + 78.7352, y + 85.7667);
ctx.bezierCurveTo(x + 78.7155, y + 85.8899, x + 78.7999, y + 86.0067, x + 78.9227, y + 86.0267);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 81.6365, y + 86.2596);
ctx.bezierCurveTo(x + 81.6489, y + 86.2618, x + 81.6608, y + 86.2532, x + 81.6623, y + 86.2405);
ctx.bezierCurveTo(x + 81.6644, y + 86.2281, x + 81.6559, y + 86.2161, x + 81.6435, y + 86.214);
ctx.bezierCurveTo(x + 81.6311, y + 86.2119, x + 81.6192, y + 86.2204, x + 81.6177, y + 86.2331);
ctx.bezierCurveTo(x + 81.6162, y + 86.2459, x + 81.6242, y + 86.2575, x + 81.6365, y + 86.2596);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 47.6759, y + 83.5794);
ctx.bezierCurveTo(x + 47.7211, y + 83.5871, x + 47.7638, y + 83.5559, x + 47.7708, y + 83.5102);
ctx.bezierCurveTo(x + 47.7784, y + 83.4649, x + 47.7469, y + 83.4225, x + 47.7023, y + 83.4152);
ctx.bezierCurveTo(x + 47.6578, y + 83.4078, x + 47.6147, y + 83.4381, x + 47.6071, y + 83.4834);
ctx.bezierCurveTo(x + 47.5992, y + 83.5293, x + 47.6304, y + 83.5724, x + 47.6759, y + 83.5794);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 50.3573, y + 84.0143);
ctx.bezierCurveTo(x + 50.4025, y + 84.022, x + 50.4453, y + 83.9908, x + 50.4523, y + 83.9451);
ctx.bezierCurveTo(x + 50.4598, y + 83.8998, x + 50.4284, y + 83.8574, x + 50.3838, y + 83.85);
ctx.bezierCurveTo(x + 50.3386, y + 83.8424, x + 50.2962, y + 83.8729, x + 50.2886, y + 83.9183);
ctx.bezierCurveTo(x + 50.281, y + 83.9636, x + 50.3118, y + 84.0072, x + 50.3573, y + 84.0143);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 53.0209, y + 84.5604);
ctx.bezierCurveTo(x + 53.1277, y + 84.5778, x + 53.2284, y + 84.5054, x + 53.2458, y + 84.3977);
ctx.bezierCurveTo(x + 53.2629, y + 84.2906, x + 53.1897, y + 84.1897, x + 53.0829, y + 84.1723);
ctx.bezierCurveTo(x + 52.9762, y + 84.1549, x + 52.8755, y + 84.2273, x + 52.8584, y + 84.3344);
ctx.bezierCurveTo(x + 52.841, y + 84.4421, x + 52.9142, y + 84.543, x + 53.0209, y + 84.5604);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 55.6869, y + 85.0922);
ctx.bezierCurveTo(x + 55.8469, y + 85.1186, x + 55.9981, y + 85.0098, x + 56.0238, y + 84.8483);
ctx.bezierCurveTo(x + 56.0498, y + 84.6878, x + 55.9401, y + 84.5361, x + 55.7801, y + 84.5097);
ctx.bezierCurveTo(x + 55.6202, y + 84.4834, x + 55.4693, y + 84.5932, x + 55.4433, y + 84.7537);
ctx.bezierCurveTo(x + 55.417, y + 84.9148, x + 55.5266, y + 85.0665, x + 55.6869, y + 85.0922);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 58.367, y + 85.534);
ctx.bezierCurveTo(x + 58.5316, y + 85.5605, x + 58.686, y + 85.4487, x + 58.7122, y + 85.2835);
ctx.bezierCurveTo(x + 58.7386, y + 85.1193, x + 58.6263, y + 84.9637, x + 58.462, y + 84.9365);
ctx.bezierCurveTo(x + 58.2974, y + 84.91, x + 58.143, y + 85.0218, x + 58.1162, y + 85.1866);
ctx.bezierCurveTo(x + 58.0906, y + 85.3522, x + 58.2023, y + 85.5074, x + 58.367, y + 85.534);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 61.0009, y + 86.2675);
ctx.bezierCurveTo(x + 61.3298, y + 86.3213, x + 61.6384, y + 86.0967, x + 61.691, y + 85.7673);
ctx.bezierCurveTo(x + 61.7437, y + 85.4379, x + 61.5206, y + 85.1268, x + 61.1913, y + 85.0737);
ctx.bezierCurveTo(x + 60.8624, y + 85.0199, x + 60.5532, y + 85.2441, x + 60.5006, y + 85.5736);
ctx.bezierCurveTo(x + 60.4486, y + 85.9033, x + 60.6716, y + 86.2144, x + 61.0009, y + 86.2675);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 63.6915, y + 86.6426);
ctx.bezierCurveTo(x + 63.9871, y + 86.6904, x + 64.266, y + 86.4892, x + 64.3135, y + 86.1921);
ctx.bezierCurveTo(x + 64.3606, y + 85.8955, x + 64.1593, y + 85.6158, x + 63.8637, y + 85.568);
ctx.bezierCurveTo(x + 63.5682, y + 85.5201, x + 63.2893, y + 85.7213, x + 63.2421, y + 86.0178);
ctx.bezierCurveTo(x + 63.1946, y + 86.315, x + 63.3963, y + 86.5941, x + 63.6915, y + 86.6426);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 66.3831, y + 87.0175);
ctx.bezierCurveTo(x + 66.6465, y + 87.0601, x + 66.8933, y + 86.8809, x + 66.9359, y + 86.617);
ctx.bezierCurveTo(x + 66.9781, y + 86.3537, x + 66.7988, y + 86.1047, x + 66.5361, y + 86.0624);
ctx.bezierCurveTo(x + 66.2731, y + 86.0191, x + 66.0259, y + 86.199, x + 65.9837, y + 86.4623);
ctx.bezierCurveTo(x + 65.9411, y + 86.7262, x + 66.1198, y + 86.9748, x + 66.3831, y + 87.0175);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 69.0737, y + 87.3925);
ctx.bezierCurveTo(x + 69.3039, y + 87.4302, x + 69.5202, y + 87.2731, x + 69.5573, y + 87.0421);
ctx.bezierCurveTo(x + 69.5941, y + 86.8117, x + 69.4375, y + 86.5938, x + 69.2078, y + 86.5564);
ctx.bezierCurveTo(x + 68.9776, y + 86.5187, x + 68.7614, y + 86.6759, x + 68.7246, y + 86.9062);
ctx.bezierCurveTo(x + 68.6875, y + 87.1372, x + 68.8435, y + 87.3548, x + 69.0737, y + 87.3925);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 71.7746, y + 87.7073);
ctx.bezierCurveTo(x + 71.9392, y + 87.7339, x + 72.0936, y + 87.6221, x + 72.1198, y + 87.4569);
ctx.bezierCurveTo(x + 72.1462, y + 87.2926, x + 72.0343, y + 87.1365, x + 71.8696, y + 87.1099);
ctx.bezierCurveTo(x + 71.705, y + 87.0833, x + 71.5506, y + 87.1951, x + 71.5241, y + 87.3593);
ctx.bezierCurveTo(x + 71.4982, y + 87.5255, x + 71.6099, y + 87.6807, x + 71.7746, y + 87.7073);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.4561, y + 88.142);
ctx.bezierCurveTo(x + 74.6208, y + 88.1685, x + 74.7752, y + 88.0567, x + 74.8014, y + 87.8915);
ctx.bezierCurveTo(x + 74.8278, y + 87.7273, x + 74.7159, y + 87.5711, x + 74.5512, y + 87.5445);
ctx.bezierCurveTo(x + 74.3866, y + 87.518, x + 74.2322, y + 87.6298, x + 74.206, y + 87.795);
ctx.bezierCurveTo(x + 74.1798, y + 87.9602, x + 74.2915, y + 88.1154, x + 74.4561, y + 88.142);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 77.1482, y + 88.51);
ctx.bezierCurveTo(x + 77.2754, y + 88.5308, x + 77.3954, y + 88.4437, x + 77.4159, y + 88.3161);
ctx.bezierCurveTo(x + 77.4364, y + 88.1884, x + 77.35, y + 88.0682, x + 77.2222, y + 88.047);
ctx.bezierCurveTo(x + 77.0951, y + 88.0262, x + 76.975, y + 88.1133, x + 76.9545, y + 88.2409);
ctx.bezierCurveTo(x + 76.934, y + 88.3685, x + 77.0205, y + 88.4888, x + 77.1482, y + 88.51);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 79.8629, y + 88.7354);
ctx.bezierCurveTo(x + 79.8753, y + 88.7376, x + 79.8865, y + 88.7287, x + 79.8886, y + 88.7163);
ctx.bezierCurveTo(x + 79.8907, y + 88.7039, x + 79.8828, y + 88.6923, x + 79.8701, y + 88.6907);
ctx.bezierCurveTo(x + 79.8577, y + 88.6886, x + 79.8464, y + 88.6975, x + 79.8444, y + 88.7099);
ctx.bezierCurveTo(x + 79.8426, y + 88.7217, x + 79.8505, y + 88.7333, x + 79.8629, y + 88.7354);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 51.2749, y + 86.8647);
ctx.bezierCurveTo(x + 51.2872, y + 86.8668, x + 51.2985, y + 86.8579, x + 51.3006, y + 86.8455);
ctx.bezierCurveTo(x + 51.3027, y + 86.8331, x + 51.2942, y + 86.8212, x + 51.2815, y + 86.8196);
ctx.bezierCurveTo(x + 51.2691, y + 86.8175, x + 51.2578, y + 86.8264, x + 51.2557, y + 86.8388);
ctx.bezierCurveTo(x + 51.2536, y + 86.8512, x + 51.2621, y + 86.8632, x + 51.2749, y + 86.8647);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 53.9508, y + 87.3292);
ctx.bezierCurveTo(x + 53.9793, y + 87.3339, x + 54.0069, y + 87.3142, x + 54.0113, y + 87.2847);
ctx.bezierCurveTo(x + 54.016, y + 87.2562, x + 53.9963, y + 87.2284, x + 53.9675, y + 87.2243);
ctx.bezierCurveTo(x + 53.9385, y + 87.2192, x + 53.9114, y + 87.2392, x + 53.9067, y + 87.2678);
ctx.bezierCurveTo(x + 53.9027, y + 87.2967, x + 53.9224, y + 87.3245, x + 53.9508, y + 87.3292);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 56.5981, y + 87.9797);
ctx.bezierCurveTo(x + 56.7463, y + 88.0043, x + 56.8853, y + 87.903, x + 56.9091, y + 87.7549);
ctx.bezierCurveTo(x + 56.933, y + 87.6068, x + 56.8319, y + 87.4671, x + 56.6843, y + 87.4429);
ctx.bezierCurveTo(x + 56.5367, y + 87.4186, x + 56.397, y + 87.5195, x + 56.3732, y + 87.6676);
ctx.bezierCurveTo(x + 56.3493, y + 87.8157, x + 56.4501, y + 87.9561, x + 56.5981, y + 87.9797);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 59.2903, y + 88.3477);
ctx.bezierCurveTo(x + 59.4014, y + 88.3659, x + 59.5057, y + 88.29, x + 59.5236, y + 88.1785);
ctx.bezierCurveTo(x + 59.5412, y + 88.0677, x + 59.4663, y + 87.9626, x + 59.3552, y + 87.9444);
ctx.bezierCurveTo(x + 59.2441, y + 87.9262, x + 59.1398, y + 88.0022, x + 59.1223, y + 88.113);
ctx.bezierCurveTo(x + 59.1043, y + 88.2245, x + 59.1792, y + 88.3295, x + 59.2903, y + 88.3477);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 61.9625, y + 88.8422);
ctx.bezierCurveTo(x + 62.1064, y + 88.8659, x + 62.2416, y + 88.7673, x + 62.265, y + 88.6229);
ctx.bezierCurveTo(x + 62.2884, y + 88.4786, x + 62.1899, y + 88.3427, x + 62.0466, y + 88.3193);
ctx.bezierCurveTo(x + 61.9027, y + 88.2956, x + 61.7676, y + 88.3942, x + 61.7445, y + 88.5379);
ctx.bezierCurveTo(x + 61.7208, y + 88.6829, x + 61.8187, y + 88.8184, x + 61.9625, y + 88.8422);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 64.6508, y + 89.2318);
ctx.bezierCurveTo(x + 64.77, y + 89.2513, x + 64.8819, y + 89.1701, x + 64.9012, y + 89.0506);
ctx.bezierCurveTo(x + 64.9204, y + 88.931, x + 64.8392, y + 88.8185, x + 64.7201, y + 88.799);
ctx.bezierCurveTo(x + 64.601, y + 88.7795, x + 64.489, y + 88.8607, x + 64.4698, y + 88.9802);
ctx.bezierCurveTo(x + 64.4509, y + 89.0992, x + 64.5317, y + 89.2123, x + 64.6508, y + 89.2318);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 67.3398, y + 89.6212);
ctx.bezierCurveTo(x + 67.4342, y + 89.6365, x + 67.5233, y + 89.572, x + 67.5383, y + 89.4773);
ctx.bezierCurveTo(x + 67.5533, y + 89.3826, x + 67.489, y + 89.2931, x + 67.3946, y + 89.2778);
ctx.bezierCurveTo(x + 67.3002, y + 89.2626, x + 67.2111, y + 89.327, x + 67.1955, y + 89.4214);
ctx.bezierCurveTo(x + 67.1807, y + 89.517, x + 67.2454, y + 89.606, x + 67.3398, y + 89.6212);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 70.027, y + 90.0186);
ctx.bezierCurveTo(x + 70.101, y + 90.0304, x + 70.1702, y + 89.9804, x + 70.1827, y + 89.9059);
ctx.bezierCurveTo(x + 70.1944, y + 89.8317, x + 70.1444, y + 89.7622, x + 70.0704, y + 89.7503);
ctx.bezierCurveTo(x + 69.9965, y + 89.7385, x + 69.9267, y + 89.7882, x + 69.9151, y + 89.8624);
ctx.bezierCurveTo(x + 69.9025, y + 89.9369, x + 69.953, y + 90.0068, x + 70.027, y + 90.0186);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 72.6846, y + 90.603);
ctx.bezierCurveTo(x + 72.8412, y + 90.6283, x + 72.9873, y + 90.5214, x + 73.0124, y + 90.3653);
ctx.bezierCurveTo(x + 73.0376, y + 90.2091, x + 72.9315, y + 90.061, x + 72.7749, y + 90.0358);
ctx.bezierCurveTo(x + 72.6183, y + 90.0105, x + 72.4716, y + 90.117, x + 72.4471, y + 90.2735);
ctx.bezierCurveTo(x + 72.4225, y + 90.43, x + 72.5289, y + 90.5775, x + 72.6846, y + 90.603);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 75.4079, y + 90.7766);
ctx.bezierCurveTo(x + 75.4203, y + 90.7787, x + 75.4316, y + 90.7698, x + 75.4337, y + 90.7574);
ctx.bezierCurveTo(x + 75.4358, y + 90.745, x + 75.4273, y + 90.733, x + 75.4146, y + 90.7315);
ctx.bezierCurveTo(x + 75.4022, y + 90.7294, x + 75.3909, y + 90.7382, x + 75.3891, y + 90.7501);
ctx.bezierCurveTo(x + 75.3876, y + 90.7628, x + 75.3956, y + 90.7744, x + 75.4079, y + 90.7766);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 57.5455, y + 90.6439);
ctx.bezierCurveTo(x + 57.5579, y + 90.646, x + 57.5692, y + 90.6371, x + 57.5713, y + 90.6247);
ctx.bezierCurveTo(x + 57.5734, y + 90.6123, x + 57.5654, y + 90.6007, x + 57.5527, y + 90.5992);
ctx.bezierCurveTo(x + 57.5404, y + 90.5971, x + 57.5291, y + 90.6059, x + 57.527, y + 90.6183);
ctx.bezierCurveTo(x + 57.5252, y + 90.6301, x + 57.5331, y + 90.6417, x + 57.5455, y + 90.6439);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 60.227, y + 91.0785);
ctx.bezierCurveTo(x + 60.2394, y + 91.0807, x + 60.2507, y + 91.0718, x + 60.2528, y + 91.0594);
ctx.bezierCurveTo(x + 60.2549, y + 91.047, x + 60.2464, y + 91.035, x + 60.2336, y + 91.0335);
ctx.bezierCurveTo(x + 60.2213, y + 91.0314, x + 60.21, y + 91.0403, x + 60.2079, y + 91.0527);
ctx.bezierCurveTo(x + 60.2067, y + 91.0648, x + 60.2146, y + 91.0764, x + 60.227, y + 91.0785);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 62.9001, y + 91.5655);
ctx.bezierCurveTo(x + 62.941, y + 91.5724, x + 62.9799, y + 91.5438, x + 62.9867, y + 91.5028);
ctx.bezierCurveTo(x + 62.9934, y + 91.4619, x + 62.9649, y + 91.4227, x + 62.9241, y + 91.4158);
ctx.bezierCurveTo(x + 62.8832, y + 91.409, x + 62.8443, y + 91.4375, x + 62.8375, y + 91.4785);
ctx.bezierCurveTo(x + 62.8314, y + 91.5198, x + 62.8593, y + 91.5586, x + 62.9001, y + 91.5655);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 65.5899, y + 91.9482);
ctx.bezierCurveTo(x + 65.6023, y + 91.9503, x + 65.6136, y + 91.9414, x + 65.6157, y + 91.929);
ctx.bezierCurveTo(x + 65.6178, y + 91.9166, x + 65.6089, y + 91.9052, x + 65.5966, y + 91.9031);
ctx.bezierCurveTo(x + 65.5842, y + 91.901, x + 65.5729, y + 91.9099, x + 65.5708, y + 91.9223);
ctx.bezierCurveTo(x + 65.5697, y + 91.9344, x + 65.5776, y + 91.946, x + 65.5899, y + 91.9482);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 68.2717, y + 92.3823);
ctx.bezierCurveTo(x + 68.2841, y + 92.3844, x + 68.2954, y + 92.3755, x + 68.2974, y + 92.3631);
ctx.bezierCurveTo(x + 68.2995, y + 92.3507, x + 68.291, y + 92.3387, x + 68.2783, y + 92.3372);
ctx.bezierCurveTo(x + 68.266, y + 92.3351, x + 68.2547, y + 92.3439, x + 68.2526, y + 92.3564);
ctx.bezierCurveTo(x + 68.2505, y + 92.3688, x + 68.259, y + 92.3808, x + 68.2717, y + 92.3823);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 70.9541, y + 92.8096);
ctx.bezierCurveTo(x + 70.9621, y + 92.8109, x + 70.9698, y + 92.8056, x + 70.9714, y + 92.7969);
ctx.bezierCurveTo(x + 70.9727, y + 92.7888, x + 70.9675, y + 92.7811, x + 70.9594, y + 92.7798);
ctx.bezierCurveTo(x + 70.9514, y + 92.7785, x + 70.9437, y + 92.7838, x + 70.9424, y + 92.7918);
ctx.bezierCurveTo(x + 70.9408, y + 92.8005, x + 70.946, y + 92.8083, x + 70.9541, y + 92.8096);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 73.637, y + 93.2373);
ctx.bezierCurveTo(x + 73.6416, y + 93.2382, x + 73.6457, y + 93.2354, x + 73.6465, y + 93.2308);
ctx.bezierCurveTo(x + 73.647, y + 93.2269, x + 73.6443, y + 93.2228, x + 73.6397, y + 93.2219);
ctx.bezierCurveTo(x + 73.6351, y + 93.221, x + 73.631, y + 93.2238, x + 73.6305, y + 93.2277);
ctx.bezierCurveTo(x + 73.6293, y + 93.233, x + 73.6331, y + 93.2368, x + 73.637, y + 93.2373);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#ED1B24";

ctx.beginPath();
ctx.moveTo(x + 78.7715, y + 70.2393);
ctx.bezierCurveTo(x + 76.4622, y + 69.8646, x + 73.7755, y + 72.3826, x + 74.0721, y + 67.0771);
ctx.bezierCurveTo(x + 82.1169, y + 64.9332, x + 86.7432, y + 59.7258, x + 87.8529, y + 52.8248);
ctx.bezierCurveTo(x + 89.5493, y + 42.2683, x + 79.2069, y + 31.8103, x + 64.7524, y + 29.4677);
ctx.bezierCurveTo(x + 50.2973, y + 27.1248, x + 37.2039, y + 33.7839, x + 35.5075, y + 44.3404);
ctx.bezierCurveTo(x + 33.8107, y + 54.8975, x + 44.1528, y + 65.3546, x + 58.6085, y + 67.6978);
ctx.bezierCurveTo(x + 61.5929, y + 68.1812, x + 64.5171, y + 68.2757, x + 67.2963, y + 68.0372);
ctx.bezierCurveTo(x + 68.0463, y + 71.4267, x + 68.8823, y + 75.441, x + 72.3903, y + 75.8116);
ctx.bezierCurveTo(x + 74.6884, y + 76.0543, x + 76.7403, y + 73.259, x + 78.8866, y + 73.5241);
ctx.bezierCurveTo(x + 80.9074, y + 73.7741, x + 83.6688, y + 77.926, x + 81.4652, y + 86.0343);
ctx.bezierCurveTo(x + 85.5505, y + 75.4362, x + 82.7642, y + 70.8865, x + 78.7715, y + 70.2393);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#020202";

ctx.beginPath();
ctx.moveTo(x + 64.7523, y + 29.4677);
ctx.bezierCurveTo(x + 79.2068, y + 31.8103, x + 89.5495, y + 42.2677, x + 87.8528, y + 52.8248);
ctx.bezierCurveTo(x + 86.7431, y + 59.7259, x + 82.1168, y + 64.9332, x + 74.072, y + 67.0771);
ctx.bezierCurveTo(x + 73.931, y + 69.5996, x + 74.4641, y + 70.3536, x + 75.311, y + 70.4912);
ctx.bezierCurveTo(x + 76.2451, y + 70.6424, x + 77.5595, y + 70.0432, x + 78.7711, y + 70.2399);
ctx.bezierCurveTo(x + 82.7632, y + 70.8868, x + 85.55, y + 75.4368, x + 81.4644, y + 86.0356);
ctx.bezierCurveTo(x + 83.6448, y + 78.0095, x + 80.9629, y + 73.8605, x + 78.9477, y + 73.5343);
ctx.bezierCurveTo(x + 78.9267, y + 73.5306, x + 78.9059, y + 73.5278, x + 78.8852, y + 73.525);
ctx.bezierCurveTo(x + 76.7389, y + 73.2599, x + 74.687, y + 76.0553, x + 72.3889, y + 75.8125);
ctx.bezierCurveTo(x + 72.3024, y + 75.8033, x + 72.2179, y + 75.792, x + 72.1353, y + 75.7787);
ctx.bezierCurveTo(x + 68.8404, y + 75.2449, x + 68.0274, y + 71.3442, x + 67.2949, y + 68.0382);
ctx.bezierCurveTo(x + 64.5157, y + 68.2767, x + 61.5915, y + 68.1821, x + 58.6071, y + 67.6987);
ctx.bezierCurveTo(x + 44.1521, y + 65.3558, x + 33.8093, y + 54.8985, x + 35.5061, y + 44.3413);
ctx.bezierCurveTo(x + 37.2038, y + 33.784, x + 50.2972, y + 27.1248, x + 64.7523, y + 29.4677);
ctx.closePath();
ctx.moveTo(x + 64.932, y + 28.3507);
ctx.bezierCurveTo(x + 49.887, y + 25.9123, x + 36.1881, y + 33.004, x + 34.3951, y + 44.16);
ctx.bezierCurveTo(x + 32.602, y + 55.316, x + 43.3835, y + 66.3755, x + 58.4285, y + 68.8139);
ctx.bezierCurveTo(x + 61.0917, y + 69.2457, x + 63.7719, y + 69.3869, x + 66.4086, y + 69.2343);
ctx.bezierCurveTo(x + 67.1616, y + 72.5479, x + 68.259, y + 76.2948, x + 71.9563, y + 76.8944);
ctx.bezierCurveTo(x + 72.0599, y + 76.9116, x + 72.1646, y + 76.9253, x + 72.2722, y + 76.9367);
ctx.bezierCurveTo(x + 73.8044, y + 77.0983, x + 75.1319, y + 76.3088, x + 76.3036, y + 75.6122);
ctx.bezierCurveTo(x + 77.2116, y + 75.0721, x + 78.0685, y + 74.5625, x + 78.7492, y + 74.6464);
ctx.lineTo(x + 78.7508, y + 74.6465);
ctx.bezierCurveTo(x + 79.0731, y + 74.6987, x + 79.5636, y + 75.0122, x + 80.0334, y + 75.7452);
ctx.bezierCurveTo(x + 80.6797, y + 76.753, x + 82.0081, y + 79.7443, x + 80.3798, y + 85.7363);
ctx.bezierCurveTo(x + 80.2217, y + 86.3174, x + 80.5439, y + 86.9199, x + 81.1141, y + 87.1084);
ctx.bezierCurveTo(x + 81.1718, y + 87.1278, x + 81.2295, y + 87.1417, x + 81.2873, y + 87.1508);
ctx.bezierCurveTo(x + 81.8039, y + 87.2349, x + 82.3219, y + 86.9471, x + 82.5159, y + 86.442);
ctx.bezierCurveTo(x + 85.5379, y + 78.6033, x + 84.7066, y + 74.3909, x + 83.4769, y + 72.2386);
ctx.bezierCurveTo(x + 82.4959, y + 70.5198, x + 80.9308, y + 69.4422, x + 78.9515, y + 69.1217);
ctx.bezierCurveTo(x + 78.1176, y + 68.9866, x + 77.324, y + 69.1292, x + 76.6243, y + 69.2547);
ctx.bezierCurveTo(x + 76.1891, y + 69.3328, x + 75.7393, y + 69.4141, x + 75.4916, y + 69.374);
ctx.bezierCurveTo(x + 75.452, y + 69.3678, x + 75.4318, y + 69.3597, x + 75.4285, y + 69.3571);
ctx.bezierCurveTo(x + 75.4276, y + 69.3558, x + 75.1929, y + 69.1182, x + 75.1778, y + 67.9387);
ctx.bezierCurveTo(x + 82.9032, y + 65.6209, x + 87.7862, y + 60.3443, x + 88.9657, y + 53.004);
ctx.bezierCurveTo(x + 90.7581, y + 41.8492, x + 79.9769, y + 30.7891, x + 64.932, y + 28.3507);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#020202";

ctx.beginPath();
ctx.moveTo(x + 64.9291, y + 29.2221);
ctx.bezierCurveTo(x + 79.3836, y + 31.5646, x + 90.4662, y + 40.7136, x + 88.5515, y + 52.6247);
ctx.bezierCurveTo(x + 87.4423, y + 59.5251, x + 82.117, y + 64.9327, x + 74.0722, y + 67.0767);
ctx.bezierCurveTo(x + 73.9312, y + 69.5992, x + 74.4642, y + 70.3532, x + 75.3111, y + 70.4908);
ctx.bezierCurveTo(x + 76.2453, y + 70.642, x + 77.5597, y + 70.0427, x + 78.7713, y + 70.2395);
ctx.bezierCurveTo(x + 82.7634, y + 70.8864, x + 85.5502, y + 75.4364, x + 81.4646, y + 86.0351);
ctx.bezierCurveTo(x + 83.645, y + 78.009, x + 80.9631, y + 73.8601, x + 78.9479, y + 73.5339);
ctx.bezierCurveTo(x + 78.9269, y + 73.5301, x + 78.9061, y + 73.5273, x + 78.8854, y + 73.5245);
ctx.bezierCurveTo(x + 76.7391, y + 73.2594, x + 74.1172, y + 76.5096, x + 71.8201, y + 76.2666);
ctx.bezierCurveTo(x + 71.724, y + 76.256, x + 71.6298, y + 76.2434, x + 71.5376, y + 76.2286);
ctx.bezierCurveTo(x + 68.2647, y + 75.6983, x + 67.4249, y + 72.1994, x + 66.6957, y + 68.9032);
ctx.bezierCurveTo(x + 63.915, y + 69.1416, x + 61.0445, y + 68.8868, x + 58.0605, y + 68.4028);
ctx.bezierCurveTo(x + 43.6055, y + 66.0599, x + 33.8099, y + 54.8974, x + 35.5066, y + 44.3403);
ctx.bezierCurveTo(x + 37.2036, y + 33.7841, x + 50.4734, y + 26.8788, x + 64.9291, y + 29.2221);
ctx.closePath();
ctx.moveTo(x + 65.1082, y + 28.1047);
ctx.bezierCurveTo(x + 57.8958, y + 26.9361, x + 50.7251, y + 27.9418, x + 44.9187, y + 30.9375);
ctx.bezierCurveTo(x + 39.0132, y + 33.9841, x + 35.2759, y + 38.6799, x + 34.3949, y + 44.1602);
ctx.bezierCurveTo(x + 33.5196, y + 49.6044, x + 35.526, y + 55.4571, x + 39.8991, y + 60.219);
ctx.bezierCurveTo(x + 44.3424, y + 65.057, x + 50.7288, y + 68.3602, x + 57.8812, y + 69.5192);
ctx.bezierCurveTo(x + 60.9493, y + 70.0166, x + 63.5001, y + 70.2031, x + 65.8093, y + 70.0953);
ctx.bezierCurveTo(x + 66.5144, y + 73.1317, x + 67.657, y + 76.7455, x + 71.3583, y + 77.345);
ctx.bezierCurveTo(x + 71.4709, y + 77.3632, x + 71.5852, y + 77.3783, x + 71.7024, y + 77.391);
ctx.bezierCurveTo(x + 73.2451, y + 77.5537, x + 74.666, y + 76.6749, x + 76.0398, y + 75.8249);
ctx.bezierCurveTo(x + 77.0418, y + 75.2045, x + 78.0789, y + 74.5638, x + 78.7479, y + 74.6459);
ctx.lineTo(x + 78.7494, y + 74.646);
ctx.bezierCurveTo(x + 79.0717, y + 74.6982, x + 79.5622, y + 75.0117, x + 80.032, y + 75.7447);
ctx.bezierCurveTo(x + 80.6784, y + 76.7525, x + 82.0067, y + 79.7438, x + 80.3785, y + 85.7357);
ctx.bezierCurveTo(x + 80.2203, y + 86.3168, x + 80.5426, y + 86.9194, x + 81.1127, y + 87.1078);
ctx.bezierCurveTo(x + 81.1705, y + 87.1273, x + 81.2281, y + 87.1412, x + 81.286, y + 87.1503);
ctx.bezierCurveTo(x + 81.8025, y + 87.2344, x + 82.3206, y + 86.9465, x + 82.5146, y + 86.4415);
ctx.bezierCurveTo(x + 85.5365, y + 78.6028, x + 84.7052, y + 74.3904, x + 83.4755, y + 72.2381);
ctx.bezierCurveTo(x + 82.4946, y + 70.5193, x + 80.9294, y + 69.4417, x + 78.9501, y + 69.1212);
ctx.bezierCurveTo(x + 78.1162, y + 68.986, x + 77.3226, y + 69.1286, x + 76.6229, y + 69.2541);
ctx.bezierCurveTo(x + 76.1877, y + 69.3323, x + 75.738, y + 69.4136, x + 75.4902, y + 69.3734);
ctx.bezierCurveTo(x + 75.4506, y + 69.3673, x + 75.4304, y + 69.3592, x + 75.4271, y + 69.3565);
ctx.bezierCurveTo(x + 75.4262, y + 69.3552, x + 75.1915, y + 69.1176, x + 75.1765, y + 67.9381);
ctx.bezierCurveTo(x + 83.126, y + 65.5537, x + 88.5152, y + 59.9459, x + 89.663, y + 52.8038);
ctx.bezierCurveTo(x + 90.6364, y + 46.7473, x + 88.5559, y + 41.1116, x + 83.6465, y + 36.5066);
ctx.bezierCurveTo(x + 79.1606, y + 32.2999, x + 72.5766, y + 29.3157, x + 65.1082, y + 28.1047);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="black";

ctx.beginPath();
ctx.moveTo(x + 70.6594, y + 38.9467);
ctx.bezierCurveTo(x + 70.5985, y + 38.1246, x + 70.233, y + 37.1258, x + 68.8378, y + 37.0716);
ctx.bezierCurveTo(x + 68.7715, y + 37.0689, x + 68.7049, y + 37.0683, x + 68.6766, y + 37.0661);
ctx.bezierCurveTo(x + 68.5942, y + 37.0479, x + 68.5128, y + 37.0295, x + 68.4303, y + 37.0114);
ctx.bezierCurveTo(x + 67.6035, y + 36.8277, x + 67.4193, y + 36.7933, x + 67.1559, y + 36.8386);
ctx.bezierCurveTo(x + 67.1387, y + 36.8409, x + 66.2256, y + 37.138, x + 65.4173, y + 37.7854);
ctx.bezierCurveTo(x + 64.4802, y + 37.1923, x + 63.2261, y + 37.3121, x + 63.2067, y + 37.3141);
ctx.bezierCurveTo(x + 62.6704, y + 37.4088, x + 61.6967, y + 38.1115, x + 60.9827, y + 39.0058);
ctx.bezierCurveTo(x + 60.1032, y + 38.3059, x + 58.7215, y + 38.4647, x + 58.7021, y + 38.4666);
ctx.bezierCurveTo(x + 58.3926, y + 38.5203, x + 57.4843, y + 39.0375, x + 56.6776, y + 39.7681);
ctx.bezierCurveTo(x + 55.7911, y + 38.763, x + 53.9744, y + 38.9588, x + 53.9506, y + 38.9615);
ctx.bezierCurveTo(x + 53.4154, y + 39.0584, x + 52.4399, y + 39.7185, x + 51.7234, y + 40.5468);
ctx.bezierCurveTo(x + 50.8489, y + 39.9256, x + 49.4695, y + 40.0976, x + 49.4498, y + 40.1001);
ctx.bezierCurveTo(x + 49.1401, y + 40.1555, x + 48.2312, y + 40.6435, x + 47.4225, y + 41.3218);
ctx.bezierCurveTo(x + 46.5414, y + 40.4276, x + 44.727, y + 40.6439, x + 44.7038, y + 40.6469);
ctx.bezierCurveTo(x + 44.1688, y + 40.7464, x + 43.1929, y + 41.3639, x + 42.4734, y + 42.1257);
ctx.bezierCurveTo(x + 41.602, y + 41.5838, x + 40.2236, y + 41.7699, x + 40.2048, y + 41.7722);
ctx.bezierCurveTo(x + 39.8803, y + 41.8312, x + 38.8931, y + 42.3369, x + 38.0543, y + 43.012);
ctx.bezierCurveTo(x + 37.7449, y + 42.5376, x + 37.0627, y + 42.2238, x + 35.6213, y + 42.4946);
ctx.bezierCurveTo(x + 35.1055, y + 42.5912, x + 34.7269, y + 42.7422, x + 34.4506, y + 42.9184);
ctx.bezierCurveTo(x + 34.3346, y + 42.9135, x + 34.2168, y + 42.9219, x + 34.0968, y + 42.9442);
ctx.bezierCurveTo(x + 31.7372, y + 43.3877, x + 30.6942, y + 44.1579, x + 30.4298, y + 44.3776);
ctx.bezierCurveTo(x + 30.3645, y + 44.4322, x + 30.3042, y + 44.4919, x + 30.2489, y + 44.5545);
ctx.bezierCurveTo(x + 29.9542, y + 44.8907, x + 29.6916, y + 45.2912, x + 29.4616, y + 45.7091);
ctx.bezierCurveTo(x + 29.462, y + 45.671, x + 29.4605, y + 45.6334, x + 29.4566, y + 45.5929);
ctx.bezierCurveTo(x + 29.3006, y + 43.8593, x + 26.0571, y + 44.4348, x + 25.6876, y + 44.5061);
ctx.bezierCurveTo(x + 25.3323, y + 44.5734, x + 24.8349, y + 44.6827, x + 24.4934, y + 44.8129);
ctx.bezierCurveTo(x + 24.4575, y + 44.8416, x + 20.8297, y + 46.4775, x + 20.9505, y + 47.7511);
ctx.bezierCurveTo(x + 20.9681, y + 47.9351, x + 21.0346, y + 48.0898, x + 21.1743, y + 48.3973);
ctx.bezierCurveTo(x + 21.1907, y + 48.4353, x + 21.2088, y + 48.4717, x + 21.2229, y + 48.5052);
ctx.bezierCurveTo(x + 21.2114, y + 48.8209, x + 21.1037, y + 49.6221, x + 21.0297, y + 50.1657);
ctx.bezierCurveTo(x + 20.9305, y + 50.8926, x + 20.8628, y + 51.4061, x + 20.8358, y + 51.777);
ctx.bezierCurveTo(x + 20.6977, y + 51.5343, x + 20.4647, y + 51.3161, x + 20.164, y + 51.1366);
ctx.bezierCurveTo(x + 20.3049, y + 51.0204, x + 20.3906, y + 50.9405, x + 20.414, y + 50.9185);
ctx.bezierCurveTo(x + 20.8287, y + 50.5399, x + 20.9913, y + 49.8509, x + 20.9, y + 48.8808);
ctx.bezierCurveTo(x + 20.8563, y + 48.4216, x + 20.7503, y + 47.9555, x + 20.2873, y + 47.6692);
ctx.bezierCurveTo(x + 20.0907, y + 46.8919, x + 19.1994, y + 46.3773, x + 18.9233, y + 46.2412);
ctx.bezierCurveTo(x + 18.3101, y + 45.9252, x + 17.4662, y + 46.0572, x + 16.6539, y + 46.214);
ctx.bezierCurveTo(x + 15.8595, y + 46.3689, x + 15.0405, y + 46.5868, x + 15.0067, y + 46.5959);
ctx.bezierCurveTo(x + 14.9011, y + 46.6239, x + 14.7983, y + 46.6599, x + 14.6993, y + 46.7019);
ctx.bezierCurveTo(x + 14.6399, y + 46.7271, x + 14.5875, y + 46.7513, x + 14.532, y + 46.7794);
ctx.bezierCurveTo(x + 14.2632, y + 46.6849, x + 13.9328, y + 46.6567, x + 13.5265, y + 46.737);
ctx.bezierCurveTo(x + 13.0293, y + 46.8344, x + 11.7032, y + 47.2928, x + 10.7328, y + 47.8631);
ctx.bezierCurveTo(x + 10.1882, y + 47.6606, x + 9.53753, y + 47.5675, x + 8.90541, y + 47.6941);
ctx.bezierCurveTo(x + 6.90503, y + 48.0948, x + 5.61139, y + 48.5666, x + 5.46962, y + 48.6167);
ctx.bezierCurveTo(x + 5.44366, y + 48.6262, x + 5.41701, y + 48.6368, x + 5.39071, y + 48.6469);
ctx.bezierCurveTo(x + 4.61811, y + 48.9882, x + 1.57569, y + 50.7271, x + 1.66394, y + 51.5517);
ctx.bezierCurveTo(x + 1.67976, y + 51.7044, x + 1.77352, y + 51.8056, x + 1.84971, y + 51.8882);
ctx.bezierCurveTo(x + 1.8539, y + 51.8921, x + 1.85714, y + 51.8963, x + 1.86133, y + 51.9003);
ctx.bezierCurveTo(x + 1.84524, y + 51.9624, x + 1.81428, y + 52.0514, x + 1.78974, y + 52.1215);
ctx.bezierCurveTo(x + 1.70684, y + 52.3589, x + 1.60224, y + 52.6512, x + 1.63488, y + 52.9547);
ctx.bezierCurveTo(x + 1.63975, y + 53.0006, x + 1.66286, y + 53.1071, x + 1.69463, y + 53.2367);
ctx.bezierCurveTo(x + 1.73215, y + 53.392, x + 1.78319, y + 53.5947, x + 1.79785, y + 53.738);
ctx.bezierCurveTo(x + 1.79887, y + 53.7506, x + 1.80049, y + 53.7635, x + 1.80116, y + 53.7766);
ctx.bezierCurveTo(x + 1.77202, y + 53.9457, x + 1.84219, y + 54.0809, x + 1.95035, y + 54.1878);
ctx.bezierCurveTo(x + 1.86354, y + 54.2926, x + 1.8058, y + 54.417, x + 1.82108, y + 54.5606);
ctx.bezierCurveTo(x + 1.85459, y + 54.8798, x + 2.429, y + 55.6024, x + 3.21617, y + 56.1827);
ctx.bezierCurveTo(x + 3.76707, y + 56.5637, x + 5.79871, y + 57.2673, x + 6.90196, y + 57.27);
ctx.bezierCurveTo(x + 7.81489, y + 57.2638, x + 8.56553, y + 57.1132, x + 9.0725, y + 56.9837);
ctx.bezierCurveTo(x + 9.24219, y + 57.0227, x + 9.44202, y + 57.049, x + 9.67147, y + 57.0463);
ctx.bezierCurveTo(x + 10.0876, y + 57.0418, x + 10.578, y + 56.879, x + 11.0491, y + 56.6216);
ctx.bezierCurveTo(x + 12.1338, y + 57.2101, x + 12.7937, y + 57.2245, x + 13.0151, y + 57.2206);
ctx.bezierCurveTo(x + 13.1925, y + 57.2199, x + 13.4787, y + 57.2586, x + 13.6011, y + 57.2751);
ctx.bezierCurveTo(x + 13.7358, y + 57.2937, x + 13.8631, y + 57.3114, x + 14.0352, y + 57.3102);
ctx.bezierCurveTo(x + 14.7597, y + 57.3088, x + 15.2873, y + 57.0918, x + 15.672, y + 56.9282);
ctx.bezierCurveTo(x + 15.7523, y + 56.8941, x + 15.8676, y + 56.8458, x + 15.934, y + 56.8223);
ctx.bezierCurveTo(x + 16.1721, y + 56.8084, x + 16.4075, y + 56.7531, x + 16.612, y + 56.659);
ctx.bezierCurveTo(x + 17.4633, y + 57.0026, x + 18.7951, y + 57.0605, x + 19.5745, y + 57.0563);
ctx.bezierCurveTo(x + 19.8663, y + 57.0549, x + 20.2575, y + 56.9358, x + 20.6513, y + 56.743);
ctx.bezierCurveTo(x + 21.6238, y + 57.1384, x + 22.0809, y + 57.1449, x + 22.2655, y + 57.1427);
ctx.bezierCurveTo(x + 22.2943, y + 57.1396, x + 24.5518, y + 57.1393, x + 25.4764, y + 56.354);
ctx.bezierCurveTo(x + 26.1701, y + 57.0986, x + 27.7746, y + 57.5072, x + 28.5352, y + 57.514);
ctx.bezierCurveTo(x + 28.5618, y + 57.5121, x + 30.3444, y + 57.4339, x + 31.4071, y + 56.769);
ctx.bezierCurveTo(x + 32.1153, y + 56.9567, x + 33.135, y + 57.1348, x + 34.5011, y + 57.1408);
ctx.bezierCurveTo(x + 34.7796, y + 57.1416, x + 35.0109, y + 57.0824, x + 35.2033, y + 56.9926);
ctx.bezierCurveTo(x + 35.3603, y + 57.0301, x + 35.5015, y + 57.0413, x + 35.6121, y + 57.0416);
ctx.bezierCurveTo(x + 36.2231, y + 57.0438, x + 36.9702, y + 56.6003, x + 37.655, y + 55.9486);
ctx.bezierCurveTo(x + 38.4472, y + 57.1758, x + 40.9703, y + 57.4096, x + 40.9993, y + 57.409);
ctx.bezierCurveTo(x + 41.7374, y + 57.4177, x + 42.9006, y + 56.8793, x + 43.5589, y + 56.2855);
ctx.bezierCurveTo(x + 44.2494, y + 56.7741, x + 45.2265, y + 57.2849, x + 45.921, y + 57.2931);
ctx.bezierCurveTo(x + 46.3119, y + 57.2968, x + 47.0554, y + 57.0671, x + 47.745, y + 56.6498);
ctx.bezierCurveTo(x + 48.8003, y + 57.3545, x + 50.3086, y + 57.5168, x + 50.3314, y + 57.5159);
ctx.bezierCurveTo(x + 51.0694, y + 57.5277, x + 52.23, y + 56.932, x + 52.8854, y + 56.2758);
ctx.bezierCurveTo(x + 53.5777, y + 56.823, x + 54.557, y + 57.3917, x + 55.253, y + 57.4031);
ctx.bezierCurveTo(x + 55.6438, y + 57.4084, x + 56.3851, y + 57.1567, x + 57.0731, y + 56.6977);
ctx.bezierCurveTo(x + 58.1328, y + 57.4808, x + 59.6411, y + 57.6631, x + 59.6639, y + 57.6622);
ctx.bezierCurveTo(x + 60.3977, y + 57.6772, x + 61.5638, y + 57.0199, x + 62.2162, y + 56.3044);
ctx.bezierCurveTo(x + 62.8965, y + 56.8977, x + 63.8656, y + 57.5382, x + 64.5823, y + 57.5524);
ctx.bezierCurveTo(x + 65.0163, y + 57.5603, x + 65.8841, y + 57.2211, x + 66.627, y + 56.6098);
ctx.bezierCurveTo(x + 67.197, y + 57.0327, x + 67.9213, y + 57.2589, x + 68.79, y + 57.2735);
ctx.bezierCurveTo(x + 68.8697, y + 57.2749, x + 68.9504, y + 57.2761, x + 69.0301, y + 57.2775);
ctx.bezierCurveTo(x + 69.5494, y + 57.2868, x + 69.9909, y + 56.9145, x + 70.2242, y + 56.3569);
ctx.bezierCurveTo(x + 71.1313, y + 55.8448, x + 71.3154, y + 54.0713, x + 71.2734, y + 53.5084);
ctx.bezierCurveTo(x + 71.2681, y + 53.4375, x + 71.2596, y + 53.3664, x + 71.2493, y + 53.2959);
ctx.bezierCurveTo(x + 71.1097, y + 52.3898, x + 70.9253, y + 51.175, x + 70.3855, y + 50.4878);
ctx.bezierCurveTo(x + 70.5926, y + 50.0434, x + 70.653, y + 49.4842, x + 70.5441, y + 48.943);
ctx.bezierCurveTo(x + 70.522, y + 48.8331, x + 70.4783, y + 48.5841, x + 70.4468, y + 48.3403);
ctx.bezierCurveTo(x + 70.4493, y + 48.3345, x + 70.451, y + 48.3299, x + 70.4535, y + 48.3241);
ctx.bezierCurveTo(x + 70.691, y + 47.9255, x + 70.8027, y + 47.399, x + 70.7598, y + 46.8276);
ctx.bezierCurveTo(x + 70.7289, y + 46.4059, x + 70.6164, y + 46.0609, x + 70.4947, y + 45.7914);
ctx.bezierCurveTo(x + 70.4964, y + 45.1642, x + 70.5663, y + 44.4856, x + 70.6038, y + 44.1174);
ctx.bezierCurveTo(x + 70.6392, y + 43.7672, x + 70.6608, y + 43.5556, x + 70.6406, y + 43.2757);
ctx.bezierCurveTo(x + 70.6221, y + 43.0272, x + 70.5751, y + 42.8099, x + 70.512, y + 42.6203);
ctx.bezierCurveTo(x + 70.802, y + 41.0844, x + 70.6794, y + 39.2184, x + 70.6594, y + 38.9467);
ctx.closePath();
ctx.moveTo(x + 9.3299, y + 52.7003);
ctx.bezierCurveTo(x + 8.71814, y + 52.76, x + 8.28046, y + 52.9586, x + 8.02342, y + 53.1952);
ctx.bezierCurveTo(x + 8.01423, y + 53.1197, x + 8.00483, y + 53.0561, x + 8.0097, y + 53.0157);
ctx.bezierCurveTo(x + 8.01417, y + 52.999, x + 8.01896, y + 52.9817, x + 8.02281, y + 52.9647);
ctx.bezierCurveTo(x + 8.041, y + 52.883, x + 8.04568, y + 52.7753, x + 8.0012, y + 52.6585);
ctx.bezierCurveTo(x + 8.09152, y + 52.6595, x + 8.18427, y + 52.6546, x + 8.27878, y + 52.6452);
ctx.bezierCurveTo(x + 9.36317, y + 52.5367, x + 10.183, y + 52.2857, x + 10.3018, y + 52.2467);
ctx.bezierCurveTo(x + 10.3584, y + 52.228, x + 10.4148, y + 52.1997, x + 10.4713, y + 52.1754);
ctx.bezierCurveTo(x + 10.5045, y + 52.3442, x + 10.5499, y + 52.4895, x + 10.626, y + 52.6168);
ctx.bezierCurveTo(x + 10.6124, y + 52.6787, x + 10.5974, y + 52.7533, x + 10.5824, y + 52.8337);
ctx.bezierCurveTo(x + 10.207, y + 52.7443, x + 9.83633, y + 52.684, x + 9.59228, y + 52.6857);
ctx.bezierCurveTo(x + 9.52129, y + 52.6843, x + 9.40096, y + 52.6929, x + 9.3299, y + 52.7003);
ctx.closePath();
ctx.moveTo(x + 30.4031, y + 51.2579);
ctx.bezierCurveTo(x + 30.3928, y + 51.2162, x + 30.3821, y + 51.1751, x + 30.3712, y + 51.133);
ctx.bezierCurveTo(x + 30.4125, y + 51.1561, x + 30.4524, y + 51.1848, x + 30.4939, y + 51.2064);
ctx.bezierCurveTo(x + 30.4611, y + 51.2224, x + 30.4335, y + 51.2406, x + 30.4031, y + 51.2579);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#F9ED32";

ctx.beginPath();
ctx.moveTo(x + 10.4248, y + 55.9214);
ctx.bezierCurveTo(x + 10.3128, y + 55.9251, x + 10.1996, y + 55.761, x + 9.95954, y + 55.7698);
ctx.bezierCurveTo(x + 9.73534, y + 55.7802, x + 8.86048, y + 56.1779, x + 7.6596, y + 56.2101);
ctx.bezierCurveTo(x + 7.21051, y + 56.2178, x + 5.62, y + 55.7419, x + 5.2549, y + 55.48);
ctx.bezierCurveTo(x + 4.52321, y + 54.926, x + 4.15318, y + 54.3105, x + 4.14305, y + 54.2137);
ctx.bezierCurveTo(x + 4.1375, y + 54.1618, x + 4.60702, y + 54.0281, x + 4.58161, y + 53.7805);
ctx.bezierCurveTo(x + 4.56802, y + 53.6482, x + 4.10791, y + 53.5578, x + 4.11833, y + 53.5045);
ctx.bezierCurveTo(x + 4.1305, y + 53.4682, x + 4.1253, y + 53.4157, x + 4.11773, y + 53.3459);
ctx.bezierCurveTo(x + 4.08988, y + 53.0754, x + 3.96211, y + 52.6226, x + 3.95197, y + 52.5186);
ctx.bezierCurveTo(x + 3.90919, y + 52.111, x + 4.21543, y + 51.6462, x + 4.18448, y + 51.3467);
ctx.bezierCurveTo(x + 4.1738, y + 51.2408, x + 3.97908, y + 51.0743, x + 3.9759, y + 51.0398);
ctx.bezierCurveTo(x + 3.94549, y + 50.7494, x + 5.96271, y + 49.362, x + 6.79869, y + 49.0129);
ctx.bezierCurveTo(x + 6.79863, y + 49.0145, x + 7.98019, y + 48.587, x + 9.83348, y + 48.242);
ctx.bezierCurveTo(x + 10.4981, y + 48.1143, x + 11.3343, y + 48.7301, x + 11.3417, y + 48.8046);
ctx.bezierCurveTo(x + 11.3466, y + 48.8561, x + 11.0456, y + 49.0713, x + 11.0652, y + 49.2733);
ctx.bezierCurveTo(x + 11.0824, y + 49.4452, x + 11.6163, y + 49.4657, x + 11.6261, y + 49.5688);
ctx.bezierCurveTo(x + 11.6261, y + 49.5688, x + 11.6475, y + 49.6279, x + 11.6577, y + 49.7303);
ctx.bezierCurveTo(x + 11.6737, y + 49.8943, x + 11.6694, y + 50.1653, x + 11.5122, y + 50.3627);
ctx.bezierCurveTo(x + 11.4117, y + 50.4822, x + 10.776, y + 51.0569, x + 10.5586, y + 51.1327);
ctx.bezierCurveTo(x + 10.5586, y + 51.1327, x + 9.90414, y + 51.3556, x + 9.03003, y + 51.4627);
ctx.bezierCurveTo(x + 8.93416, y + 51.4746, x + 8.76209, y + 51.368, x + 8.75729, y + 51.3205);
ctx.bezierCurveTo(x + 8.75648, y + 51.3105, x + 8.75533, y + 51.301, x + 8.77068, y + 51.2992);
ctx.bezierCurveTo(x + 8.96433, y + 51.1382, x + 8.96293, y + 50.6459, x + 8.94245, y + 50.4426);
ctx.bezierCurveTo(x + 8.92285, y + 50.2478, x + 8.64915, y + 50.2497, x + 8.63901, y + 50.1529);
ctx.bezierCurveTo(x + 8.63833, y + 50.147, x + 8.63739, y + 50.14, x + 8.63705, y + 50.1334);
ctx.bezierCurveTo(x + 8.63509, y + 50.114, x + 8.64848, y + 50.0927, x + 8.64571, y + 50.0632);
ctx.bezierCurveTo(x + 8.62996, y + 49.9089, x + 8.50692, y + 49.6346, x + 8.20435, y + 49.6843);
ctx.bezierCurveTo(x + 7.68169, y + 49.7715, x + 7.07363, y + 50.2977, x + 7.10377, y + 50.5943);
ctx.bezierCurveTo(x + 7.10661, y + 50.6223, x + 7.10945, y + 50.6503, x + 7.12953, y + 50.6759);
ctx.bezierCurveTo(x + 7.13007, y + 50.685, x + 7.1469, y + 50.692, x + 7.1492, y + 50.7109);
ctx.bezierCurveTo(x + 7.16251, y + 50.8422, x + 6.97311, y + 51.1998, x + 7.01576, y + 51.6177);
ctx.bezierCurveTo(x + 7.0263, y + 51.7195, x + 7.41474, y + 51.7378, x + 7.43516, y + 51.9355);
ctx.bezierCurveTo(x + 7.45557, y + 52.1332, x + 6.95569, y + 52.2843, x + 6.96961, y + 52.4231);
ctx.bezierCurveTo(x + 6.98556, y + 52.5799, x + 7.40761, y + 52.621, x + 7.39679, y + 52.6693);
ctx.bezierCurveTo(x + 7.36055, y + 52.7865, x + 7.3767, y + 52.9458, x + 7.39542, y + 53.1322);
ctx.bezierCurveTo(x + 7.41076, y + 53.2814, x + 7.42577, y + 53.4313, x + 7.44111, y + 53.5805);
ctx.bezierCurveTo(x + 7.45612, y + 53.7304, x + 7.47146, y + 53.8797, x + 7.44975, y + 53.985);
ctx.bezierCurveTo(x + 7.45042, y + 53.991, x + 7.45076, y + 53.9976, x + 7.45144, y + 54.0035);
ctx.bezierCurveTo(x + 7.46995, y + 54.1873, x + 8.15716, y + 54.7757, x + 8.87649, y + 54.7378);
ctx.bezierCurveTo(x + 9.10063, y + 54.7289, x + 10.1352, y + 53.997, x + 10.0755, y + 53.3985);
ctx.bezierCurveTo(x + 10.0727, y + 53.3689, x + 10.1511, y + 53.3425, x + 10.2625, y + 53.3328);
ctx.bezierCurveTo(x + 10.2784, y + 53.3314, x + 10.2944, y + 53.3299, x + 10.311, y + 53.3288);
ctx.bezierCurveTo(x + 10.4235, y + 53.3286, x + 11.3285, y + 53.5369, x + 11.6501, y + 53.7088);
ctx.bezierCurveTo(x + 11.7522, y + 53.762, x + 12.2324, y + 54.2233, x + 12.2367, y + 54.2657);
ctx.bezierCurveTo(x + 12.293, y + 54.8447, x + 10.7136, y + 55.9224, x + 10.4248, y + 55.9214);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#F9ED32";

ctx.beginPath();
ctx.moveTo(x + 17.8848, y + 54.6585);
ctx.bezierCurveTo(x + 17.8626, y + 54.6037, x + 18.317, y + 54.4783, x + 18.2934, y + 54.2261);
ctx.bezierCurveTo(x + 18.275, y + 54.032, x + 17.6773, y + 54.1684, x + 17.666, y + 54.0549);
ctx.bezierCurveTo(x + 17.6267, y + 53.6469, x + 17.3431, y + 52.7129, x + 17.3431, y + 52.7129);
ctx.bezierCurveTo(x + 17.2178, y + 52.4039, x + 16.6344, y + 52.1965, x + 16.6344, y + 52.1965);
ctx.bezierCurveTo(x + 16.3631, y + 52.223, x + 15.7736, y + 52.6092, x + 15.7737, y + 52.6077);
ctx.bezierCurveTo(x + 15.782, y + 52.6947, x + 16.1986, y + 53.0061, x + 16.1986, y + 53.0061);
ctx.bezierCurveTo(x + 16.0731, y + 53.6943, x + 16.0921, y + 54.0671, x + 16.1097, y + 54.2439);
ctx.bezierCurveTo(x + 16.1135, y + 54.2844, x + 16.1174, y + 54.3249, x + 16.1216, y + 54.3649);
ctx.bezierCurveTo(x + 16.2022, y + 54.3604, x + 16.3907, y + 54.4835, x + 16.395, y + 54.5274);
ctx.bezierCurveTo(x + 16.4252, y + 54.8369, x + 16.5801, y + 55.2752, x + 16.5984, y + 55.4637);
ctx.bezierCurveTo(x + 16.6041, y + 55.5196, x + 16.6073, y + 55.5526, x + 16.5749, y + 55.5536);
ctx.bezierCurveTo(x + 15.9353, y + 55.577, x + 15.4218, y + 56.0721, x + 14.7811, y + 56.0861);
ctx.bezierCurveTo(x + 14.7328, y + 56.087, x + 14.211, y + 56.0045, x + 13.7627, y + 56.0165);
ctx.bezierCurveTo(x + 13.4417, y + 56.0232, x + 12.7277, y + 55.6085, x + 12.7276, y + 55.61);
ctx.bezierCurveTo(x + 12.9513, y + 55.2812, x + 12.8842, y + 54.2702, x + 12.8842, y + 54.2702);
ctx.bezierCurveTo(x + 12.8812, y + 54.2397, x + 13.3953, y + 54.0814, x + 13.3734, y + 53.8606);
ctx.bezierCurveTo(x + 13.3597, y + 53.7242, x + 12.8638, y + 53.7489, x + 12.8541, y + 53.6555);
ctx.bezierCurveTo(x + 12.7652, y + 52.753, x + 12.992, y + 52.2789, x + 12.9712, y + 52.069);
ctx.bezierCurveTo(x + 12.966, y + 52.0166, x + 12.9466, y + 51.9769, x + 12.8954, y + 51.9498);
ctx.bezierCurveTo(x + 12.6738, y + 51.8275, x + 12.7556, y + 50.3723, x + 12.3881, y + 49.7494);
ctx.bezierCurveTo(x + 12.3686, y + 49.7098, x + 12.6645, y + 49.6132, x + 12.6552, y + 49.5192);
ctx.bezierCurveTo(x + 12.6075, y + 49.037, x + 11.9334, y + 48.5791, x + 11.9276, y + 48.5191);
ctx.bezierCurveTo(x + 11.9159, y + 48.4006, x + 13.4114, y + 47.539, x + 14.4555, y + 47.3408);
ctx.bezierCurveTo(x + 14.6449, y + 47.3053, x + 14.9208, y + 47.8201, x + 14.9385, y + 47.9954);
ctx.bezierCurveTo(x + 14.9385, y + 47.9954, x + 15.0071, y + 48.0283, x + 15.0863, y + 48.015);
ctx.bezierCurveTo(x + 15.1186, y + 48.0099, x + 15.1336, y + 48.0072, x + 15.1632, y + 47.9797);
ctx.bezierCurveTo(x + 15.1634, y + 47.9822, x + 15.9933, y + 47.2326, x + 16.0868, y + 47.1905);
ctx.bezierCurveTo(x + 16.0868, y + 47.1905, x + 16.8578, y + 46.9946, x + 17.5874, y + 46.8633);
ctx.bezierCurveTo(x + 18.11, y + 46.7689, x + 18.6197, y + 46.7008, x + 18.7894, y + 46.7902);
ctx.bezierCurveTo(x + 18.7898, y + 46.788, x + 19.6365, y + 47.225, x + 19.6816, y + 47.7018);
ctx.bezierCurveTo(x + 19.6816, y + 47.7018, x + 19.3202, y + 47.9743, x + 19.3382, y + 48.1618);
ctx.bezierCurveTo(x + 19.3504, y + 48.2909, x + 19.5272, y + 48.2884, x + 19.7019, y + 48.2622);
ctx.bezierCurveTo(x + 19.8452, y + 48.2409, x + 19.9696, y + 48.1978, x + 20.0486, y + 48.1861);
ctx.bezierCurveTo(x + 20.0652, y + 48.1834, x + 20.0819, y + 48.1935, x + 20.0976, y + 48.1911);
ctx.bezierCurveTo(x + 20.1837, y + 48.2385, x + 20.2348, y + 48.4485, x + 20.2596, y + 48.7102);
ctx.bezierCurveTo(x + 20.3033, y + 49.175, x + 20.2499, y + 49.7965, x + 20.1317, y + 49.9062);
ctx.bezierCurveTo(x + 20.1317, y + 49.9062, x + 19.4084, y + 50.5957, x + 18.4108, y + 51.0941);
ctx.bezierCurveTo(x + 18.4108, y + 51.0941, x + 18.3416, y + 51.2176, x + 18.3455, y + 51.2637);
ctx.bezierCurveTo(x + 18.3462, y + 51.2753, x + 18.3648, y + 51.2849, x + 18.3802, y + 51.2831);
ctx.bezierCurveTo(x + 19.1438, y + 51.1997, x + 20.3013, y + 51.6931, x + 20.3252, y + 51.9463);
ctx.bezierCurveTo(x + 20.3252, y + 51.9463, x + 20.3089, y + 52.1154, x + 20.3347, y + 52.388);
ctx.bezierCurveTo(x + 20.3933, y + 53.0058, x + 20.6418, y + 54.0895, x + 21.6176, y + 54.7395);
ctx.bezierCurveTo(x + 21.6178, y + 54.7435, x + 21.6185, y + 54.7479, x + 21.619, y + 54.7514);
ctx.bezierCurveTo(x + 21.6314, y + 54.8886, x + 20.5534, y + 55.7033, x + 20.3124, y + 55.7052);
ctx.bezierCurveTo(x + 19.5444, y + 55.7246, x + 18.3824, y + 55.6522, x + 18.0918, y + 55.4689);
ctx.bezierCurveTo(x + 18.0392, y + 55.4386, x + 17.9832, y + 54.8478, x + 17.8848, y + 54.6585);
ctx.closePath();
ctx.moveTo(x + 16.863, y + 49.8995);
ctx.bezierCurveTo(x + 16.8516, y + 49.7764, x + 17.1497, y + 49.542, x + 17.1408, y + 49.4515);
ctx.bezierCurveTo(x + 17.0504, y + 48.5114, x + 16.472, y + 48.3524, x + 16.472, y + 48.3524);
ctx.bezierCurveTo(x + 16.1544, y + 48.4049, x + 15.4736, y + 48.8696, x + 15.4813, y + 48.945);
ctx.bezierCurveTo(x + 15.4817, y + 48.9484, x + 15.4822, y + 48.9519, x + 15.4823, y + 48.956);
ctx.bezierCurveTo(x + 15.6216, y + 49.0571, x + 15.8359, y + 49.4399, x + 15.8672, y + 49.7604);
ctx.bezierCurveTo(x + 15.8694, y + 49.7823, x + 15.6312, y + 49.9935, x + 15.6005, y + 49.9971);
ctx.bezierCurveTo(x + 15.6005, y + 49.9971, x + 15.745, y + 50.5016, x + 15.775, y + 50.8101);
ctx.bezierCurveTo(x + 15.7825, y + 50.8871, x + 15.7873, y + 50.9417, x + 15.7769, y + 50.9878);
ctx.bezierCurveTo(x + 15.7769, y + 50.9878, x + 15.9146, y + 51.0832, x + 16.042, y + 51.069);
ctx.bezierCurveTo(x + 16.2971, y + 51.0431, x + 17.1359, y + 50.3911, x + 17.1272, y + 50.2975);
ctx.bezierCurveTo(x + 17.1157, y + 50.1744, x + 16.8738, y + 50.0111, x + 16.863, y + 49.8995);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#F9ED32";

ctx.beginPath();
ctx.moveTo(x + 27.4694, y + 55.3331);
ctx.bezierCurveTo(x + 27.4642, y + 55.2806, x + 27.5404, y + 54.8813, x + 27.5027, y + 54.4717);
ctx.bezierCurveTo(x + 27.4817, y + 54.2449, x + 26.9856, y + 52.6829, x + 26.9858, y + 52.6854);
ctx.bezierCurveTo(x + 26.9748, y + 52.5673, x + 27.5564, y + 52.6082, x + 27.5362, y + 52.3827);
ctx.bezierCurveTo(x + 27.5168, y + 52.1704, x + 27.1788, y + 51.9948, x + 26.605, y + 52.0391);
ctx.bezierCurveTo(x + 26.2382, y + 52.068, x + 25.4311, y + 52.375, x + 25.3646, y + 52.5208);
ctx.bezierCurveTo(x + 25.2694, y + 52.7113, x + 25.1488, y + 54.5286, x + 25.2123, y + 55.214);
ctx.bezierCurveTo(x + 25.2247, y + 55.344, x + 23.7819, y + 55.7093, x + 22.997, y + 55.7258);
ctx.bezierCurveTo(x + 22.6764, y + 55.7318, x + 21.8058, y + 55.3406, x + 21.8063, y + 55.3425);
ctx.bezierCurveTo(x + 21.7546, y + 55.3079, x + 21.7504, y + 55.2592, x + 21.7477, y + 55.2353);
ctx.bezierCurveTo(x + 21.7474, y + 55.2272, x + 21.7462, y + 55.2193, x + 21.7454, y + 55.2108);
ctx.bezierCurveTo(x + 21.978, y + 54.9637, x + 22.331, y + 53.9311, x + 22.3304, y + 53.9292);
ctx.bezierCurveTo(x + 22.6337, y + 53.9142, x + 23.0635, y + 53.5185, x + 23.0551, y + 53.4314);
ctx.bezierCurveTo(x + 23.0399, y + 53.2703, x + 22.6665, y + 53.0709, x + 22.6577, y + 52.9733);
ctx.bezierCurveTo(x + 22.6575, y + 52.9692, x + 22.6564, y + 52.9654, x + 22.6563, y + 52.9613);
ctx.bezierCurveTo(x + 22.7032, y + 52.763, x + 23.148, y + 51.8553, x + 23.1407, y + 51.7792);
ctx.bezierCurveTo(x + 23.0891, y + 51.2308, x + 23.5809, y + 48.3983, x + 23.5267, y + 47.81);
ctx.bezierCurveTo(x + 23.52, y + 47.7343, x + 23.2608, y + 47.2136, x + 23.252, y + 47.1144);
ctx.bezierCurveTo(x + 23.2367, y + 46.9507, x + 25.6043, y + 45.5426, x + 25.7447, y + 45.4805);
ctx.bezierCurveTo(x + 25.9465, y + 45.4056, x + 26.3421, y + 45.3232, x + 26.6276, y + 45.2727);
ctx.bezierCurveTo(x + 27.8169, y + 45.0614, x + 28.8001, y + 45.2366, x + 28.8141, y + 45.3883);
ctx.bezierCurveTo(x + 28.8226, y + 45.4851, x + 28.5839, y + 46.5848, x + 28.6649, y + 47.4774);
ctx.bezierCurveTo(x + 28.6761, y + 47.5996, x + 28.9921, y + 47.5286, x + 28.9969, y + 47.5832);
ctx.bezierCurveTo(x + 29.0296, y + 47.9428, x + 29.901, y + 52.0529, x + 30.3334, y + 52.9399);
ctx.bezierCurveTo(x + 30.3342, y + 52.9443, x + 30.334, y + 52.949, x + 30.3344, y + 52.954);
ctx.bezierCurveTo(x + 30.343, y + 53.0507, x + 29.8584, y + 53.2016, x + 29.8833, y + 53.4745);
ctx.bezierCurveTo(x + 29.9229, y + 53.9123, x + 30.8796, y + 53.6619, x + 30.9047, y + 53.9389);
ctx.bezierCurveTo(x + 30.9047, y + 53.9389, x + 30.8913, y + 53.9674, x + 30.8964, y + 54.023);
ctx.bezierCurveTo(x + 30.9014, y + 54.0786, x + 30.9256, y + 54.1745, x + 30.972, y + 54.3267);
ctx.bezierCurveTo(x + 31.0633, y + 54.628, x + 31.5242, y + 55.1185, x + 31.5267, y + 55.147);
ctx.bezierCurveTo(x + 31.5568, y + 55.4868, x + 29.8834, y + 55.9589, x + 29.2589, y + 55.9651);
ctx.bezierCurveTo(x + 28.5065, y + 55.9734, x + 27.4812, y + 55.4628, x + 27.4694, y + 55.3331);
ctx.closePath();
ctx.moveTo(x + 26.4222, y + 48.4646);
ctx.bezierCurveTo(x + 26.4207, y + 48.447, x + 26.419, y + 48.43, x + 26.4169, y + 48.4121);
ctx.bezierCurveTo(x + 26.4023, y + 48.2544, x + 26.3918, y + 48.1367, x + 26.2479, y + 48.1561);
ctx.bezierCurveTo(x + 25.6432, y + 48.2373, x + 25.6339, y + 48.4743, x + 25.6395, y + 48.539);
ctx.bezierCurveTo(x + 25.6612, y + 48.7717, x + 25.7481, y + 49.0234, x + 25.7577, y + 49.1271);
ctx.bezierCurveTo(x + 25.7756, y + 49.3234, x + 25.4133, y + 49.9255, x + 25.4466, y + 50.2854);
ctx.bezierCurveTo(x + 25.4466, y + 50.2854, x + 25.4729, y + 50.5688, x + 25.5515, y + 50.5608);
ctx.bezierCurveTo(x + 25.8536, y + 50.5308, x + 26.0782, y + 50.3383, x + 26.4288, y + 50.3027);
ctx.bezierCurveTo(x + 26.7312, y + 50.272, x + 26.8067, y + 50.2104, x + 26.8022, y + 50.1583);
ctx.bezierCurveTo(x + 26.8011, y + 50.1458, x + 26.783, y + 50.134, x + 26.7817, y + 50.1205);
ctx.bezierCurveTo(x + 26.546, y + 49.6409, x + 26.444, y + 48.7014, x + 26.4222, y + 48.4646);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#F9ED32";

ctx.beginPath();
ctx.moveTo(x + 35.8155, y + 54.9612);
ctx.bezierCurveTo(x + 35.559, y + 54.9679, x + 35.4399, y + 55.4433, x + 35.2172, y + 55.4466);
ctx.bezierCurveTo(x + 32.814, y + 55.4857, x + 31.7675, y + 54.9065, x + 31.7681, y + 54.9084);
ctx.bezierCurveTo(x + 31.647, y + 54.8119, x + 31.3049, y + 53.507, x + 31.2251, y + 52.615);
ctx.bezierCurveTo(x + 31.2153, y + 52.5047, x + 32.0191, y + 51.9721, x + 32.0192, y + 51.9705);
ctx.bezierCurveTo(x + 32.2173, y + 51.8432, x + 32.801, y + 51.7309, x + 32.801, y + 51.7309);
ctx.bezierCurveTo(x + 32.8166, y + 51.73, x + 32.822, y + 51.7866, x + 32.827, y + 51.8437);
ctx.bezierCurveTo(x + 32.8385, y + 51.9725, x + 32.8392, y + 52.1583, x + 32.8392, y + 52.1583);
ctx.bezierCurveTo(x + 32.8483, y + 52.257, x + 33.336, y + 53.0502, x + 33.336, y + 53.0502);
ctx.bezierCurveTo(x + 33.3863, y + 53.076, x + 34.2776, y + 53.3509, x + 34.6617, y + 53.334);
ctx.bezierCurveTo(x + 35.3012, y + 53.3081, x + 35.8893, y + 52.3245, x + 35.8667, y + 52.0689);
ctx.bezierCurveTo(x + 35.8376, y + 51.7401, x + 35.2009, y + 51.0704, x + 35.2008, y + 51.072);
ctx.bezierCurveTo(x + 35.201, y + 51.0689, x + 33.9757, y + 50.4888, x + 33.7368, y + 50.5126);
ctx.bezierCurveTo(x + 33.4558, y + 50.6096, x + 33.3767, y + 50.6157, x + 33.3598, y + 50.6174);
ctx.bezierCurveTo(x + 33.2322, y + 50.6276, x + 32.9485, y + 50.3194, x + 32.9423, y + 50.2487);
ctx.bezierCurveTo(x + 32.9373, y + 50.1915, x + 33.0159, y + 49.8079, x + 33.0159, y + 49.8079);
ctx.bezierCurveTo(x + 33.0031, y + 49.6641, x + 32.6632, y + 49.6401, x + 32.6632, y + 49.6401);
ctx.bezierCurveTo(x + 32.5827, y + 49.6487, x + 32.2231, y + 49.7552, x + 32.2231, y + 49.7552);
ctx.bezierCurveTo(x + 31.9836, y + 49.7715, x + 30.6967, y + 48.5214, x + 30.6811, y + 48.348);
ctx.bezierCurveTo(x + 30.6665, y + 48.1831, x + 31.1954, y + 46.0042, x + 32.2023, y + 44.8305);
ctx.bezierCurveTo(x + 32.2022, y + 44.8321, x + 32.967, y + 44.18, x + 35.0456, y + 43.8202);
ctx.bezierCurveTo(x + 35.0456, y + 43.8202, x + 35.3509, y + 44.1757, x + 35.7483, y + 44.1103);
ctx.bezierCurveTo(x + 35.7483, y + 44.1103, x + 36.0846, y + 43.902, x + 36.0514, y + 43.526);
ctx.bezierCurveTo(x + 36.0489, y + 43.4959, x + 36.2864, y + 43.4401, x + 36.5722, y + 43.3906);
ctx.bezierCurveTo(x + 37.0325, y + 43.3108, x + 37.6237, y + 43.2555, x + 37.6394, y + 43.4401);
ctx.bezierCurveTo(x + 37.6394, y + 43.4401, x + 37.6817, y + 43.7292, x + 37.7134, y + 44.0979);
ctx.bezierCurveTo(x + 37.7352, y + 44.3435, x + 37.759, y + 44.6198, x + 37.7479, y + 44.8702);
ctx.bezierCurveTo(x + 37.7479, y + 44.8702, x + 37.9866, y + 45.5817, x + 37.9986, y + 45.7211);
ctx.bezierCurveTo(x + 37.9991, y + 45.7262, x + 37.9995, y + 45.7312, x + 37.9995, y + 45.7368);
ctx.bezierCurveTo(x + 37.8939, y + 46.0023, x + 37.1554, y + 46.5795, x + 36.9477, y + 46.6048);
ctx.bezierCurveTo(x + 36.9166, y + 46.609, x + 36.8997, y + 46.5963, x + 36.8973, y + 46.5662);
ctx.bezierCurveTo(x + 36.8695, y + 46.2437, x + 35.7905, y + 45.5104, x + 35.0597, y + 45.6235);
ctx.bezierCurveTo(x + 34.6781, y + 45.6834, x + 33.8452, y + 46.6483, x + 33.884, y + 47.0817);
ctx.bezierCurveTo(x + 33.884, y + 47.0817, x + 33.9965, y + 47.4356, x + 34.2509, y + 47.4037);
ctx.bezierCurveTo(x + 34.3468, y + 47.3918, x + 34.4378, y + 47.3356, x + 34.5712, y + 47.2);
ctx.bezierCurveTo(x + 34.5762, y + 47.1996, x + 34.5815, y + 47.1986, x + 34.5865, y + 47.1982);
ctx.bezierCurveTo(x + 34.761, y + 47.1695, x + 36.4082, y + 47.9624, x + 36.4876, y + 48.1428);
ctx.bezierCurveTo(x + 36.4876, y + 48.1428, x + 36.6756, y + 48.0913, x + 36.8354, y + 48.0736);
ctx.bezierCurveTo(x + 36.9162, y + 48.0644, x + 36.9803, y + 48.0724, x + 37.0129, y + 48.0842);
ctx.bezierCurveTo(x + 37.6241, y + 48.4573, x + 38.3366, y + 49.2405, x + 38.413, y + 49.3904);
ctx.bezierCurveTo(x + 38.5459, y + 49.6254, x + 38.8701, y + 50.4072, x + 39.0082, y + 52.0025);
ctx.bezierCurveTo(x + 39.0726, y + 52.7539, x + 37.0183, y + 55.3344, x + 36.3284, y + 55.3233);
ctx.bezierCurveTo(x + 36.1843, y + 55.3243, x + 36.1674, y + 54.9519, x + 35.8155, y + 54.9612);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#F9ED32";

ctx.beginPath();
ctx.moveTo(x + 48.6432, y + 53.9646);
ctx.bezierCurveTo(x + 48.6693, y + 54.283, x + 47.2336, y + 55.3388, x + 46.6245, y + 55.3402);
ctx.bezierCurveTo(x + 46.1283, y + 55.3423, x + 44.9211, y + 54.5125, x + 44.829, y + 54.3851);
ctx.bezierCurveTo(x + 44.7572, y + 54.2873, x + 44.6005, y + 52.7992, x + 44.6005, y + 52.7992);
ctx.bezierCurveTo(x + 44.592, y + 52.7009, x + 45.1446, y + 52.5929, x + 45.1038, y + 52.1096);
ctx.bezierCurveTo(x + 45.0759, y + 51.7759, x + 44.5419, y + 51.9223, x + 44.5308, y + 51.7898);
ctx.bezierCurveTo(x + 44.5183, y + 51.6413, x + 44.6461, y + 51.2509, x + 44.5948, y + 50.6371);
ctx.bezierCurveTo(x + 44.5598, y + 50.2226, x + 44.4586, y + 49.5968, x + 44.3899, y + 49.5352);
ctx.bezierCurveTo(x + 44.3391, y + 49.506, x + 44.3376, y + 49.49, x + 44.2256, y + 49.4992);
ctx.bezierCurveTo(x + 43.0135, y + 49.602, x + 42.3789, y + 50.2565, x + 42.4129, y + 50.6584);
ctx.bezierCurveTo(x + 42.4265, y + 50.8194, x + 42.6514, y + 50.8366, x + 42.7633, y + 50.8288);
ctx.bezierCurveTo(x + 42.8596, y + 50.822, x + 42.9373, y + 50.7839, x + 42.9842, y + 50.7813);
ctx.bezierCurveTo(x + 43.0007, y + 50.7802, x + 43.0184, y + 50.7957, x + 43.0184, y + 50.7957);
ctx.bezierCurveTo(x + 43.0349, y + 50.8106, x + 43.0367, y + 50.8275, x + 43.0408, y + 50.8762);
ctx.bezierCurveTo(x + 43.06, y + 51.1035, x + 43.0362, y + 51.7593, x + 43.1009, y + 52.5229);
ctx.bezierCurveTo(x + 43.1436, y + 53.0271, x + 43.2148, y + 53.4971, x + 43.323, y + 53.8198);
ctx.bezierCurveTo(x + 43.3879, y + 54.0135, x + 43.4608, y + 54.3221, x + 43.4776, y + 54.5177);
ctx.bezierCurveTo(x + 43.4847, y + 54.5984, x + 43.4732, y + 54.6479, x + 43.4587, y + 54.6654);
ctx.bezierCurveTo(x + 43.4459, y + 54.7014, x + 42.3486, y + 55.5638, x + 41.708, y + 55.5674);
ctx.bezierCurveTo(x + 41.3074, y + 55.5695, x + 39.7625, y + 55.1376, x + 39.7399, y + 54.8763);
ctx.bezierCurveTo(x + 39.7387, y + 54.8612, x + 39.7559, y + 54.8604, x + 39.754, y + 54.845);
ctx.bezierCurveTo(x + 40.0293, y + 54.3252, x + 40.2154, y + 53.1392, x + 39.9885, y + 50.5016);
ctx.bezierCurveTo(x + 39.9221, y + 49.7323, x + 39.7742, y + 48.9405, x + 39.7742, y + 48.9405);
ctx.bezierCurveTo(x + 39.5147, y + 48.7281, x + 39.4702, y + 48.4027, x + 39.4577, y + 48.2614);
ctx.bezierCurveTo(x + 39.4558, y + 48.2404, x + 39.4541, y + 48.2203, x + 39.4523, y + 48.1992);
ctx.bezierCurveTo(x + 39.445, y + 48.1216, x + 39.9221, y + 47.865, x + 39.8982, y + 47.5815);
ctx.bezierCurveTo(x + 39.8752, y + 47.3136, x + 39.4847, y + 47.2646, x + 39.4932, y + 47.1686);
ctx.bezierCurveTo(x + 39.5265, y + 46.9906, x + 39.5218, y + 46.7545, x + 39.5005, y + 46.5037);
ctx.bezierCurveTo(x + 39.4302, y + 45.6882, x + 39.15, y + 44.6833, x + 39.0623, y + 44.4128);
ctx.bezierCurveTo(x + 39.0596, y + 44.3817, x + 39.0427, y + 44.3691, x + 39.0412, y + 44.3531);
ctx.bezierCurveTo(x + 39.0408, y + 44.348, x + 39.0404, y + 44.343, x + 39.0397, y + 44.337);
ctx.bezierCurveTo(x + 39.0203, y + 44.1103, x + 40.7286, y + 42.8073, x + 41.1562, y + 42.7276);
ctx.bezierCurveTo(x + 41.3785, y + 42.689, x + 42.5031, y + 42.829, x + 42.5157, y + 42.9775);
ctx.bezierCurveTo(x + 42.528, y + 43.1251, x + 42.4692, y + 44.7173, x + 42.4447, y + 44.8019);
ctx.bezierCurveTo(x + 42.4195, y + 44.8877, x + 42.3484, y + 44.9958, x + 42.3551, y + 45.0771);
ctx.bezierCurveTo(x + 42.3799, y + 45.3691, x + 42.7465, y + 45.5175, x + 42.777, y + 45.8767);
ctx.bezierCurveTo(x + 42.7835, y + 45.9586, x + 42.5647, y + 46.2167, x + 42.6062, y + 46.7043);
ctx.bezierCurveTo(x + 42.6062, y + 46.7043, x + 42.6153, y + 46.9987, x + 42.6391, y + 47.2751);
ctx.bezierCurveTo(x + 42.6556, y + 47.4697, x + 42.6877, y + 47.6636, x + 42.7046, y + 47.6778);
ctx.bezierCurveTo(x + 42.7394, y + 47.7069, x + 42.8681, y + 47.7093, x + 43.0434, y + 47.6907);
ctx.bezierCurveTo(x + 43.3937, y + 47.6541, x + 43.897, y + 47.5185, x + 44.1022, y + 47.2792);
ctx.bezierCurveTo(x + 44.2167, y + 47.1171, x + 44.3287, y + 46.7193, x + 44.2001, y + 45.1934);
ctx.bezierCurveTo(x + 44.1555, y + 44.6624, x + 43.9747, y + 43.4622, x + 43.8887, y + 43.2246);
ctx.bezierCurveTo(x + 43.8883, y + 43.2196, x + 43.8876, y + 43.2137, x + 43.8872, y + 43.2086);
ctx.bezierCurveTo(x + 43.8693, y + 42.9979, x + 45.1194, y + 41.7606, x + 45.66, y + 41.6627);
ctx.bezierCurveTo(x + 46.0723, y + 41.5904, x + 47.218, y + 41.7975, x + 47.2398, y + 42.0574);
ctx.bezierCurveTo(x + 47.2405, y + 42.0634, x + 47.2405, y + 42.069, x + 47.2412, y + 42.075);
ctx.bezierCurveTo(x + 47.2412, y + 42.075, x + 46.939, y + 43.0994, x + 47.0644, y + 44.6067);
ctx.bezierCurveTo(x + 47.0903, y + 44.9153, x + 47.1696, y + 45.4944, x + 47.1811, y + 45.632);
ctx.bezierCurveTo(x + 47.2063, y + 45.7332, x + 46.776, y + 45.9745, x + 46.8014, y + 46.2812);
ctx.bezierCurveTo(x + 46.8155, y + 46.4514, x + 47.128, y + 46.7277, x + 47.3359, y + 46.705);
ctx.bezierCurveTo(x + 47.3672, y + 46.7017, x + 47.4192, y + 46.9386, x + 47.4396, y + 47.1795);
ctx.bezierCurveTo(x + 47.4519, y + 47.3342, x + 47.4638, y + 47.4711, x + 47.4384, y + 47.5601);
ctx.bezierCurveTo(x + 47.4017, y + 47.7026, x + 47.3326, y + 47.8302, x + 47.3072, y + 47.9191);
ctx.bezierCurveTo(x + 47.3141, y + 47.9988, x + 47.3205, y + 48.0792, x + 47.3274, y + 48.159);
ctx.bezierCurveTo(x + 47.3929, y + 48.947, x + 47.6541, y + 51.3257, x + 47.7548, y + 51.5627);
ctx.bezierCurveTo(x + 47.7555, y + 51.5686, x + 47.7555, y + 51.5743, x + 47.7562, y + 51.5803);
ctx.bezierCurveTo(x + 47.7677, y + 51.7178, x + 47.3526, y + 51.946, x + 47.3866, y + 52.355);
ctx.bezierCurveTo(x + 47.4105, y + 52.6458, x + 47.9353, y + 52.5893, x + 47.9393, y + 52.6411);
ctx.bezierCurveTo(x + 47.9436, y + 52.6922, x + 48.2202, y + 53.5081, x + 48.6233, y + 53.9143);
ctx.bezierCurveTo(x + 48.6401, y + 53.93, x + 48.6415, y + 53.9476, x + 48.6432, y + 53.9646);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#F9ED32";

ctx.beginPath();
ctx.moveTo(x + 57.9566, y + 53.7271);
ctx.bezierCurveTo(x + 57.9838, y + 54.078, x + 56.5545, y + 55.2358, x + 55.9462, y + 55.2344);
ctx.bezierCurveTo(x + 55.4494, y + 55.2346, x + 54.237, y + 54.3076, x + 54.146, y + 54.1655);
ctx.bezierCurveTo(x + 54.0734, y + 54.0562, x + 53.9069, y + 52.4059, x + 53.9069, y + 52.4059);
ctx.bezierCurveTo(x + 53.8982, y + 52.2963, x + 54.4505, y + 52.1817, x + 54.4076, y + 51.6461);
ctx.bezierCurveTo(x + 54.3781, y + 51.2763, x + 53.8444, y + 51.4325, x + 53.8323, y + 51.2859);
ctx.bezierCurveTo(x + 53.8192, y + 51.1211, x + 53.9451, y + 50.6895, x + 53.8902, y + 50.0089);
ctx.bezierCurveTo(x + 53.8531, y + 49.5493, x + 53.7486, y + 48.8546, x + 53.6793, y + 48.7854);
ctx.bezierCurveTo(x + 53.628, y + 48.7527, x + 53.6269, y + 48.7346, x + 53.5162, y + 48.743);
ctx.bezierCurveTo(x + 52.3021, y + 48.8406, x + 51.6704, y + 49.559, x + 51.7065, y + 50.0061);
ctx.bezierCurveTo(x + 51.7212, y + 50.1853, x + 51.9478, y + 50.2066, x + 52.0593, y + 50.1995);
ctx.bezierCurveTo(x + 52.1553, y + 50.1932, x + 52.2322, y + 50.1523, x + 52.2803, y + 50.1489);
ctx.bezierCurveTo(x + 52.2959, y + 50.148, x + 52.3136, y + 50.1651, x + 52.3136, y + 50.1651);
ctx.bezierCurveTo(x + 52.3316, y + 50.1816, x + 52.3333, y + 50.2001, x + 52.3375, y + 50.2544);
ctx.bezierCurveTo(x + 52.3577, y + 50.5071, x + 52.3361, y + 51.2352, x + 52.4049, y + 52.0835);
ctx.bezierCurveTo(x + 52.4508, y + 52.6439, x + 52.5256, y + 53.1662, x + 52.6344, y + 53.5252);
ctx.bezierCurveTo(x + 52.7005, y + 53.7412, x + 52.776, y + 54.084, x + 52.7943, y + 54.3013);
ctx.bezierCurveTo(x + 52.801, y + 54.3914, x + 52.7905, y + 54.4462, x + 52.7748, y + 54.4646);
ctx.bezierCurveTo(x + 52.7621, y + 54.5047, x + 51.67, y + 55.4555, x + 51.0285, y + 55.4563);
ctx.bezierCurveTo(x + 50.628, y + 55.4568, x + 49.0823, y + 54.966, x + 49.0576, y + 54.674);
ctx.bezierCurveTo(x + 49.0558, y + 54.657, x + 49.072, y + 54.6565, x + 49.0706, y + 54.6389);
ctx.bezierCurveTo(x + 49.3441, y + 54.0606, x + 49.5241, y + 52.7401, x + 49.2814, y + 49.7986);
ctx.bezierCurveTo(x + 49.2108, y + 48.9406, x + 49.0569, y + 48.0559, x + 49.0569, y + 48.0559);
ctx.bezierCurveTo(x + 48.7961, y + 47.8157, x + 48.7499, y + 47.4517, x + 48.7374, y + 47.2944);
ctx.bezierCurveTo(x + 48.7353, y + 47.2709, x + 48.7335, y + 47.2483, x + 48.7314, y + 47.2247);
ctx.bezierCurveTo(x + 48.7246, y + 47.1378, x + 49.1997, y + 46.8601, x + 49.1742, y + 46.5436);
ctx.bezierCurveTo(x + 49.1497, y + 46.2454, x + 48.7585, y + 46.1831, x + 48.765, y + 46.0765);
ctx.bezierCurveTo(x + 48.7969, y + 45.8793, x + 48.7909, y + 45.6154, x + 48.7678, y + 45.3362);
ctx.bezierCurveTo(x + 48.6926, y + 44.4261, x + 48.4072, y + 43.3008, x + 48.3185, y + 42.9978);
ctx.bezierCurveTo(x + 48.3156, y + 42.9626, x + 48.2988, y + 42.9484, x + 48.2974, y + 42.9308);
ctx.bezierCurveTo(x + 48.2967, y + 42.9248, x + 48.2966, y + 42.9192, x + 48.296, y + 42.9132);
ctx.bezierCurveTo(x + 48.2745, y + 42.6598, x + 49.9776, y + 41.2483, x + 50.4076, y + 41.17);
ctx.bezierCurveTo(x + 50.6296, y + 41.132, x + 51.7559, y + 41.3137, x + 51.7693, y + 41.4779);
ctx.bezierCurveTo(x + 51.7828, y + 41.6421, x + 51.7331, y + 43.4064, x + 51.7081, y + 43.5004);
ctx.bezierCurveTo(x + 51.6844, y + 43.595, x + 51.6128, y + 43.714, x + 51.6201, y + 43.8044);
ctx.bezierCurveTo(x + 51.6463, y + 44.1284, x + 52.0156, y + 44.3007, x + 52.0476, y + 44.6991);
ctx.bezierCurveTo(x + 52.0552, y + 44.7904, x + 51.8357, y + 45.0729, x + 51.8795, y + 45.6138);
ctx.bezierCurveTo(x + 51.8795, y + 45.6138, x + 51.8906, y + 45.9405, x + 51.9156, y + 46.2479);
ctx.bezierCurveTo(x + 51.933, y + 46.4639, x + 51.9667, y + 46.6793, x + 51.9847, y + 46.6958);
ctx.bezierCurveTo(x + 52.0191, y + 46.7286, x + 52.1473, y + 46.7332, x + 52.3239, y + 46.7153);
ctx.bezierCurveTo(x + 52.6745, y + 46.6797, x + 53.1771, y + 46.5381, x + 53.3814, y + 46.2759);
ctx.bezierCurveTo(x + 53.4954, y + 46.0975, x + 53.6041, y + 45.6595, x + 53.4675, y + 43.9668);
ctx.bezierCurveTo(x + 53.4201, y + 43.3776, x + 53.2326, y + 42.0456, x + 53.1468, y + 41.7803);
ctx.bezierCurveTo(x + 53.1462, y + 41.7743, x + 53.1461, y + 41.7686, x + 53.1454, y + 41.7627);
ctx.bezierCurveTo(x + 53.126, y + 41.5288, x + 54.3722, y + 40.1862, x + 54.9115, y + 40.0907);
ctx.bezierCurveTo(x + 55.3244, y + 40.0203, x + 56.4731, y + 40.2738, x + 56.4958, y + 40.5607);
ctx.bezierCurveTo(x + 56.4962, y + 40.5673, x + 56.4969, y + 40.5733, x + 56.4972, y + 40.5798);
ctx.bezierCurveTo(x + 56.4972, y + 40.5798, x + 56.1994, y + 41.7042, x + 56.3316, y + 43.3704);
ctx.bezierCurveTo(x + 56.3586, y + 43.7116, x + 56.4421, y + 44.3523, x + 56.4542, y + 44.5045);
ctx.bezierCurveTo(x + 56.4789, y + 44.6167, x + 56.0488, y + 44.8764, x + 56.0762, y + 45.2154);
ctx.bezierCurveTo(x + 56.091, y + 45.4044, x + 56.4052, y + 45.7137, x + 56.613, y + 45.6925);
ctx.bezierCurveTo(x + 56.6453, y + 45.6889, x + 56.6975, y + 45.9516, x + 56.719, y + 46.2178);
ctx.bezierCurveTo(x + 56.7328, y + 46.3886, x + 56.7442, y + 46.5405, x + 56.721, y + 46.6386);
ctx.bezierCurveTo(x + 56.6852, y + 46.7952, x + 56.6152, y + 46.9359, x + 56.5911, y + 47.0327);
ctx.bezierCurveTo(x + 56.5978, y + 47.1212, x + 56.6052, y + 47.21, x + 56.6123, y + 47.2979);
ctx.bezierCurveTo(x + 56.6817, y + 48.1697, x + 56.9544, y + 50.7994, x + 57.0549, y + 51.0627);
ctx.bezierCurveTo(x + 57.0552, y + 51.0693, x + 57.0559, y + 51.0753, x + 57.0563, y + 51.0818);
ctx.bezierCurveTo(x + 57.0677, y + 51.2337, x + 56.6553, y + 51.4817, x + 56.6914, y + 51.9344);
ctx.bezierCurveTo(x + 56.7174, y + 52.2559, x + 57.2413, y + 52.1981, x + 57.2457, y + 52.2549);
ctx.bezierCurveTo(x + 57.2504, y + 52.3111, x + 57.5307, y + 53.2153, x + 57.9343, y + 53.6666);
ctx.bezierCurveTo(x + 57.9539, y + 53.6888, x + 57.9549, y + 53.7085, x + 57.9566, y + 53.7271);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#F9ED32";

ctx.beginPath();
ctx.moveTo(x + 67.272, y + 53.5292);
ctx.bezierCurveTo(x + 67.3012, y + 53.9125, x + 65.875, y + 55.1727, x + 65.2655, y + 55.169);
ctx.bezierCurveTo(x + 64.7701, y + 55.1668, x + 63.5538, y + 54.1433, x + 63.4609, y + 53.9858);
ctx.bezierCurveTo(x + 63.3878, y + 53.8658, x + 63.2162, y + 52.052, x + 63.2162, y + 52.052);
ctx.bezierCurveTo(x + 63.2071, y + 51.9318, x + 63.759, y + 51.8105, x + 63.7135, y + 51.2223);
ctx.bezierCurveTo(x + 63.6818, y + 50.8161, x + 63.1494, y + 50.9827, x + 63.1365, y + 50.8219);
ctx.bezierCurveTo(x + 63.1228, y + 50.6408, x + 63.2468, y + 50.1683, x + 63.1891, y + 49.4206);
ctx.bezierCurveTo(x + 63.1503, y + 48.9152, x + 63.0431, y + 48.1518, x + 62.9729, y + 48.0758);
ctx.bezierCurveTo(x + 62.9215, y + 48.039, x + 62.9205, y + 48.0193, x + 62.8082, y + 48.0276);
ctx.bezierCurveTo(x + 61.5952, y + 48.1203, x + 60.9658, y + 48.9023, x + 61.0045, y + 49.3948);
ctx.bezierCurveTo(x + 61.0197, y + 49.592, x + 61.2457, y + 49.6185, x + 61.3573, y + 49.6114);
ctx.bezierCurveTo(x + 61.4539, y + 49.6055, x + 61.5312, y + 49.5608, x + 61.5781, y + 49.5583);
ctx.bezierCurveTo(x + 61.5953, y + 49.5575, x + 61.6119, y + 49.5764, x + 61.6119, y + 49.5764);
ctx.bezierCurveTo(x + 61.6295, y + 49.595, x + 61.6311, y + 49.6151, x + 61.6354, y + 49.6751);
ctx.bezierCurveTo(x + 61.6566, y + 49.9532, x + 61.6391, y + 50.7531, x + 61.7121, y + 51.686);
ctx.bezierCurveTo(x + 61.7595, y + 52.3025, x + 61.8356, y + 52.8774, x + 61.9478, y + 53.2735);
ctx.bezierCurveTo(x + 62.0144, y + 53.5114, x + 62.0906, y + 53.889, x + 62.1095, y + 54.1282);
ctx.bezierCurveTo(x + 62.1171, y + 54.2267, x + 62.1067, y + 54.2872, x + 62.0921, y + 54.3078);
ctx.bezierCurveTo(x + 62.0799, y + 54.3514, x + 60.9901, y + 55.3915, x + 60.3504, y + 55.3892);
ctx.bezierCurveTo(x + 59.9499, y + 55.3882, x + 58.4002, y + 54.8384, x + 58.3749, y + 54.5157);
ctx.bezierCurveTo(x + 58.3732, y + 54.4972, x + 58.39, y + 54.497, x + 58.389, y + 54.4772);
ctx.bezierCurveTo(x + 58.6582, y + 53.8405, x + 58.8322, y + 52.3855, x + 58.5768, y + 49.1403);
ctx.bezierCurveTo(x + 58.5025, y + 48.1939, x + 58.3458, y + 47.2165, x + 58.3458, y + 47.2165);
ctx.bezierCurveTo(x + 58.0841, y + 46.9478, x + 58.0348, y + 46.5461, x + 58.0214, y + 46.3732);
ctx.bezierCurveTo(x + 58.0197, y + 46.3475, x + 58.0171, y + 46.322, x + 58.0154, y + 46.2963);
ctx.bezierCurveTo(x + 58.008, y + 46.2002, x + 58.4832, y + 45.901, x + 58.4556, y + 45.5522);
ctx.bezierCurveTo(x + 58.4294, y + 45.2226, x + 58.038, y + 45.1491, x + 58.0453, y + 45.0309);
ctx.bezierCurveTo(x + 58.0772, y + 44.8137, x + 58.0698, y + 44.5234, x + 58.0455, y + 44.2148);
ctx.bezierCurveTo(x + 57.9666, y + 43.2106, x + 57.6743, y + 41.9656, x + 57.5838, y + 41.6296);
ctx.bezierCurveTo(x + 57.5805, y + 41.591, x + 57.5641, y + 41.5746, x + 57.5621, y + 41.5551);
ctx.bezierCurveTo(x + 57.5618, y + 41.5485, x + 57.5615, y + 41.5419, x + 57.5602, y + 41.5356);
ctx.bezierCurveTo(x + 57.5381, y + 41.2547, x + 59.2386, y + 39.7354, x + 59.6674, y + 39.6596);
ctx.bezierCurveTo(x + 59.8906, y + 39.6222, x + 61.0197, y + 39.8447, x + 61.0337, y + 40.0252);
ctx.bezierCurveTo(x + 61.0477, y + 40.2057, x + 61.0039, y + 42.1436, x + 60.9808, y + 42.2457);
ctx.bezierCurveTo(x + 60.956, y + 42.3494, x + 60.8859, y + 42.4788, x + 60.8937, y + 42.5783);
ctx.bezierCurveTo(x + 60.9216, y + 42.9352, x + 61.2902, y + 43.1303, x + 61.3245, y + 43.5692);
ctx.bezierCurveTo(x + 61.332, y + 43.6693, x + 61.1152, y + 43.9756, x + 61.1613, y + 44.5714);
ctx.bezierCurveTo(x + 61.1613, y + 44.5714, x + 61.1735, y + 44.9307, x + 61.1997, y + 45.2691);
ctx.bezierCurveTo(x + 61.2187, y + 45.5067, x + 61.2523, y + 45.7438, x + 61.2696, y + 45.763);
ctx.bezierCurveTo(x + 61.3051, y + 45.7997, x + 61.4338, y + 45.8061, x + 61.6097, y + 45.7894);
ctx.bezierCurveTo(x + 61.9602, y + 45.7554, x + 62.4635, y + 45.6069, x + 62.6663, y + 45.3215);
ctx.bezierCurveTo(x + 62.7794, y + 45.1274, x + 62.8877, y + 44.6485, x + 62.7446, y + 42.789);
ctx.bezierCurveTo(x + 62.6951, y + 42.1418, x + 62.5021, y + 40.6773, x + 62.4138, y + 40.3849);
ctx.bezierCurveTo(x + 62.4134, y + 40.3784, x + 62.4125, y + 40.3714, x + 62.4121, y + 40.3648);
ctx.bezierCurveTo(x + 62.3921, y + 40.1075, x + 63.6342, y + 38.6602, x + 64.1762, y + 38.567);
ctx.bezierCurveTo(x + 64.5896, y + 38.4985, x + 65.7401, y + 38.7978, x + 65.7642, y + 39.1126);
ctx.bezierCurveTo(x + 65.7651, y + 39.1195, x + 65.7651, y + 39.1267, x + 65.7661, y + 39.1336);
ctx.bezierCurveTo(x + 65.7661, y + 39.1336, x + 65.4721, y + 40.3576, x + 65.6111, y + 42.1827);
ctx.bezierCurveTo(x + 65.6391, y + 42.5565, x + 65.7243, y + 43.2589, x + 65.737, y + 43.4258);
ctx.bezierCurveTo(x + 65.7632, y + 43.5484, x + 65.3341, y + 43.8263, x + 65.3622, y + 44.1986);
ctx.bezierCurveTo(x + 65.3782, y + 44.4057, x + 65.6937, y + 44.7485, x + 65.9012, y + 44.7279);
ctx.bezierCurveTo(x + 65.9325, y + 44.7247, x + 65.9873, y + 45.0127, x + 66.0093, y + 45.304);
ctx.bezierCurveTo(x + 66.0236, y + 45.4911, x + 66.0361, y + 45.6571, x + 66.0118, y + 45.7642);
ctx.bezierCurveTo(x + 65.9766, y + 45.9356, x + 65.908, y + 46.0882, x + 65.8838, y + 46.1938);
ctx.bezierCurveTo(x + 65.8914, y + 46.2908, x + 65.8984, y + 46.3874, x + 65.9061, y + 46.4844);
ctx.bezierCurveTo(x + 65.9781, y + 47.4392, x + 66.2617, y + 50.3213, x + 66.3648, y + 50.61);
ctx.bezierCurveTo(x + 66.3652, y + 50.6166, x + 66.3658, y + 50.6241, x + 66.3667, y + 50.631);
ctx.bezierCurveTo(x + 66.3792, y + 50.797, x + 65.9658, y + 51.0653, x + 66.0035, y + 51.5613);
ctx.bezierCurveTo(x + 66.0306, y + 51.9137, x + 66.5546, y + 51.8544, x + 66.5591, y + 51.9169);
ctx.bezierCurveTo(x + 66.5639, y + 51.9787, x + 66.8475, y + 52.9703, x + 67.2548, y + 53.4668);
ctx.bezierCurveTo(x + 67.2689, y + 53.4875, x + 67.2704, y + 53.5091, x + 67.272, y + 53.5292);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#F9ED32";

ctx.beginPath();
ctx.moveTo(x + 70.2407, y + 51.3812);
ctx.bezierCurveTo(x + 70.3681, y + 51.3758, x + 70.616, y + 52.9902, x + 70.616, y + 52.9902);
ctx.bezierCurveTo(x + 70.6353, y + 53.2504, x + 70.4176, y + 53.9872, x + 70.3384, y + 53.9876);
ctx.bezierCurveTo(x + 70.3062, y + 53.988, x + 70.2245, y + 53.9671, x + 70.1282, y + 53.9683);
ctx.bezierCurveTo(x + 69.9844, y + 53.9702, x + 69.8122, y + 54.0162, x + 69.6969, y + 54.1883);
ctx.bezierCurveTo(x + 69.6676, y + 54.2311, x + 69.6701, y + 54.274, x + 69.6751, y + 54.3384);
ctx.bezierCurveTo(x + 69.6845, y + 54.4668, x + 69.7301, y + 54.6378, x + 69.7364, y + 54.7228);
ctx.bezierCurveTo(x + 69.7398, y + 54.7655, x + 69.7246, y + 54.7873, x + 69.7087, y + 54.7872);
ctx.bezierCurveTo(x + 69.6289, y + 54.7874, x + 69.5487, y + 54.7881, x + 69.4689, y + 54.7882);
ctx.bezierCurveTo(x + 69.0689, y + 54.7906, x + 68.2945, y + 54.7291, x + 67.8905, y + 54.2496);
ctx.bezierCurveTo(x + 67.8018, y + 54.1448, x + 67.5168, y + 53.1196, x + 67.4722, y + 52.5326);
ctx.bezierCurveTo(x + 67.4579, y + 52.3439, x + 67.4624, y + 52.1962, x + 67.5061, y + 52.1319);
ctx.bezierCurveTo(x + 67.7649, y + 51.7467, x + 68.2025, y + 50.7356, x + 69.081, y + 50.6956);
ctx.bezierCurveTo(x + 69.1941, y + 50.6901, x + 69.7772, y + 51.3961, x + 70.2407, y + 51.3812);
ctx.closePath();
ctx.moveTo(x + 68.1249, y + 38.1423);
ctx.bezierCurveTo(x + 68.204, y + 38.129, x + 69.0086, y + 38.3274, x + 69.2379, y + 38.3797);
ctx.bezierCurveTo(x + 69.4676, y + 38.4315, x + 69.9956, y + 38.3952, x + 70.0037, y + 38.5028);
ctx.bezierCurveTo(x + 70.0115, y + 38.6111, x + 70.139, y + 41.3996, x + 69.6942, y + 42.126);
ctx.bezierCurveTo(x + 69.6666, y + 42.173, x + 69.654, y + 42.2387, x + 69.6574, y + 42.283);
ctx.bezierCurveTo(x + 69.6734, y + 42.4973, x + 69.9768, y + 42.6807, x + 69.9861, y + 42.8106);
ctx.bezierCurveTo(x + 69.9973, y + 42.9632, x + 69.7594, y + 44.5104, x + 69.8558, y + 45.8011);
ctx.bezierCurveTo(x + 69.8624, y + 45.8871, x + 70.0913, y + 46.1503, x + 70.1056, y + 46.3445);
ctx.bezierCurveTo(x + 70.1087, y + 46.3879, x + 70.1122, y + 46.4305, x + 70.0809, y + 46.4554);
ctx.bezierCurveTo(x + 69.997, y + 46.6139, x + 69.8087, y + 47.1049, x + 69.8087, y + 47.1049);
ctx.bezierCurveTo(x + 69.7514, y + 47.1952, x + 69.7489, y + 47.3896, x + 69.7683, y + 47.6483);
ctx.bezierCurveTo(x + 69.8054, y + 48.1423, x + 69.9344, y + 48.7829, x + 69.9344, y + 48.7829);
ctx.bezierCurveTo(x + 69.9344, y + 48.7845, x + 69.2979, y + 49.7258, x + 68.5945, y + 49.7591);
ctx.bezierCurveTo(x + 68.498, y + 49.7635, x + 67.8942, y + 49.4128, x + 67.8768, y + 49.1809);
ctx.bezierCurveTo(x + 67.8768, y + 49.1809, x + 67.6796, y + 46.5628, x + 67.5764, y + 46.254);
ctx.bezierCurveTo(x + 67.5764, y + 46.254, x + 67.326, y + 45.703, x + 67.3064, y + 45.4506);
ctx.bezierCurveTo(x + 67.3033, y + 45.4089, x + 67.3154, y + 45.3653, x + 67.3308, y + 45.3419);
ctx.bezierCurveTo(x + 67.3308, y + 45.3419, x + 67.5658, y + 44.8531, x + 67.55, y + 44.6412);
ctx.bezierCurveTo(x + 67.5226, y + 44.2821, x + 66.9761, y + 44.0627, x + 66.9681, y + 43.9591);
ctx.bezierCurveTo(x + 66.9472, y + 43.686, x + 67.2181, y + 43.21, x + 67.207, y + 43.0631);
ctx.bezierCurveTo(x + 67.1415, y + 42.1959, x + 66.5598, y + 40.2556, x + 66.4951, y + 39.3984);
ctx.bezierCurveTo(x + 66.4709, y + 39.0651, x + 67.7597, y + 38.2026, x + 68.1249, y + 38.1423);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.restore();

  }

  drawElementPhoneTwo(ctx, scale, x, y) {

    x = x / scale;
    y = y / scale;

ctx.save();
ctx.strokeStyle="rgba(0,0,0,0)";
ctx.miterLimit=4;

ctx.fillStyle="rgba(0,0,0,0)";

ctx.save();
ctx.fillStyle="#ED1B24";

ctx.beginPath();
ctx.moveTo(x + 51.8304, y + 41.1113);
ctx.bezierCurveTo(x + 51.8555, y + 41.1362, x + 51.8555, y + 41.1611, x + 51.8555, y + 41.1611);
ctx.bezierCurveTo(x + 51.8806, y + 41.186, x + 51.8806, y + 41.2109, x + 51.9057, y + 41.2358);
ctx.bezierCurveTo(x + 53.9628, y + 44.222, x + 53.5363, y + 49.3983, x + 50.3753, y + 58.0834);
ctx.bezierCurveTo(x + 47.1641, y + 66.8929, x + 46.1105, y + 70.6009, x + 43.5767, y + 72.2434);
ctx.lineTo(x + 53.1098, y + 81.8742);
ctx.bezierCurveTo(x + 58.6792, y + 70.0534, x + 63.5713, y + 50.6674, x + 65.227, y + 41.7086);
ctx.lineTo(x + 51.8304, y + 41.1113);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 65.227, y + 41.6837);
ctx.bezierCurveTo(x + 63.5712, y + 50.6425, x + 58.6792, y + 70.0036, x + 53.1098, y + 81.8492);
ctx.bezierCurveTo(x + 53.5112, y + 79.709, x + 51.8805, y + 77.0463, x + 51.8805, y + 77.0463);
ctx.bezierCurveTo(x + 51.8805, y + 77.0463, x + 54.6401, y + 70.2276, x + 56.0199, y + 66.9178);
ctx.bezierCurveTo(x + 56.2206, y + 67.2164, x + 56.2708, y + 68.2367, x + 56.2708, y + 68.2367);
ctx.bezierCurveTo(x + 56.5468, y + 67.2662, x + 56.4464, y + 65.8726, x + 56.4464, y + 65.8726);
ctx.bezierCurveTo(x + 56.3962, y + 65.6984, x + 56.3461, y + 65.4993, x + 56.2959, y + 65.3251);
ctx.bezierCurveTo(x + 56.2206, y + 65.0762, x + 56.1454, y + 64.8523, x + 56.045, y + 64.6034);
ctx.bezierCurveTo(x + 55.8443, y + 64.1306, x + 55.5935, y + 63.6577, x + 55.3677, y + 63.1849);
ctx.bezierCurveTo(x + 55.7189, y + 63.5831, x + 56.0701, y + 63.9813, x + 56.3712, y + 64.4292);
ctx.bezierCurveTo(x + 56.5217, y + 64.6532, x + 56.6471, y + 64.8771, x + 56.7726, y + 65.1011);
ctx.bezierCurveTo(x + 57.7008, y + 62.8614, x + 58.4283, y + 60.7959, x + 58.8548, y + 59.3774);
ctx.bezierCurveTo(x + 59.3064, y + 57.9091, x + 60.3851, y + 52.9569, x + 61.1378, y + 48.2037);
ctx.bezierCurveTo(x + 61.2381, y + 47.6562, x + 61.0625, y + 47.0839, x + 60.6862, y + 46.6608);
ctx.bezierCurveTo(x + 60.3099, y + 46.2626, x + 59.8081, y + 45.8396, x + 59.2813, y + 45.5409);
ctx.bezierCurveTo(x + 59.1057, y + 45.4414, x + 58.9301, y + 45.3667, x + 58.7795, y + 45.2921);
ctx.bezierCurveTo(x + 58.5036, y + 45.1925, x + 58.2025, y + 45.3916, x + 58.2276, y + 45.6903);
ctx.bezierCurveTo(x + 58.2276, y + 45.7898, x + 58.2527, y + 45.8645, x + 58.2527, y + 45.964);
ctx.bezierCurveTo(x + 58.3781, y + 47.5567, x + 58.4785, y + 49.0747, x + 56.5719, y + 55.321);
ctx.bezierCurveTo(x + 55.2673, y + 59.5516, x + 54.2638, y + 62.6125, x + 53.6116, y + 64.6283);
ctx.bezierCurveTo(x + 53.1349, y + 66.1214, x + 52.8088, y + 67.0671, x + 52.6331, y + 67.6644);
ctx.lineTo(x + 48.1174, y + 71.0986);
ctx.lineTo(x + 52.1565, y + 67.3657);
ctx.bezierCurveTo(x + 52.3321, y + 66.7436, x + 52.6332, y + 65.7979, x + 53.0847, y + 64.4541);
ctx.bezierCurveTo(x + 53.737, y + 62.4383, x + 54.7405, y + 59.4023, x + 56.045, y + 55.1468);
ctx.bezierCurveTo(x + 57.9266, y + 49.0001, x + 57.8262, y + 47.5318, x + 57.7259, y + 45.9889);
ctx.bezierCurveTo(x + 57.7008, y + 45.6903, x + 57.5001, y + 44.4709, x + 57.2743, y + 43.998);
ctx.bezierCurveTo(x + 53.6868, y + 43.1768, x + 52.2819, y + 41.609, x + 51.9558, y + 41.1859);
ctx.bezierCurveTo(x + 51.9307, y + 41.161, x + 51.9307, y + 41.1362, x + 51.9056, y + 41.1113);
ctx.bezierCurveTo(x + 51.9056, y + 41.0864, x + 51.8805, y + 41.0864, x + 51.8805, y + 41.0615);
ctx.lineTo(x + 51.8805, y + 41.0366);
ctx.lineTo(x + 65.227, y + 41.6837);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#ED1B24";

ctx.beginPath();
ctx.moveTo(x + 64.4241, y + 43.3508);
ctx.bezierCurveTo(x + 64.0227, y + 44.8937, x + 63.6464, y + 46.4367, x + 63.245, y + 47.9796);
ctx.bezierCurveTo(x + 63.0443, y + 48.751, x + 62.8436, y + 49.5225, x + 62.6429, y + 50.2939);
ctx.lineTo(x + 62.0408, y + 52.6083);
ctx.bezierCurveTo(x + 61.6143, y + 54.1512, x + 61.2129, y + 55.6942, x + 60.7864, y + 57.2122);
ctx.bezierCurveTo(x + 60.5857, y + 57.9836, x + 60.3599, y + 58.7551, x + 60.1592, y + 59.5017);
ctx.bezierCurveTo(x + 59.9335, y + 60.2731, x + 59.7328, y + 61.0446, x + 59.507, y + 61.7912);
ctx.bezierCurveTo(x + 59.0805, y + 63.3341, x + 58.6289, y + 64.8521, x + 58.1523, y + 66.3701);
ctx.bezierCurveTo(x + 57.9265, y + 67.1416, x + 57.7007, y + 67.8882, x + 57.4498, y + 68.6596);
ctx.lineTo(x + 56.7223, y + 70.9491);
ctx.lineTo(x + 55.9697, y + 73.2137);
ctx.lineTo(x + 55.192, y + 75.5032);
ctx.lineTo(x + 54.3892, y + 77.7678);
ctx.bezierCurveTo(x + 54.1132, y + 78.5144, x + 53.8372, y + 79.2609, x + 53.5613, y + 80.0075);
ctx.bezierCurveTo(x + 54.8909, y + 77.1208, x + 56.07, y + 74.1345, x + 57.1237, y + 71.1233);
ctx.bezierCurveTo(x + 57.6505, y + 69.6053, x + 58.1523, y + 68.1121, x + 58.6289, y + 66.5692);
ctx.bezierCurveTo(x + 58.8798, y + 65.8226, x + 59.1056, y + 65.0512, x + 59.3314, y + 64.2797);
ctx.bezierCurveTo(x + 59.5571, y + 63.5083, x + 59.7829, y + 62.7617, x + 60.0087, y + 61.9902);
ctx.bezierCurveTo(x + 60.8868, y + 58.9293, x + 61.6896, y + 55.8435, x + 62.4422, y + 52.7328);
ctx.bezierCurveTo(x + 63.1948, y + 49.622, x + 63.8471, y + 46.5113, x + 64.4241, y + 43.3508);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 53.2353, y + 82.4963);
ctx.lineTo(x + 53.4611, y + 81.9985);
ctx.bezierCurveTo(x + 58.8047, y + 70.6507, x + 63.772, y + 51.638, x + 65.6034, y + 41.7583);
ctx.lineTo(x + 65.6786, y + 41.3353);
ctx.lineTo(x + 51.2785, y + 40.6882);
ctx.lineTo(x + 51.5043, y + 41.2606);
ctx.lineTo(x + 51.5796, y + 41.3601);
ctx.bezierCurveTo(x + 51.6047, y + 41.385, x + 51.6047, y + 41.4099, x + 51.6297, y + 41.4348);
ctx.bezierCurveTo(x + 53.6367, y + 44.3215, x + 53.135, y + 49.4231, x + 50.0492, y + 57.934);
ctx.bezierCurveTo(x + 49.6478, y + 59.029, x + 49.2966, y + 60.0493, x + 48.9454, y + 60.995);
ctx.bezierCurveTo(x + 46.5872, y + 67.5399, x + 45.5084, y + 70.5262, x + 43.4011, y + 71.8949);
ctx.lineTo(x + 42.9746, y + 72.1687);
ctx.lineTo(x + 53.2353, y + 82.4963);
ctx.closePath();
ctx.moveTo(x + 64.7755, y + 42.0569);
ctx.bezierCurveTo(x + 62.919, y + 51.8619, x + 58.1524, y + 70.0285, x + 53.0095, y + 81.2022);
ctx.lineTo(x + 44.1537, y + 72.2682);
ctx.bezierCurveTo(x + 46.236, y + 70.6755, x + 47.3398, y + 67.5897, x + 49.6228, y + 61.2438);
ctx.bezierCurveTo(x + 49.974, y + 60.2982, x + 50.3252, y + 59.2779, x + 50.7266, y + 58.1829);
ctx.bezierCurveTo(x + 53.7622, y + 49.8462, x + 54.3141, y + 44.6451, x + 52.5329, y + 41.4846);
ctx.lineTo(x + 64.7755, y + 42.0569);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#ED1B24";

ctx.beginPath();
ctx.moveTo(x + 46.8881, y + 25.1595);
ctx.bezierCurveTo(x + 44.9313, y + 29.6389, x + 45.7843, y + 34.641, x + 48.6693, y + 38.2494);
ctx.bezierCurveTo(x + 49.9739, y + 39.8919, x + 51.73, y + 41.2606, x + 53.8122, y + 42.1565);
ctx.bezierCurveTo(x + 60.4855, y + 44.9934, x + 68.1873, y + 42.0071, x + 71.0221, y + 35.4622);
ctx.bezierCurveTo(x + 71.4486, y + 34.4917, x + 71.7246, y + 33.4962, x + 71.9002, y + 32.5257);
ctx.bezierCurveTo(x + 71.9754, y + 32.1026, x + 72.0256, y + 31.6547, x + 72.0507, y + 31.2316);
ctx.lineTo(x + 72.0507, y + 31.2067);
ctx.bezierCurveTo(x + 72.3768, y + 25.9061, x + 69.3413, y + 20.7299, x + 64.098, y + 18.4901);
ctx.bezierCurveTo(x + 57.4248, y + 15.6283, x + 49.723, y + 18.6146, x + 46.8881, y + 25.1595);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 53.6617, y + 42.5049);
ctx.bezierCurveTo(x + 60.5106, y + 45.4166, x + 68.4382, y + 42.3307, x + 71.3483, y + 35.6116);
ctx.bezierCurveTo(x + 71.7748, y + 34.6411, x + 72.0758, y + 33.6207, x + 72.2514, y + 32.5755);
ctx.bezierCurveTo(x + 72.3267, y + 32.1525, x + 72.3769, y + 31.7045, x + 72.4019, y + 31.2566);
ctx.bezierCurveTo(x + 72.4019, y + 31.2317, x + 72.4019, y + 31.2317, x + 72.4019, y + 31.2068);
ctx.bezierCurveTo(x + 72.7281, y + 25.6324, x + 69.4416, y + 20.3815, x + 64.2235, y + 18.1418);
ctx.bezierCurveTo(x + 57.3746, y + 15.2302, x + 49.447, y + 18.316, x + 46.5369, y + 25.0352);
ctx.bezierCurveTo(x + 44.6052, y + 29.4897, x + 45.3076, y + 34.6411, x + 48.3683, y + 38.4983);
ctx.bezierCurveTo(x + 49.7732, y + 40.2155, x + 51.6045, y + 41.6091, x + 53.6617, y + 42.5049);
ctx.closePath();
ctx.moveTo(x + 71.6744, y + 31.1819);
ctx.bezierCurveTo(x + 71.6493, y + 31.605, x + 71.5992, y + 32.0281, x + 71.5239, y + 32.4511);
ctx.bezierCurveTo(x + 71.3483, y + 33.4217, x + 71.0723, y + 34.3922, x + 70.6709, y + 35.313);
ctx.bezierCurveTo(x + 67.9113, y + 41.6588, x + 60.4353, y + 44.5705, x + 53.9628, y + 41.8081);
ctx.bezierCurveTo(x + 52.0059, y + 40.962, x + 50.2749, y + 39.668, x + 48.9453, y + 38.0006);
ctx.bezierCurveTo(x + 46.0603, y + 34.3673, x + 45.3829, y + 29.5146, x + 47.2143, y + 25.3089);
ctx.bezierCurveTo(x + 49.9739, y + 18.963, x + 57.4499, y + 16.0514, x + 63.9224, y + 18.8137);
ctx.bezierCurveTo(x + 68.8646, y + 20.929, x + 71.9755, y + 25.8813, x + 71.6493, y + 31.1571);
ctx.lineTo(x + 71.6744, y + 31.1819);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 55.9445, y + 27.3993);
ctx.bezierCurveTo(x + 55.8191, y + 27.6979, x + 55.9445, y + 28.0463, x + 56.2456, y + 28.1707);
ctx.bezierCurveTo(x + 56.5466, y + 28.2951, x + 56.8978, y + 28.1707, x + 57.0233, y + 27.8721);
ctx.bezierCurveTo(x + 57.1487, y + 27.5735, x + 57.0233, y + 27.2251, x + 56.7222, y + 27.1006);
ctx.bezierCurveTo(x + 56.4212, y + 26.9762, x + 56.07, y + 27.1006, x + 55.9445, y + 27.3993);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 56.8478, y + 24.8113);
ctx.bezierCurveTo(x + 56.7224, y + 25.1099, x + 56.8478, y + 25.4583, x + 57.1489, y + 25.5828);
ctx.bezierCurveTo(x + 57.4499, y + 25.7072, x + 57.8012, y + 25.5828, x + 57.9266, y + 25.2841);
ctx.bezierCurveTo(x + 58.052, y + 24.9855, x + 57.9266, y + 24.6371, x + 57.6256, y + 24.5127);
ctx.bezierCurveTo(x + 57.3245, y + 24.3634, x + 56.9733, y + 24.5127, x + 56.8478, y + 24.8113);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 58.2778, y + 22.9696);
ctx.bezierCurveTo(x + 58.1523, y + 23.2682, x + 58.2778, y + 23.6166, x + 58.5788, y + 23.741);
ctx.bezierCurveTo(x + 58.8799, y + 23.8655, x + 59.2311, y + 23.741, x + 59.3565, y + 23.4424);
ctx.bezierCurveTo(x + 59.482, y + 23.1438, x + 59.3565, y + 22.7954, x + 59.0555, y + 22.6709);
ctx.bezierCurveTo(x + 58.7544, y + 22.5465, x + 58.4032, y + 22.6709, x + 58.2778, y + 22.9696);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 60.1342, y + 24.4131);
ctx.bezierCurveTo(x + 60.0088, y + 24.7117, x + 60.1342, y + 25.0601, x + 60.4353, y + 25.1846);
ctx.bezierCurveTo(x + 60.7363, y + 25.309, x + 61.0875, y + 25.1846, x + 61.213, y + 24.8859);
ctx.bezierCurveTo(x + 61.3384, y + 24.5873, x + 61.213, y + 24.2389, x + 60.9119, y + 24.1145);
ctx.bezierCurveTo(x + 60.6109, y + 23.9652, x + 60.2597, y + 24.1145, x + 60.1342, y + 24.4131);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 61.3635, y + 26.2298);
ctx.bezierCurveTo(x + 61.238, y + 26.5284, x + 61.3635, y + 26.8768, x + 61.6645, y + 27.0012);
ctx.bezierCurveTo(x + 61.9656, y + 27.1257, x + 62.3168, y + 27.0012, x + 62.4422, y + 26.7026);
ctx.bezierCurveTo(x + 62.5677, y + 26.404, x + 62.4422, y + 26.0556, x + 62.1412, y + 25.9311);
ctx.bezierCurveTo(x + 61.8652, y + 25.7818, x + 61.514, y + 25.9311, x + 61.3635, y + 26.2298);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 62.0659, y + 28.1956);
ctx.bezierCurveTo(x + 61.9404, y + 28.4943, x + 62.0659, y + 28.8427, x + 62.3669, y + 28.9671);
ctx.bezierCurveTo(x + 62.668, y + 29.0915, x + 63.0192, y + 28.9671, x + 63.1446, y + 28.6685);
ctx.bezierCurveTo(x + 63.2701, y + 28.3698, x + 63.1446, y + 28.0214, x + 62.8436, y + 27.897);
ctx.bezierCurveTo(x + 62.5425, y + 27.7726, x + 62.1913, y + 27.897, x + 62.0659, y + 28.1956);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 61.7148, y + 30.5101);
ctx.bezierCurveTo(x + 61.5894, y + 30.8087, x + 61.7148, y + 31.1571, x + 62.0158, y + 31.2816);
ctx.bezierCurveTo(x + 62.3169, y + 31.406, x + 62.6681, y + 31.2816, x + 62.7935, y + 30.9829);
ctx.bezierCurveTo(x + 62.919, y + 30.6843, x + 62.7935, y + 30.3359, x + 62.4925, y + 30.2115);
ctx.bezierCurveTo(x + 62.1914, y + 30.087, x + 61.8402, y + 30.2115, x + 61.7148, y + 30.5101);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 60.8115, y + 32.6003);
ctx.bezierCurveTo(x + 60.686, y + 32.899, x + 60.8115, y + 33.2474, x + 61.1125, y + 33.3718);
ctx.bezierCurveTo(x + 61.4136, y + 33.4962, x + 61.7648, y + 33.3718, x + 61.8902, y + 33.0732);
ctx.bezierCurveTo(x + 62.0157, y + 32.7745, x + 61.8902, y + 32.4261, x + 61.5892, y + 32.3017);
ctx.bezierCurveTo(x + 61.2881, y + 32.1524, x + 60.9369, y + 32.2768, x + 60.8115, y + 32.6003);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 59.1557, y + 34.3426);
ctx.bezierCurveTo(x + 59.0303, y + 34.6412, x + 59.1557, y + 34.9896, x + 59.4568, y + 35.114);
ctx.bezierCurveTo(x + 59.7578, y + 35.2384, x + 60.109, y + 35.114, x + 60.2345, y + 34.8154);
ctx.bezierCurveTo(x + 60.3599, y + 34.5168, x + 60.2345, y + 34.1684, x + 59.9334, y + 34.0439);
ctx.bezierCurveTo(x + 59.6324, y + 33.8946, x + 59.2811, y + 34.0439, x + 59.1557, y + 34.3426);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 57.0986, y + 35.4126);
ctx.bezierCurveTo(x + 56.9731, y + 35.7113, x + 57.0986, y + 36.0597, x + 57.3996, y + 36.1841);
ctx.bezierCurveTo(x + 57.7007, y + 36.3085, x + 58.0519, y + 36.1841, x + 58.1773, y + 35.8855);
ctx.bezierCurveTo(x + 58.3028, y + 35.5868, x + 58.1773, y + 35.2384, x + 57.8763, y + 35.114);
ctx.bezierCurveTo(x + 57.6003, y + 34.9647, x + 57.2491, y + 35.114, x + 57.0986, y + 35.4126);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 54.6149, y + 35.6365);
ctx.bezierCurveTo(x + 54.4895, y + 35.9351, x + 54.6149, y + 36.2835, x + 54.916, y + 36.408);
ctx.bezierCurveTo(x + 55.217, y + 36.5324, x + 55.5683, y + 36.408, x + 55.6937, y + 36.1093);
ctx.bezierCurveTo(x + 55.8191, y + 35.8107, x + 55.6937, y + 35.4623, x + 55.3926, y + 35.3379);
ctx.bezierCurveTo(x + 55.0916, y + 35.1886, x + 54.7404, y + 35.3379, x + 54.6149, y + 35.6365);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 51.9558, y + 34.8402);
ctx.bezierCurveTo(x + 51.8303, y + 35.1388, x + 51.9558, y + 35.4872, x + 52.2568, y + 35.6116);
ctx.bezierCurveTo(x + 52.5579, y + 35.7361, x + 52.9091, y + 35.6116, x + 53.0345, y + 35.313);
ctx.bezierCurveTo(x + 53.1599, y + 35.0144, x + 53.0345, y + 34.666, x + 52.7335, y + 34.5416);
ctx.bezierCurveTo(x + 52.4324, y + 34.4171, x + 52.0812, y + 34.5416, x + 51.9558, y + 34.8402);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 50.3, y + 33.148);
ctx.bezierCurveTo(x + 50.1746, y + 33.4466, x + 50.3, y + 33.795, x + 50.601, y + 33.9194);
ctx.bezierCurveTo(x + 50.9021, y + 34.0439, x + 51.2533, y + 33.9194, x + 51.3788, y + 33.6208);
ctx.bezierCurveTo(x + 51.5042, y + 33.3222, x + 51.3788, y + 32.9738, x + 51.0777, y + 32.8493);
ctx.bezierCurveTo(x + 50.7767, y + 32.7, x + 50.4254, y + 32.8493, x + 50.3, y + 33.148);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 49.4721, y + 30.8584);
ctx.bezierCurveTo(x + 49.3467, y + 31.1571, x + 49.4721, y + 31.5055, x + 49.7732, y + 31.6299);
ctx.bezierCurveTo(x + 50.0742, y + 31.7543, x + 50.4254, y + 31.6299, x + 50.5509, y + 31.3313);
ctx.bezierCurveTo(x + 50.6763, y + 31.0326, x + 50.5509, y + 30.6842, x + 50.2498, y + 30.5598);
ctx.bezierCurveTo(x + 49.9488, y + 30.4105, x + 49.5976, y + 30.5598, x + 49.4721, y + 30.8584);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 49.5224, y + 28.6436);
ctx.bezierCurveTo(x + 49.397, y + 28.9423, x + 49.5224, y + 29.2907, x + 49.8235, y + 29.4151);
ctx.bezierCurveTo(x + 50.1245, y + 29.5395, x + 50.4757, y + 29.4151, x + 50.6012, y + 29.1165);
ctx.bezierCurveTo(x + 50.7266, y + 28.8178, x + 50.6012, y + 28.4694, x + 50.3001, y + 28.345);
ctx.bezierCurveTo(x + 49.9991, y + 28.2206, x + 49.6478, y + 28.345, x + 49.5224, y + 28.6436);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 49.8234, y + 26.4039);
ctx.bezierCurveTo(x + 49.698, y + 26.7025, x + 49.8234, y + 27.0509, x + 50.1245, y + 27.1754);
ctx.bezierCurveTo(x + 50.4255, y + 27.2998, x + 50.7768, y + 27.1754, x + 50.9022, y + 26.8767);
ctx.bezierCurveTo(x + 51.0276, y + 26.5781, x + 50.9022, y + 26.2297, x + 50.6011, y + 26.1053);
ctx.bezierCurveTo(x + 50.3001, y + 25.9808, x + 49.9489, y + 26.1053, x + 49.8234, y + 26.4039);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 50.9523, y + 24.7615);
ctx.bezierCurveTo(x + 50.8269, y + 25.0601, x + 50.9523, y + 25.4085, x + 51.2534, y + 25.533);
ctx.bezierCurveTo(x + 51.5544, y + 25.6574, x + 51.9057, y + 25.533, x + 52.0311, y + 25.2343);
ctx.bezierCurveTo(x + 52.1565, y + 24.9357, x + 52.0311, y + 24.5873, x + 51.73, y + 24.4629);
ctx.bezierCurveTo(x + 51.429, y + 24.3136, x + 51.0778, y + 24.4629, x + 50.9523, y + 24.7615);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 52.4575, y + 23.343);
ctx.bezierCurveTo(x + 52.332, y + 23.6417, x + 52.4575, y + 23.9901, x + 52.7585, y + 24.1145);
ctx.bezierCurveTo(x + 53.0596, y + 24.2389, x + 53.4108, y + 24.1145, x + 53.5362, y + 23.8159);
ctx.bezierCurveTo(x + 53.6617, y + 23.5172, x + 53.5362, y + 23.1688, x + 53.2352, y + 23.0444);
ctx.bezierCurveTo(x + 52.9341, y + 22.8951, x + 52.5829, y + 23.0444, x + 52.4575, y + 23.343);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 54.1384, y + 22.4969);
ctx.bezierCurveTo(x + 54.0129, y + 22.7955, x + 54.1384, y + 23.1439, x + 54.4394, y + 23.2683);
ctx.bezierCurveTo(x + 54.7405, y + 23.3927, x + 55.0917, y + 23.2683, x + 55.2171, y + 22.9697);
ctx.bezierCurveTo(x + 55.3426, y + 22.6711, x + 55.2171, y + 22.3227, x + 54.9161, y + 22.1982);
ctx.bezierCurveTo(x + 54.615, y + 22.0489, x + 54.2638, y + 22.1982, x + 54.1384, y + 22.4969);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 56.07, y + 22.3724);
ctx.bezierCurveTo(x + 55.9446, y + 22.671, x + 56.07, y + 23.0194, x + 56.3711, y + 23.1439);
ctx.bezierCurveTo(x + 56.6721, y + 23.2683, x + 57.0233, y + 23.1439, x + 57.1488, y + 22.8452);
ctx.bezierCurveTo(x + 57.2742, y + 22.5466, x + 57.1488, y + 22.1982, x + 56.8477, y + 22.0738);
ctx.bezierCurveTo(x + 56.5467, y + 21.9493, x + 56.1955, y + 22.0738, x + 56.07, y + 22.3724);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 58.7294, y + 26.1302);
ctx.bezierCurveTo(x + 58.604, y + 26.4288, x + 58.7294, y + 26.7772, x + 59.0305, y + 26.9017);
ctx.bezierCurveTo(x + 59.3315, y + 27.0261, x + 59.6828, y + 26.9017, x + 59.8082, y + 26.603);
ctx.bezierCurveTo(x + 59.9336, y + 26.3044, x + 59.8082, y + 25.956, x + 59.5071, y + 25.8316);
ctx.bezierCurveTo(x + 59.2061, y + 25.7072, x + 58.8549, y + 25.8316, x + 58.7294, y + 26.1302);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 59.7829, y + 28.3949);
ctx.bezierCurveTo(x + 59.6575, y + 28.6935, x + 59.7829, y + 29.0419, x + 60.084, y + 29.1663);
ctx.bezierCurveTo(x + 60.385, y + 29.2908, x + 60.7362, y + 29.1663, x + 60.8617, y + 28.8677);
ctx.bezierCurveTo(x + 60.9871, y + 28.5691, x + 60.8617, y + 28.2207, x + 60.5606, y + 28.0962);
ctx.bezierCurveTo(x + 60.2596, y + 27.9718, x + 59.9083, y + 28.0962, x + 59.7829, y + 28.3949);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 59.2563, y + 30.8087);
ctx.bezierCurveTo(x + 59.1309, y + 31.1073, x + 59.2563, y + 31.4557, x + 59.5573, y + 31.5801);
ctx.bezierCurveTo(x + 59.8584, y + 31.7046, x + 60.2096, y + 31.5801, x + 60.335, y + 31.2815);
ctx.bezierCurveTo(x + 60.4605, y + 30.9829, x + 60.335, y + 30.6345, x + 60.034, y + 30.5101);
ctx.bezierCurveTo(x + 59.733, y + 30.3856, x + 59.3817, y + 30.5101, x + 59.2563, y + 30.8087);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 57.9768, y + 32.5755);
ctx.bezierCurveTo(x + 57.8513, y + 32.8742, x + 57.9768, y + 33.2226, x + 58.2778, y + 33.347);
ctx.bezierCurveTo(x + 58.5788, y + 33.4714, x + 58.9301, y + 33.347, x + 59.0555, y + 33.0484);
ctx.bezierCurveTo(x + 59.1809, y + 32.7497, x + 59.0555, y + 32.4013, x + 58.7545, y + 32.2769);
ctx.bezierCurveTo(x + 58.4534, y + 32.1525, x + 58.1022, y + 32.2769, x + 57.9768, y + 32.5755);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 56.02, y + 33.4466);
ctx.bezierCurveTo(x + 55.8945, y + 33.7452, x + 56.02, y + 34.0936, x + 56.321, y + 34.218);
ctx.bezierCurveTo(x + 56.6221, y + 34.3424, x + 56.9733, y + 34.218, x + 57.0987, y + 33.9194);
ctx.bezierCurveTo(x + 57.2242, y + 33.6208, x + 57.0987, y + 33.2724, x + 56.7977, y + 33.1479);
ctx.bezierCurveTo(x + 56.4966, y + 32.9986, x + 56.1454, y + 33.1479, x + 56.02, y + 33.4466);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 53.7871, y + 33.347);
ctx.bezierCurveTo(x + 53.6616, y + 33.6456, x + 53.7871, y + 33.994, x + 54.0881, y + 34.1184);
ctx.bezierCurveTo(x + 54.3891, y + 34.2428, x + 54.7404, y + 34.1184, x + 54.8658, y + 33.8198);
ctx.bezierCurveTo(x + 54.9912, y + 33.5212, x + 54.8658, y + 33.1728, x + 54.5648, y + 33.0483);
ctx.bezierCurveTo(x + 54.2637, y + 32.899, x + 53.9125, y + 33.0483, x + 53.7871, y + 33.347);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 52.006, y + 31.7293);
ctx.bezierCurveTo(x + 51.8806, y + 32.028, x + 52.0061, y + 32.3764, x + 52.3071, y + 32.5008);
ctx.bezierCurveTo(x + 52.6081, y + 32.6252, x + 52.9594, y + 32.5008, x + 53.0848, y + 32.2022);
ctx.bezierCurveTo(x + 53.2102, y + 31.9035, x + 53.0848, y + 31.5551, x + 52.7838, y + 31.4307);
ctx.bezierCurveTo(x + 52.4827, y + 31.3063, x + 52.1315, y + 31.4307, x + 52.006, y + 31.7293);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 51.4792, y + 29.7386);
ctx.bezierCurveTo(x + 51.3538, y + 30.0372, x + 51.4792, y + 30.3856, x + 51.7802, y + 30.51);
ctx.bezierCurveTo(x + 52.0813, y + 30.6344, x + 52.4325, y + 30.51, x + 52.558, y + 30.2114);
ctx.bezierCurveTo(x + 52.6834, y + 29.9128, x + 52.5579, y + 29.5644, x + 52.2569, y + 29.4399);
ctx.bezierCurveTo(x + 51.9559, y + 29.2906, x + 51.6046, y + 29.4399, x + 51.4792, y + 29.7386);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 51.7299, y + 27.6483);
ctx.bezierCurveTo(x + 51.6045, y + 27.9469, x + 51.7299, y + 28.2953, x + 52.031, y + 28.4197);
ctx.bezierCurveTo(x + 52.332, y + 28.5442, x + 52.6832, y + 28.4197, x + 52.8087, y + 28.1211);
ctx.bezierCurveTo(x + 52.9341, y + 27.8225, x + 52.8087, y + 27.4741, x + 52.5076, y + 27.3497);
ctx.bezierCurveTo(x + 52.2066, y + 27.2252, x + 51.8554, y + 27.3497, x + 51.7299, y + 27.6483);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 52.8088, y + 25.8814);
ctx.bezierCurveTo(x + 52.6833, y + 26.18, x + 52.8088, y + 26.5284, x + 53.1098, y + 26.6528);
ctx.bezierCurveTo(x + 53.4109, y + 26.7773, x + 53.7621, y + 26.6528, x + 53.8875, y + 26.3542);
ctx.bezierCurveTo(x + 54.013, y + 26.0556, x + 53.8875, y + 25.7072, x + 53.5865, y + 25.5827);
ctx.bezierCurveTo(x + 53.2854, y + 25.4334, x + 52.9342, y + 25.5827, x + 52.8088, y + 25.8814);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 54.5397, y + 24.8858);
ctx.bezierCurveTo(x + 54.4143, y + 25.1845, x + 54.5397, y + 25.5329, x + 54.8408, y + 25.6573);
ctx.bezierCurveTo(x + 55.1418, y + 25.7817, x + 55.4931, y + 25.6573, x + 55.6185, y + 25.3587);
ctx.bezierCurveTo(x + 55.7439, y + 25.06, x + 55.6185, y + 24.7116, x + 55.3174, y + 24.5872);
ctx.bezierCurveTo(x + 55.0164, y + 24.4628, x + 54.6652, y + 24.5872, x + 54.5397, y + 24.8858);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 57.2993, y + 28.6436);
ctx.bezierCurveTo(x + 57.1738, y + 28.9422, x + 57.2993, y + 29.2906, x + 57.6003, y + 29.415);
ctx.bezierCurveTo(x + 57.9014, y + 29.5395, x + 58.2526, y + 29.415, x + 58.378, y + 29.1164);
ctx.bezierCurveTo(x + 58.5035, y + 28.8178, x + 58.378, y + 28.4694, x + 58.077, y + 28.345);
ctx.bezierCurveTo(x + 57.7759, y + 28.1956, x + 57.4247, y + 28.345, x + 57.2993, y + 28.6436);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 55.3928, y + 29.1663);
ctx.bezierCurveTo(x + 55.2673, y + 29.4649, x + 55.3928, y + 29.8133, x + 55.6938, y + 29.9377);
ctx.bezierCurveTo(x + 55.9949, y + 30.0622, x + 56.3461, y + 29.9377, x + 56.4715, y + 29.6391);
ctx.bezierCurveTo(x + 56.597, y + 29.3405, x + 56.4715, y + 28.9921, x + 56.1705, y + 28.8677);
ctx.bezierCurveTo(x + 55.8694, y + 28.7183, x + 55.5182, y + 28.8677, x + 55.3928, y + 29.1663);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 56.6721, y + 30.4105);
ctx.bezierCurveTo(x + 56.5466, y + 30.7091, x + 56.6721, y + 31.0575, x + 56.9731, y + 31.1819);
ctx.bezierCurveTo(x + 57.2742, y + 31.3064, x + 57.6254, y + 31.1819, x + 57.7508, y + 30.8833);
ctx.bezierCurveTo(x + 57.8763, y + 30.5847, x + 57.7508, y + 30.2363, x + 57.4498, y + 30.1119);
ctx.bezierCurveTo(x + 57.1487, y + 29.9874, x + 56.7975, y + 30.1119, x + 56.6721, y + 30.4105);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 54.8408, y + 30.9331);
ctx.bezierCurveTo(x + 54.7153, y + 31.2318, x + 54.8408, y + 31.5802, x + 55.1418, y + 31.7046);
ctx.bezierCurveTo(x + 55.4429, y + 31.829, x + 55.7941, y + 31.7046, x + 55.9195, y + 31.406);
ctx.bezierCurveTo(x + 56.045, y + 31.1073, x + 55.9195, y + 30.7589, x + 55.6185, y + 30.6345);
ctx.bezierCurveTo(x + 55.3174, y + 30.4852, x + 54.9662, y + 30.6345, x + 54.8408, y + 30.9331);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 53.6367, y + 29.44);
ctx.bezierCurveTo(x + 53.5112, y + 29.7387, x + 53.6367, y + 30.0871, x + 53.9377, y + 30.2115);
ctx.bezierCurveTo(x + 54.2388, y + 30.3359, x + 54.59, y + 30.2115, x + 54.7154, y + 29.9129);
ctx.bezierCurveTo(x + 54.8409, y + 29.6142, x + 54.7154, y + 29.2658, x + 54.4144, y + 29.1414);
ctx.bezierCurveTo(x + 54.1384, y + 29.017, x + 53.7872, y + 29.1414, x + 53.6367, y + 29.44);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 54.1132, y + 27.7227);
ctx.bezierCurveTo(x + 53.9878, y + 28.0214, x + 54.1132, y + 28.3698, x + 54.4143, y + 28.4942);
ctx.bezierCurveTo(x + 54.7153, y + 28.6186, x + 55.0665, y + 28.4942, x + 55.192, y + 28.1956);
ctx.bezierCurveTo(x + 55.3174, y + 27.8969, x + 55.192, y + 27.5485, x + 54.8909, y + 27.4241);
ctx.bezierCurveTo(x + 54.5899, y + 27.2997, x + 54.2387, y + 27.4241, x + 54.1132, y + 27.7227);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 55.9448, y + 27.3993);
ctx.bezierCurveTo(x + 55.8193, y + 27.6979, x + 55.9448, y + 28.0463, x + 56.2458, y + 28.1707);
ctx.bezierCurveTo(x + 56.5469, y + 28.2951, x + 56.8981, y + 28.1707, x + 57.0235, y + 27.8721);
ctx.bezierCurveTo(x + 57.149, y + 27.5735, x + 57.0235, y + 27.2251, x + 56.7225, y + 27.1006);
ctx.bezierCurveTo(x + 56.4214, y + 26.9762, x + 56.0702, y + 27.1006, x + 55.9448, y + 27.3993);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 57.2993, y + 28.6436);
ctx.bezierCurveTo(x + 57.1738, y + 28.9422, x + 57.2993, y + 29.2906, x + 57.6003, y + 29.415);
ctx.bezierCurveTo(x + 57.9014, y + 29.5395, x + 58.2526, y + 29.415, x + 58.378, y + 29.1164);
ctx.bezierCurveTo(x + 58.5035, y + 28.8178, x + 58.378, y + 28.4694, x + 58.077, y + 28.345);
ctx.bezierCurveTo(x + 57.7759, y + 28.1956, x + 57.4247, y + 28.345, x + 57.2993, y + 28.6436);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 55.3928, y + 29.1663);
ctx.bezierCurveTo(x + 55.2673, y + 29.4649, x + 55.3928, y + 29.8133, x + 55.6938, y + 29.9377);
ctx.bezierCurveTo(x + 55.9949, y + 30.0622, x + 56.3461, y + 29.9377, x + 56.4715, y + 29.6391);
ctx.bezierCurveTo(x + 56.597, y + 29.3405, x + 56.4715, y + 28.9921, x + 56.1705, y + 28.8677);
ctx.bezierCurveTo(x + 55.8694, y + 28.7183, x + 55.5182, y + 28.8677, x + 55.3928, y + 29.1663);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 56.6723, y + 30.4105);
ctx.bezierCurveTo(x + 56.5469, y + 30.7091, x + 56.6723, y + 31.0575, x + 56.9734, y + 31.1819);
ctx.bezierCurveTo(x + 57.2744, y + 31.3064, x + 57.6256, y + 31.1819, x + 57.7511, y + 30.8833);
ctx.bezierCurveTo(x + 57.8765, y + 30.5847, x + 57.7511, y + 30.2363, x + 57.45, y + 30.1119);
ctx.bezierCurveTo(x + 57.149, y + 29.9874, x + 56.7977, y + 30.1119, x + 56.6723, y + 30.4105);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 54.8408, y + 30.9331);
ctx.bezierCurveTo(x + 54.7153, y + 31.2318, x + 54.8408, y + 31.5802, x + 55.1418, y + 31.7046);
ctx.bezierCurveTo(x + 55.4429, y + 31.829, x + 55.7941, y + 31.7046, x + 55.9195, y + 31.406);
ctx.bezierCurveTo(x + 56.045, y + 31.1073, x + 55.9195, y + 30.7589, x + 55.6185, y + 30.6345);
ctx.bezierCurveTo(x + 55.3174, y + 30.4852, x + 54.9662, y + 30.6345, x + 54.8408, y + 30.9331);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 53.6367, y + 29.44);
ctx.bezierCurveTo(x + 53.5112, y + 29.7387, x + 53.6367, y + 30.0871, x + 53.9377, y + 30.2115);
ctx.bezierCurveTo(x + 54.2388, y + 30.3359, x + 54.59, y + 30.2115, x + 54.7154, y + 29.9129);
ctx.bezierCurveTo(x + 54.8409, y + 29.6142, x + 54.7154, y + 29.2658, x + 54.4144, y + 29.1414);
ctx.bezierCurveTo(x + 54.1384, y + 29.017, x + 53.7872, y + 29.1414, x + 53.6367, y + 29.44);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 54.1132, y + 27.7227);
ctx.bezierCurveTo(x + 53.9878, y + 28.0214, x + 54.1132, y + 28.3698, x + 54.4143, y + 28.4942);
ctx.bezierCurveTo(x + 54.7153, y + 28.6186, x + 55.0665, y + 28.4942, x + 55.192, y + 28.1956);
ctx.bezierCurveTo(x + 55.3174, y + 27.8969, x + 55.192, y + 27.5485, x + 54.8909, y + 27.4241);
ctx.bezierCurveTo(x + 54.5899, y + 27.2997, x + 54.2387, y + 27.4241, x + 54.1132, y + 27.7227);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 66.0048, y + 24.4131);
ctx.bezierCurveTo(x + 66.2305, y + 25.2841, x + 66.5065, y + 26.1551, x + 66.6821, y + 27.0261);
ctx.bezierCurveTo(x + 66.7825, y + 27.4491, x + 66.8577, y + 27.8971, x + 66.9079, y + 28.3201);
ctx.bezierCurveTo(x + 66.9581, y + 28.7432, x + 67.0083, y + 29.1911, x + 67.0083, y + 29.6142);
ctx.bezierCurveTo(x + 67.0083, y + 30.4852, x + 66.933, y + 31.3313, x + 66.7072, y + 32.1774);
ctx.bezierCurveTo(x + 66.5065, y + 33.0235, x + 66.2055, y + 33.8448, x + 65.8542, y + 34.6411);
ctx.bezierCurveTo(x + 65.6786, y + 35.0393, x + 65.4779, y + 35.4375, x + 65.2772, y + 35.7859);
ctx.bezierCurveTo(x + 65.0514, y + 36.1591, x + 64.8257, y + 36.5075, x + 64.5497, y + 36.8311);
ctx.bezierCurveTo(x + 64.2737, y + 37.1546, x + 63.9727, y + 37.4781, x + 63.6716, y + 37.7767);
ctx.bezierCurveTo(x + 63.3455, y + 38.0754, x + 63.0194, y + 38.3491, x + 62.6681, y + 38.598);
ctx.bezierCurveTo(x + 61.9657, y + 39.0957, x + 61.188, y + 39.5187, x + 60.3852, y + 39.9169);
ctx.bezierCurveTo(x + 59.9838, y + 40.116, x + 59.5824, y + 40.2902, x + 59.1559, y + 40.4644);
ctx.bezierCurveTo(x + 58.9552, y + 40.539, x + 58.7294, y + 40.6386, x + 58.5287, y + 40.7132);
ctx.bezierCurveTo(x + 58.328, y + 40.7879, x + 58.1023, y + 40.8626, x + 57.8765, y + 40.9123);
ctx.bezierCurveTo(x + 58.1023, y + 40.9621, x + 58.328, y + 40.9372, x + 58.5789, y + 40.9123);
ctx.bezierCurveTo(x + 58.8047, y + 40.8874, x + 59.0305, y + 40.8626, x + 59.2563, y + 40.8128);
ctx.bezierCurveTo(x + 59.7078, y + 40.7381, x + 60.1594, y + 40.6137, x + 60.611, y + 40.4644);
ctx.bezierCurveTo(x + 61.489, y + 40.1906, x + 62.342, y + 39.7676, x + 63.1197, y + 39.245);
ctx.bezierCurveTo(x + 63.8974, y + 38.7224, x + 64.625, y + 38.1251, x + 65.2521, y + 37.4034);
ctx.bezierCurveTo(x + 65.5532, y + 37.055, x + 65.8291, y + 36.6569, x + 66.08, y + 36.2587);
ctx.bezierCurveTo(x + 66.3309, y + 35.8605, x + 66.5316, y + 35.4126, x + 66.7072, y + 34.9895);
ctx.bezierCurveTo(x + 67.0584, y + 34.1434, x + 67.3846, y + 33.2724, x + 67.5602, y + 32.3516);
ctx.bezierCurveTo(x + 67.7609, y + 31.4309, x + 67.8361, y + 30.5101, x + 67.7609, y + 29.5644);
ctx.bezierCurveTo(x + 67.7358, y + 29.0916, x + 67.6605, y + 28.6437, x + 67.5602, y + 28.1957);
ctx.bezierCurveTo(x + 67.4598, y + 27.7478, x + 67.3344, y + 27.2998, x + 67.1839, y + 26.8768);
ctx.bezierCurveTo(x + 66.8326, y + 26.0307, x + 66.4563, y + 25.2094, x + 66.0048, y + 24.4131);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 63.0445, y + 37.2789);
ctx.bezierCurveTo(x + 62.4675, y + 37.7517, x + 61.9156, y + 38.2495, x + 61.3135, y + 38.6725);
ctx.bezierCurveTo(x + 61.0124, y + 38.8965, x + 60.7114, y + 39.0956, x + 60.4103, y + 39.2698);
ctx.bezierCurveTo(x + 60.2598, y + 39.3444, x + 60.1093, y + 39.444, x + 59.9337, y + 39.5186);
ctx.bezierCurveTo(x + 59.7831, y + 39.5933, x + 59.6075, y + 39.6679, x + 59.457, y + 39.7426);
ctx.bezierCurveTo(x + 58.1525, y + 40.315, x + 56.6974, y + 40.4643, x + 55.2674, y + 40.3399);
ctx.bezierCurveTo(x + 55.0918, y + 40.3399, x + 54.9162, y + 40.2901, x + 54.7406, y + 40.2652);
ctx.bezierCurveTo(x + 54.565, y + 40.2403, x + 54.3894, y + 40.2154, x + 54.2138, y + 40.1905);
ctx.bezierCurveTo(x + 53.8625, y + 40.1159, x + 53.5113, y + 40.0661, x + 53.1601, y + 39.9417);
ctx.bezierCurveTo(x + 52.4576, y + 39.7675, x + 51.8054, y + 39.4937, x + 51.1782, y + 39.1702);
ctx.bezierCurveTo(x + 50.5259, y + 38.8716, x + 49.9238, y + 38.4983, x + 49.3468, y + 38.0753);
ctx.bezierCurveTo(x + 49.1963, y + 37.9757, x + 49.0458, y + 37.8762, x + 48.9203, y + 37.7517);
ctx.bezierCurveTo(x + 48.7698, y + 37.6522, x + 48.6193, y + 37.5278, x + 48.4938, y + 37.4282);
ctx.bezierCurveTo(x + 48.2179, y + 37.2043, x + 47.9168, y + 36.9554, x + 47.6409, y + 36.7065);
ctx.bezierCurveTo(x + 47.8917, y + 37.4282, x + 48.3684, y + 38.0504, x + 48.9203, y + 38.5979);
ctx.bezierCurveTo(x + 49.4722, y + 39.1453, x + 50.1245, y + 39.5684, x + 50.8019, y + 39.9417);
ctx.bezierCurveTo(x + 51.4792, y + 40.2901, x + 52.2068, y + 40.5887, x + 52.9594, y + 40.7629);
ctx.bezierCurveTo(x + 53.3357, y + 40.8625, x + 53.712, y + 40.9122, x + 54.0883, y + 40.9869);
ctx.bezierCurveTo(x + 54.289, y + 41.0118, x + 54.4646, y + 41.0367, x + 54.6653, y + 41.0615);
ctx.bezierCurveTo(x + 54.866, y + 41.0864, x + 55.0416, y + 41.1113, x + 55.2423, y + 41.1113);
ctx.bezierCurveTo(x + 55.995, y + 41.1611, x + 56.7727, y + 41.1113, x + 57.5504, y + 40.9869);
ctx.bezierCurveTo(x + 58.303, y + 40.8625, x + 59.0556, y + 40.6136, x + 59.733, y + 40.2652);
ctx.bezierCurveTo(x + 60.4103, y + 39.9168, x + 61.0375, y + 39.4689, x + 61.5894, y + 38.9711);
ctx.bezierCurveTo(x + 62.0912, y + 38.4237, x + 62.5929, y + 37.8762, x + 63.0445, y + 37.2789);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 48.6694, y + 38.2495);
ctx.bezierCurveTo(x + 49.974, y + 39.892, x + 51.7301, y + 41.2607, x + 53.8123, y + 42.1566);
ctx.bezierCurveTo(x + 60.4856, y + 44.9936, x + 68.1874, y + 42.0073, x + 71.0222, y + 35.4623);
ctx.bezierCurveTo(x + 71.4487, y + 34.4918, x + 71.7247, y + 33.4964, x + 71.9003, y + 32.5258);
ctx.lineTo(x + 72.0508, y + 31.2318);
ctx.lineTo(x + 72.0508, y + 31.2069);
ctx.lineTo(x + 71.6996, y + 31.2566);
ctx.bezierCurveTo(x + 71.6996, y + 32.9738, x + 70.5707, y + 35.6365, x + 69.3163, y + 36.8808);
ctx.bezierCurveTo(x + 73.5059, y + 29.4898, x + 69.1407, y + 24.7117, x + 68.0369, y + 25.1845);
ctx.bezierCurveTo(x + 67.4598, y + 25.4334, x + 67.0584, y + 26.2297, x + 66.9581, y + 27.1007);
ctx.bezierCurveTo(x + 66.9581, y + 27.1007, x + 67.786, y + 29.7884, x + 66.6069, y + 33.9692);
ctx.bezierCurveTo(x + 65.4278, y + 38.15, x + 61.1378, y + 39.9666, x + 61.1378, y + 39.9666);
ctx.bezierCurveTo(x + 61.1378, y + 39.9666, x + 60.0089, y + 40.3897, x + 56.0702, y + 40.763);
ctx.bezierCurveTo(x + 52.1315, y + 41.1363, x + 48.7949, y + 38.1002, x + 48.7949, y + 38.1002);
ctx.lineTo(x + 48.6694, y + 38.2495);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#ED1B24";

ctx.beginPath();
ctx.moveTo(x + 62.0158, y + 42.3307);
ctx.bezierCurveTo(x + 61.213, y + 42.48, x + 60.4353, y + 42.5795, x + 59.6326, y + 42.6293);
ctx.bezierCurveTo(x + 58.8298, y + 42.6542, x + 58.052, y + 42.6293, x + 57.2493, y + 42.5298);
ctx.bezierCurveTo(x + 56.4465, y + 42.4551, x + 55.6687, y + 42.3058, x + 54.891, y + 42.1067);
ctx.bezierCurveTo(x + 54.1133, y + 41.9076, x + 53.3607, y + 41.6837, x + 52.583, y + 41.4099);
ctx.bezierCurveTo(x + 53.2855, y + 41.8081, x + 54.0381, y + 42.1316, x + 54.8158, y + 42.3805);
ctx.bezierCurveTo(x + 55.5935, y + 42.6293, x + 56.3963, y + 42.8035, x + 57.1991, y + 42.9031);
ctx.bezierCurveTo(x + 58.0019, y + 43.0026, x + 58.8298, y + 43.0026, x + 59.6576, y + 42.9031);
ctx.bezierCurveTo(x + 60.4604, y + 42.8284, x + 61.2632, y + 42.6542, x + 62.0158, y + 42.3307);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#ED1B24";

ctx.beginPath();
ctx.moveTo(x + 67.5851, y + 39.22);
ctx.bezierCurveTo(x + 67.3845, y + 38.9213, x + 65.1015, y + 40.8375, x + 64.2485, y + 41.1362);
ctx.bezierCurveTo(x + 65.4026, y + 40.7878, x + 66.1301, y + 40.4643, x + 66.7322, y + 40.091);
ctx.bezierCurveTo(x + 67.1587, y + 39.8172, x + 67.7106, y + 39.3942, x + 67.5851, y + 39.22);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 66.6319, y + 24.1144);
ctx.bezierCurveTo(x + 66.4563, y + 23.4674, x + 66.0549, y + 22.895, x + 65.503, y + 22.4968);
ctx.bezierCurveTo(x + 65.227, y + 22.2977, x + 64.926, y + 22.1484, x + 64.625, y + 22.024);
ctx.bezierCurveTo(x + 64.3239, y + 21.8996, x + 63.9978, y + 21.8249, x + 63.6716, y + 21.7751);
ctx.bezierCurveTo(x + 63.9476, y + 21.9742, x + 64.2236, y + 22.1235, x + 64.4995, y + 22.2977);
ctx.bezierCurveTo(x + 64.7755, y + 22.4719, x + 65.0263, y + 22.6213, x + 65.2772, y + 22.8203);
ctx.bezierCurveTo(x + 65.5281, y + 22.9945, x + 65.7539, y + 23.1936, x + 65.9797, y + 23.4176);
ctx.bezierCurveTo(x + 66.2055, y + 23.6416, x + 66.4062, y + 23.8655, x + 66.6319, y + 24.1144);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 58.5036, y + 21.5263);
ctx.lineTo(x + 54.7154, y + 17.8433);
ctx.lineTo(x + 54.2388, y + 18.4156);
ctx.lineTo(x + 58.5036, y + 21.5263);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 56.0451, y + 21.3769);
ctx.bezierCurveTo(x + 55.8945, y + 21.1529, x + 55.6938, y + 20.9539, x + 55.4931, y + 20.8045);
ctx.bezierCurveTo(x + 55.2924, y + 20.6303, x + 55.0416, y + 20.5059, x + 54.8158, y + 20.3815);
ctx.bezierCurveTo(x + 54.3391, y + 20.1326, x + 53.8374, y + 19.9584, x + 53.3105, y + 19.8589);
ctx.lineTo(x + 54.0381, y + 20.1824);
ctx.bezierCurveTo(x + 54.2639, y + 20.3068, x + 54.5147, y + 20.4064, x + 54.7405, y + 20.5308);
ctx.bezierCurveTo(x + 55.1921, y + 20.7797, x + 55.6437, y + 21.0534, x + 56.0451, y + 21.3769);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 63.471, y + 20.7051);
ctx.bezierCurveTo(x + 62.8689, y + 20.083, x + 62.1664, y + 19.5106, x + 61.3887, y + 19.0627);
ctx.bezierCurveTo(x + 60.6361, y + 18.5899, x + 59.8082, y + 18.2166, x + 58.9302, y + 17.9428);
ctx.bezierCurveTo(x + 58.0772, y + 17.6691, x + 57.149, y + 17.5198, x + 56.2458, y + 17.5198);
ctx.bezierCurveTo(x + 55.3176, y + 17.5198, x + 54.3893, y + 17.6691, x + 53.5364, y + 18.0921);
ctx.lineTo(x + 53.8374, y + 18.7641);
ctx.bezierCurveTo(x + 54.6151, y + 18.4654, x + 55.4179, y + 18.2663, x + 56.2709, y + 18.2166);
ctx.bezierCurveTo(x + 57.1239, y + 18.1668, x + 57.9768, y + 18.2415, x + 58.8047, y + 18.4157);
ctx.bezierCurveTo(x + 59.6326, y + 18.6147, x + 60.4605, y + 18.8885, x + 61.2633, y + 19.2867);
ctx.bezierCurveTo(x + 62.0661, y + 19.6848, x + 62.7936, y + 20.1328, x + 63.471, y + 20.7051);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 70.1691, y + 25.4583);
ctx.bezierCurveTo(x + 68.99, y + 23.2932, x + 67.9614, y + 20.9291, x + 65.3523, y + 19.3613);
ctx.bezierCurveTo(x + 65.3523, y + 19.3613, x + 63.4457, y + 18.5152, x + 63.2701, y + 19.212);
ctx.bezierCurveTo(x + 63.0945, y + 19.9088, x + 64.6248, y + 20.2572, x + 66.4813, y + 21.5264);
ctx.bezierCurveTo(x + 68.3377, y + 22.7955, x + 69.567, y + 24.5873, x + 70.1691, y + 25.4583);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 76.3658, y + 0.223988);
ctx.bezierCurveTo(x + 75.4125, y + 0.298645, x + 74.4341, y + 0.44796, x + 73.4808, y + 0.547503);
ctx.bezierCurveTo(x + 73.556, y + 0.62216, x + 73.6313, y + 0.696817, x + 73.7316, y + 0.771474);
ctx.bezierCurveTo(x + 73.5058, y + 1.56782, x + 73.9574, y + 2.38905, x + 73.9574, y + 2.38905);
ctx.bezierCurveTo(x + 73.9574, y + 2.38905, x + 71.9002, y + 1.5927, x + 71.2229, y + 3.01119);
ctx.bezierCurveTo(x + 70.5957, y + 4.47945, x + 72.0759, y + 5.72373, x + 72.0759, y + 5.72373);
ctx.bezierCurveTo(x + 72.0759, y + 5.72373, x + 69.7929, y + 5.74862, x + 69.0905, y + 7.54039);
ctx.bezierCurveTo(x + 68.5135, y + 9.03354, x + 70.5957, y + 10.1783, x + 70.5957, y + 10.1783);
ctx.bezierCurveTo(x + 69.542, y + 10.4769, x + 69.0654, y + 10.8253, x + 68.7643, y + 11.1488);
ctx.bezierCurveTo(x + 68.4633, y + 11.4972, x + 68.1121, y + 12.5175, x + 68.1121, y + 12.5175);
ctx.lineTo(x + 69.5671, y + 13.289);
ctx.bezierCurveTo(x + 69.5671, y + 13.289, x + 69.9434, y + 12.4927, x + 70.094, y + 12.0696);
ctx.bezierCurveTo(x + 70.2696, y + 11.6217, x + 72.4271, y + 10.9746, x + 72.4271, y + 10.9746);
ctx.bezierCurveTo(x + 72.4271, y + 10.9746, x + 74.4341, y + 11.6217, x + 75.1867, y + 10.3027);
ctx.bezierCurveTo(x + 75.9393, y + 8.98376, x + 74.5093, y + 8.21231, x + 73.9825, y + 8.18742);
ctx.bezierCurveTo(x + 73.4557, y + 8.16254, x + 72.2515, y + 8.36162, x + 72.2515, y + 8.36162);
ctx.bezierCurveTo(x + 72.2515, y + 8.36162, x + 71.4738, y + 8.08788, x + 71.3985, y + 7.78925);
ctx.bezierCurveTo(x + 72.2013, y + 7.24176, x + 73.3804, y + 7.06756, x + 74.0076, y + 7.29154);
ctx.bezierCurveTo(x + 74.6348, y + 7.54039, x + 75.864, y + 8.36162, x + 76.4411, y + 7.14222);
ctx.bezierCurveTo(x + 76.993, y + 5.89793, x + 74.8355, y + 5.49976, x + 74.8355, y + 5.49976);
ctx.bezierCurveTo(x + 74.8355, y + 5.49976, x + 73.4557, y + 4.45456, x + 73.4808, y + 3.98173);
ctx.bezierCurveTo(x + 73.5309, y + 3.5089, x + 76.4912, y + 5.32556, x + 77.2188, y + 4.97716);
ctx.bezierCurveTo(x + 77.9463, y + 4.62876, x + 78.3979, y + 3.35959, x + 77.6703, y + 3.01119);
ctx.bezierCurveTo(x + 76.9428, y + 2.6379, x + 76.2905, y + 2.1153, x + 76.0397, y + 1.69225);
ctx.bezierCurveTo(x + 76.993, y + 2.01576, x + 78.6237, y + 1.9411, x + 78.8745, y + 0.871017);
ctx.bezierCurveTo(x + 78.9498, y + 0.572388, x + 78.9247, y + 0.27376, x + 78.8494, y + 0.0249023);
ctx.bezierCurveTo(x + 78.0216, y + 0.0995595, x + 77.2188, y + 0.174217, x + 76.3658, y + 0.223988);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 78.7741, y + 0.0248857);
ctx.bezierCurveTo(x + 78.8493, y + 0.273743, x + 78.8744, y + 0.572372, x + 78.7991, y + 0.846115);
ctx.bezierCurveTo(x + 78.7239, y + 1.14474, x + 78.5483, y + 1.36872, x + 78.2472, y + 1.51803);
ctx.bezierCurveTo(x + 77.6451, y + 1.84154, x + 76.6918, y + 1.81666, x + 76.0395, y + 1.59269);
ctx.lineTo(x + 75.8639, y + 1.54292);
ctx.lineTo(x + 75.9643, y + 1.69223);
ctx.bezierCurveTo(x + 76.2152, y + 2.14017, x + 76.8674, y + 2.68766, x + 77.62, y + 3.06094);
ctx.bezierCurveTo(x + 77.896, y + 3.21026, x + 77.9713, y + 3.45912, x + 77.9713, y + 3.68309);
ctx.bezierCurveTo(x + 77.9713, y + 4.15592, x + 77.62, y + 4.72829, x + 77.1936, y + 4.92737);
ctx.bezierCurveTo(x + 76.8172, y + 5.10157, x + 75.7636, y + 4.65363, x + 74.9357, y + 4.30523);
ctx.bezierCurveTo(x + 74.1329, y + 3.95683, x + 73.6562, y + 3.78263, x + 73.4806, y + 3.88217);
ctx.bezierCurveTo(x + 73.4305, y + 3.90706, x + 73.4054, y + 3.95683, x + 73.4054, y + 3.98172);
ctx.bezierCurveTo(x + 73.3552, y + 4.47943, x + 74.6346, y + 5.44997, x + 74.7852, y + 5.54952);
ctx.lineTo(x + 74.8103, y + 5.54952);
ctx.lineTo(x + 74.8353, y + 5.54952);
ctx.bezierCurveTo(x + 74.8353, y + 5.54952, x + 76.0897, y + 5.79837, x + 76.4158, y + 6.42052);
ctx.bezierCurveTo(x + 76.5162, y + 6.6196, x + 76.5162, y + 6.84358, x + 76.4158, y + 7.09243);
ctx.bezierCurveTo(x + 76.2904, y + 7.39106, x + 76.1148, y + 7.56526, x + 75.8639, y + 7.6648);
ctx.bezierCurveTo(x + 75.4124, y + 7.839, x + 74.8103, y + 7.56526, x + 74.3838, y + 7.36618);
ctx.bezierCurveTo(x + 74.2583, y + 7.3164, x + 74.158, y + 7.26663, x + 74.0576, y + 7.21686);
ctx.bezierCurveTo(x + 73.3803, y + 6.968, x + 72.1761, y + 7.19198, x + 71.3984, y + 7.71458);
ctx.lineTo(x + 71.3482, y + 7.73946);
ctx.lineTo(x + 71.3733, y + 7.78923);
ctx.bezierCurveTo(x + 71.4486, y + 8.11275, x + 72.1761, y + 8.3616, x + 72.2764, y + 8.41138);
ctx.lineTo(x + 72.3015, y + 8.41138);
ctx.lineTo(x + 72.3266, y + 8.41138);
ctx.bezierCurveTo(x + 72.3266, y + 8.41138, x + 73.5308, y + 8.21229, x + 74.0576, y + 8.23718);
ctx.bezierCurveTo(x + 74.158, y + 8.23718, x + 74.2834, y + 8.28695, x + 74.434, y + 8.33672);
ctx.bezierCurveTo(x + 74.7099, y + 8.46115, x + 75.0611, y + 8.68512, x + 75.2367, y + 9.00863);
ctx.bezierCurveTo(x + 75.4374, y + 9.38192, x + 75.4374, y + 9.80498, x + 75.1866, y + 10.228);
ctx.bezierCurveTo(x + 74.4841, y + 11.4972, x + 72.5273, y + 10.8751, x + 72.5273, y + 10.8751);
ctx.lineTo(x + 72.5022, y + 10.8751);
ctx.lineTo(x + 72.4771, y + 10.8751);
ctx.bezierCurveTo(x + 72.2514, y + 10.9497, x + 70.2695, y + 11.547, x + 70.0938, y + 11.9949);
ctx.bezierCurveTo(x + 69.9684, y + 12.3433, x + 69.6924, y + 12.9406, x + 69.5921, y + 13.1397);
ctx.lineTo(x + 68.2625, y + 12.4429);
ctx.bezierCurveTo(x + 68.3377, y + 12.2189, x + 68.6388, y + 11.4474, x + 68.8896, y + 11.1488);
ctx.bezierCurveTo(x + 69.1405, y + 10.8502, x + 69.567, y + 10.5267, x + 70.6959, y + 10.1783);
ctx.lineTo(x + 70.8465, y + 10.1285);
ctx.lineTo(x + 70.6959, y + 10.0538);
ctx.bezierCurveTo(x + 70.6709, y + 10.0538, x + 68.689, y + 8.93398, x + 69.2409, y + 7.4906);
ctx.bezierCurveTo(x + 69.9182, y + 5.7486, x + 72.1259, y + 5.72372, x + 72.151, y + 5.72372);
ctx.lineTo(x + 72.3517, y + 5.72372);
ctx.lineTo(x + 72.2012, y + 5.59929);
ctx.bezierCurveTo(x + 72.1761, y + 5.59929, x + 70.7712, y + 4.355, x + 71.3984, y + 2.98629);
ctx.bezierCurveTo(x + 72.0256, y + 1.64246, x + 74.0075, y + 2.38903, x + 74.0326, y + 2.38903);
ctx.lineTo(x + 74.2082, y + 2.46369);
ctx.lineTo(x + 74.1078, y + 2.28949);
ctx.bezierCurveTo(x + 74.1078, y + 2.28949, x + 73.6813, y + 1.46826, x + 73.882, y + 0.721686);
ctx.lineTo(x + 73.882, y + 0.671915);
ctx.lineTo(x + 73.8569, y + 0.647029);
ctx.bezierCurveTo(x + 73.7817, y + 0.572372, x + 73.7315, y + 0.5226, x + 73.6562, y + 0.447943);
ctx.bezierCurveTo(x + 73.6061, y + 0.447943, x + 73.5308, y + 0.447943, x + 73.4806, y + 0.472829);
ctx.bezierCurveTo(x + 73.5559, y + 0.547486, x + 73.6312, y + 0.647029, x + 73.7315, y + 0.721686);
ctx.bezierCurveTo(x + 73.581, y + 1.31894, x + 73.7817, y + 1.94109, x + 73.9071, y + 2.21483);
ctx.bezierCurveTo(x + 73.4054, y + 2.06552, x + 71.8249, y + 1.69223, x + 71.2479, y + 2.93652);
ctx.bezierCurveTo(x + 70.6959, y + 4.15592, x + 71.6242, y + 5.25089, x + 71.9754, y + 5.59929);
ctx.bezierCurveTo(x + 71.4235, y + 5.64906, x + 69.6924, y + 5.9228, x + 69.0904, y + 7.44083);
ctx.bezierCurveTo(x + 68.5886, y + 8.73489, x + 70.0186, y + 9.78009, x + 70.4702, y + 10.0787);
ctx.bezierCurveTo(x + 69.4165, y + 10.4022, x + 69.0151, y + 10.7506, x + 68.7642, y + 11.0244);
ctx.bezierCurveTo(x + 68.4632, y + 11.3728, x + 68.1119, y + 12.3682, x + 68.0869, y + 12.418);
ctx.lineTo(x + 68.0618, y + 12.4678);
ctx.lineTo(x + 69.6423, y + 13.289);
ctx.lineTo(x + 69.6674, y + 13.2143);
ctx.bezierCurveTo(x + 69.6674, y + 13.2143, x + 70.0437, y + 12.418, x + 70.1942, y + 11.9949);
ctx.bezierCurveTo(x + 70.2945, y + 11.6963, x + 71.6493, y + 11.1986, x + 72.4771, y + 10.9497);
ctx.bezierCurveTo(x + 72.7029, y + 11.0244, x + 74.5594, y + 11.5221, x + 75.2869, y + 10.228);
ctx.bezierCurveTo(x + 75.6381, y + 9.60589, x + 75.5127, y + 9.15795, x + 75.3371, y + 8.85932);
ctx.bezierCurveTo(x + 75.036, y + 8.33672, x + 74.3587, y + 8.0132, x + 74.0326, y + 8.0132);
ctx.bezierCurveTo(x + 73.5308, y + 7.98832, x + 72.4521, y + 8.16252, x + 72.3015, y + 8.1874);
ctx.bezierCurveTo(x + 72.0507, y + 8.08786, x + 71.6242, y + 7.88878, x + 71.5238, y + 7.71458);
ctx.bezierCurveTo(x + 72.3266, y + 7.19198, x + 73.4555, y + 7.04266, x + 74.0075, y + 7.26663);
ctx.bezierCurveTo(x + 74.1078, y + 7.29152, x + 74.2082, y + 7.34129, x + 74.3085, y + 7.39106);
ctx.bezierCurveTo(x + 74.7601, y + 7.59015, x + 75.3873, y + 7.88878, x + 75.889, y + 7.68969);
ctx.bezierCurveTo(x + 76.165, y + 7.59015, x + 76.3657, y + 7.36618, x + 76.5162, y + 7.04266);
ctx.bezierCurveTo(x + 76.6416, y + 6.74403, x + 76.6416, y + 6.49517, x + 76.5162, y + 6.24632);
ctx.bezierCurveTo(x + 76.165, y + 5.59929, x + 75.011, y + 5.32555, x + 74.8604, y + 5.30066);
ctx.bezierCurveTo(x + 74.4841, y + 5.00203, x + 73.5308, y + 4.20569, x + 73.5559, y + 3.85729);
ctx.bezierCurveTo(x + 73.6312, y + 3.75774, x + 74.3838, y + 4.08126, x + 74.8855, y + 4.28035);
ctx.bezierCurveTo(x + 75.8138, y + 4.65363, x + 76.8423, y + 5.10157, x + 77.2688, y + 4.90249);
ctx.bezierCurveTo(x + 77.7455, y + 4.67852, x + 78.1218, y + 4.08126, x + 78.1218, y + 3.53377);
ctx.bezierCurveTo(x + 78.1218, y + 3.18537, x + 77.9713, y + 2.93652, x + 77.6953, y + 2.7872);
ctx.bezierCurveTo(x + 77.0681, y + 2.46369, x + 76.4911, y + 2.04063, x + 76.1901, y + 1.64246);
ctx.bezierCurveTo(x + 76.8423, y + 1.81666, x + 77.7204, y + 1.81666, x + 78.3225, y + 1.49314);
ctx.bezierCurveTo(x + 78.6486, y + 1.31894, x + 78.8493, y + 1.0452, x + 78.9246, y + 0.721686);
ctx.bezierCurveTo(x + 79.0249, y + 0.572372, x + 78.9998, y + 0.273743, x + 78.9246, y + 0);
ctx.bezierCurveTo(x + 78.8744, y + 0, x + 78.8242, y + 0, x + 78.7741, y + 0.0248857);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 78.4981, y + 0.597168);
ctx.lineTo(x + 78.172, y + 0.671825);
ctx.bezierCurveTo(x + 78.0717, y + 0.696711, x + 77.9713, y + 0.721597, x + 77.871, y + 0.771368);
ctx.bezierCurveTo(x + 77.7706, y + 0.796254, x + 77.6703, y + 0.82114, x + 77.595, y + 0.870911);
ctx.bezierCurveTo(x + 77.4946, y + 0.920682, x + 77.4194, y + 0.970454, x + 77.2939, y + 1.02023);
ctx.bezierCurveTo(x + 77.3943, y + 1.11977, x + 77.5197, y + 1.14465, x + 77.6452, y + 1.16954);
ctx.bezierCurveTo(x + 77.7706, y + 1.16954, x + 77.896, y + 1.16954, x + 77.9964, y + 1.11977);
ctx.bezierCurveTo(x + 78.1218, y + 1.07, x + 78.2222, y + 1.02023, x + 78.3225, y + 0.920682);
ctx.bezierCurveTo(x + 78.3978, y + 0.846025, x + 78.4731, y + 0.721597, x + 78.4981, y + 0.597168);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 77.4444, y + 3.88208);
ctx.lineTo(x + 77.1183, y + 3.95674);
ctx.bezierCurveTo(x + 77.0179, y + 3.98162, x + 76.9176, y + 4.00651, x + 76.8172, y + 4.05628);
ctx.bezierCurveTo(x + 76.7169, y + 4.08117, x + 76.6165, y + 4.13094, x + 76.5413, y + 4.18071);
ctx.bezierCurveTo(x + 76.4409, y + 4.23048, x + 76.3657, y + 4.28025, x + 76.2402, y + 4.33002);
ctx.bezierCurveTo(x + 76.3406, y + 4.42957, x + 76.466, y + 4.45445, x + 76.5915, y + 4.47934);
ctx.bezierCurveTo(x + 76.7169, y + 4.47934, x + 76.8423, y + 4.47934, x + 76.9427, y + 4.42957);
ctx.bezierCurveTo(x + 77.0681, y + 4.37979, x + 77.1685, y + 4.33002, x + 77.2688, y + 4.23048);
ctx.bezierCurveTo(x + 77.3441, y + 4.13094, x + 77.4444, y + 4.00651, x + 77.4444, y + 3.88208);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 75.9643, y + 6.99292);
ctx.bezierCurveTo(x + 75.8389, y + 7.01781, x + 75.7385, y + 7.04269, x + 75.6633, y + 7.04269);
ctx.bezierCurveTo(x + 75.5629, y + 7.06758, x + 75.4877, y + 7.06758, x + 75.3873, y + 7.09246);
ctx.bezierCurveTo(x + 75.287, y + 7.11735, x + 75.2117, y + 7.14223, x + 75.1114, y + 7.16712);
ctx.lineTo(x + 74.8103, y + 7.26666);
ctx.bezierCurveTo(x + 74.8856, y + 7.39109, x + 75.011, y + 7.44086, x + 75.1364, y + 7.46575);
ctx.bezierCurveTo(x + 75.2619, y + 7.49063, x + 75.3622, y + 7.49063, x + 75.4877, y + 7.46575);
ctx.bezierCurveTo(x + 75.6131, y + 7.44086, x + 75.7134, y + 7.39109, x + 75.8138, y + 7.31643);
ctx.bezierCurveTo(x + 75.8891, y + 7.21689, x + 75.9643, y + 7.11735, x + 75.9643, y + 6.99292);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 74.9106, y + 9.75513);
ctx.bezierCurveTo(x + 74.7851, y + 9.8049, x + 74.6597, y + 9.85467, x + 74.5593, y + 9.90444);
ctx.bezierCurveTo(x + 74.4339, y + 9.95421, x + 74.3336, y + 9.9791, x + 74.2332, y + 10.0289);
ctx.lineTo(x + 73.9071, y + 10.1284);
ctx.bezierCurveTo(x + 73.7816, y + 10.1533, x + 73.6813, y + 10.2031, x + 73.5308, y + 10.228);
ctx.bezierCurveTo(x + 73.6311, y + 10.3524, x + 73.7816, y + 10.3773, x + 73.9071, y + 10.4022);
ctx.bezierCurveTo(x + 74.0576, y + 10.427, x + 74.183, y + 10.4022, x + 74.3336, y + 10.3773);
ctx.bezierCurveTo(x + 74.459, y + 10.3275, x + 74.6095, y + 10.2528, x + 74.7099, y + 10.1533);
ctx.bezierCurveTo(x + 74.8102, y + 10.0289, x + 74.8855, y + 9.90444, x + 74.9106, y + 9.75513);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 72.8534, y + 5.10156);
ctx.bezierCurveTo(x + 72.6276, y + 5.40019, x + 72.0004, y + 4.82782, x + 71.8499, y + 3.6333);
ctx.bezierCurveTo(x + 72.5272, y + 4.18079, x + 73.1293, y + 4.72827, x + 72.8534, y + 5.10156);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 70.7462, y + 9.35693);
ctx.bezierCurveTo(x + 70.5204, y + 9.65556, x + 69.8932, y + 9.08319, x + 69.7427, y + 7.88867);
ctx.bezierCurveTo(x + 70.3949, y + 8.43616, x + 70.997, y + 8.98364, x + 70.7462, y + 9.35693);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 69.9433, y + 13.4631);
ctx.lineTo(x + 66.7321, y + 20.9288);
ctx.lineTo(x + 63.6965, y + 19.1619);
ctx.lineTo(x + 67.7858, y + 12.2935);
ctx.lineTo(x + 69.9433, y + 13.4631);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#ED1B24";

ctx.beginPath();
ctx.moveTo(x + 67.8359, y + 17.221);
ctx.bezierCurveTo(x + 67.8359, y + 17.221, x + 66.707, y + 16.6237, x + 66.7822, y + 16.3997);
ctx.bezierCurveTo(x + 67.1836, y + 15.4043, x + 67.9112, y + 14.2098, x + 68.3126, y + 13.5379);
ctx.bezierCurveTo(x + 68.4882, y + 13.2393, x + 68.9398, y + 13.1397, x + 68.9398, y + 13.1397);
ctx.bezierCurveTo(x + 68.7641, y + 13.0402, x + 68.2373, y + 12.3683, x + 67.7356, y + 12.642);
ctx.bezierCurveTo(x + 67.4596, y + 12.7913, x + 67.0331, y + 13.737, x + 66.7822, y + 14.2098);
ctx.bezierCurveTo(x + 66.13, y + 15.3545, x + 65.7788, y + 16.0016, x + 65.7788, y + 16.0016);
ctx.lineTo(x + 64.0979, y + 18.8634);
ctx.lineTo(x + 64.7, y + 19.1621);
ctx.bezierCurveTo(x + 64.7, y + 19.1621, x + 65.3021, y + 18.5648, x + 65.6533, y + 17.8182);
ctx.bezierCurveTo(x + 66.1551, y + 16.6237, x + 67.8359, y + 17.221, x + 67.8359, y + 17.221);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 65.7028, y + 15.737);
ctx.lineTo(x + 65.5266, y + 16.0669);
ctx.lineTo(x + 68.1205, y + 17.4298);
ctx.lineTo(x + 68.2966, y + 17.1);
ctx.lineTo(x + 65.7028, y + 15.737);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 66.8827, y + 21.3519);
ctx.lineTo(x + 70.0688, y + 13.9111);
ctx.bezierCurveTo(x + 70.1942, y + 13.5876, x + 70.0688, y + 13.2143, x + 69.7678, y + 13.065);
ctx.lineTo(x + 68.2625, y + 12.2438);
ctx.bezierCurveTo(x + 67.9364, y + 12.0696, x + 67.535, y + 12.1691, x + 67.3594, y + 12.4926);
ctx.lineTo(x + 63.3203, y + 19.2864);
ctx.lineTo(x + 66.8827, y + 21.3519);
ctx.closePath();
ctx.moveTo(x + 67.9615, y + 12.7166);
ctx.bezierCurveTo(x + 67.9866, y + 12.7166, x + 67.9866, y + 12.7166, x + 67.9615, y + 12.7166);
ctx.lineTo(x + 69.4667, y + 13.5378);
ctx.bezierCurveTo(x + 69.5169, y + 13.5627, x + 69.542, y + 13.6374, x + 69.5169, y + 13.6871);
ctx.lineTo(x + 66.5817, y + 20.5556);
ctx.lineTo(x + 64.0729, y + 19.0873);
ctx.lineTo(x + 67.8109, y + 12.7912);
ctx.bezierCurveTo(x + 67.8611, y + 12.7166, x + 67.9113, y + 12.6917, x + 67.9615, y + 12.7166);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 52.1565, y + 41.584);
ctx.bezierCurveTo(x + 54.9914, y + 43.4753, x + 57.2492, y + 45.1924, x + 57.0987, y + 46.5114);
ctx.bezierCurveTo(x + 56.9482, y + 47.8303, x + 55.4178, y + 48.3778, x + 53.16, y + 46.8349);
ctx.bezierCurveTo(x + 53.16, y + 46.8349, x + 53.4359, y + 44.62, x + 52.9342, y + 43.55);
ctx.bezierCurveTo(x + 52.4074, y + 42.5048, x + 52.1565, y + 41.584, x + 52.1565, y + 41.584);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#ED1B24";

ctx.beginPath();
ctx.moveTo(x + 58.4535, y + 59.0289);
ctx.bezierCurveTo(x + 58.3281, y + 58.4565, x + 58.1023, y + 57.9339, x + 57.8263, y + 57.4362);
ctx.bezierCurveTo(x + 57.5503, y + 56.9385, x + 57.1991, y + 56.4657, x + 56.8479, y + 56.0177);
ctx.bezierCurveTo(x + 56.4967, y + 55.5698, x + 56.0953, y + 55.1467, x + 55.6939, y + 54.7486);
ctx.bezierCurveTo(x + 55.2925, y + 54.3504, x + 54.8409, y + 53.9771, x + 54.3643, y + 53.6785);
ctx.bezierCurveTo(x + 54.6904, y + 54.1513, x + 55.0165, y + 54.5992, x + 55.3677, y + 55.0472);
ctx.bezierCurveTo(x + 55.719, y + 55.4951, x + 56.0702, y + 55.9182, x + 56.4214, y + 56.3661);
ctx.bezierCurveTo(x + 56.7726, y + 56.8141, x + 57.1239, y + 57.2371, x + 57.4751, y + 57.6851);
ctx.bezierCurveTo(x + 57.8012, y + 58.1081, x + 58.1274, y + 58.5312, x + 58.4535, y + 59.0289);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 48.8449, y + 74.906);
ctx.bezierCurveTo(x + 49.1209, y + 74.458, x + 49.3968, y + 74.0101, x + 49.6728, y + 73.5621);
ctx.bezierCurveTo(x + 49.9487, y + 73.1142, x + 50.1996, y + 72.6662, x + 50.4505, y + 72.1934);
ctx.bezierCurveTo(x + 50.7014, y + 71.7455, x + 50.9522, y + 71.2726, x + 51.178, y + 70.7998);
ctx.bezierCurveTo(x + 51.4038, y + 70.327, x + 51.6296, y + 69.8542, x + 51.8052, y + 69.3564);
ctx.bezierCurveTo(x + 51.5543, y + 69.8293, x + 51.2784, y + 70.2523, x + 50.9773, y + 70.6754);
ctx.bezierCurveTo(x + 50.6763, y + 71.0984, x + 50.3752, y + 71.5215, x + 50.0491, y + 71.9446);
ctx.bezierCurveTo(x + 49.723, y + 72.3676, x + 49.4219, y + 72.7658, x + 49.0958, y + 73.164);
ctx.bezierCurveTo(x + 48.7696, y + 73.5621, x + 48.4435, y + 73.9603, x + 48.0923, y + 74.3585);
ctx.lineTo(x + 48.8449, y + 74.906);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#ED1B24";

ctx.beginPath();
ctx.moveTo(x + 28.2985, y + 79.5846);
ctx.bezierCurveTo(x + 25.4636, y + 86.1296, x + 28.5745, y + 93.7446, x + 35.2226, y + 96.5816);
ctx.bezierCurveTo(x + 41.8958, y + 99.4185, x + 49.5976, y + 96.4322, x + 52.4325, y + 89.8873);
ctx.bezierCurveTo(x + 55.2674, y + 83.3424, x + 52.1565, y + 75.7273, x + 45.5084, y + 72.8904);
ctx.bezierCurveTo(x + 44.5551, y + 72.4922, x + 43.6018, y + 72.1936, x + 42.6234, y + 72.0194);
ctx.bezierCurveTo(x + 40.0394, y + 71.5465, x + 37.4303, y + 71.87, x + 35.0972, y + 72.8655);
ctx.bezierCurveTo(x + 32.1369, y + 74.1098, x + 29.6532, y + 76.4241, x + 28.2985, y + 79.5846);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 35.072, y + 96.9051);
ctx.bezierCurveTo(x + 41.9209, y + 99.8167, x + 49.8485, y + 96.7309, x + 52.7586, y + 90.0117);
ctx.bezierCurveTo(x + 55.6687, y + 83.2926, x + 52.4826, y + 75.4536, x + 45.6338, y + 72.5419);
ctx.bezierCurveTo(x + 44.6805, y + 72.1438, x + 43.677, y + 71.8451, x + 42.6735, y + 71.646);
ctx.bezierCurveTo(x + 40.0644, y + 71.1732, x + 37.3801, y + 71.4718, x + 34.9466, y + 72.517);
ctx.bezierCurveTo(x + 31.7856, y + 73.8609, x + 29.302, y + 76.2997, x + 27.9472, y + 79.4353);
ctx.bezierCurveTo(x + 25.0371, y + 86.1544, x + 28.2232, y + 93.9934, x + 35.072, y + 96.9051);
ctx.closePath();
ctx.moveTo(x + 45.3578, y + 73.2138);
ctx.bezierCurveTo(x + 51.8304, y + 75.9762, x + 54.8409, y + 83.3672, x + 52.1063, y + 89.7131);
ctx.bezierCurveTo(x + 49.3467, y + 96.0589, x + 41.8707, y + 98.9706, x + 35.3982, y + 96.2083);
ctx.bezierCurveTo(x + 28.9256, y + 93.4459, x + 25.9152, y + 86.0549, x + 28.6497, y + 79.709);
ctx.bezierCurveTo(x + 29.9291, y + 76.7725, x + 32.2623, y + 74.4581, x + 35.2476, y + 73.189);
ctx.bezierCurveTo(x + 37.5557, y + 72.2184, x + 40.0895, y + 71.9198, x + 42.5481, y + 72.3677);
ctx.bezierCurveTo(x + 43.5014, y + 72.5419, x + 44.4547, y + 72.8406, x + 45.3578, y + 73.2138);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 40.5913, y + 80.406);
ctx.bezierCurveTo(x + 40.3404, y + 80.6299, x + 40.3404, y + 81.0032, x + 40.5662, y + 81.2521);
ctx.bezierCurveTo(x + 40.792, y + 81.5009, x + 41.1683, y + 81.5009, x + 41.4192, y + 81.277);
ctx.bezierCurveTo(x + 41.6701, y + 81.053, x + 41.6701, y + 80.6797, x + 41.4443, y + 80.4308);
ctx.bezierCurveTo(x + 41.1934, y + 80.182, x + 40.8171, y + 80.182, x + 40.5913, y + 80.406);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 41.344, y + 82.0733);
ctx.bezierCurveTo(x + 41.0931, y + 82.2973, x + 41.0931, y + 82.6706, x + 41.3189, y + 82.9195);
ctx.bezierCurveTo(x + 41.5447, y + 83.1683, x + 41.921, y + 83.1683, x + 42.1719, y + 82.9444);
ctx.bezierCurveTo(x + 42.4228, y + 82.7204, x + 42.4228, y + 82.3471, x + 42.197, y + 82.0982);
ctx.bezierCurveTo(x + 41.9712, y + 81.8494, x + 41.5949, y + 81.8245, x + 41.344, y + 82.0733);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 39.3872, y + 81.7996);
ctx.bezierCurveTo(x + 39.1363, y + 82.0236, x + 39.1363, y + 82.3969, x + 39.3621, y + 82.6457);
ctx.bezierCurveTo(x + 39.5879, y + 82.8946, x + 39.9642, y + 82.8946, x + 40.2151, y + 82.6706);
ctx.bezierCurveTo(x + 40.466, y + 82.4466, x + 40.466, y + 82.0734, x + 40.2402, y + 81.8245);
ctx.bezierCurveTo(x + 39.9893, y + 81.6005, x + 39.613, y + 81.5756, x + 39.3872, y + 81.7996);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 40.0645, y + 83.4668);
ctx.bezierCurveTo(x + 39.8136, y + 83.6907, x + 39.8136, y + 84.064, x + 40.0394, y + 84.3129);
ctx.bezierCurveTo(x + 40.2652, y + 84.5617, x + 40.6415, y + 84.5617, x + 40.8923, y + 84.3377);
ctx.bezierCurveTo(x + 41.1432, y + 84.1138, x + 41.1432, y + 83.7405, x + 40.9174, y + 83.4916);
ctx.bezierCurveTo(x + 40.6916, y + 83.2428, x + 40.3153, y + 83.2428, x + 40.0645, y + 83.4668);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 38.1829, y + 83.218);
ctx.bezierCurveTo(x + 37.932, y + 83.4419, x + 37.932, y + 83.8152, x + 38.1578, y + 84.0641);
ctx.bezierCurveTo(x + 38.3836, y + 84.3129, x + 38.7599, y + 84.3129, x + 39.0108, y + 84.089);
ctx.bezierCurveTo(x + 39.2616, y + 83.865, x + 39.2616, y + 83.4917, x + 39.0358, y + 83.2429);
ctx.bezierCurveTo(x + 38.8101, y + 82.994, x + 38.4337, y + 82.994, x + 38.1829, y + 83.218);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 37.6812, y + 81.4012);
ctx.bezierCurveTo(x + 37.4303, y + 81.6252, x + 37.4303, y + 81.9985, x + 37.6561, y + 82.2473);
ctx.bezierCurveTo(x + 37.8819, y + 82.4962, x + 38.2582, y + 82.4962, x + 38.509, y + 82.2722);
ctx.bezierCurveTo(x + 38.7599, y + 82.0483, x + 38.7599, y + 81.675, x + 38.5341, y + 81.4261);
ctx.bezierCurveTo(x + 38.2833, y + 81.1773, x + 37.9069, y + 81.1524, x + 37.6812, y + 81.4012);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 38.7849, y + 79.9829);
ctx.bezierCurveTo(x + 38.534, y + 80.2068, x + 38.534, y + 80.5801, x + 38.7598, y + 80.829);
ctx.bezierCurveTo(x + 38.9856, y + 81.0778, x + 39.3619, y + 81.0778, x + 39.6128, y + 80.8539);
ctx.bezierCurveTo(x + 39.8637, y + 80.6299, x + 39.8637, y + 80.2566, x + 39.6379, y + 80.0078);
ctx.bezierCurveTo(x + 39.387, y + 79.7589, x + 39.0107, y + 79.7589, x + 38.7849, y + 79.9829);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 41.2436, y + 74.2094);
ctx.bezierCurveTo(x + 40.2902, y + 73.9854, x + 39.3118, y + 73.9108, x + 38.3334, y + 74.0103);
ctx.bezierCurveTo(x + 37.355, y + 74.1098, x + 36.3766, y + 74.4085, x + 35.4735, y + 74.8813);
ctx.bezierCurveTo(x + 34.5703, y + 75.3541, x + 33.7926, y + 76.0012, x + 33.1404, y + 76.7726);
ctx.bezierCurveTo(x + 32.4881, y + 77.5441, x + 31.9863, y + 78.44, x + 31.6351, y + 79.3856);
ctx.bezierCurveTo(x + 31.2839, y + 80.3313, x + 31.0581, y + 81.3018, x + 31.033, y + 82.3221);
ctx.bezierCurveTo(x + 30.9828, y + 83.3176, x + 31.1585, y + 84.3628, x + 31.5599, y + 85.2835);
ctx.bezierCurveTo(x + 31.9362, y + 86.2292, x + 32.5383, y + 87.0504, x + 33.2407, y + 87.7472);
ctx.bezierCurveTo(x + 33.9432, y + 88.444, x + 34.7961, y + 88.9666, x + 35.6742, y + 89.3648);
ctx.bezierCurveTo(x + 34.8965, y + 88.7924, x + 34.1689, y + 88.1703, x + 33.5668, y + 87.4486);
ctx.bezierCurveTo(x + 32.9647, y + 86.7269, x + 32.5132, y + 85.9057, x + 32.2372, y + 85.0596);
ctx.bezierCurveTo(x + 31.9613, y + 84.1886, x + 31.8609, y + 83.2927, x + 31.9111, y + 82.3968);
ctx.bezierCurveTo(x + 31.9111, y + 82.2724, x + 31.9111, y + 82.1728, x + 31.9362, y + 82.0484);
ctx.lineTo(x + 31.9863, y + 81.7);
ctx.lineTo(x + 32.0365, y + 81.3516);
ctx.bezierCurveTo(x + 32.0616, y + 81.252, x + 32.0867, y + 81.1276, x + 32.1118, y + 81.0281);
ctx.lineTo(x + 32.187, y + 80.7046);
ctx.bezierCurveTo(x + 32.2121, y + 80.605, x + 32.2372, y + 80.4806, x + 32.2874, y + 80.381);
ctx.lineTo(x + 32.5132, y + 79.734);
ctx.bezierCurveTo(x + 32.8393, y + 78.8879, x + 33.2658, y + 78.0667, x + 33.8428, y + 77.345);
ctx.bezierCurveTo(x + 34.3947, y + 76.6233, x + 35.0721, y + 76.0012, x + 35.8498, y + 75.5283);
ctx.bezierCurveTo(x + 36.6275, y + 75.0555, x + 37.5056, y + 74.6822, x + 38.4087, y + 74.4831);
ctx.bezierCurveTo(x + 39.3118, y + 74.2343, x + 40.2652, y + 74.1596, x + 41.2436, y + 74.2094);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 34.194, y + 76.2251);
ctx.bezierCurveTo(x + 34.194, y + 76.2251, x + 36.1257, y + 78.2657, x + 34.9215, y + 81.8742);
ctx.bezierCurveTo(x + 33.7173, y + 85.5075, x + 32.2873, y + 86.1296, x + 32.2873, y + 86.1296);
ctx.bezierCurveTo(x + 30.5563, y + 82.7949, x + 31.3089, y + 78.7386, x + 34.1438, y + 76.25);
ctx.lineTo(x + 34.194, y + 76.2251);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#ED1B24";

ctx.beginPath();
ctx.moveTo(x + 37.6812, y + 75.7273);
ctx.lineTo(x + 37.7816, y + 75.4784);
ctx.lineTo(x + 37.907, y + 75.2296);
ctx.bezierCurveTo(x + 37.8067, y + 75.1798, x + 36.3516, y + 74.3834, x + 35.3983, y + 73.8608);
ctx.lineTo(x + 35.1223, y + 74.3337);
ctx.bezierCurveTo(x + 36.2512, y + 74.9558, x + 37.631, y + 75.7024, x + 37.6812, y + 75.7273);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 38.1326, y + 75.4536);
ctx.bezierCurveTo(x + 38.0824, y + 75.1799, x + 37.9319, y + 74.931, x + 37.7312, y + 74.7071);
ctx.bezierCurveTo(x + 37.5556, y + 74.508, x + 37.3298, y + 74.3089, x + 37.0789, y + 74.1845);
ctx.bezierCurveTo(x + 36.828, y + 74.0351, x + 36.5772, y + 73.9356, x + 36.3012, y + 73.8858);
ctx.bezierCurveTo(x + 36.0253, y + 73.8361, x + 35.7242, y + 73.8361, x + 35.4482, y + 73.9605);
ctx.bezierCurveTo(x + 35.6991, y + 74.0849, x + 35.9249, y + 74.1845, x + 36.1507, y + 74.3089);
ctx.bezierCurveTo(x + 36.3765, y + 74.4333, x + 36.5772, y + 74.5329, x + 36.803, y + 74.6573);
ctx.lineTo(x + 38.1326, y + 75.4536);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 40.9927, y + 76.9715);
ctx.bezierCurveTo(x + 40.9927, y + 76.7973, x + 40.9425, y + 76.648, x + 40.8673, y + 76.4987);
ctx.bezierCurveTo(x + 40.792, y + 76.3494, x + 40.6917, y + 76.2249, x + 40.5913, y + 76.1005);
ctx.bezierCurveTo(x + 40.491, y + 75.9761, x + 40.3655, y + 75.8765, x + 40.215, y + 75.777);
ctx.bezierCurveTo(x + 40.0645, y + 75.7023, x + 39.914, y + 75.6028, x + 39.7634, y + 75.6028);
ctx.bezierCurveTo(x + 39.914, y + 75.6774, x + 40.0143, y + 75.777, x + 40.1397, y + 75.9014);
ctx.bezierCurveTo(x + 40.2652, y + 76.001, x + 40.3655, y + 76.1254, x + 40.4659, y + 76.2249);
ctx.bezierCurveTo(x + 40.5662, y + 76.3494, x + 40.6666, y + 76.4489, x + 40.7669, y + 76.5733);
ctx.bezierCurveTo(x + 40.8422, y + 76.6978, x + 40.9174, y + 76.8222, x + 40.9927, y + 76.9715);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 46.3364, y + 77.1208);
ctx.bezierCurveTo(x + 46.2611, y + 76.9964, x + 46.1357, y + 76.8969, x + 46.0102, y + 76.8222);
ctx.bezierCurveTo(x + 45.8597, y + 76.7724, x + 45.7092, y + 76.7476, x + 45.5587, y + 76.7476);
ctx.bezierCurveTo(x + 45.4081, y + 76.7476, x + 45.2576, y + 76.7973, x + 45.1322, y + 76.8471);
ctx.bezierCurveTo(x + 45.0067, y + 76.8969, x + 44.8562, y + 76.9715, x + 44.7559, y + 77.0711);
ctx.lineTo(x + 45.1573, y + 76.9964);
ctx.bezierCurveTo(x + 45.2827, y + 76.9715, x + 45.4332, y + 76.9466, x + 45.5587, y + 76.9466);
ctx.bezierCurveTo(x + 45.6841, y + 76.9466, x + 45.8095, y + 76.9466, x + 45.935, y + 76.9715);
ctx.bezierCurveTo(x + 46.0855, y + 76.9964, x + 46.2109, y + 77.0462, x + 46.3364, y + 77.1208);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 46.3111, y + 96.3825);
ctx.bezierCurveTo(x + 47.1139, y + 95.9843, x + 47.8665, y + 95.5364, x + 48.5439, y + 94.9889);
ctx.lineTo(x + 48.4435, y + 94.8396);
ctx.bezierCurveTo(x + 48.3432, y + 94.9143, x + 47.3146, y + 95.6111, x + 46.2358, y + 96.2083);
ctx.lineTo(x + 46.3111, y + 96.3825);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 35.097, y + 72.8654);
ctx.bezierCurveTo(x + 35.373, y + 73.0147, x + 35.4984, y + 73.1142, x + 35.3981, y + 73.1391);
ctx.bezierCurveTo(x + 34.6706, y + 73.4378, x + 30.5813, y + 75.2046, x + 29.2266, y + 80.1071);
ctx.bezierCurveTo(x + 27.8719, y + 85.0345, x + 30.4308, y + 90.1859, x + 36.0253, y + 92.3509);
ctx.bezierCurveTo(x + 41.6198, y + 94.5409, x + 49.1209, y + 91.8034, x + 50.4003, y + 83.6658);
ctx.bezierCurveTo(x + 51.6798, y + 75.5282, x + 44.5801, y + 72.7658, x + 42.548, y + 72.3428);
ctx.lineTo(x + 42.6232, y + 71.9944);
ctx.bezierCurveTo(x + 43.6017, y + 72.1686, x + 44.555, y + 72.4423, x + 45.5083, y + 72.8654);
ctx.bezierCurveTo(x + 47.8916, y + 73.8857, x + 49.8233, y + 75.5033, x + 51.178, y + 77.4692);
ctx.lineTo(x + 50.8519, y + 77.5688);
ctx.bezierCurveTo(x + 52.5077, y + 79.4103, x + 53.7118, y + 86.876, x + 49.9237, y + 93.6201);
ctx.bezierCurveTo(x + 49.4972, y + 94.068, x + 49.0205, y + 94.4911, x + 48.5188, y + 94.8644);
ctx.bezierCurveTo(x + 49.8233, y + 93.6947, x + 50.8268, y + 90.6587, x + 50.8017, y + 88.4936);
ctx.bezierCurveTo(x + 50.0742, y + 89.6633, x + 48.7195, y + 90.5343, x + 48.1174, y + 91.2808);
ctx.bezierCurveTo(x + 47.5153, y + 92.0274, x + 44.9815, y + 94.7648, x + 43.9529, y + 95.5363);
ctx.bezierCurveTo(x + 42.9494, y + 96.3077, x + 42.4225, y + 97.2036, x + 43.8525, y + 97.1539);
ctx.bezierCurveTo(x + 42.3724, y + 97.552, x + 40.842, y + 97.6765, x + 39.2866, y + 97.552);
ctx.bezierCurveTo(x + 37.2295, y + 96.8552, x + 34.9716, y + 95.6856, x + 32.6887, y + 93.645);
ctx.bezierCurveTo(x + 30.4308, y + 91.6043, x + 28.9507, y + 89.489, x + 28.9507, y + 89.489);
ctx.bezierCurveTo(x + 28.9507, y + 89.489, x + 30.3555, y + 93.7694, x + 34.6204, y + 96.2829);
ctx.bezierCurveTo(x + 28.3486, y + 93.2717, x + 25.4886, y + 85.9055, x + 28.2482, y + 79.5596);
ctx.bezierCurveTo(x + 29.6531, y + 76.424, x + 32.1367, y + 74.1097, x + 35.097, y + 72.8654);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 45.9348, y + 88.2697);
ctx.bezierCurveTo(x + 46.5118, y + 87.5978, x + 46.9885, y + 86.8014, x + 47.3146, y + 85.9802);
ctx.bezierCurveTo(x + 47.6658, y + 85.159, x + 47.8916, y + 84.2631, x + 47.992, y + 83.3672);
ctx.bezierCurveTo(x + 48.0923, y + 82.4713, x + 48.0672, y + 81.5506, x + 47.8415, y + 80.6796);
ctx.bezierCurveTo(x + 47.6408, y + 79.8086, x + 47.2394, y + 78.9624, x + 46.6373, y + 78.2905);
ctx.bezierCurveTo(x + 47.0637, y + 79.062, x + 47.3397, y + 79.9081, x + 47.4902, y + 80.7542);
ctx.bezierCurveTo(x + 47.6157, y + 81.6003, x + 47.6408, y + 82.4713, x + 47.5404, y + 83.3423);
ctx.bezierCurveTo(x + 47.4401, y + 84.2133, x + 47.2644, y + 85.0594, x + 46.9885, y + 85.8807);
ctx.bezierCurveTo(x + 46.7125, y + 86.677, x + 46.3613, y + 87.4983, x + 45.9348, y + 88.2697);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 58.6041, y + 58.6805);
ctx.bezierCurveTo(x + 58.4535, y + 58.133, x + 58.2027, y + 57.6104, x + 57.9016, y + 57.1127);
ctx.bezierCurveTo(x + 57.6257, y + 56.615, x + 57.2744, y + 56.167, x + 56.9232, y + 55.7191);
ctx.bezierCurveTo(x + 56.572, y + 55.2712, x + 56.1957, y + 54.8481, x + 55.7692, y + 54.4499);
ctx.bezierCurveTo(x + 55.3678, y + 54.0518, x + 54.9413, y + 53.6536, x + 54.4897, y + 53.3301);
ctx.bezierCurveTo(x + 54.841, y + 53.778, x + 55.1922, y + 54.226, x + 55.5434, y + 54.649);
ctx.bezierCurveTo(x + 55.8946, y + 55.097, x + 56.2709, y + 55.52, x + 56.6222, y + 55.968);
ctx.bezierCurveTo(x + 56.7978, y + 56.1919, x + 56.9734, y + 56.4159, x + 57.149, y + 56.615);
ctx.lineTo(x + 57.3999, y + 56.9385);
ctx.bezierCurveTo(x + 57.4751, y + 57.0629, x + 57.5755, y + 57.1625, x + 57.6508, y + 57.2869);
ctx.bezierCurveTo(x + 57.9769, y + 57.7349, x + 58.303, y + 58.1828, x + 58.6041, y + 58.6805);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#ED1B24";

ctx.beginPath();
ctx.moveTo(x + 56.2959, y + 60.4475);
ctx.bezierCurveTo(x + 56.2457, y + 60.2484, x + 56.0952, y + 60.0991, x + 55.9698, y + 59.9747);
ctx.bezierCurveTo(x + 55.8192, y + 59.8503, x + 55.6436, y + 59.7507, x + 55.468, y + 59.701);
ctx.bezierCurveTo(x + 55.1168, y + 59.5765, x + 54.7405, y + 59.5019, x + 54.3642, y + 59.4521);
ctx.bezierCurveTo(x + 53.9879, y + 59.4023, x + 53.6366, y + 59.3774, x + 53.2603, y + 59.3774);
ctx.bezierCurveTo(x + 52.884, y + 59.3774, x + 52.5328, y + 59.4023, x + 52.1565, y + 59.4272);
ctx.bezierCurveTo(x + 52.5077, y + 59.5019, x + 52.884, y + 59.5516, x + 53.2352, y + 59.6014);
ctx.bezierCurveTo(x + 53.5865, y + 59.6512, x + 53.9377, y + 59.7258, x + 54.2889, y + 59.7756);
ctx.bezierCurveTo(x + 54.6401, y + 59.8503, x + 54.9914, y + 59.9249, x + 55.3175, y + 60.0245);
ctx.bezierCurveTo(x + 55.4931, y + 60.0742, x + 55.6436, y + 60.124, x + 55.7942, y + 60.1987);
ctx.bezierCurveTo(x + 55.9949, y + 60.2484, x + 56.1454, y + 60.3231, x + 56.2959, y + 60.4475);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 56.4214, y + 60.1736);
ctx.bezierCurveTo(x + 56.3712, y + 59.9745, x + 56.2207, y + 59.8252, x + 56.0953, y + 59.7008);
ctx.bezierCurveTo(x + 55.9447, y + 59.5763, x + 55.7691, y + 59.4768, x + 55.5935, y + 59.427);
ctx.bezierCurveTo(x + 55.2423, y + 59.3026, x + 54.866, y + 59.2279, x + 54.4897, y + 59.1782);
ctx.bezierCurveTo(x + 54.1134, y + 59.1284, x + 53.7621, y + 59.1035, x + 53.3858, y + 59.1035);
ctx.bezierCurveTo(x + 53.0095, y + 59.1035, x + 52.6583, y + 59.1284, x + 52.282, y + 59.1533);
ctx.bezierCurveTo(x + 52.6332, y + 59.2279, x + 53.0095, y + 59.2777, x + 53.3607, y + 59.3275);
ctx.bezierCurveTo(x + 53.712, y + 59.3773, x + 54.0632, y + 59.4519, x + 54.4144, y + 59.5017);
ctx.bezierCurveTo(x + 54.7656, y + 59.5763, x + 55.1169, y + 59.651, x + 55.443, y + 59.7505);
ctx.bezierCurveTo(x + 55.6186, y + 59.8003, x + 55.7691, y + 59.8501, x + 55.9196, y + 59.9247);
ctx.bezierCurveTo(x + 56.0953, y + 59.9994, x + 56.2458, y + 60.0741, x + 56.4214, y + 60.1736);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 51.3037, y + 69.6553);
ctx.bezierCurveTo(x + 51.0528, y + 69.8544, x + 50.7768, y + 70.0534, x + 50.5259, y + 70.2276);
ctx.bezierCurveTo(x + 50.25, y + 70.4018, x + 49.9991, y + 70.576, x + 49.7231, y + 70.7502);
ctx.bezierCurveTo(x + 49.1712, y + 71.0986, x + 48.6193, y + 71.4222, x + 48.0674, y + 71.7706);
ctx.bezierCurveTo(x + 48.6946, y + 71.5466, x + 49.2716, y + 71.248, x + 49.8235, y + 70.8996);
ctx.bezierCurveTo(x + 50.3503, y + 70.5512, x + 50.8772, y + 70.153, x + 51.3037, y + 69.6553);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 47.8917, y + 26.0305);
ctx.bezierCurveTo(x + 47.6659, y + 27.0011, x + 47.5656, y + 27.9467, x + 47.5656, y + 28.9173);
ctx.bezierCurveTo(x + 47.5656, y + 29.8629, x + 47.6659, y + 30.8335, x + 47.8666, y + 31.7542);
ctx.bezierCurveTo(x + 48.268, y + 33.5958, x + 49.0708, y + 35.3378, x + 50.4255, y + 36.5074);
ctx.bezierCurveTo(x + 51.8054, y + 37.7268, x + 53.5615, y + 38.4734, x + 55.4179, y + 38.6476);
ctx.bezierCurveTo(x + 56.3462, y + 38.7471, x + 57.2995, y + 38.6974, x + 58.2277, y + 38.5232);
ctx.bezierCurveTo(x + 59.1559, y + 38.349, x + 60.0842, y + 38.0254, x + 60.9622, y + 37.5277);
ctx.bezierCurveTo(x + 60.8619, y + 37.6024, x + 60.7866, y + 37.7019, x + 60.6863, y + 37.7766);
ctx.bezierCurveTo(x + 60.5859, y + 37.8512, x + 60.5107, y + 37.9508, x + 60.4103, y + 38.0254);
ctx.lineTo(x + 60.1093, y + 38.2494);
ctx.bezierCurveTo(x + 60.0591, y + 38.2743, x + 60.0089, y + 38.3241, x + 59.9587, y + 38.349);
ctx.lineTo(x + 59.8082, y + 38.4485);
ctx.bezierCurveTo(x + 59.5824, y + 38.5729, x + 59.3817, y + 38.6974, x + 59.1309, y + 38.8218);
ctx.lineTo(x + 58.7796, y + 38.9711);
ctx.bezierCurveTo(x + 58.6542, y + 39.0209, x + 58.5288, y + 39.0706, x + 58.4284, y + 39.0955);
ctx.bezierCurveTo(x + 57.4751, y + 39.4439, x + 56.4214, y + 39.6181, x + 55.3928, y + 39.6181);
ctx.bezierCurveTo(x + 53.3106, y + 39.6181, x + 51.2033, y + 38.8218, x + 49.6228, y + 37.4282);
ctx.bezierCurveTo(x + 49.5224, y + 37.3535, x + 49.4221, y + 37.254, x + 49.3217, y + 37.1544);
ctx.lineTo(x + 49.0457, y + 36.8558);
ctx.bezierCurveTo(x + 48.9454, y + 36.7563, x + 48.8701, y + 36.6567, x + 48.7949, y + 36.5572);
ctx.lineTo(x + 48.544, y + 36.2337);
ctx.bezierCurveTo(x + 48.4687, y + 36.1341, x + 48.3935, y + 36.0097, x + 48.3182, y + 35.9102);
ctx.lineTo(x + 48.1175, y + 35.5866);
ctx.bezierCurveTo(x + 47.967, y + 35.3627, x + 47.8666, y + 35.1138, x + 47.7412, y + 34.8898);
ctx.bezierCurveTo(x + 47.2896, y + 33.9442, x + 47.0388, y + 32.9239, x + 46.9133, y + 31.9284);
ctx.bezierCurveTo(x + 46.7879, y + 30.9081, x + 46.813, y + 29.8878, x + 46.9635, y + 28.8924);
ctx.bezierCurveTo(x + 47.0388, y + 28.3947, x + 47.1642, y + 27.8969, x + 47.3147, y + 27.4241);
ctx.bezierCurveTo(x + 47.39, y + 27.1753, x + 47.4903, y + 26.9513, x + 47.5656, y + 26.7273);
ctx.bezierCurveTo(x + 47.6659, y + 26.4785, x + 47.7914, y + 26.2545, x + 47.8917, y + 26.0305);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 54.2639, y + 49.8711);
ctx.bezierCurveTo(x + 54.013, y + 51.7375, x + 53.6116, y + 53.5542, x + 53.16, y + 55.3708);
ctx.bezierCurveTo(x + 52.7085, y + 57.1875, x + 52.1816, y + 58.9793, x + 51.5795, y + 60.7462);
ctx.bezierCurveTo(x + 50.9774, y + 62.513, x + 50.3001, y + 64.255, x + 49.5224, y + 65.9722);
ctx.bezierCurveTo(x + 49.3217, y + 66.3952, x + 49.121, y + 66.8183, x + 48.9203, y + 67.2413);
ctx.bezierCurveTo(x + 48.6945, y + 67.6644, x + 48.4938, y + 68.0874, x + 48.2429, y + 68.4856);
ctx.bezierCurveTo(x + 48.0171, y + 68.8838, x + 47.7663, y + 69.3068, x + 47.5154, y + 69.6801);
ctx.bezierCurveTo(x + 47.2645, y + 70.0783, x + 46.9885, y + 70.4516, x + 46.6875, y + 70.8249);
ctx.bezierCurveTo(x + 47.415, y + 69.0829, x + 48.0171, y + 67.3658, x + 48.6192, y + 65.5989);
ctx.lineTo(x + 50.4004, y + 60.348);
ctx.bezierCurveTo(x + 51.0025, y + 58.606, x + 51.6046, y + 56.8391, x + 52.2318, y + 55.0971);
ctx.bezierCurveTo(x + 52.859, y + 53.3302, x + 53.5112, y + 51.5882, x + 54.2639, y + 49.8711);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 29.7786, y + 83.4419);
ctx.bezierCurveTo(x + 30.0797, y + 84.6364, x + 30.6316, y + 85.6567, x + 31.3089, y + 86.5526);
ctx.bezierCurveTo(x + 31.9863, y + 87.4734, x + 32.7891, y + 88.2697, x + 33.6922, y + 89.0163);
ctx.bezierCurveTo(x + 34.5703, y + 89.738, x + 35.5487, y + 90.385, x + 36.5773, y + 90.9076);
ctx.bezierCurveTo(x + 37.6059, y + 91.4551, x + 38.6846, y + 91.8782, x + 39.8888, y + 92.2017);
ctx.bezierCurveTo(x + 38.6595, y + 92.4008, x + 37.3801, y + 92.2017, x + 36.201, y + 91.7786);
ctx.bezierCurveTo(x + 35.0219, y + 91.3556, x + 33.8929, y + 90.7334, x + 32.9145, y + 89.9371);
ctx.bezierCurveTo(x + 31.9361, y + 89.1407, x + 31.1082, y + 88.1702, x + 30.5061, y + 87.0503);
ctx.bezierCurveTo(x + 30.2051, y + 86.478, x + 29.9793, y + 85.8807, x + 29.8539, y + 85.2834);
ctx.bezierCurveTo(x + 29.7034, y + 84.6613, x + 29.6532, y + 84.0392, x + 29.7786, y + 83.4419);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 37.3298, y + 89.1157);
ctx.bezierCurveTo(x + 37.9068, y + 89.2402, x + 38.4337, y + 89.3895, x + 38.9354, y + 89.489);
ctx.bezierCurveTo(x + 39.4623, y + 89.5885, x + 39.964, y + 89.6383, x + 40.4908, y + 89.6632);
ctx.bezierCurveTo(x + 41.0177, y + 89.6881, x + 41.5445, y + 89.6881, x + 42.0713, y + 89.6632);
ctx.bezierCurveTo(x + 42.5982, y + 89.6383, x + 43.1501, y + 89.5885, x + 43.7271, y + 89.5388);
ctx.bezierCurveTo(x + 43.3006, y + 89.9369, x + 42.7487, y + 90.1858, x + 42.1968, y + 90.3351);
ctx.bezierCurveTo(x + 41.6449, y + 90.5093, x + 41.0428, y + 90.5591, x + 40.4407, y + 90.5342);
ctx.bezierCurveTo(x + 39.8386, y + 90.5093, x + 39.2616, y + 90.36, x + 38.7347, y + 90.136);
ctx.bezierCurveTo(x + 38.2079, y + 89.8872, x + 37.7312, y + 89.5388, x + 37.3298, y + 89.1157);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 22.8294, y + 78.4896);
ctx.bezierCurveTo(x + 26.442, y + 73.2636, x + 25.1374, y + 66.1463, x + 19.8942, y + 62.5876);
ctx.bezierCurveTo(x + 16.0558, y + 59.9746, x + 11.0383, y + 59.9746, x + 7.40068, y + 62.3139);
ctx.lineTo(x + 1.10376, y + 55.9431);
ctx.lineTo(x + 5.39369, y + 63.8817);
ctx.bezierCurveTo(x + 4.84177, y + 64.4043, x + 4.34002, y + 65.0015, x + 3.88845, y + 65.6485);
ctx.bezierCurveTo(x + 0.275878, y + 70.8746, x + 1.58042, y + 77.9919, x + 6.82367, y + 81.5505);
ctx.bezierCurveTo(x + 12.0418, y + 85.0594, x + 19.2168, y + 83.7156, x + 22.8294, y + 78.4896);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 26.417, y + 73.2636);
ctx.bezierCurveTo(x + 26.392, y + 72.3677, x + 26.3669, y + 71.4718, x + 26.2414, y + 70.551);
ctx.bezierCurveTo(x + 26.116, y + 69.6303, x + 25.9153, y + 68.7095, x + 25.5892, y + 67.739);
ctx.bezierCurveTo(x + 25.263, y + 66.7933, x + 24.7864, y + 65.8228, x + 24.1341, y + 64.8771);
ctx.bezierCurveTo(x + 23.4818, y + 63.9314, x + 22.6289, y + 63.0107, x + 21.5752, y + 62.1646);
ctx.bezierCurveTo(x + 22.7292, y + 62.8365, x + 23.7829, y + 63.7821, x + 24.5606, y + 64.7776);
ctx.bezierCurveTo(x + 25.3383, y + 65.773, x + 25.8902, y + 66.8182, x + 26.2414, y + 67.8385);
ctx.bezierCurveTo(x + 26.5927, y + 68.8339, x + 26.7683, y + 69.8045, x + 26.7934, y + 70.7252);
ctx.bezierCurveTo(x + 26.7934, y + 71.646, x + 26.693, y + 72.4921, x + 26.417, y + 73.2636);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 28.0727, y + 73.4377);
ctx.bezierCurveTo(x + 28.0978, y + 72.8405, x + 28.148, y + 72.2681, x + 28.148, y + 71.6957);
ctx.bezierCurveTo(x + 28.148, y + 71.0985, x + 28.1229, y + 70.5261, x + 28.0226, y + 69.9039);
ctx.bezierCurveTo(x + 27.9473, y + 69.2818, x + 27.7968, y + 68.6597, x + 27.5961, y + 68.0375);
ctx.bezierCurveTo(x + 27.3954, y + 67.3905, x + 27.1194, y + 66.7434, x + 26.8184, y + 66.0715);
ctx.bezierCurveTo(x + 27.3201, y + 66.7186, x + 27.7215, y + 67.4154, x + 27.9975, y + 68.0873);
ctx.bezierCurveTo(x + 28.2985, y + 68.7592, x + 28.4741, y + 69.4311, x + 28.5745, y + 70.0533);
ctx.bezierCurveTo(x + 28.6748, y + 70.7003, x + 28.6497, y + 71.2975, x + 28.5745, y + 71.8699);
ctx.bezierCurveTo(x + 28.4992, y + 72.4174, x + 28.3236, y + 72.9649, x + 28.0727, y + 73.4377);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 7.1248, y + 82.098);
ctx.bezierCurveTo(x + 7.25024, y + 82.1727, x + 7.37568, y + 82.2473, x + 7.50111, y + 82.322);
ctx.lineTo(x + 7.70181, y + 82.4215);
ctx.lineTo(x + 7.90251, y + 82.5211);
ctx.bezierCurveTo(x + 8.42934, y + 82.7948, x + 8.95618, y + 83.0188, x + 9.48301, y + 83.2179);
ctx.bezierCurveTo(x + 9.73388, y + 83.3174, x + 10.0098, y + 83.3921, x + 10.2607, y + 83.4667);
ctx.bezierCurveTo(x + 10.5116, y + 83.5414, x + 10.7876, y + 83.5911, x + 11.0384, y + 83.6658);
ctx.bezierCurveTo(x + 12.067, y + 83.8898, x + 13.0203, y + 83.9395, x + 13.9235, y + 83.9147);
ctx.bezierCurveTo(x + 14.8266, y + 83.8898, x + 15.6545, y + 83.7653, x + 16.4322, y + 83.5663);
ctx.bezierCurveTo(x + 17.9876, y + 83.1681, x + 19.3172, y + 82.5211, x + 20.4713, y + 81.7247);
ctx.bezierCurveTo(x + 21.6002, y + 80.9035, x + 22.5284, y + 79.9081, x + 23.281, y + 78.8131);
ctx.bezierCurveTo(x + 24.4351, y + 77.0711, x + 25.1626, y + 75.0553, x + 25.2629, y + 72.7658);
ctx.bezierCurveTo(x + 25.3131, y + 71.6211, x + 25.2128, y + 70.4017, x + 24.8365, y + 69.1325);
ctx.bezierCurveTo(x + 24.4852, y + 67.8634, x + 23.8831, y + 66.5195, x + 22.9298, y + 65.2006);
ctx.bezierCurveTo(x + 22.4532, y + 64.5536, x + 21.8511, y + 63.9065, x + 21.1988, y + 63.3342);
ctx.bezierCurveTo(x + 20.5214, y + 62.7369, x + 19.7688, y + 62.2143, x + 18.9911, y + 61.8161);
ctx.bezierCurveTo(x + 18.5897, y + 61.617, x + 18.2134, y + 61.418, x + 17.812, y + 61.2686);
ctx.bezierCurveTo(x + 17.6113, y + 61.194, x + 17.4106, y + 61.1193, x + 17.2099, y + 61.0447);
ctx.bezierCurveTo(x + 17.0092, y + 60.97, x + 16.8085, y + 60.9202, x + 16.6078, y + 60.8705);
ctx.bezierCurveTo(x + 15.8301, y + 60.6216, x + 15.0524, y + 60.4972, x + 14.3249, y + 60.4225);
ctx.bezierCurveTo(x + 13.5973, y + 60.3728, x + 12.8949, y + 60.3728, x + 12.2426, y + 60.4474);
ctx.bezierCurveTo(x + 11.5903, y + 60.5221, x + 10.9632, y + 60.6216, x + 10.3862, y + 60.7958);
ctx.bezierCurveTo(x + 9.25723, y + 61.0944, x + 8.25373, y + 61.5673, x + 7.37568, y + 62.1396);
ctx.lineTo(x + 1.32963, y + 55.8187);
ctx.lineTo(x + 0, y + 54.45);
ctx.lineTo(x + 0.802795, y + 55.9182);
ctx.lineTo(x + 5.01747, y + 63.7074);
ctx.bezierCurveTo(x + 4.06415, y + 64.6282, x + 3.31153, y + 65.6485, x + 2.70943, y + 66.8182);
ctx.bezierCurveTo(x + 2.10734, y + 68.0127, x + 1.68085, y + 69.3316, x + 1.50524, y + 70.7501);
ctx.bezierCurveTo(x + 1.35472, y + 72.1935, x + 1.42998, y + 73.7364, x + 1.93172, y + 75.4037);
ctx.lineTo(x + 2.03207, y + 75.7273);
ctx.lineTo(x + 2.15751, y + 76.0508);
ctx.bezierCurveTo(x + 2.23277, y + 76.2498, x + 2.33312, y + 76.4738, x + 2.40838, y + 76.6978);
ctx.bezierCurveTo(x + 2.48365, y + 76.9218, x + 2.60908, y + 77.1209, x + 2.70943, y + 77.3448);
ctx.lineTo(x + 2.88504, y + 77.6683);
ctx.bezierCurveTo(x + 2.93522, y + 77.7679, x + 3.01048, y + 77.8923, x + 3.06065, y + 77.9919);
ctx.lineTo(x + 3.26135, y + 78.3154);
ctx.bezierCurveTo(x + 3.33661, y + 78.4149, x + 3.41188, y + 78.5393, x + 3.48714, y + 78.6389);
ctx.bezierCurveTo(x + 3.63766, y + 78.8629, x + 3.78819, y + 79.0619, x + 3.9638, y + 79.2859);
ctx.bezierCurveTo(x + 4.03906, y + 79.3855, x + 4.13941, y + 79.485, x + 4.21467, y + 79.6094);
ctx.lineTo(x + 4.34011, y + 79.7587);
ctx.bezierCurveTo(x + 4.39028, y + 79.8085, x + 4.44046, y + 79.8583, x + 4.49063, y + 79.9081);
ctx.lineTo(x + 4.76659, y + 80.2067);
ctx.lineTo(x + 5.06764, y + 80.5053);
ctx.bezierCurveTo(x + 5.16799, y + 80.6049, x + 5.26834, y + 80.7044, x + 5.39378, y + 80.8039);
ctx.bezierCurveTo(x + 5.49413, y + 80.9035, x + 5.61956, y + 81.003, x + 5.71991, y + 81.1026);
ctx.bezierCurveTo(x + 5.9457, y + 81.2768, x + 6.17148, y + 81.4759, x + 6.42236, y + 81.6501);
ctx.bezierCurveTo(x + 6.62305, y + 81.7745, x + 6.87393, y + 81.9487, x + 7.1248, y + 82.098);
ctx.closePath();
ctx.moveTo(x + 6.79867, y + 81.1026);
ctx.bezierCurveTo(x + 6.59797, y + 80.9533, x + 6.39727, y + 80.8039, x + 6.19657, y + 80.6297);
ctx.bezierCurveTo(x + 6.09622, y + 80.5551, x + 5.99587, y + 80.4555, x + 5.92061, y + 80.3809);
ctx.bezierCurveTo(x + 5.82026, y + 80.3062, x + 5.71991, y + 80.2067, x + 5.64465, y + 80.132);
ctx.lineTo(x + 5.36869, y + 79.8832);
ctx.lineTo(x + 5.11782, y + 79.6094);
ctx.bezierCurveTo(x + 5.06764, y + 79.5597, x + 5.01747, y + 79.5348, x + 4.96729, y + 79.485);
ctx.lineTo(x + 4.84185, y + 79.3357);
ctx.bezierCurveTo(x + 4.76659, y + 79.2361, x + 4.69133, y + 79.1615, x + 4.61607, y + 79.0619);
ctx.bezierCurveTo(x + 4.46554, y + 78.8629, x + 4.31502, y + 78.6887, x + 4.18958, y + 78.4896);
ctx.bezierCurveTo(x + 4.11432, y + 78.39, x + 4.06415, y + 78.2905, x + 3.98889, y + 78.1909);
ctx.lineTo(x + 3.81327, y + 77.8923);
ctx.bezierCurveTo(x + 3.7631, y + 77.7928, x + 3.68784, y + 77.6932, x + 3.63766, y + 77.5937);
ctx.lineTo(x + 3.51223, y + 77.3199);
ctx.bezierCurveTo(x + 3.41188, y + 77.1209, x + 3.31153, y + 76.9218, x + 3.23627, y + 76.7227);
ctx.bezierCurveTo(x + 3.161, y + 76.5236, x + 3.06065, y + 76.3245, x + 2.98539, y + 76.1254);
ctx.lineTo(x + 2.88504, y + 75.8268);
ctx.lineTo(x + 2.78469, y + 75.5282);
ctx.bezierCurveTo(x + 2.30803, y + 73.9604, x + 2.1826, y + 72.4672, x + 2.33312, y + 71.0736);
ctx.bezierCurveTo(x + 2.48365, y + 69.68, x + 2.85996, y + 68.4108, x + 3.43696, y + 67.2163);
ctx.bezierCurveTo(x + 4.01397, y + 66.0467, x + 4.76659, y + 64.9766, x + 5.69482, y + 64.0558);
ctx.lineTo(x + 5.745, y + 64.0061);
ctx.lineTo(x + 5.71991, y + 63.9065);
ctx.lineTo(x + 5.71991, y + 63.8816);
ctx.lineTo(x + 5.69482, y + 63.8319);
ctx.lineTo(x + 2.13242, y + 57.2372);
ctx.lineTo(x + 7.30041, y + 62.3138);
ctx.lineTo(x + 7.35059, y + 62.3636);
ctx.lineTo(x + 9.9095, y + 64.9268);
ctx.lineTo(x + 7.60146, y + 62.3387);
ctx.bezierCurveTo(x + 8.50461, y + 61.7912, x + 9.5081, y + 61.3682, x + 10.6621, y + 61.0944);
ctx.bezierCurveTo(x + 11.2391, y + 60.9451, x + 11.8663, y + 60.8456, x + 12.4935, y + 60.7958);
ctx.bezierCurveTo(x + 13.1458, y + 60.746, x + 13.8231, y + 60.746, x + 14.5256, y + 60.8207);
ctx.bezierCurveTo(x + 15.228, y + 60.8954, x + 15.9555, y + 61.0198, x + 16.6831, y + 61.2438);
ctx.bezierCurveTo(x + 16.8587, y + 61.2935, x + 17.0594, y + 61.3682, x + 17.235, y + 61.418);
ctx.bezierCurveTo(x + 17.4106, y + 61.4926, x + 17.6113, y + 61.5424, x + 17.7869, y + 61.6419);
ctx.bezierCurveTo(x + 18.1632, y + 61.7912, x + 18.5145, y + 61.9654, x + 18.8657, y + 62.1645);
ctx.bezierCurveTo(x + 19.5681, y + 62.5627, x + 20.2455, y + 63.0355, x + 20.8476, y + 63.5581);
ctx.bezierCurveTo(x + 21.4497, y + 64.0807, x + 21.9765, y + 64.678, x + 22.403, y + 65.2752);
ctx.bezierCurveTo(x + 23.281, y + 66.4946, x + 23.8079, y + 67.7389, x + 24.1089, y + 68.9334);
ctx.bezierCurveTo(x + 24.41, y + 70.128, x + 24.4852, y + 71.2976, x + 24.4351, y + 72.3926);
ctx.bezierCurveTo(x + 24.2845, y + 74.5825, x + 23.5319, y + 76.4987, x + 22.3779, y + 78.1412);
ctx.bezierCurveTo(x + 21.6253, y + 79.1864, x + 20.7221, y + 80.132, x + 19.6183, y + 80.9035);
ctx.bezierCurveTo(x + 18.5395, y + 81.6749, x + 17.2601, y + 82.322, x + 15.805, y + 82.6953);
ctx.bezierCurveTo(x + 15.0775, y + 82.8943, x + 14.2998, y + 83.0188, x + 13.4719, y + 83.0437);
ctx.bezierCurveTo(x + 12.644, y + 83.0685, x + 11.766, y + 83.0188, x + 10.8628, y + 82.8446);
ctx.bezierCurveTo(x + 10.637, y + 82.7948, x + 10.4112, y + 82.745, x + 10.1855, y + 82.6704);
ctx.bezierCurveTo(x + 9.95967, y + 82.6206, x + 9.73388, y + 82.5459, x + 9.5081, y + 82.4713);
ctx.bezierCurveTo(x + 9.05653, y + 82.2971, x + 8.57987, y + 82.1229, x + 8.15338, y + 81.874);
ctx.lineTo(x + 7.97777, y + 81.7994);
ctx.lineTo(x + 7.80216, y + 81.6998);
ctx.bezierCurveTo(x + 7.65164, y + 81.6501, x + 7.5262, y + 81.6003, x + 7.42585, y + 81.5256);
ctx.bezierCurveTo(x + 7.20006, y + 81.4012, x + 6.99937, y + 81.2519, x + 6.79867, y + 81.1026);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="white";

ctx.beginPath();
ctx.moveTo(x + 5.97072, y + 41.9574);
ctx.bezierCurveTo(x + 4.76653, y + 34.3424, x + 11.4147, y + 28.2703, x + 20.8224, y + 28.3947);
ctx.bezierCurveTo(x + 27.7465, y + 28.4942, x + 34.4198, y + 31.9285, x + 37.6811, y + 36.7314);
ctx.lineTo(x + 50.4756, y + 34.8152);
ctx.lineTo(x + 39.3118, y + 39.6431);
ctx.bezierCurveTo(x + 39.6881, y + 40.5389, x + 39.939, y + 41.4597, x + 40.0895, y + 42.4054);
ctx.bezierCurveTo(x + 41.2937, y + 50.0204, x + 34.6455, y + 56.0925, x + 25.2378, y + 55.9681);
ctx.bezierCurveTo(x + 15.805, y + 55.8437, x + 7.17491, y + 49.5725, x + 5.97072, y + 41.9574);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 3.21111, y + 35.935);
ctx.bezierCurveTo(x + 3.6376, y + 34.9893, x + 4.08917, y + 34.0437, x + 4.69127, y + 33.1478);
ctx.bezierCurveTo(x + 5.29336, y + 32.2519, x + 5.99581, y + 31.3809, x + 6.89895, y + 30.5597);
ctx.bezierCurveTo(x + 7.80209, y + 29.7384, x + 8.88085, y + 28.9919, x + 10.2356, y + 28.3697);
ctx.bezierCurveTo(x + 11.5903, y + 27.7476, x + 13.221, y + 27.2747, x + 15.0523, y + 27.0259);
ctx.bezierCurveTo(x + 13.1206, y + 27.0508, x + 11.214, y + 27.4241, x + 9.65856, y + 28.0213);
ctx.bezierCurveTo(x + 8.10314, y + 28.6186, x + 6.87386, y + 29.39, x + 5.92054, y + 30.261);
ctx.bezierCurveTo(x + 4.96723, y + 31.132, x + 4.31496, y + 32.0528, x + 3.86338, y + 32.9985);
ctx.bezierCurveTo(x + 3.41181, y + 33.9441, x + 3.18603, y + 34.9395, x + 3.21111, y + 35.935);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 0.80279, y + 35.0888);
ctx.bezierCurveTo(x + 1.02858, y + 34.4417, x + 1.22927, y + 33.7947, x + 1.48015, y + 33.1726);
ctx.bezierCurveTo(x + 1.75611, y + 32.5504, x + 2.05716, y + 31.9283, x + 2.45855, y + 31.331);
ctx.bezierCurveTo(x + 2.85995, y + 30.7338, x + 3.33661, y + 30.1614, x + 3.91362, y + 29.589);
ctx.bezierCurveTo(x + 4.49063, y + 29.0415, x + 5.16799, y + 28.494, x + 5.89552, y + 27.9714);
ctx.bezierCurveTo(x + 4.89202, y + 28.3696, x + 4.03906, y + 28.8673, x + 3.31152, y + 29.3899);
ctx.bezierCurveTo(x + 2.58399, y + 29.9374, x + 2.03207, y + 30.5347, x + 1.63067, y + 31.1568);
ctx.bezierCurveTo(x + 1.22927, y + 31.779, x + 0.953314, y + 32.426, x + 0.827877, y + 33.0979);
ctx.bezierCurveTo(x + 0.677353, y + 33.7698, x + 0.652266, y + 34.4417, x + 0.80279, y + 35.0888);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 24.41, y + 56.3414);
ctx.bezierCurveTo(x + 24.1842, y + 56.3414, x + 23.9584, y + 56.3165, x + 23.7326, y + 56.2916);
ctx.lineTo(x + 23.4065, y + 56.2667);
ctx.lineTo(x + 23.0804, y + 56.217);
ctx.bezierCurveTo(x + 22.2023, y + 56.1423, x + 21.3493, y + 55.9681, x + 20.4964, y + 55.7939);
ctx.bezierCurveTo(x + 20.095, y + 55.6944, x + 19.6685, y + 55.5948, x + 19.2922, y + 55.4953);
ctx.bezierCurveTo(x + 18.8908, y + 55.3957, x + 18.5145, y + 55.2713, x + 18.1381, y + 55.1469);
ctx.bezierCurveTo(x + 16.6329, y + 54.6492, x + 15.3033, y + 54.0519, x + 14.1242, y + 53.4049);
ctx.bezierCurveTo(x + 12.9451, y + 52.7578, x + 11.9165, y + 52.061, x + 11.0133, y + 51.3145);
ctx.bezierCurveTo(x + 9.20706, y + 49.8462, x + 7.87743, y + 48.3033, x + 6.92411, y + 46.7106);
ctx.bezierCurveTo(x + 5.97079, y + 45.1179, x + 5.41887, y + 43.5252, x + 5.168, y + 41.9077);
ctx.bezierCurveTo(x + 4.84186, y + 39.4191, x + 5.24326, y + 36.9305, x + 6.69832, y + 34.6161);
ctx.bezierCurveTo(x + 7.42586, y + 33.4714, x + 8.40426, y + 32.3515, x + 9.75898, y + 31.3312);
ctx.bezierCurveTo(x + 11.1137, y + 30.3358, x + 12.8196, y + 29.415, x + 15.0273, y + 28.8178);
ctx.bezierCurveTo(x + 16.1312, y + 28.5191, x + 17.3354, y + 28.2952, x + 18.6399, y + 28.1707);
ctx.bezierCurveTo(x + 19.8692, y + 28.121, x + 21.2239, y + 28.121, x + 22.5786, y + 28.2454);
ctx.bezierCurveTo(x + 23.256, y + 28.3201, x + 23.9082, y + 28.3947, x + 24.5354, y + 28.5191);
ctx.bezierCurveTo(x + 24.8615, y + 28.5689, x + 25.1626, y + 28.6436, x + 25.4887, y + 28.7182);
ctx.bezierCurveTo(x + 25.7898, y + 28.7929, x + 26.1159, y + 28.8675, x + 26.417, y + 28.9422);
ctx.bezierCurveTo(x + 27.6212, y + 29.2657, x + 28.725, y + 29.6639, x + 29.7536, y + 30.1118);
ctx.bezierCurveTo(x + 30.7571, y + 30.5598, x + 31.6853, y + 31.0575, x + 32.5132, y + 31.5552);
ctx.bezierCurveTo(x + 33.3411, y + 32.0778, x + 34.0937, y + 32.6253, x + 34.746, y + 33.1728);
ctx.bezierCurveTo(x + 36.0254, y + 34.2429, x + 37.054, y + 35.3876, x + 37.8317, y + 36.5572);
ctx.lineTo(x + 50.2499, y + 34.5415);
ctx.lineTo(x + 52.9594, y + 34.1184);
ctx.lineTo(x + 50.8771, y + 35.0143);
ctx.lineTo(x + 39.9139, y + 39.7426);
ctx.bezierCurveTo(x + 40.5411, y + 41.2855, x + 40.8673, y + 42.8284, x + 40.8422, y + 44.3714);
ctx.bezierCurveTo(x + 40.8422, y + 45.964, x + 40.491, y + 47.5318, x + 39.7132, y + 49.0499);
ctx.bezierCurveTo(x + 38.9355, y + 50.5679, x + 37.7564, y + 52.0362, x + 35.9502, y + 53.3053);
ctx.lineTo(x + 35.5989, y + 53.5542);
ctx.lineTo(x + 35.2226, y + 53.7782);
ctx.bezierCurveTo(x + 34.9717, y + 53.9275, x + 34.7209, y + 54.0768, x + 34.4449, y + 54.2261);
ctx.bezierCurveTo(x + 34.194, y + 54.3754, x + 33.893, y + 54.4998, x + 33.617, y + 54.6492);
ctx.lineTo(x + 33.1655, y + 54.8482);
ctx.bezierCurveTo(x + 33.0149, y + 54.9229, x + 32.8644, y + 54.9727, x + 32.6888, y + 55.0473);
ctx.lineTo(x + 32.2121, y + 55.2215);
ctx.bezierCurveTo(x + 32.0365, y + 55.2713, x + 31.8609, y + 55.346, x + 31.7104, y + 55.3957);
ctx.bezierCurveTo(x + 31.3843, y + 55.5202, x + 31.0079, y + 55.5948, x + 30.6567, y + 55.6944);
ctx.bezierCurveTo(x + 30.4811, y + 55.7441, x + 30.2804, y + 55.7939, x + 30.0797, y + 55.8188);
ctx.lineTo(x + 29.8038, y + 55.8934);
ctx.bezierCurveTo(x + 29.7034, y + 55.9183, x + 29.6031, y + 55.9183, x + 29.5027, y + 55.9432);
ctx.lineTo(x + 28.9006, y + 56.0428);
ctx.lineTo(x + 28.2734, y + 56.1174);
ctx.bezierCurveTo(x + 28.0727, y + 56.1423, x + 27.8469, y + 56.1672, x + 27.6462, y + 56.1921);
ctx.bezierCurveTo(x + 27.4455, y + 56.217, x + 27.2198, y + 56.2418, x + 27.0191, y + 56.2418);
ctx.bezierCurveTo(x + 26.5926, y + 56.2667, x + 26.141, y + 56.2916, x + 25.7145, y + 56.2916);
ctx.bezierCurveTo(x + 25.288, y + 56.3663, x + 24.8365, y + 56.3414, x + 24.41, y + 56.3414);
ctx.closePath();
ctx.moveTo(x + 25.5389, y + 55.5948);
ctx.bezierCurveTo(x + 25.9152, y + 55.5948, x + 26.2915, y + 55.5699, x + 26.6678, y + 55.5699);
ctx.bezierCurveTo(x + 26.8435, y + 55.5699, x + 27.0441, y + 55.545, x + 27.2198, y + 55.5202);
ctx.bezierCurveTo(x + 27.3954, y + 55.4953, x + 27.5961, y + 55.4953, x + 27.7717, y + 55.4704);
ctx.lineTo(x + 28.2985, y + 55.3957);
ctx.lineTo(x + 28.8253, y + 55.2962);
ctx.bezierCurveTo(x + 28.9006, y + 55.2713, x + 29.001, y + 55.2713, x + 29.0762, y + 55.2464);
ctx.lineTo(x + 29.3271, y + 55.1966);
ctx.bezierCurveTo(x + 29.5027, y + 55.1469, x + 29.6532, y + 55.122, x + 29.8288, y + 55.0722);
ctx.bezierCurveTo(x + 30.155, y + 54.9727, x + 30.4811, y + 54.898, x + 30.7822, y + 54.7985);
ctx.bezierCurveTo(x + 30.9327, y + 54.7487, x + 31.0832, y + 54.6989, x + 31.2337, y + 54.6492);
ctx.lineTo(x + 31.6853, y + 54.475);
ctx.bezierCurveTo(x + 31.8358, y + 54.4252, x + 31.9864, y + 54.3754, x + 32.1118, y + 54.3008);
ctx.lineTo(x + 32.5383, y + 54.1266);
ctx.bezierCurveTo(x + 32.7891, y + 54.0021, x + 33.0651, y + 53.8777, x + 33.316, y + 53.7533);
ctx.bezierCurveTo(x + 33.5669, y + 53.6288, x + 33.8177, y + 53.4795, x + 34.0435, y + 53.3302);
ctx.lineTo(x + 34.3947, y + 53.1062);
ctx.lineTo(x + 34.7209, y + 52.8823);
ctx.bezierCurveTo(x + 36.4519, y + 51.6878, x + 37.6059, y + 50.2942, x + 38.3836, y + 48.8259);
ctx.bezierCurveTo(x + 39.1613, y + 47.3576, x + 39.5126, y + 45.8396, x + 39.5878, y + 44.2967);
ctx.bezierCurveTo(x + 39.638, y + 42.7538, x + 39.362, y + 41.186, x + 38.7348, y + 39.6431);
ctx.lineTo(x + 38.6847, y + 39.5435);
ctx.lineTo(x + 38.785, y + 39.4689);
ctx.lineTo(x + 38.8352, y + 39.444);
ctx.lineTo(x + 38.8854, y + 39.4191);
ctx.lineTo(x + 48.1677, y + 35.4125);
ctx.lineTo(x + 37.7815, y + 36.831);
ctx.lineTo(x + 37.6812, y + 36.8559);
ctx.lineTo(x + 32.5132, y + 37.6024);
ctx.lineTo(x + 37.3801, y + 36.6568);
ctx.bezierCurveTo(x + 36.5522, y + 35.512, x + 35.4986, y + 34.3673, x + 34.169, y + 33.3221);
ctx.bezierCurveTo(x + 33.4916, y + 32.7746, x + 32.739, y + 32.252, x + 31.9111, y + 31.7543);
ctx.bezierCurveTo(x + 31.0832, y + 31.2566, x + 30.1801, y + 30.8086, x + 29.2017, y + 30.3856);
ctx.bezierCurveTo(x + 28.2233, y + 29.9625, x + 27.1696, y + 29.5892, x + 26.0156, y + 29.3155);
ctx.bezierCurveTo(x + 25.7396, y + 29.2408, x + 25.4386, y + 29.1662, x + 25.1626, y + 29.1164);
ctx.bezierCurveTo(x + 24.8615, y + 29.0666, x + 24.5856, y + 28.992, x + 24.2845, y + 28.9422);
ctx.bezierCurveTo(x + 23.6824, y + 28.8427, x + 23.0804, y + 28.768, x + 22.4783, y + 28.7182);
ctx.bezierCurveTo(x + 21.2741, y + 28.6187, x + 20.0448, y + 28.6187, x + 18.8657, y + 28.7182);
ctx.bezierCurveTo(x + 17.7117, y + 28.8178, x + 16.6078, y + 29.0417, x + 15.6043, y + 29.3155);
ctx.bezierCurveTo(x + 13.5973, y + 29.8879, x + 12.0419, y + 30.7589, x + 10.7876, y + 31.7294);
ctx.bezierCurveTo(x + 9.53319, y + 32.6999, x + 8.65514, y + 33.77, x + 7.97778, y + 34.8899);
ctx.bezierCurveTo(x + 6.67324, y + 37.1296, x + 6.37219, y + 39.5435, x + 6.77359, y + 41.9574);
ctx.bezierCurveTo(x + 7.04955, y + 43.5004, x + 7.62655, y + 45.0682, x + 8.55479, y + 46.5862);
ctx.bezierCurveTo(x + 9.48302, y + 48.1042, x + 10.7374, y + 49.5974, x + 12.4182, y + 50.9661);
ctx.bezierCurveTo(x + 13.2712, y + 51.6629, x + 14.1994, y + 52.3099, x + 15.3033, y + 52.9072);
ctx.bezierCurveTo(x + 16.382, y + 53.5044, x + 17.5862, y + 54.0519, x + 18.9159, y + 54.4998);
ctx.bezierCurveTo(x + 19.242, y + 54.5994, x + 19.5932, y + 54.7238, x + 19.9444, y + 54.7985);
ctx.bezierCurveTo(x + 20.2957, y + 54.898, x + 20.6469, y + 54.9727, x + 20.9981, y + 55.0722);
ctx.bezierCurveTo(x + 21.7256, y + 55.2215, x + 22.4532, y + 55.3708, x + 23.2309, y + 55.4455);
ctx.lineTo(x + 23.5068, y + 55.4704);
ctx.lineTo(x + 23.7828, y + 55.4953);
ctx.bezierCurveTo(x + 23.9835, y + 55.5202, x + 24.1591, y + 55.5202, x + 24.3598, y + 55.545);
ctx.bezierCurveTo(x + 24.7863, y + 55.5948, x + 25.1626, y + 55.5948, x + 25.5389, y + 55.5948);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 17.1096, y + 38.1996);
ctx.bezierCurveTo(x + 16.7082, y + 38.7968, x + 16.2817, y + 39.4438, x + 15.8552, y + 40.0909);
ctx.bezierCurveTo(x + 15.4288, y + 40.7379, x + 15.0023, y + 41.4098, x + 14.5758, y + 42.0568);
ctx.bezierCurveTo(x + 14.1493, y + 42.7288, x + 13.773, y + 43.3509, x + 13.3967, y + 43.9233);
ctx.bezierCurveTo(x + 13.3465, y + 44.0228, x + 13.2963, y + 44.0975, x + 13.2462, y + 44.1224);
ctx.bezierCurveTo(x + 13.196, y + 44.1472, x + 13.1458, y + 44.1472, x + 13.0956, y + 44.1224);
ctx.bezierCurveTo(x + 13.0455, y + 44.0975, x + 12.9702, y + 44.0726, x + 12.92, y + 43.9979);
ctx.bezierCurveTo(x + 12.8448, y + 43.9482, x + 12.7946, y + 43.8735, x + 12.7193, y + 43.8237);
ctx.bezierCurveTo(x + 12.5688, y + 43.6744, x + 12.4935, y + 43.5251, x + 12.4434, y + 43.3758);
ctx.bezierCurveTo(x + 12.3932, y + 43.2265, x + 12.4684, y + 43.0025, x + 12.619, y + 42.7536);
ctx.bezierCurveTo(x + 12.7444, y + 42.4799, x + 12.92, y + 42.1813, x + 13.1207, y + 41.8578);
ctx.bezierCurveTo(x + 13.3214, y + 41.5094, x + 13.5221, y + 41.1361, x + 13.773, y + 40.7379);
ctx.bezierCurveTo(x + 13.5723, y + 40.713, x + 13.3716, y + 40.6881, x + 13.196, y + 40.6632);
ctx.bezierCurveTo(x + 12.9953, y + 40.6384, x + 12.7946, y + 40.6135, x + 12.5939, y + 40.6135);
ctx.bezierCurveTo(x + 12.2928, y + 41.1112, x + 12.0169, y + 41.584, x + 11.766, y + 42.032);
ctx.bezierCurveTo(x + 11.5151, y + 42.4799, x + 11.2893, y + 42.8781, x + 11.0886, y + 43.2514);
ctx.bezierCurveTo(x + 11.0134, y + 43.3758, x + 10.9381, y + 43.4504, x + 10.8879, y + 43.4753);
ctx.bezierCurveTo(x + 10.8378, y + 43.5002, x + 10.7625, y + 43.4753, x + 10.6622, y + 43.4007);
ctx.bezierCurveTo(x + 10.5869, y + 43.3011, x + 10.4865, y + 43.2265, x + 10.3862, y + 43.1269);
ctx.bezierCurveTo(x + 10.2858, y + 43.0274, x + 10.2357, y + 42.9278, x + 10.1855, y + 42.8283);
ctx.bezierCurveTo(x + 10.1102, y + 42.7039, x + 10.0852, y + 42.5794, x + 10.1102, y + 42.455);
ctx.bezierCurveTo(x + 10.1102, y + 42.3306, x + 10.1855, y + 42.1564, x + 10.2858, y + 41.9573);
ctx.bezierCurveTo(x + 10.5869, y + 41.4347, x + 10.9381, y + 40.8374, x + 11.3144, y + 40.1158);
ctx.bezierCurveTo(x + 11.6907, y + 39.419, x + 12.067, y + 38.6973, x + 12.4684, y + 37.9258);
ctx.bezierCurveTo(x + 12.8698, y + 37.1544, x + 13.2712, y + 36.4078, x + 13.6476, y + 35.6612);
ctx.bezierCurveTo(x + 14.0489, y + 34.9146, x + 14.4002, y + 34.2178, x + 14.7514, y + 33.5957);
ctx.bezierCurveTo(x + 14.9019, y + 33.3717, x + 15.0023, y + 33.2473, x + 15.0775, y + 33.2224);
ctx.bezierCurveTo(x + 15.1528, y + 33.2224, x + 15.2281, y + 33.2722, x + 15.3284, y + 33.4215);
ctx.bezierCurveTo(x + 15.4288, y + 33.5708, x + 15.5291, y + 33.745, x + 15.6044, y + 33.9441);
ctx.bezierCurveTo(x + 15.7047, y + 34.1432, x + 15.78, y + 34.3423, x + 15.8301, y + 34.5414);
ctx.bezierCurveTo(x + 15.8552, y + 34.6409, x + 15.8803, y + 34.7404, x + 15.8803, y + 34.8151);
ctx.bezierCurveTo(x + 15.8803, y + 34.8898, x + 15.8803, y + 34.9644, x + 15.8803, y + 35.0391);
ctx.bezierCurveTo(x + 15.8552, y + 35.1137, x + 15.8552, y + 35.1884, x + 15.8051, y + 35.2382);
ctx.bezierCurveTo(x + 15.78, y + 35.3128, x + 15.7298, y + 35.3875, x + 15.6545, y + 35.487);
ctx.bezierCurveTo(x + 15.4037, y + 35.8852, x + 15.1026, y + 36.358, x + 14.7765, y + 36.9055);
ctx.bezierCurveTo(x + 14.4503, y + 37.453, x + 14.0991, y + 38.0502, x + 13.7228, y + 38.6724);
ctx.bezierCurveTo(x + 13.9235, y + 38.7222, x + 14.0991, y + 38.747, x + 14.2747, y + 38.7968);
ctx.bezierCurveTo(x + 14.4503, y + 38.8466, x + 14.626, y + 38.8964, x + 14.8016, y + 38.9461);
ctx.bezierCurveTo(x + 15.2531, y + 38.1996, x + 15.7047, y + 37.4779, x + 16.1312, y + 36.7562);
ctx.bezierCurveTo(x + 16.5577, y + 36.0345, x + 16.9591, y + 35.3875, x + 17.3354, y + 34.8151);
ctx.bezierCurveTo(x + 17.4859, y + 34.5911, x + 17.5863, y + 34.4916, x + 17.6615, y + 34.5165);
ctx.bezierCurveTo(x + 17.7368, y + 34.5165, x + 17.8371, y + 34.5911, x + 17.9375, y + 34.7404);
ctx.bezierCurveTo(x + 18.0378, y + 34.8649, x + 18.1131, y + 35.0142, x + 18.1884, y + 35.1884);
ctx.bezierCurveTo(x + 18.2636, y + 35.3626, x + 18.3389, y + 35.5368, x + 18.3891, y + 35.7359);
ctx.bezierCurveTo(x + 18.4392, y + 35.935, x + 18.4392, y + 36.0843, x + 18.4141, y + 36.1838);
ctx.bezierCurveTo(x + 18.3891, y + 36.2834, x + 18.3138, y + 36.4327, x + 18.2134, y + 36.6069);
ctx.bezierCurveTo(x + 17.8873, y + 37.0548, x + 17.511, y + 37.5774, x + 17.1096, y + 38.1996);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 19.3674, y + 36.134);
ctx.bezierCurveTo(x + 19.6183, y + 36.1589, x + 19.8692, y + 36.2086, x + 20.12, y + 36.2833);
ctx.bezierCurveTo(x + 20.3709, y + 36.358, x + 20.6469, y + 36.4326, x + 20.8977, y + 36.5073);
ctx.bezierCurveTo(x + 21.1737, y + 36.6068, x + 21.4246, y + 36.7064, x + 21.6504, y + 36.8308);
ctx.bezierCurveTo(x + 21.8761, y + 36.9552, x + 21.9514, y + 37.1792, x + 21.9012, y + 37.5027);
ctx.bezierCurveTo(x + 21.8761, y + 37.6769, x + 21.8511, y + 37.8511, x + 21.826, y + 37.9755);
ctx.bezierCurveTo(x + 21.8009, y + 38.1, x + 21.7507, y + 38.2493, x + 21.7005, y + 38.4235);
ctx.bezierCurveTo(x + 21.6504, y + 38.5977, x + 21.5751, y + 38.6972, x + 21.5249, y + 38.747);
ctx.bezierCurveTo(x + 21.4747, y + 38.7968, x + 21.3744, y + 38.7968, x + 21.249, y + 38.747);
ctx.bezierCurveTo(x + 20.973, y + 38.6723, x + 20.7221, y + 38.5728, x + 20.4211, y + 38.4981);
ctx.bezierCurveTo(x + 20.1451, y + 38.3986, x + 19.8441, y + 38.3239, x + 19.5179, y + 38.2493);
ctx.bezierCurveTo(x + 19.3172, y + 38.523, x + 19.1165, y + 38.8216, x + 18.9158, y + 39.1203);
ctx.bezierCurveTo(x + 18.7151, y + 39.4189, x + 18.5144, y + 39.7424, x + 18.2636, y + 40.0659);
ctx.bezierCurveTo(x + 18.4141, y + 40.0908, x + 18.5395, y + 40.1406, x + 18.665, y + 40.1655);
ctx.bezierCurveTo(x + 18.7904, y + 40.2152, x + 18.9409, y + 40.265, x + 19.0914, y + 40.3148);
ctx.bezierCurveTo(x + 19.2169, y + 40.3646, x + 19.2921, y + 40.4143, x + 19.3423, y + 40.489);
ctx.bezierCurveTo(x + 19.3925, y + 40.5636, x + 19.4176, y + 40.6632, x + 19.3925, y + 40.8125);
ctx.bezierCurveTo(x + 19.3925, y + 40.9618, x + 19.3674, y + 41.1111, x + 19.3423, y + 41.2604);
ctx.bezierCurveTo(x + 19.3172, y + 41.4098, x + 19.2921, y + 41.5342, x + 19.242, y + 41.6835);
ctx.bezierCurveTo(x + 19.2169, y + 41.8577, x + 19.1667, y + 41.9572, x + 19.1165, y + 41.9821);
ctx.bezierCurveTo(x + 19.0664, y + 42.0319, x + 18.966, y + 42.0319, x + 18.8406, y + 42.0319);
ctx.bezierCurveTo(x + 18.5395, y + 42.007, x + 18.2636, y + 41.9821, x + 17.9625, y + 41.9324);
ctx.bezierCurveTo(x + 17.6615, y + 41.8826, x + 17.3855, y + 41.8577, x + 17.0845, y + 41.8577);
ctx.bezierCurveTo(x + 16.959, y + 42.0568, x + 16.8336, y + 42.2559, x + 16.7082, y + 42.455);
ctx.bezierCurveTo(x + 16.5827, y + 42.6292, x + 16.4824, y + 42.8282, x + 16.3569, y + 43.0024);
ctx.bezierCurveTo(x + 16.5827, y + 43.0273, x + 16.8085, y + 43.0522, x + 17.0092, y + 43.0771);
ctx.bezierCurveTo(x + 17.2099, y + 43.102, x + 17.4106, y + 43.1518, x + 17.6364, y + 43.2015);
ctx.bezierCurveTo(x + 17.7618, y + 43.2264, x + 17.8622, y + 43.2762, x + 17.9123, y + 43.3508);
ctx.bezierCurveTo(x + 17.9625, y + 43.4255, x + 17.9876, y + 43.525, x + 17.9876, y + 43.6495);
ctx.bezierCurveTo(x + 17.9876, y + 43.7988, x + 17.9625, y + 43.9481, x + 17.9374, y + 44.0725);
ctx.bezierCurveTo(x + 17.9123, y + 44.197, x + 17.8873, y + 44.3214, x + 17.8873, y + 44.4458);
ctx.bezierCurveTo(x + 17.8622, y + 44.5951, x + 17.812, y + 44.6698, x + 17.7618, y + 44.7196);
ctx.bezierCurveTo(x + 17.7116, y + 44.7693, x + 17.6364, y + 44.7693, x + 17.4859, y + 44.7693);
ctx.bezierCurveTo(x + 17.1597, y + 44.7693, x + 16.8336, y + 44.7444, x + 16.5075, y + 44.7444);
ctx.bezierCurveTo(x + 16.1813, y + 44.7444, x + 15.8552, y + 44.7444, x + 15.5541, y + 44.7444);
ctx.bezierCurveTo(x + 15.3534, y + 44.7693, x + 15.2029, y + 44.7444, x + 15.1276, y + 44.6698);
ctx.bezierCurveTo(x + 15.1026, y + 44.62, x + 15.0524, y + 44.5205, x + 15.0273, y + 44.4458);
ctx.bezierCurveTo(x + 14.9771, y + 44.3463, x + 14.952, y + 44.2467, x + 14.9269, y + 44.1472);
ctx.bezierCurveTo(x + 14.9019, y + 44.0476, x + 14.8517, y + 43.9232, x + 14.8266, y + 43.749);
ctx.bezierCurveTo(x + 14.8015, y + 43.6246, x + 14.8015, y + 43.5002, x + 14.8015, y + 43.3508);
ctx.bezierCurveTo(x + 14.8266, y + 43.2015, x + 14.8768, y + 43.0273, x + 14.9771, y + 42.8531);
ctx.bezierCurveTo(x + 16.2315, y + 40.5636, x + 17.4859, y + 38.299, x + 18.69, y + 36.0593);
ctx.bezierCurveTo(x + 18.8907, y + 36.0593, x + 19.1165, y + 36.1091, x + 19.3674, y + 36.134);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 20.2706, y + 45.8891);
ctx.bezierCurveTo(x + 19.9445, y + 45.8643, x + 19.6183, y + 45.8643, x + 19.3424, y + 45.8643);
ctx.bezierCurveTo(x + 19.2169, y + 45.8643, x + 19.1417, y + 45.8643, x + 19.0664, y + 45.8643);
ctx.bezierCurveTo(x + 18.9911, y + 45.8394, x + 18.941, y + 45.8394, x + 18.8908, y + 45.7896);
ctx.bezierCurveTo(x + 18.8406, y + 45.7647, x + 18.8155, y + 45.7149, x + 18.7904, y + 45.6901);
ctx.bezierCurveTo(x + 18.7654, y + 45.6652, x + 18.7403, y + 45.6154, x + 18.7403, y + 45.5656);
ctx.bezierCurveTo(x + 18.6901, y + 45.4661, x + 18.665, y + 45.3914, x + 18.6399, y + 45.2919);
ctx.bezierCurveTo(x + 18.6148, y + 45.1923, x + 18.5647, y + 45.0679, x + 18.5145, y + 44.9186);
ctx.bezierCurveTo(x + 18.4894, y + 44.7942, x + 18.4643, y + 44.6946, x + 18.4894, y + 44.5453);
ctx.bezierCurveTo(x + 18.4894, y + 44.4209, x + 18.5396, y + 44.2716, x + 18.6399, y + 44.1223);
ctx.bezierCurveTo(x + 18.7654, y + 43.8734, x + 18.9159, y + 43.5748, x + 19.0915, y + 43.2513);
ctx.bezierCurveTo(x + 19.2671, y + 42.9277, x + 19.4678, y + 42.5545, x + 19.6936, y + 42.1812);
ctx.bezierCurveTo(x + 19.9194, y + 41.8079, x + 20.1452, y + 41.4097, x + 20.396, y + 40.9867);
ctx.bezierCurveTo(x + 20.6469, y + 40.5885, x + 20.8727, y + 40.1903, x + 21.1236, y + 39.7921);
ctx.bezierCurveTo(x + 21.3744, y + 39.394, x + 21.6002, y + 39.0207, x + 21.8511, y + 38.6723);
ctx.bezierCurveTo(x + 22.0769, y + 38.3239, x + 22.3027, y + 38.0004, x + 22.5034, y + 37.7017);
ctx.bezierCurveTo(x + 22.6288, y + 37.5524, x + 22.7292, y + 37.4529, x + 22.8044, y + 37.4529);
ctx.bezierCurveTo(x + 22.8797, y + 37.4529, x + 22.98, y + 37.5275, x + 23.0804, y + 37.652);
ctx.bezierCurveTo(x + 23.1807, y + 37.7764, x + 23.2811, y + 37.9257, x + 23.3814, y + 38.0999);
ctx.bezierCurveTo(x + 23.4818, y + 38.2741, x + 23.557, y + 38.4483, x + 23.6323, y + 38.6225);
ctx.bezierCurveTo(x + 23.6825, y + 38.7967, x + 23.7076, y + 38.946, x + 23.7076, y + 39.0207);
ctx.bezierCurveTo(x + 23.7076, y + 39.1202, x + 23.6323, y + 39.2447, x + 23.5319, y + 39.3691);
ctx.bezierCurveTo(x + 23.2811, y + 39.6926, x + 23.0302, y + 40.041, x + 22.7542, y + 40.4641);
ctx.bezierCurveTo(x + 22.4783, y + 40.8622, x + 22.1772, y + 41.2853, x + 21.9013, y + 41.7083);
ctx.bezierCurveTo(x + 21.6002, y + 42.1314, x + 21.3243, y + 42.5793, x + 21.0232, y + 43.0024);
ctx.bezierCurveTo(x + 20.7473, y + 43.4503, x + 20.4713, y + 43.8734, x + 20.1953, y + 44.2716);
ctx.bezierCurveTo(x + 20.4211, y + 44.2965, x + 20.6218, y + 44.3213, x + 20.7974, y + 44.3462);
ctx.bezierCurveTo(x + 20.973, y + 44.3711, x + 21.1737, y + 44.4209, x + 21.3995, y + 44.4707);
ctx.bezierCurveTo(x + 21.525, y + 44.4955, x + 21.6253, y + 44.5453, x + 21.6504, y + 44.5951);
ctx.bezierCurveTo(x + 21.7006, y + 44.6449, x + 21.7257, y + 44.7444, x + 21.7257, y + 44.8688);
ctx.bezierCurveTo(x + 21.7257, y + 44.9933, x + 21.7257, y + 45.1177, x + 21.7006, y + 45.2421);
ctx.bezierCurveTo(x + 21.6755, y + 45.3665, x + 21.6504, y + 45.4661, x + 21.6253, y + 45.5905);
ctx.bezierCurveTo(x + 21.6002, y + 45.7149, x + 21.5751, y + 45.8145, x + 21.525, y + 45.8394);
ctx.bezierCurveTo(x + 21.4999, y + 45.8643, x + 21.3995, y + 45.8891, x + 21.249, y + 45.8891);
ctx.bezierCurveTo(x + 20.9229, y + 45.914, x + 20.5967, y + 45.8891, x + 20.2706, y + 45.8891);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 23.8079, y + 46.9593);
ctx.bezierCurveTo(x + 23.4818, y + 46.9344, x + 23.1808, y + 46.9095, x + 22.8797, y + 46.9095);
ctx.bezierCurveTo(x + 22.7543, y + 46.9095, x + 22.679, y + 46.9095, x + 22.6037, y + 46.8847);
ctx.bezierCurveTo(x + 22.5285, y + 46.8598, x + 22.4783, y + 46.8598, x + 22.4281, y + 46.81);
ctx.bezierCurveTo(x + 22.378, y + 46.7851, x + 22.3529, y + 46.7602, x + 22.3278, y + 46.7105);
ctx.bezierCurveTo(x + 22.3027, y + 46.6856, x + 22.2776, y + 46.6358, x + 22.2776, y + 46.6109);
ctx.bezierCurveTo(x + 22.2274, y + 46.5363, x + 22.2023, y + 46.4367, x + 22.1522, y + 46.3621);
ctx.bezierCurveTo(x + 22.102, y + 46.2874, x + 22.0769, y + 46.1879, x + 22.0267, y + 46.0385);
ctx.bezierCurveTo(x + 21.9766, y + 45.939, x + 21.9766, y + 45.8146, x + 21.9766, y + 45.715);
ctx.bezierCurveTo(x + 21.9766, y + 45.5906, x + 22.0267, y + 45.4662, x + 22.102, y + 45.3169);
ctx.bezierCurveTo(x + 22.2274, y + 45.0929, x + 22.3529, y + 44.8191, x + 22.5285, y + 44.5205);
ctx.bezierCurveTo(x + 22.7041, y + 44.2219, x + 22.8797, y + 43.8984, x + 23.0804, y + 43.55);
ctx.bezierCurveTo(x + 23.2811, y + 43.2016, x + 23.5069, y + 42.8532, x + 23.7327, y + 42.4799);
ctx.bezierCurveTo(x + 23.9585, y + 42.1066, x + 24.1842, y + 41.7582, x + 24.41, y + 41.3849);
ctx.bezierCurveTo(x + 24.6358, y + 41.0365, x + 24.8616, y + 40.6881, x + 25.0874, y + 40.3646);
ctx.bezierCurveTo(x + 25.3132, y + 40.0411, x + 25.5139, y + 39.7425, x + 25.6895, y + 39.4936);
ctx.bezierCurveTo(x + 25.8149, y + 39.3443, x + 25.8902, y + 39.2696, x + 25.9654, y + 39.2945);
ctx.bezierCurveTo(x + 26.0407, y + 39.2945, x + 26.1411, y + 39.3692, x + 26.2414, y + 39.4936);
ctx.bezierCurveTo(x + 26.3418, y + 39.618, x + 26.4421, y + 39.7425, x + 26.5675, y + 39.9167);
ctx.bezierCurveTo(x + 26.6679, y + 40.0909, x + 26.7682, y + 40.2402, x + 26.8184, y + 40.3895);
ctx.bezierCurveTo(x + 26.8686, y + 40.5637, x + 26.8937, y + 40.6881, x + 26.8937, y + 40.7628);
ctx.bezierCurveTo(x + 26.8937, y + 40.8623, x + 26.8435, y + 40.9619, x + 26.7432, y + 41.0863);
ctx.bezierCurveTo(x + 26.5174, y + 41.3849, x + 26.2665, y + 41.6835, x + 26.0156, y + 42.0568);
ctx.bezierCurveTo(x + 25.7647, y + 42.4052, x + 25.4888, y + 42.7785, x + 25.2128, y + 43.1767);
ctx.bezierCurveTo(x + 24.9369, y + 43.5749, x + 24.6609, y + 43.9481, x + 24.41, y + 44.3463);
ctx.bezierCurveTo(x + 24.1341, y + 44.7445, x + 23.8832, y + 45.1178, x + 23.6323, y + 45.4911);
ctx.bezierCurveTo(x + 23.8581, y + 45.5159, x + 24.0588, y + 45.5408, x + 24.2344, y + 45.5906);
ctx.bezierCurveTo(x + 24.41, y + 45.6404, x + 24.6107, y + 45.6653, x + 24.8365, y + 45.7399);
ctx.bezierCurveTo(x + 24.962, y + 45.7648, x + 25.0623, y + 45.8146, x + 25.1125, y + 45.8643);
ctx.bezierCurveTo(x + 25.1627, y + 45.9141, x + 25.1877, y + 46.0137, x + 25.1877, y + 46.1132);
ctx.bezierCurveTo(x + 25.1877, y + 46.2376, x + 25.1877, y + 46.3372, x + 25.1877, y + 46.4616);
ctx.bezierCurveTo(x + 25.1877, y + 46.5611, x + 25.1627, y + 46.6856, x + 25.1376, y + 46.7851);
ctx.bezierCurveTo(x + 25.1125, y + 46.9095, x + 25.0874, y + 46.9842, x + 25.0623, y + 47.0091);
ctx.bezierCurveTo(x + 24.987, y + 47.034, x + 24.8867, y + 47.034, x + 24.7362, y + 47.034);
ctx.bezierCurveTo(x + 24.4351, y + 47.0091, x + 24.109, y + 46.9842, x + 23.8079, y + 46.9593);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 31.7606, y + 43.8983);
ctx.bezierCurveTo(x + 31.7606, y + 44.0974, x + 31.7355, y + 44.2964, x + 31.6854, y + 44.5204);
ctx.bezierCurveTo(x + 31.585, y + 44.8688, x + 31.4345, y + 45.2421, x + 31.2338, y + 45.6154);
ctx.bezierCurveTo(x + 31.0331, y + 45.9887, x + 30.8073, y + 46.362, x + 30.5313, y + 46.6855);
ctx.bezierCurveTo(x + 30.2554, y + 47.0339, x + 29.9543, y + 47.3574, x + 29.6282, y + 47.6311);
ctx.bezierCurveTo(x + 29.3021, y + 47.9049, x + 28.9508, y + 48.1537, x + 28.5745, y + 48.303);
ctx.bezierCurveTo(x + 28.3237, y + 48.4026, x + 28.0979, y + 48.4275, x + 27.8972, y + 48.4275);
ctx.bezierCurveTo(x + 27.6714, y + 48.4275, x + 27.4456, y + 48.3528, x + 27.2198, y + 48.2533);
ctx.bezierCurveTo(x + 27.0693, y + 48.1786, x + 26.8937, y + 48.104, x + 26.7432, y + 48.0044);
ctx.bezierCurveTo(x + 26.5926, y + 47.9049, x + 26.4421, y + 47.8053, x + 26.3418, y + 47.656);
ctx.bezierCurveTo(x + 26.2665, y + 47.5565, x + 26.1912, y + 47.4072, x + 26.116, y + 47.2578);
ctx.bezierCurveTo(x + 26.0407, y + 47.1085, x + 26.0156, y + 46.9592, x + 26.0156, y + 46.785);
ctx.bezierCurveTo(x + 26.0156, y + 46.5113, x + 26.0658, y + 46.2126, x + 26.1411, y + 45.8891);
ctx.bezierCurveTo(x + 26.2163, y + 45.5656, x + 26.3418, y + 45.2421, x + 26.4923, y + 44.8937);
ctx.bezierCurveTo(x + 26.6428, y + 44.5453, x + 26.8435, y + 44.2218, x + 27.0442, y + 43.8983);
ctx.bezierCurveTo(x + 27.27, y + 43.5748, x + 27.4958, y + 43.2761, x + 27.7467, y + 43.0024);
ctx.bezierCurveTo(x + 27.9975, y + 42.7286, x + 28.2735, y + 42.4798, x + 28.5745, y + 42.2807);
ctx.bezierCurveTo(x + 28.8756, y + 42.0816, x + 29.1766, y + 41.9074, x + 29.4777, y + 41.8079);
ctx.bezierCurveTo(x + 29.6784, y + 41.7581, x + 29.8791, y + 41.7332, x + 30.1049, y + 41.783);
ctx.bezierCurveTo(x + 30.3306, y + 41.8328, x + 30.5313, y + 41.9074, x + 30.6819, y + 42.0567);
ctx.bezierCurveTo(x + 30.8826, y + 42.2309, x + 31.0833, y + 42.43, x + 31.2338, y + 42.6291);
ctx.bezierCurveTo(x + 31.4094, y + 42.8282, x + 31.5348, y + 43.0273, x + 31.6101, y + 43.2512);
ctx.bezierCurveTo(x + 31.7105, y + 43.5001, x + 31.7606, y + 43.6992, x + 31.7606, y + 43.8983);
ctx.closePath();
ctx.moveTo(x + 29.9794, y + 43.4254);
ctx.bezierCurveTo(x + 29.8289, y + 43.5001, x + 29.6533, y + 43.5996, x + 29.4526, y + 43.749);
ctx.bezierCurveTo(x + 29.2519, y + 43.8983, x + 29.0512, y + 44.0974, x + 28.8505, y + 44.2964);
ctx.bezierCurveTo(x + 28.6498, y + 44.5204, x + 28.4491, y + 44.7195, x + 28.2986, y + 44.9435);
ctx.bezierCurveTo(x + 28.123, y + 45.1426, x + 27.9724, y + 45.3914, x + 27.847, y + 45.6154);
ctx.bezierCurveTo(x + 27.6965, y + 45.8642, x + 27.5961, y + 46.0882, x + 27.4958, y + 46.3122);
ctx.bezierCurveTo(x + 27.3954, y + 46.5362, x + 27.3453, y + 46.7352, x + 27.3453, y + 46.9094);
ctx.bezierCurveTo(x + 27.3202, y + 47.0836, x + 27.3703, y + 47.2081, x + 27.4456, y + 47.2827);
ctx.bezierCurveTo(x + 27.5209, y + 47.3574, x + 27.6212, y + 47.3574, x + 27.7717, y + 47.3076);
ctx.bezierCurveTo(x + 27.8972, y + 47.2578, x + 28.0728, y + 47.1832, x + 28.2233, y + 47.0588);
ctx.bezierCurveTo(x + 28.3989, y + 46.9343, x + 28.5745, y + 46.7601, x + 28.7752, y + 46.561);
ctx.bezierCurveTo(x + 28.9759, y + 46.362, x + 29.1515, y + 46.138, x + 29.3522, y + 45.8891);
ctx.bezierCurveTo(x + 29.5028, y + 45.69, x + 29.6533, y + 45.4661, x + 29.8038, y + 45.1923);
ctx.bezierCurveTo(x + 29.9543, y + 44.9435, x + 30.0798, y + 44.6946, x + 30.1801, y + 44.4706);
ctx.bezierCurveTo(x + 30.2805, y + 44.2218, x + 30.3557, y + 44.0227, x + 30.3808, y + 43.8236);
ctx.bezierCurveTo(x + 30.4059, y + 43.6245, x + 30.4059, y + 43.5001, x + 30.3306, y + 43.4254);
ctx.bezierCurveTo(x + 30.2554, y + 43.3757, x + 30.1299, y + 43.3757, x + 29.9794, y + 43.4254);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 30.2805, y + 48.3032);
ctx.bezierCurveTo(x + 30.3557, y + 48.2285, x + 30.4561, y + 48.1787, x + 30.5564, y + 48.1538);
ctx.bezierCurveTo(x + 30.6568, y + 48.129, x + 30.7822, y + 48.129, x + 30.8826, y + 48.1538);
ctx.bezierCurveTo(x + 31.008, y + 48.1787, x + 31.1084, y + 48.2285, x + 31.2338, y + 48.328);
ctx.bezierCurveTo(x + 31.3341, y + 48.4027, x + 31.4094, y + 48.4774, x + 31.4596, y + 48.552);
ctx.bezierCurveTo(x + 31.5097, y + 48.6267, x + 31.5348, y + 48.7262, x + 31.5348, y + 48.8009);
ctx.bezierCurveTo(x + 31.5348, y + 48.8755, x + 31.5348, y + 48.9502, x + 31.5097, y + 49.0248);
ctx.bezierCurveTo(x + 31.4847, y + 49.0995, x + 31.4596, y + 49.1493, x + 31.4094, y + 49.199);
ctx.bezierCurveTo(x + 31.3843, y + 49.2239, x + 31.3341, y + 49.2737, x + 31.284, y + 49.3235);
ctx.bezierCurveTo(x + 31.2338, y + 49.3732, x + 31.1585, y + 49.3981, x + 31.0833, y + 49.423);
ctx.bezierCurveTo(x + 31.008, y + 49.4479, x + 30.9327, y + 49.4728, x + 30.8324, y + 49.4728);
ctx.bezierCurveTo(x + 30.732, y + 49.4728, x + 30.6568, y + 49.4728, x + 30.5564, y + 49.4479);
ctx.bezierCurveTo(x + 30.3557, y + 49.3981, x + 30.1801, y + 49.2737, x + 30.1049, y + 49.1244);
ctx.bezierCurveTo(x + 30.0045, y + 48.9751, x + 30.0045, y + 48.776, x + 30.1299, y + 48.552);
ctx.bezierCurveTo(x + 30.1299, y + 48.4525, x + 30.2052, y + 48.3529, x + 30.2805, y + 48.3032);
ctx.closePath();
ctx.moveTo(x + 34.8464, y + 44.7694);
ctx.bezierCurveTo(x + 34.8464, y + 44.8689, x + 34.7962, y + 44.9436, x + 34.6958, y + 45.0431);
ctx.bezierCurveTo(x + 34.445, y + 45.292, x + 34.2192, y + 45.5408, x + 33.9683, y + 45.8146);
ctx.bezierCurveTo(x + 33.7174, y + 46.0883, x + 33.4916, y + 46.3372, x + 33.2408, y + 46.6109);
ctx.bezierCurveTo(x + 33.015, y + 46.8847, x + 32.7892, y + 47.1335, x + 32.5634, y + 47.4073);
ctx.bezierCurveTo(x + 32.3376, y + 47.6561, x + 32.162, y + 47.905, x + 31.9864, y + 48.1538);
ctx.bezierCurveTo(x + 31.9362, y + 48.2285, x + 31.861, y + 48.2783, x + 31.8108, y + 48.2783);
ctx.bezierCurveTo(x + 31.7606, y + 48.2783, x + 31.6854, y + 48.2534, x + 31.585, y + 48.2036);
ctx.bezierCurveTo(x + 31.4847, y + 48.129, x + 31.3843, y + 48.0792, x + 31.284, y + 48.0045);
ctx.bezierCurveTo(x + 31.2087, y + 47.9299, x + 31.1084, y + 47.8552, x + 31.0331, y + 47.7806);
ctx.bezierCurveTo(x + 30.9578, y + 47.681, x + 30.9077, y + 47.6064, x + 30.9077, y + 47.5317);
ctx.bezierCurveTo(x + 30.9077, y + 47.457, x + 30.9327, y + 47.3575, x + 31.008, y + 47.2331);
ctx.bezierCurveTo(x + 31.1585, y + 46.9842, x + 31.3341, y + 46.7105, x + 31.5599, y + 46.387);
ctx.bezierCurveTo(x + 31.7857, y + 46.0634, x + 32.0115, y + 45.7399, x + 32.2373, y + 45.4164);
ctx.bezierCurveTo(x + 32.4631, y + 45.0929, x + 32.7139, y + 44.7694, x + 32.9397, y + 44.4459);
ctx.bezierCurveTo(x + 33.1655, y + 44.1224, x + 33.3913, y + 43.8486, x + 33.5669, y + 43.6246);
ctx.bezierCurveTo(x + 33.6673, y + 43.5002, x + 33.7425, y + 43.4504, x + 33.8178, y + 43.4504);
ctx.bezierCurveTo(x + 33.893, y + 43.4504, x + 33.9934, y + 43.5251, x + 34.0937, y + 43.6495);
ctx.bezierCurveTo(x + 34.1941, y + 43.7491, x + 34.2944, y + 43.8735, x + 34.4199, y + 44.0228);
ctx.bezierCurveTo(x + 34.5453, y + 44.1721, x + 34.6206, y + 44.2966, x + 34.6958, y + 44.4459);
ctx.bezierCurveTo(x + 34.8213, y + 44.5703, x + 34.8464, y + 44.6698, x + 34.8464, y + 44.7694);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 14.5005, y + 70.5013);
ctx.bezierCurveTo(x + 14.074, y + 71.1732, x + 13.6726, y + 71.8451, x + 13.2461, y + 72.5419);
ctx.bezierCurveTo(x + 12.8196, y + 73.2387, x + 12.4183, y + 73.9106, x + 12.0169, y + 74.5825);
ctx.bezierCurveTo(x + 11.6155, y + 75.2544, x + 11.2642, y + 75.8517, x + 10.9381, y + 76.4241);
ctx.bezierCurveTo(x + 10.913, y + 76.5236, x + 10.8628, y + 76.5983, x + 10.7876, y + 76.5983);
ctx.bezierCurveTo(x + 10.7374, y + 76.5983, x + 10.6371, y + 76.5983, x + 10.5618, y + 76.5485);
ctx.bezierCurveTo(x + 10.4614, y + 76.4987, x + 10.3611, y + 76.449, x + 10.2607, y + 76.3494);
ctx.bezierCurveTo(x + 10.1353, y + 76.2748, x + 10.035, y + 76.1752, x + 9.88443, y + 76.0757);
ctx.bezierCurveTo(x + 9.63356, y + 75.8766, x + 9.43286, y + 75.6775, x + 9.30742, y + 75.4784);
ctx.bezierCurveTo(x + 9.18199, y + 75.2793, x + 9.18199, y + 75.0802, x + 9.33251, y + 74.8563);
ctx.bezierCurveTo(x + 9.43286, y + 74.6074, x + 9.5583, y + 74.3337, x + 9.70882, y + 74.0102);
ctx.bezierCurveTo(x + 9.85934, y + 73.6866, x + 10.035, y + 73.3382, x + 10.2357, y + 72.9401);
ctx.bezierCurveTo(x + 9.90952, y + 72.8903, x + 9.60847, y + 72.8156, x + 9.30742, y + 72.7659);
ctx.bezierCurveTo(x + 9.00637, y + 72.7161, x + 8.70533, y + 72.6414, x + 8.37919, y + 72.5917);
ctx.bezierCurveTo(x + 8.12832, y + 73.0396, x + 7.90253, y + 73.4378, x + 7.70183, y + 73.836);
ctx.bezierCurveTo(x + 7.50113, y + 74.2341, x + 7.35061, y + 74.5576, x + 7.175, y + 74.8812);
ctx.bezierCurveTo(x + 7.12482, y + 74.9807, x + 7.04956, y + 75.0554, x + 6.9743, y + 75.0554);
ctx.bezierCurveTo(x + 6.89904, y + 75.0554, x + 6.7736, y + 75.0056, x + 6.62308, y + 74.8812);
ctx.bezierCurveTo(x + 6.47255, y + 74.7567, x + 6.29694, y + 74.6323, x + 6.12133, y + 74.5079);
ctx.bezierCurveTo(x + 5.94572, y + 74.3835, x + 5.7952, y + 74.259, x + 5.69485, y + 74.1346);
ctx.bezierCurveTo(x + 5.54432, y + 73.9853, x + 5.46906, y + 73.8608, x + 5.41889, y + 73.7364);
ctx.bezierCurveTo(x + 5.36871, y + 73.612, x + 5.3938, y + 73.4876, x + 5.49415, y + 73.3134);
ctx.bezierCurveTo(x + 5.71993, y + 72.9152, x + 5.97081, y + 72.4175, x + 6.24677, y + 71.8451);
ctx.bezierCurveTo(x + 6.52273, y + 71.2727, x + 6.79869, y + 70.6755, x + 7.07465, y + 70.0284);
ctx.bezierCurveTo(x + 7.35061, y + 69.4063, x + 7.62657, y + 68.7593, x + 7.90253, y + 68.1122);
ctx.bezierCurveTo(x + 8.17849, y + 67.4652, x + 8.45445, y + 66.868, x + 8.70533, y + 66.3454);
ctx.bezierCurveTo(x + 8.83076, y + 66.1463, x + 8.9562, y + 66.0218, x + 9.08164, y + 66.0218);
ctx.bezierCurveTo(x + 9.20707, y + 65.997, x + 9.3576, y + 66.0467, x + 9.5583, y + 66.1712);
ctx.bezierCurveTo(x + 9.78408, y + 66.2707, x + 10.0099, y + 66.3951, x + 10.2607, y + 66.5693);
ctx.bezierCurveTo(x + 10.5116, y + 66.7186, x + 10.7123, y + 66.8928, x + 10.8628, y + 67.0422);
ctx.bezierCurveTo(x + 10.9632, y + 67.1168, x + 11.0384, y + 67.2164, x + 11.0635, y + 67.2661);
ctx.bezierCurveTo(x + 11.1137, y + 67.3408, x + 11.1388, y + 67.3906, x + 11.1388, y + 67.4652);
ctx.bezierCurveTo(x + 11.1388, y + 67.515, x + 11.1388, y + 67.5896, x + 11.1137, y + 67.6643);
ctx.bezierCurveTo(x + 11.0886, y + 67.739, x + 11.0384, y + 67.8136, x + 10.9883, y + 67.8883);
ctx.bezierCurveTo(x + 10.7625, y + 68.2616, x + 10.4865, y + 68.7095, x + 10.2106, y + 69.2321);
ctx.bezierCurveTo(x + 9.93461, y + 69.7298, x + 9.60847, y + 70.2773, x + 9.30742, y + 70.8497);
ctx.bezierCurveTo(x + 9.63356, y + 70.8994, x + 9.93461, y + 70.9741, x + 10.2357, y + 71.0239);
ctx.bezierCurveTo(x + 10.5367, y + 71.0985, x + 10.8377, y + 71.1483, x + 11.1137, y + 71.1981);
ctx.bezierCurveTo(x + 11.5151, y + 70.4764, x + 11.9165, y + 69.7547, x + 12.3179, y + 69.033);
ctx.bezierCurveTo(x + 12.7193, y + 68.3113, x + 13.0956, y + 67.6394, x + 13.4468, y + 67.0422);
ctx.bezierCurveTo(x + 13.5723, y + 66.8182, x + 13.7228, y + 66.6938, x + 13.8482, y + 66.6938);
ctx.bezierCurveTo(x + 13.9737, y + 66.6938, x + 14.1493, y + 66.7186, x + 14.3751, y + 66.8431);
ctx.bezierCurveTo(x + 14.5758, y + 66.9426, x + 14.7765, y + 67.067, x + 14.9772, y + 67.2164);
ctx.bezierCurveTo(x + 15.1779, y + 67.3657, x + 15.3535, y + 67.5399, x + 15.5291, y + 67.7141);
ctx.bezierCurveTo(x + 15.6796, y + 67.8883, x + 15.7549, y + 68.0625, x + 15.78, y + 68.162);
ctx.bezierCurveTo(x + 15.78, y + 68.2864, x + 15.7298, y + 68.4358, x + 15.6043, y + 68.6348);
ctx.bezierCurveTo(x + 15.3033, y + 69.2072, x + 14.927, y + 69.8294, x + 14.5005, y + 70.5013);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 18.8909, y + 69.033);
ctx.bezierCurveTo(x + 18.8909, y + 69.1574, x + 18.8407, y + 69.3316, x + 18.7153, y + 69.5556);
ctx.bezierCurveTo(x + 18.5146, y + 69.904, x + 18.2637, y + 70.3022, x + 18.0128, y + 70.775);
ctx.bezierCurveTo(x + 17.7619, y + 71.223, x + 17.486, y + 71.6958, x + 17.21, y + 72.1935);
ctx.bezierCurveTo(x + 16.9341, y + 72.6912, x + 16.6581, y + 73.1889, x + 16.3821, y + 73.7115);
ctx.bezierCurveTo(x + 16.1062, y + 74.2341, x + 15.8302, y + 74.7318, x + 15.5793, y + 75.2047);
ctx.bezierCurveTo(x + 15.3285, y + 75.7024, x + 15.0776, y + 76.1503, x + 14.8518, y + 76.5734);
ctx.bezierCurveTo(x + 14.626, y + 76.9964, x + 14.4253, y + 77.3946, x + 14.2748, y + 77.7181);
ctx.bezierCurveTo(x + 14.1995, y + 77.8426, x + 14.1243, y + 77.9172, x + 14.049, y + 77.9172);
ctx.bezierCurveTo(x + 13.9738, y + 77.9421, x + 13.8483, y + 77.8674, x + 13.6978, y + 77.743);
ctx.bezierCurveTo(x + 13.5222, y + 77.6186, x + 13.3717, y + 77.4942, x + 13.2211, y + 77.3697);
ctx.bezierCurveTo(x + 13.0455, y + 77.2702, x + 12.9201, y + 77.1458, x + 12.7946, y + 76.9964);
ctx.bezierCurveTo(x + 12.6692, y + 76.8471, x + 12.5689, y + 76.6978, x + 12.5689, y + 76.5734);
ctx.bezierCurveTo(x + 12.5438, y + 76.449, x + 12.5689, y + 76.2748, x + 12.6692, y + 76.0757);
ctx.bezierCurveTo(x + 12.7696, y + 75.8019, x + 12.895, y + 75.4784, x + 13.0706, y + 75.0554);
ctx.bezierCurveTo(x + 13.2462, y + 74.6323, x + 13.4469, y + 74.1844, x + 13.6476, y + 73.7115);
ctx.bezierCurveTo(x + 13.8734, y + 73.2138, x + 14.0992, y + 72.7161, x + 14.3501, y + 72.1686);
ctx.bezierCurveTo(x + 14.6009, y + 71.6211, x + 14.8518, y + 71.0985, x + 15.1027, y + 70.5759);
ctx.bezierCurveTo(x + 15.3536, y + 70.0533, x + 15.6044, y + 69.5556, x + 15.8302, y + 69.0828);
ctx.bezierCurveTo(x + 16.0811, y + 68.61, x + 16.2818, y + 68.1869, x + 16.4825, y + 67.8385);
ctx.bezierCurveTo(x + 16.6079, y + 67.6145, x + 16.7584, y + 67.4901, x + 16.8839, y + 67.4652);
ctx.bezierCurveTo(x + 17.0093, y + 67.4403, x + 17.1849, y + 67.4652, x + 17.3856, y + 67.5896);
ctx.bezierCurveTo(x + 17.5863, y + 67.6892, x + 17.8121, y + 67.8385, x + 18.063, y + 68.0127);
ctx.bezierCurveTo(x + 18.2888, y + 68.1869, x + 18.4895, y + 68.386, x + 18.64, y + 68.5602);
ctx.bezierCurveTo(x + 18.7905, y + 68.7593, x + 18.8909, y + 68.9086, x + 18.8909, y + 69.033);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#17162B";

ctx.beginPath();
ctx.moveTo(x + 17.7117, y + 77.6186);
ctx.bezierCurveTo(x + 17.7869, y + 77.5191, x + 17.8873, y + 77.4693, x + 17.9876, y + 77.4195);
ctx.bezierCurveTo(x + 18.088, y + 77.3698, x + 18.2134, y + 77.3698, x + 18.3388, y + 77.3946);
ctx.bezierCurveTo(x + 18.4643, y + 77.4195, x + 18.5897, y + 77.4693, x + 18.7152, y + 77.5937);
ctx.bezierCurveTo(x + 18.8155, y + 77.6933, x + 18.9159, y + 77.7679, x + 18.966, y + 77.8924);
ctx.bezierCurveTo(x + 19.0162, y + 77.9919, x + 19.0413, y + 78.1163, x + 19.0664, y + 78.2159);
ctx.bezierCurveTo(x + 19.0664, y + 78.3154, x + 19.0664, y + 78.4398, x + 19.0413, y + 78.5394);
ctx.bezierCurveTo(x + 19.0162, y + 78.6389, x + 18.9911, y + 78.7136, x + 18.9409, y + 78.7882);
ctx.bezierCurveTo(x + 18.9159, y + 78.838, x + 18.8657, y + 78.8878, x + 18.8155, y + 78.9624);
ctx.bezierCurveTo(x + 18.7653, y + 79.0122, x + 18.6901, y + 79.062, x + 18.6148, y + 79.1118);
ctx.bezierCurveTo(x + 18.5395, y + 79.1615, x + 18.4643, y + 79.1864, x + 18.3639, y + 79.1864);
ctx.bezierCurveTo(x + 18.2636, y + 79.1864, x + 18.1883, y + 79.1864, x + 18.088, y + 79.1366);
ctx.bezierCurveTo(x + 17.8371, y + 79.0122, x + 17.6866, y + 78.8629, x + 17.5611, y + 78.6638);
ctx.bezierCurveTo(x + 17.4608, y + 78.4398, x + 17.4357, y + 78.2159, x + 17.5361, y + 77.9421);
ctx.bezierCurveTo(x + 17.5862, y + 77.8177, x + 17.6364, y + 77.7182, x + 17.7117, y + 77.6186);
ctx.closePath();
ctx.moveTo(x + 22.403, y + 71.87);
ctx.bezierCurveTo(x + 22.403, y + 71.9944, x + 22.3528, y + 72.1438, x + 22.2525, y + 72.2931);
ctx.bezierCurveTo(x + 22.0016, y + 72.741, x + 21.7256, y + 73.189, x + 21.4748, y + 73.6369);
ctx.bezierCurveTo(x + 21.2239, y + 74.0848, x + 20.973, y + 74.5328, x + 20.7221, y + 74.9558);
ctx.bezierCurveTo(x + 20.4713, y + 75.3789, x + 20.2455, y + 75.802, x + 20.0448, y + 76.2001);
ctx.bezierCurveTo(x + 19.819, y + 76.5983, x + 19.6434, y + 76.9716, x + 19.4678, y + 77.2951);
ctx.bezierCurveTo(x + 19.4176, y + 77.4195, x + 19.3423, y + 77.4693, x + 19.2922, y + 77.4942);
ctx.bezierCurveTo(x + 19.242, y + 77.5191, x + 19.1667, y + 77.4693, x + 19.0664, y + 77.3946);
ctx.bezierCurveTo(x + 18.9409, y + 77.32, x + 18.8406, y + 77.2453, x + 18.7402, y + 77.1458);
ctx.bezierCurveTo(x + 18.6399, y + 77.0711, x + 18.5646, y + 76.9716, x + 18.4643, y + 76.872);
ctx.bezierCurveTo(x + 18.389, y + 76.7725, x + 18.3388, y + 76.673, x + 18.3138, y + 76.5734);
ctx.bezierCurveTo(x + 18.3138, y + 76.4739, x + 18.3388, y + 76.3494, x + 18.4141, y + 76.1752);
ctx.bezierCurveTo(x + 18.5395, y + 75.8517, x + 18.7152, y + 75.4784, x + 18.9159, y + 75.0305);
ctx.bezierCurveTo(x + 19.1166, y + 74.5826, x + 19.3423, y + 74.1346, x + 19.5681, y + 73.6618);
ctx.bezierCurveTo(x + 19.7939, y + 73.189, x + 20.0197, y + 72.7161, x + 20.2455, y + 72.2682);
ctx.bezierCurveTo(x + 20.4713, y + 71.7954, x + 20.6971, y + 71.3972, x + 20.8727, y + 71.0239);
ctx.bezierCurveTo(x + 20.973, y + 70.8497, x + 21.0483, y + 70.7502, x + 21.1486, y + 70.7004);
ctx.bezierCurveTo(x + 21.2239, y + 70.6755, x + 21.3493, y + 70.7004, x + 21.4748, y + 70.7999);
ctx.bezierCurveTo(x + 21.6002, y + 70.8746, x + 21.7507, y + 70.9741, x + 21.8762, y + 71.0986);
ctx.bezierCurveTo(x + 22.0267, y + 71.223, x + 22.127, y + 71.3474, x + 22.2274, y + 71.4718);
ctx.bezierCurveTo(x + 22.3779, y + 71.6212, x + 22.4281, y + 71.7456, x + 22.403, y + 71.87);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.restore();

  }
}
